import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  ISO8601DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  SavedSearchCriteria: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

/** Autogenerated input type of AcceptFundDisclaimer */
export type AcceptFundDisclaimerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AcceptFundDisclaimer */
export type AcceptFundDisclaimerPayload = {
  __typename?: 'AcceptFundDisclaimerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type AccreditedInvestorProfile = {
  __typename?: 'AccreditedInvestorProfile';
  bonds: Maybe<Scalars['String']['output']>;
  foreignCurrencies: Maybe<Scalars['String']['output']>;
  futuresOrCommodities: Maybe<Scalars['String']['output']>;
  hedgeFunds: Maybe<Scalars['String']['output']>;
  /** The id of the accredited investor profile */
  id: Scalars['ID']['output'];
  incomeReq: Maybe<Scalars['Boolean']['output']>;
  investmentSize: Maybe<Scalars['String']['output']>;
  netWorth: Maybe<Scalars['String']['output']>;
  netWorthReq: Maybe<Scalars['Boolean']['output']>;
  next12MoAllocation: Maybe<Scalars['String']['output']>;
  privateCompanies: Maybe<Scalars['String']['output']>;
  privateEquityFunds: Maybe<Scalars['String']['output']>;
  publiclyTradedStocks: Maybe<Scalars['String']['output']>;
  realEstate: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  user: User;
  userId: Scalars['ID']['output'];
  yearsInvesting: Maybe<Scalars['String']['output']>;
};

export type AdCampaign = {
  __typename?: 'AdCampaign';
  /** the action_text of the ad */
  actionText: Scalars['String']['output'];
  /** additional link on the modal */
  additionalModalLinkLink: Maybe<Scalars['String']['output']>;
  /** additional link text to add on the ad */
  additionalModalLinkText: Maybe<Scalars['String']['output']>;
  /** the body of the ad */
  body: Scalars['String']['output'];
  /** the headline of the ad */
  headline: Scalars['String']['output'];
  /** the url of the header image of the ad */
  headlineImageUrl: Maybe<Scalars['String']['output']>;
  /** The id of the AdCampaign */
  id: Scalars['ID']['output'];
  /** the modal_text of the ad */
  modalHeaderText: Maybe<Scalars['String']['output']>;
  /** the modal_text of the ad */
  modalText: Scalars['String']['output'];
  /** the name of the ad */
  name: Scalars['String']['output'];
  /** the name of the partner */
  partnerName: Scalars['String']['output'];
  /** a redirect link to the partner's external site */
  redirectLink: Maybe<Scalars['String']['output']>;
  /** whether to show the ticker search component */
  showTicker: Maybe<Scalars['Boolean']['output']>;
};

export type Address = {
  __typename?: 'Address';
  city: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  lineOne: Maybe<Scalars['String']['output']>;
  lineTwo: Maybe<Scalars['String']['output']>;
  postalCode: Maybe<Scalars['String']['output']>;
  state: Maybe<Scalars['String']['output']>;
};

export type AdminPost = {
  __typename?: 'AdminPost';
  /** The body of the post public_field */
  body: Maybe<Scalars['String']['output']>;
  /** The number of comments public_field */
  commentsCount: Maybe<Scalars['Int']['output']>;
  /** The timestamp the post was created public_field */
  createdAt: Scalars['String']['output'];
  /** The domain parsed from the og_url data public_field */
  domain: Maybe<Scalars['String']['output']>;
  /** The id of the post public_field */
  id: Scalars['ID']['output'];
  /** The description from the og data public_field */
  ogDescription: Maybe<Scalars['String']['output']>;
  /** The preview image url from the og data public_field */
  ogPreviewImageUrl: Maybe<Scalars['String']['output']>;
  /** The title from the og data public_field */
  ogTitle: Maybe<Scalars['String']['output']>;
  /** The url from the og data public_field */
  ogUrl: Maybe<Scalars['String']['output']>;
  /** The first tagged entity */
  primaryEntityId: Maybe<Scalars['ID']['output']>;
  /** public_field */
  user: Maybe<User>;
};

export type AllocatorBlocklistEntry = {
  __typename?: 'AllocatorBlocklistEntry';
  allocatorProfile: AllocatorProfile;
  fundProfile: EmployerProfile;
  /** The id of the blocklist entry */
  id: Scalars['ID']['output'];
};

export type AllocatorProfile = {
  __typename?: 'AllocatorProfile';
  /** Address line 1 */
  address1: Maybe<Scalars['String']['output']>;
  /** Address line 1 */
  address2: Maybe<Scalars['String']['output']>;
  /** Allocator recommendation for the current user */
  allocatorRecommendation: Maybe<FundRecommendation>;
  /** Asset Class Preferences */
  assetClassPreferences: Maybe<Array<Scalars['String']['output']>>;
  /** The AUM range of the allocator public_field */
  aumRange: Maybe<Scalars['String']['output']>;
  /** AUM Range Preferences */
  aumRangePreferences: Maybe<Array<Scalars['String']['output']>>;
  /** URL for cropped background image */
  backgroundImageCroppedUrl: Maybe<Scalars['String']['output']>;
  /** URL for background image */
  backgroundImageUrl: Maybe<Scalars['String']['output']>;
  /** The bio of the profile public_field */
  bio: Maybe<Scalars['String']['output']>;
  /** City string for address */
  cityStr: Maybe<Scalars['String']['output']>;
  /** Country for address */
  country: Maybe<Scalars['String']['output']>;
  /** URL for default background image */
  defaultBackgroundImage: Maybe<Scalars['String']['output']>;
  /** Email */
  email: Maybe<Scalars['String']['output']>;
  /** The firm type of the profile public_field */
  employerType: Maybe<Scalars['String']['output']>;
  /** Executives */
  executives: Maybe<Array<AllocatorProfileExecutive>>;
  /** The allocator's Fund Manager public_field */
  fundManager: Maybe<Scalars['String']['output']>;
  /** Strategy Preferences */
  fundStrategyPreferences: Maybe<Array<Scalars['String']['output']>>;
  /** Fund Type Preferences */
  fundTypePreferences: Maybe<Array<Scalars['String']['output']>>;
  /** Geography Preferences */
  geographyPreferences: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights from text searches in a hash with html */
  highlights: Maybe<Scalars['String']['output']>;
  /** The id of the allocator profile public_field */
  id: Scalars['ID']['output'];
  /** Investment criteria */
  investmentCriteria: Maybe<Scalars['String']['output']>;
  /** The city where the allocator is located public_field */
  location: Maybe<Scalars['String']['output']>;
  /** The name of the allocator public_field */
  name: Maybe<Scalars['String']['output']>;
  /** Phone number */
  phoneNumber: Maybe<Scalars['String']['output']>;
  /** The public bio of the profile public_field */
  publicBio: Maybe<Scalars['String']['output']>;
  /** Whether the allocator just joined */
  recentlyJoined: Maybe<Scalars['Boolean']['output']>;
  /** Sector Preferences */
  sectorPreferences: Maybe<Array<Scalars['String']['output']>>;
  /** State for address */
  state: Maybe<Scalars['String']['output']>;
  /** Whether the AUM range is undisclosed public_field */
  undisclosed: Maybe<Scalars['Boolean']['output']>;
  /** The link string for the allocator profile public_field */
  vanityLink: Maybe<Scalars['String']['output']>;
  /** ZIP code for address */
  zip: Maybe<Scalars['String']['output']>;
};

export type AllocatorProfileExecutive = {
  __typename?: 'AllocatorProfileExecutive';
  bio: Maybe<Scalars['String']['output']>;
  /** Url for default photo */
  defaultPhoto: Maybe<Scalars['String']['output']>;
  hasPhoto: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Photo URL cropped for the profile */
  photoProfileUrl: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
};

export type AllocatorProfilePreference = {
  __typename?: 'AllocatorProfilePreference';
  assetClasses: Maybe<Array<Scalars['String']['output']>>;
  fundTypes: Maybe<Array<Scalars['String']['output']>>;
  geographies: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the Allocator profile preference */
  id: Scalars['ID']['output'];
  /** The offset to grab the recommendations from */
  offset: Scalars['Int']['output'];
  sectors: Maybe<Array<Scalars['String']['output']>>;
};

export type AnonUser = {
  __typename?: 'AnonUser';
  allocatorDisplayName: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  anonymousUserId: Scalars['String']['output'];
  /** (public_field) */
  aumRange: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  fundType: Maybe<Scalars['String']['output']>;
  /** public_field */
  id: Scalars['ID']['output'];
  /** (public_field) */
  isAllocator: Scalars['Boolean']['output'];
  /** (public_field) */
  title: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  username: Maybe<Scalars['String']['output']>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  /** Is this api key active */
  active: Scalars['Boolean']['output'];
  /** Is this api key part of a demo */
  demo: Scalars['Boolean']['output'];
  /** The internal id of the api key */
  id: Scalars['ID']['output'];
  /** The prefix of the post */
  prefix: Scalars['String']['output'];
  /** Does this user have access to raw idea text? */
  rawText: Scalars['Boolean']['output'];
  /** The user who owns the api key */
  user: User;
};

/** Autogenerated input type of ArchiveThread */
export type ArchiveThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  threadNum: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveThread */
export type ArchiveThreadPayload = {
  __typename?: 'ArchiveThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

export type Asset = {
  __typename?: 'Asset';
  /** The asset class name of the asset public_field */
  assetClassName: Maybe<Scalars['String']['output']>;
  /** The bbg_id of the asset (public_field) */
  bbgId: Maybe<Scalars['String']['output']>;
  /** The company data for the asset (public_field) */
  companyData: Maybe<CompanyData>;
  /** The crypto assets market data public_field */
  cryptoMarketData: Maybe<CryptoMarketData>;
  /** The currency symbol for the asset (public_field) */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** The currency symbol for the asset (public_field) */
  currencyName: Maybe<Scalars['String']['output']>;
  /** The current users' open quick position on the asset */
  currentUserQuickPosition: Maybe<QuickPosition>;
  /** The cusip of the asset */
  cusip: Maybe<Scalars['String']['output']>;
  /** The entity of the asset public_field */
  entity: Entity;
  /** The entity id of the asset */
  entityId: Scalars['ID']['output'];
  /** The factset symbol of the asset */
  factsetSymbol: Maybe<Scalars['String']['output']>;
  /** 52-week price range string public_field */
  fiftyTwoWeekRange: Maybe<Scalars['String']['output']>;
  /** The fifty two-week range low as a string (public_field) */
  fiftyTwoWeekRangeHigh: Maybe<Scalars['String']['output']>;
  /** The fifty two-week range low as a string (public_field) */
  fiftyTwoWeekRangeLow: Maybe<Scalars['String']['output']>;
  /** If this asset is the selected to be the primary asset of the entity */
  forcePrimaryEntityAsset: Maybe<Scalars['Boolean']['output']>;
  /** The fs_perm_sec_id of the asset public_field */
  fsPermSecId: Maybe<Scalars['String']['output']>;
  /** The fundamentals of the asset (public_field) */
  fundamental: Maybe<Fundamental>;
  /** The currency for the fundamentals (public_field) */
  fundamentalCurrencyCode: Maybe<Scalars['String']['output']>;
  /** The currency for the fundamentals (public_field) */
  fundamentalCurrencyName: Maybe<Scalars['String']['output']>;
  /** public_field */
  id: Scalars['ID']['output'];
  /** Idea ideas associated with this asset */
  ideaIds: Maybe<Array<Scalars['String']['output']>>;
  /** Idea Updates in a certain timeframe */
  ideaUpdatesInTimeframe: Maybe<IdeaUpdateConnection>;
  /** Ideas in a certain timeframe */
  ideasInTimeframe: Maybe<IdeaConnection>;
  /** If the asset is a credit asset (public_field) */
  isCredit: Maybe<Scalars['Boolean']['output']>;
  /** If the asset is a preferred asset */
  isPreferred: Maybe<Scalars['Boolean']['output']>;
  /** The latest price of an asset public_field */
  latestPrice: Maybe<Scalars['Float']['output']>;
  /** The date of the latest price public_field */
  latestQuoteDate: Maybe<Scalars['String']['output']>;
  /** The percentage of long open quick positions out of the number of all open quick positions */
  longQuickPositionRatio: Maybe<Scalars['Int']['output']>;
  /** markup display for a cash tagged asset */
  mentionDisplay: Scalars['String']['output'];
  /** markup id for a cash tagged asset */
  mentionId: Scalars['String']['output'];
  /** The name of the asset public_field */
  name: Maybe<Scalars['String']['output']>;
  priceHistory: Array<Price>;
  /** The primary symbol of the asset public_field */
  primarySymbol: Maybe<Scalars['String']['output']>;
  /** public_field */
  recentIdeas: Maybe<IdeaConnection>;
  /** The percentage of short open quick positions out of the number of all open quick positions */
  shortQuickPositionRatio: Maybe<Scalars['Int']['output']>;
  /** The bloomberg symbol of the asset public_field */
  symbol: Maybe<Scalars['String']['output']>;
  /** The user entered symbol of the asset */
  userSymbol: Maybe<Scalars['String']['output']>;
  /** The yahoo symbol of the asset */
  yahooSymbol: Maybe<Scalars['String']['output']>;
};


export type AssetIdeaUpdatesInTimeframeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type AssetIdeasInTimeframeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type AssetPriceHistoryArgs = {
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type AssetRecentIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetClass = {
  __typename?: 'AssetClass';
  /** The id of the asset class */
  id: Scalars['ID']['output'];
  /** The name of the asset class */
  name: Scalars['String']['output'];
};

/** The connection type for Asset. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<AssetEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Asset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Asset>;
};

/** Attributes to generate the assets to merge list */
export type AssetsToMergeAttributes = {
  /** id of the accepting asset */
  acceptingAssetId: Scalars['ID']['input'];
  /** id of the mergeing asset */
  mergingAssetId: Scalars['ID']['input'];
};

/** Autogenerated input type of AssociateViewerIntroRequestMessage */
export type AssociateViewerIntroRequestMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the message to associate */
  messageId: Scalars['ID']['input'];
  /** The id of the viewer intro request */
  viewerIntroRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of AssociateViewerIntroRequestMessage */
export type AssociateViewerIntroRequestMessagePayload = {
  __typename?: 'AssociateViewerIntroRequestMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Attachable = WhitePaper | WhitePaperUpdate;

export type AttachmentType = {
  __typename?: 'AttachmentType';
  /** The user-specified custom name for file public_field */
  customName: Maybe<Scalars['String']['output']>;
  /** The name of the file public_field */
  fileName: Scalars['String']['output'];
  /** The id of the file attachment (public_field) */
  id: Scalars['ID']['output'];
};

export type AumRange = {
  __typename?: 'AumRange';
  /** The id of the aum range */
  id: Scalars['ID']['output'];
  /** Name of the Aum Range */
  name: Scalars['String']['output'];
};

export type Badge = {
  __typename?: 'Badge';
  /** The description of the badge (public_field) */
  description: Scalars['String']['output'];
  /** The id of the badge (public_field) */
  id: Scalars['ID']['output'];
  /** The name of the badge (public_field) */
  name: Scalars['String']['output'];
  /** The order that the badge display (public_field)s */
  order: Scalars['Int']['output'];
};

export type BadgeCollectionRelationship = {
  __typename?: 'BadgeCollectionRelationship';
  /** The badge associated with this (public_field) */
  badge: Maybe<Badge>;
  /** The number of badges awarded (public_field) */
  badgeNumber: Scalars['Int']['output'];
  /** When the badge was earned */
  earnedAt: Maybe<Scalars['String']['output']>;
  /** The id primary key (public_field) */
  id: Scalars['ID']['output'];
  /** If the badge is visible (public_field) */
  visible: Scalars['Boolean']['output'];
};

/** The connection type for BadgeCollectionRelationship. */
export type BadgeCollectionRelationshipConnection = {
  __typename?: 'BadgeCollectionRelationshipConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<BadgeCollectionRelationshipEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<BadgeCollectionRelationship>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BadgeCollectionRelationshipEdge = {
  __typename?: 'BadgeCollectionRelationshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<BadgeCollectionRelationship>;
};

export type BillingAddress = {
  __typename?: 'BillingAddress';
  address: Address;
  email: Scalars['String']['output'];
  name: Maybe<Scalars['String']['output']>;
};

/** The most recent blog posts public_field */
export type BlogPost = {
  __typename?: 'BlogPost';
  /** The blog post image public_field */
  blogPostImage: Maybe<Scalars['String']['output']>;
  /** The body of the blog post */
  body: Maybe<Scalars['String']['output']>;
  /** When the post was created */
  createdAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  featured: Maybe<Scalars['Boolean']['output']>;
  fullreportrequest: Maybe<Scalars['Boolean']['output']>;
  googleFinance: Maybe<Scalars['Boolean']['output']>;
  googleTickers: Maybe<Scalars['String']['output']>;
  homePage: Maybe<Scalars['Boolean']['output']>;
  /** The id of the blog post public_field */
  id: Scalars['ID']['output'];
  imageLink: Maybe<Scalars['String']['output']>;
  industry: Maybe<Scalars['String']['output']>;
  infoBox: Maybe<Scalars['String']['output']>;
  linkTitle: Maybe<Scalars['String']['output']>;
  photoCredit: Maybe<Scalars['String']['output']>;
  /** The preview of the blog post public_field */
  preview: Maybe<Scalars['String']['output']>;
  /** When the post was first published */
  publishedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  requiresMembership: Maybe<Scalars['Boolean']['output']>;
  /** Whether the blog post is active or not */
  status: Maybe<Scalars['String']['output']>;
  /** Blog post tags */
  tags: Maybe<Scalars['String']['output']>;
  /** The title of the blog post public_field */
  title: Maybe<Scalars['String']['output']>;
  /** When the post was updated */
  updatedAt: Maybe<Scalars['ISO8601DateTime']['output']>;
  userId: Maybe<Scalars['ID']['output']>;
  videoLink: Maybe<Scalars['String']['output']>;
};

export type CardDetails = {
  __typename?: 'CardDetails';
  brand: Scalars['String']['output'];
  expiryMonth: Scalars['Int']['output'];
  expiryYear: Scalars['Int']['output'];
  lastFour: Scalars['String']['output'];
};

/** Autogenerated input type of ChangeKeyStatus */
export type ChangeKeyStatusInput = {
  /** Should the key be active */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Should the key be limited to boolean scope */
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  /** The internal id of the api key */
  keyId: Scalars['ID']['input'];
};

/** Autogenerated return type of ChangeKeyStatus */
export type ChangeKeyStatusPayload = {
  __typename?: 'ChangeKeyStatusPayload';
  /** Did the operation succeed */
  apiKey: Maybe<ApiKey>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

export type Chat = {
  __typename?: 'Chat';
  /** Whether the current user can chat publicly */
  canCurrentUserChatPublicly: Scalars['Boolean']['output'];
  /** The chat mesages belonging to the chat */
  chatMessages: ChatMessageConnection;
  /** The amount of chat messages belonging to the chat */
  chatMessagesCount: Scalars['Int']['output'];
  /** The name of the chattable */
  chattableName: Scalars['String']['output'];
  /** The url of the chattable */
  chattableUrl: Scalars['String']['output'];
  /** The entity associated with the chat */
  entity: Maybe<Entity>;
  /** The id of the chat message */
  id: Scalars['ID']['output'];
  /** The sector associated with the chat */
  sector: Maybe<Sector>;
  /** The amount of unread chat messages belonging to the chat */
  unreadMessagesCount: Scalars['Int']['output'];
};


export type ChatChatMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type ChatMessage = {
  __typename?: 'ChatMessage';
  /** If the quick position associated with the chat's entity's asset was anonymous */
  anonymous: Maybe<Scalars['Boolean']['output']>;
  /** The body of the chat message */
  body: Scalars['String']['output'];
  /** The timestamp of when the chat message was created */
  createdAt: Scalars['String']['output'];
  /** The direction of the quick position associated with the chat's entity's asset */
  direction: Maybe<Scalars['String']['output']>;
  /** The id of the chat message */
  id: Scalars['ID']['output'];
  /** The user's anonymous display name */
  participantName: Scalars['String']['output'];
  /** The user that created the chat message */
  user: User;
};

/** The connection type for ChatMessage. */
export type ChatMessageConnection = {
  __typename?: 'ChatMessageConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ChatMessageEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ChatMessage>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** Autogenerated return type of ChatMessageCreated */
export type ChatMessageCreatedPayload = {
  __typename?: 'ChatMessageCreatedPayload';
  chatId: Scalars['String']['output'];
  chatMessage: ChatMessage;
};

/** An edge in a connection. */
export type ChatMessageEdge = {
  __typename?: 'ChatMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ChatMessage>;
};

/** Autogenerated input type of ClickIdeaRecommendation */
export type ClickIdeaRecommendationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClickIdeaRecommendation */
export type ClickIdeaRecommendationPayload = {
  __typename?: 'ClickIdeaRecommendationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of ClickedNotifications */
export type ClickedNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ClickedNotifications */
export type ClickedNotificationsPayload = {
  __typename?: 'ClickedNotificationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of CloseQuickPosition */
export type CloseQuickPositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the quick position */
  quickPositionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CloseQuickPosition */
export type CloseQuickPositionPayload = {
  __typename?: 'CloseQuickPositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The quick position */
  quickPosition: QuickPosition;
};

/** Autogenerated input type of CloseUserJobPost */
export type CloseUserJobPostInput = {
  /** accepted application id if the applicant has been hired through SZ Job Vault */
  applicationId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** position has been filled */
  hired: Scalars['Boolean']['input'];
  /** job posting id */
  jobPostId: Scalars['ID']['input'];
};

/** Autogenerated return type of CloseUserJobPost */
export type CloseUserJobPostPayload = {
  __typename?: 'CloseUserJobPostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type Comment = {
  __typename?: 'Comment';
  /** (public_field) */
  anonUser: Maybe<AnonUser>;
  /** Whether the comment is anonymous */
  anonymous: Maybe<Scalars['Boolean']['output']>;
  /** The body of the comment (public_field) */
  body: Maybe<Scalars['String']['output']>;
  /** If the comment is by an allocator public_field */
  byAllocator: Scalars['Boolean']['output'];
  /** Attachments uploaded for this comment public_field */
  commentAttachments: Maybe<Array<AttachmentType>>;
  /** How long ago the comment was created public_field */
  commentCreationTime: Scalars['String']['output'];
  /** The comment object public_field */
  commentObject: Maybe<CommentObject>;
  /** The type of commentable object */
  commentableType: Maybe<Scalars['String']['output']>;
  commentsCount: Maybe<Scalars['Int']['output']>;
  /** When the comment was created (public_field) */
  createdAt: Scalars['String']['output'];
  /** Whether or not the user has liked this specific comment (public_field) */
  currentUserHasLiked: Scalars['Boolean']['output'];
  /** The id of the comment (public_field) */
  id: Scalars['ID']['output'];
  /** The number of likes on the comment (public_field) */
  likeCount: Scalars['Int']['output'];
  /** The id of the parent comment, if one exists (public_field) */
  parentId: Maybe<Scalars['ID']['output']>;
  /** The body of the comment without mentionables */
  parsedBody: Maybe<Scalars['String']['output']>;
  /** If a response was requested for this comment (public_field) */
  responseRequested: Maybe<Scalars['Boolean']['output']>;
  /** (public_field) */
  user: Maybe<User>;
};

/** The connection type for Comment. */
export type CommentConnection = {
  __typename?: 'CommentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CommentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Comment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CommentEdge = {
  __typename?: 'CommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Comment>;
};

/** CommentObject */
export type CommentObject = AdminPost | EmployerProfile | FeaturedItem | Idea | IdeaUpdate | Post | WhitePaper;

export type CompanyData = {
  __typename?: 'CompanyData';
  /** CEO of the company  */
  ceo: Maybe<Scalars['String']['output']>;
  /** Country for company data (public_field) */
  country: Maybe<Scalars['String']['output']>;
  currentPe: Maybe<Scalars['Float']['output']>;
  employees: Maybe<Scalars['Int']['output']>;
  ev: Maybe<Scalars['Int']['output']>;
  /** The fifty two-week range as a string */
  fiftyTwoWeekRange: Scalars['String']['output'];
  /** The Fifty-Two Week Range High */
  fiftyTwoWeekRangeHigh: Scalars['Float']['output'];
  /** The Fifty-Two Week Range Low */
  fiftyTwoWeekRangeLow: Scalars['Float']['output'];
  fy1SellsideConsensusPe: Maybe<Scalars['Float']['output']>;
  /** Geography for company data (public_field) */
  geography: Maybe<Scalars['String']['output']>;
  /** City of headquarters */
  headquarters: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  id: Scalars['ID']['output'];
  /** Industry for company data (public_field) */
  industry: Scalars['String']['output'];
  ltmDilutedEps: Maybe<Scalars['Float']['output']>;
  ltmDividendYield: Maybe<Scalars['Float']['output']>;
  ltmEbitda: Maybe<Scalars['Int']['output']>;
  ltmRevenue: Maybe<Scalars['Int']['output']>;
  marketCap: Maybe<Scalars['Int']['output']>;
  /** Sector for company data (public_field) */
  sector: Scalars['String']['output'];
  /** 3 month daily average volume */
  threeMoAvgDailyVolume: Maybe<Scalars['Int']['output']>;
};

export type CompanyNewsBulletItem = {
  __typename?: 'CompanyNewsBulletItem';
  /** The category of the group public_field */
  category: Maybe<Scalars['String']['output']>;
  feedItems: Maybe<FeedItemConnection>;
  /** The number of feed items in the group public_field */
  itemCount: Maybe<Scalars['Int']['output']>;
};


export type CompanyNewsBulletItemFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for CompanyNewsBulletItem. */
export type CompanyNewsBulletItemConnection = {
  __typename?: 'CompanyNewsBulletItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CompanyNewsBulletItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CompanyNewsBulletItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompanyNewsBulletItemEdge = {
  __typename?: 'CompanyNewsBulletItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CompanyNewsBulletItem>;
};

export type CompanyNewsItem = {
  __typename?: 'CompanyNewsItem';
  /** The elevator pitch of the idea public_field */
  actionDate: Maybe<Scalars['String']['output']>;
  /** public_field */
  companyNewsBulletItems: Maybe<CompanyNewsBulletItemConnection>;
};


export type CompanyNewsItemCompanyNewsBulletItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for CompanyNewsItem. */
export type CompanyNewsItemConnection = {
  __typename?: 'CompanyNewsItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CompanyNewsItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<CompanyNewsItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompanyNewsItemEdge = {
  __typename?: 'CompanyNewsItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<CompanyNewsItem>;
};

export type CompanyQuestion = {
  __typename?: 'CompanyQuestion';
  /** The answer options belonging to the question */
  answerOptions: Array<Scalars['String']['output']>;
  /** Whether the question is marked deleted */
  deleted: Scalars['Boolean']['output'];
  /** How long until an answer expires */
  expirationMonths: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The title of the question */
  name: Scalars['String']['output'];
  /** Collection of user responses to the question for a particular entity */
  pollResponseData: PollResponseData;
  /** The answer format of the poll question */
  questionType: Scalars['String']['output'];
  /** The responses to the question for a particular entity */
  responses: Maybe<Array<CompanyQuestionResponse>>;
  /** Show or hide tooltip of the poll result line graph */
  showTooltip: Maybe<Scalars['Boolean']['output']>;
  /** The text of the question */
  text: Scalars['String']['output'];
  /** The number of y-axis ticks of the poll result line graph */
  tickCount: Maybe<Scalars['Int']['output']>;
  /** The values of y-axis ticks of the poll result line graph */
  tickValues: Maybe<Array<Scalars['String']['output']>>;
  /** The maximum value of y-axis of the poll result line graph */
  yMax: Maybe<Scalars['Int']['output']>;
  /** The minimum value of y-axis of the poll result line graph */
  yMin: Maybe<Scalars['Int']['output']>;
};


export type CompanyQuestionPollResponseDataArgs = {
  entityId: Scalars['ID']['input'];
};


export type CompanyQuestionResponsesArgs = {
  entityId: Scalars['ID']['input'];
};

export type CompanyQuestionResponse = {
  __typename?: 'CompanyQuestionResponse';
  id: Scalars['ID']['output'];
  /** The total number of users who chose this answer for a particular entity */
  numChose: Scalars['Int']['output'];
  /** The poll question that this response belongs to */
  pollQuestion: CompanyQuestion;
  /** Whether or not question was skipped */
  skipped: Maybe<Scalars['Boolean']['output']>;
  /** The text of the answer */
  text: Scalars['String']['output'];
  /** The updated at timestamp */
  updatedAt: Scalars['String']['output'];
};


export type CompanyQuestionResponseNumChoseArgs = {
  entityId: Scalars['ID']['input'];
};

export type Compensation = {
  __typename?: 'Compensation';
  /** Other cash bonus of the comp posting */
  annualDiscrBonus: Scalars['Float']['output'];
  /** The asset class expertise of the fund of the comp posting */
  assetClass: Scalars['String']['output'];
  /** The base salary of the comp posting */
  baseSalary: Scalars['Float']['output'];
  /** Whether the user is allowed to build a personal track record through managing a book or sub-portfolio */
  buildPersonalTrackRecord: Maybe<Scalars['Boolean']['output']>;
  /** The type (estimated/actual) of the comp posting */
  category: Scalars['String']['output'];
  /** Any additional information regarding the comp posting */
  comments: Maybe<Scalars['String']['output']>;
  completed: Scalars['Boolean']['output'];
  /** The years of experience of the comp posting */
  experience: Scalars['String']['output'];
  /** The fund size of the comp posting */
  fundSize: Scalars['String']['output'];
  /** The fund strategy of the comp posting */
  fundStrategy: Scalars['String']['output'];
  /** The firm type of the comp posting */
  fundType: Scalars['String']['output'];
  /** The id of the comp posting */
  id: Scalars['ID']['output'];
  /** The industry focus of the comp posting */
  industry: Scalars['String']['output'];
  /** The incentive fees percentage of the comp posting */
  interestIncentiveFeesPerc: Scalars['Float']['output'];
  /** The cash value of incentive fees of the comp posting */
  interestIncentiveFeesValue: Scalars['Float']['output'];
  /** The management fees percentage of the comp posting */
  interestMgmtFeesPerc: Scalars['Float']['output'];
  /** The cash value of management fees of the comp posting */
  interestMgmtFeesValue: Scalars['Float']['output'];
  /** Whether the user is able to invest in the fund without paying fees */
  investInFund: Maybe<Scalars['Boolean']['output']>;
  /** The location of the comp posting */
  location: Scalars['String']['output'];
  /** Whether the user is allowed to market personal track record post-employment */
  marketPersonalTrackRecord: Maybe<Scalars['Boolean']['output']>;
  /** The pie chart URL of the comp posting */
  pieChartData: Scalars['String']['output'];
  /** The posted date of the comp posting */
  postedAt: Scalars['String']['output'];
  /** The status (either draft or publisherd) of the comp posting */
  status: Scalars['String']['output'];
  /** The title of the comp posting */
  title: Scalars['String']['output'];
  /** The total cash compensation of the posting */
  totalCashComp: Scalars['Float']['output'];
  /** The total cash and deferred compensation of the comp posting */
  totalCashDeferredComp: Scalars['Float']['output'];
  /** The deferred compensation of the comp posting */
  totalDeferredComp: Scalars['Float']['output'];
  /** The updated date of the comp posting */
  updatedAt: Scalars['String']['output'];
  /** The vesting period of the incentive fees  of the comp posting */
  vestingIncentiveFees: Scalars['Int']['output'];
  /** The vesting period of the management fees */
  vestingMgmtFees: Scalars['Int']['output'];
  /** The year of the comp posting */
  year: Scalars['Int']['output'];
};

/** The connection type for Compensation. */
export type CompensationConnection = {
  __typename?: 'CompensationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<CompensationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Compensation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CompensationEdge = {
  __typename?: 'CompensationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Compensation>;
};

export type CompensationStatistics = {
  __typename?: 'CompensationStatistics';
  /** The maximum total cash comp data (filtered results if applicable) */
  maxComp: Scalars['Float']['output'];
  /** The mean of total cash comp data (filtered results if applicable) */
  mean: Scalars['Float']['output'];
  /** The median of total cash comp data (filtered results if applicable) */
  median: Scalars['Float']['output'];
  /** The minimum total cash comp data (filtered results if applicable) */
  minComp: Scalars['Float']['output'];
};

export type Contest = {
  __typename?: 'Contest';
  /** If the contest is active public_field */
  active: Maybe<Scalars['Boolean']['output']>;
  /** public_field */
  awardWinners: Array<Idea>;
  /** The countdown datetime in EDT (-04:00) or EST (-05:00) public_field */
  countdownDate: Maybe<Scalars['String']['output']>;
  /** If the modal should be disabled */
  disableSiteWideModal: Maybe<Scalars['Boolean']['output']>;
  /** The end date of the contest public_field */
  endDate: Maybe<Scalars['String']['output']>;
  /** All sponsors public_field */
  eventSponsors: Maybe<Array<ContestPrizeType>>;
  /** The id of the contest public_field */
  id: Scalars['ID']['output'];
  /** Whether the current user is a judge of the contest public_field */
  isCurrentUserJudge: Scalars['Boolean']['output'];
  /** The judges for the contest public_field */
  judges: Maybe<Array<ContestJudge>>;
  /** The list of names of judges */
  judgesDisplayNames: Maybe<Array<Scalars['String']['output']>>;
  /** The name of the contest public_field */
  name: Maybe<Scalars['String']['output']>;
  /** Prizes public_field */
  prizes: Maybe<Array<ContestPrizeType>>;
  /** Idea promo summary of the contest public_field */
  promoSummary: Maybe<Scalars['String']['output']>;
  /** Sponsors not offering any prizes public_field */
  sponsors: Maybe<Array<ContestPrizeType>>;
  /** The start date of the contest public_field */
  startDate: Maybe<Scalars['String']['output']>;
  /** Summary of the contest public_field */
  summary: Maybe<Scalars['String']['output']>;
};

/** The connection type for Contest. */
export type ContestConnection = {
  __typename?: 'ContestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ContestEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Contest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ContestEdge = {
  __typename?: 'ContestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Contest>;
};

export type ContestIdea = {
  __typename?: 'ContestIdea';
  /** If contest idea had an award (public_field) */
  award: Maybe<Scalars['String']['output']>;
  /** The id of the contest associated with this contest idea (public_field) */
  contestId: Scalars['ID']['output'];
  /** The name of the contest (public_field) */
  contestName: Scalars['String']['output'];
  /** The id of the contest idea (public_field) */
  id: Scalars['ID']['output'];
  /** The status of the contest idea (public_field) */
  status: Scalars['String']['output'];
};

export type ContestJudge = {
  __typename?: 'ContestJudge';
  /** The id of the judge public_field */
  id: Scalars['ID']['output'];
  /** The display name after sanitized for privacy public_field */
  sanitizedDisplayName: Maybe<Scalars['String']['output']>;
  /** The employer name after sanitized for privacy public_field */
  sanitizedEmployerString: Maybe<Scalars['String']['output']>;
  /** The employer url after sanitized for privacy public_field */
  sanitizedEmployerUrl: Maybe<Scalars['String']['output']>;
  /** The profile photo URL after sanitized for privacy public_field */
  sanitizedProfilePictureUrl: Maybe<Scalars['String']['output']>;
  /** The user or allocator profile URL depending on user type public_field */
  sanitizedProfileUrl: Maybe<Scalars['String']['output']>;
};

export type ContestPrizeType = {
  __typename?: 'ContestPrizeType';
  /** The action taken public_field */
  description: Maybe<Scalars['String']['output']>;
  /** ID public_field */
  id: Scalars['String']['output'];
  /** The action taken public_field */
  sponsorImage: Maybe<Scalars['String']['output']>;
  /** The action taken public_field */
  sponsorTrackingLink: Maybe<Scalars['String']['output']>;
};

export type CorporateAction = {
  __typename?: 'CorporateAction';
  /** The date of the action public_field */
  actionDate: Maybe<Scalars['String']['output']>;
  /** The type of the action public_field */
  actionType: Maybe<Scalars['String']['output']>;
  /** The action period return of the child entity public_field */
  childActionPeriodReturn: Maybe<Scalars['Float']['output']>;
  /** The name of the child entity public_field */
  childEntity: Maybe<Entity>;
  /** The post-action price of the child entity public_field */
  childPostActionPrice: Maybe<Scalars['Float']['output']>;
  /** The pre-action price of the child entity public_field */
  childPreActionPrice: Maybe<Scalars['Float']['output']>;
  /** The id of the acquisition public_field */
  id: Scalars['ID']['output'];
  /** The action period return of the parent entity public_field */
  parentActionPeriodReturn: Maybe<Scalars['Float']['output']>;
  /** The parent asset public_field */
  parentAsset: Maybe<Asset>;
  /** The parent entity public_field */
  parentEntity: Maybe<Entity>;
  /** The post-action price of the parent entity public_field */
  parentPostActionPrice: Maybe<Scalars['Float']['output']>;
  /** The pre-action price of the parent entity public_field */
  parentPreActionPrice: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of CreateAdLead */
export type CreateAdLeadInput = {
  adId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
  requestedTicker?: InputMaybe<Scalars['String']['input']>;
  tickerOnPage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAdLead */
export type CreateAdLeadPayload = {
  __typename?: 'CreateAdLeadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  partnerOffer: Maybe<AdCampaign>;
};

/** Autogenerated input type of CreateAllocatorBlocklistEntry */
export type CreateAllocatorBlocklistEntryInput = {
  allocatorProfileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAllocatorBlocklistEntry */
export type CreateAllocatorBlocklistEntryPayload = {
  __typename?: 'CreateAllocatorBlocklistEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  newBlocklistEntry: Maybe<AllocatorBlocklistEntry>;
};

/** Autogenerated input type of CreateAuditRecord */
export type CreateAuditRecordInput = {
  action: Scalars['String']['input'];
  auditableId: Scalars['ID']['input'];
  auditableType: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentType?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateAuditRecord */
export type CreateAuditRecordPayload = {
  __typename?: 'CreateAuditRecordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CreateChatMessage */
export type CreateChatMessageInput = {
  anonymous: Scalars['Boolean']['input'];
  body: Scalars['String']['input'];
  chatId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateChatMessage */
export type CreateChatMessagePayload = {
  __typename?: 'CreateChatMessagePayload';
  chatMessage: Maybe<ChatMessage>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateComment */
export type CreateCommentInput = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerProfileId?: InputMaybe<Scalars['ID']['input']>;
  feedItemId?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  hideFromFundAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  ideaId?: InputMaybe<Scalars['ID']['input']>;
  ideaUpdateId?: InputMaybe<Scalars['ID']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  postId?: InputMaybe<Scalars['ID']['input']>;
  requestResponse?: InputMaybe<Scalars['Boolean']['input']>;
  whitePaperId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateComment */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  comment: Maybe<Comment>;
  idea: Maybe<Idea>;
};

/** Autogenerated input type of CreateEventImpression */
export type CreateEventImpressionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  elapsedTime?: InputMaybe<Scalars['Int']['input']>;
  eventId: Scalars['ID']['input'];
  index?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateEventImpression */
export type CreateEventImpressionPayload = {
  __typename?: 'CreateEventImpressionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  event: Maybe<Event>;
};

/** Autogenerated input type of CreateFundProfile */
export type CreateFundProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerId: Scalars['ID']['input'];
};

/** Autogenerated input type of CreateFundProfileMessage */
export type CreateFundProfileMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateFundProfileMessage */
export type CreateFundProfileMessagePayload = {
  __typename?: 'CreateFundProfileMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated return type of CreateFundProfile */
export type CreateFundProfilePayload = {
  __typename?: 'CreateFundProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CreateFundProfileSearchAlert */
export type CreateFundProfileSearchAlertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFundProfileSearchAlert */
export type CreateFundProfileSearchAlertPayload = {
  __typename?: 'CreateFundProfileSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  searchAlert: Maybe<EmployerProfileSearchAlert>;
};

/** Autogenerated input type of CreateIdeaSearchAlert */
export type CreateIdeaSearchAlertInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};

/** Autogenerated return type of CreateIdeaSearchAlert */
export type CreateIdeaSearchAlertPayload = {
  __typename?: 'CreateIdeaSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  searchAlert: Maybe<IdeaSearchAlert>;
};

/** Autogenerated input type of CreateIntroRequest */
export type CreateIntroRequestInput = {
  allocatorProfileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundProfileId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateIntroRequest */
export type CreateIntroRequestPayload = {
  __typename?: 'CreateIntroRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
  fundProfile: Maybe<EmployerProfile>;
};

/** Autogenerated input type of CreateJobApplication */
export type CreateJobApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** cover note/ cover letter from job applicant */
  coverLetter?: InputMaybe<Scalars['String']['input']>;
  /** email of job applicant */
  email: Scalars['String']['input'];
  /** related job post id for the application */
  jobPostId: Scalars['ID']['input'];
  /** phone number of job applicant */
  phone: Scalars['String']['input'];
};

/** Autogenerated return type of CreateJobApplication */
export type CreateJobApplicationPayload = {
  __typename?: 'CreateJobApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CreateJobPosting */
export type CreateJobPostingInput = {
  actScore?: InputMaybe<Scalars['Int']['input']>;
  assetClassNames?: InputMaybe<Array<Scalars['String']['input']>>;
  aum: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverLetter: Scalars['String']['input'];
  degreesAndCertifications?: InputMaybe<Array<Scalars['String']['input']>>;
  description: Scalars['String']['input'];
  employerCity: Scalars['String']['input'];
  employerDescription: Scalars['String']['input'];
  firmExperience?: InputMaybe<Array<Scalars['String']['input']>>;
  fundType: Scalars['String']['input'];
  geographyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  maxGpa: Scalars['String']['input'];
  maxSat: Scalars['String']['input'];
  minimumGpa?: InputMaybe<Scalars['String']['input']>;
  minimumSat?: InputMaybe<Scalars['Int']['input']>;
  positionAssetClassNames?: InputMaybe<Array<Scalars['String']['input']>>;
  positionCity: Scalars['String']['input'];
  positionGeographyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  positionSectorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  sectorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  strategy: Scalars['String']['input'];
  title: Scalars['String']['input'];
  useCompanyInvestmentMandate: Scalars['Boolean']['input'];
  yearsOfExperience: Scalars['String']['input'];
};

/** Autogenerated return type of CreateJobPosting */
export type CreateJobPostingPayload = {
  __typename?: 'CreateJobPostingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  jobPost: Maybe<JobPosting>;
};

/** Autogenerated input type of CreateLead */
export type CreateLeadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  email: Scalars['String']['input'];
  /** public_field */
  firmName?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateLead */
export type CreateLeadPayload = {
  __typename?: 'CreateLeadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** public_field */
  message: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateMessageForThread */
export type CreateMessageForThreadInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  thread: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateMessageForThread */
export type CreateMessageForThreadPayload = {
  __typename?: 'CreateMessageForThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  createdMessage: Maybe<Message>;
};

/** Autogenerated input type of CreateMessage */
export type CreateMessageInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  receiverUserId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  thread?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateMessage */
export type CreateMessagePayload = {
  __typename?: 'CreateMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of CreateOrEditIdeaUpdate */
export type CreateOrEditIdeaUpdateInput = {
  /** Attachments to the idea */
  attachments?: InputMaybe<Array<ResearchAttachmentAttributes>>;
  /** Details text input about the idea update */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A collection of catalysts of the idea */
  catalysts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to close the idea after saving this update */
  closeIdea: Scalars['Boolean']['input'];
  /** ID of idea the update belongs to */
  ideaId: Scalars['ID']['input'];
  /** ID of idea update to be edited */
  ideaUpdateId?: InputMaybe<Scalars['ID']['input']>;
  /** The update's impact on the original idea - positive, neutral, or negative */
  impact?: InputMaybe<Scalars['String']['input']>;
  /** The price target of the idea's primary position */
  priceTarget?: InputMaybe<Scalars['String']['input']>;
  /** The return target of the idea (if pair trade) */
  returnTarget?: InputMaybe<Scalars['String']['input']>;
  /** The situation of the idea */
  situation?: InputMaybe<Scalars['String']['input']>;
  /** The target allocation percentage range of the idea */
  targetAllocation?: InputMaybe<Scalars['String']['input']>;
  /** The time frame range of the idea */
  timeframe?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrEditIdeaUpdate */
export type CreateOrEditIdeaUpdatePayload = {
  __typename?: 'CreateOrEditIdeaUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  idea: Maybe<Idea>;
  ideaUpdate: Maybe<IdeaUpdate>;
};

/** Autogenerated input type of CreateOrUpdateAccreditedInvestorProfile */
export type CreateOrUpdateAccreditedInvestorProfileInput = {
  bonds?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  foreignCurrencies?: InputMaybe<Scalars['String']['input']>;
  futuresOrCommodities?: InputMaybe<Scalars['String']['input']>;
  hedgeFunds?: InputMaybe<Scalars['String']['input']>;
  incomeReq?: InputMaybe<Scalars['Boolean']['input']>;
  investmentSize?: InputMaybe<Scalars['String']['input']>;
  netWorth?: InputMaybe<Scalars['String']['input']>;
  netWorthReq?: InputMaybe<Scalars['Boolean']['input']>;
  next12MoAllocation?: InputMaybe<Scalars['String']['input']>;
  privateCompanies?: InputMaybe<Scalars['String']['input']>;
  privateEquityFunds?: InputMaybe<Scalars['String']['input']>;
  publiclyTradedStocks?: InputMaybe<Scalars['String']['input']>;
  realEstate?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  yearsInvesting?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrUpdateAccreditedInvestorProfile */
export type CreateOrUpdateAccreditedInvestorProfilePayload = {
  __typename?: 'CreateOrUpdateAccreditedInvestorProfilePayload';
  accreditedInvestorProfile: Maybe<AccreditedInvestorProfile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  unaccredited: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of CreateOrUpdateCompanyQuestion */
export type CreateOrUpdateCompanyQuestionInput = {
  /** The answer options of the question */
  answerOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The number of months for which an answer to the question is valid */
  expirationMonths?: InputMaybe<Scalars['Int']['input']>;
  /** The question id - if updating */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The question name/title */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The question type */
  questionType?: InputMaybe<Scalars['String']['input']>;
  /** The question text */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOrUpdateCompanyQuestion */
export type CreateOrUpdateCompanyQuestionPayload = {
  __typename?: 'CreateOrUpdateCompanyQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  companyQuestion: Maybe<CompanyQuestion>;
};

/** Autogenerated input type of CreateOrUpdateCompensation */
export type CreateOrUpdateCompensationInput = {
  annualDiscrBonus?: InputMaybe<Scalars['Float']['input']>;
  assetClass?: InputMaybe<Scalars['String']['input']>;
  baseSalary?: InputMaybe<Scalars['Float']['input']>;
  buildPersonalTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  fundSize?: InputMaybe<Scalars['String']['input']>;
  fundStrategy?: InputMaybe<Scalars['String']['input']>;
  fundType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  interestIncentiveFeesPerc?: InputMaybe<Scalars['Float']['input']>;
  interestIncentiveFeesValue?: InputMaybe<Scalars['Float']['input']>;
  interestMgmtFeesPerc?: InputMaybe<Scalars['Float']['input']>;
  interestMgmtFeesValue?: InputMaybe<Scalars['Float']['input']>;
  investInFund?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  marketPersonalTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  status: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  totalDeferredComp?: InputMaybe<Scalars['Float']['input']>;
  vestingIncentiveFees?: InputMaybe<Scalars['Int']['input']>;
  vestingMgmtFees?: InputMaybe<Scalars['Int']['input']>;
  year: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateOrUpdateCompensation */
export type CreateOrUpdateCompensationPayload = {
  __typename?: 'CreateOrUpdateCompensationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  compensation: Maybe<Compensation>;
  completed: Maybe<Scalars['Boolean']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of CreateOrUpdateIdea */
export type CreateOrUpdateIdeaInput = {
  anonymous: Scalars['Boolean']['input'];
  attachments: Array<ResearchAttachmentAttributes>;
  catalystNames: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contests: Array<Scalars['ID']['input']>;
  currentStep: Scalars['String']['input'];
  elevatorPitch: Scalars['String']['input'];
  employerApprovalDisclaimer: Scalars['Boolean']['input'];
  employerId?: InputMaybe<Scalars['ID']['input']>;
  fundProfileDisplay: Scalars['Boolean']['input'];
  ideaId?: InputMaybe<Scalars['ID']['input']>;
  isSubmission: Scalars['Boolean']['input'];
  mentionedEntities: Array<Scalars['String']['input']>;
  noPriorAgreementDisclaimer: Scalars['Boolean']['input'];
  pairRatio?: InputMaybe<Array<Scalars['Float']['input']>>;
  portfolioPercentage: Scalars['String']['input'];
  positionDisclaimerFund: Scalars['Boolean']['input'];
  positionDisclaimerIndividual: Scalars['Boolean']['input'];
  positions: Array<PositionAttributes>;
  publicInformationDisclaimer: Scalars['Boolean']['input'];
  returnTarget?: InputMaybe<Scalars['Float']['input']>;
  situation: Scalars['String']['input'];
  tagList: Array<Scalars['String']['input']>;
  thesis: Scalars['String']['input'];
  timeframe: Scalars['String']['input'];
};

/** Autogenerated return type of CreateOrUpdateIdea */
export type CreateOrUpdateIdeaPayload = {
  __typename?: 'CreateOrUpdateIdeaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  idea: Idea;
};

/** Autogenerated input type of CreateOrUpdateWhitePaper */
export type CreateOrUpdateWhitePaperInput = {
  attachments: Array<ResearchAttachmentAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentStep: Scalars['String']['input'];
  elevatorPitch: Scalars['String']['input'];
  employerId?: InputMaybe<Scalars['ID']['input']>;
  esgs: Array<Scalars['ID']['input']>;
  fundProfileDisplay: Scalars['Boolean']['input'];
  geographies: Array<Scalars['ID']['input']>;
  globalMacros: Array<Scalars['ID']['input']>;
  isSubmission: Scalars['Boolean']['input'];
  mentionedEntities: Array<Scalars['ID']['input']>;
  positionDisclaimerFund: Scalars['Boolean']['input'];
  positionDisclaimerIndividual: Scalars['Boolean']['input'];
  sectors: Array<Scalars['ID']['input']>;
  tagList: Array<Scalars['String']['input']>;
  thesis: Scalars['String']['input'];
  title: Scalars['String']['input'];
  whitePaperId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateOrUpdateWhitePaper */
export type CreateOrUpdateWhitePaperPayload = {
  __typename?: 'CreateOrUpdateWhitePaperPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  whitePaper: WhitePaper;
};

/** Autogenerated input type of CreatePost */
export type CreatePostInput = {
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ogUrl?: InputMaybe<Scalars['String']['input']>;
  postFiles?: InputMaybe<Scalars['String']['input']>;
  tagList?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreatePost */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  feedItem: Maybe<FeedItem>;
  post: Maybe<Post>;
};

/** Autogenerated input type of CreateQuickPosition */
export type CreateQuickPositionInput = {
  /** Whether or not the quick position's anonymous */
  anonymous: Scalars['Boolean']['input'];
  /** The ID of the quick position's asset */
  assetId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The direction of the quick position */
  direction: Scalars['String']['input'];
};

/** Autogenerated return type of CreateQuickPosition */
export type CreateQuickPositionPayload = {
  __typename?: 'CreateQuickPositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** The quick position */
  quickPosition: QuickPosition;
};

/** Autogenerated input type of CreateThesisImage */
export type CreateThesisImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  image: Scalars['String']['input'];
  imageableId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateThesisImage */
export type CreateThesisImagePayload = {
  __typename?: 'CreateThesisImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  thesisImageUrl: Scalars['String']['output'];
};

/** Autogenerated input type of CreateTweet */
export type CreateTweetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tweetBody: Scalars['String']['input'];
};

/** Autogenerated return type of CreateTweet */
export type CreateTweetPayload = {
  __typename?: 'CreateTweetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  tweetUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateUpdateReadingListItem */
export type CreateUpdateReadingListItemInput = {
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId?: InputMaybe<Scalars['ID']['input']>;
  readingListItemId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateUpdateReadingListItem */
export type CreateUpdateReadingListItemPayload = {
  __typename?: 'CreateUpdateReadingListItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
  readingListItem: Maybe<ReadingListItem>;
};

/** Autogenerated input type of CreateUserFeedback */
export type CreateUserFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateUserFeedback */
export type CreateUserFeedbackPayload = {
  __typename?: 'CreateUserFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  userFeedback: Maybe<UserFeedback>;
};

/** Autogenerated input type of CreateViewerIntroRequest */
export type CreateViewerIntroRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the viewable */
  viewableId: Scalars['ID']['input'];
  /** The type of the viewable */
  viewableType: Scalars['String']['input'];
  /** The id of the user who has viewed the idea */
  viewerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateViewerIntroRequest */
export type CreateViewerIntroRequestPayload = {
  __typename?: 'CreateViewerIntroRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  viewerIntroRequest: Maybe<ViewerIntroRequest>;
};

export type CryptoMarketData = {
  __typename?: 'CryptoMarketData';
  /** The crypto assets circulating supply public_field */
  circulatingSupply: Maybe<Scalars['Int']['output']>;
  /** The crypto assets diluted market cap public_field */
  fullyDilutedMarketCap: Maybe<Scalars['Int']['output']>;
  /** The crypto assets market cap public_field */
  marketCap: Maybe<Scalars['Int']['output']>;
  /** The crypto assets max supply public_field */
  maxSupply: Maybe<Scalars['Int']['output']>;
  /** The crypto assets percent change over 7 days public_field */
  percentChange7d: Maybe<Scalars['Int']['output']>;
  /** The crypto assets percent change over 24 hours public_field */
  percentChange24h: Maybe<Scalars['Int']['output']>;
  /** The crypto assets total supply public_field */
  totalSupply: Maybe<Scalars['Int']['output']>;
  /** The crypto assets 24 hour volume public_field */
  volume24h: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of DeleteFundSearchAlert */
export type DeleteFundSearchAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** employer profile saved search alert id */
  fundSearchAlertId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteFundSearchAlert */
export type DeleteFundSearchAlertPayload = {
  __typename?: 'DeleteFundSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of DeleteIdeaSearchAlert */
export type DeleteIdeaSearchAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** idea saved search alert id */
  ideaSearchAlertId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIdeaSearchAlert */
export type DeleteIdeaSearchAlertPayload = {
  __typename?: 'DeleteIdeaSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of DeletePost */
export type DeletePostInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  feedItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePost */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  feedItem: Maybe<FeedItem>;
};

/** Autogenerated input type of DestroyAllocatorBlocklistEntry */
export type DestroyAllocatorBlocklistEntryInput = {
  allocatorProfileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyAllocatorBlocklistEntry */
export type DestroyAllocatorBlocklistEntryPayload = {
  __typename?: 'DestroyAllocatorBlocklistEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  destroyedBlocklistEntry: Maybe<AllocatorBlocklistEntry>;
};

/** Autogenerated input type of DestroyCompanyQuestion */
export type DestroyCompanyQuestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The question id */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyCompanyQuestion */
export type DestroyCompanyQuestionPayload = {
  __typename?: 'DestroyCompanyQuestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  companyQuestion: Maybe<CompanyQuestion>;
};

/** Autogenerated input type of DestroyCompensation */
export type DestroyCompensationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyCompensation */
export type DestroyCompensationPayload = {
  __typename?: 'DestroyCompensationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of DestroyIdeaDraft */
export type DestroyIdeaDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyIdeaDraft */
export type DestroyIdeaDraftPayload = {
  __typename?: 'DestroyIdeaDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUserId: Scalars['ID']['output'];
  ideaId: Scalars['ID']['output'];
};

/** Autogenerated input type of DestroyWhitePaperDraft */
export type DestroyWhitePaperDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  whitePaperId: Scalars['ID']['input'];
};

/** Autogenerated return type of DestroyWhitePaperDraft */
export type DestroyWhitePaperDraftPayload = {
  __typename?: 'DestroyWhitePaperDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUserId: Scalars['ID']['output'];
  whitePaperId: Scalars['ID']['output'];
};

export type EmailPreference = {
  __typename?: 'EmailPreference';
  /** The email type/category of the preference */
  emailType: Scalars['String']['output'];
  /** The id of the email preference */
  id: Scalars['ID']['output'];
  /** Whether or not the user is subscribed to the email type */
  subscribed: Maybe<Scalars['Boolean']['output']>;
};

export type Employer = {
  __typename?: 'Employer';
  /** The allocator profile of the employer */
  allocatorProfile: Maybe<AllocatorProfile>;
  /** The asset types managed by the employer */
  assets: Maybe<Array<Scalars['String']['output']>>;
  /** The AUM of the employer */
  aum: Maybe<Scalars['Int']['output']>;
  /** The AUM range of the employer public_field */
  aumRange: Maybe<Scalars['String']['output']>;
  /** If the AUM Range is not N/A */
  aumRangePresent: Maybe<Scalars['Boolean']['output']>;
  /** If the employer can extend cap intro access (cap intro posting) */
  canExtendCapIntroAccess: Scalars['Boolean']['output'];
  /** The city of the employer (public_field) */
  city: Maybe<Scalars['String']['output']>;
  /** The description of the employer */
  description: Maybe<Scalars['String']['output']>;
  /** The employer profile associated with this (public_field) */
  employerProfile: Maybe<EmployerProfile>;
  /** The fund type of the employer public_field */
  fundType: Maybe<Scalars['String']['output']>;
  /** If the employer has a fund profile (public_field) */
  hasFundProfile: Scalars['Boolean']['output'];
  /** The id of the employer (public_field) */
  id: Scalars['ID']['output'];
  /** Investment style of the employer */
  investmentStyle: Maybe<Scalars['String']['output']>;
  /** The name of the employer public_field */
  name: Scalars['String']['output'];
  /** Regions the employer operates in */
  regions: Maybe<Array<Scalars['String']['output']>>;
  /** The sectors the employer is involved in */
  sectors: Maybe<Array<Scalars['String']['output']>>;
  /** The strategy of the employer (public_field) */
  strategy: Maybe<Scalars['String']['output']>;
};

export type EmployerHistory = {
  __typename?: 'EmployerHistory';
  /** If the employer is a current employer (public_field) */
  currentEmployer: Scalars['Boolean']['output'];
  /** The employer associated with this (public_field) */
  employer: Maybe<Employer>;
  /** From date */
  fromDate: Maybe<Scalars['String']['output']>;
  /** The id of the employer history (public_field) */
  id: Scalars['ID']['output'];
  /** If the employer is a primary employer */
  primary: Scalars['Boolean']['output'];
  /** The title if any (public_field) */
  title: Maybe<Scalars['String']['output']>;
  /** To date */
  toDate: Maybe<Scalars['String']['output']>;
};

export type EmployerProfile = {
  __typename?: 'EmployerProfile';
  /** The employer profile's allocator blocklist entries */
  allocatorBlocklist: Array<AllocatorBlocklistEntry>;
  /** If the fund already intro requested a particular allocator profile in the last 6 months */
  alreadyRequestedIntro: Maybe<Scalars['Boolean']['output']>;
  /** Asset Class Expertise */
  assetClassExpertise: Maybe<Array<Scalars['String']['output']>>;
  /** The AUM of the fund */
  aum: Maybe<Scalars['Int']['output']>;
  /** The AUM range of the fund profile public_field */
  aumRange: Maybe<Scalars['String']['output']>;
  /** URL for cropped background image */
  backgroundImageCroppedUrl: Maybe<Scalars['String']['output']>;
  /** URL for background image */
  backgroundImageUrl: Maybe<Scalars['String']['output']>;
  /** Baseline intro requests per 6 month period */
  baselineIntroRequestBonus: Maybe<Scalars['Int']['output']>;
  /** Beta */
  beta: Maybe<Scalars['Float']['output']>;
  /** The current employees of the employer profile */
  currentEmployees: Array<User>;
  /** The current user is an allocator, and has messaged this Fund */
  currentUserHasMessagedFund: Maybe<Scalars['Boolean']['output']>;
  /** Whether the current user is on the blocklist */
  currentUserOnBlocklist: Maybe<Scalars['Boolean']['output']>;
  /** The number of times the user has viewed this Profile */
  currentUserViewCount: Maybe<Scalars['Int']['output']>;
  /** URL for default background image */
  defaultBackgroundImage: Maybe<Scalars['String']['output']>;
  /** URL for default logo */
  defaultLogo: Maybe<Scalars['String']['output']>;
  /** The description of the fund public_field */
  description: Maybe<Scalars['String']['output']>;
  /** Due Diligence Documents */
  dueDiligenceDocuments: Maybe<Array<EmployerProfileDueDiligenceDocument>>;
  /** Excluded sections */
  excludedSections: Maybe<Array<Scalars['String']['output']>>;
  /** Executives */
  executives: Maybe<Array<EmployerProfileExecutive>>;
  /** Featured Research */
  featuredResearch: Maybe<Array<Idea>>;
  /** Featured Macro / Thematic Research */
  featuredWhitePaperResearch: Maybe<Array<WhitePaper>>;
  /** Fee Structure Documents */
  feeStructureDocuments: Maybe<Array<EmployerProfileDocument>>;
  /** Firm References */
  firmReferences: Maybe<Array<EmployerProfileFirmReference>>;
  /** The focus of the fund public_field */
  focus: Maybe<Scalars['String']['output']>;
  /** The number of followers on the profile (public_field) */
  followerCount: Maybe<Scalars['Int']['output']>;
  /** Founders' Shares */
  foundersShares: Maybe<Scalars['Boolean']['output']>;
  /** The Founding Date of the fund profile public_field */
  foundingDate: Maybe<Scalars['String']['output']>;
  /** The founding year of the fund profile public_field */
  foundingYear: Maybe<Scalars['String']['output']>;
  /** The fund admin ids of the employer profile */
  fundAdminIds: Array<Scalars['ID']['output']>;
  /** The Fund Manager public_field */
  fundManager: Maybe<Scalars['String']['output']>;
  /** Fund recommendation for the fund and the current user */
  fundRecommendation: Maybe<FundRecommendation>;
  /** The firm type of the profile public_field */
  fundType: Maybe<Scalars['String']['output']>;
  /** Geographic Expertise */
  geographicExpertise: Maybe<Array<Scalars['String']['output']>>;
  /** Highlights from text searches in a hash with html */
  highlights: Maybe<Scalars['String']['output']>;
  /** Highwater Mark */
  highwaterMark: Maybe<Scalars['Boolean']['output']>;
  /** Holdings */
  holdings: Maybe<Array<EmployerProfileHolding>>;
  /** Holdings Documents */
  holdingsDocuments: Maybe<Array<EmployerProfileDocument>>;
  /** Date Holdings Updated */
  holdingsUpdatedDate: Maybe<Scalars['String']['output']>;
  /** Hurdle Rate */
  hurdleRate: Maybe<Scalars['Float']['output']>;
  /** The id of the employer profile (public_field) */
  id: Scalars['ID']['output'];
  /** The number of ideas on the profile */
  ideaCount: Maybe<Scalars['Int']['output']>;
  /** Incentive Fee */
  incentiveFee: Maybe<Scalars['Float']['output']>;
  /** When intro requests refresh */
  introRequestPeriodEnd: Maybe<Scalars['String']['output']>;
  /** Intro requests left */
  introRequestsLeft: Maybe<Scalars['Int']['output']>;
  /** Investor Level Gates */
  investorLevelGates: Maybe<Scalars['Boolean']['output']>;
  /** If the allocator profile is in the employer profile's allocator blocklist entries */
  isAllocatorBlocklisted: Scalars['Boolean']['output'];
  /** The latest benchmarked employer return */
  lastReturn: Maybe<EmployerReturn>;
  /** The city where the fund is located public_field */
  location: Maybe<Scalars['String']['output']>;
  /** Lock Up */
  lockUp: Maybe<Scalars['Int']['output']>;
  /** URL for cropped logo public_field */
  logoProfileUrl: Maybe<Scalars['String']['output']>;
  /** URL for logo public_field */
  logoUrl: Maybe<Scalars['String']['output']>;
  /** Management Fee */
  managementFee: Maybe<Scalars['Float']['output']>;
  /** Marketing Materials */
  marketingMaterials: Maybe<Array<EmployerProfileDocument>>;
  /** Metrics Documents */
  metricsDocuments: Maybe<Array<EmployerProfileDocument>>;
  /** Date Metrics Updated */
  metricsUpdatedAt: Maybe<Scalars['String']['output']>;
  /** The name of the fund public_field */
  name: Maybe<Scalars['String']['output']>;
  /** Notes */
  notes: Maybe<Scalars['String']['output']>;
  /** Any pending intro requests from the current user (public_field) */
  pendingIntroRequest: Maybe<IntroRequest>;
  /** Presses */
  presses: Maybe<Array<EmployerProfilePress>>;
  /** The completeness of the profile */
  profileCompleteness: Maybe<Scalars['Int']['output']>;
  /** Returns */
  returns: Maybe<Array<EmployerReturn>>;
  /** Returns Documents */
  returnsDocuments: Maybe<Array<EmployerProfileDocument>>;
  /** Date Returns Updated */
  returnsUpdatedDate: Maybe<Scalars['String']['output']>;
  /** Section completeness percents (JSON) */
  sectionCompletenessPercents: Maybe<Scalars['String']['output']>;
  /** Section visibilities (JSON) */
  sectionVisibilities: Maybe<Scalars['String']['output']>;
  /** Sector Expertise */
  sectorExpertise: Maybe<Array<Scalars['String']['output']>>;
  /** Seed Deal */
  seedDeal: Maybe<Scalars['Boolean']['output']>;
  /** Service Providers */
  serviceProviders: Maybe<Array<EmployerProfileServiceProvider>>;
  /** Sharpe Ratio */
  sharpeRatio: Maybe<Scalars['Float']['output']>;
  /** Status of the profile */
  status: Maybe<Scalars['String']['output']>;
  /** The firm strategy public_field */
  strategy: Maybe<Scalars['String']['output']>;
  /** Subsector Expertise */
  subsectorExpertise: Maybe<Scalars['String']['output']>;
  /** Tag Names */
  tagNames: Maybe<Array<Scalars['String']['output']>>;
  /** Turnover Ratio */
  turnoverRatio: Maybe<Scalars['Float']['output']>;
  /** Updated at */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** The link string for the fund profile public_field */
  vanityLink: Maybe<Scalars['String']['output']>;
};


export type EmployerProfileAlreadyRequestedIntroArgs = {
  allocatorProfileId: Scalars['ID']['input'];
};


export type EmployerProfileIsAllocatorBlocklistedArgs = {
  allocatorProfileId: Scalars['ID']['input'];
};

export type EmployerProfileDocument = {
  __typename?: 'EmployerProfileDocument';
  /** The category of the document public_field */
  category: Maybe<Scalars['String']['output']>;
  /** The description of the document */
  description: Maybe<Scalars['String']['output']>;
  /** The file name of the document */
  filename: Maybe<Scalars['String']['output']>;
  /** The ID of the document public_field */
  id: Scalars['ID']['output'];
  /** The name of the document public_field */
  name: Maybe<Scalars['String']['output']>;
  /** The content type of the document */
  url: Maybe<Scalars['String']['output']>;
};

/** The connection type for EmployerProfileDocument. */
export type EmployerProfileDocumentConnection = {
  __typename?: 'EmployerProfileDocumentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EmployerProfileDocumentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EmployerProfileDocument>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmployerProfileDocumentEdge = {
  __typename?: 'EmployerProfileDocumentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EmployerProfileDocument>;
};

export type EmployerProfileDueDiligenceDocument = {
  __typename?: 'EmployerProfileDueDiligenceDocument';
  /** The category of the document */
  category: Scalars['String']['output'];
  /** The description of the document */
  description: Scalars['String']['output'];
  /** The file name of the document */
  filename: Maybe<Scalars['String']['output']>;
  /** The ID of the document */
  id: Scalars['ID']['output'];
  /** The name of the document */
  name: Scalars['String']['output'];
};

export type EmployerProfileExecutive = {
  __typename?: 'EmployerProfileExecutive';
  bio: Maybe<Scalars['String']['output']>;
  /** Url for default photo */
  defaultPhoto: Maybe<Scalars['String']['output']>;
  hasPhoto: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  /** Photo URL cropped for the profile */
  photoProfileUrl: Maybe<Scalars['String']['output']>;
  photoUrl: Maybe<Scalars['String']['output']>;
};

export type EmployerProfileFirmReference = {
  __typename?: 'EmployerProfileFirmReference';
  contactEmail: Maybe<Scalars['String']['output']>;
  employer: Maybe<Scalars['String']['output']>;
  employerProfileId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Maybe<Scalars['String']['output']>;
  relationshipToFund: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};

export type EmployerProfileHolding = {
  __typename?: 'EmployerProfileHolding';
  action: Maybe<Scalars['String']['output']>;
  assetClass: Maybe<Scalars['String']['output']>;
  assetId: Maybe<Scalars['ID']['output']>;
  averageCost: Maybe<Scalars['Float']['output']>;
  displayIndex: Maybe<Scalars['Int']['output']>;
  employerProfileId: Maybe<Scalars['ID']['output']>;
  entityName: Maybe<Scalars['String']['output']>;
  expectedReturn: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  percentOfPortfolio: Maybe<Scalars['Int']['output']>;
  priceTarget: Maybe<Scalars['String']['output']>;
  primarySymbol: Maybe<Scalars['String']['output']>;
  realizedReturn: Maybe<Scalars['Float']['output']>;
  timeframe: Maybe<Scalars['String']['output']>;
};

export type EmployerProfilePress = {
  __typename?: 'EmployerProfilePress';
  /** Description of the publication public_field */
  description: Maybe<Scalars['String']['output']>;
  /** The url of the pdf */
  fileUrl: Maybe<Scalars['String']['output']>;
  /** The filename of the pdf */
  filename: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** URL of the scraped image */
  previewImageUrl: Maybe<Scalars['String']['output']>;
  /** The date of the publication public_field */
  publishDate: Maybe<Scalars['String']['output']>;
  /** The title of the publication public_field */
  title: Maybe<Scalars['String']['output']>;
  /** The url of the link public_field */
  url: Maybe<Scalars['String']['output']>;
};

/** The connection type for EmployerProfilePress. */
export type EmployerProfilePressConnection = {
  __typename?: 'EmployerProfilePressConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EmployerProfilePressEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EmployerProfilePress>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmployerProfilePressEdge = {
  __typename?: 'EmployerProfilePressEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EmployerProfilePress>;
};

export type EmployerProfileSearchAlert = {
  __typename?: 'EmployerProfileSearchAlert';
  /** If the search alert is active */
  active: Maybe<Scalars['Boolean']['output']>;
  /** If the search alert is displaying */
  display: Maybe<Scalars['Boolean']['output']>;
  /** The fund profile saved search associated with this alert */
  employerProfileSavedSearch: Maybe<SavedSearch>;
  /** The id of the search alert */
  id: Scalars['ID']['output'];
  /** The name of the saved search */
  name: Maybe<Scalars['String']['output']>;
};

/** The connection type for EmployerProfileSearchAlert. */
export type EmployerProfileSearchAlertConnection = {
  __typename?: 'EmployerProfileSearchAlertConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EmployerProfileSearchAlertEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EmployerProfileSearchAlert>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EmployerProfileSearchAlertEdge = {
  __typename?: 'EmployerProfileSearchAlertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EmployerProfileSearchAlert>;
};

export type EmployerProfileServiceProvider = {
  __typename?: 'EmployerProfileServiceProvider';
  /** The category of the service provider */
  category: Maybe<Scalars['String']['output']>;
  /** The email of the contact */
  contactEmail: Maybe<Scalars['String']['output']>;
  /** The name of the contact at the firm */
  contactName: Maybe<Scalars['String']['output']>;
  /** The phone number of the contact */
  contactPhoneNumber: Maybe<Scalars['String']['output']>;
  /** The name of the firm */
  firmName: Maybe<Scalars['String']['output']>;
  /** The ID of the document */
  id: Scalars['ID']['output'];
};

export type EmployerProfileUpdate = {
  __typename?: 'EmployerProfileUpdate';
  /** Flag to indicate whether the expertise section changed public_field */
  expertiseChanges: Maybe<Scalars['String']['output']>;
  /** Flag to indicate whether the fund holding section changed public_field */
  fundHoldingsChanges: Maybe<Scalars['String']['output']>;
  /** The Employer Profile belonging to the update public_field */
  fundProfile: Maybe<EmployerProfile>;
  /** Flag to indicate whether the fund return section changed public_field */
  fundReturnsChanges: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Marketing materials associated with the update public_field */
  marketingMaterials: Maybe<EmployerProfileDocumentConnection>;
  /** Marketing materials associated with the update public_field */
  pressMediaList: Maybe<EmployerProfilePressConnection>;
};


export type EmployerProfileUpdateMarketingMaterialsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EmployerProfileUpdatePressMediaListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type EmployerReturn = {
  __typename?: 'EmployerReturn';
  benchmark: Maybe<Scalars['String']['output']>;
  employerBenchmark: Maybe<Scalars['Boolean']['output']>;
  employerProfileId: Scalars['ID']['output'];
  fiveYear: Maybe<Scalars['Float']['output']>;
  id: Maybe<Scalars['ID']['output']>;
  ltm: Maybe<Scalars['Float']['output']>;
  oneYear: Maybe<Scalars['Float']['output']>;
  sevenYear: Maybe<Scalars['Float']['output']>;
  sinceInception: Maybe<Scalars['Float']['output']>;
  status: Maybe<Scalars['String']['output']>;
  tenYear: Maybe<Scalars['Float']['output']>;
  threeYear: Maybe<Scalars['Float']['output']>;
  ytd: Maybe<Scalars['Float']['output']>;
};

export type Entity = {
  __typename?: 'Entity';
  /** The assets of the entity */
  assets: Maybe<Array<Asset>>;
  /** public_field */
  companyNewsItems: Maybe<CompanyNewsItemConnection>;
  /** Country for company data public_field */
  country: Maybe<Scalars['String']['output']>;
  /** Primary Currency Symbol public_field */
  currencyCode: Maybe<Scalars['String']['output']>;
  entityQuoteData: Maybe<Scalars['String']['output']>;
  /** Factet Entity Id */
  factsetEntityId: Maybe<Scalars['String']['output']>;
  /** The number of followers of the entity (public_field) */
  followersCount: Maybe<Scalars['Int']['output']>;
  /** Fundamentals for company data */
  fundamental: Maybe<Fundamental>;
  /** Geography for company data public_field */
  geography: Maybe<Scalars['String']['output']>;
  /** If the entity should be hidden from the index/omnisearch */
  hideFromIndex: Maybe<Scalars['Boolean']['output']>;
  /** The id of the entity public_field */
  id: Scalars['ID']['output'];
  /** Industry for company data public_field */
  industry: Maybe<Scalars['String']['output']>;
  /** public_field */
  mostRecentIdea: Maybe<Idea>;
  /** The name of the entity public_field */
  name: Maybe<Scalars['String']['output']>;
  /** Only to be used in the context of top_companies_newly_followed */
  newFollowersCount: Scalars['Int']['output'];
  /** Buyside consensus questions current user has not answered or skipped recently */
  pollQuestionsUnansweredByCurrentUser: Maybe<Array<CompanyQuestion>>;
  /** The primary asset of the entity public_field */
  primaryAsset: Maybe<Asset>;
  primaryAssetId: Maybe<Scalars['ID']['output']>;
  /** The primary symbol of the entity public_field */
  primarySymbol: Maybe<Scalars['String']['output']>;
  /** public_field */
  recentIdeas: Maybe<IdeaConnection>;
  /** public_field */
  relatedCompanies: Maybe<Array<Entity>>;
  /** Sector for company data public_field */
  sector: Maybe<Scalars['String']['output']>;
  /** The status for admins of the entity */
  status: Maybe<Scalars['String']['output']>;
  /** Company tag string for posts */
  tickerTagString: Maybe<Scalars['String']['output']>;
};


export type EntityAssetsArgs = {
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EntityCompanyNewsItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type EntityEntityQuoteDataArgs = {
  timeframe?: InputMaybe<Scalars['String']['input']>;
};


export type EntityRecentIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Entity. */
export type EntityConnection = {
  __typename?: 'EntityConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EntityEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Entity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EntityEdge = {
  __typename?: 'EntityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Entity>;
};

export type Esg = {
  __typename?: 'Esg';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Event = {
  __typename?: 'Event';
  /** Whether or not the user has liked this specific event public_field */
  currentUserHasLiked: Scalars['Boolean']['output'];
  /** The event object public_field */
  eventObject: Maybe<EventObject>;
  /** The id of the event public_field */
  id: Scalars['ID']['output'];
  /** The number of likes on the event public_field */
  likeCount: Scalars['Int']['output'];
  /** A list of names of users who have liked this content public_field */
  likesNames: Maybe<Array<Scalars['String']['output']>>;
  /** The type of event public_field */
  verb: Maybe<Scalars['String']['output']>;
};

export enum EventEnum {
  /** Represents activity related to attachments */
  attachments = 'attachments',
  /** Represents actions related to comments */
  comments = 'comments',
  /** Represents activity related to drafting and editing ideas */
  ideas = 'ideas',
  /** Represents likes on ideas and comments */
  likes = 'likes',
  /** Represents rankings of ideas */
  ranks = 'ranks',
  /** Represents updates and addendums to ideas */
  updates = 'updates',
  /** Represents idea views */
  views = 'views'
}

/** EventObject */
export type EventObject = AdminPost | AllocatorProfile | Comment | CorporateAction | EmployerProfile | EmployerProfileUpdate | FeaturedItem | Idea | IdeaUpdate | JobPosting | Post | Rank | WhitePaper;

/** Autogenerated input type of EventRegistration */
export type EventRegistrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firmName?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of EventRegistration */
export type EventRegistrationPayload = {
  __typename?: 'EventRegistrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** If the user has been registered public_field */
  registered: Scalars['Boolean']['output'];
};

export type EventType = {
  __typename?: 'EventType';
  /** The action taken */
  action: Scalars['String']['output'];
  /** What kind of event took place */
  eventType: Scalars['String']['output'];
  /** the identifier of the object for the event */
  objectLookup: Scalars['String']['output'];
  /** When the action was taken */
  timestamp: Scalars['Int']['output'];
  /** Which user took the action */
  userId: Maybe<Scalars['String']['output']>;
};

/** The connection type for EventType. */
export type EventTypeConnection = {
  __typename?: 'EventTypeConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<EventTypeEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<EventType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type EventTypeEdge = {
  __typename?: 'EventTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<EventType>;
};

export type FeaturedItem = {
  __typename?: 'FeaturedItem';
  /** The description of the feature public_field */
  feature: Scalars['String']['output'];
  /** public_field */
  featuredIdeas: Maybe<IdeaConnection>;
  /** The type of the feature public_field */
  featuredType: Scalars['String']['output'];
  /** The id of the featured item public_field */
  id: Scalars['ID']['output'];
};


export type FeaturedItemFeaturedIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type FeedItem = {
  __typename?: 'FeedItem';
  /** The creation timestamp public_field */
  createdAt: Scalars['String']['output'];
  /** The event belonging to the feed item public_field */
  event: Maybe<Event>;
  feedId: Maybe<Scalars['ID']['output']>;
  /** list of mentionables for comments */
  feedItemMentionables: Maybe<Array<Mentionable>>;
  /** identifies if the feed item is for a mentioned entity public_field */
  forMentionedEntity: Maybe<Scalars['Boolean']['output']>;
  /** The id of the feed item public_field */
  id: Scalars['ID']['output'];
};

/** The connection type for FeedItem. */
export type FeedItemConnection = {
  __typename?: 'FeedItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FeedItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FeedItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FeedItemEdge = {
  __typename?: 'FeedItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FeedItem>;
};

/** Autogenerated input type of FlagItem */
export type FlagItemInput = {
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  itemId: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};

/** Autogenerated return type of FlagItem */
export type FlagItemPayload = {
  __typename?: 'FlagItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  flagMarker: Maybe<FlagMarker>;
};

export type FlagMarker = {
  __typename?: 'FlagMarker';
  /** The category of the flag */
  flagCategory: Scalars['String']['output'];
  /** The id of the flag marker */
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of FollowItem */
export type FollowItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  /** use if you need to skip creating datafeed and audit records, i.e. for onboarding */
  skipSideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FollowItem */
export type FollowItemPayload = {
  __typename?: 'FollowItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
  message: Maybe<Scalars['String']['output']>;
  user: Maybe<User>;
};

/** Autogenerated input type of FollowMultiple */
export type FollowMultipleInput = {
  assetClassNames?: InputMaybe<Array<Scalars['String']['input']>>;
  aumRangeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundStrategyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  fundTypeNames?: InputMaybe<Array<Scalars['String']['input']>>;
  geographyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  section?: InputMaybe<Scalars['Int']['input']>;
  sectorNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of FollowMultiple */
export type FollowMultiplePayload = {
  __typename?: 'FollowMultiplePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type FundLetter = {
  __typename?: 'FundLetter';
  /** The name of the fund the letter belongs to (public_field) */
  fundName: Scalars['String']['output'];
  /** The id of the fund letter (public_field) */
  id: Scalars['ID']['output'];
  /** The name given to the fund letter (public_field) */
  name: Maybe<Scalars['String']['output']>;
  /** The link to the pdf version of the fund letter (public_field) */
  pdfLink: Scalars['String']['output'];
};

/** The connection type for FundLetter. */
export type FundLetterConnection = {
  __typename?: 'FundLetterConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FundLetterEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FundLetter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FundLetterEdge = {
  __typename?: 'FundLetterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FundLetter>;
};

export type FundLetterSource = {
  __typename?: 'FundLetterSource';
  /** the names of funds related to this letter (public_field) */
  sources: Array<Scalars['String']['output']>;
  /** The alphabetical letter the source name begins with (public_field) */
  startingCharacter: Scalars['String']['output'];
};

export type FundRecommendation = {
  __typename?: 'FundRecommendation';
  /** The allocator profile associated with the fund */
  allocatorProfile: Maybe<AllocatorProfile>;
  /** The allocator profile preference associated with the fund */
  allocatorProfilePreference: Maybe<AllocatorProfilePreference>;
  /** An array of the asset classes that matched */
  assetClassesMatching: Maybe<Array<Scalars['String']['output']>>;
  /** The employer profile associated with the fund */
  fundProfile: Maybe<EmployerProfile>;
  /** An array of the geographies that matched */
  geographiesMatching: Maybe<Array<Scalars['String']['output']>>;
  hide: Maybe<Scalars['Boolean']['output']>;
  /** The id of the fund recommendation */
  id: Scalars['ID']['output'];
  /** If the recommendation is because of asset classes */
  matchesAssetClasses: Maybe<Scalars['Boolean']['output']>;
  /** If the recommendation is because of aum range */
  matchesAumRange: Maybe<Scalars['Boolean']['output']>;
  /** If the recommendation is because of fund type */
  matchesFundType: Maybe<Scalars['Boolean']['output']>;
  /** If the recommendation is because of geography */
  matchesGeographies: Maybe<Scalars['Boolean']['output']>;
  /** If the recommendation is because of sectors */
  matchesSectors: Maybe<Scalars['Boolean']['output']>;
  /** If the recommendation is because of the fund strategy */
  matchesStrategy: Maybe<Scalars['Boolean']['output']>;
  /** An array of the sectors that matched */
  sectorsMatching: Maybe<Array<Scalars['String']['output']>>;
};

/** The connection type for FundRecommendation. */
export type FundRecommendationConnection = {
  __typename?: 'FundRecommendationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<FundRecommendationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<FundRecommendation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FundRecommendationEdge = {
  __typename?: 'FundRecommendationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<FundRecommendation>;
};

export type FundStrategy = {
  __typename?: 'FundStrategy';
  /** The id of the strategy */
  id: Scalars['ID']['output'];
  /** Name of the Fund Strategy */
  name: Scalars['String']['output'];
};

export type FundType = {
  __typename?: 'FundType';
  /** The id of the fund type */
  id: Scalars['ID']['output'];
  /** Name of the Fund Type */
  name: Scalars['String']['output'];
};

export type Fundamental = {
  __typename?: 'Fundamental';
  /** The book value per share of the factset fundamental in USD (public_field) */
  bookValue: Maybe<Scalars['Float']['output']>;
  /** The LTM/PE of the factset fundamental (public_field) */
  currentPe: Maybe<Scalars['Float']['output']>;
  /** The Debt Book of the factset fundamental (public_field) */
  debtBook: Maybe<Scalars['Float']['output']>;
  /** The Divident Yield of the factset fundamental (public_field) */
  divYield: Maybe<Scalars['Float']['output']>;
  /** The ev of the factset fundamental in USD (public_field) */
  ev: Maybe<Scalars['Int']['output']>;
  /** The EV/EBITDA of the factset fundamental (public_field) */
  evEbitda: Maybe<Scalars['Float']['output']>;
  /** The EV/FCF of the factset fundamental (public_field) */
  evFcf: Maybe<Scalars['Float']['output']>;
  /** The EV Sales of the factset fundamental (public_field) */
  evSales: Maybe<Scalars['Float']['output']>;
  /** The FCF Yield of the factset fundamental (public_field) */
  fcfYield: Maybe<Scalars['Float']['output']>;
  /** The forward PE of the factset fundamental (public_field) */
  forwardPe: Maybe<Scalars['Float']['output']>;
  /** The id of the fundamental (public_field) */
  id: Scalars['ID']['output'];
  /** The ltm revenues */
  ltmRevenue: Maybe<Scalars['Int']['output']>;
  /** The market cap of the factset fundamental in USD (public_field) */
  marketCap: Maybe<Scalars['Int']['output']>;
  /** The Price Book of the factset fundamental (public_field) */
  priceBook: Maybe<Scalars['Float']['output']>;
  /** The sellside consensus of the factset fundamental (public_field) */
  sellsideConsensus: Maybe<Scalars['Float']['output']>;
  /** the sellside consensus text public_field */
  sellsideConsensusText: Scalars['String']['output'];
  /** The three month average daily volume of the factset fundamental (public_field) */
  threeMonthAdv: Maybe<Scalars['Float']['output']>;
  /** The total cash of the factset fundamental in USD (public_field) */
  totalCash: Maybe<Scalars['Int']['output']>;
  /** The total debt of the factset fundamental in USD (public_field) */
  totalDebt: Maybe<Scalars['Int']['output']>;
};

export type Geography = {
  __typename?: 'Geography';
  /** The id of the geography */
  id: Scalars['ID']['output'];
  /** The name of the geography */
  name: Scalars['String']['output'];
};

export type GlobalMacro = {
  __typename?: 'GlobalMacro';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of GoogleReCAPTCHA */
export type GoogleReCaptchaInput = {
  /** The associated action (e.g. 'homepage') public_field */
  action: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The user's response token provided by the reCAPTCHA client-side integration public_field */
  response: Scalars['String']['input'];
};

/** Autogenerated return type of GoogleReCAPTCHA */
export type GoogleReCaptchaPayload = {
  __typename?: 'GoogleReCAPTCHAPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** public_field */
  verified: Scalars['Boolean']['output'];
};

/** Autogenerated input type of HideFundRecommendation */
export type HideFundRecommendationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fundRecommendationId: Scalars['ID']['input'];
};

/** Autogenerated return type of HideFundRecommendation */
export type HideFundRecommendationPayload = {
  __typename?: 'HideFundRecommendationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  fundRecommendation: Maybe<FundRecommendation>;
};

/** Autogenerated input type of HideIdeaRecommendation */
export type HideIdeaRecommendationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of HideIdeaRecommendation */
export type HideIdeaRecommendationPayload = {
  __typename?: 'HideIdeaRecommendationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type Idea = {
  __typename?: 'Idea';
  /** The IRR return of the idea (public_field) */
  annualizedReturn: Maybe<Scalars['Float']['output']>;
  /** (public_field) */
  anonymous: Scalars['Boolean']['output'];
  /** If the idea has been approved (public_field) */
  approved: Maybe<Scalars['Boolean']['output']>;
  /** The asset class of the idea public_field */
  assetClass: Scalars['String']['output'];
  /** The symbol of the asset the idea covers public_field */
  assetSymbol: Scalars['String']['output'];
  /** The assets associated with this idea */
  assets: AssetConnection;
  /** The associated Employer (public_field) */
  associatedEmployer: Maybe<Employer>;
  /** Attachment extensions public_field */
  attachmentExtensions: Maybe<Array<Scalars['String']['output']>>;
  /** public_field */
  authorName: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  autoclosed: Maybe<Scalars['Boolean']['output']>;
  /** Contest ideas that won awards (public_field) */
  awardWinningContestIdeas: Maybe<Array<ContestIdea>>;
  /** The names of the benchmark positions (public_field) */
  benchmarkNames: Maybe<Scalars['String']['output']>;
  /** The idea benchmark position of the idea update (public_field) */
  benchmarkUpdate: Maybe<IdeaUpdate>;
  /** If the current user can view this idea, with exception checking (public_field) */
  canCurrentUserAccess: Scalars['Boolean']['output'];
  /** The catalysts associated with the idea (public_field) */
  catalystNames: Array<Scalars['String']['output']>;
  /** If the idea is close to the target (public_field) */
  closeToTarget: Maybe<Scalars['Boolean']['output']>;
  /** If the idea is close to the timeframe where it will close (public_field) */
  closeToTimeframe: Maybe<Scalars['Boolean']['output']>;
  /** When the idea was closed (public_field) */
  closedAt: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  comments: Maybe<CommentConnection>;
  /** The number of comments public_field */
  commentsCount: Maybe<Scalars['Int']['output']>;
  /** list of mentionables (public_field) */
  commentsMentionableList: Array<Mentionable>;
  /** The average community rating of the idea */
  communityRating: Maybe<Scalars['Float']['output']>;
  /** Contests to which the idea has been submitted to */
  contestIds: Array<Scalars['ID']['output']>;
  /** The created at date of the idea (public_field) */
  createdAt: Scalars['String']['output'];
  /** Date to close in a string (public_field) */
  dateToClose: Maybe<Scalars['String']['output']>;
  /** Show direction regardless of current user access. To control access, use position#direction public_field */
  direction: Maybe<Scalars['String']['output']>;
  /** The elevator pitch of the idea public_field */
  elevatorPitch: Maybe<Scalars['String']['output']>;
  employerApprovalDisclaimer: Maybe<Scalars['Boolean']['output']>;
  /** The name of the entity associated with the idea public_field */
  entityName: Scalars['String']['output'];
  events: Maybe<EventTypeConnection>;
  /** The rating of the idea public_field */
  expectedPerformanceRating: Maybe<Rating>;
  /** The expected return of the idea (public_field) */
  expectedReturn: Maybe<Scalars['Float']['output']>;
  /** The expected return range of the idea public_field */
  expectedReturnRange: Maybe<Scalars['String']['output']>;
  /** the fs_perm_sec_id of the primary asset */
  factsetId: Maybe<Scalars['String']['output']>;
  /** If the idea has been featured on a fund profile (public_field) */
  featuredOnAFundProfile: Maybe<Scalars['Boolean']['output']>;
  followersCount: Maybe<Scalars['Int']['output']>;
  /** Whether the ideas entity has other ideas (public_field) */
  hasEntitiesHaveOtherIdeas: Maybe<Scalars['Boolean']['output']>;
  /** public_field */
  hasPendingEdit: Scalars['Boolean']['output'];
  /** The id of the idea public_field */
  id: Scalars['ID']['output'];
  /** Attachments for the idea (public_field) */
  ideaAttachments: Maybe<Array<IdeaAttachment>>;
  /** The hashed id of the idea */
  ideaId: Scalars['ID']['output'];
  /** (public_field) */
  ideaPdfLink: Maybe<Scalars['String']['output']>;
  /** Idea updates of this idea (public_field) */
  ideaUpdates: Array<IdeaUpdate>;
  /** The number of idea updates (public_field) */
  ideaUpdatesCount: Scalars['Int']['output'];
  /** Data about who has viewed the idea */
  ideaViews: Maybe<IdeaViewConnection>;
  isCurrentUserAuthor: Scalars['Boolean']['output'];
  /** If the idea author is retail (public_field) */
  isNonBuyside: Scalars['Boolean']['output'];
  /** If the idea is open to public access (public_field) */
  isOpenAccess: Scalars['Boolean']['output'];
  /** Is pair trade? (public_field) */
  isPairTrade: Maybe<Scalars['Boolean']['output']>;
  /** The latest user update of the idea or idea update (public_field) */
  lastUpdatedAt: Scalars['String']['output'];
  /**
   * (public_field)
   * @deprecated New ideas will never have this field. Use positionDisclaimerIndividual and positionDisclaimerFund
   */
  legacyPositionDisclaimer: Maybe<Scalars['Boolean']['output']>;
  /** The market cap of the idea */
  marketCap: Scalars['String']['output'];
  /** Related tickers tagged by the author (public_field) */
  mentionedEntities: Maybe<Array<Entity>>;
  /** The number of new views of the idea (public_field) */
  newViewsCount: Scalars['Int']['output'];
  noPriorAgreementDisclaimer: Maybe<Scalars['Boolean']['output']>;
  /** The opened at date of the idea (public_field) */
  openedAt: Maybe<Scalars['String']['output']>;
  /** Pair ratio (public_field) */
  pairRatio: Maybe<Array<Scalars['Float']['output']>>;
  /** The reviews of the idea (public_field) */
  paladinReviews: Maybe<Array<PaladinReview>>;
  /** For rendering PDF thesis on idea show */
  pdfThesisUrl: Maybe<Scalars['String']['output']>;
  /** Contest ideas with a pending_approval status (public_field) */
  pendingContestIdeas: Maybe<Array<ContestIdea>>;
  /** Pending intro request for the current user from the idea's associated employer (public_field) */
  pendingIntroRequest: Maybe<IntroRequest>;
  /** The percentile of the idea (public_field) */
  percentile: Maybe<Scalars['Float']['output']>;
  /** The number of times a phase shows up in the thesis or elevator pitch (public_field) */
  phraseCount: Maybe<Scalars['Int']['output']>;
  /** (public_field) */
  positionDisclaimerFund: Maybe<Scalars['Boolean']['output']>;
  /** (public_field) */
  positionDisclaimerIndividual: Maybe<Scalars['Boolean']['output']>;
  /** The non-benchmark positions of the idea public_field */
  positions: Array<Position>;
  /** If the return is positive public_field */
  positiveReturn: Maybe<Scalars['Boolean']['output']>;
  /** The opened at date of the idea in time ago (public_field) */
  postedAt: Maybe<Scalars['String']['output']>;
  /** The creation date of the idea in time ago obscured public_field */
  postedAtObscured: Maybe<Scalars['String']['output']>;
  /** The assets that belong to the ideas non benchmark positions */
  primaryAssets: Array<Asset>;
  primaryEntityId: Maybe<Scalars['String']['output']>;
  publicInformationDisclaimer: Maybe<Scalars['Boolean']['output']>;
  /** public_field */
  relatedIdeas: Array<Idea>;
  /** Posts by the idea author, whose linked entities include the idea's ticker (public_field) */
  relatedPosts: Maybe<Array<Post>>;
  /** Return target (public_field) */
  returnTarget: Maybe<Scalars['Float']['output']>;
  /** The return vs benchmark of the idea (public_field) */
  returnVsBenchmark: Maybe<Scalars['Float']['output']>;
  sector: Maybe<Scalars['String']['output']>;
  /** The situation of the idea public_field */
  situation: Maybe<Scalars['String']['output']>;
  /** The status of the idea (public_field) */
  status: Maybe<Scalars['String']['output']>;
  /** Keyword tags (public_field) */
  tagList: Array<Scalars['String']['output']>;
  /** The amount the person has in their porfolio (public_field) */
  targetAllocation: Maybe<Scalars['String']['output']>;
  /** The thesis of the idea (public_field) */
  thesis: Maybe<Scalars['String']['output']>;
  /** Word Count of Thesis */
  thesisWordCount: Scalars['Int']['output'];
  /** The thirty day trailing return */
  thirtyDayReturnChange: Maybe<Scalars['Float']['output']>;
  tier: Maybe<Scalars['String']['output']>;
  /** The timeframe of the idea, public_field */
  timeframe: Maybe<Scalars['String']['output']>;
  /** The total return of the idea (public_field) */
  totalReturn: Maybe<Scalars['Float']['output']>;
  /** The expected return of the idea public_field */
  totalReturnRange: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['String']['output'];
  /** public_field */
  user: Maybe<User>;
  /** The latest update by the user of the idea */
  userUpdatedAt: Scalars['String']['output'];
  /** The number of views an idea has received within a specific timeframe */
  viewsSinceDate: Maybe<Scalars['Int']['output']>;
  /** If the idea was a weekly top idea (public_field) */
  weeklyTopIdea: Scalars['Boolean']['output'];
  /** (public_field) */
  youtubeIds: Maybe<Array<Scalars['String']['output']>>;
};


export type IdeaAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaCanCurrentUserAccessArgs = {
  permission: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};


export type IdeaCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaIdeaViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaSituationArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
  showPage?: InputMaybe<Scalars['Boolean']['input']>;
};


export type IdeaTimeframeArgs = {
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdeaAttachment = {
  __typename?: 'IdeaAttachment';
  /** The type of the attachment (public_field) */
  attachmentType: Maybe<Scalars['String']['output']>;
  /** The created at of the attachment (public_field) */
  createdAt: Scalars['String']['output'];
  /** The description of the attachment (public_field) */
  description: Maybe<Scalars['String']['output']>;
  /** The file type of the attachment (public_field) */
  fileType: Maybe<Scalars['String']['output']>;
  /** The file name of the attachment (public_field) */
  filename: Maybe<Scalars['String']['output']>;
  /** If the attachment was from an update (public_field) */
  fromUpdate: Maybe<Scalars['Boolean']['output']>;
  /** The id of the attachment (public_field) */
  id: Scalars['ID']['output'];
  /** The research type of the attachment (public_field) */
  researchType: Scalars['String']['output'];
  /** (public_field) */
  url: Maybe<Scalars['String']['output']>;
};

/** The connection type for IdeaAttachment. */
export type IdeaAttachmentConnection = {
  __typename?: 'IdeaAttachmentConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<IdeaAttachmentEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<IdeaAttachment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IdeaAttachmentEdge = {
  __typename?: 'IdeaAttachmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IdeaAttachment>;
};

/** The connection type for Idea. */
export type IdeaConnection = {
  __typename?: 'IdeaConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<IdeaEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Idea>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IdeaEdge = {
  __typename?: 'IdeaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Idea>;
};

export type IdeaRecommendation = {
  __typename?: 'IdeaRecommendation';
  /** The recommendation_id of the idea recommendation, from the recommendation microservice */
  id: Scalars['ID']['output'];
  /** The idea associated with the recommendation */
  idea: Maybe<Idea>;
  /** The user_id of the recommendation */
  userId: Scalars['ID']['output'];
};

export type IdeaSearchAlert = {
  __typename?: 'IdeaSearchAlert';
  /** If the search alert is active */
  active: Maybe<Scalars['Boolean']['output']>;
  /** If the search alert is displaying */
  display: Maybe<Scalars['Boolean']['output']>;
  /** the email schedule */
  frequency: Maybe<Scalars['String']['output']>;
  /** The id of the search alert public_field */
  id: Scalars['ID']['output'];
  /** The idea saved search associated with this alert public_field */
  ideaSavedSearch: Maybe<SavedSearch>;
  /** The name of the saved search public_field */
  name: Maybe<Scalars['String']['output']>;
};

/** The connection type for IdeaSearchAlert. */
export type IdeaSearchAlertConnection = {
  __typename?: 'IdeaSearchAlertConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<IdeaSearchAlertEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<IdeaSearchAlert>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IdeaSearchAlertEdge = {
  __typename?: 'IdeaSearchAlertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IdeaSearchAlert>;
};

export type IdeaUpdate = {
  __typename?: 'IdeaUpdate';
  /** The added catalyst names (public_field) */
  addedCatalystNames: Maybe<Array<Scalars['String']['output']>>;
  /** The html body of the idea update (public_field) */
  body: Maybe<Scalars['String']['output']>;
  /** The catalyst names of the update (public_field) */
  catalystNames: Array<Scalars['String']['output']>;
  /** The hash of differences between the original idea and the update public_field */
  changesHash: Scalars['Json']['output'];
  /** Whether the idea is closed or not public_field */
  closed: Scalars['Boolean']['output'];
  /** The list of mentionable users in comments */
  commentMentionables: Maybe<Array<Mentionable>>;
  /** The idea update's comments */
  comments: Maybe<CommentConnection>;
  /** The idea update's number of comments (public_field) */
  commentsCount: Maybe<Scalars['Int']['output']>;
  /** The created at date of the idea update (public_field) */
  createdAt: Scalars['String']['output'];
  /** public_field */
  hasAttachments: Maybe<Scalars['Boolean']['output']>;
  /** If there is a body for the update public_field */
  hasBody: Maybe<Scalars['Boolean']['output']>;
  /** The id of the idea update public_field */
  id: Scalars['ID']['output'];
  /** public_field */
  idea: Maybe<Idea>;
  /** public_field */
  ideaAttachments: Maybe<IdeaAttachmentConnection>;
  /** (public_field) */
  ideaAttachmentsArray: Maybe<Array<IdeaAttachment>>;
  /** The impact of the idea public_field */
  impact: Maybe<Scalars['String']['output']>;
  /** The humanized created at date of the idea update public_field */
  postedAt: Scalars['String']['output'];
  /** The price target of the update (public_field) */
  priceTarget: Maybe<Scalars['Float']['output']>;
  /** The removed catalyst names (public_field) */
  removedCatalystNames: Maybe<Array<Scalars['String']['output']>>;
  /** The removed price target of the update, denotes an update (public_field) */
  removedPriceTarget: Maybe<Scalars['Float']['output']>;
  /** The removed return target of the update, denotes an update (public_field) */
  removedReturnTarget: Maybe<Scalars['Float']['output']>;
  /** The removed situation of the idea update, denotes an update (public_field) */
  removedSituation: Maybe<Scalars['String']['output']>;
  /** The removed target allocation for the current update, denotes an update (public_field) */
  removedTargetAllocation: Maybe<Scalars['String']['output']>;
  /** The removed timeframe of the update, denotes an update (public_field) */
  removedTimeframe: Maybe<Scalars['String']['output']>;
  /** The return target of the update (public_field) */
  returnTarget: Maybe<Scalars['Float']['output']>;
  /** The situation of the idea update (public_field) */
  situation: Maybe<Scalars['String']['output']>;
  /** The target allocation for the current update (public_field) */
  targetAllocation: Maybe<Scalars['String']['output']>;
  /** The body of the idea update public_field */
  text: Maybe<Scalars['String']['output']>;
  /** The timeframe of the update (public_field) */
  timeframe: Maybe<Scalars['String']['output']>;
  /** Whether or not an idea update's body property should be truncated (public_field) */
  truncated: Scalars['Boolean']['output'];
  /** public_field */
  user: Maybe<User>;
  /** YouTube video ids (public_field) */
  youtubeIds: Maybe<Array<Scalars['String']['output']>>;
};


export type IdeaUpdateCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type IdeaUpdateIdeaAttachmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for IdeaUpdate. */
export type IdeaUpdateConnection = {
  __typename?: 'IdeaUpdateConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<IdeaUpdateEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<IdeaUpdate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IdeaUpdateEdge = {
  __typename?: 'IdeaUpdateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IdeaUpdate>;
};

export type IdeaView = {
  __typename?: 'IdeaView';
  /** The actions performed by the viewer, if empty, it only represents a page view with no additional actions taken */
  actions: Array<Scalars['String']['output']>;
  /** The ID of the IdeaView */
  id: Scalars['ID']['output'];
  /** The asset symbol of the idea */
  ideaAssetSymbol: Maybe<Scalars['String']['output']>;
  /** The id of the viewed idea */
  ideaId: Scalars['ID']['output'];
  /** The time ago of the idea view in words */
  timeAgo: Scalars['String']['output'];
  /** The timestamp of the idea view */
  timestamp: Scalars['String']['output'];
  /** The viewer */
  viewer: User;
  /** The AUM range of the viewer */
  viewerAumRange: Maybe<Scalars['String']['output']>;
  /** The city name of the viewer */
  viewerCityName: Maybe<Scalars['String']['output']>;
  /** The fund type of the viewer */
  viewerFundType: Maybe<Scalars['String']['output']>;
  /** The viewer intro request associated with this idea view */
  viewerIntroRequest: Maybe<ViewerIntroRequest>;
  /** The title of the viewer */
  viewerTitle: Maybe<Scalars['String']['output']>;
};

/** The connection type for IdeaView. */
export type IdeaViewConnection = {
  __typename?: 'IdeaViewConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<IdeaViewEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<IdeaView>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type IdeaViewEdge = {
  __typename?: 'IdeaViewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<IdeaView>;
};

export type InsiderTrade = {
  __typename?: 'InsiderTrade';
  /** Disclosure date of the trade (e.g., '05 Mar 2024') */
  date: Scalars['String']['output'];
  /** ID of SumZero entity of the asset whose bloomberg_symbol match the 'symbol' in SixAI feed */
  entityId: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Name of the corporate insider who made the trade */
  name: Scalars['String']['output'];
  /** Number of shares traded */
  numShares: Scalars['Int']['output'];
  /** Positive or negative percentage change in the insider's ownership of the security */
  ownershipChangePct: Maybe<Scalars['String']['output']>;
  /** Price at which the trade was excuted */
  sharePrice: Scalars['String']['output'];
  /** Identifier of the security traded (SixAI-sourced) */
  symbol: Scalars['String']['output'];
  /** Job title of the corporate insider who made the trade */
  title: Scalars['String']['output'];
  /** 'Purchase' or 'Sale' */
  tradeType: Scalars['String']['output'];
};

export type IntroRequest = {
  __typename?: 'IntroRequest';
  /** The employer name for the intro request (public_field) */
  employerName: Scalars['String']['output'];
  /** The employer profle for the intro request */
  employerProfile: Maybe<EmployerProfile>;
  /** The ID of the intro request (public_field) */
  id: Scalars['ID']['output'];
  /** The message thread ID (public_field) */
  messageThread: Maybe<Scalars['ID']['output']>;
  /** The status of the intro request (public_field) */
  status: Scalars['String']['output'];
};

/** Autogenerated input type of InviteNewMembersMutation */
export type InviteNewMembersMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emails: Scalars['String']['input'];
  personalMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of InviteNewMembersMutation */
export type InviteNewMembersMutationPayload = {
  __typename?: 'InviteNewMembersMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amount: Scalars['String']['output'];
  description: Scalars['String']['output'];
  paidDate: YearMonthDay;
  status: InvoiceStatusType;
};

/** Possible statuses for an invoice charge */
export enum InvoiceStatusType {
  failed = 'failed',
  pending = 'pending',
  successful = 'successful'
}

export type JobApplication = {
  __typename?: 'JobApplication';
  /** The cover note of the application */
  coverNote: Maybe<Scalars['String']['output']>;
  /** The created date of the job application */
  createdAt: Scalars['String']['output'];
  /** The email of the application */
  email: Maybe<Scalars['String']['output']>;
  /** The id of the job application */
  id: Scalars['ID']['output'];
  /** The related job posting */
  jobPosting: JobPosting;
  /** The name of the applicant */
  name: Maybe<Scalars['String']['output']>;
  otherApplications: Maybe<Array<JobApplication>>;
  /** The phone number of the application */
  phone: Maybe<Scalars['String']['output']>;
  /** The applicant's profile */
  profile: Maybe<Profile>;
  /** The applicant's resume url */
  resumeUrl: Maybe<Scalars['String']['output']>;
  /** Whether the employer has starred the application */
  starred: Maybe<Scalars['Boolean']['output']>;
  /** The current status of the job application */
  status: Scalars['String']['output'];
  /** The applicant */
  user: Maybe<User>;
  /** The id of the applicant */
  userId: Scalars['ID']['output'];
};

export type JobPosting = {
  __typename?: 'JobPosting';
  /** The minimum ACT required for the job posting */
  actScore: Maybe<Scalars['Int']['output']>;
  /** The number of applications for this job posting */
  applicationCount: Maybe<Scalars['Int']['output']>;
  /** An array of applications (sorted by created_at descending) for the job posting */
  applications: Maybe<Array<JobApplication>>;
  /** A collection of asset class names for the job posting */
  assets: Maybe<Array<Scalars['String']['output']>>;
  /** The city name public_field */
  city: Maybe<Scalars['String']['output']>;
  /** If the cover letter is required */
  coverLetter: Maybe<Scalars['String']['output']>;
  /** A collection of education required for the job posting */
  degreesAndCertifications: Maybe<Array<Scalars['String']['output']>>;
  /** The description of the job posting public_field */
  description: Maybe<Scalars['String']['output']>;
  /** A collection of reasons why the current user cannot apply to the Job Post */
  disqualifiedReasons: Maybe<Array<Scalars['String']['output']>>;
  /** The employer of the job posting public_field */
  employer: Maybe<Employer>;
  /** A collection of firm experience required for the job posting */
  firmExperience: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the job posting public_field */
  id: Scalars['ID']['output'];
  /** If the job posting is active */
  isActive: Maybe<Scalars['Boolean']['output']>;
  /** The maximum GPA required for the job posting */
  maximumGpa: Maybe<Scalars['String']['output']>;
  /** The maximum SAT required for the job posting */
  maximumSat: Maybe<Scalars['String']['output']>;
  /** The minimum GPA required for the job posting */
  minimumGpa: Maybe<Scalars['String']['output']>;
  /** The minimum SAT required for the job posting */
  minimumSat: Maybe<Scalars['String']['output']>;
  /** The posted date of the job posting (public_field) */
  postedAt: Maybe<Scalars['String']['output']>;
  /** A collection of region names for the job posting */
  regions: Maybe<Array<Scalars['String']['output']>>;
  /** A string listing of the sector names for the job posting public_field */
  sectors: Maybe<Scalars['String']['output']>;
  /** The current status of the job posting */
  status: Maybe<Scalars['String']['output']>;
  /** The title of the job posting public_field */
  title: Scalars['String']['output'];
  /** The last updated date of the job posting public_field */
  updatedAt: Maybe<Scalars['String']['output']>;
  /** Use the company investment mandate for the job posting */
  useCompanyInvestmentMandate: Maybe<Scalars['Boolean']['output']>;
  /** The id of the job poster */
  userId: Maybe<Scalars['ID']['output']>;
  /** The years of experience required for the job posting */
  yearsOfExperience: Maybe<Scalars['String']['output']>;
};


export type JobPostingPostedAtArgs = {
  isTimeAgo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for JobPosting. */
export type JobPostingConnection = {
  __typename?: 'JobPostingConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<JobPostingEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<JobPosting>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type JobPostingEdge = {
  __typename?: 'JobPostingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<JobPosting>;
};

/** Autogenerated input type of LikeComment */
export type LikeCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of LikeComment */
export type LikeCommentPayload = {
  __typename?: 'LikeCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  comment: Maybe<Comment>;
};

/** Autogenerated input type of LikeEvent */
export type LikeEventInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['ID']['input'];
};

/** Autogenerated return type of LikeEvent */
export type LikeEventPayload = {
  __typename?: 'LikeEventPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  event: Maybe<Event>;
};

/** Autogenerated input type of MakeCheckoutSessionUpdatePaymentMethod */
export type MakeCheckoutSessionUpdatePaymentMethodInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MakeCheckoutSessionUpdatePaymentMethod */
export type MakeCheckoutSessionUpdatePaymentMethodPayload = {
  __typename?: 'MakeCheckoutSessionUpdatePaymentMethodPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  sessionId: Scalars['String']['output'];
};

/** Autogenerated input type of MakeStripeCheckout */
export type MakeStripeCheckoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** URL that the user will be redirected to if they cancel public_field */
  currentUrl: Scalars['String']['input'];
  /** User's contact email public_field */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The Plan that the checkout page will be made for public_field */
  plan: Scalars['String']['input'];
};

/** Autogenerated return type of MakeStripeCheckout */
export type MakeStripeCheckoutPayload = {
  __typename?: 'MakeStripeCheckoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** Id of the user's session public_field */
  sessionId: Scalars['String']['output'];
};

/** Autogenerated input type of MarkChatRead */
export type MarkChatReadInput = {
  chatId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of MarkChatRead */
export type MarkChatReadPayload = {
  __typename?: 'MarkChatReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkJobApplicationViewed */
export type MarkJobApplicationViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** job application id */
  jobApplicationId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkJobApplicationViewed */
export type MarkJobApplicationViewedPayload = {
  __typename?: 'MarkJobApplicationViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  jobApplication: Maybe<JobApplication>;
};

/** Autogenerated input type of MarkMessageAsRead */
export type MarkMessageAsReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkMessageAsRead */
export type MarkMessageAsReadPayload = {
  __typename?: 'MarkMessageAsReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  updatedMessage: Maybe<Message>;
};

/** Autogenerated input type of MassFollowEntities */
export type MassFollowEntitiesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityIds: Array<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
};

/** Autogenerated return type of MassFollowEntities */
export type MassFollowEntitiesPayload = {
  __typename?: 'MassFollowEntitiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type MassImport = {
  __typename?: 'MassImport';
  /** The filename of the mass import */
  fileName: Scalars['String']['output'];
  /** The id of the MassImport */
  id: Scalars['ID']['output'];
  /** The number of tickers associated with this file */
  numberOfTickers: Scalars['Int']['output'];
};

export type MassTickerSearch = {
  __typename?: 'MassTickerSearch';
  foundEntities: Array<Entity>;
  unfoundSymbols: Array<Scalars['String']['output']>;
};

export type Media = PodcastEpisode | Video;

/** The connection type for Media. */
export type MediaConnection = {
  __typename?: 'MediaConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MediaEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Media>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MediaEdge = {
  __typename?: 'MediaEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Media>;
};

export type Mentionable = {
  __typename?: 'Mentionable';
  /** public_field */
  display: Scalars['String']['output'];
  /** public_field */
  id: Scalars['String']['output'];
};

/** Autogenerated input type of MergeEntities */
export type MergeEntitiesInput = {
  /** Assets related to the entity that need merging */
  assetsToMerge: Array<AssetsToMergeAttributes>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Entity id to merge into */
  destinationId: Scalars['ID']['input'];
  /** Entity id to delete and merge */
  toMergeId: Scalars['ID']['input'];
};

/** Autogenerated return type of MergeEntities */
export type MergeEntitiesPayload = {
  __typename?: 'MergeEntitiesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  entity: Maybe<Entity>;
};

export type Message = {
  __typename?: 'Message';
  /** Boolean on whether the current_user has archived this message */
  archiveStatus: Maybe<Scalars['Boolean']['output']>;
  /** The body of the message */
  body: Maybe<Scalars['String']['output']>;
  /** The created at name */
  createdAt: Maybe<Scalars['String']['output']>;
  /** The ID of the message */
  id: Scalars['ID']['output'];
  /** An associated intro request */
  introRequest: Maybe<IntroRequest>;
  /** Calculates if a message is cap intro */
  isCapIntroMessage: Maybe<Scalars['Boolean']['output']>;
  /** Job posting associated with message */
  jobPosting: Maybe<JobPosting>;
  /** Attachments uploaded for this message */
  messageAttachments: Maybe<Array<AttachmentType>>;
  /** The other user involved in this message thread that is not the current user */
  otherParty: Maybe<User>;
  /** Boolean on whether the current_user has or hasn't read the message */
  readStatus: Maybe<Scalars['Boolean']['output']>;
  /** The receiver status of the message */
  receiverStatus: Maybe<Scalars['String']['output']>;
  reciever: Maybe<User>;
  /** The subject of the message */
  rootMessage: Maybe<Message>;
  sender: Maybe<User>;
  /** The sender of this message is the currently logged in user */
  senderIsCurrentUser: Maybe<Scalars['Boolean']['output']>;
  /** The sender status of the message */
  senderStatus: Maybe<Scalars['String']['output']>;
  /** The subject of the message */
  subject: Maybe<Scalars['String']['output']>;
  /** The thread of the message */
  thread: Maybe<Scalars['ID']['output']>;
  /** The number of messages in this thread */
  threadCount: Maybe<Scalars['Int']['output']>;
};

/** The connection type for Message. */
export type MessageConnection = {
  __typename?: 'MessageConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<MessageEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Message>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MessageEdge = {
  __typename?: 'MessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Message>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Accept Fund Disclaimer */
  acceptFundDisclaimer: Maybe<AcceptFundDisclaimerPayload>;
  /** archive messages in thread */
  archiveThread: Maybe<ArchiveThreadPayload>;
  associateViewerIntroRequestMessage: Maybe<AssociateViewerIntroRequestMessagePayload>;
  /** Records clicks of recommended ideas */
  clickIdeaRecommendation: Maybe<ClickIdeaRecommendationPayload>;
  /** Clicked notifications */
  clickedNotifications: Maybe<ClickedNotificationsPayload>;
  /** Close Job Post */
  closeJobPost: Maybe<CloseUserJobPostPayload>;
  /** Close a quick position */
  closeQuickPosition: Maybe<CloseQuickPositionPayload>;
  /** Create a new ad lead */
  createAdLead: Maybe<CreateAdLeadPayload>;
  /** Create blocklist entry */
  createAllocatorBlocklistEntry: Maybe<CreateAllocatorBlocklistEntryPayload>;
  /** Create an Api Key for the datafeed */
  createApiKey: Maybe<ApiKeyPayload>;
  /** Create a new audit record */
  createAuditRecord: Maybe<CreateAuditRecordPayload>;
  /** Create a new chat message */
  createChatMessage: Maybe<CreateChatMessagePayload>;
  /** Create Comment */
  createComment: Maybe<CreateCommentPayload>;
  /** Create Fund Profile Search Alert */
  createEmployerProfileSearchAlert: Maybe<CreateFundProfileSearchAlertPayload>;
  /** Create Event Impression */
  createEventImpression: Maybe<CreateEventImpressionPayload>;
  /** Registering for an event public_field */
  createEventRegistration: Maybe<EventRegistrationPayload>;
  createFundProfile: Maybe<CreateFundProfilePayload>;
  /** Create a Fund Profile Message */
  createFundProfileMessage: Maybe<CreateFundProfileMessagePayload>;
  /** Create Idea Saved Search Alert */
  createIdeaSearchAlert: Maybe<CreateIdeaSearchAlertPayload>;
  /** Create an Intro Request */
  createIntroRequest: Maybe<CreateIntroRequestPayload>;
  /** Submit job application */
  createJobApplication: Maybe<CreateJobApplicationPayload>;
  /** Create a job posting */
  createJobPosting: Maybe<CreateJobPostingPayload>;
  /** Prospect info collected on basket report page public_field */
  createLead: Maybe<CreateLeadPayload>;
  /** Create a Message */
  createMessage: Maybe<CreateMessagePayload>;
  /** Creates a Message for a specified thread */
  createMessageForThread: Maybe<CreateMessageForThreadPayload>;
  /** Create New Member Invitation */
  createNewMemberInvitation: Maybe<InviteNewMembersMutationPayload>;
  /** Create or edit an idea update */
  createOrEditIdeaUpdate: Maybe<CreateOrEditIdeaUpdatePayload>;
  /** Create or update a user's accredited investor profile */
  createOrUpdateAccreditedInvestorProfile: Maybe<CreateOrUpdateAccreditedInvestorProfilePayload>;
  /** [Admin Tool] Create or update company question */
  createOrUpdateCompanyQuestion: Maybe<CreateOrUpdateCompanyQuestionPayload>;
  /** Create or update compensation drafts */
  createOrUpdateCompensation: Maybe<CreateOrUpdateCompensationPayload>;
  createOrUpdateIdea: Maybe<CreateOrUpdateIdeaPayload>;
  /** Create or Update Reading List Item */
  createOrUpdateReadingListItem: Maybe<CreateUpdateReadingListItemPayload>;
  /** Create or update a potential user's application public_field */
  createOrUpdateUserApplication: Maybe<UserApplicationPayload>;
  createOrUpdateWhitePaper: Maybe<CreateOrUpdateWhitePaperPayload>;
  /** Create Post */
  createPost: Maybe<CreatePostPayload>;
  /** Create a quick position */
  createQuickPosition: Maybe<CreateQuickPositionPayload>;
  /** Upload new images in thesis */
  createThesisImage: Maybe<CreateThesisImagePayload>;
  /** Create a new tweet for an account authorized on Twitter */
  createTweet: Maybe<CreateTweetPayload>;
  /** Create a users feedback based off a received prompt */
  createUserFeedback: Maybe<CreateUserFeedbackPayload>;
  createViewerIntroRequest: Maybe<CreateViewerIntroRequestPayload>;
  /** Delete Fund Search Alert */
  deleteFundSearchAlert: Maybe<DeleteFundSearchAlertPayload>;
  /** Delete Idea Search Alert */
  deleteIdeaSearchAlert: Maybe<DeleteIdeaSearchAlertPayload>;
  /** destroy blocklist entry */
  destroyAllocatorBlocklistEntry: Maybe<DestroyAllocatorBlocklistEntryPayload>;
  /** [Admin tool] Mark company question deleted */
  destroyCompanyQuestion: Maybe<DestroyCompanyQuestionPayload>;
  /** Delete actual compensation draft and estimated draft for the subsequent year (if any) */
  destroyCompensation: Maybe<DestroyCompensationPayload>;
  /** Destroy idea draft */
  destroyIdeaDraft: Maybe<DestroyIdeaDraftPayload>;
  /** Delete Post */
  destroyPost: Maybe<DeletePostPayload>;
  /** Destroy white paper draft */
  destroyWhitePaperDraft: Maybe<DestroyWhitePaperDraftPayload>;
  /** Flag as inappropriate */
  flagItem: Maybe<FlagItemPayload>;
  /** Follow multiple sectors/asset clasess etc., will pass several fields with names in arrays to update all at once */
  followMultiple: Maybe<FollowMultiplePayload>;
  /** Follow Object */
  followObject: Maybe<FollowItemPayload>;
  /** v3 Invisible public_field */
  googleReCAPTCHA: Maybe<GoogleReCaptchaPayload>;
  /** Removes and deactivates fund recommendation, then sends back a new fund recommendation */
  hideFundRecommendation: Maybe<HideFundRecommendationPayload>;
  /** Removes the idea recommendation, then sends back a new recommendation */
  hideIdeaRecommendation: Maybe<HideIdeaRecommendationPayload>;
  /** Like Comment */
  likeComment: Maybe<LikeCommentPayload>;
  /** Like Event */
  likeEvent: Maybe<LikeEventPayload>;
  /** create a checkout session to allow a user to update their credit card */
  makeCheckoutSessionUpdatePaymentMethod: Maybe<MakeCheckoutSessionUpdatePaymentMethodPayload>;
  /** Make a dedicated stripe checkout page public_field */
  makeStripeCheckout: Maybe<MakeStripeCheckoutPayload>;
  /** Marks the last time a user viewed a chat */
  markChatRead: Maybe<MarkChatReadPayload>;
  /** Set status of job application to viewed */
  markJobApplicationViewed: Maybe<MarkJobApplicationViewedPayload>;
  /** marks a Message as read */
  markMessageAsRead: Maybe<MarkMessageAsReadPayload>;
  /** Follows multiple tickers (Entities), with mass ticker uploader */
  massFollowEntities: Maybe<MassFollowEntitiesPayload>;
  /** This takes two entities, to_merge and destination, and deletes the to_merge and combines it with the destination. Admin only */
  mergeEntities: Maybe<MergeEntitiesPayload>;
  /** Publish Fund Profile */
  publishFundProfile: Maybe<PublishFundProfilePayload>;
  /** Rate the idea and return the updated user rating */
  rateIdea: Maybe<RateIdeaPayload>;
  /** Removes a mass import and all of the entity watchlist item associated with it */
  removeMassImport: Maybe<RemoveMassImportPayload>;
  /** Request an idea update from the author */
  requestIdeaUpdate: Maybe<RequestIdeaUpdatePayload>;
  requestResearchAccess: Maybe<RequestResearchAccessMutationPayload>;
  /** Recreate Deleted Fund Search Alert */
  restoreFundSearchAlert: Maybe<RestoreUserFundSearchAlertPayload>;
  /** Recreate Deleted Idea Search Alert */
  restoreIdeaSearchAlert: Maybe<RestoreUserIdeaSearchAlertPayload>;
  /** Create or edit username for anonymous author display */
  setUsername: Maybe<SetUsernamePayload>;
  /** Spend idea token on idea */
  spendIdeaToken: Maybe<PurchaseIdeaPayload>;
  /** Star/Bookmark job application */
  starJobApplication: Maybe<StarJobApplicationPayload>;
  /** Answer company question */
  submitCompanyQuestionResponse: Maybe<SubmitCompanyQuestionResponsePayload>;
  /** Suggest Tag */
  suggestTag: Maybe<SuggestTagPayload>;
  toggleFundProfileAdmin: Maybe<ToggleFundProfileAdminPayload>;
  /** Toggles hidden status of the mutation */
  toggleHideNotification: Maybe<ToggleHideNotificationPayload>;
  /** unarchive messages in thread */
  unarchiveThread: Maybe<UnarchiveThreadPayload>;
  /** Unfollow Object */
  unfollowObject: Maybe<UnfollowItemPayload>;
  /** Mark Notification as Unviewed */
  unviewNotification: Maybe<UnviewNotificationPayload>;
  /** Update Allocator Profile */
  updateAllocatorProfile: Maybe<UpdateAllocatorProfilePayload>;
  /** Update Allocator Profile Background Image */
  updateAllocatorProfileBackgroundImage: Maybe<UpdateAllocatorProfileBackgroundImagePayload>;
  updateApiKey: Maybe<ChangeKeyStatusPayload>;
  /** Update Badge Visibility */
  updateBadgeVisibility: Maybe<UpdateUserBadgeVisibilityPayload>;
  /** Update number of times a link was clicked */
  updateClickCount: Maybe<UpdateClickCountPayload>;
  /** Updates The last_viewed_messages_at column of the current user to the current time */
  updateCurrentUserLastViewedMessagesAt: Maybe<UpdateCurrentUserLastViewedMessagesAtPayload>;
  /** Update Email */
  updateEmail: Maybe<UpdateUserEmailPayload>;
  /** Update Email Preferences */
  updateEmailPreferences: Maybe<UpdateUserEmailPreferencesPayload>;
  /** Update the entity via sumzero admin */
  updateEntityAdmin: Maybe<UpdateEntityAdminPayload>;
  /** Update Fund Profile */
  updateFundProfile: Maybe<UpdateFundProfilePayload>;
  /** Update Fund Profile Background Image */
  updateFundProfileBackgroundImage: Maybe<UpdateFundProfileBackgroundImagePayload>;
  /** Update Fund Profile Section Visibility */
  updateFundProfileSectionVisibility: Maybe<UpdateFundProfileSectionVisibilityPayload>;
  /** Update Fund Search Alert */
  updateFundSearchAlert: Maybe<UpdateUserFundSearchAlertPayload>;
  /** Update Idea Search Alert */
  updateIdeaSearchAlert: Maybe<UpdateUserIdeaSearchAlertPayload>;
  /** Update when an idea's views were last viewed */
  updateIdeaViewsLastViewed: Maybe<UpdateIdeaViewsLastViewedPayload>;
  /** Update the status of an Intro Request */
  updateIntroRequest: Maybe<UpdateIntroRequestStatusPayload>;
  /** Request interview or reject */
  updateJobAppStatus: Maybe<UpdateJobAppStatusPayload>;
  /** Update paladin review or create a new paladin review as an admin */
  updatePaladinReview: Maybe<UpdatePaladinReviewPayload>;
  /** Update Password */
  updatePassword: Maybe<UpdateUserPasswordPayload>;
  /** Cancel subscription at the end of the current billing period or reactivate it */
  updateSubscription: Maybe<UpdateSubscriptionPayload>;
  /** Update user notification settings */
  updateUserNotificationSettings: Maybe<UpdateNotificationSettingsPayload>;
  /** Update User Profile */
  updateUserProfile: Maybe<UpdateUserProfilePayload>;
  /** Update User Profile Background Image */
  updateUserProfileBackgroundImage: Maybe<UpdateUserProfileBackgroundImagePayload>;
  /** Accept/Reject the viewer intro request */
  updateViewerIntroRequest: Maybe<UpdateViewerIntroRequestPayload>;
  /** Mark all Notifications as Viewed */
  viewAllNotifications: Maybe<ViewAllNotificationsPayload>;
  /** Records the shown idea recommendation as viewed */
  viewIdeaRecommendation: Maybe<ViewIdeaRecommendationPayload>;
  /** Mark Notification as Viewed */
  viewNotification: Maybe<ViewNotificationPayload>;
};


export type MutationAcceptFundDisclaimerArgs = {
  input: AcceptFundDisclaimerInput;
};


export type MutationArchiveThreadArgs = {
  input: ArchiveThreadInput;
};


export type MutationAssociateViewerIntroRequestMessageArgs = {
  input: AssociateViewerIntroRequestMessageInput;
};


export type MutationClickIdeaRecommendationArgs = {
  input: ClickIdeaRecommendationInput;
};


export type MutationClickedNotificationsArgs = {
  input: ClickedNotificationsInput;
};


export type MutationCloseJobPostArgs = {
  input: CloseUserJobPostInput;
};


export type MutationCloseQuickPositionArgs = {
  input: CloseQuickPositionInput;
};


export type MutationCreateAdLeadArgs = {
  input: CreateAdLeadInput;
};


export type MutationCreateAllocatorBlocklistEntryArgs = {
  input: CreateAllocatorBlocklistEntryInput;
};


export type MutationCreateApiKeyArgs = {
  input: ApiKeyInput;
};


export type MutationCreateAuditRecordArgs = {
  input: CreateAuditRecordInput;
};


export type MutationCreateChatMessageArgs = {
  input: CreateChatMessageInput;
};


export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type MutationCreateEmployerProfileSearchAlertArgs = {
  input: CreateFundProfileSearchAlertInput;
};


export type MutationCreateEventImpressionArgs = {
  input: CreateEventImpressionInput;
};


export type MutationCreateEventRegistrationArgs = {
  input: EventRegistrationInput;
};


export type MutationCreateFundProfileArgs = {
  input: CreateFundProfileInput;
};


export type MutationCreateFundProfileMessageArgs = {
  input: CreateFundProfileMessageInput;
};


export type MutationCreateIdeaSearchAlertArgs = {
  input: CreateIdeaSearchAlertInput;
};


export type MutationCreateIntroRequestArgs = {
  input: CreateIntroRequestInput;
};


export type MutationCreateJobApplicationArgs = {
  input: CreateJobApplicationInput;
};


export type MutationCreateJobPostingArgs = {
  input: CreateJobPostingInput;
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationCreateMessageArgs = {
  input: CreateMessageInput;
};


export type MutationCreateMessageForThreadArgs = {
  input: CreateMessageForThreadInput;
};


export type MutationCreateNewMemberInvitationArgs = {
  input: InviteNewMembersMutationInput;
};


export type MutationCreateOrEditIdeaUpdateArgs = {
  input: CreateOrEditIdeaUpdateInput;
};


export type MutationCreateOrUpdateAccreditedInvestorProfileArgs = {
  input: CreateOrUpdateAccreditedInvestorProfileInput;
};


export type MutationCreateOrUpdateCompanyQuestionArgs = {
  input: CreateOrUpdateCompanyQuestionInput;
};


export type MutationCreateOrUpdateCompensationArgs = {
  input: CreateOrUpdateCompensationInput;
};


export type MutationCreateOrUpdateIdeaArgs = {
  input: CreateOrUpdateIdeaInput;
};


export type MutationCreateOrUpdateReadingListItemArgs = {
  input: CreateUpdateReadingListItemInput;
};


export type MutationCreateOrUpdateUserApplicationArgs = {
  input: UserApplicationInput;
};


export type MutationCreateOrUpdateWhitePaperArgs = {
  input: CreateOrUpdateWhitePaperInput;
};


export type MutationCreatePostArgs = {
  input: CreatePostInput;
};


export type MutationCreateQuickPositionArgs = {
  input: CreateQuickPositionInput;
};


export type MutationCreateThesisImageArgs = {
  input: CreateThesisImageInput;
};


export type MutationCreateTweetArgs = {
  input: CreateTweetInput;
};


export type MutationCreateUserFeedbackArgs = {
  input: CreateUserFeedbackInput;
};


export type MutationCreateViewerIntroRequestArgs = {
  input: CreateViewerIntroRequestInput;
};


export type MutationDeleteFundSearchAlertArgs = {
  input: DeleteFundSearchAlertInput;
};


export type MutationDeleteIdeaSearchAlertArgs = {
  input: DeleteIdeaSearchAlertInput;
};


export type MutationDestroyAllocatorBlocklistEntryArgs = {
  input: DestroyAllocatorBlocklistEntryInput;
};


export type MutationDestroyCompanyQuestionArgs = {
  input: DestroyCompanyQuestionInput;
};


export type MutationDestroyCompensationArgs = {
  input: DestroyCompensationInput;
};


export type MutationDestroyIdeaDraftArgs = {
  input: DestroyIdeaDraftInput;
};


export type MutationDestroyPostArgs = {
  input: DeletePostInput;
};


export type MutationDestroyWhitePaperDraftArgs = {
  input: DestroyWhitePaperDraftInput;
};


export type MutationFlagItemArgs = {
  input: FlagItemInput;
};


export type MutationFollowMultipleArgs = {
  input: FollowMultipleInput;
};


export type MutationFollowObjectArgs = {
  input: FollowItemInput;
};


export type MutationGoogleReCaptchaArgs = {
  input: GoogleReCaptchaInput;
};


export type MutationHideFundRecommendationArgs = {
  input: HideFundRecommendationInput;
};


export type MutationHideIdeaRecommendationArgs = {
  input: HideIdeaRecommendationInput;
};


export type MutationLikeCommentArgs = {
  input: LikeCommentInput;
};


export type MutationLikeEventArgs = {
  input: LikeEventInput;
};


export type MutationMakeCheckoutSessionUpdatePaymentMethodArgs = {
  input: MakeCheckoutSessionUpdatePaymentMethodInput;
};


export type MutationMakeStripeCheckoutArgs = {
  input: MakeStripeCheckoutInput;
};


export type MutationMarkChatReadArgs = {
  input: MarkChatReadInput;
};


export type MutationMarkJobApplicationViewedArgs = {
  input: MarkJobApplicationViewedInput;
};


export type MutationMarkMessageAsReadArgs = {
  input: MarkMessageAsReadInput;
};


export type MutationMassFollowEntitiesArgs = {
  input: MassFollowEntitiesInput;
};


export type MutationMergeEntitiesArgs = {
  input: MergeEntitiesInput;
};


export type MutationPublishFundProfileArgs = {
  input: PublishFundProfileInput;
};


export type MutationRateIdeaArgs = {
  input: RateIdeaInput;
};


export type MutationRemoveMassImportArgs = {
  input: RemoveMassImportInput;
};


export type MutationRequestIdeaUpdateArgs = {
  input: RequestIdeaUpdateInput;
};


export type MutationRequestResearchAccessArgs = {
  input: RequestResearchAccessMutationInput;
};


export type MutationRestoreFundSearchAlertArgs = {
  input: RestoreUserFundSearchAlertInput;
};


export type MutationRestoreIdeaSearchAlertArgs = {
  input: RestoreUserIdeaSearchAlertInput;
};


export type MutationSetUsernameArgs = {
  input: SetUsernameInput;
};


export type MutationSpendIdeaTokenArgs = {
  input: PurchaseIdeaInput;
};


export type MutationStarJobApplicationArgs = {
  input: StarJobApplicationInput;
};


export type MutationSubmitCompanyQuestionResponseArgs = {
  input: SubmitCompanyQuestionResponseInput;
};


export type MutationSuggestTagArgs = {
  input: SuggestTagInput;
};


export type MutationToggleFundProfileAdminArgs = {
  input: ToggleFundProfileAdminInput;
};


export type MutationToggleHideNotificationArgs = {
  input: ToggleHideNotificationInput;
};


export type MutationUnarchiveThreadArgs = {
  input: UnarchiveThreadInput;
};


export type MutationUnfollowObjectArgs = {
  input: UnfollowItemInput;
};


export type MutationUnviewNotificationArgs = {
  input: UnviewNotificationInput;
};


export type MutationUpdateAllocatorProfileArgs = {
  input: UpdateAllocatorProfileInput;
};


export type MutationUpdateAllocatorProfileBackgroundImageArgs = {
  input: UpdateAllocatorProfileBackgroundImageInput;
};


export type MutationUpdateApiKeyArgs = {
  input: ChangeKeyStatusInput;
};


export type MutationUpdateBadgeVisibilityArgs = {
  input: UpdateUserBadgeVisibilityInput;
};


export type MutationUpdateClickCountArgs = {
  input: UpdateClickCountInput;
};


export type MutationUpdateCurrentUserLastViewedMessagesAtArgs = {
  input: UpdateCurrentUserLastViewedMessagesAtInput;
};


export type MutationUpdateEmailArgs = {
  input: UpdateUserEmailInput;
};


export type MutationUpdateEmailPreferencesArgs = {
  input: UpdateUserEmailPreferencesInput;
};


export type MutationUpdateEntityAdminArgs = {
  input: UpdateEntityAdminInput;
};


export type MutationUpdateFundProfileArgs = {
  input: UpdateFundProfileInput;
};


export type MutationUpdateFundProfileBackgroundImageArgs = {
  input: UpdateFundProfileBackgroundImageInput;
};


export type MutationUpdateFundProfileSectionVisibilityArgs = {
  input: UpdateFundProfileSectionVisibilityInput;
};


export type MutationUpdateFundSearchAlertArgs = {
  input: UpdateUserFundSearchAlertInput;
};


export type MutationUpdateIdeaSearchAlertArgs = {
  input: UpdateUserIdeaSearchAlertInput;
};


export type MutationUpdateIdeaViewsLastViewedArgs = {
  input: UpdateIdeaViewsLastViewedInput;
};


export type MutationUpdateIntroRequestArgs = {
  input: UpdateIntroRequestStatusInput;
};


export type MutationUpdateJobAppStatusArgs = {
  input: UpdateJobAppStatusInput;
};


export type MutationUpdatePaladinReviewArgs = {
  input: UpdatePaladinReviewInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdateUserPasswordInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateUserNotificationSettingsArgs = {
  input: UpdateNotificationSettingsInput;
};


export type MutationUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


export type MutationUpdateUserProfileBackgroundImageArgs = {
  input: UpdateUserProfileBackgroundImageInput;
};


export type MutationUpdateViewerIntroRequestArgs = {
  input: UpdateViewerIntroRequestInput;
};


export type MutationViewAllNotificationsArgs = {
  input: ViewAllNotificationsInput;
};


export type MutationViewIdeaRecommendationArgs = {
  input: ViewIdeaRecommendationInput;
};


export type MutationViewNotificationArgs = {
  input: ViewNotificationInput;
};

export type Notification = {
  __typename?: 'Notification';
  /** The user associated with this notification */
  associatedUser: Maybe<User>;
  /** The created at date of the notification */
  createdAt: Maybe<Scalars['String']['output']>;
  /** The custom link of the item the notification is about */
  customLink: Maybe<Scalars['String']['output']>;
  /** The description of the notification */
  description: Maybe<Scalars['String']['output']>;
  /** If the notification is hidden */
  hidden: Maybe<Scalars['Boolean']['output']>;
  /** The id of the notification */
  id: Scalars['ID']['output'];
  /** The id of the item the notification is about */
  linkId: Maybe<Scalars['ID']['output']>;
  /** The class of the notification */
  notificationClass: Maybe<Scalars['String']['output']>;
  /** If the notification has been read or marked as read */
  viewed: Scalars['Boolean']['output'];
};

/** The connection type for Notification. */
export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<NotificationEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Notification>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Notification>;
};

export type NumericResult = {
  __typename?: 'NumericResult';
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Omnisearch = {
  __typename?: 'Omnisearch';
  allocators: Maybe<Array<AllocatorProfile>>;
  anonUsers: Array<AnonUser>;
  employers: Maybe<Array<Employer>>;
  /** public_field */
  entities: Maybe<Array<Entity>>;
  funds: Maybe<Array<EmployerProfile>>;
  ideas: Array<Idea>;
  /** public_field */
  podcastEpisodes: Array<PodcastEpisode>;
  users: Array<User>;
  /** public_field */
  videos: Maybe<Array<Video>>;
};

export type OpenGraphData = {
  __typename?: 'OpenGraphData';
  /** The domain parsed from the og_url data */
  domain: Maybe<Scalars['String']['output']>;
  /** The description scraped from the og source data */
  ogDescription: Maybe<Scalars['String']['output']>;
  /** The image preview scraped from the og source data */
  ogPreviewImageUrl: Maybe<Scalars['String']['output']>;
  /** The title scraped from the og source data */
  ogTitle: Maybe<Scalars['String']['output']>;
  /** The url of the og source data */
  ogUrl: Scalars['String']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor: Maybe<Scalars['String']['output']>;
};

export type PaginatedInsiderTrades = {
  __typename?: 'PaginatedInsiderTrades';
  maxPage: Scalars['Int']['output'];
  resultCount: Scalars['Int']['output'];
  trades: Array<InsiderTrade>;
};

export type Paladin = {
  __typename?: 'Paladin';
  /** The display name of the paladin (public_field) */
  displayName: Maybe<Scalars['String']['output']>;
  /** Whether or not the user has a quota for the item type */
  hasQuota: Maybe<Scalars['Boolean']['output']>;
  /** The id of the paladin (public_field) */
  id: Scalars['ID']['output'];
  /** The next deadline for paladin quotas */
  nextQuotaDeadline: Scalars['String']['output'];
  /** The quota for a specific item type */
  quota: Maybe<Scalars['String']['output']>;
  /** The current monthly count for a specific item type */
  quotaCurrentMonth: Maybe<Scalars['String']['output']>;
  /** The current percent of a specific item type */
  quotaPercent: Maybe<Scalars['String']['output']>;
  /** The user of the paladin */
  user: Maybe<User>;
  /** The user id of the paladin (public_field) */
  userId: Maybe<Scalars['ID']['output']>;
};


export type PaladinHasQuotaArgs = {
  type: Scalars['String']['input'];
};


export type PaladinQuotaArgs = {
  type: Scalars['String']['input'];
};


export type PaladinQuotaCurrentMonthArgs = {
  type: Scalars['String']['input'];
};


export type PaladinQuotaPercentArgs = {
  type: Scalars['String']['input'];
};

export type PaladinReview = {
  __typename?: 'PaladinReview';
  /** The body of the review (public_field) */
  description: Maybe<Scalars['String']['output']>;
  /** The id of the paladin review (public_field) */
  id: Scalars['ID']['output'];
  /** The paladin of the review (public_field) */
  paladin: Maybe<Paladin>;
  /** The status of the review (public_field) */
  status: Maybe<Scalars['String']['output']>;
};

export type PodcastEpisode = {
  __typename?: 'PodcastEpisode';
  /** The podcast episode's description (public_field) */
  description: Scalars['String']['output'];
  /** The podcast episode's Spotify ID (public_field) */
  episodeId: Scalars['String']['output'];
  /** public_field */
  id: Scalars['ID']['output'];
  /** The podcast episode's mentioned entities (public_field) */
  mentionedEntities: Array<Entity>;
  /** The podcast episode's name (public_field) */
  name: Scalars['String']['output'];
  /** Related podcast episodes by tags (public_field) */
  relatedPodcastEpisodes: Array<PodcastEpisode>;
  /** The podcast episode's released at date (public_field) */
  releasedAt: Scalars['String']['output'];
  /** The podcast episode's tags (public_field) */
  tagList: Array<Scalars['String']['output']>;
  /** The podcast episode's thumbnail image (public_field) */
  thumbnailImageUrl: Maybe<Scalars['String']['output']>;
  /** The podcast episode's show page vanity link (public_field) */
  vanityLink: Maybe<Scalars['String']['output']>;
};


export type PodcastEpisodeReleasedAtArgs = {
  isTimeAgo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The connection type for PodcastEpisode. */
export type PodcastEpisodeConnection = {
  __typename?: 'PodcastEpisodeConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PodcastEpisodeEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<PodcastEpisode>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PodcastEpisodeEdge = {
  __typename?: 'PodcastEpisodeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<PodcastEpisode>;
};

export type PollResponseData = {
  __typename?: 'PollResponseData';
  /** Whether the question has been answered by the current user */
  answeredByCurrentUser: Scalars['Boolean']['output'];
  /** Buyside Poll result data statistics */
  buysidePollResultStats: Maybe<PollResultStatistics>;
  /** Retail Poll result data statistics */
  retailPollResultStats: Maybe<PollResultStatistics>;
};

export type PollResultStatistics = {
  __typename?: 'PollResultStatistics';
  /** The response distribution percentages during the current month for a table */
  currentMonthPct: Maybe<Array<NumericResult>>;
  /** The monthly average values for a line graph */
  monthlyAvg: Maybe<Array<NumericResult>>;
  /** The response distribution percentages over a 12-month period for a table */
  twelveMonthsPct: Maybe<Array<NumericResult>>;
};

export type Position = {
  __typename?: 'Position';
  /** public_field */
  asset: Maybe<Asset>;
  /** The saved closing price when an Idea is closed (public_field) */
  closingPrice: Maybe<Scalars['Float']['output']>;
  /** The direction of the position public_field */
  direction: Scalars['String']['output'];
  /** public_field */
  entityName: Scalars['String']['output'];
  /** public_field */
  id: Scalars['ID']['output'];
  /** If the asset currency code is GBp or ILs (public_field) */
  isCurrencySubunit: Scalars['Boolean']['output'];
  /** The latest price of the quote (public_field) */
  latestPrice: Maybe<Scalars['Float']['output']>;
  /** The date of the latest price quote (public_field) */
  latestPriceDate: Maybe<Scalars['String']['output']>;
  /** The saved opening price when an Idea is closed (public_field) */
  openingPrice: Maybe<Scalars['Float']['output']>;
  /** The target price of the positon (public_field) */
  priceTarget: Maybe<Scalars['Float']['output']>;
  /** public_field */
  primarySymbol: Scalars['String']['output'];
  /** The total return of the position (public_field) */
  totalReturn: Maybe<Scalars['Float']['output']>;
  /** (public_field) */
  userCompanyData: Maybe<UserCompanyData>;
  /** (public_field) */
  userCreditData: Maybe<UserCreditData>;
};

export type PositionAttributes = {
  assetId: Scalars['ID']['input'];
  direction: Scalars['String']['input'];
  positionId?: InputMaybe<Scalars['ID']['input']>;
  priceTarget?: InputMaybe<Scalars['Float']['input']>;
  userDefinedAsset?: InputMaybe<UserDefinedAssetAttributes>;
};

export type Post = {
  __typename?: 'Post';
  /** The body of the post public_field */
  body: Maybe<Scalars['String']['output']>;
  /** The list of mentionable users in comments */
  commentMentionables: Maybe<Array<Mentionable>>;
  /** The comments */
  comments: Maybe<CommentConnection>;
  /** The number of comments (public_field) */
  commentsCount: Maybe<Scalars['Int']['output']>;
  /** The timestamp the post was created public_field */
  createdAt: Scalars['String']['output'];
  /** If the current user has liked the post event (public_field) */
  currentUserHasLiked: Scalars['Boolean']['output'];
  /** The domain parsed from the og_url data public_field */
  domain: Maybe<Scalars['String']['output']>;
  /** Any tagged entities */
  entities: Maybe<Array<Entity>>;
  /** The id of the first event for the post (public_field) */
  eventId: Maybe<Scalars['ID']['output']>;
  /** The id of the post (public_field) */
  id: Scalars['ID']['output'];
  /** The like count of the post event (public_field) */
  likeCount: Scalars['Int']['output'];
  /** The description from the og data public_field */
  ogDescription: Maybe<Scalars['String']['output']>;
  /** The preview image url from the og data public_field */
  ogPreviewImageUrl: Maybe<Scalars['String']['output']>;
  /** The title from the og data public_field */
  ogTitle: Maybe<Scalars['String']['output']>;
  /** The url from the og data public_field */
  ogUrl: Maybe<Scalars['String']['output']>;
  /** The humanized timestamp of when the post was created public_field */
  postedAt: Maybe<Scalars['String']['output']>;
  /** Research on entities tagged in the post */
  relatedIdeas: Maybe<IdeaConnection>;
  /** Keyword/hash tags */
  tagList: Maybe<Array<Scalars['String']['output']>>;
  /** Body with any entity mentions replaced with ticker symbols (public_field) */
  untaggedBody: Maybe<Scalars['String']['output']>;
  /** The user who owns the post public_field */
  user: Maybe<User>;
  /** The YouTube id public_field */
  youtubeId: Maybe<Scalars['String']['output']>;
};


export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type PostRelatedIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Post. */
export type PostConnection = {
  __typename?: 'PostConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<PostEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Post>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PostEdge = {
  __typename?: 'PostEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Post>;
};

export type Price = {
  __typename?: 'Price';
  currency: Maybe<Scalars['String']['output']>;
  /** public_field */
  date: Maybe<Scalars['String']['output']>;
  openPrice: Maybe<Scalars['Float']['output']>;
  /** public_field */
  price: Maybe<Scalars['Float']['output']>;
};

export type Profile = {
  __typename?: 'Profile';
  /** Asset Class Expertise */
  assetClassExpertise: Maybe<Array<Scalars['String']['output']>>;
  /** URL for cropped background image */
  backgroundImageCroppedUrl: Maybe<Scalars['String']['output']>;
  /** URL for background image */
  backgroundImageUrl: Maybe<Scalars['String']['output']>;
  /** Certifications held by the profile user */
  certifications: Maybe<Array<Scalars['String']['output']>>;
  /** The city name of the profile public_field */
  city: Maybe<Scalars['String']['output']>;
  /** The current or former company the user works at. public_field */
  companyString: Maybe<Scalars['String']['output']>;
  /** URL for default background image */
  defaultBackgroundImage: Maybe<Scalars['String']['output']>;
  /** URL for default image */
  defaultImage: Maybe<Scalars['String']['output']>;
  /** The user's email address */
  email: Maybe<Scalars['String']['output']>;
  /** The user's employer histories */
  employerHistories: Maybe<Array<EmployerHistory>>;
  /** The user's experience by firm type */
  experienceByFirmType: Maybe<Scalars['String']['output']>;
  /** The user's favorite investment book */
  favoriteInvestmentBook: Maybe<Scalars['String']['output']>;
  /** Geographic Expertise */
  geographicExpertise: Maybe<Array<Scalars['String']['output']>>;
  /** If the user has answered all the profile questions */
  hasAllProfileAnswers: Maybe<Scalars['Boolean']['output']>;
  /** If the user has answered any profile questions */
  hasAnyProfileAnswers: Maybe<Scalars['Boolean']['output']>;
  /** If the user has completed the private part of the profile */
  hasFilledPrivateProfile: Maybe<Scalars['Boolean']['output']>;
  /** If the user has added a GPA */
  hasGpa: Maybe<Scalars['Boolean']['output']>;
  /** If the user has added an SAT or ACT score */
  hasSatOrAct: Maybe<Scalars['Boolean']['output']>;
  /** The user's hometown */
  hometown: Maybe<Scalars['String']['output']>;
  /** The id of the profile (public_field) */
  id: Scalars['ID']['output'];
  /** The user's ideas' annualized return median (public_field) */
  ideaAnnualizedReturnMedian: Maybe<Scalars['String']['output']>;
  /** The user's ideas' return vs benchmark average (public_field) */
  ideaReturnVsBenchmarkAverage: Maybe<Scalars['String']['output']>;
  /** The user's ideas' total return average (public_field) */
  ideaTotalReturnAverage: Maybe<Scalars['String']['output']>;
  /** URL for cropped image */
  imageProfileUrl: Maybe<Scalars['String']['output']>;
  /** URL for image */
  imageUrl: Maybe<Scalars['String']['output']>;
  /** The user's investing style */
  investingStyle: Maybe<Scalars['String']['output']>;
  /** The user's investment hero */
  investmentHero: Maybe<Scalars['String']['output']>;
  /** If the user is self identified as an accredited investor */
  isAccredited: Maybe<Scalars['Boolean']['output']>;
  /** The user's languages spoken */
  languagesSpoken: Maybe<Scalars['String']['output']>;
  /** The user's mobile phone */
  mobilePhone: Maybe<Scalars['String']['output']>;
  /** If the user has published an idea in the last 3 months */
  postedInLast3Months: Maybe<Scalars['Boolean']['output']>;
  /** Profile answers */
  profileAnswers: Maybe<Array<ProfileAnswer>>;
  /** Featured research attachments */
  profileAttachments: Maybe<Array<ProfileAttachmentType>>;
  /** The user's test results */
  profileTestResults: Maybe<Array<ProfileTestResult>>;
  /** The user's resume as an object */
  resume: Maybe<Scalars['String']['output']>;
  /** The user's school histories */
  schoolHistories: Maybe<Array<SchoolHistory>>;
  /** Sector Expertise */
  sectorExpertise: Maybe<Array<Scalars['String']['output']>>;
  /** The summary of the user profile (public_field) */
  summary: Maybe<Scalars['String']['output']>;
  /** The user associated with the profile */
  user: Maybe<User>;
  /** The user's work phone */
  workPhone: Maybe<Scalars['String']['output']>;
};


export type ProfileIdeaAnnualizedReturnMedianArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileIdeaReturnVsBenchmarkAverageArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileIdeaTotalReturnAverageArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileAnswer = {
  __typename?: 'ProfileAnswer';
  /** The answer to the question */
  answer: Maybe<Scalars['String']['output']>;
  /** The id of the featured item */
  id: Scalars['ID']['output'];
  /** The ID of the associated question */
  profileQuestionId: Maybe<Scalars['Int']['output']>;
};

export type ProfileAttachmentType = {
  __typename?: 'ProfileAttachmentType';
  /** The description of the attachment */
  description: Maybe<Scalars['String']['output']>;
  /** The file name of the attachment */
  filename: Maybe<Scalars['String']['output']>;
  /** The id of the attachment */
  id: Scalars['ID']['output'];
  /** The name of the attachment */
  name: Maybe<Scalars['String']['output']>;
};

/** The connection type for Profile. */
export type ProfileConnection = {
  __typename?: 'ProfileConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ProfileEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Profile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ProfileEdge = {
  __typename?: 'ProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Profile>;
};

export type ProfileTestResult = {
  __typename?: 'ProfileTestResult';
  /** The date the test was taken */
  date: Maybe<Scalars['String']['output']>;
  /** The score report filename */
  filename: Maybe<Scalars['String']['output']>;
  /** The id of the profile test result */
  id: Scalars['ID']['output'];
  /** The maximum test score */
  maxScore: Maybe<Scalars['String']['output']>;
  /** The name of the test */
  name: Maybe<Scalars['String']['output']>;
  /** The test score */
  score: Maybe<Scalars['Float']['output']>;
  /** The url of the score report */
  url: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of PublishFundProfile */
export type PublishFundProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishFundProfile */
export type PublishFundProfilePayload = {
  __typename?: 'PublishFundProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  employerProfile: Maybe<EmployerProfile>;
};

/** Autogenerated input type of PurchaseIdea */
export type PurchaseIdeaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
};

/** Autogenerated return type of PurchaseIdea */
export type PurchaseIdeaPayload = {
  __typename?: 'PurchaseIdeaPayload';
  availableTokenCount: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** The query root for this schema */
export type Query = {
  __typename?: 'Query';
  accreditedInvestorProfilesIndexList: Maybe<Array<AccreditedInvestorProfile>>;
  activeConversationIdeas: Maybe<IdeaConnection>;
  aggregatedFeedItems: Maybe<FeedItemConnection>;
  allocatorProfile: Maybe<AllocatorProfile>;
  allocatorProfilesIndexList: Maybe<Array<AllocatorProfile>>;
  allocatorRecommendations: FundRecommendationConnection;
  /** Fields to query api keys for the datafeed */
  apiKeys: Maybe<Array<ApiKey>>;
  asset: Maybe<Asset>;
  assetsByBloombergSymbol: Maybe<Array<Asset>>;
  biggestMoverIdeas: Maybe<IdeaConnection>;
  biggestMoverRank: Rank;
  /** public_field */
  blogPosts: Maybe<Array<BlogPost>>;
  chat: Maybe<Chat>;
  /** Cities field public_field */
  cities: Maybe<Scalars['String']['output']>;
  /** Searching for cities public_field */
  citySearch: Maybe<Array<Scalars['String']['output']>>;
  companyNewsItems: Maybe<CompanyNewsItemConnection>;
  companyQuestions: Maybe<Array<CompanyQuestion>>;
  compensation: Maybe<Compensation>;
  compensationIndexList: Maybe<CompensationConnection>;
  compensationStatistics: Maybe<CompensationStatistics>;
  /** Contest field public_field */
  contest: Maybe<Contest>;
  contestIndex: Maybe<ContestConnection>;
  /** Any ongoing contests */
  currentContests: Array<Contest>;
  /** Current Ranking for a given category (each ranking has many ranks) public_field */
  currentRankingForCategory: Maybe<Ranking>;
  /** Current Ranks for a given category (e.g. #1 All-time, #2, etc) public_field */
  currentRanksForCategory: Maybe<RankConnection>;
  /** public_field */
  currentUser: Maybe<User>;
  /** public_field */
  emailSearch: Scalars['Boolean']['output'];
  /** employer blacklist public_field */
  employerBlacklist: Maybe<Array<Scalars['String']['output']>>;
  /** public_field */
  employerSearch: Maybe<Array<Employer>>;
  /** Collects sumzero entities by id, Admin Only */
  entities: Maybe<Array<Entity>>;
  entitiesByBloombergSymbol: Array<Entity>;
  /** Searches sumzero entities by name or (id must be exact), Admin Only */
  entitiesSearch: Maybe<Array<Entity>>;
  /** public_field */
  entity: Maybe<Entity>;
  events: Maybe<EventTypeConnection>;
  fakeField: Scalars['Boolean']['output'];
  /** Any ongoing & upcoming contests */
  featuredContests: Array<Contest>;
  feedItemComments: Maybe<CommentConnection>;
  feedItemCommentsCount: Maybe<Scalars['Int']['output']>;
  feedItemShow: Maybe<FeedItem>;
  /** public_field */
  feedItems: Maybe<FeedItemConnection>;
  /** The funds we provide the fund letters from (public_field) */
  fundLetterSources: Array<FundLetterSource>;
  fundProfile: Maybe<EmployerProfile>;
  fundProfilesIndexList: Maybe<Array<EmployerProfile>>;
  fundProfilesSavedSearchList: Maybe<EmployerProfileSearchAlertConnection>;
  fundRecommendations: FundRecommendationConnection;
  homeComments: Array<Comment>;
  homeCommentsMaxOffset: Scalars['Int']['output'];
  homeIdeaUpdates: Array<IdeaUpdate>;
  homeIdeaUpdatesMaxOffset: Scalars['Int']['output'];
  /** (public_field) */
  idea: Idea;
  ideaSubmissionAssetLookup: Maybe<Asset>;
  ideaUpdate: IdeaUpdate;
  /** public_field */
  ideasIndexList: Maybe<IdeaConnection>;
  /** public_field */
  ideasSavedSearchList: Maybe<IdeaSearchAlertConnection>;
  /** public_field */
  indexListResultCount: Maybe<Scalars['Int']['output']>;
  insiderTrades: PaginatedInsiderTrades;
  jobApplication: Maybe<JobApplication>;
  jobApplicationsIndexList: Maybe<Array<JobApplication>>;
  jobPost: Maybe<JobPosting>;
  jobPostingIndexList: Maybe<JobPostingConnection>;
  largestInsiderTrades: Array<InsiderTrade>;
  /** latest messages in message thread for current user */
  latestMessagePerThread: Maybe<MessageConnection>;
  /** public_field */
  latestSiteMessage: Maybe<SiteMessage>;
  /** Fund letters for a provided fund name (public_field) */
  lettersForFund: Maybe<FundLetterConnection>;
  massTickerSearch: Maybe<MassTickerSearch>;
  /** public_field */
  media: Media;
  /** public_field */
  mediaIndexList: Maybe<MediaConnection>;
  /** public_field */
  mostPopularMediaHashtags: Array<Scalars['String']['output']>;
  /** When the next ranking will be published public_field */
  nextRankingPublishDate: Maybe<Scalars['String']['output']>;
  /** public_field */
  omnisearch: Omnisearch;
  openGraphData: Maybe<OpenGraphData>;
  /** public_field */
  podcastEpisodesIndexList: PodcastEpisodeConnection;
  popularAssetSearch: Maybe<Array<Asset>>;
  post: Maybe<Post>;
  postsIndexList: Maybe<PostConnection>;
  /** The latest contest for which the site wide modal is enabled, during the display_site_wide_modal? time period */
  promotedContest: Maybe<Contest>;
  recommendedIdea: Maybe<IdeaRecommendation>;
  /** Recommended users to follow based on current user's watchlist */
  recommendedUsersToFollow: Maybe<UserConnection>;
  recommendedUsersToFollowCount: Scalars['Int']['output'];
  /** If a user has already registered for an event (public_field) */
  registrantSearch: Scalars['Boolean']['output'];
  sampleFeedItems: Maybe<FeedItemConnection>;
  /** public_field */
  schoolNameSearch: Maybe<Array<Scalars['String']['output']>>;
  sectorChats: Array<Chat>;
  securities: SecurityConnection;
  securitySearch: Maybe<Scalars['String']['output']>;
  termsOfUse: Maybe<Scalars['String']['output']>;
  thesisImage: Maybe<ThesisImage>;
  /** messages for a given thread */
  threadMessages: Maybe<MessageConnection>;
  /** The top stocks contest winners (public_field) */
  topStockWinners: Array<Idea>;
  trendingIdeas: Maybe<IdeaConnection>;
  /** The users application (public_field) */
  userApplication: UserApplication;
  userLookUp: Maybe<User>;
  userProfile: Profile;
  userProfileIndexList: Maybe<ProfileConnection>;
  /** public_field */
  userSearch: Maybe<Array<User>>;
  watchlistTickerAssetData: Maybe<Asset>;
  whitePaper: WhitePaper;
  whitePapersIndexList: Maybe<Array<WhitePaper>>;
};


/** The query root for this schema */
export type QueryAccreditedInvestorProfilesIndexListArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryActiveConversationIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryAggregatedFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryAllocatorProfileArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryAllocatorProfilesIndexListArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryAllocatorRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fundProfileId?: InputMaybe<Scalars['ID']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root for this schema */
export type QueryAssetArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryAssetsByBloombergSymbolArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryBiggestMoverIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryBiggestMoverRankArgs = {
  feedItemId?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root for this schema */
export type QueryBlogPostsArgs = {
  featured: Scalars['Boolean']['input'];
  number: Scalars['Int']['input'];
};


/** The query root for this schema */
export type QueryChatArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryCitySearchArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryCompanyNewsItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryCompensationArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root for this schema */
export type QueryCompensationIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryCompensationStatisticsArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryContestArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryContestIndexArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryCurrentRankingForCategoryArgs = {
  category: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryCurrentRanksForCategoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  category: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryEmailSearchArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  userOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root for this schema */
export type QueryEmployerSearchArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryEntitiesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query root for this schema */
export type QueryEntitiesByBloombergSymbolArgs = {
  query: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryEntitiesSearchArgs = {
  query: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryEntityArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<EventEnum>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryFeedItemCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  feedItemId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryFeedItemCommentsCountArgs = {
  feedItemId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryFeedItemShowArgs = {
  feedItemId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  feedFilter?: InputMaybe<Scalars['String']['input']>;
  feedId?: InputMaybe<Scalars['ID']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryFundProfileArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryFundProfilesIndexListArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryFundProfilesSavedSearchListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root for this schema */
export type QueryFundRecommendationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root for this schema */
export type QueryHomeCommentsArgs = {
  offset: Scalars['Int']['input'];
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryHomeCommentsMaxOffsetArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryHomeIdeaUpdatesArgs = {
  offset: Scalars['Int']['input'];
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryHomeIdeaUpdatesMaxOffsetArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryIdeaArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryIdeaSubmissionAssetLookupArgs = {
  fsymId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryIdeaUpdateArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryIdeasIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryIdeasSavedSearchListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root for this schema */
export type QueryIndexListResultCountArgs = {
  indexType: Scalars['String']['input'];
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryInsiderTradesArgs = {
  page: Scalars['Int']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
  watchlistedTickers?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root for this schema */
export type QueryJobApplicationArgs = {
  jobApplicationId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryJobApplicationsIndexListArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryJobPostArgs = {
  jobPostId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryJobPostingIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryLargestInsiderTradesArgs = {
  timeframe: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryLatestMessagePerThreadArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryLettersForFundArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  fundName: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryMassTickerSearchArgs = {
  tickers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query root for this schema */
export type QueryMediaArgs = {
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryMediaIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  indexType: Scalars['String']['input'];
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryMostPopularMediaHashtagsArgs = {
  type: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryOmnisearchArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryOpenGraphDataArgs = {
  ogUrl?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryPodcastEpisodesIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryPopularAssetSearchArgs = {
  categoryName: Scalars['String']['input'];
  categoryType: Scalars['String']['input'];
};


/** The query root for this schema */
export type QueryPostArgs = {
  postId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryPostsIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryRecommendedIdeaArgs = {
  lastSeenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  userId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryRecommendedUsersToFollowArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryRegistrantSearchArgs = {
  email: Scalars['String']['input'];
};


/** The query root for this schema */
export type QuerySampleFeedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QuerySchoolNameSearchArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QuerySecuritiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  symbol: Scalars['String']['input'];
};


/** The query root for this schema */
export type QuerySecuritySearchArgs = {
  assetClass?: InputMaybe<Scalars['String']['input']>;
  includeLocalAsset?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryThesisImageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root for this schema */
export type QueryThreadMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  threadNum?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryTrendingIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** The query root for this schema */
export type QueryUserApplicationArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryUserLookUpArgs = {
  userId: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryUserProfileArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryUserProfileIndexListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryUserSearchArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


/** The query root for this schema */
export type QueryWatchlistTickerAssetDataArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/** The query root for this schema */
export type QueryWhitePaperArgs = {
  id: Scalars['ID']['input'];
};


/** The query root for this schema */
export type QueryWhitePapersIndexListArgs = {
  searchParams?: InputMaybe<Scalars['String']['input']>;
};

export type QuickPosition = {
  __typename?: 'QuickPosition';
  /** If the quick position is anonymous */
  anonymous: Scalars['Boolean']['output'];
  /** The quick positions asset */
  asset: Asset;
  /** The chat belonging to the quick position's asset's entity */
  chat: Chat;
  /** When the quick position was closed */
  closedAt: Maybe<Scalars['String']['output']>;
  /** The closing price of the quick position asset */
  closingPrice: Maybe<Scalars['Float']['output']>;
  /** The amount of members who have an open quick position on the same asset */
  communityParticipantCount: Scalars['Int']['output'];
  /** The direction of the quick position */
  direction: Scalars['String']['output'];
  /** The id of the quick position */
  id: Scalars['ID']['output'];
  /** When the quick position was opened */
  openedAt: Maybe<Scalars['String']['output']>;
  /** The opening price of the quick positions asset */
  openingPrice: Maybe<Scalars['Float']['output']>;
  /** The return to date of the quick position */
  returnToDate: Maybe<Scalars['Float']['output']>;
};

export type Rank = {
  __typename?: 'Rank';
  /** The category of the rank (public_field) */
  category: Scalars['String']['output'];
  /** created at date */
  createdAt: Scalars['String']['output'];
  /** If the ranking is current (public_field) */
  current: Scalars['Boolean']['output'];
  /** The id of the rank (public_field) */
  id: Scalars['ID']['output'];
  /** The previous ranking if any */
  pastRank: Maybe<Rank>;
  /** public_field */
  privateDeltaString: Maybe<Scalars['String']['output']>;
  /** The string representation of the ranks (public_field) */
  rankString: Scalars['String']['output'];
  /** The user of the rank public_field */
  user: Maybe<User>;
  /** The value of the ranking (what rank the user is) public_field */
  value: Maybe<Scalars['Int']['output']>;
  /** public_field */
  viewDeltaString: Maybe<Scalars['String']['output']>;
};

/** The connection type for Rank. */
export type RankConnection = {
  __typename?: 'RankConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<RankEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Rank>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type RankEdge = {
  __typename?: 'RankEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Rank>;
};

export type Ranking = {
  __typename?: 'Ranking';
  /** Category of the ranking public_field */
  category: Maybe<Scalars['String']['output']>;
  /** confidence value public_field */
  confidence: Maybe<Scalars['Int']['output']>;
  /** Date of the ranking public_field */
  date: Maybe<Scalars['String']['output']>;
  /** The id of the ranking */
  id: Scalars['ID']['output'];
  /** The public ranks of the ranking */
  publicRanks: Maybe<RankConnection>;
};


export type RankingPublicRanksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of RateIdea */
export type RateIdeaInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
};

/** Autogenerated return type of RateIdea */
export type RateIdeaPayload = {
  __typename?: 'RateIdeaPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  idea: Maybe<Idea>;
  userRating: Maybe<UserRating>;
};

export type Rating = {
  __typename?: 'Rating';
  /** The average rating public_field */
  averageRating: Maybe<Scalars['Float']['output']>;
  /** The id of the rating public_field */
  id: Scalars['ID']['output'];
  /** The number of users that have rated public_field */
  userRatingCount: Scalars['Int']['output'];
};

export type ReadingListItem = {
  __typename?: 'ReadingListItem';
  /** If the reading list item is archived */
  archived: Scalars['Boolean']['output'];
  /** The id of the reading list item */
  id: Scalars['ID']['output'];
  /** The idea of the reading list item */
  idea: Idea;
  /** The reading list item's idea id */
  ideaId: Scalars['ID']['output'];
  /** The user of the reading list item */
  user: User;
};

/** The connection type for ReadingListItem. */
export type ReadingListItemConnection = {
  __typename?: 'ReadingListItemConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ReadingListItemEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ReadingListItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ReadingListItemEdge = {
  __typename?: 'ReadingListItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ReadingListItem>;
};

/** Autogenerated input type of RemoveMassImport */
export type RemoveMassImportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  massImportId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveMassImport */
export type RemoveMassImportPayload = {
  __typename?: 'RemoveMassImportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of RequestIdeaUpdate */
export type RequestIdeaUpdateInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
};

/** Autogenerated return type of RequestIdeaUpdate */
export type RequestIdeaUpdatePayload = {
  __typename?: 'RequestIdeaUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  complete: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of RequestResearchAccessMutation */
export type RequestResearchAccessMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RequestResearchAccessMutation */
export type RequestResearchAccessMutationPayload = {
  __typename?: 'RequestResearchAccessMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Attributes of an idea, idea update, or white paper attachment */
export type ResearchAttachmentAttributes = {
  /** Selected attachment type */
  attachmentType?: InputMaybe<Scalars['String']['input']>;
  /** Uploaded file */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** Uploaded file name */
  filename: Scalars['String']['input'];
  /** Id */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Selected research type */
  researchType: Scalars['String']['input'];
};

/** Autogenerated input type of RestoreUserFundSearchAlert */
export type RestoreUserFundSearchAlertInput = {
  /** email notifications about new fund profiles matching this search are enabled */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** this saved search is displayed on the fund profile index page */
  display?: InputMaybe<Scalars['Boolean']['input']>;
  /** employer profile saved search alert id */
  employerProfileSavedSearchId: Scalars['ID']['input'];
  /** employer profile saved search alert name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RestoreUserFundSearchAlert */
export type RestoreUserFundSearchAlertPayload = {
  __typename?: 'RestoreUserFundSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of RestoreUserIdeaSearchAlert */
export type RestoreUserIdeaSearchAlertInput = {
  /** email notifications about new ideas matching this search are enabled */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** this saved search is displayed on the idea index page */
  display?: InputMaybe<Scalars['Boolean']['input']>;
  /** idea saved search alert id */
  ideaSavedSearchId: Scalars['ID']['input'];
  /** idea saved search alert name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RestoreUserIdeaSearchAlert */
export type RestoreUserIdeaSearchAlertPayload = {
  __typename?: 'RestoreUserIdeaSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type SavedSearch = {
  __typename?: 'SavedSearch';
  /** The criteria of the search in a JSON public_field */
  criteria: Maybe<Scalars['SavedSearchCriteria']['output']>;
  /** The id of the saved search public_field */
  id: Scalars['ID']['output'];
  /** The search key of the saved search public_field */
  searchKey: Scalars['String']['output'];
  /** The type of saved search */
  type: Scalars['String']['output'];
};

export type SchoolHistory = {
  __typename?: 'SchoolHistory';
  /** If the user is a current student */
  currentStudent: Maybe<Scalars['Boolean']['output']>;
  /** The name of the degree */
  degree: Maybe<Scalars['String']['output']>;
  /** The field of study of the degree */
  fieldOfStudy: Maybe<Scalars['String']['output']>;
  /** Grad year */
  gradYear: Maybe<Scalars['Int']['output']>;
  /** The id of the school history */
  id: Scalars['ID']['output'];
  /** The name of the school */
  schoolName: Scalars['String']['output'];
  /** Start year */
  startYear: Maybe<Scalars['Int']['output']>;
};

export type Sector = {
  __typename?: 'Sector';
  chatId: Scalars['String']['output'];
  /** The id of the sector */
  id: Scalars['ID']['output'];
  /** The name of the sector */
  name: Scalars['String']['output'];
  /** Only to be used in the context of top_sectors_newly_followed */
  newFollowersCount: Scalars['Int']['output'];
};

export type Security = {
  __typename?: 'Security';
  display: Maybe<Scalars['String']['output']>;
  entityName: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['String']['output']>;
  symbol: Maybe<Scalars['String']['output']>;
};

/** The connection type for Security. */
export type SecurityConnection = {
  __typename?: 'SecurityConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<SecurityEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<Security>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SecurityEdge = {
  __typename?: 'SecurityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<Security>;
};

/** Autogenerated input type of SetUsername */
export type SetUsernameInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/** Autogenerated return type of SetUsername */
export type SetUsernamePayload = {
  __typename?: 'SetUsernamePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

export type SiteMessage = {
  __typename?: 'SiteMessage';
  /** The body of the site message public_field */
  body: Maybe<Scalars['String']['output']>;
  /** The id of the message public_field */
  id: Scalars['ID']['output'];
  /** If the message is for a contest public_field */
  isContest: Maybe<Scalars['Boolean']['output']>;
  /** The link text public_field */
  linkText: Maybe<Scalars['String']['output']>;
  /** The Url for the link public_field */
  linkUrl: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of StarJobApplication */
export type StarJobApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobApplicationId: Scalars['ID']['input'];
  /** Should the application be starred/bookmarked */
  starredBoolean: Scalars['Boolean']['input'];
};

/** Autogenerated return type of StarJobApplication */
export type StarJobApplicationPayload = {
  __typename?: 'StarJobApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** JobApplication with updated status */
  jobApplication: Maybe<JobApplication>;
};

export type StripeSubscription = {
  __typename?: 'StripeSubscription';
  /** End of the current period that the subscription has been invoiced for */
  currentPeriodEnd: Scalars['String']['output'];
  /** The description of the plan from Payment::STRIPE_PLANS */
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  /** Whether the subscription is scheduled to be canceled at the end of the current period */
  isAutoRenewing: Scalars['Boolean']['output'];
  /** Possible values are incomplete, incomplete_expired, trialing, active, past_due, canceled, or unpaid. */
  status: Scalars['String']['output'];
};

/** Properties of a subcategory */
export type Subcategory = Esg | Geography | GlobalMacro | Sector;

/** Autogenerated input type of SubmitCompanyQuestionResponse */
export type SubmitCompanyQuestionResponseInput = {
  /** The answer(s) */
  answers: Array<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The entity id */
  entityId: Scalars['ID']['input'];
  /** The question id */
  id: Scalars['ID']['input'];
  /** Whether or not question was skipped */
  skipped: Scalars['Boolean']['input'];
};

/** Autogenerated return type of SubmitCompanyQuestionResponse */
export type SubmitCompanyQuestionResponsePayload = {
  __typename?: 'SubmitCompanyQuestionResponsePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  companyQuestionResponse: Maybe<CompanyQuestionResponse>;
};

/** The subscription root for the GraphQL schema */
export type Subscription = {
  __typename?: 'Subscription';
  chatMessageCreated: ChatMessageCreatedPayload;
};

/** Autogenerated input type of SuggestTag */
export type SuggestTagInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SuggestTag */
export type SuggestTagPayload = {
  __typename?: 'SuggestTagPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  success: Maybe<Scalars['Boolean']['output']>;
};

export type ThesisImage = {
  __typename?: 'ThesisImage';
  id: Scalars['ID']['output'];
  url: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ToggleFundProfileAdmin */
export type ToggleFundProfileAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  currentEmployeeId: Scalars['ID']['input'];
  employerProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of ToggleFundProfileAdmin */
export type ToggleFundProfileAdminPayload = {
  __typename?: 'ToggleFundProfileAdminPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  employerProfile: EmployerProfile;
};

/** Autogenerated input type of ToggleHideNotification */
export type ToggleHideNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hidden: Scalars['Boolean']['input'];
  notificationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ToggleHideNotification */
export type ToggleHideNotificationPayload = {
  __typename?: 'ToggleHideNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  notification: Maybe<Notification>;
};

/** Autogenerated input type of UnarchiveThread */
export type UnarchiveThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  threadNum: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveThread */
export type UnarchiveThreadPayload = {
  __typename?: 'UnarchiveThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  id: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of UnfollowItem */
export type UnfollowItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  followId?: InputMaybe<Scalars['ID']['input']>;
  /** use if you need to skip creating datafeed and audit records, i.e. for onboarding */
  skipSideEffects?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UnfollowItem */
export type UnfollowItemPayload = {
  __typename?: 'UnfollowItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
  user: Maybe<User>;
};

/** Autogenerated input type of UnviewNotification */
export type UnviewNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnviewNotification */
export type UnviewNotificationPayload = {
  __typename?: 'UnviewNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
  notification: Maybe<Notification>;
};

/** Autogenerated input type of UpdateAllocatorProfileBackgroundImage */
export type UpdateAllocatorProfileBackgroundImageInput = {
  allocatorProfileId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  imageData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateAllocatorProfileBackgroundImage */
export type UpdateAllocatorProfileBackgroundImagePayload = {
  __typename?: 'UpdateAllocatorProfileBackgroundImagePayload';
  allocatorProfile: Maybe<AllocatorProfile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateAllocatorProfile */
export type UpdateAllocatorProfileInput = {
  allocatorProfileId: Scalars['ID']['input'];
  aumRange?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerType?: InputMaybe<Scalars['String']['input']>;
  executives?: InputMaybe<Scalars['String']['input']>;
  fundManager?: InputMaybe<Scalars['String']['input']>;
  investmentCriteria?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  section: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateAllocatorProfile */
export type UpdateAllocatorProfilePayload = {
  __typename?: 'UpdateAllocatorProfilePayload';
  allocatorProfile: Maybe<AllocatorProfile>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateClickCount */
export type UpdateClickCountInput = {
  adminPostId: Scalars['ID']['input'];
  clickedUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateClickCount */
export type UpdateClickCountPayload = {
  __typename?: 'UpdateClickCountPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  updatedAdminPost: Maybe<AdminPost>;
};

/** Autogenerated input type of UpdateCurrentUserLastViewedMessagesAt */
export type UpdateCurrentUserLastViewedMessagesAtInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCurrentUserLastViewedMessagesAt */
export type UpdateCurrentUserLastViewedMessagesAtPayload = {
  __typename?: 'UpdateCurrentUserLastViewedMessagesAtPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  complete: Maybe<Scalars['Boolean']['output']>;
  user: Maybe<User>;
};

/** Autogenerated input type of UpdateEntityAdmin */
export type UpdateEntityAdminInput = {
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  factsetEntityId: Scalars['String']['input'];
  hideFromIndex: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateEntityAdmin */
export type UpdateEntityAdminPayload = {
  __typename?: 'UpdateEntityAdminPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  entity: Maybe<Entity>;
};

/** Autogenerated input type of UpdateFundProfileBackgroundImage */
export type UpdateFundProfileBackgroundImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
  imageData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateFundProfileBackgroundImage */
export type UpdateFundProfileBackgroundImagePayload = {
  __typename?: 'UpdateFundProfileBackgroundImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  employerProfile: Maybe<EmployerProfile>;
};

/** Autogenerated input type of UpdateFundProfile */
export type UpdateFundProfileInput = {
  assetClassNames?: InputMaybe<Array<Scalars['String']['input']>>;
  aum?: InputMaybe<Scalars['Int']['input']>;
  beta?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceDocuments?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
  executives?: InputMaybe<Scalars['String']['input']>;
  feeStructureDocuments?: InputMaybe<Scalars['String']['input']>;
  firmReferences?: InputMaybe<Scalars['String']['input']>;
  focus?: InputMaybe<Scalars['String']['input']>;
  foundersShares?: InputMaybe<Scalars['Boolean']['input']>;
  foundingDate?: InputMaybe<Scalars['String']['input']>;
  fundManager?: InputMaybe<Scalars['String']['input']>;
  fundType?: InputMaybe<Scalars['String']['input']>;
  geographyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  highwaterMark?: InputMaybe<Scalars['Boolean']['input']>;
  holdings?: InputMaybe<Scalars['String']['input']>;
  holdingsDocuments?: InputMaybe<Scalars['String']['input']>;
  hurdleRate?: InputMaybe<Scalars['Float']['input']>;
  ideaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  imageData?: InputMaybe<Scalars['String']['input']>;
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  investorLevelGates?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  lockUp?: InputMaybe<Scalars['Int']['input']>;
  managementFee?: InputMaybe<Scalars['Float']['input']>;
  marketingMaterials?: InputMaybe<Scalars['String']['input']>;
  metricsDocuments?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  presses?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  returns?: InputMaybe<Scalars['String']['input']>;
  returnsDocuments?: InputMaybe<Scalars['String']['input']>;
  returnsUpdatedDate?: InputMaybe<Scalars['String']['input']>;
  section: Scalars['String']['input'];
  sectorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  seedDeal?: InputMaybe<Scalars['Boolean']['input']>;
  serviceProviders?: InputMaybe<Scalars['String']['input']>;
  sharpeRatio?: InputMaybe<Scalars['Float']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  subsectorExpertise?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  turnoverRatio?: InputMaybe<Scalars['Float']['input']>;
  whitePaperIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of UpdateFundProfile */
export type UpdateFundProfilePayload = {
  __typename?: 'UpdateFundProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  employerProfile: Maybe<EmployerProfile>;
};

/** Autogenerated input type of UpdateFundProfileSectionVisibility */
export type UpdateFundProfileSectionVisibilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  employerProfileId: Scalars['ID']['input'];
  section: Scalars['String']['input'];
  sectionVisibility: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateFundProfileSectionVisibility */
export type UpdateFundProfileSectionVisibilityPayload = {
  __typename?: 'UpdateFundProfileSectionVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  employerProfile: Maybe<EmployerProfile>;
};

/** Autogenerated input type of UpdateIdeaViewsLastViewed */
export type UpdateIdeaViewsLastViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateIdeaViewsLastViewed */
export type UpdateIdeaViewsLastViewedPayload = {
  __typename?: 'UpdateIdeaViewsLastViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  idea: Maybe<Idea>;
};

/** Autogenerated input type of UpdateIntroRequestStatus */
export type UpdateIntroRequestStatusInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  introRequestId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateIntroRequestStatus */
export type UpdateIntroRequestStatusPayload = {
  __typename?: 'UpdateIntroRequestStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  introRequest: Maybe<IntroRequest>;
};

/** Autogenerated input type of UpdateJobAppStatus */
export type UpdateJobAppStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jobApplicationId: Scalars['ID']['input'];
  /** Message sent to the job applicant with interview request */
  message?: InputMaybe<Scalars['String']['input']>;
  /** interviewed or rejected */
  status: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateJobAppStatus */
export type UpdateJobAppStatusPayload = {
  __typename?: 'UpdateJobAppStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** JobApplication with updated status */
  jobApplication: Maybe<JobApplication>;
};

/** Autogenerated input type of UpdateNotificationSettings */
export type UpdateNotificationSettingsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  showActivelyDiscussed?: InputMaybe<Scalars['Boolean']['input']>;
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  showBadges?: InputMaybe<Scalars['Boolean']['input']>;
  showBiggestMovers?: InputMaybe<Scalars['Boolean']['input']>;
  showCapIntro?: InputMaybe<Scalars['Boolean']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showContests?: InputMaybe<Scalars['Boolean']['input']>;
  showFolloweeActivity?: InputMaybe<Scalars['Boolean']['input']>;
  showFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  showFundFollower?: InputMaybe<Scalars['Boolean']['input']>;
  showIdeas?: InputMaybe<Scalars['Boolean']['input']>;
  showJobVault?: InputMaybe<Scalars['Boolean']['input']>;
  showNewRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  showRankings?: InputMaybe<Scalars['Boolean']['input']>;
  showTrendingResearch?: InputMaybe<Scalars['Boolean']['input']>;
  showViewerIntroRequests?: InputMaybe<Scalars['Boolean']['input']>;
  showWatchlist?: InputMaybe<Scalars['Boolean']['input']>;
  showWhitePapers?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateNotificationSettings */
export type UpdateNotificationSettingsPayload = {
  __typename?: 'UpdateNotificationSettingsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  userNotificationSetting: Maybe<UserNotificationSetting>;
};

/** Autogenerated input type of UpdatePaladinReview */
export type UpdatePaladinReviewInput = {
  approvedContestIdeas?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  paladinReviewId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePaladinReview */
export type UpdatePaladinReviewPayload = {
  __typename?: 'UpdatePaladinReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  paladinReview: Maybe<PaladinReview>;
};

/** Autogenerated input type of UpdateSubscription */
export type UpdateSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Stripe subscription id */
  id: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateSubscription */
export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  subscription: StripeSubscription;
};

/** Autogenerated input type of UpdateUserBadgeVisibility */
export type UpdateUserBadgeVisibilityInput = {
  /** badge collection relationship id */
  badgeCollectionRelationshipId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** this badge collection is displayed on the member profile index page */
  visible: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateUserBadgeVisibility */
export type UpdateUserBadgeVisibilityPayload = {
  __typename?: 'UpdateUserBadgeVisibilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of UpdateUserEmail */
export type UpdateUserEmailInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** email */
  email: Scalars['String']['input'];
  /** password */
  password: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserEmail */
export type UpdateUserEmailPayload = {
  __typename?: 'UpdateUserEmailPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of UpdateUserEmailPreferences */
export type UpdateUserEmailPreferencesInput = {
  /** Weekly Digest */
  activityDigestMailer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Daily Digest */
  activityDigestMailerWeekly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Unsubscribe from all */
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weekly Allocator Digest */
  allocatorDigest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Event Notifications */
  buysideEventNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  /** Job Vault Digest */
  buysideJobsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cap Intro Announcements */
  capIntro?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Someone comments on my idea */
  commentCreateAuthorFollowedIdea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments on an idea for a company I follow */
  commentCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments after me on an idea */
  commentCreateFollowedIdea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments after me on a post */
  commentCreateFollowedPost?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone I follow comments on an idea */
  commentCreateFollowedUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments on an idea by an analyst I follow */
  commentCreateFollowedUserIdea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments after me on a Macro/Thematic report */
  commentCreateFollowedWhitePaper?: InputMaybe<Scalars['Boolean']['input']>;
  /** An allocator comments on my fund */
  commentCreateFundAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments on my post */
  commentCreatePostAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone comments on my Macro/Thematic report */
  commentCreateWhitePaperAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  /** A price changes signficantly for a company I follow */
  companyPriceChange?: InputMaybe<Scalars['Boolean']['input']>;
  /** Daily Company Chat Digest */
  dailyChatDigest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Monthly Rankings Update */
  generalRankingsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone publishes an idea on a company I follow */
  ideaCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone I follow publishes an idea */
  ideaCreateFollowedUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reminders about idea tokens */
  ideaToken?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone updates an idea on a company I follow */
  ideaUpdateCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone updates an idea I have commented on */
  ideaUpdateCreateFollowedIdea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone I follow updates an idea */
  ideaUpdateCreateFollowedUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Member Engagement */
  memberEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  /** An allocator contacts my fund */
  newAllocatorEnquiry?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new allocator joins Cap Intro */
  newAllocatorProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** An allocator requests I update my profile */
  newAllocatorUpdateRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /** A buyside user contacts my fund */
  newBuysideUserFundProfileMessage?: InputMaybe<Scalars['Boolean']['input']>;
  /** A new fund joins Cap Intro */
  newFundProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Personal Rankings Update */
  personalRankingsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone posts a compensation similar to mine */
  positionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone publishes a post on a company I follow */
  postCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone publishes a post on a sector I follow */
  postCreateFollowedSector?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone rates my idea */
  rateIdea?: InputMaybe<Scalars['Boolean']['input']>;
  /** SumZero Products and Services */
  researchAccess?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weekly Market Dispatch */
  retailWeeklyMarketDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  /** General Announcements */
  siteNewsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone wants an update on my idea */
  updateIdea?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone sends me a message */
  userToUser?: InputMaybe<Scalars['Boolean']['input']>;
  /** Someone wants an introduction to me after I have anonymously viewed one of their reports. */
  viewerIntroRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weekly Buyside Update */
  weeklyDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Weekly Top Idea */
  weeklyTopIdea?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserEmailPreferences */
export type UpdateUserEmailPreferencesPayload = {
  __typename?: 'UpdateUserEmailPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of UpdateUserFundSearchAlert */
export type UpdateUserFundSearchAlertInput = {
  /** email notifications about new fund profiles matching this search are enabled */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** this saved search is displayed on the fund profile index page */
  display?: InputMaybe<Scalars['Boolean']['input']>;
  /** employer profile saved search alert id */
  fundSearchAlertId: Scalars['ID']['input'];
  /** employer profile saved search alert name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserFundSearchAlert */
export type UpdateUserFundSearchAlertPayload = {
  __typename?: 'UpdateUserFundSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of UpdateUserIdeaSearchAlert */
export type UpdateUserIdeaSearchAlertInput = {
  /** email notifications about new ideas matching this search are enabled */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** this saved search is displayed on the idea index page */
  display?: InputMaybe<Scalars['Boolean']['input']>;
  /** the email schedule */
  frequency?: InputMaybe<Scalars['String']['input']>;
  /** idea saved search alert id */
  ideaSearchAlertId: Scalars['ID']['input'];
  /** idea saved search alert name */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserIdeaSearchAlert */
export type UpdateUserIdeaSearchAlertPayload = {
  __typename?: 'UpdateUserIdeaSearchAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of UpdateUserPassword */
export type UpdateUserPasswordInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** current password */
  currentPassword: Scalars['String']['input'];
  /** new password */
  password: Scalars['String']['input'];
  /** new password confirmation */
  passwordConfirmation: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateUserPassword */
export type UpdateUserPasswordPayload = {
  __typename?: 'UpdateUserPasswordPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of UpdateUserProfileBackgroundImage */
export type UpdateUserProfileBackgroundImageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  imageData?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ID']['input'];
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateUserProfileBackgroundImage */
export type UpdateUserProfileBackgroundImagePayload = {
  __typename?: 'UpdateUserProfileBackgroundImagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  profile: Maybe<Profile>;
};

/** Autogenerated input type of UpdateUserProfile */
export type UpdateUserProfileInput = {
  assetClassNames?: InputMaybe<Array<Scalars['String']['input']>>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  employerHistories?: InputMaybe<Scalars['String']['input']>;
  favoriteInvestmentBook?: InputMaybe<Scalars['String']['input']>;
  geographyNames?: InputMaybe<Array<Scalars['String']['input']>>;
  hometown?: InputMaybe<Scalars['String']['input']>;
  imageData?: InputMaybe<Scalars['String']['input']>;
  investingStyle?: InputMaybe<Scalars['String']['input']>;
  investmentHero?: InputMaybe<Scalars['String']['input']>;
  languagesSpoken?: InputMaybe<Scalars['String']['input']>;
  profileAnswers?: InputMaybe<Scalars['String']['input']>;
  profileAttachments?: InputMaybe<Scalars['String']['input']>;
  profileId: Scalars['ID']['input'];
  profileTestResults?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  schoolHistories?: InputMaybe<Scalars['String']['input']>;
  section: Scalars['String']['input'];
  sectorNames?: InputMaybe<Array<Scalars['String']['input']>>;
  summary?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserProfile */
export type UpdateUserProfilePayload = {
  __typename?: 'UpdateUserProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  profile: Maybe<Profile>;
};

/** Autogenerated input type of UpdateViewerIntroRequest */
export type UpdateViewerIntroRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

/** Autogenerated return type of UpdateViewerIntroRequest */
export type UpdateViewerIntroRequestPayload = {
  __typename?: 'UpdateViewerIntroRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  viewerIntroRequest: Maybe<ViewerIntroRequest>;
};

export type User = {
  __typename?: 'User';
  /** If the user has accepted the fund disclaimer */
  acceptedFundDisclaimer: Scalars['Boolean']['output'];
  /** If the user has accepted the post terms */
  acceptedPostTerms: Maybe<Scalars['Boolean']['output']>;
  /** The users accredited investor profile */
  accreditedInvestorProfile: Maybe<AccreditedInvestorProfile>;
  /** The timestamp of the last time the user was active */
  activeAt: Maybe<Scalars['String']['output']>;
  /** The number of members this user is following, who are active and not hidden. (public_field) */
  activeFollowedUsersCount: Scalars['Int']['output'];
  /** The number of members that are not hidden, active, and currently following this user. (public_field) */
  activeFollowersCount: Scalars['Int']['output'];
  /** The fund profile(s) the user is an admin of */
  adminFundProfiles: Array<EmployerProfile>;
  /** Employer histories for active fund profile(s) of which the user is an admin */
  adminFunds: Array<EmployerHistory>;
  /** The number of access days the user has earned */
  allTimeReferralAwards: Maybe<Scalars['Int']['output']>;
  /** The user's allocator profile */
  allocatorProfile: Maybe<AllocatorProfile>;
  /** The profile image of the user's employer */
  allocatorProfileLogoUrl: Maybe<Scalars['String']['output']>;
  /** (public_field) */
  anonymousUserId: Scalars['String']['output'];
  archivedReadingListItems: Maybe<ReadingListItemConnection>;
  /** The number of idea user has archived to reading list */
  archivedReadingListItemsCount: Maybe<Scalars['Int']['output']>;
  /** The number of unused & unexpired idea tokens on the user's contracts */
  availableTokenCount: Maybe<Scalars['Int']['output']>;
  /** (public_field) */
  badgeCollectionRelationships: Maybe<BadgeCollectionRelationshipConnection>;
  /** Stripe billing address of the user */
  billingAddress: Maybe<BillingAddress>;
  /** amount paid, dates, and for what product */
  billingHistory: Maybe<Array<Invoice>>;
  /** If the user can access the resource and permission */
  canAccess: Maybe<Scalars['Boolean']['output']>;
  /** if user can apply to jobs */
  canApplyToJobs: Scalars['Boolean']['output'];
  /** If the user can comment anonymously on the idea */
  canCommentAnonymously: Scalars['Boolean']['output'];
  /** user can edit idea */
  canEditIdea: Maybe<Scalars['Boolean']['output']>;
  /** If the user can edit their profile */
  canEditProfile: Maybe<Scalars['Boolean']['output']>;
  /** user can post jobs on the Job Vault */
  canPostJobs: Scalars['Boolean']['output'];
  /** Whether the user is eligible to receive a viewer intro request */
  canReceiveViewerIntroRequest: Maybe<Scalars['Boolean']['output']>;
  /** card that will be charged info such as expiry details, brand, last four */
  cardDetails: Maybe<CardDetails>;
  /** The name of the user's current employer public_field */
  currentEmployerName: Maybe<Scalars['String']['output']>;
  /** The users current employers */
  currentEmployers: Array<Employer>;
  /** Current Ranks for the user */
  currentRanks: Maybe<Array<Rank>>;
  /** The count of current ranks */
  currentRanksCount: Maybe<Scalars['Int']['output']>;
  /** the user's title public_field */
  currentTitle: Maybe<Scalars['String']['output']>;
  /** The name of the user (public_field) */
  displayName: Scalars['String']['output'];
  draftAndPendingIdeas: Array<Idea>;
  /** The current user's draft compensations */
  draftCompensations: Maybe<Array<Compensation>>;
  draftIdeas: Maybe<Array<Idea>>;
  draftWhitePapers: Maybe<Array<WhitePaper>>;
  /** The email address of the user */
  email: Scalars['String']['output'];
  /** The user's email preferences */
  emailPreferences: Maybe<Array<EmailPreference>>;
  /** User's best rank for the ranking period (public_field) */
  featuredRank: Maybe<Rank>;
  /** User's best rank for the current user's watchlist sectors and LTM category; used for user recommendations */
  featuredRankForCurrentUserWatchlist: Maybe<Rank>;
  /** The first name of the user */
  firstName: Scalars['String']['output'];
  followedEntityIds: Array<Scalars['String']['output']>;
  followedEsgIds: Array<Scalars['String']['output']>;
  followedFundIds: Array<Scalars['String']['output']>;
  followedGeographyIds: Array<Scalars['String']['output']>;
  followedGlobalMacroIds: Array<Scalars['String']['output']>;
  followedSectorIds: Array<Scalars['String']['output']>;
  followedUserIds: Array<Scalars['String']['output']>;
  /** The number of members this user is currently following. */
  followedUsersCount: Scalars['Int']['output'];
  /** The number of members that are currently following this user. (public_field) */
  followersCount: Scalars['Int']['output'];
  followersList: Maybe<ProfileConnection>;
  followingList: Maybe<ProfileConnection>;
  /** The fund profile of the user's primary/only/latest current employer public_field */
  fundProfile: Maybe<EmployerProfile>;
  /** The user's fund profile saved search alerts */
  fundProfileSearchAlerts: Maybe<Array<EmployerProfileSearchAlert>>;
  /** if the user has idea access */
  hasActiveContract: Maybe<Scalars['Boolean']['output']>;
  /** Whether currently paying for a subscription */
  hasActiveSubscription: Scalars['Boolean']['output'];
  /** If the user has any badges */
  hasBadges: Maybe<Scalars['Boolean']['output']>;
  /** If the user completed their accredited investor profile */
  hasCompletedAccreditedInvestorProfile: Maybe<Scalars['Boolean']['output']>;
  /** If the user has completed SumZero onboarding */
  hasCompletedOnboarding: Scalars['Boolean']['output'];
  /** If the user qualifies for complimentary event registration */
  hasComplimentaryEventRegistration: Maybe<Scalars['Boolean']['output']>;
  /** If the user has contracts */
  hasContracts: Scalars['Boolean']['output'];
  /** If the user has an idea of any status */
  hasIdeas: Scalars['Boolean']['output'];
  /** if user has access to Job Vault */
  hasJobAccess: Maybe<Scalars['Boolean']['output']>;
  /** if user has applied to jobs on the Job Vault */
  hasJobApplications: Maybe<Scalars['Boolean']['output']>;
  /** if user has posted jobs on the Job Vault */
  hasJobPostings: Scalars['Boolean']['output'];
  /** If the user has been ranked */
  hasRanks: Maybe<Scalars['Boolean']['output']>;
  /** If the user has registered for an ongoing event */
  hasRegisteredForEvent: Maybe<Scalars['Boolean']['output']>;
  /** If the user has authorized SumZero with their Twitter account */
  hasTwitterToken: Maybe<Scalars['Boolean']['output']>;
  /** The user's historical public rankings */
  historicalPublicRankings: Maybe<Array<Scalars['String']['output']>>;
  /** The id of the user public_field */
  id: Scalars['ID']['output'];
  ideaRating: Maybe<UserRating>;
  /** The user's idea saved search alerts */
  ideaSearchAlerts: Maybe<Array<IdeaSearchAlert>>;
  /** If the user is in the trial period */
  inTrial: Scalars['Boolean']['output'];
  /** incoming message threads that has an argument for limits */
  incomingMessageThreads: Maybe<Array<Message>>;
  /** How many pending intro requests this user has based on their allocator profile */
  introRequestCount: Maybe<Scalars['Int']['output']>;
  /** If the user is an admin */
  isAdmin: Scalars['Boolean']['output'];
  /** If the user is an allocator */
  isAllocator: Scalars['Boolean']['output'];
  /** If the user is an admin of a particular allocator */
  isAllocatorAdmin: Scalars['Boolean']['output'];
  /** If the current user is blocked from a particular feature */
  isBlocked: Maybe<Scalars['Boolean']['output']>;
  isBuyside: Scalars['Boolean']['output'];
  /** If the current user does not have cap intro access */
  isCapIntroAccessBlocked: Maybe<Scalars['Boolean']['output']>;
  /** if the user is a cap intro member */
  isCapIntroMember: Scalars['Boolean']['output'];
  /** If the current user's compensation access has expired */
  isCompensationAccessExpired: Maybe<Scalars['Boolean']['output']>;
  isEliteTier: Scalars['Boolean']['output'];
  /** public_field */
  isFollowedByCurrentUser: Scalars['Boolean']['output'];
  /** If the user is an admin of a particular fund */
  isFundAdmin: Scalars['Boolean']['output'];
  /** If the user is an admin of any fund(s) */
  isFundProfileAdmin: Maybe<Scalars['Boolean']['output']>;
  /** If the current user is hidden */
  isHidden: Scalars['Boolean']['output'];
  /** If the user is high profile */
  isHighProfile: Maybe<Scalars['Boolean']['output']>;
  /** If the user is a hiring manager for a particular user profile */
  isHiringManager: Scalars['Boolean']['output'];
  isInRetailTrialPeriod: Scalars['Boolean']['output'];
  /** If the current user does not have job vault access */
  isJobAccessBlocked: Maybe<Scalars['Boolean']['output']>;
  isLiteTier: Scalars['Boolean']['output'];
  /** If the user is a Paladin */
  isPaladin: Scalars['Boolean']['output'];
  isPremiumTier: Scalars['Boolean']['output'];
  /** If the user is top ranked (has a public rank) public_field */
  isRanked: Maybe<Scalars['Boolean']['output']>;
  /** If the user is a non-buyside user */
  isRetail: Scalars['Boolean']['output'];
  /** Whether or not the user is token-based */
  isTokenBased: Maybe<Scalars['Boolean']['output']>;
  /** If the user is a top-down user */
  isTopDown: Scalars['Boolean']['output'];
  /** If the user is an admin of a particular user profile */
  isUserProfileAdmin: Scalars['Boolean']['output'];
  /** job application ids by the current user on the Job Vault */
  jobApplicationIds: Maybe<Array<Scalars['String']['output']>>;
  /** The user's job applications */
  jobApplications: Maybe<Array<JobApplication>>;
  /** jobs post ids by the current user on the Job Vault */
  jobPostingIds: Maybe<Array<Scalars['String']['output']>>;
  /** The user's job postings */
  jobPostings: Array<JobPosting>;
  /** jobs post ids applied to by the current user on the Job Vault */
  jobPostsAppliedIds: Maybe<Array<Scalars['ID']['output']>>;
  /** Data about who has viewed the user's ideas */
  lastNViews: Maybe<IdeaViewConnection>;
  lnkdSub: Maybe<Scalars['String']['output']>;
  /** Describe missing info if !current_user.has_a_current_and_filled_employer_history? */
  missingJobPostReqDescription: Maybe<Scalars['String']['output']>;
  /** The current employer of the profile (public_field) */
  mostRecentEmployer: Maybe<EmployerHistory>;
  /** Only to be used in the context of top_members_newly_followed */
  newFollowersCount: Scalars['Int']['output'];
  /** The count of recent notifications */
  newNotificationsCount: Maybe<Scalars['Int']['output']>;
  /** Notifications for the user */
  notifications: Maybe<NotificationConnection>;
  /** The number of days of access for a specific item */
  numDaysAccessLeft: Maybe<Scalars['String']['output']>;
  /** The number of days left to access cap intro */
  numDaysCapIntroAccessRemaining: Maybe<Scalars['String']['output']>;
  /** The number of days left for compensation view */
  numDaysCompensationViewRemaining: Maybe<Scalars['String']['output']>;
  /** The number of days left for job vault view */
  numDaysJobViewRemaining: Maybe<Scalars['String']['output']>;
  /** The total page count (starting at zero) of recommended funds for allocator onboarding */
  onboardingFundRecommendationMaxOffset: Maybe<Scalars['Int']['output']>;
  /** Recommended funds for allocator onboarding */
  onboardingFundRecommendations: Maybe<Array<EmployerProfile>>;
  /** The users open quick positions */
  openQuickPositions: Array<QuickPosition>;
  paladin: Maybe<Paladin>;
  /** The % of access that is left for a specific item */
  percentAccessLeft: Maybe<Scalars['String']['output']>;
  posts: Maybe<Array<Post>>;
  /** The primary contact of the user (if any) */
  primaryContact: Maybe<User>;
  /** (public_field) */
  profile: Maybe<Profile>;
  /** The profile city of the user (public_field) */
  profileCity: Maybe<Scalars['String']['output']>;
  /** The profile image of the user (public_field) */
  profileImageUrl: Maybe<Scalars['String']['output']>;
  /** The users public rankings */
  publicRankings: Maybe<Array<Rank>>;
  /** The current user's published compensations */
  publishedCompensations: Maybe<Array<Compensation>>;
  /** The user's published ideas */
  publishedIdeas: Maybe<IdeaConnection>;
  /** The number of published ideas this user currently has (including pending approval) */
  publishedIdeasCount: Scalars['Int']['output'];
  /** The users quick positions */
  quickPositions: Maybe<Array<QuickPosition>>;
  /** Complete history of all Ranks for the user */
  ranks: Maybe<Array<Rank>>;
  ratings: Maybe<UserRatingConnection>;
  readingListItems: Maybe<ReadingListItemConnection>;
  readingListItemsCount: Scalars['Int']['output'];
  /** The most recently published idea public_field */
  recentIdea: Maybe<Idea>;
  /** Entities the user has written ideas for and/or entities the user has watchlisted and/or entities belonging to the sectors the user has watchlisted */
  relevantEntities: Maybe<EntityConnection>;
  /** The sectors the user has written on related to the watchlist */
  sectorsWroteOn: Maybe<Array<Scalars['String']['output']>>;
  /** Viewer intro requests sent by contributer */
  sentViewerIntroRequests: Maybe<Array<ViewerIntroRequest>>;
  sessionId: Scalars['String']['output'];
  /** Stripe customer id of the user */
  stripeCustomerId: Maybe<Scalars['String']['output']>;
  /** Stripe subscription */
  subscriptions: Maybe<Array<StripeSubscription>>;
  /** The top performing ideas for this user public_field */
  topIdeas: Maybe<IdeaConnection>;
  /** The number of unexpired trial idea tokens on the user's contracts */
  trialTokenCount: Maybe<Scalars['Int']['output']>;
  /** The expiration of unexpired trial token (if any) in time ago in words */
  trialTokenExpiresIn: Maybe<Scalars['String']['output']>;
  /** how many unaddressed job applications there are */
  unaddressedApplicationsCount: Maybe<Scalars['Int']['output']>;
  /** The badges the current user has not earned */
  unearnedBadges: Maybe<Array<Badge>>;
  /** Count of unread messages */
  unreadMessageCount: Maybe<Scalars['Int']['output']>;
  /** The count of unread notifications */
  unreadNotificationsCount: Maybe<Scalars['Int']['output']>;
  unreadReadingListItems: Maybe<ReadingListItemConnection>;
  /** The number of ideas user has saved to reading list */
  unreadReadingListItemsCount: Maybe<Scalars['Int']['output']>;
  /** The approved but unregistered new user application via the user's referral */
  unregisteredReferrals: Maybe<Array<UserApplication>>;
  /** Count of unseen messages since the user last clicked the messages dropdown */
  unseenMessageCount: Maybe<Scalars['Int']['output']>;
  /** The number of used idea tokens on the user's contracts */
  usedTokenCount: Maybe<Scalars['Int']['output']>;
  /** If the current user has already submitted feedback for a specific prompt */
  userFeedbackSubmitted: Scalars['Boolean']['output'];
  /** T/F value on whether that user resides in watchlisted region */
  userInWatchlistedGeography: Maybe<Scalars['Boolean']['output']>;
  userNotificationSetting: Maybe<UserNotificationSetting>;
  /** The user's user referrals */
  userReferrals: Maybe<Array<UserReferral>>;
  /** (public_field) */
  username: Maybe<Scalars['String']['output']>;
  /** The number of unrejected viewer intro requests */
  viewerIntroRequestCount: Scalars['Int']['output'];
  viewerIntroRequests: Maybe<ViewerIntroRequestConnection>;
  /** The watchlist of the user */
  watchlist: Maybe<Watchlist>;
  /** The count of the number of ideas the user wrote for entities on the current user's watchlist */
  watchlistIdeasCount: Maybe<Scalars['Int']['output']>;
  watchlistTickers: Maybe<Array<WatchlistTagRelationship>>;
  whitePapers: Maybe<Array<WhitePaper>>;
  /** The count of the number of ideas written by both the current user and user */
  wroteOnSameEntitiesCount: Maybe<Scalars['Int']['output']>;
  /** The count of ideas written by the user on the watchlisted sectors of current user */
  wroteOnWatchlistedSectors: Maybe<Scalars['Int']['output']>;
};


export type UserArchivedReadingListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type UserBadgeCollectionRelationshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserCanAccessArgs = {
  permission: Scalars['String']['input'];
  resource: Scalars['String']['input'];
};


export type UserCanEditIdeaArgs = {
  ideaId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserDisplayNameArgs = {
  controlled?: InputMaybe<Scalars['Boolean']['input']>;
  ideaId?: InputMaybe<Scalars['ID']['input']>;
  suppress?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserFirstNameArgs = {
  suppress?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserFollowersListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type UserFollowingListArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type UserIdeaRatingArgs = {
  ideaId: Scalars['ID']['input'];
};


export type UserIncomingMessageThreadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  unread?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserIsAllocatorAdminArgs = {
  allocatorProfileId: Scalars['ID']['input'];
};


export type UserIsBlockedArgs = {
  feature: Scalars['String']['input'];
};


export type UserIsFundAdminArgs = {
  employerProfileId: Scalars['ID']['input'];
};


export type UserIsHiringManagerArgs = {
  profileId: Scalars['ID']['input'];
};


export type UserIsUserProfileAdminArgs = {
  profileId: Scalars['ID']['input'];
};


export type UserLastNViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  n: Scalars['Int']['input'];
};


export type UserNotificationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  desc?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserNumDaysAccessLeftArgs = {
  itemType: Scalars['String']['input'];
};


export type UserOnboardingFundRecommendationsArgs = {
  offset: Scalars['Int']['input'];
};


export type UserPercentAccessLeftArgs = {
  itemType: Scalars['String']['input'];
};


export type UserProfileImageUrlArgs = {
  suppress?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserPublicRankingsArgs = {
  timeframe: Scalars['String']['input'];
};


export type UserPublishedIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserPublishedIdeasCountArgs = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserRatingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserReadingListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserRecentIdeaArgs = {
  controlled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserRelevantEntitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type UserTopIdeasArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserUnreadReadingListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type UserUserFeedbackSubmittedArgs = {
  prompt: Scalars['String']['input'];
};


export type UserViewerIntroRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type UserWhitePapersArgs = {
  status?: InputMaybe<Scalars['String']['input']>;
};

/** A potential pro user's application public_field */
export type UserApplication = {
  __typename?: 'UserApplication';
  /** The applicant's application type public_field */
  applicantType: Maybe<Scalars['String']['output']>;
  /** The applicant's employer name on basic applications public_field */
  basicEmployerName: Maybe<Scalars['String']['output']>;
  /** The applicant's closest and/or current city public_field */
  city: Maybe<Scalars['String']['output']>;
  /** The applicant's school degree public_field */
  degree: Maybe<Scalars['String']['output']>;
  /** The applicant's email public_field */
  email: Scalars['String']['output'];
  /** The applicant's current employers aum range public_field */
  employerAumRange: Maybe<Scalars['String']['output']>;
  /** The applicant's current employers fund type public_field */
  employerFundType: Maybe<Scalars['String']['output']>;
  /** The applicant's current employers name public_field */
  employerName: Maybe<Scalars['String']['output']>;
  /** The applicant's current employment status (employed, seeking employment, or student) public_field */
  employmentStatus: Maybe<Scalars['String']['output']>;
  /** The applicant's school graduation year public_field */
  expectedGraduation: Maybe<Scalars['Int']['output']>;
  /** The applicant's school field of study public_field */
  fieldOfStudy: Maybe<Scalars['String']['output']>;
  /** The first name of the applicant public_field */
  firstName: Maybe<Scalars['String']['output']>;
  /** The id of the user application public_field */
  id: Maybe<Scalars['ID']['output']>;
  /** The applicant's investor profile public_field */
  investorType: Maybe<Scalars['String']['output']>;
  /** If the applicant identifies as an accredited investor public_field */
  isAccredited: Maybe<Scalars['Boolean']['output']>;
  /** The last name of the applicant public_field */
  lastName: Maybe<Scalars['String']['output']>;
  /** The applicant's LinkedIn profile public_field */
  linkedinUrl: Maybe<Scalars['String']['output']>;
  /** The applicant's phone number public_field */
  phone: Maybe<Scalars['String']['output']>;
  /** The id of the user who referred this applicant public_field */
  referrerId: Maybe<Scalars['Int']['output']>;
  /** The applicant's school name public_field */
  schoolName: Maybe<Scalars['String']['output']>;
  /** The applicant's application status public_field */
  status: Maybe<Scalars['String']['output']>;
  /** The applicant's title at their current employer public_field */
  title: Maybe<Scalars['String']['output']>;
  /** The applicant's school start yearpublic_field */
  yearStart: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of UserApplication */
export type UserApplicationInput = {
  /** public_field */
  acceptedDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  /** public_field */
  applicantType?: InputMaybe<Scalars['String']['input']>;
  /** Retail user employer for SZ Basic public_field */
  basicEmployerName?: InputMaybe<Scalars['String']['input']>;
  /** Retail investor type for SZ Basic public_field */
  basicInvestorType?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  degree?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  email: Scalars['String']['input'];
  /** public_field */
  employerAumRange?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  employerFundType?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  employerName?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  expectedGraduation?: InputMaybe<Scalars['Int']['input']>;
  /** public_field */
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  investorType?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  isAccredited?: InputMaybe<Scalars['Boolean']['input']>;
  /** public_field */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  referrerId?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  resume?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  schoolName?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  title?: InputMaybe<Scalars['String']['input']>;
  /** public_field */
  yearStart?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UserApplication */
export type UserApplicationPayload = {
  __typename?: 'UserApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  /** public_field */
  userApplication: Maybe<UserApplication>;
};

export type UserCompanyData = {
  __typename?: 'UserCompanyData';
  /** The country from the user (public_field) */
  country: Maybe<Scalars['String']['output']>;
  /** The created at date of the credit */
  createdAt: Maybe<Scalars['String']['output']>;
  /** The currency name from the user (public_field) */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** The currency name from the user (public_field) */
  currencyName: Maybe<Scalars['String']['output']>;
  /** The current PE from the user (public_field) */
  currentPe: Maybe<Scalars['Float']['output']>;
  /** The div yield from the user (public_field) */
  divYield: Maybe<Scalars['Float']['output']>;
  /** The enterprise value from the user (public_field) */
  ev: Maybe<Scalars['Int']['output']>;
  /** The id of the user credit data (public_field) */
  id: Scalars['ID']['output'];
  /** The industry from the user (public_field) */
  industry: Maybe<Scalars['String']['output']>;
  /** The total market cap from the user (public_field) */
  marketCap: Maybe<Scalars['Int']['output']>;
  /** The three month average daily trading volume from the user (public_field) */
  threeMonthAdv: Maybe<Scalars['Float']['output']>;
  /** The total cash from the user (public_field) */
  totalCash: Maybe<Scalars['Int']['output']>;
  /** The total debt from the user (public_field) */
  totalDebt: Maybe<Scalars['Int']['output']>;
  /** The updated at date of the credit (public_field) */
  updatedAt: Maybe<Scalars['String']['output']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

export type UserCreditData = {
  __typename?: 'UserCreditData';
  /** The amount outstanding (public_field) */
  amountOutstanding: Maybe<Scalars['Float']['output']>;
  /** If the credit is convertible (public_field) */
  convertible: Maybe<Scalars['Boolean']['output']>;
  /** The coupon frequency of the credit (public_field) */
  couponFrequency: Maybe<Scalars['String']['output']>;
  /** The coupon rate of the credit (public_field) */
  couponRate: Maybe<Scalars['Float']['output']>;
  /** The coupon type (public_field) */
  couponType: Maybe<Scalars['String']['output']>;
  /** The created at date of the credit (public_field) */
  createdAt: Maybe<Scalars['String']['output']>;
  /** The current yield of the credit (public_field) */
  currentYield: Maybe<Scalars['Float']['output']>;
  /** The embedded option of the credit (public_field) */
  embeddedOption: Maybe<Scalars['String']['output']>;
  /** The fitch credit rating of the asset (public_field) */
  fitchCreditRating: Maybe<Scalars['String']['output']>;
  /** If the credit is guaranteed (public_field) */
  guaranteed: Maybe<Scalars['Boolean']['output']>;
  /** The id of the user credit data (public_field) */
  id: Scalars['ID']['output'];
  /** The issue size of the credit (public_field) */
  issueSize: Maybe<Scalars['Float']['output']>;
  /** The lein of the credit (public_field) */
  lien: Maybe<Scalars['String']['output']>;
  /** The maturity date of the credit rating (public_field) */
  maturityDate: Maybe<Scalars['String']['output']>;
  /** The moody credit rating (public_field) */
  moodyCreditRating: Maybe<Scalars['String']['output']>;
  /** The secured by of the credit (public_field) */
  securedBy: Maybe<Scalars['String']['output']>;
  /** The security class of the credit data (public_field) */
  securityClass: Maybe<Scalars['String']['output']>;
  /** The seniority of the credit (public_field) */
  seniority: Maybe<Scalars['String']['output']>;
  /** The standard credit rating (public_field) */
  standardCreditRating: Maybe<Scalars['String']['output']>;
  /** The updated at date of the credit (public_field) */
  updatedAt: Maybe<Scalars['String']['output']>;
};

export type UserCreditDataAttributes = {
  amountOutstanding?: InputMaybe<Scalars['Float']['input']>;
  convertible: Scalars['Boolean']['input'];
  couponFrequency?: InputMaybe<Scalars['String']['input']>;
  couponRate?: InputMaybe<Scalars['Float']['input']>;
  couponType?: InputMaybe<Scalars['String']['input']>;
  currentYield?: InputMaybe<Scalars['Float']['input']>;
  embeddedOption: Scalars['String']['input'];
  fitchCreditRating: Scalars['String']['input'];
  guaranteed: Scalars['Boolean']['input'];
  issueSize?: InputMaybe<Scalars['Float']['input']>;
  lien?: InputMaybe<Scalars['String']['input']>;
  maturityDate: Scalars['String']['input'];
  moodyCreditRating: Scalars['String']['input'];
  securedBy?: InputMaybe<Scalars['String']['input']>;
  securityClass: Scalars['String']['input'];
  seniority: Scalars['String']['input'];
  standardCreditRating: Scalars['String']['input'];
};

export type UserDefinedAssetAttributes = {
  assetClassId: Scalars['ID']['input'];
  currencyId: Scalars['ID']['input'];
  entityName: Scalars['String']['input'];
  recentPrice?: InputMaybe<Scalars['Float']['input']>;
  symbol: Scalars['String']['input'];
  userCreditData?: InputMaybe<UserCreditDataAttributes>;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<User>;
};

export type UserFeedback = {
  __typename?: 'UserFeedback';
  /** The optional user feedback comment left by the user */
  comment: Maybe<Scalars['String']['output']>;
  /** The created at date of the user feedback */
  createdAt: Scalars['String']['output'];
  /** The id of the user feedback */
  id: Scalars['ID']['output'];
  /** The feedback prompt the user is responding to */
  prompt: Scalars['String']['output'];
  /** The user feedback rating, either 1 for postive feedback, -1 for negative feedbac, or 0 for no feedback */
  rating: Scalars['Int']['output'];
  /** The user feedback's sentiment */
  sentiment: Maybe<Scalars['String']['output']>;
  /** The user associated with the user feedback */
  user: User;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  /** The id of the user notification setting */
  id: Scalars['ID']['output'];
  /** Should show actively discussed research */
  showActivelyDiscussed: Scalars['Boolean']['output'];
  /** Should show user all notifications */
  showAll: Scalars['Boolean']['output'];
  /** Should show badges notifications */
  showBadges: Scalars['Boolean']['output'];
  /** Should show biggest movers */
  showBiggestMovers: Scalars['Boolean']['output'];
  /** Should show cap intro notifications */
  showCapIntro: Scalars['Boolean']['output'];
  /** Should show comments notifications */
  showComments: Scalars['Boolean']['output'];
  /** Should show contest notifications */
  showContests: Scalars['Boolean']['output'];
  /** Should show followee activity notifications */
  showFolloweeActivity: Scalars['Boolean']['output'];
  /** Should show follower notifications */
  showFollowers: Scalars['Boolean']['output'];
  /** Should show new fund follower notifications */
  showFundFollower: Scalars['Boolean']['output'];
  /** Should show idea notifications */
  showIdeas: Scalars['Boolean']['output'];
  /** Should show job vault activity */
  showJobVault: Scalars['Boolean']['output'];
  /** Should show new recommendations */
  showNewRecommended: Scalars['Boolean']['output'];
  /** Should show rankings notifications */
  showRankings: Scalars['Boolean']['output'];
  /** Should show actively discussed and trending ideas */
  showTrendingIdeas: Scalars['Boolean']['output'];
  /** Should show trending research */
  showTrendingResearch: Scalars['Boolean']['output'];
  /** Should viewer intro request notifications */
  showViewerIntroRequests: Scalars['Boolean']['output'];
  /** Periodic watchlist update reminders */
  showWatchlist: Scalars['Boolean']['output'];
  /** Should show Macro / Thematic reports based on the user's watchlist */
  showWhitePapers: Scalars['Boolean']['output'];
};

export type UserRating = {
  __typename?: 'UserRating';
  /** The created  date of the user rating */
  createdAt: Scalars['String']['output'];
  /** The id of the user rating */
  id: Scalars['ID']['output'];
  /** The idea the user has rated */
  idea: Idea;
  /** The id of the rating to which it belongs */
  ratingId: Scalars['ID']['output'];
  /** The score that the user made */
  score: Scalars['Int']['output'];
  /** The total return of the idea since rating */
  totalReturn: Maybe<Scalars['Float']['output']>;
  /** The updated date of the user rating */
  updatedAt: Scalars['String']['output'];
};

/** The connection type for UserRating. */
export type UserRatingConnection = {
  __typename?: 'UserRatingConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<UserRatingEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<UserRating>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserRatingEdge = {
  __typename?: 'UserRatingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<UserRating>;
};

export type UserReferral = {
  __typename?: 'UserReferral';
  /** The total number of access days earned through the referral, depending on the referee's milestone progress */
  cumulativeRewardDays: Maybe<Scalars['Int']['output']>;
  /** The id of the referral */
  id: Scalars['ID']['output'];
  /** The person who has received the referral */
  referee: User;
  /** The maximum number of access days available through the referral program the referral belongs to */
  referralProgramMaxRewardDays: Maybe<Scalars['Int']['output']>;
};

export type Video = {
  __typename?: 'Video';
  /** The description of the video that is imported from Youtube and/or manually adjusted by admins. (public_field) */
  description: Scalars['String']['output'];
  /** The SumZero DB id of the video (public_field) */
  id: Scalars['ID']['output'];
  /** Related entities tagged by admins (public_field) */
  mentionedEntities: Array<Entity>;
  /** The date that the video was published on Youtube. Must be imported or adjusted manually through the console. (public_field) */
  publishedAt: Scalars['String']['output'];
  /** Videos with tags matching the current video (public_field) */
  relatedVideos: Array<Video>;
  /** The custom tags for the video that are created by admins (public_field) */
  tagList: Array<Scalars['String']['output']>;
  /** The video's thumbnail image (public_field) */
  thumbnailImageUrl: Maybe<Scalars['String']['output']>;
  /** The title of the video that is imported from Youtube and/or manually adjusted by admins (public_field) */
  title: Scalars['String']['output'];
  /** The vanity link for use on SumZero that is created by admins (public_field) */
  vanityLink: Maybe<Scalars['String']['output']>;
  /** The Youtube Video ID (public_field) */
  videoId: Scalars['String']['output'];
};


export type VideoPublishedAtArgs = {
  isTimeAgo?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of ViewAllNotifications */
export type ViewAllNotificationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ViewAllNotifications */
export type ViewAllNotificationsPayload = {
  __typename?: 'ViewAllNotificationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of ViewIdeaRecommendation */
export type ViewIdeaRecommendationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of ViewIdeaRecommendation */
export type ViewIdeaRecommendationPayload = {
  __typename?: 'ViewIdeaRecommendationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
};

/** Autogenerated input type of ViewNotification */
export type ViewNotificationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notificationId: Scalars['ID']['input'];
};

/** Autogenerated return type of ViewNotification */
export type ViewNotificationPayload = {
  __typename?: 'ViewNotificationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  currentUser: Maybe<User>;
  notification: Maybe<Notification>;
};

export type ViewerIntroRequest = {
  __typename?: 'ViewerIntroRequest';
  /** The viewable's user */
  author: User;
  /** The time created */
  createdAt: Scalars['String']['output'];
  /** The ID of the intro request */
  id: Scalars['ID']['output'];
  /** The idea view associated with this intro request */
  ideaView: Maybe<IdeaView>;
  /** The status of the request */
  status: Scalars['String']['output'];
  /** The time most recently updated */
  updatedAt: Scalars['String']['output'];
  /** The display title for the viewable */
  viewableDisplayTitle: Scalars['String']['output'];
  /** The id of the viewable */
  viewableId: Scalars['ID']['output'];
  /** The type of viewable */
  viewableType: Scalars['String']['output'];
  /** User who receives the intro request */
  viewer: User;
};

/** The connection type for ViewerIntroRequest. */
export type ViewerIntroRequestConnection = {
  __typename?: 'ViewerIntroRequestConnection';
  /** A list of edges. */
  edges: Maybe<Array<Maybe<ViewerIntroRequestEdge>>>;
  /** A list of nodes. */
  nodes: Maybe<Array<Maybe<ViewerIntroRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ViewerIntroRequestEdge = {
  __typename?: 'ViewerIntroRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Maybe<ViewerIntroRequest>;
};

export type Watchlist = {
  __typename?: 'Watchlist';
  /** Asset Classes the watchlist follows */
  assetClasses: Maybe<Array<AssetClass>>;
  /** Aum Ranges the user is following Allocator Only */
  aumRanges: Maybe<Array<AumRange>>;
  /** Entities the watchlist follows */
  entities: Maybe<Array<Entity>>;
  /** Entities that are from mass imports */
  entitiesFromMassImport: Maybe<Array<Entity>>;
  /** Entities that are followed reguarly, not through csv imports */
  entitiesRegularFollows: Maybe<Array<Entity>>;
  /** Fund Strategies the user is following Allocator Only */
  fundStrategies: Maybe<Array<FundStrategy>>;
  /** Fund Types the user is following Allocator Only */
  fundTypes: Maybe<Array<FundType>>;
  /** Geographies the watchlist follows */
  geographies: Maybe<Array<Geography>>;
  /** The id of the watchlist */
  id: Scalars['ID']['output'];
  /** Mass imports associated with the watchlist */
  massImports: Maybe<Array<MassImport>>;
  /** The onboarding status of the watchlist Watchlist::ONBOARDING_STATUSES */
  onboardingStatus: Scalars['String']['output'];
  /** Sectors the watchlist follows */
  sectors: Maybe<Array<Sector>>;
  /** Users the watchlist is following */
  users: Maybe<Array<User>>;
};

export type WatchlistTagRelationship = {
  __typename?: 'WatchlistTagRelationship';
  /** The time stamp of the tag relationship */
  createdAt: Scalars['String']['output'];
  /** The tagged entity */
  entity: Maybe<Entity>;
  /** The id of the watchlist tag relationship */
  id: Scalars['ID']['output'];
  /** The id of the tagged item */
  tagId: Scalars['ID']['output'];
};

export type WhitePaper = {
  __typename?: 'WhitePaper';
  /** Employer associated with the white paper */
  associatedEmployer: Maybe<Employer>;
  /** Attachment extentions public_field */
  attachmentExtensions: Maybe<Array<Scalars['String']['output']>>;
  categories: Array<Scalars['String']['output']>;
  comments: Maybe<CommentConnection>;
  /** public_field */
  commentsCount: Maybe<Scalars['Int']['output']>;
  /** list of mentionables */
  commentsMentionableList: Maybe<Array<Mentionable>>;
  /** public_field */
  elevatorPitch: Scalars['String']['output'];
  /** public_field */
  esgNames: Scalars['String']['output'];
  esgs: Maybe<Array<Esg>>;
  /** If the white paper has been featured on a fund profile */
  featuredOnAFundProfile: Maybe<Scalars['Boolean']['output']>;
  geographies: Maybe<Array<Geography>>;
  /** public_field */
  geographyNames: Scalars['String']['output'];
  /** public_field */
  globalMacroNames: Scalars['String']['output'];
  globalMacros: Maybe<Array<GlobalMacro>>;
  /** public_field */
  id: Scalars['ID']['output'];
  isAuthor: Maybe<Scalars['Boolean']['output']>;
  /** Related tickers tagged by the author */
  mentionedEntities: Maybe<Array<Entity>>;
  /** For rendering PDF thesis on white paper show */
  pdfThesisUrl: Maybe<Scalars['String']['output']>;
  positionDisclaimerFund: Maybe<Scalars['Boolean']['output']>;
  positionDisclaimerIndividual: Maybe<Scalars['Boolean']['output']>;
  postedAt: Scalars['String']['output'];
  ratings: Maybe<Rating>;
  /** Ideas on entities tagged by the white paper */
  relatedIdeas: Maybe<Array<Idea>>;
  /** public_field */
  sectorNames: Scalars['String']['output'];
  sectors: Maybe<Array<Sector>>;
  status: Scalars['String']['output'];
  subcategories: Maybe<Array<Subcategory>>;
  /** public_field */
  submittedAt: Maybe<Scalars['String']['output']>;
  /** public_field */
  tagList: Array<Scalars['String']['output']>;
  /** public_field */
  thesis: Scalars['String']['output'];
  thesisText: Scalars['String']['output'];
  /** public_field */
  title: Scalars['String']['output'];
  /** public_field */
  updatedAt: Scalars['String']['output'];
  /** public_field */
  user: User;
  /** public_field */
  whitePaperAttachments: Maybe<Array<WhitePaperAttachment>>;
  whitePaperUpdates: Array<WhitePaperUpdate>;
  /** public_field */
  youtubeIds: Maybe<Array<Scalars['String']['output']>>;
};


export type WhitePaperCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type WhitePaperAttachment = {
  __typename?: 'WhitePaperAttachment';
  attachable: Attachable;
  attachmentType: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  description: Scalars['String']['output'];
  fileType: Scalars['String']['output'];
  /** public_field */
  filename: Scalars['String']['output'];
  /** public_field */
  id: Scalars['ID']['output'];
  researchType: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WhitePaperUpdate = {
  __typename?: 'WhitePaperUpdate';
  body: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  user: User;
  whitePaper: WhitePaper;
};

export type YearMonthDay = {
  __typename?: 'YearMonthDay';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/** Autogenerated input type of apiKey */
export type ApiKeyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  prefix: Scalars['String']['input'];
  rawText?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of apiKey */
export type ApiKeyPayload = {
  __typename?: 'apiKeyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId: Maybe<Scalars['String']['output']>;
  key: Maybe<Scalars['String']['output']>;
};

export type AdminAssetFragment = { __typename?: 'Asset', id: string, assetClassName: string | null, bbgId: string | null, currencyCode: string | null, currencyName: string | null, cusip: string | null, factsetSymbol: string | null, forcePrimaryEntityAsset: boolean | null, fsPermSecId: string | null, fundamentalCurrencyCode: string | null, fundamentalCurrencyName: string | null, ideaIds: Array<string> | null, name: string | null, symbol: string | null, userSymbol: string | null, yahooSymbol: string | null };

export type AdminEntityFragment = { __typename?: 'Entity', id: string, name: string | null, status: string | null, factsetEntityId: string | null, hideFromIndex: boolean | null };

export type CreateApiKeyMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  prefix: Scalars['String']['input'];
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  rawText?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'apiKeyPayload', key: string | null } | null };

export type MergeEntitiesMutationVariables = Exact<{
  toMergeId: Scalars['ID']['input'];
  destinationId: Scalars['ID']['input'];
  assetsToMerge: Array<AssetsToMergeAttributes> | AssetsToMergeAttributes;
}>;


export type MergeEntitiesMutation = { __typename?: 'Mutation', mergeEntities: { __typename?: 'MergeEntitiesPayload', entity: { __typename?: 'Entity', id: string } | null } | null };

export type UpdateApiKeyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  demo?: InputMaybe<Scalars['Boolean']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateApiKeyMutation = { __typename?: 'Mutation', updateApiKey: { __typename?: 'ChangeKeyStatusPayload', apiKey: { __typename?: 'ApiKey', id: string } | null } | null };

export type UpdateEntityAdminMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  factsetEntityId: Scalars['String']['input'];
  approve?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromIndex: Scalars['Boolean']['input'];
}>;


export type UpdateEntityAdminMutation = { __typename?: 'Mutation', updateEntityAdmin: { __typename?: 'UpdateEntityAdminPayload', entity: { __typename?: 'Entity', id: string, name: string | null, status: string | null, factsetEntityId: string | null, hideFromIndex: boolean | null } | null } | null };

export type AdminEntityQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type AdminEntityQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, name: string | null, status: string | null, factsetEntityId: string | null, hideFromIndex: boolean | null } | null };

export type EntitiesMergeSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type EntitiesMergeSearchQuery = { __typename?: 'Query', entitiesSearch: Array<{ __typename?: 'Entity', id: string, name: string | null, factsetEntityId: string | null }> | null };

export type MergeEntityAssetsQueryVariables = Exact<{
  mergeToEntityId: Scalars['ID']['input'];
  destinationEntityId: Scalars['ID']['input'];
}>;


export type MergeEntityAssetsQuery = { __typename?: 'Query', mergeToEntity: { __typename?: 'Entity', id: string, name: string | null, assets: Array<{ __typename?: 'Asset', id: string, assetClassName: string | null, bbgId: string | null, currencyCode: string | null, currencyName: string | null, cusip: string | null, factsetSymbol: string | null, forcePrimaryEntityAsset: boolean | null, fsPermSecId: string | null, fundamentalCurrencyCode: string | null, fundamentalCurrencyName: string | null, ideaIds: Array<string> | null, name: string | null, symbol: string | null, userSymbol: string | null, yahooSymbol: string | null }> | null } | null, destinationEntity: { __typename?: 'Entity', id: string, name: string | null, assets: Array<{ __typename?: 'Asset', id: string, assetClassName: string | null, bbgId: string | null, currencyCode: string | null, currencyName: string | null, cusip: string | null, factsetSymbol: string | null, forcePrimaryEntityAsset: boolean | null, fsPermSecId: string | null, fundamentalCurrencyCode: string | null, fundamentalCurrencyName: string | null, ideaIds: Array<string> | null, name: string | null, symbol: string | null, userSymbol: string | null, yahooSymbol: string | null }> | null } | null };

export type WatchlistFilterEntitiesSearchQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type WatchlistFilterEntitiesSearchQuery = { __typename?: 'Query', entities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }> | null };

export type ApiKeyRetrievalQueryVariables = Exact<{ [key: string]: never; }>;


export type ApiKeyRetrievalQuery = { __typename?: 'Query', apiKeys: Array<{ __typename?: 'ApiKey', id: string, active: boolean, demo: boolean, prefix: string, user: { __typename?: 'User', displayName: string } }> | null };

export type SearchQueryVariables = Exact<{
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', userSearch: Array<{ __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null }> | null };

export type AccreditedInvestorProfileFragment = { __typename?: 'AccreditedInvestorProfile', id: string, bonds: string | null, foreignCurrencies: string | null, futuresOrCommodities: string | null, hedgeFunds: string | null, investmentSize: string | null, netWorth: string | null, next12MoAllocation: string | null, privateCompanies: string | null, privateEquityFunds: string | null, publiclyTradedStocks: string | null, realEstate: string | null, updatedAt: string, yearsInvesting: string | null };

export type AccreditedInvestorProfileIndexItemFragment = { __typename?: 'AccreditedInvestorProfile', id: string, user: { __typename?: 'User', id: string, profileCity: string | null, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, summary: string | null } | null } };

export type ActivityFeedAdminPostFragment = { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type ActivityFeedAllocatorProfileFragment = { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null };

export type ActivityFeedAssetFragment = { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null };

export type ActivityFeedCommentFragment = { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentableType: string | null, commentCreationTime: string, currentUserHasLiked: boolean, likeCount: number, parentId: string | null, anonUser: { __typename?: 'AnonUser', id: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type ActivityFeedCorporateActionFragment = { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null };

export type ActivityFeedEmployerProfileFragment = { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null };

export type ActivityFeedEmployerProfileDocumentFragment = { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null };

export type ActivityFeedEmployerProfilePressFragment = { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null };

export type ActivityFeedEmployerProfileUpdateFragment = { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null };

export type ActivityFeedEntityFragment = { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null };

export type ActivityFeedFeatureFragment = { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null };

export type ActivityFeedIdeaFragment = { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type ActivityFeedIdeaUpdateFragment = { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null };

export type ActivityFeedItemFragment = { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null } | { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null } | null };

export type ActivityFeedJobPostingFragment = { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null };

export type ActivityFeedPostFragment = { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type ActivityFeedPublishedCommentFragment = { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type ActivityFeedRankFragment = { __typename?: 'Rank', id: string, category: string, value: number | null, user: { __typename?: 'User', publishedIdeasCount: number, id: string, displayName: string, profileImageUrl: string | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null, topIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, totalReturn: number | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null> | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null } | null, pastRank: { __typename?: 'Rank', id: string, category: string, value: number | null } | null };

export type ActivityFeedUserFragment = { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null };

export type ActivityFeedWhitePaperFragment = { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } };

export type AllocatorProfileBackgroundImageFragment = { __typename?: 'AllocatorProfile', backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null };

export type AllocatorProfileCardFragment = { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null };

export type AllocatorProfileRecommendationFragment = { __typename?: 'FundRecommendation', id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, matchesGeographies: boolean | null, matchesSectors: boolean | null, matchesAssetClasses: boolean | null, geographiesMatching: Array<string> | null, sectorsMatching: Array<string> | null, assetClassesMatching: Array<string> | null, hide: boolean | null, allocatorProfile: { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null } | null, fundProfile: { __typename?: 'EmployerProfile', id: string, name: string | null } | null };

export type AllocatorProfileExecutiveManagementFragment = { __typename?: 'AllocatorProfile', executives: Array<{ __typename?: 'AllocatorProfileExecutive', id: string, name: string | null, bio: string | null, photoUrl: string | null, photoProfileUrl: string | null, defaultPhoto: string | null }> | null };

export type AllocatorProfileInvestmentPreferencesFragment = { __typename?: 'AllocatorProfile', sectorPreferences: Array<string> | null, geographyPreferences: Array<string> | null, assetClassPreferences: Array<string> | null, fundTypePreferences: Array<string> | null, fundStrategyPreferences: Array<string> | null, aumRangePreferences: Array<string> | null };

export type BadgesFragment = { __typename?: 'Badge', id: string, name: string, description: string, order: number };

export type ChatMessageFragment = { __typename?: 'ChatMessage', id: string, anonymous: boolean | null, body: string, createdAt: string, direction: string | null, participantName: string, user: { __typename?: 'User', id: string, profileCity: string | null, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } };

export type CompanyPageFundamentalFragment = { __typename?: 'Fundamental', id: string, bookValue: number | null, currentPe: number | null, debtBook: number | null, divYield: number | null, ev: number | null, evEbitda: number | null, evFcf: number | null, evSales: number | null, fcfYield: number | null, forwardPe: number | null, marketCap: number | null, priceBook: number | null, sellsideConsensus: number | null, threeMonthAdv: number | null, totalCash: number | null, totalDebt: number | null };

export type CompanyQuestionFragment = { __typename?: 'CompanyQuestion', answerOptions: Array<string>, expirationMonths: number | null, name: string, questionType: string, text: string };

export type CompensationFieldsFragment = { __typename?: 'Compensation', id: string, completed: boolean, status: string, category: string, year: number, title: string, experience: string, industry: string, location: string, fundType: string, fundStrategy: string, fundSize: string, assetClass: string, baseSalary: number, interestMgmtFeesPerc: number, interestMgmtFeesValue: number, vestingMgmtFees: number, interestIncentiveFeesPerc: number, interestIncentiveFeesValue: number, vestingIncentiveFees: number, annualDiscrBonus: number, totalDeferredComp: number, investInFund: boolean | null, buildPersonalTrackRecord: boolean | null, marketPersonalTrackRecord: boolean | null, comments: string | null };

export type ContestIndexCardFragment = { __typename?: 'Contest', id: string, active: boolean | null, startDate: string | null, endDate: string | null, name: string | null, promoSummary: string | null, prizes: Array<{ __typename?: 'ContestPrizeType', id: string, description: string | null, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null };

export type CryptoQuoteFragment = { __typename?: 'CryptoMarketData', circulatingSupply: number | null, fullyDilutedMarketCap: number | null, marketCap: number | null, maxSupply: number | null, percentChange24h: number | null, percentChange7d: number | null, totalSupply: number | null, volume24h: number | null };

export type FeaturedIdeaFragment = { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null };

export type FeaturedRankingFragment = { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean };

export type FollowIdsFragment = { __typename?: 'User', followedFundIds: Array<string>, followedUserIds: Array<string>, followedEntityIds: Array<string>, followedEsgIds: Array<string>, followedGeographyIds: Array<string>, followedGlobalMacroIds: Array<string>, followedSectorIds: Array<string> };

export type FundProfileAdminDashboardFragment = { __typename?: 'EmployerProfile', status: string | null, updatedAt: string | null, introRequestsLeft: number | null, introRequestPeriodEnd: string | null };

export type FundProfileBackgroundImageFragment = { __typename?: 'EmployerProfile', backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null };

export type FundProfileCardFragment = { __typename?: 'EmployerProfile', id: string, aumRange: string | null, description: string | null, focus: string | null, followerCount: number | null, foundingYear: string | null, fundType: string | null, location: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', ltm: number | null, sinceInception: number | null, ytd: number | null } | null };

export type FundProfileIndexItemFragment = { __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, highlights: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', id: string | null, ltm: number | null, sinceInception: number | null, ytd: number | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null };

export type FundProfileRecommendationFragment = { __typename?: 'FundRecommendation', id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, fundProfile: { __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, highlights: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', id: string | null, ltm: number | null, sinceInception: number | null, ytd: number | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null } | null };

export type FundProfileSavedSearchFragment = { __typename?: 'EmployerProfileSearchAlert', id: string, name: string | null, savedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null, searchKey: string } | null };

export type FundProfileDueDiligenceFragment = { __typename?: 'EmployerProfile', dueDiligenceDocuments: Array<{ __typename?: 'EmployerProfileDueDiligenceDocument', id: string, name: string, category: string, description: string, filename: string | null }> | null, serviceProviders: Array<{ __typename?: 'EmployerProfileServiceProvider', id: string, category: string | null, firmName: string | null, contactName: string | null, contactEmail: string | null, contactPhoneNumber: string | null }> | null };

export type FundProfileExecutiveManagementFragment = { __typename?: 'EmployerProfile', executives: Array<{ __typename?: 'EmployerProfileExecutive', id: string, name: string | null, bio: string | null, photoUrl: string | null, photoProfileUrl: string | null, defaultPhoto: string | null }> | null };

export type FundProfileExpertiseFragment = { __typename?: 'EmployerProfile', sectorExpertise: Array<string> | null, geographicExpertise: Array<string> | null, assetClassExpertise: Array<string> | null, subsectorExpertise: string | null };

export type FundProfileFeaturedResearchFragment = { __typename?: 'EmployerProfile', featuredResearch: Array<{ __typename?: 'Idea', id: string, postedAt: string | null, totalReturn: number | null, elevatorPitch: string | null, canCurrentUserViewIdeaFilterDetails: boolean, updated: string, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', name: string | null } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } | null }> | null };

export type FundProfileFeaturedWhitePaperResearchFragment = { __typename?: 'EmployerProfile', featuredWhitePaperResearch: Array<{ __typename?: 'WhitePaper', id: string, elevatorPitch: string, submittedAt: string | null, title: string, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } }> | null };

export type FundProfileFeeStructureFragment = { __typename?: 'EmployerProfile', managementFee: number | null, incentiveFee: number | null, hurdleRate: number | null, lockUp: number | null, highwaterMark: boolean | null, seedDeal: boolean | null, foundersShares: boolean | null, investorLevelGates: boolean | null, feeStructureDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null };

export type FundProfileFirmReferencesFragment = { __typename?: 'EmployerProfile', firmReferences: Array<{ __typename?: 'EmployerProfileFirmReference', id: string, name: string | null, employer: string | null, title: string | null, contactEmail: string | null, relationshipToFund: string | null }> | null };

export type FundProfileFundHoldingsFragment = { __typename?: 'EmployerProfile', holdingsUpdatedDate: string | null, holdings: Array<{ __typename?: 'EmployerProfileHolding', id: string, percentOfPortfolio: number | null, entityName: string | null, primarySymbol: string | null, assetClass: string | null, realizedReturn: number | null, expectedReturn: number | null, averageCost: number | null, action: string | null, priceTarget: string | null, timeframe: string | null }> | null, holdingsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null };

export type FundProfileMarketingMaterialsFragment = { __typename?: 'EmployerProfile', marketingMaterials: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null, filename: string | null, url: string | null }> | null };

export type FundProfileMetricsFragment = { __typename?: 'EmployerProfile', beta: number | null, sharpeRatio: number | null, turnoverRatio: number | null, metricsUpdatedAt: string | null, metricsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null };

export type FundProfileNotesFragment = { __typename?: 'EmployerProfile', notes: string | null };

export type FundProfilePressMediaFragment = { __typename?: 'EmployerProfile', presses: Array<{ __typename?: 'EmployerProfilePress', id: string, title: string | null, url: string | null, filename: string | null, fileUrl: string | null, publishDate: string | null, description: string | null, previewImageUrl: string | null }> | null };

export type FundProfileReturnsFragment = { __typename?: 'EmployerProfile', name: string | null, returnsUpdatedDate: string | null, returns: Array<{ __typename?: 'EmployerReturn', id: string | null, benchmark: string | null, employerBenchmark: boolean | null, employerProfileId: string, fiveYear: number | null, ltm: number | null, oneYear: number | null, sevenYear: number | null, sinceInception: number | null, status: string | null, tenYear: number | null, threeYear: number | null, ytd: number | null }> | null, returnsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, category: string | null, description: string | null, filename: string | null, name: string | null, url: string | null }> | null };

export type FundProfileTagsFragment = { __typename?: 'EmployerProfile', tagNames: Array<string> | null };

export type IdeaAttachmentsFragment = { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null };

export type IdeaResearchItemFragment = { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null };

export type IdeaSavedSearchFragment = { __typename?: 'IdeaSearchAlert', id: string, name: string | null, savedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null, searchKey: string } | null };

export type IdeaShowPageCommentFragment = { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, likeCount: number, currentUserHasLiked: boolean, parentId: string | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, commentAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null };

export type IdeaSubmissionAssetFragment = { __typename?: 'Asset', id: string, currencyCode: string | null, latestPrice: number | null, name: string | null, primarySymbol: string | null, entity: { __typename?: 'Entity', name: string | null } };

export type IdeaSubmissionDraftFragment = { __typename?: 'Idea', id: string, anonymous: boolean, catalystNames: Array<string>, contestIds: Array<string>, elevatorPitch: string | null, employerApprovalDisclaimer: boolean | null, featuredOnAFundProfile: boolean | null, isPairTrade: boolean | null, noPriorAgreementDisclaimer: boolean | null, pairRatio: Array<number> | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, publicInformationDisclaimer: boolean | null, returnTarget: number | null, situation: string | null, status: string | null, tagList: Array<string>, targetAllocation: string | null, thesis: string | null, timeframe: string | null, associatedEmployer: { __typename?: 'Employer', id: string } | null, ideaAttachments: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, positions: Array<{ __typename?: 'Position', id: string, latestPrice: number | null, priceTarget: number | null, direction: string, asset: { __typename?: 'Asset', id: string } | null }>, user: { __typename?: 'User', id: string } | null };

export type IdeaUpdatesFragment = { __typename?: 'IdeaUpdate', id: string, addedCatalystNames: Array<string> | null, body: string | null, catalystNames: Array<string>, closed: boolean, createdAt: string, commentsCount: number | null, impact: string | null, priceTarget: number | null, removedCatalystNames: Array<string> | null, removedPriceTarget: number | null, removedReturnTarget: number | null, removedSituation: string | null, removedTargetAllocation: string | null, removedTimeframe: string | null, returnTarget: number | null, situation: string | null, targetAllocation: string | null, timeframe: string | null, truncated: boolean, youtubeIds: Array<string> | null, ideaAttachmentsArray: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null };

export type IdeaViewFragment = { __typename?: 'IdeaView', actions: Array<string>, id: string, ideaAssetSymbol: string | null, ideaId: string, timestamp: string, timeAgo: string, viewerAumRange: string | null, viewerCityName: string | null, viewerFundType: string | null, viewerTitle: string | null, viewer: { __typename?: 'User', canReceiveViewerIntroRequest: boolean | null, id: string, emailPreferences: Array<{ __typename?: 'EmailPreference', id: string, emailType: string, subscribed: boolean | null }> | null }, viewerIntroRequest: { __typename?: 'ViewerIntroRequest', id: string, status: string } | null };

export type InsiderTradeFragment = { __typename?: 'InsiderTrade', id: string, date: string, entityId: string | null, name: string, numShares: number, ownershipChangePct: string | null, sharePrice: string, symbol: string, title: string, tradeType: string };

export type JobVaultEmployerFragment = { __typename?: 'Employer', id: string, name: string, assets: Array<string> | null, aumRange: string | null, description: string | null, fundType: string | null, investmentStyle: string | null, regions: Array<string> | null, strategy: string | null, sectors: Array<string> | null };

export type MembersIndexCardFragment = { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type MembersIndexCardUserFragment = { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null };

export type MessageItemFragment = { __typename?: 'Message', id: string, thread: string | null, threadCount: number | null, createdAt: string | null, body: string | null, subject: string | null, senderIsCurrentUser: boolean | null, readStatus: boolean | null, isCapIntroMessage: boolean | null, otherParty: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string } | null } | null } | null };

export type MessageThreadItemFragment = { __typename?: 'Message', id: string, thread: string | null, subject: string | null, body: string | null, createdAt: string | null, readStatus: boolean | null, archiveStatus: boolean | null, isCapIntroMessage: boolean | null, rootMessage: { __typename?: 'Message', id: string } | null, jobPosting: { __typename?: 'JobPosting', id: string, title: string } | null, otherParty: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string } | null } | null } | null, sender: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } | null, introRequest: { __typename?: 'IntroRequest', id: string, status: string } | null, messageAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null };

export type PaladinQuotaFragment = { __typename?: 'Paladin', nextQuotaDeadline: string, ratingQuota: string | null, ratingCurrentMonth: string | null, ratingPercent: string | null, commentQuota: string | null, commentCurrentMonth: string | null, commentPercent: string | null, pollAnswerQuota: string | null, pollAnswerCurrentMonth: string | null, pollAnswerPercent: string | null, hasPollAnswerQuota: boolean | null };

export type PartnerOfferFragmentFragment = { __typename?: 'AdCampaign', id: string, partnerName: string, name: string, headline: string, body: string, actionText: string, modalText: string, modalHeaderText: string | null, headlineImageUrl: string | null, additionalModalLinkLink: string | null, additionalModalLinkText: string | null, redirectLink: string | null, showTicker: boolean | null };

export type PodcastEpisodeMediaFragment = { __typename?: 'PodcastEpisode', id: string, description: string, tagList: Array<string>, mediaId: string, publishedAt: string, title: string, mentionedEntities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }>, relatedMedia: Array<{ __typename?: 'PodcastEpisode', id: string, description: string, tagList: Array<string>, vanityLink: string | null, title: string }> };

export type PodcastEpisodeMediaIndexFragment = { __typename?: 'PodcastEpisode', id: string, description: string, tagList: Array<string>, thumbnailImageUrl: string | null, vanityLink: string | null, publishedAt: string, title: string, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> };

export type RankCardFragment = { __typename?: 'Rank', id: string, value: number | null, rankString: string, viewDeltaString: string | null, privateDeltaString: string | null, user: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, profileImageUrl: string | null, profileCity: string | null, isFollowedByCurrentUser: boolean, mostRecentEmployer: { __typename?: 'EmployerHistory', currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null, topIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null> | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null, badgeCollectionRelationships: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string } | null } | null } | null> | null } | null } | null };

export type RankingsWidgetRankFragment = { __typename?: 'Rank', id: string, user: { __typename?: 'User', id: string, displayName: string, profileCity: string | null, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, isCurrentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null };

export type ReadingListItemFragment = { __typename?: 'ReadingListItem', id: string, archived: boolean, ideaId: string };

export type ResearchItemFragment = { __typename?: 'Idea', id: string, communityRating: number | null, positions: Array<{ __typename?: 'Position', id: string, entityName: string, primarySymbol: string, asset: { __typename?: 'Asset', id: string, entity: { __typename?: 'Entity', id: string } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profileCity: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null };

export type ResearchItemUserFragment = { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null };

export type UserAccessFragment = { __typename?: 'User', ideaIsBlocked: boolean | null, ideaDaysLeft: string | null, compensationIsBlocked: boolean | null, compensationDaysLeft: string | null, capIntroIsBlocked: boolean | null, capIntroDaysLeft: string | null, jobIsBlocked: boolean | null, jobDaysLeft: string | null };

export type UserEmployerFragment = { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, followerCount: number | null } | null };

export type UserNotificationFragment = { __typename?: 'Notification', id: string, description: string | null, createdAt: string | null, viewed: boolean, linkId: string | null, customLink: string | null, notificationClass: string | null, hidden: boolean | null, associatedUser: { __typename?: 'User', id: string, isAllocator: boolean, allocatorProfileLogoUrl: string | null, profileImageUrl: string | null } | null };

export type UserProfileFragment = { __typename?: 'User', displayName: string, activeFollowedUsersCount: number, activeFollowersCount: number, isAllocator: boolean, profileImageUrl: string | null, publishedIdeasCount: number, currentEmployers: Array<{ __typename?: 'Employer', id: string, name: string }>, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, profile: { __typename?: 'Profile', id: string } | null, primaryContact: { __typename?: 'User', id: string, displayName: string, email: string } | null };

export type UserProfileAdminDashboardFragment = { __typename?: 'Profile', hasFilledPrivateProfile: boolean | null, user: { __typename?: 'User', canPostJobs: boolean, isHighProfile: boolean | null } | null };

export type UserProfileBackgroundImageFragment = { __typename?: 'Profile', backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null };

export type UserProfileCardFragment = { __typename?: 'Profile', imageProfileUrl: string | null, imageUrl: string | null, defaultImage: string | null, certifications: Array<string> | null, city: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, activeFollowedUsersCount: number, activeFollowersCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, hasFundProfile: boolean } | null } | null } | null };

export type UserProfileContactFragment = { __typename?: 'Profile', email: string | null, mobilePhone: string | null, workPhone: string | null };

export type UserProfileAcademicPerformanceFragment = { __typename?: 'Profile', hasGpa: boolean | null, hasSatOrAct: boolean | null, profileTestResults: Array<{ __typename?: 'ProfileTestResult', id: string, name: string | null, score: number | null, maxScore: string | null, date: string | null, url: string | null, filename: string | null }> | null };

export type UserProfileAwardsFragment = { __typename?: 'Profile', user: { __typename?: 'User', historicalPublicRankings: Array<string> | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, earnedAt: string | null, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null };

export type UserProfileEducationFragment = { __typename?: 'Profile', schoolHistories: Array<{ __typename?: 'SchoolHistory', id: string, schoolName: string, degree: string | null, fieldOfStudy: string | null, currentStudent: boolean | null, startYear: number | null, gradYear: number | null }> | null };

export type UserProfileExpertiseFragment = { __typename?: 'Profile', sectorExpertise: Array<string> | null, geographicExpertise: Array<string> | null, assetClassExpertise: Array<string> | null };

export type UserProfilePersonalDetailsFragment = { __typename?: 'Profile', hometown: string | null, investmentHero: string | null, favoriteInvestmentBook: string | null, investingStyle: string | null, languagesSpoken: string | null };

export type UserProfileQAndAFragment = { __typename?: 'Profile', hasAnyProfileAnswers: boolean | null, hasAllProfileAnswers: boolean | null, profileAnswers: Array<{ __typename?: 'ProfileAnswer', profileQuestionId: number | null, answer: string | null }> | null };

export type UserProfileResearchFragment = { __typename?: 'Profile', postedInLast3Months: boolean | null, user: { __typename?: 'User', recentIdea: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null, profileAttachments: Array<{ __typename?: 'ProfileAttachmentType', id: string, name: string | null, description: string | null, filename: string | null }> | null };

export type UserProfileResearchPerformanceFragment = { __typename?: 'Profile', ideaTotalReturnAverage: string | null, ideaReturnVsBenchmarkAverage: string | null, ideaAnnualizedReturnMedian: string | null };

export type UserProfileResumePhoneFragment = { __typename?: 'Profile', resume: string | null, workPhone: string | null };

export type UserProfileWorkExperienceFragment = { __typename?: 'Profile', experienceByFirmType: string | null, employerHistories: Array<{ __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, fromDate: string | null, primary: boolean, title: string | null, toDate: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, aumRangePresent: boolean | null, fundType: string | null } | null }> | null };

export type UserWatchlistFragment = { __typename?: 'Watchlist', id: string, onboardingStatus: string, sectors: Array<{ __typename?: 'Sector', id: string, name: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string, name: string }> | null, assetClasses: Array<{ __typename?: 'AssetClass', id: string, name: string }> | null, entitiesFromMassImport: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, entitiesRegularFollows: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, massImports: Array<{ __typename?: 'MassImport', id: string, numberOfTickers: number, fileName: string }> | null, users: Array<{ __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null }> | null, aumRanges: Array<{ __typename?: 'AumRange', id: string, name: string }> | null, fundTypes: Array<{ __typename?: 'FundType', id: string, name: string }> | null, fundStrategies: Array<{ __typename?: 'FundStrategy', id: string, name: string }> | null };

export type VideoMediaFragment = { __typename?: 'Video', id: string, description: string, publishedAt: string, tagList: Array<string>, title: string, mediaId: string, mentionedEntities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }>, relatedMedia: Array<{ __typename?: 'Video', id: string, description: string, tagList: Array<string>, title: string, vanityLink: string | null }> };

export type VideoMediaIndexFragment = { __typename?: 'Video', id: string, description: string, publishedAt: string, tagList: Array<string>, thumbnailImageUrl: string | null, title: string, vanityLink: string | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> };

export type WhitePaperCategoryNamesFragment = { __typename?: 'WhitePaper', esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string };

export type WhitePaperResearchItemFragment = { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, elevatorPitch: string, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, submittedAt: string | null, tagList: Array<string>, title: string, updatedAt: string, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } };

export type WhitePaperSubmissionDraftFragment = { __typename?: 'WhitePaper', id: string, elevatorPitch: string, featuredOnAFundProfile: boolean | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, status: string, tagList: Array<string>, thesis: string, thesisText: string, title: string, associatedEmployer: { __typename?: 'Employer', id: string } | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, esgs: Array<{ __typename?: 'Esg', id: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string }> | null, globalMacros: Array<{ __typename?: 'GlobalMacro', id: string }> | null, sectors: Array<{ __typename?: 'Sector', id: string }> | null, user: { __typename?: 'User', id: string }, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, attachmentType: string, filename: string, createdAt: string, researchType: string, fileType: string, url: string }> | null };

export type AcceptFundDisclaimerMutationVariables = Exact<{ [key: string]: never; }>;


export type AcceptFundDisclaimerMutation = { __typename?: 'Mutation', acceptFundDisclaimer: { __typename?: 'AcceptFundDisclaimerPayload', currentUser: { __typename?: 'User', id: string, acceptedFundDisclaimer: boolean } | null } | null };

export type ArchiveThreadMutationVariables = Exact<{
  threadNum: Scalars['ID']['input'];
}>;


export type ArchiveThreadMutation = { __typename?: 'Mutation', archiveThread: { __typename?: 'ArchiveThreadPayload', id: string | null } | null };

export type AssociateViewerIntroRequestMessageMutationVariables = Exact<{
  viewerIntroRequestId: Scalars['ID']['input'];
  messageId: Scalars['ID']['input'];
}>;


export type AssociateViewerIntroRequestMessageMutation = { __typename?: 'Mutation', associateViewerIntroRequestMessage: { __typename?: 'AssociateViewerIntroRequestMessagePayload', success: boolean } | null };

export type ClickIdeaRecommendationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
}>;


export type ClickIdeaRecommendationMutation = { __typename?: 'Mutation', clickIdeaRecommendation: { __typename?: 'ClickIdeaRecommendationPayload', currentUser: { __typename?: 'User', id: string } | null } | null };

export type ClickedNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ClickedNotificationsMutation = { __typename?: 'Mutation', clickedNotifications: { __typename?: 'ClickedNotificationsPayload', currentUser: { __typename?: 'User', id: string, newNotificationsCount: number | null } | null } | null };

export type CloseQuickPositionMutationVariables = Exact<{
  quickPositionId: Scalars['ID']['input'];
}>;


export type CloseQuickPositionMutation = { __typename?: 'Mutation', closeQuickPosition: { __typename?: 'CloseQuickPositionPayload', quickPosition: { __typename?: 'QuickPosition', id: string, closedAt: string | null, closingPrice: number | null, direction: string, asset: { __typename?: 'Asset', id: string, symbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } } } | null };

export type CloseJobPostMutationVariables = Exact<{
  jobPostId: Scalars['ID']['input'];
  hired: Scalars['Boolean']['input'];
  applicationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CloseJobPostMutation = { __typename?: 'Mutation', closeJobPost: { __typename?: 'CloseUserJobPostPayload', currentUser: { __typename?: 'User', id: string, jobPostings: Array<{ __typename?: 'JobPosting', id: string, status: string | null, title: string, postedAt: string | null, updatedAt: string | null }> } | null } | null };

export type CreateAdLeadMutationVariables = Exact<{
  adId: Scalars['ID']['input'];
  requestedTicker?: InputMaybe<Scalars['String']['input']>;
  tickerOnPage?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAdLeadMutation = { __typename?: 'Mutation', createAdLead: { __typename?: 'CreateAdLeadPayload', partnerOffer: { __typename?: 'AdCampaign', id: string, partnerName: string, name: string, headline: string, body: string, actionText: string, modalText: string, modalHeaderText: string | null, headlineImageUrl: string | null, additionalModalLinkLink: string | null, additionalModalLinkText: string | null, redirectLink: string | null, showTicker: boolean | null } | null } | null };

export type CreateBlocklistEntryMutationVariables = Exact<{
  allocatorProfileId: Scalars['ID']['input'];
  employerProfileId: Scalars['ID']['input'];
}>;


export type CreateBlocklistEntryMutation = { __typename?: 'Mutation', createAllocatorBlocklistEntry: { __typename?: 'CreateAllocatorBlocklistEntryPayload', newBlocklistEntry: { __typename?: 'AllocatorBlocklistEntry', id: string, allocatorProfile: { __typename?: 'AllocatorProfile', id: string } } | null } | null };

export type CreateAuditRecordMutationVariables = Exact<{
  auditableId: Scalars['ID']['input'];
  auditableType: Scalars['String']['input'];
  action: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  parentType?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAuditRecordMutation = { __typename?: 'Mutation', createAuditRecord: { __typename?: 'CreateAuditRecordPayload', success: boolean | null } | null };

export type CreateChatMessageMutationVariables = Exact<{
  anonymous: Scalars['Boolean']['input'];
  body: Scalars['String']['input'];
  chatId: Scalars['ID']['input'];
}>;


export type CreateChatMessageMutation = { __typename?: 'Mutation', createChatMessage: { __typename?: 'CreateChatMessagePayload', chatMessage: { __typename?: 'ChatMessage', id: string, anonymous: boolean | null, body: string, createdAt: string, direction: string | null, participantName: string, user: { __typename?: 'User', id: string, profileCity: string | null, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } } | null } | null };

export type CreateCommentMutationVariables = Exact<{
  feedItemId: Scalars['ID']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CreateCommentPayload', comment: { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentableType: string | null, commentCreationTime: string, currentUserHasLiked: boolean, likeCount: number, parentId: string | null, anonUser: { __typename?: 'AnonUser', id: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null };

export type CreateEventImpressionMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
  elapsedTime?: InputMaybe<Scalars['Int']['input']>;
  index?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateEventImpressionMutation = { __typename?: 'Mutation', createEventImpression: { __typename?: 'CreateEventImpressionPayload', event: { __typename?: 'Event', id: string } | null } | null };

export type CreateFundProfileMutationVariables = Exact<{
  employerId: Scalars['ID']['input'];
}>;


export type CreateFundProfileMutation = { __typename?: 'Mutation', createFundProfile: { __typename?: 'CreateFundProfilePayload', success: boolean } | null };

export type CreateFundProfileMessageMutationVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type CreateFundProfileMessageMutation = { __typename?: 'Mutation', createFundProfileMessage: { __typename?: 'CreateFundProfileMessagePayload', success: boolean } | null };

export type CreateFundProfileSearchAlertMutationVariables = Exact<{
  query: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateFundProfileSearchAlertMutation = { __typename?: 'Mutation', createEmployerProfileSearchAlert: { __typename?: 'CreateFundProfileSearchAlertPayload', searchAlert: { __typename?: 'EmployerProfileSearchAlert', id: string, name: string | null, savedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null, searchKey: string } | null } | null } | null };

export type CreateIdeaCommentMutationVariables = Exact<{
  body?: InputMaybe<Scalars['String']['input']>;
  ideaId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  response?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  controlName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateIdeaCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CreateCommentPayload', comment: { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, likeCount: number, currentUserHasLiked: boolean, parentId: string | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, commentAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null } | null } | null };

export type CreateIdeaSearchAlertMutationVariables = Exact<{
  query: Scalars['String']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateIdeaSearchAlertMutation = { __typename?: 'Mutation', createIdeaSearchAlert: { __typename?: 'CreateIdeaSearchAlertPayload', searchAlert: { __typename?: 'IdeaSearchAlert', id: string, name: string | null, savedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null, searchKey: string } | null } | null } | null };

export type CreateIdeaUpdateCommentMutationVariables = Exact<{
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  ideaUpdateId: Scalars['ID']['input'];
  requestResponse?: InputMaybe<Scalars['Boolean']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['ID']['input']>;
  controlName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateIdeaUpdateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CreateCommentPayload', comment: { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, likeCount: number, currentUserHasLiked: boolean, parentId: string | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, commentAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null } | null } | null };

export type CreateIntroRequestMutationVariables = Exact<{
  allocatorProfileId: Scalars['ID']['input'];
  fundProfileId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateIntroRequestMutation = { __typename?: 'Mutation', createIntroRequest: { __typename?: 'CreateIntroRequestPayload', currentUser: { __typename?: 'User', id: string } | null, fundProfile: { __typename?: 'EmployerProfile', id: string, introRequestsLeft: number | null, alreadyRequestedIntro: boolean | null } | null } | null };

export type CreateJobApplicationMutationVariables = Exact<{
  jobPostId: Scalars['ID']['input'];
  phone: Scalars['String']['input'];
  email: Scalars['String']['input'];
  coverLetter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateJobApplicationMutation = { __typename?: 'Mutation', createJobApplication: { __typename?: 'CreateJobApplicationPayload', success: boolean | null } | null };

export type CreateJobPostingMutationVariables = Exact<{
  aum: Scalars['Int']['input'];
  fund_type: Scalars['String']['input'];
  strategy: Scalars['String']['input'];
  employer_city: Scalars['String']['input'];
  employer_description: Scalars['String']['input'];
  asset_class_names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  sector_names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  geography_names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  title: Scalars['String']['input'];
  description: Scalars['String']['input'];
  years_of_experience: Scalars['String']['input'];
  minimum_gpa?: InputMaybe<Scalars['String']['input']>;
  minimum_sat?: InputMaybe<Scalars['Int']['input']>;
  use_company_investment_mandate: Scalars['Boolean']['input'];
  max_gpa: Scalars['String']['input'];
  max_sat: Scalars['String']['input'];
  act_score?: InputMaybe<Scalars['Int']['input']>;
  cover_letter: Scalars['String']['input'];
  position_city: Scalars['String']['input'];
  firm_experience?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  degrees_and_certifications?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  position_asset_class_names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  position_sector_names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  position_geography_names?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateJobPostingMutation = { __typename?: 'Mutation', createJobPosting: { __typename?: 'CreateJobPostingPayload', jobPost: { __typename?: 'JobPosting', id: string, isActive: boolean | null } | null } | null };

export type CreateLeadMutationVariables = Exact<{
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firmName?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateLeadMutation = { __typename?: 'Mutation', createLead: { __typename?: 'CreateLeadPayload', message: string | null } | null };

export type CreateMessageMutationVariables = Exact<{
  body: Scalars['String']['input'];
  receiverUserId: Scalars['ID']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  thread?: InputMaybe<Scalars['ID']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMessageMutation = { __typename?: 'Mutation', createMessage: { __typename?: 'CreateMessagePayload', id: string | null } | null };

export type CreateMessageForThreadMutationVariables = Exact<{
  body: Scalars['String']['input'];
  subject?: InputMaybe<Scalars['String']['input']>;
  thread: Scalars['ID']['input'];
  files?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMessageForThreadMutation = { __typename?: 'Mutation', createMessageForThread: { __typename?: 'CreateMessageForThreadPayload', createdMessage: { __typename?: 'Message', id: string, thread: string | null, subject: string | null, body: string | null, createdAt: string | null, readStatus: boolean | null, archiveStatus: boolean | null, isCapIntroMessage: boolean | null, rootMessage: { __typename?: 'Message', id: string } | null, jobPosting: { __typename?: 'JobPosting', id: string, title: string } | null, otherParty: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string } | null } | null } | null, sender: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } | null, introRequest: { __typename?: 'IntroRequest', id: string, status: string } | null, messageAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null } | null } | null };

export type CreateOrEditIdeaUpdateMutationVariables = Exact<{
  ideaId: Scalars['ID']['input'];
  ideaUpdateId?: InputMaybe<Scalars['ID']['input']>;
  attachments?: InputMaybe<Array<ResearchAttachmentAttributes> | ResearchAttachmentAttributes>;
  body?: InputMaybe<Scalars['String']['input']>;
  catalysts?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  closeIdea: Scalars['Boolean']['input'];
  impact?: InputMaybe<Scalars['String']['input']>;
  priceTarget?: InputMaybe<Scalars['String']['input']>;
  returnTarget?: InputMaybe<Scalars['String']['input']>;
  situation?: InputMaybe<Scalars['String']['input']>;
  targetAllocation?: InputMaybe<Scalars['String']['input']>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrEditIdeaUpdateMutation = { __typename?: 'Mutation', createOrEditIdeaUpdate: { __typename?: 'CreateOrEditIdeaUpdatePayload', ideaUpdate: { __typename?: 'IdeaUpdate', id: string, addedCatalystNames: Array<string> | null, body: string | null, catalystNames: Array<string>, closed: boolean, createdAt: string, commentsCount: number | null, impact: string | null, priceTarget: number | null, removedCatalystNames: Array<string> | null, removedPriceTarget: number | null, removedReturnTarget: number | null, removedSituation: string | null, removedTargetAllocation: string | null, removedTimeframe: string | null, returnTarget: number | null, situation: string | null, targetAllocation: string | null, timeframe: string | null, truncated: boolean, youtubeIds: Array<string> | null, ideaAttachmentsArray: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null } | null } | null };

export type CreateOrUpdateAccreditedInvestorProfileMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  netWorth?: InputMaybe<Scalars['String']['input']>;
  next12MoAllocation?: InputMaybe<Scalars['String']['input']>;
  investmentSize?: InputMaybe<Scalars['String']['input']>;
  yearsInvesting?: InputMaybe<Scalars['String']['input']>;
  bonds?: InputMaybe<Scalars['String']['input']>;
  hedgeFunds?: InputMaybe<Scalars['String']['input']>;
  realEstate?: InputMaybe<Scalars['String']['input']>;
  foreignCurrencies?: InputMaybe<Scalars['String']['input']>;
  futuresOrCommodities?: InputMaybe<Scalars['String']['input']>;
  privateEquityFunds?: InputMaybe<Scalars['String']['input']>;
  publiclyTradedStocks?: InputMaybe<Scalars['String']['input']>;
  privateCompanies?: InputMaybe<Scalars['String']['input']>;
  netWorthReq?: InputMaybe<Scalars['Boolean']['input']>;
  incomeReq?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateOrUpdateAccreditedInvestorProfileMutation = { __typename?: 'Mutation', createOrUpdateAccreditedInvestorProfile: { __typename?: 'CreateOrUpdateAccreditedInvestorProfilePayload', unaccredited: boolean | null, accreditedInvestorProfile: { __typename?: 'AccreditedInvestorProfile', id: string, userId: string, netWorth: string | null, next12MoAllocation: string | null, investmentSize: string | null, yearsInvesting: string | null, bonds: string | null, hedgeFunds: string | null, realEstate: string | null, foreignCurrencies: string | null, futuresOrCommodities: string | null, privateEquityFunds: string | null, publiclyTradedStocks: string | null, privateCompanies: string | null } | null } | null };

export type CreateOrUpdateCompanyQuestionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  questionType?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  expirationMonths?: InputMaybe<Scalars['Int']['input']>;
  answers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateOrUpdateCompanyQuestionMutation = { __typename?: 'Mutation', createOrUpdateCompanyQuestion: { __typename?: 'CreateOrUpdateCompanyQuestionPayload', companyQuestion: { __typename?: 'CompanyQuestion', id: string, answerOptions: Array<string>, expirationMonths: number | null, name: string, questionType: string, text: string } | null } | null };

export type CreateOrUpdateCompensationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  status: Scalars['String']['input'];
  category: Scalars['String']['input'];
  year: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Scalars['String']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  fundType?: InputMaybe<Scalars['String']['input']>;
  fundStrategy?: InputMaybe<Scalars['String']['input']>;
  fundSize?: InputMaybe<Scalars['String']['input']>;
  assetClass?: InputMaybe<Scalars['String']['input']>;
  baseSalary?: InputMaybe<Scalars['Float']['input']>;
  interestMgmtFeesPerc?: InputMaybe<Scalars['Float']['input']>;
  interestMgmtFeesValue?: InputMaybe<Scalars['Float']['input']>;
  vestingMgmtFees?: InputMaybe<Scalars['Int']['input']>;
  interestIncentiveFeesPerc?: InputMaybe<Scalars['Float']['input']>;
  interestIncentiveFeesValue?: InputMaybe<Scalars['Float']['input']>;
  vestingIncentiveFees?: InputMaybe<Scalars['Int']['input']>;
  annualDiscrBonus?: InputMaybe<Scalars['Float']['input']>;
  totalDeferredComp?: InputMaybe<Scalars['Float']['input']>;
  investInFund?: InputMaybe<Scalars['Boolean']['input']>;
  buildPersonalTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  marketPersonalTrackRecord?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateOrUpdateCompensationMutation = { __typename?: 'Mutation', createOrUpdateCompensation: { __typename?: 'CreateOrUpdateCompensationPayload', compensation: { __typename?: 'Compensation', id: string, completed: boolean, status: string, category: string, year: number, title: string, experience: string, industry: string, location: string, fundType: string, fundStrategy: string, fundSize: string, assetClass: string, baseSalary: number, interestMgmtFeesPerc: number, interestMgmtFeesValue: number, vestingMgmtFees: number, interestIncentiveFeesPerc: number, interestIncentiveFeesValue: number, vestingIncentiveFees: number, annualDiscrBonus: number, totalDeferredComp: number, investInFund: boolean | null, buildPersonalTrackRecord: boolean | null, marketPersonalTrackRecord: boolean | null, comments: string | null } | null, currentUser: { __typename?: 'User', id: string, numDaysCompensationViewRemaining: string | null } | null } | null };

export type CreateOrUpdateIdeaMutationVariables = Exact<{
  ideaId?: InputMaybe<Scalars['ID']['input']>;
  anonymous: Scalars['Boolean']['input'];
  attachments: Array<ResearchAttachmentAttributes> | ResearchAttachmentAttributes;
  catalystNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  contests: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  currentStep: Scalars['String']['input'];
  elevatorPitch: Scalars['String']['input'];
  employerApprovalDisclaimer: Scalars['Boolean']['input'];
  employerId?: InputMaybe<Scalars['ID']['input']>;
  isSubmission: Scalars['Boolean']['input'];
  mentionedEntities: Array<Scalars['String']['input']> | Scalars['String']['input'];
  noPriorAgreementDisclaimer: Scalars['Boolean']['input'];
  pairRatio?: InputMaybe<Array<Scalars['Float']['input']> | Scalars['Float']['input']>;
  portfolioPercentage: Scalars['String']['input'];
  positionDisclaimerFund: Scalars['Boolean']['input'];
  positionDisclaimerIndividual: Scalars['Boolean']['input'];
  positions: Array<PositionAttributes> | PositionAttributes;
  fundProfileDisplay: Scalars['Boolean']['input'];
  publicInformationDisclaimer: Scalars['Boolean']['input'];
  returnTarget?: InputMaybe<Scalars['Float']['input']>;
  situation: Scalars['String']['input'];
  tagList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  thesis: Scalars['String']['input'];
  timeframe: Scalars['String']['input'];
}>;


export type CreateOrUpdateIdeaMutation = { __typename?: 'Mutation', createOrUpdateIdea: { __typename?: 'CreateOrUpdateIdeaPayload', idea: { __typename?: 'Idea', id: string, anonymous: boolean, catalystNames: Array<string>, contestIds: Array<string>, elevatorPitch: string | null, employerApprovalDisclaimer: boolean | null, featuredOnAFundProfile: boolean | null, isPairTrade: boolean | null, noPriorAgreementDisclaimer: boolean | null, pairRatio: Array<number> | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, publicInformationDisclaimer: boolean | null, returnTarget: number | null, situation: string | null, status: string | null, tagList: Array<string>, targetAllocation: string | null, thesis: string | null, timeframe: string | null, associatedEmployer: { __typename?: 'Employer', id: string } | null, ideaAttachments: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, positions: Array<{ __typename?: 'Position', id: string, latestPrice: number | null, priceTarget: number | null, direction: string, asset: { __typename?: 'Asset', id: string } | null }>, user: { __typename?: 'User', id: string } | null } } | null };

export type CreateOrUpdateWhitePaperMutationVariables = Exact<{
  whitePaperId?: InputMaybe<Scalars['ID']['input']>;
  attachments: Array<ResearchAttachmentAttributes> | ResearchAttachmentAttributes;
  currentStep: Scalars['String']['input'];
  elevatorPitch: Scalars['String']['input'];
  employerId?: InputMaybe<Scalars['ID']['input']>;
  esgs: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fundProfileDisplay: Scalars['Boolean']['input'];
  geographies: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  globalMacros: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isSubmission: Scalars['Boolean']['input'];
  mentionedEntities: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  positionDisclaimerFund: Scalars['Boolean']['input'];
  positionDisclaimerIndividual: Scalars['Boolean']['input'];
  sectors: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  tagList: Array<Scalars['String']['input']> | Scalars['String']['input'];
  thesis: Scalars['String']['input'];
  title: Scalars['String']['input'];
}>;


export type CreateOrUpdateWhitePaperMutation = { __typename?: 'Mutation', createOrUpdateWhitePaper: { __typename?: 'CreateOrUpdateWhitePaperPayload', whitePaper: { __typename?: 'WhitePaper', id: string, elevatorPitch: string, featuredOnAFundProfile: boolean | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, status: string, tagList: Array<string>, thesis: string, thesisText: string, title: string, associatedEmployer: { __typename?: 'Employer', id: string } | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, esgs: Array<{ __typename?: 'Esg', id: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string }> | null, globalMacros: Array<{ __typename?: 'GlobalMacro', id: string }> | null, sectors: Array<{ __typename?: 'Sector', id: string }> | null, user: { __typename?: 'User', id: string }, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, attachmentType: string, filename: string, createdAt: string, researchType: string, fileType: string, url: string }> | null } } | null };

export type CreatePostMutationVariables = Exact<{
  body: Scalars['String']['input'];
  ogUrl?: InputMaybe<Scalars['String']['input']>;
  postFiles?: InputMaybe<Scalars['String']['input']>;
  asAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  tagList?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePostMutation = { __typename?: 'Mutation', createPost: { __typename?: 'CreatePostPayload', feedItem: { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null } | { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null } | null } | null, post: { __typename?: 'Post', id: string, body: string | null, commentsCount: number | null, domain: string | null, eventId: string | null, likeCount: number, ogDescription: string | null, ogUrl: string | null, ogPreviewImageUrl: string | null, ogTitle: string | null, postedAt: string | null, tagList: Array<string> | null, untaggedBody: string | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null } | null } | null } | null };

export type CreatePostCommentMutationVariables = Exact<{
  parentId?: InputMaybe<Scalars['ID']['input']>;
  postId: Scalars['ID']['input'];
  body?: InputMaybe<Scalars['String']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreatePostCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CreateCommentPayload', comment: { __typename?: 'Comment', id: string, anonymous: boolean | null, body: string | null, byAllocator: boolean, createdAt: string, commentableType: string | null, commentCreationTime: string, currentUserHasLiked: boolean, likeCount: number, parentId: string | null, anonUser: { __typename?: 'AnonUser', id: string, aumRange: string | null, fundType: string | null, title: string | null } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null };

export type CreateQuickPositionMutationVariables = Exact<{
  assetId: Scalars['ID']['input'];
  direction: Scalars['String']['input'];
  anonymous: Scalars['Boolean']['input'];
}>;


export type CreateQuickPositionMutation = { __typename?: 'Mutation', createQuickPosition: { __typename?: 'CreateQuickPositionPayload', quickPosition: { __typename?: 'QuickPosition', id: string, direction: string, openedAt: string | null, openingPrice: number | null, asset: { __typename?: 'Asset', id: string, longQuickPositionRatio: number | null, shortQuickPositionRatio: number | null } } } | null };

export type CreateReadingListItemMutationVariables = Exact<{
  ideaId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateReadingListItemMutation = { __typename?: 'Mutation', createOrUpdateReadingListItem: { __typename?: 'CreateUpdateReadingListItemPayload', currentUser: { __typename?: 'User', id: string } | null, readingListItem: { __typename?: 'ReadingListItem', id: string, archived: boolean, ideaId: string } | null } | null };

export type CreateThesisImageMutationVariables = Exact<{
  imageableId: Scalars['ID']['input'];
  image: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type CreateThesisImageMutation = { __typename?: 'Mutation', createThesisImage: { __typename?: 'CreateThesisImagePayload', thesisImageUrl: string } | null };

export type CreateTweetMutationVariables = Exact<{
  tweetBody: Scalars['String']['input'];
}>;


export type CreateTweetMutation = { __typename?: 'Mutation', createTweet: { __typename?: 'CreateTweetPayload', tweetUrl: string | null } | null };

export type CreateUserFeedbackMutationVariables = Exact<{
  rating: Scalars['Int']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
}>;


export type CreateUserFeedbackMutation = { __typename?: 'Mutation', createUserFeedback: { __typename?: 'CreateUserFeedbackPayload', userFeedback: { __typename?: 'UserFeedback', id: string, sentiment: string | null } | null } | null };

export type CreateViewerIntroRequestMutationVariables = Exact<{
  viewerId: Scalars['ID']['input'];
  viewableId: Scalars['ID']['input'];
  viewableType: Scalars['String']['input'];
}>;


export type CreateViewerIntroRequestMutation = { __typename?: 'Mutation', createViewerIntroRequest: { __typename?: 'CreateViewerIntroRequestPayload', viewerIntroRequest: { __typename?: 'ViewerIntroRequest', id: string, status: string, updatedAt: string, viewableDisplayTitle: string, viewableId: string, viewableType: string, author: { __typename?: 'User', id: string }, viewer: { __typename?: 'User', id: string, displayName: string } } | null } | null };

export type CreateWhitePaperCommentMutationVariables = Exact<{
  body?: InputMaybe<Scalars['String']['input']>;
  whitePaperId: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  hideFromFundAdmins?: InputMaybe<Scalars['Boolean']['input']>;
  requestResponse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateWhitePaperCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CreateCommentPayload', comment: { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, currentUserHasLiked: boolean, parentId: string | null, likeCount: number, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, isAllocator: boolean, fundType: string | null, title: string | null, username: string | null } | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null };

export type DeleteFundSearchAlertMutationVariables = Exact<{
  fundSearchAlertId: Scalars['ID']['input'];
}>;


export type DeleteFundSearchAlertMutation = { __typename?: 'Mutation', deleteFundSearchAlert: { __typename?: 'DeleteFundSearchAlertPayload', currentUser: { __typename?: 'User', id: string, fundProfileSearchAlerts: Array<{ __typename?: 'EmployerProfileSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null, employerProfileSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null } | null } | null };

export type DeleteIdeaSearchAlertMutationVariables = Exact<{
  ideaSearchAlertId: Scalars['ID']['input'];
}>;


export type DeleteIdeaSearchAlertMutation = { __typename?: 'Mutation', deleteIdeaSearchAlert: { __typename?: 'DeleteIdeaSearchAlertPayload', currentUser: { __typename?: 'User', id: string, ideaSearchAlerts: Array<{ __typename?: 'IdeaSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null, ideaSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null } | null } | null };

export type DestroyPostMutationVariables = Exact<{
  feedItemId: Scalars['ID']['input'];
}>;


export type DestroyPostMutation = { __typename?: 'Mutation', destroyPost: { __typename?: 'DeletePostPayload', feedItem: { __typename?: 'FeedItem', id: string, feedId: string | null } | null } | null };

export type DestroyBlocklistEntryMutationVariables = Exact<{
  allocatorProfileId: Scalars['ID']['input'];
  employerProfileId: Scalars['ID']['input'];
}>;


export type DestroyBlocklistEntryMutation = { __typename?: 'Mutation', destroyAllocatorBlocklistEntry: { __typename?: 'DestroyAllocatorBlocklistEntryPayload', destroyedBlocklistEntry: { __typename?: 'AllocatorBlocklistEntry', id: string, allocatorProfile: { __typename?: 'AllocatorProfile', id: string } } | null } | null };

export type DestroyCompanyQuestionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DestroyCompanyQuestionMutation = { __typename?: 'Mutation', destroyCompanyQuestion: { __typename?: 'DestroyCompanyQuestionPayload', companyQuestion: { __typename?: 'CompanyQuestion', id: string, deleted: boolean } | null } | null };

export type DestroyCompensationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DestroyCompensationMutation = { __typename?: 'Mutation', destroyCompensation: { __typename?: 'DestroyCompensationPayload', currentUser: { __typename?: 'User', id: string, draftCompensations: Array<{ __typename?: 'Compensation', id: string }> | null } | null } | null };

export type DestroyIdeaDraftMutationVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type DestroyIdeaDraftMutation = { __typename?: 'Mutation', destroyIdeaDraft: { __typename?: 'DestroyIdeaDraftPayload', currentUserId: string, ideaId: string } | null };

export type DeleteWhitePaperDraftMutationVariables = Exact<{
  whitePaperId: Scalars['ID']['input'];
}>;


export type DeleteWhitePaperDraftMutation = { __typename?: 'Mutation', destroyWhitePaperDraft: { __typename?: 'DestroyWhitePaperDraftPayload', currentUserId: string, whitePaperId: string } | null };

export type EventRegistrationMutationVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  firmName?: InputMaybe<Scalars['String']['input']>;
}>;


export type EventRegistrationMutation = { __typename?: 'Mutation', createEventRegistration: { __typename?: 'EventRegistrationPayload', registered: boolean } | null };

export type FlagItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type FlagItemMutation = { __typename?: 'Mutation', flagItem: { __typename?: 'FlagItemPayload', flagMarker: { __typename?: 'FlagMarker', id: string, flagCategory: string } | null } | null };

export type FollowEntityOnboardingMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FollowEntityOnboardingMutation = { __typename?: 'Mutation', followObject: { __typename?: 'FollowItemPayload', message: string | null, currentUser: { __typename?: 'User', id: string, watchlist: { __typename?: 'Watchlist', id: string, entitiesFromMassImport: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, entitiesRegularFollows: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null } | null } | null } | null };

export type FollowItemMutationVariables = Exact<{
  followId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type FollowItemMutation = { __typename?: 'Mutation', followObject: { __typename?: 'FollowItemPayload', user: { __typename?: 'User', id: string, followedFundIds: Array<string>, followedUserIds: Array<string>, followedEntityIds: Array<string>, followedEsgIds: Array<string>, followedGeographyIds: Array<string>, followedGlobalMacroIds: Array<string>, followedSectorIds: Array<string> } | null } | null };

export type FollowMultipleMutationVariables = Exact<{
  sectorNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assetClassNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  geographyNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  fundTypeNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  fundStrategyNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  aumRangeNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  section?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FollowMultipleMutation = { __typename?: 'Mutation', followMultiple: { __typename?: 'FollowMultiplePayload', currentUser: { __typename?: 'User', id: string, watchlist: { __typename?: 'Watchlist', id: string, onboardingStatus: string, sectors: Array<{ __typename?: 'Sector', id: string, name: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string, name: string }> | null, assetClasses: Array<{ __typename?: 'AssetClass', id: string, name: string }> | null, entitiesFromMassImport: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, entitiesRegularFollows: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, massImports: Array<{ __typename?: 'MassImport', id: string, numberOfTickers: number, fileName: string }> | null, users: Array<{ __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null }> | null, aumRanges: Array<{ __typename?: 'AumRange', id: string, name: string }> | null, fundTypes: Array<{ __typename?: 'FundType', id: string, name: string }> | null, fundStrategies: Array<{ __typename?: 'FundStrategy', id: string, name: string }> | null } | null } | null } | null };

export type FollowUserOnboardingMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type FollowUserOnboardingMutation = { __typename?: 'Mutation', followObject: { __typename?: 'FollowItemPayload', message: string | null, currentUser: { __typename?: 'User', id: string, watchlist: { __typename?: 'Watchlist', id: string, users: Array<{ __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null }> | null } | null } | null } | null };

export type GoogleReCaptchaMutationVariables = Exact<{
  response: Scalars['String']['input'];
  action: Scalars['String']['input'];
}>;


export type GoogleReCaptchaMutation = { __typename?: 'Mutation', googleReCAPTCHA: { __typename?: 'GoogleReCAPTCHAPayload', verified: boolean } | null };

export type HideFundRecommendationMutationVariables = Exact<{
  fundRecommendationId: Scalars['ID']['input'];
}>;


export type HideFundRecommendationMutation = { __typename?: 'Mutation', hideFundRecommendation: { __typename?: 'HideFundRecommendationPayload', fundRecommendation: { __typename?: 'FundRecommendation', id: string } | null } | null };

export type HideIdeaRecommendationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
}>;


export type HideIdeaRecommendationMutation = { __typename?: 'Mutation', hideIdeaRecommendation: { __typename?: 'HideIdeaRecommendationPayload', currentUser: { __typename?: 'User', id: string } | null } | null };

export type InviteNewMembersMutationMutationVariables = Exact<{
  emails: Scalars['String']['input'];
  personalMessage?: InputMaybe<Scalars['String']['input']>;
}>;


export type InviteNewMembersMutationMutation = { __typename?: 'Mutation', createNewMemberInvitation: { __typename?: 'InviteNewMembersMutationPayload', success: boolean | null } | null };

export type LikeCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
}>;


export type LikeCommentMutation = { __typename?: 'Mutation', likeComment: { __typename?: 'LikeCommentPayload', comment: { __typename?: 'Comment', id: string, likeCount: number, currentUserHasLiked: boolean } | null } | null };

export type LikeEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type LikeEventMutation = { __typename?: 'Mutation', likeEvent: { __typename?: 'LikeEventPayload', event: { __typename?: 'Event', id: string, likeCount: number, currentUserHasLiked: boolean } | null } | null };

export type MakeCheckoutSessionUpdatePaymentMethodMutationVariables = Exact<{ [key: string]: never; }>;


export type MakeCheckoutSessionUpdatePaymentMethodMutation = { __typename?: 'Mutation', makeCheckoutSessionUpdatePaymentMethod: { __typename?: 'MakeCheckoutSessionUpdatePaymentMethodPayload', sessionId: string } | null };

export type MakeStripeCheckoutMutationVariables = Exact<{
  plan: Scalars['String']['input'];
  currentUrl: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type MakeStripeCheckoutMutation = { __typename?: 'Mutation', makeStripeCheckout: { __typename?: 'MakeStripeCheckoutPayload', sessionId: string } | null };

export type MarkChatReadMutationVariables = Exact<{
  chatId: Scalars['ID']['input'];
}>;


export type MarkChatReadMutation = { __typename?: 'Mutation', markChatRead: { __typename?: 'MarkChatReadPayload', success: boolean } | null };

export type MarkJobApplicationViewedMutationVariables = Exact<{
  jobApplicationId: Scalars['ID']['input'];
}>;


export type MarkJobApplicationViewedMutation = { __typename?: 'Mutation', markJobApplicationViewed: { __typename?: 'MarkJobApplicationViewedPayload', jobApplication: { __typename?: 'JobApplication', id: string, status: string } | null } | null };

export type MarkMessageAsReadMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MarkMessageAsReadMutation = { __typename?: 'Mutation', markMessageAsRead: { __typename?: 'MarkMessageAsReadPayload', updatedMessage: { __typename?: 'Message', id: string, thread: string | null, subject: string | null, body: string | null, createdAt: string | null, readStatus: boolean | null, receiverStatus: string | null, sender: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null } | null } | null } | null };

export type MassFollowEntitiesMutationVariables = Exact<{
  entityIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  fileName: Scalars['String']['input'];
}>;


export type MassFollowEntitiesMutation = { __typename?: 'Mutation', massFollowEntities: { __typename?: 'MassFollowEntitiesPayload', currentUser: { __typename?: 'User', id: string, followedEntityIds: Array<string>, watchlistTickers: Array<{ __typename?: 'WatchlistTagRelationship', id: string, createdAt: string, entity: { __typename?: 'Entity', id: string, name: string | null, primaryAsset: { __typename?: 'Asset', primarySymbol: string | null } | null } | null }> | null } | null } | null };

export type PublishFundProfileMutationVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
}>;


export type PublishFundProfileMutation = { __typename?: 'Mutation', publishFundProfile: { __typename?: 'PublishFundProfilePayload', employerProfile: { __typename?: 'EmployerProfile', id: string, status: string | null } | null } | null };

export type PurchaseIdeaMutationVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type PurchaseIdeaMutation = { __typename?: 'Mutation', spendIdeaToken: { __typename?: 'PurchaseIdeaPayload', availableTokenCount: number | null } | null };

export type RateIdeaMutationVariables = Exact<{
  ideaId: Scalars['ID']['input'];
  score: Scalars['Int']['input'];
}>;


export type RateIdeaMutation = { __typename?: 'Mutation', rateIdea: { __typename?: 'RateIdeaPayload', userRating: { __typename?: 'UserRating', id: string, score: number } | null, idea: { __typename?: 'Idea', id: string, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null } | null } | null };

export type RemoveMassImportMutationVariables = Exact<{
  massImportId: Scalars['ID']['input'];
}>;


export type RemoveMassImportMutation = { __typename?: 'Mutation', removeMassImport: { __typename?: 'RemoveMassImportPayload', currentUser: { __typename?: 'User', id: string, watchlist: { __typename?: 'Watchlist', id: string, onboardingStatus: string, sectors: Array<{ __typename?: 'Sector', id: string, name: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string, name: string }> | null, assetClasses: Array<{ __typename?: 'AssetClass', id: string, name: string }> | null, entitiesFromMassImport: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, entitiesRegularFollows: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, massImports: Array<{ __typename?: 'MassImport', id: string, numberOfTickers: number, fileName: string }> | null, users: Array<{ __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null }> | null, aumRanges: Array<{ __typename?: 'AumRange', id: string, name: string }> | null, fundTypes: Array<{ __typename?: 'FundType', id: string, name: string }> | null, fundStrategies: Array<{ __typename?: 'FundStrategy', id: string, name: string }> | null } | null } | null } | null };

export type RequestIdeaUpdateMutationVariables = Exact<{
  body: Scalars['String']['input'];
  ideaId: Scalars['ID']['input'];
}>;


export type RequestIdeaUpdateMutation = { __typename?: 'Mutation', requestIdeaUpdate: { __typename?: 'RequestIdeaUpdatePayload', complete: boolean | null } | null };

export type RequestResearchAccessMutationVariables = Exact<{ [key: string]: never; }>;


export type RequestResearchAccessMutation = { __typename?: 'Mutation', requestResearchAccess: { __typename?: 'RequestResearchAccessMutationPayload', success: boolean } | null };

export type RestoreFundSearchAlertMutationVariables = Exact<{
  employerProfileSavedSearchId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  active: Scalars['Boolean']['input'];
  display: Scalars['Boolean']['input'];
}>;


export type RestoreFundSearchAlertMutation = { __typename?: 'Mutation', restoreFundSearchAlert: { __typename?: 'RestoreUserFundSearchAlertPayload', currentUser: { __typename?: 'User', id: string, fundProfileSearchAlerts: Array<{ __typename?: 'EmployerProfileSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null, employerProfileSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null } | null } | null };

export type RestoreIdeaSearchAlertMutationVariables = Exact<{
  ideaSavedSearchId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RestoreIdeaSearchAlertMutation = { __typename?: 'Mutation', restoreIdeaSearchAlert: { __typename?: 'RestoreUserIdeaSearchAlertPayload', currentUser: { __typename?: 'User', id: string, ideaSearchAlerts: Array<{ __typename?: 'IdeaSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null, ideaSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null } | null } | null };

export type SetUsernameMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type SetUsernameMutation = { __typename?: 'Mutation', setUsername: { __typename?: 'SetUsernamePayload', currentUser: { __typename?: 'User', id: string, username: string | null } | null } | null };

export type StarJobApplicationMutationVariables = Exact<{
  jobApplicationId: Scalars['ID']['input'];
  starredBoolean: Scalars['Boolean']['input'];
}>;


export type StarJobApplicationMutation = { __typename?: 'Mutation', starJobApplication: { __typename?: 'StarJobApplicationPayload', jobApplication: { __typename?: 'JobApplication', id: string, starred: boolean | null } | null } | null };

export type SubmitCompanyQuestionResponseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  answers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  entityId: Scalars['ID']['input'];
  skipped: Scalars['Boolean']['input'];
}>;


export type SubmitCompanyQuestionResponseMutation = { __typename?: 'Mutation', submitCompanyQuestionResponse: { __typename?: 'SubmitCompanyQuestionResponsePayload', companyQuestionResponse: { __typename?: 'CompanyQuestionResponse', id: string, text: string, skipped: boolean | null, updatedAt: string, pollQuestion: { __typename?: 'CompanyQuestion', id: string, yMin: number | null, yMax: number | null, tickCount: number | null, showTooltip: boolean | null, tickValues: Array<string> | null, answerOptions: Array<string>, expirationMonths: number | null, name: string, questionType: string, text: string, pollResponseData: { __typename?: 'PollResponseData', answeredByCurrentUser: boolean, buysidePollResultStats: { __typename?: 'PollResultStatistics', monthlyAvg: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, twelveMonthsPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, currentMonthPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null } | null, retailPollResultStats: { __typename?: 'PollResultStatistics', monthlyAvg: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, twelveMonthsPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, currentMonthPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null } | null } } } | null } | null };

export type SuggestTagMutationVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuggestTagMutation = { __typename?: 'Mutation', suggestTag: { __typename?: 'SuggestTagPayload', success: boolean | null } | null };

export type ToggleFundProfileAdminMutationVariables = Exact<{
  currentEmployeeId: Scalars['ID']['input'];
  employerProfileId: Scalars['ID']['input'];
}>;


export type ToggleFundProfileAdminMutation = { __typename?: 'Mutation', toggleFundProfileAdmin: { __typename?: 'ToggleFundProfileAdminPayload', employerProfile: { __typename?: 'EmployerProfile', id: string, fundAdminIds: Array<string> } } | null };

export type ToggleHideNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
  hidden: Scalars['Boolean']['input'];
}>;


export type ToggleHideNotificationMutation = { __typename?: 'Mutation', toggleHideNotification: { __typename?: 'ToggleHideNotificationPayload', notification: { __typename?: 'Notification', id: string, hidden: boolean | null } | null } | null };

export type UnarchiveThreadMutationVariables = Exact<{
  threadNum: Scalars['ID']['input'];
}>;


export type UnarchiveThreadMutation = { __typename?: 'Mutation', unarchiveThread: { __typename?: 'UnarchiveThreadPayload', id: string | null } | null };

export type UnfollowEntityOnboardingMutationVariables = Exact<{
  entityId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UnfollowEntityOnboardingMutation = { __typename?: 'Mutation', unfollowObject: { __typename?: 'UnfollowItemPayload', currentUser: { __typename?: 'User', id: string, watchlist: { __typename?: 'Watchlist', id: string, entitiesFromMassImport: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, entitiesRegularFollows: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null } | null } | null } | null };

export type UnfollowItemMutationVariables = Exact<{
  followId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
}>;


export type UnfollowItemMutation = { __typename?: 'Mutation', unfollowObject: { __typename?: 'UnfollowItemPayload', user: { __typename?: 'User', id: string, followedFundIds: Array<string>, followedUserIds: Array<string>, followedEntityIds: Array<string>, followedEsgIds: Array<string>, followedGeographyIds: Array<string>, followedGlobalMacroIds: Array<string>, followedSectorIds: Array<string> } | null } | null };

export type UnfollowUserOnboardingMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UnfollowUserOnboardingMutation = { __typename?: 'Mutation', unfollowObject: { __typename?: 'UnfollowItemPayload', currentUser: { __typename?: 'User', id: string, watchlist: { __typename?: 'Watchlist', id: string, users: Array<{ __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null }> | null } | null } | null } | null };

export type UnviewNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type UnviewNotificationMutation = { __typename?: 'Mutation', unviewNotification: { __typename?: 'UnviewNotificationPayload', notification: { __typename?: 'Notification', id: string, viewed: boolean } | null, currentUser: { __typename?: 'User', id: string, unreadNotificationsCount: number | null } | null } | null };

export type UpdateAllocatorProfileMutationVariables = Exact<{
  allocatorProfileId: Scalars['ID']['input'];
  section: Scalars['String']['input'];
  aumRange?: InputMaybe<Scalars['String']['input']>;
  employerType?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  fundManager?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  executives?: InputMaybe<Scalars['String']['input']>;
  investmentCriteria?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateAllocatorProfileMutation = { __typename?: 'Mutation', updateAllocatorProfile: { __typename?: 'UpdateAllocatorProfilePayload', allocatorProfile: { __typename?: 'AllocatorProfile', investmentCriteria: string | null, id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null, sectorPreferences: Array<string> | null, geographyPreferences: Array<string> | null, assetClassPreferences: Array<string> | null, fundTypePreferences: Array<string> | null, fundStrategyPreferences: Array<string> | null, aumRangePreferences: Array<string> | null, executives: Array<{ __typename?: 'AllocatorProfileExecutive', id: string, name: string | null, bio: string | null, photoUrl: string | null, photoProfileUrl: string | null, defaultPhoto: string | null }> | null } | null } | null };

export type UpdateAllocatorProfileBackgroundImageMutationVariables = Exact<{
  allocatorProfileId: Scalars['ID']['input'];
  imageData?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateAllocatorProfileBackgroundImageMutation = { __typename?: 'Mutation', updateAllocatorProfileBackgroundImage: { __typename?: 'UpdateAllocatorProfileBackgroundImagePayload', allocatorProfile: { __typename?: 'AllocatorProfile', id: string, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null } | null } | null };

export type UpdateCurrentUserLastViewedMessagesAtMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateCurrentUserLastViewedMessagesAtMutation = { __typename?: 'Mutation', updateCurrentUserLastViewedMessagesAt: { __typename?: 'UpdateCurrentUserLastViewedMessagesAtPayload', user: { __typename?: 'User', id: string, unseenMessageCount: number | null } | null } | null };

export type UpdateFundProfileMutationVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
  section: Scalars['String']['input'];
  fundType?: InputMaybe<Scalars['String']['input']>;
  strategy?: InputMaybe<Scalars['String']['input']>;
  focus?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  fundManager?: InputMaybe<Scalars['String']['input']>;
  aum?: InputMaybe<Scalars['Int']['input']>;
  foundingDate?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  imageData?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  executives?: InputMaybe<Scalars['String']['input']>;
  firmReferences?: InputMaybe<Scalars['String']['input']>;
  sectorExpertise?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  geographicExpertise?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assetClassExpertise?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  subsectorExpertise?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  returns?: InputMaybe<Scalars['String']['input']>;
  returnsUpdatedDate?: InputMaybe<Scalars['String']['input']>;
  returnsDocuments?: InputMaybe<Scalars['String']['input']>;
  ideaIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  whitePaperIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  holdings?: InputMaybe<Scalars['String']['input']>;
  holdingsDocuments?: InputMaybe<Scalars['String']['input']>;
  marketingMaterials?: InputMaybe<Scalars['String']['input']>;
  presses?: InputMaybe<Scalars['String']['input']>;
  sharpeRatio?: InputMaybe<Scalars['Float']['input']>;
  beta?: InputMaybe<Scalars['Float']['input']>;
  turnoverRatio?: InputMaybe<Scalars['Float']['input']>;
  metricsDocuments?: InputMaybe<Scalars['String']['input']>;
  managementFee?: InputMaybe<Scalars['Float']['input']>;
  incentiveFee?: InputMaybe<Scalars['Float']['input']>;
  hurdleRate?: InputMaybe<Scalars['Float']['input']>;
  lockUp?: InputMaybe<Scalars['Int']['input']>;
  highwaterMark?: InputMaybe<Scalars['Boolean']['input']>;
  seedDeal?: InputMaybe<Scalars['Boolean']['input']>;
  foundersShares?: InputMaybe<Scalars['Boolean']['input']>;
  investorLevelGates?: InputMaybe<Scalars['Boolean']['input']>;
  feeStructureDocuments?: InputMaybe<Scalars['String']['input']>;
  dueDiligenceDocuments?: InputMaybe<Scalars['String']['input']>;
  serviceProviders?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFundProfileMutation = { __typename?: 'Mutation', updateFundProfile: { __typename?: 'UpdateFundProfilePayload', employerProfile: { __typename?: 'EmployerProfile', aum: number | null, foundingDate: string | null, fundManager: string | null, sectionCompletenessPercents: string | null, excludedSections: Array<string> | null, sectionVisibilities: string | null, currentUserOnBlocklist: boolean | null, currentUserViewCount: number | null, currentUserHasMessagedFund: boolean | null, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null, id: string, aumRange: string | null, description: string | null, focus: string | null, followerCount: number | null, foundingYear: string | null, fundType: string | null, location: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, status: string | null, updatedAt: string | null, introRequestsLeft: number | null, introRequestPeriodEnd: string | null, sectorExpertise: Array<string> | null, geographicExpertise: Array<string> | null, assetClassExpertise: Array<string> | null, subsectorExpertise: string | null, tagNames: Array<string> | null, returnsUpdatedDate: string | null, holdingsUpdatedDate: string | null, beta: number | null, turnoverRatio: number | null, metricsUpdatedAt: string | null, managementFee: number | null, incentiveFee: number | null, hurdleRate: number | null, lockUp: number | null, highwaterMark: boolean | null, seedDeal: boolean | null, foundersShares: boolean | null, investorLevelGates: boolean | null, notes: string | null, fundRecommendation: { __typename?: 'FundRecommendation', id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, fundProfile: { __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, highlights: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', id: string | null, ltm: number | null, sinceInception: number | null, ytd: number | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null } | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null, lastReturn: { __typename?: 'EmployerReturn', ltm: number | null, sinceInception: number | null, ytd: number | null } | null, executives: Array<{ __typename?: 'EmployerProfileExecutive', id: string, name: string | null, bio: string | null, photoUrl: string | null, photoProfileUrl: string | null, defaultPhoto: string | null }> | null, firmReferences: Array<{ __typename?: 'EmployerProfileFirmReference', id: string, name: string | null, employer: string | null, title: string | null, contactEmail: string | null, relationshipToFund: string | null }> | null, returns: Array<{ __typename?: 'EmployerReturn', id: string | null, benchmark: string | null, employerBenchmark: boolean | null, employerProfileId: string, fiveYear: number | null, ltm: number | null, oneYear: number | null, sevenYear: number | null, sinceInception: number | null, status: string | null, tenYear: number | null, threeYear: number | null, ytd: number | null }> | null, returnsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, category: string | null, description: string | null, filename: string | null, name: string | null, url: string | null }> | null, featuredResearch: Array<{ __typename?: 'Idea', id: string, postedAt: string | null, totalReturn: number | null, elevatorPitch: string | null, canCurrentUserViewIdeaFilterDetails: boolean, updated: string, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', name: string | null } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } | null }> | null, featuredWhitePaperResearch: Array<{ __typename?: 'WhitePaper', id: string, elevatorPitch: string, submittedAt: string | null, title: string, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } }> | null, holdings: Array<{ __typename?: 'EmployerProfileHolding', id: string, percentOfPortfolio: number | null, entityName: string | null, primarySymbol: string | null, assetClass: string | null, realizedReturn: number | null, expectedReturn: number | null, averageCost: number | null, action: string | null, priceTarget: string | null, timeframe: string | null }> | null, holdingsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null, marketingMaterials: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null, filename: string | null, url: string | null }> | null, presses: Array<{ __typename?: 'EmployerProfilePress', id: string, title: string | null, url: string | null, filename: string | null, fileUrl: string | null, publishDate: string | null, description: string | null, previewImageUrl: string | null }> | null, metricsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null, feeStructureDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null, dueDiligenceDocuments: Array<{ __typename?: 'EmployerProfileDueDiligenceDocument', id: string, name: string, category: string, description: string, filename: string | null }> | null, serviceProviders: Array<{ __typename?: 'EmployerProfileServiceProvider', id: string, category: string | null, firmName: string | null, contactName: string | null, contactEmail: string | null, contactPhoneNumber: string | null }> | null } | null } | null };

export type UpdateFundProfileBackgroundImageMutationVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
  imageData?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFundProfileBackgroundImageMutation = { __typename?: 'Mutation', updateFundProfileBackgroundImage: { __typename?: 'UpdateFundProfileBackgroundImagePayload', employerProfile: { __typename?: 'EmployerProfile', id: string, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null } | null } | null };

export type UpdateFundProfileSectionVisibilityMutationVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
  section: Scalars['String']['input'];
  sectionVisibility: Scalars['String']['input'];
}>;


export type UpdateFundProfileSectionVisibilityMutation = { __typename?: 'Mutation', updateFundProfileSectionVisibility: { __typename?: 'UpdateFundProfileSectionVisibilityPayload', employerProfile: { __typename?: 'EmployerProfile', id: string, sectionVisibilities: string | null } | null } | null };

export type UpdateIdeaViewsLastViewedMutationVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type UpdateIdeaViewsLastViewedMutation = { __typename?: 'Mutation', updateIdeaViewsLastViewed: { __typename?: 'UpdateIdeaViewsLastViewedPayload', idea: { __typename?: 'Idea', id: string, newViewsCount: number } | null } | null };

export type UpdateIntroRequestStatusMutationVariables = Exact<{
  status: Scalars['String']['input'];
  introRequestId: Scalars['ID']['input'];
}>;


export type UpdateIntroRequestStatusMutation = { __typename?: 'Mutation', updateIntroRequest: { __typename?: 'UpdateIntroRequestStatusPayload', introRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null } | null };

export type UpdateJobAppStatusMutationVariables = Exact<{
  jobApplicationId: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
}>;


export type UpdateJobAppStatusMutation = { __typename?: 'Mutation', updateJobAppStatus: { __typename?: 'UpdateJobAppStatusPayload', jobApplication: { __typename?: 'JobApplication', id: string, status: string } | null } | null };

export type UpdateLinkClickCountMutationVariables = Exact<{
  adminPostId: Scalars['ID']['input'];
  clickedUrl: Scalars['String']['input'];
}>;


export type UpdateLinkClickCountMutation = { __typename?: 'Mutation', updateClickCount: { __typename?: 'UpdateClickCountPayload', updatedAdminPost: { __typename?: 'AdminPost', id: string } | null } | null };

export type UpdateNotificationSettingsMutationVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  showContests?: InputMaybe<Scalars['Boolean']['input']>;
  showComments?: InputMaybe<Scalars['Boolean']['input']>;
  showIdeas?: InputMaybe<Scalars['Boolean']['input']>;
  showBadges?: InputMaybe<Scalars['Boolean']['input']>;
  showRankings?: InputMaybe<Scalars['Boolean']['input']>;
  showCapIntro?: InputMaybe<Scalars['Boolean']['input']>;
  showFundFollower?: InputMaybe<Scalars['Boolean']['input']>;
  showNewRecommended?: InputMaybe<Scalars['Boolean']['input']>;
  showWatchlist?: InputMaybe<Scalars['Boolean']['input']>;
  showWhitePapers?: InputMaybe<Scalars['Boolean']['input']>;
  showFollowers?: InputMaybe<Scalars['Boolean']['input']>;
  showFolloweeActivity?: InputMaybe<Scalars['Boolean']['input']>;
  showJobVault?: InputMaybe<Scalars['Boolean']['input']>;
  showTrendingResearch?: InputMaybe<Scalars['Boolean']['input']>;
  showActivelyDiscussed?: InputMaybe<Scalars['Boolean']['input']>;
  showBiggestMovers?: InputMaybe<Scalars['Boolean']['input']>;
  showViewerIntroRequests?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateNotificationSettingsMutation = { __typename?: 'Mutation', updateUserNotificationSettings: { __typename?: 'UpdateNotificationSettingsPayload', userNotificationSetting: { __typename?: 'UserNotificationSetting', id: string, showAll: boolean, showContests: boolean, showComments: boolean, showRankings: boolean, showIdeas: boolean, showBadges: boolean, showCapIntro: boolean, showFundFollower: boolean, showNewRecommended: boolean, showWatchlist: boolean, showWhitePapers: boolean, showFollowers: boolean, showFolloweeActivity: boolean, showJobVault: boolean, showTrendingResearch: boolean, showActivelyDiscussed: boolean, showBiggestMovers: boolean, showViewerIntroRequests: boolean } | null } | null };

export type UpdatePaladinReviewMutationVariables = Exact<{
  paladinReviewId: Scalars['ID']['input'];
  approvedContestIdeas?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  status: Scalars['String']['input'];
}>;


export type UpdatePaladinReviewMutation = { __typename?: 'Mutation', updatePaladinReview: { __typename?: 'UpdatePaladinReviewPayload', paladinReview: { __typename?: 'PaladinReview', id: string, status: string | null, description: string | null } | null } | null };

export type UpdateReadingListItemMutationVariables = Exact<{
  readingListItemId?: InputMaybe<Scalars['ID']['input']>;
  archived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateReadingListItemMutation = { __typename?: 'Mutation', createOrUpdateReadingListItem: { __typename?: 'CreateUpdateReadingListItemPayload', currentUser: { __typename?: 'User', id: string } | null, readingListItem: { __typename?: 'ReadingListItem', id: string, archived: boolean, ideaId: string } | null } | null };

export type UpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: { __typename?: 'UpdateSubscriptionPayload', subscription: { __typename?: 'StripeSubscription', id: string, currentPeriodEnd: string, description: string, isAutoRenewing: boolean } } | null };

export type UpdateBadgeVisibilityMutationVariables = Exact<{
  badgeCollectionRelationshipId: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
}>;


export type UpdateBadgeVisibilityMutation = { __typename?: 'Mutation', updateBadgeVisibility: { __typename?: 'UpdateUserBadgeVisibilityPayload', currentUser: { __typename?: 'User', id: string, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, visible: boolean } | null } | null> | null } | null } | null } | null };

export type UpdateEmailMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type UpdateEmailMutation = { __typename?: 'Mutation', updateEmail: { __typename?: 'UpdateUserEmailPayload', currentUser: { __typename?: 'User', id: string, email: string } | null } | null };

export type UpdateEmailPreferencesMutationVariables = Exact<{
  activityDigestMailer?: InputMaybe<Scalars['Boolean']['input']>;
  activityDigestMailerWeekly?: InputMaybe<Scalars['Boolean']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  allocatorDigest?: InputMaybe<Scalars['Boolean']['input']>;
  buysideEventNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  buysideJobsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  capIntro?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateAuthorFollowedIdea?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFollowedIdea?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFollowedPost?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFollowedUser?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFollowedUserIdea?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFollowedWhitePaper?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateFundAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreatePostAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  commentCreateWhitePaperAuthor?: InputMaybe<Scalars['Boolean']['input']>;
  companyPriceChange?: InputMaybe<Scalars['Boolean']['input']>;
  dailyChatDigest?: InputMaybe<Scalars['Boolean']['input']>;
  generalRankingsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  ideaCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  ideaCreateFollowedUser?: InputMaybe<Scalars['Boolean']['input']>;
  ideaToken?: InputMaybe<Scalars['Boolean']['input']>;
  ideaUpdateCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  ideaUpdateCreateFollowedIdea?: InputMaybe<Scalars['Boolean']['input']>;
  ideaUpdateCreateFollowedUser?: InputMaybe<Scalars['Boolean']['input']>;
  memberEngagement?: InputMaybe<Scalars['Boolean']['input']>;
  newAllocatorEnquiry?: InputMaybe<Scalars['Boolean']['input']>;
  newAllocatorProfile?: InputMaybe<Scalars['Boolean']['input']>;
  newAllocatorUpdateRequest?: InputMaybe<Scalars['Boolean']['input']>;
  newBuysideUserFundProfileMessage?: InputMaybe<Scalars['Boolean']['input']>;
  newFundProfile?: InputMaybe<Scalars['Boolean']['input']>;
  personalRankingsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  positionCreate?: InputMaybe<Scalars['Boolean']['input']>;
  postCreateFollowedEntity?: InputMaybe<Scalars['Boolean']['input']>;
  postCreateFollowedSector?: InputMaybe<Scalars['Boolean']['input']>;
  rateIdea?: InputMaybe<Scalars['Boolean']['input']>;
  researchAccess?: InputMaybe<Scalars['Boolean']['input']>;
  retailWeeklyMarketDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  siteNewsEmail?: InputMaybe<Scalars['Boolean']['input']>;
  updateIdea?: InputMaybe<Scalars['Boolean']['input']>;
  userToUser?: InputMaybe<Scalars['Boolean']['input']>;
  viewerIntroRequest?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyDigestEmail?: InputMaybe<Scalars['Boolean']['input']>;
  weeklyTopIdea?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateEmailPreferencesMutation = { __typename?: 'Mutation', updateEmailPreferences: { __typename?: 'UpdateUserEmailPreferencesPayload', currentUser: { __typename?: 'User', id: string, emailPreferences: Array<{ __typename?: 'EmailPreference', id: string, emailType: string, subscribed: boolean | null }> | null } | null } | null };

export type UpdateFundSearchAlertMutationVariables = Exact<{
  fundSearchAlertId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  display?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFundSearchAlertMutation = { __typename?: 'Mutation', updateFundSearchAlert: { __typename?: 'UpdateUserFundSearchAlertPayload', currentUser: { __typename?: 'User', id: string, fundProfileSearchAlerts: Array<{ __typename?: 'EmployerProfileSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null }> | null } | null } | null };

export type UpdateIdeaSearchAlertMutationVariables = Exact<{
  ideaSearchAlertId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateIdeaSearchAlertMutation = { __typename?: 'Mutation', updateIdeaSearchAlert: { __typename?: 'UpdateUserIdeaSearchAlertPayload', currentUser: { __typename?: 'User', id: string, ideaSearchAlerts: Array<{ __typename?: 'IdeaSearchAlert', id: string, active: boolean | null, frequency: string | null, display: boolean | null, name: string | null }> | null } | null } | null };

export type UpdatePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
}>;


export type UpdatePasswordMutation = { __typename?: 'Mutation', updatePassword: { __typename?: 'UpdateUserPasswordPayload', currentUser: { __typename?: 'User', id: string, email: string } | null } | null };

export type UpdateUserProfileMutationVariables = Exact<{
  profileId: Scalars['ID']['input'];
  section: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  imageData?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
  employerHistories?: InputMaybe<Scalars['String']['input']>;
  sectorExpertise?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  geographicExpertise?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assetClassExpertise?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  schoolHistories?: InputMaybe<Scalars['String']['input']>;
  hometown?: InputMaybe<Scalars['String']['input']>;
  investmentHero?: InputMaybe<Scalars['String']['input']>;
  favoriteInvestmentBook?: InputMaybe<Scalars['String']['input']>;
  investingStyle?: InputMaybe<Scalars['String']['input']>;
  languagesSpoken?: InputMaybe<Scalars['String']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  workPhone?: InputMaybe<Scalars['String']['input']>;
  profileTestResults?: InputMaybe<Scalars['String']['input']>;
  profileAttachments?: InputMaybe<Scalars['String']['input']>;
  profileAnswers?: InputMaybe<Scalars['String']['input']>;
  controlIdeaAccess?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserProfileMutation = { __typename?: 'Mutation', updateUserProfile: { __typename?: 'UpdateUserProfilePayload', profile: { __typename?: 'Profile', id: string, imageProfileUrl: string | null, imageUrl: string | null, defaultImage: string | null, certifications: Array<string> | null, city: string | null, summary: string | null, hasFilledPrivateProfile: boolean | null, ideaTotalReturnAverage: string | null, ideaReturnVsBenchmarkAverage: string | null, ideaAnnualizedReturnMedian: string | null, experienceByFirmType: string | null, sectorExpertise: Array<string> | null, geographicExpertise: Array<string> | null, assetClassExpertise: Array<string> | null, hometown: string | null, investmentHero: string | null, favoriteInvestmentBook: string | null, investingStyle: string | null, languagesSpoken: string | null, resume: string | null, workPhone: string | null, hasGpa: boolean | null, hasSatOrAct: boolean | null, postedInLast3Months: boolean | null, hasAnyProfileAnswers: boolean | null, hasAllProfileAnswers: boolean | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, activeFollowedUsersCount: number, activeFollowersCount: number, canPostJobs: boolean, isHighProfile: boolean | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, hasFundProfile: boolean } | null } | null, recentIdea: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null, employerHistories: Array<{ __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, fromDate: string | null, primary: boolean, title: string | null, toDate: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, aumRangePresent: boolean | null, fundType: string | null } | null }> | null, schoolHistories: Array<{ __typename?: 'SchoolHistory', id: string, schoolName: string, degree: string | null, fieldOfStudy: string | null, currentStudent: boolean | null, startYear: number | null, gradYear: number | null }> | null, profileTestResults: Array<{ __typename?: 'ProfileTestResult', id: string, name: string | null, score: number | null, maxScore: string | null, date: string | null, url: string | null, filename: string | null }> | null, profileAttachments: Array<{ __typename?: 'ProfileAttachmentType', id: string, name: string | null, description: string | null, filename: string | null }> | null, profileAnswers: Array<{ __typename?: 'ProfileAnswer', profileQuestionId: number | null, answer: string | null }> | null } | null } | null };

export type UpdateUserProfileBackgroundImageMutationVariables = Exact<{
  profileId: Scalars['ID']['input'];
  imageData?: InputMaybe<Scalars['String']['input']>;
  cropData?: InputMaybe<Scalars['String']['input']>;
  removeImage?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserProfileBackgroundImageMutation = { __typename?: 'Mutation', updateUserProfileBackgroundImage: { __typename?: 'UpdateUserProfileBackgroundImagePayload', profile: { __typename?: 'Profile', id: string, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null } | null } | null };

export type UpdateViewerIntroRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  status: Scalars['String']['input'];
}>;


export type UpdateViewerIntroRequestMutation = { __typename?: 'Mutation', updateViewerIntroRequest: { __typename?: 'UpdateViewerIntroRequestPayload', viewerIntroRequest: { __typename?: 'ViewerIntroRequest', id: string, status: string } | null } | null };

export type CreateOrUpdateUserApplicationMutationVariables = Exact<{
  acceptedDisclaimer?: InputMaybe<Scalars['Boolean']['input']>;
  applicantType?: InputMaybe<Scalars['String']['input']>;
  basicEmployerName?: InputMaybe<Scalars['String']['input']>;
  basicInvestorType?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  degree?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employerAumRange?: InputMaybe<Scalars['String']['input']>;
  employerFundType?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  employmentStatus?: InputMaybe<Scalars['String']['input']>;
  expectedGraduation?: InputMaybe<Scalars['Int']['input']>;
  fieldOfStudy?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  investorType?: InputMaybe<Scalars['String']['input']>;
  isAccredited?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referrerId?: InputMaybe<Scalars['String']['input']>;
  resume?: InputMaybe<Scalars['String']['input']>;
  schoolName?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  yearStart?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateOrUpdateUserApplicationMutation = { __typename?: 'Mutation', createOrUpdateUserApplication: { __typename?: 'UserApplicationPayload', userApplication: { __typename?: 'UserApplication', id: string | null } | null } | null };

export type ViewAllNotificationsMutationVariables = Exact<{ [key: string]: never; }>;


export type ViewAllNotificationsMutation = { __typename?: 'Mutation', viewAllNotifications: { __typename?: 'ViewAllNotificationsPayload', currentUser: { __typename?: 'User', id: string, newNotificationsCount: number | null, unreadNotificationsCount: number | null, notifications: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, description: string | null, createdAt: string | null, viewed: boolean, linkId: string | null, customLink: string | null, notificationClass: string | null, hidden: boolean | null, associatedUser: { __typename?: 'User', id: string, isAllocator: boolean, allocatorProfileLogoUrl: string | null, profileImageUrl: string | null } | null } | null } | null> | null } | null } | null } | null };

export type ViewIdeaRecommendationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  ideaId: Scalars['ID']['input'];
}>;


export type ViewIdeaRecommendationMutation = { __typename?: 'Mutation', viewIdeaRecommendation: { __typename?: 'ViewIdeaRecommendationPayload', currentUser: { __typename?: 'User', id: string } | null } | null };

export type ViewNotificationMutationVariables = Exact<{
  notificationId: Scalars['ID']['input'];
}>;


export type ViewNotificationMutation = { __typename?: 'Mutation', viewNotification: { __typename?: 'ViewNotificationPayload', notification: { __typename?: 'Notification', id: string, viewed: boolean } | null, currentUser: { __typename?: 'User', id: string, unreadNotificationsCount: number | null } | null } | null };

export type AccessProfileCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessProfileCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isPaladin: boolean, isTokenBased: boolean | null, inTrial: boolean, readingListItemsCount: number, displayName: string, activeFollowedUsersCount: number, activeFollowersCount: number, isAllocator: boolean, profileImageUrl: string | null, publishedIdeasCount: number, canWriteIdeas: boolean | null, ideaIsBlocked: boolean | null, ideaDaysLeft: string | null, compensationIsBlocked: boolean | null, compensationDaysLeft: string | null, capIntroIsBlocked: boolean | null, capIntroDaysLeft: string | null, jobIsBlocked: boolean | null, jobDaysLeft: string | null, paladin: { __typename?: 'Paladin', nextQuotaDeadline: string, ratingQuota: string | null, ratingCurrentMonth: string | null, ratingPercent: string | null, commentQuota: string | null, commentCurrentMonth: string | null, commentPercent: string | null, pollAnswerQuota: string | null, pollAnswerCurrentMonth: string | null, pollAnswerPercent: string | null, hasPollAnswerQuota: boolean | null } | null, currentEmployers: Array<{ __typename?: 'Employer', id: string, name: string }>, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, profile: { __typename?: 'Profile', id: string } | null, primaryContact: { __typename?: 'User', id: string, displayName: string, email: string } | null } | null };

export type AccreditedInvestorProfilesIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type AccreditedInvestorProfilesIndexListQuery = { __typename?: 'Query', indexListResultCount: number | null, accreditedInvestorProfilesIndexList: Array<{ __typename?: 'AccreditedInvestorProfile', id: string, user: { __typename?: 'User', id: string, profileCity: string | null, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, summary: string | null } | null } }> | null, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null } | null };

export type ActivityFeedJoyrideQueryVariables = Exact<{ [key: string]: never; }>;


export type ActivityFeedJoyrideQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canViewIdeas: boolean | null } | null };

export type AdminCompanyQuestionsQueryVariables = Exact<{
  entityId: Scalars['ID']['input'];
}>;


export type AdminCompanyQuestionsQuery = { __typename?: 'Query', companyQuestions: Array<{ __typename?: 'CompanyQuestion', id: string, answerOptions: Array<string>, expirationMonths: number | null, name: string, questionType: string, text: string, pollResponseData: { __typename?: 'PollResponseData', answeredByCurrentUser: boolean }, responses: Array<{ __typename?: 'CompanyQuestionResponse', text: string, numChose: number }> | null }> | null };

export type AggregatedFeedItemsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AggregatedFeedItemsQuery = { __typename?: 'Query', aggregatedFeedItems: { __typename?: 'FeedItemConnection', edges: Array<{ __typename?: 'FeedItemEdge', node: { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null } | { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null } | null } | null } | null> | null } | null };

export type AllocatorBlocklistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AllocatorBlocklistQuery = { __typename?: 'Query', fundProfile: { __typename?: 'EmployerProfile', id: string, allocatorBlocklist: Array<{ __typename?: 'AllocatorBlocklistEntry', id: string, allocatorProfile: { __typename?: 'AllocatorProfile', id: string, name: string | null } }> } | null };

export type AllocatorProfileCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AllocatorProfileCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isCapIntroMember: boolean, adminFundProfiles: Array<{ __typename?: 'EmployerProfile', id: string, name: string | null }> } | null };

export type AllocatorProfileIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type AllocatorProfileIndexListQuery = { __typename?: 'Query', allocatorProfilesIndexListResultCount: number | null, allocatorProfilesIndexList: Array<{ __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null }> | null };

export type AllocatorProfileRecommendationsQueryVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
  fundProfileId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AllocatorProfileRecommendationsQuery = { __typename?: 'Query', allocatorRecommendations: { __typename?: 'FundRecommendationConnection', edges: Array<{ __typename?: 'FundRecommendationEdge', node: { __typename?: 'FundRecommendation', id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, matchesGeographies: boolean | null, matchesSectors: boolean | null, matchesAssetClasses: boolean | null, geographiesMatching: Array<string> | null, sectorsMatching: Array<string> | null, assetClassesMatching: Array<string> | null, hide: boolean | null, allocatorProfile: { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null } | null, fundProfile: { __typename?: 'EmployerProfile', id: string, name: string | null } | null } | null } | null> | null } };

export type AllocatorProfileShowPageQueryVariables = Exact<{
  allocatorProfileId: Scalars['ID']['input'];
}>;


export type AllocatorProfileShowPageQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAllocator: boolean, isAllocatorAdmin: boolean, adminFunds: Array<{ __typename?: 'EmployerHistory', id: string, primary: boolean, employer: { __typename?: 'Employer', id: string, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, alreadyRequestedIntro: boolean | null, introRequestPeriodEnd: string | null, introRequestsLeft: number | null, isAllocatorBlocklisted: boolean, status: string | null } | null } | null }> } | null, allocatorProfile: { __typename?: 'AllocatorProfile', investmentCriteria: string | null, recentlyJoined: boolean | null, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null, id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null, sectorPreferences: Array<string> | null, geographyPreferences: Array<string> | null, assetClassPreferences: Array<string> | null, fundTypePreferences: Array<string> | null, fundStrategyPreferences: Array<string> | null, aumRangePreferences: Array<string> | null, allocatorRecommendation: { __typename?: 'FundRecommendation', id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, matchesGeographies: boolean | null, matchesSectors: boolean | null, matchesAssetClasses: boolean | null, geographiesMatching: Array<string> | null, sectorsMatching: Array<string> | null, assetClassesMatching: Array<string> | null, hide: boolean | null, allocatorProfile: { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null, highlights: string | null } | null, fundProfile: { __typename?: 'EmployerProfile', id: string, name: string | null } | null } | null, executives: Array<{ __typename?: 'AllocatorProfileExecutive', id: string, name: string | null, bio: string | null, photoUrl: string | null, photoProfileUrl: string | null, defaultPhoto: string | null }> | null } | null };

export type AnonymousCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type AnonymousCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, username: string | null, profileCity: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null } | null };

export type AssetQuoteQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  timeframe?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssetQuoteQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, currencyCode: string | null, priceHistory: Array<{ __typename?: 'Price', price: number | null, date: string | null }>, ideasInTimeframe: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, elevatorPitch: string | null, totalReturn: number | null, returnTarget: number | null, createdAt: string | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, priceTarget: number | null, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null, ideaUpdatesInTimeframe: { __typename?: 'IdeaUpdateConnection', edges: Array<{ __typename?: 'IdeaUpdateEdge', node: { __typename?: 'IdeaUpdate', id: string, createdAt: string, closed: boolean, impact: string | null, text: string | null, idea: { __typename?: 'Idea', id: string, elevatorPitch: string | null, createdAt: string, totalReturn: number | null, returnTarget: number | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, priceTarget: number | null, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null } | null> | null } | null } | null };

export type BillingAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingAddressQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, billingAddress: { __typename?: 'BillingAddress', name: string | null, email: string, address: { __typename?: 'Address', city: string | null, lineOne: string | null, lineTwo: string | null, postalCode: string | null, state: string | null, country: string } } | null, subscriptions: Array<{ __typename?: 'StripeSubscription', status: string }> | null } | null };

export type BillingHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingHistoryQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, stripeCustomerId: string | null, billingHistory: Array<{ __typename?: 'Invoice', amount: string, description: string, status: InvoiceStatusType, paidDate: { __typename?: 'YearMonthDay', year: number, month: number, day: number } }> | null } | null };

export type BlogPostsQueryVariables = Exact<{
  number: Scalars['Int']['input'];
  featured: Scalars['Boolean']['input'];
}>;


export type BlogPostsQuery = { __typename?: 'Query', blogPosts: Array<{ __typename?: 'BlogPost', id: string, title: string | null, preview: string | null, blogPostImage: string | null }> | null };

export type ChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ChatQuery = { __typename?: 'Query', chat: { __typename?: 'Chat', id: string, canCurrentUserChatPublicly: boolean, chatMessagesCount: number, chattableName: string, chattableUrl: string, unreadMessagesCount: number, chatMessages: { __typename?: 'ChatMessageConnection', edges: Array<{ __typename?: 'ChatMessageEdge', node: { __typename?: 'ChatMessage', id: string, anonymous: boolean | null, body: string, createdAt: string, direction: string | null, participantName: string, user: { __typename?: 'User', id: string, profileCity: string | null, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } } | null };

export type CitySearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type CitySearchQuery = { __typename?: 'Query', citySearch: Array<string> | null };

export type CommentsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  feedItemId: Scalars['ID']['input'];
}>;


export type CommentsQuery = { __typename?: 'Query', feedItemComments: { __typename?: 'CommentConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentableType: string | null, commentCreationTime: string, currentUserHasLiked: boolean, likeCount: number, parentId: string | null, anonUser: { __typename?: 'AnonUser', id: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, feedItemShow: { __typename?: 'FeedItem', id: string, feedItemMentionables: Array<{ __typename?: 'Mentionable', id: string, display: string }> | null } | null };

export type CommunitySuggestionsQueryVariables = Exact<{
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  afterCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommunitySuggestionsQuery = { __typename?: 'Query', recommendedUsersToFollow: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, profileImageUrl: string | null, publishedIdeasCount: number, currentRanksCount: number | null, wroteOnWatchlistedSectors: number | null, sectorsWroteOn: Array<string> | null, featuredRankForCurrentUserWatchlist: { __typename?: 'Rank', id: string, category: string, value: number | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null } | null };

export type CompensationIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type CompensationIndexListQuery = { __typename?: 'Query', compensationIndexListResultCount: number | null, compensationIndexList: { __typename?: 'CompensationConnection', edges: Array<{ __typename?: 'CompensationEdge', node: { __typename?: 'Compensation', id: string, title: string, location: string, baseSalary: number, year: number, category: string, experience: string, fundType: string, fundSize: string, interestIncentiveFeesValue: number, interestMgmtFeesValue: number, annualDiscrBonus: number, totalCashComp: number, postedAt: string, interestIncentiveFeesPerc: number, vestingIncentiveFees: number, interestMgmtFeesPerc: number, vestingMgmtFees: number, totalDeferredComp: number, totalCashDeferredComp: number, fundStrategy: string, industry: string, assetClass: string, pieChartData: string, investInFund: boolean | null, buildPersonalTrackRecord: boolean | null, marketPersonalTrackRecord: boolean | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, compensationStatistics: { __typename?: 'CompensationStatistics', maxComp: number, mean: number, minComp: number, median: number } | null, currentUser: { __typename?: 'User', id: string, isAdmin: boolean, canCreateCompensations: boolean | null, draftCompensations: Array<{ __typename?: 'Compensation', id: string }> | null } | null };

export type CompensationSubmissionCompensationQueryVariables = Exact<{
  actualId?: InputMaybe<Scalars['ID']['input']>;
  estimatedId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CompensationSubmissionCompensationQuery = { __typename?: 'Query', actualCompensation: { __typename?: 'Compensation', id: string, completed: boolean, status: string, category: string, year: number, title: string, experience: string, industry: string, location: string, fundType: string, fundStrategy: string, fundSize: string, assetClass: string, baseSalary: number, interestMgmtFeesPerc: number, interestMgmtFeesValue: number, vestingMgmtFees: number, interestIncentiveFeesPerc: number, interestIncentiveFeesValue: number, vestingIncentiveFees: number, annualDiscrBonus: number, totalDeferredComp: number, investInFund: boolean | null, buildPersonalTrackRecord: boolean | null, marketPersonalTrackRecord: boolean | null, comments: string | null } | null, estimatedCompensation: { __typename?: 'Compensation', id: string, completed: boolean, status: string, category: string, year: number, title: string, experience: string, industry: string, location: string, fundType: string, fundStrategy: string, fundSize: string, assetClass: string, baseSalary: number, interestMgmtFeesPerc: number, interestMgmtFeesValue: number, vestingMgmtFees: number, interestIncentiveFeesPerc: number, interestIncentiveFeesValue: number, vestingIncentiveFees: number, annualDiscrBonus: number, totalDeferredComp: number, investInFund: boolean | null, buildPersonalTrackRecord: boolean | null, marketPersonalTrackRecord: boolean | null, comments: string | null } | null };

export type ContestIndexQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ContestIndexQuery = { __typename?: 'Query', contestIndex: { __typename?: 'ContestConnection', edges: Array<{ __typename?: 'ContestEdge', node: { __typename?: 'Contest', id: string, active: boolean | null, startDate: string | null, endDate: string | null, name: string | null, promoSummary: string | null, prizes: Array<{ __typename?: 'ContestPrizeType', id: string, description: string | null, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, featuredContests: Array<{ __typename?: 'Contest', id: string, active: boolean | null, startDate: string | null, endDate: string | null, name: string | null, promoSummary: string | null, prizes: Array<{ __typename?: 'ContestPrizeType', id: string, description: string | null, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null }> };

export type ContestShowQueryVariables = Exact<{
  contestId: Scalars['ID']['input'];
}>;


export type ContestShowQuery = { __typename?: 'Query', contest: { __typename?: 'Contest', id: string, active: boolean | null, name: string | null, summary: string | null, promoSummary: string | null, countdownDate: string | null, startDate: string | null, endDate: string | null, isCurrentUserJudge: boolean, awardWinners: Array<{ __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null }>, prizes: Array<{ __typename?: 'ContestPrizeType', id: string, description: string | null, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null, sponsors: Array<{ __typename?: 'ContestPrizeType', id: string, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null, judges: Array<{ __typename?: 'ContestJudge', id: string, sanitizedDisplayName: string | null, sanitizedProfilePictureUrl: string | null, sanitizedProfileUrl: string | null, sanitizedEmployerString: string | null, sanitizedEmployerUrl: string | null }> | null } | null };

export type CryptoStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CryptoStatsQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, primaryAsset: { __typename?: 'Asset', id: string, currencyCode: string | null, fiftyTwoWeekRange: string | null, companyData: { __typename?: 'CompanyData', id: string, country: string | null, geography: string | null, industry: string, sector: string } | null, cryptoMarketData: { __typename?: 'CryptoMarketData', circulatingSupply: number | null, fullyDilutedMarketCap: number | null, marketCap: number | null, maxSupply: number | null, percentChange24h: number | null, percentChange7d: number | null, totalSupply: number | null, volume24h: number | null } | null } | null } | null };

export type CurrentRankingQueryVariables = Exact<{
  category: Scalars['String']['input'];
}>;


export type CurrentRankingQuery = { __typename?: 'Query', currentRankingForCategory: { __typename?: 'Ranking', date: string | null, confidence: number | null } | null };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, acceptedPostTerms: boolean | null, canCommentAnonymously: boolean, hasCompletedOnboarding: boolean, isAdmin: boolean, isAllocator: boolean, isPaladin: boolean, isRetail: boolean, profileImageUrl: string | null, sessionId: string, canComment: boolean | null, canWriteIdeas: boolean | null, canWriteWhitePapers: boolean | null, canPost: boolean, canViewUserDetails: boolean | null, canViewIdeas: boolean | null, adminFundProfiles: Array<{ __typename?: 'EmployerProfile', id: string, sectionCompletenessPercents: string | null, sectionVisibilities: string | null, name: string | null, returnsUpdatedDate: string | null, returns: Array<{ __typename?: 'EmployerReturn', id: string | null, benchmark: string | null, employerBenchmark: boolean | null, employerProfileId: string, fiveYear: number | null, ltm: number | null, oneYear: number | null, sevenYear: number | null, sinceInception: number | null, status: string | null, tenYear: number | null, threeYear: number | null, ytd: number | null }> | null, returnsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, category: string | null, description: string | null, filename: string | null, name: string | null, url: string | null }> | null }>, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean } | null } | null };

export type CurrentUserAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isTokenBased: boolean | null, stripeCustomerId: string | null } | null };

export type CurrentUserAccountBadgesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountBadgesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, earnedAt: string | null, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null, unearnedBadges: Array<{ __typename?: 'Badge', id: string, name: string, description: string }> | null } | null };

export type CurrentUserAccountCompensationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountCompensationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAdmin: boolean, draftCompensations: Array<{ __typename?: 'Compensation', id: string, title: string, location: string, year: number, category: string, updatedAt: string }> | null, publishedCompensations: Array<{ __typename?: 'Compensation', id: string, title: string, location: string, baseSalary: number, year: number, category: string, experience: string, fundType: string, fundSize: string, interestIncentiveFeesValue: number, interestMgmtFeesValue: number, annualDiscrBonus: number, totalCashComp: number, postedAt: string, interestIncentiveFeesPerc: number, vestingIncentiveFees: number, interestMgmtFeesPerc: number, vestingMgmtFees: number, totalDeferredComp: number, totalCashDeferredComp: number, fundStrategy: string, industry: string, assetClass: string, pieChartData: string, investInFund: boolean | null, buildPersonalTrackRecord: boolean | null, marketPersonalTrackRecord: boolean | null, comments: string | null }> | null } | null };

export type CurrentUserAccountFollowersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountFollowersQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, activeFollowersCount: number } | null };

export type CurrentUserAccountFollowingQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountFollowingQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, activeFollowedUsersCount: number } | null };

export type CurrentUserAccountIdeasQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentUserAccountIdeasQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isRetail: boolean, publishedIdeasCount: number, draftIdeas: Array<{ __typename?: 'Idea', id: string, entityName: string, userUpdatedAt: string }> | null, publishedIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type CurrentUserAccountJobApplicationsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountJobApplicationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, jobApplications: Array<{ __typename?: 'JobApplication', id: string, status: string, createdAt: string, jobPosting: { __typename?: 'JobPosting', id: string, city: string | null, status: string | null, title: string, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } }> | null } | null };

export type CurrentUserAccountJobPostingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountJobPostingsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, jobPostings: Array<{ __typename?: 'JobPosting', id: string, status: string | null, title: string, applicationCount: number | null, postedAt: string | null, updatedAt: string | null }>, profile: { __typename?: 'Profile', id: string } | null } | null };

export type CurrentUserAccountLeftSideBarQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountLeftSideBarQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canPostJobs: boolean, canApplyToJobs: boolean, isTopDown: boolean, hasBadges: boolean | null, hasIdeas: boolean, stripeCustomerId: string | null, canWriteCompensations: boolean | null, profile: { __typename?: 'Profile', id: string } | null } | null };

export type CurrentUserAccountNotificationShowPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountNotificationShowPageQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canReceiveViewerIntroRequest: boolean | null, hasIdeas: boolean, isAllocator: boolean, isFundProfileAdmin: boolean | null, isRetail: boolean, canMessage: boolean | null, canWriteIdeaComments: boolean | null, canWriteWhitePapers: boolean | null, emailPreferences: Array<{ __typename?: 'EmailPreference', id: string, emailType: string, subscribed: boolean | null }> | null, fundProfileSearchAlerts: Array<{ __typename?: 'EmployerProfileSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null, employerProfileSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null, ideaSearchAlerts: Array<{ __typename?: 'IdeaSearchAlert', id: string, active: boolean | null, frequency: string | null, display: boolean | null, name: string | null, ideaSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null } | null };

export type CurrentUserAccountSavedSearchesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountSavedSearchesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, fundProfileSearchAlerts: Array<{ __typename?: 'EmployerProfileSearchAlert', id: string, active: boolean | null, display: boolean | null, name: string | null, employerProfileSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null, ideaSearchAlerts: Array<{ __typename?: 'IdeaSearchAlert', id: string, active: boolean | null, frequency: string | null, display: boolean | null, name: string | null, ideaSavedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null } | null }> | null } | null };

export type CurrentUserAccountShowPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountShowPageQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string } | null };

export type CurrentUserAccountUserReferralsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccountUserReferralsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, allTimeReferralAwards: number | null, userReferrals: Array<{ __typename?: 'UserReferral', id: string, cumulativeRewardDays: number | null, referralProgramMaxRewardDays: number | null, referee: { __typename?: 'User', id: string, displayName: string, email: string, activeAt: string | null } }> | null, unregisteredReferrals: Array<{ __typename?: 'UserApplication', id: string | null, email: string, status: string | null, referrerId: number | null }> | null } | null };

export type CurrentUserAccreditedInvestorProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserAccreditedInvestorProfileQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, accreditedInvestorProfile: { __typename?: 'AccreditedInvestorProfile', userId: string, netWorth: string | null, next12MoAllocation: string | null, investmentSize: string | null, yearsInvesting: string | null, bonds: string | null, hedgeFunds: string | null, realEstate: string | null, foreignCurrencies: string | null, futuresOrCommodities: string | null, privateEquityFunds: string | null, publiclyTradedStocks: string | null, privateCompanies: string | null } | null } | null };

export type CurrentUserArchivedReadingListItemsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CurrentUserArchivedReadingListItemsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, archivedReadingListItemsCount: number | null, isPaladin: boolean, canViewUserDetails: boolean | null, archivedReadingListItems: { __typename?: 'ReadingListItemConnection', edges: Array<{ __typename?: 'ReadingListItemEdge', node: { __typename?: 'ReadingListItem', id: string, idea: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } } | null } | null> | null } | null } | null };

export type CurrentUserDraftAndPendingIdeasQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserDraftAndPendingIdeasQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, draftAndPendingIdeas: Array<{ __typename?: 'Idea', id: string, status: string | null, updatedAt: string, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> }> } | null };

export type CurrentUserEventRegistrationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserEventRegistrationQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, hasRegisteredForEvent: boolean | null } | null };

export type CurrentUserFollowersListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CurrentUserFollowersListQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, activeFollowersCount: number, canViewUserDetails: boolean | null, followersList: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type CurrentUserFollowingListQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CurrentUserFollowingListQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, activeFollowedUsersCount: number, canViewUserDetails: boolean | null, followingList: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type CurrentUserFundProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserFundProfileQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, adminFundProfiles: Array<{ __typename?: 'EmployerProfile', id: string, name: string | null }> } | null };

export type CurrentUserIdeaDraftsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdeaDraftsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, draftIdeas: Array<{ __typename?: 'Idea', id: string, updatedAt: string, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> }> | null } | null };

export type CurrentUserIdeaTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserIdeaTokensQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, availableTokenCount: number | null, trialTokenCount: number | null, trialTokenExpiresIn: string | null, usedTokenCount: number | null } | null };

export type CurrentUserNotificationSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserNotificationSettingsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canReceiveViewerIntroRequest: boolean | null, canWriteIdeas: boolean | null, canAccessComments: boolean | null, canViewCapIntro: boolean, canAccessJobPostings: boolean | null, userNotificationSetting: { __typename?: 'UserNotificationSetting', id: string, showAll: boolean, showActivelyDiscussed: boolean, showBadges: boolean, showBiggestMovers: boolean, showCapIntro: boolean, showContests: boolean, showComments: boolean, showFolloweeActivity: boolean, showFollowers: boolean, showFundFollower: boolean, showIdeas: boolean, showJobVault: boolean, showViewerIntroRequests: boolean, showNewRecommended: boolean, showRankings: boolean, showTrendingResearch: boolean, showWatchlist: boolean, showWhitePapers: boolean } | null } | null };

export type CurrentUserNotificationsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentUserNotificationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, newNotificationsCount: number | null, unreadNotificationsCount: number | null, notifications: { __typename?: 'NotificationConnection', edges: Array<{ __typename?: 'NotificationEdge', node: { __typename?: 'Notification', id: string, description: string | null, createdAt: string | null, viewed: boolean, linkId: string | null, customLink: string | null, notificationClass: string | null, hidden: boolean | null, associatedUser: { __typename?: 'User', id: string, isAllocator: boolean, allocatorProfileLogoUrl: string | null, profileImageUrl: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type CurrentUserPublishedPostsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPublishedPostsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, acceptedPostTerms: boolean | null, isAdmin: boolean, profileImageUrl: string | null, posts: Array<{ __typename?: 'Post', id: string, body: string | null, commentsCount: number | null, currentUserHasLiked: boolean, eventId: string | null, domain: string | null, likeCount: number, ogDescription: string | null, ogUrl: string | null, ogPreviewImageUrl: string | null, ogTitle: string | null, postedAt: string | null, tagList: Array<string> | null, untaggedBody: string | null, youtubeId: string | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null } | null }> | null } | null };

export type CurrentUserPublishedWhitePapersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPublishedWhitePapersQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canWriteWhitePapers: boolean | null, whitePapers: Array<{ __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, elevatorPitch: string, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, submittedAt: string | null, tagList: Array<string>, title: string, updatedAt: string, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } }> | null } | null };

export type CurrentUserQuickPositionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuickPositionsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, quickPositions: Array<{ __typename?: 'QuickPosition', id: string, closedAt: string | null, closingPrice: number | null, direction: string, openedAt: string | null, openingPrice: number | null, returnToDate: number | null, asset: { __typename?: 'Asset', id: string, currencyCode: string | null, entityId: string, symbol: string | null, latestPrice: number | null } }> | null } | null };

export type CurrentUserRankingsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserRankingsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canViewIdeaFilterDetails: boolean | null, canViewUserDetails: boolean | null } | null };

export type CurrentUserRatingsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentUserRatingsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, ratings: { __typename?: 'UserRatingConnection', edges: Array<{ __typename?: 'UserRatingEdge', node: { __typename?: 'UserRating', id: string, createdAt: string, score: number, ratingId: string, updatedAt: string, totalReturn: number | null, idea: { __typename?: 'Idea', id: string, direction: string | null, totalReturn: number | null, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, name: string | null, primarySymbol: string | null } | null }> } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type CurrentUserResearchSubmissionQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserResearchSubmissionQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canWriteWhitePapers: boolean | null, canWriteIdeas: boolean | null } | null };

export type CurrentUserSentIntroRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserSentIntroRequestsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, sentViewerIntroRequests: Array<{ __typename?: 'ViewerIntroRequest', createdAt: string, id: string, status: string, updatedAt: string, viewableDisplayTitle: string, viewableId: string, viewableType: string, ideaView: { __typename?: 'IdeaView', id: string, viewerCityName: string | null, viewerFundType: string | null, viewerAumRange: string | null, viewerTitle: string | null } | null, viewer: { __typename?: 'User', id: string, displayName: string } }> | null } | null };

export type CurrentUserUnreadReadingListItemsQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CurrentUserUnreadReadingListItemsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isPaladin: boolean, unreadReadingListItemsCount: number | null, canViewUserDetails: boolean | null, unreadReadingListItems: { __typename?: 'ReadingListItemConnection', edges: Array<{ __typename?: 'ReadingListItemEdge', node: { __typename?: 'ReadingListItem', id: string, idea: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } } | null } | null> | null } | null } | null };

export type CurrentUserViewerIntroRequestsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentUserViewerIntroRequestsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, viewerIntroRequestCount: number, viewerIntroRequests: { __typename?: 'ViewerIntroRequestConnection', edges: Array<{ __typename?: 'ViewerIntroRequestEdge', node: { __typename?: 'ViewerIntroRequest', id: string, status: string, createdAt: string, viewableId: string, viewableType: string, viewableDisplayTitle: string, author: { __typename?: 'User', id: string, displayName: string } } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type CurrentUserWatchlistQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWatchlistQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAllocator: boolean, canViewUserDetails: boolean | null, watchlist: { __typename?: 'Watchlist', id: string, onboardingStatus: string, sectors: Array<{ __typename?: 'Sector', id: string, name: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string, name: string }> | null, assetClasses: Array<{ __typename?: 'AssetClass', id: string, name: string }> | null, entitiesFromMassImport: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, entitiesRegularFollows: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, massImports: Array<{ __typename?: 'MassImport', id: string, numberOfTickers: number, fileName: string }> | null, users: Array<{ __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null }> | null, aumRanges: Array<{ __typename?: 'AumRange', id: string, name: string }> | null, fundTypes: Array<{ __typename?: 'FundType', id: string, name: string }> | null, fundStrategies: Array<{ __typename?: 'FundStrategy', id: string, name: string }> | null } | null } | null };

export type CurrentUserWatchlistTickersQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWatchlistTickersQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, followedEntityIds: Array<string>, watchlistTickers: Array<{ __typename?: 'WatchlistTagRelationship', id: string, createdAt: string, entity: { __typename?: 'Entity', id: string, name: string | null, primaryAsset: { __typename?: 'Asset', primarySymbol: string | null } | null } | null }> | null } | null };

export type CurrentUserWhitePaperDraftsQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserWhitePaperDraftsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, draftWhitePapers: Array<{ __typename?: 'WhitePaper', id: string, title: string, categories: Array<string>, updatedAt: string }> | null } | null };

export type EmailSearchQueryVariables = Exact<{
  email?: InputMaybe<Scalars['String']['input']>;
  userOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EmailSearchQuery = { __typename?: 'Query', emailSearch: boolean };

export type EmployerBlacklistQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployerBlacklistQuery = { __typename?: 'Query', employerBlacklist: Array<string> | null };

export type EmployerSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type EmployerSearchQuery = { __typename?: 'Query', employerSearch: Array<{ __typename?: 'Employer', name: string, aumRange: string | null, fundType: string | null }> | null };

export type EntitiesByBloombergSymbolQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type EntitiesByBloombergSymbolQuery = { __typename?: 'Query', entitiesByBloombergSymbol: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> };

export type EntityFeedCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityFeedCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canCommentAnonymously: boolean, isAdmin: boolean, isAllocator: boolean, isRetail: boolean, profileImageUrl: string | null, sessionId: string, canViewUserDetails: boolean | null } | null };

export type EntityOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityOverviewQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, primaryAsset: { __typename?: 'Asset', id: string, latestPrice: number | null, latestQuoteDate: string | null, fundamental: { __typename?: 'Fundamental', id: string, sellsideConsensusText: string } | null } | null } | null };

export type EntityOverviewCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type EntityOverviewCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAdmin: boolean } | null };

export type EntityPollQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityPollQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, currencyCode: string | null, name: string | null, primaryAssetId: string | null, primarySymbol: string | null, pollQuestionsUnansweredByCurrentUser: Array<{ __typename?: 'CompanyQuestion', id: string, answerOptions: Array<string>, expirationMonths: number | null, name: string, questionType: string, text: string }> | null } | null, companyQuestions: Array<{ __typename?: 'CompanyQuestion', id: string, yMin: number | null, yMax: number | null, tickCount: number | null, showTooltip: boolean | null, tickValues: Array<string> | null, answerOptions: Array<string>, expirationMonths: number | null, name: string, questionType: string, text: string, pollResponseData: { __typename?: 'PollResponseData', answeredByCurrentUser: boolean, buysidePollResultStats: { __typename?: 'PollResultStatistics', monthlyAvg: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, twelveMonthsPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, currentMonthPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null } | null, retailPollResultStats: { __typename?: 'PollResultStatistics', monthlyAvg: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, twelveMonthsPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null, currentMonthPct: Array<{ __typename?: 'NumericResult', label: string, value: number }> | null } | null } }> | null, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null } | null };

export type EntityPostQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityPostQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, acceptedPostTerms: boolean | null, isAdmin: boolean, profileImageUrl: string | null, canPost: boolean } | null, entity: { __typename?: 'Entity', id: string, tickerTagString: string | null } | null };

export type EntityRelatedCompaniesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityRelatedCompaniesQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, relatedCompanies: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, mostRecentIdea: { __typename?: 'Idea', id: string, elevatorPitch: string | null, postedAt: string | null, totalReturn: number | null, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, direction: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } | null } | null }> | null } | null };

export type EntityStatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EntityStatsQuery = { __typename?: 'Query', entity: { __typename?: 'Entity', id: string, primaryAsset: { __typename?: 'Asset', id: string, currencyCode: string | null, fiftyTwoWeekRange: string | null, companyData: { __typename?: 'CompanyData', id: string, country: string | null, geography: string | null, industry: string, sector: string } | null, fundamental: { __typename?: 'Fundamental', id: string, bookValue: number | null, currentPe: number | null, debtBook: number | null, divYield: number | null, ev: number | null, evEbitda: number | null, evFcf: number | null, evSales: number | null, fcfYield: number | null, forwardPe: number | null, marketCap: number | null, priceBook: number | null, sellsideConsensus: number | null, threeMonthAdv: number | null, totalCash: number | null, totalDebt: number | null } | null } | null } | null };

export type EntityToMentionSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type EntityToMentionSearchQuery = { __typename?: 'Query', assetsByBloombergSymbol: Array<{ __typename?: 'Asset', entityId: string, mentionDisplay: string, entity: { __typename?: 'Entity', id: string, primarySymbol: string | null } }> | null };

export type EventRegistrationSponsorsQueryVariables = Exact<{
  contestId: Scalars['ID']['input'];
}>;


export type EventRegistrationSponsorsQuery = { __typename?: 'Query', contest: { __typename?: 'Contest', id: string, eventSponsors: Array<{ __typename?: 'ContestPrizeType', id: string, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null } | null };

export type FeaturedContestQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturedContestQuery = { __typename?: 'Query', featuredContests: Array<{ __typename?: 'Contest', id: string, active: boolean | null, name: string | null, countdownDate: string | null, disableSiteWideModal: boolean | null }> };

export type FeedQueryVariables = Exact<{
  feedId?: InputMaybe<Scalars['ID']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
  feedFilter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type FeedQuery = { __typename?: 'Query', feedItems: { __typename?: 'FeedItemConnection', edges: Array<{ __typename?: 'FeedItemEdge', node: { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null } | { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type FeedRankQueryVariables = Exact<{
  feedItemId: Scalars['ID']['input'];
}>;


export type FeedRankQuery = { __typename?: 'Query', biggestMoverRank: { __typename?: 'Rank', id: string, category: string, value: number | null, user: { __typename?: 'User', publishedIdeasCount: number, id: string, displayName: string, profileImageUrl: string | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null, topIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, totalReturn: number | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null> | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null } | null, pastRank: { __typename?: 'Rank', id: string, category: string, value: number | null } | null }, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null, canManageMessages: boolean | null } | null };

export type FeedShowQueryVariables = Exact<{
  showId: Scalars['ID']['input'];
}>;


export type FeedShowQuery = { __typename?: 'Query', feedItemShow: { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null } | { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null } | null } | null };

export type FundLetterSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type FundLetterSourcesQuery = { __typename?: 'Query', fundLetterSources: Array<{ __typename?: 'FundLetterSource', startingCharacter: string, sources: Array<string> }> };

export type FundLettersQueryVariables = Exact<{
  fundName: Scalars['String']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type FundLettersQuery = { __typename?: 'Query', lettersForFund: { __typename?: 'FundLetterConnection', edges: Array<{ __typename?: 'FundLetterEdge', node: { __typename?: 'FundLetter', id: string, name: string | null, pdfLink: string } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type FundProfileCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type FundProfileCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, introRequestCount: number | null, isAdmin: boolean, isAllocator: boolean, isCapIntroMember: boolean, profileImageUrl: string | null } | null };

export type FundProfileIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type FundProfileIndexListQuery = { __typename?: 'Query', fundProfilesIndexListResultCount: number | null, fundProfilesIndexList: Array<{ __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, highlights: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', id: string | null, ltm: number | null, sinceInception: number | null, ytd: number | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null }> | null };

export type FundProfileIndexSavedSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type FundProfileIndexSavedSearchQuery = { __typename?: 'Query', fundProfilesSavedSearchList: { __typename?: 'EmployerProfileSearchAlertConnection', edges: Array<{ __typename?: 'EmployerProfileSearchAlertEdge', node: { __typename?: 'EmployerProfileSearchAlert', id: string, name: string | null, savedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null, searchKey: string } | null } | null } | null> | null } | null };

export type FundProfileRecommendationsQueryVariables = Exact<{
  showAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type FundProfileRecommendationsQuery = { __typename?: 'Query', fundRecommendations: { __typename?: 'FundRecommendationConnection', edges: Array<{ __typename?: 'FundRecommendationEdge', node: { __typename?: 'FundRecommendation', matchesGeographies: boolean | null, matchesSectors: boolean | null, matchesAssetClasses: boolean | null, geographiesMatching: Array<string> | null, sectorsMatching: Array<string> | null, assetClassesMatching: Array<string> | null, hide: boolean | null, id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, fundProfile: { __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, highlights: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', id: string | null, ltm: number | null, sinceInception: number | null, ytd: number | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null } | null } | null } | null> | null } };

export type FundProfileShowPageQueryVariables = Exact<{
  employerProfileId: Scalars['ID']['input'];
}>;


export type FundProfileShowPageQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, acceptedFundDisclaimer: boolean, currentEmployerName: string | null, isAdmin: boolean, isAllocator: boolean, isFundAdmin: boolean, isPaladin: boolean, canViewIdeas: boolean | null, canViewUserDetails: boolean | null } | null, fundProfile: { __typename?: 'EmployerProfile', aum: number | null, foundingDate: string | null, fundAdminIds: Array<string>, fundManager: string | null, sectionCompletenessPercents: string | null, excludedSections: Array<string> | null, sectionVisibilities: string | null, currentUserOnBlocklist: boolean | null, currentUserViewCount: number | null, currentUserHasMessagedFund: boolean | null, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null, id: string, aumRange: string | null, description: string | null, focus: string | null, followerCount: number | null, foundingYear: string | null, fundType: string | null, location: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, status: string | null, updatedAt: string | null, introRequestsLeft: number | null, introRequestPeriodEnd: string | null, sectorExpertise: Array<string> | null, geographicExpertise: Array<string> | null, assetClassExpertise: Array<string> | null, subsectorExpertise: string | null, tagNames: Array<string> | null, returnsUpdatedDate: string | null, holdingsUpdatedDate: string | null, beta: number | null, turnoverRatio: number | null, metricsUpdatedAt: string | null, managementFee: number | null, incentiveFee: number | null, hurdleRate: number | null, lockUp: number | null, highwaterMark: boolean | null, seedDeal: boolean | null, foundersShares: boolean | null, investorLevelGates: boolean | null, notes: string | null, currentEmployees: Array<{ __typename?: 'User', id: string, displayName: string }>, fundRecommendation: { __typename?: 'FundRecommendation', id: string, matchesStrategy: boolean | null, matchesAumRange: boolean | null, matchesFundType: boolean | null, fundProfile: { __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, highlights: string | null, logoProfileUrl: string | null, name: string | null, sharpeRatio: number | null, strategy: string | null, vanityLink: string | null, lastReturn: { __typename?: 'EmployerReturn', id: string | null, ltm: number | null, sinceInception: number | null, ytd: number | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null } | null } | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, status: string, messageThread: string | null } | null, lastReturn: { __typename?: 'EmployerReturn', ltm: number | null, sinceInception: number | null, ytd: number | null } | null, executives: Array<{ __typename?: 'EmployerProfileExecutive', id: string, name: string | null, bio: string | null, photoUrl: string | null, photoProfileUrl: string | null, defaultPhoto: string | null }> | null, firmReferences: Array<{ __typename?: 'EmployerProfileFirmReference', id: string, name: string | null, employer: string | null, title: string | null, contactEmail: string | null, relationshipToFund: string | null }> | null, returns: Array<{ __typename?: 'EmployerReturn', id: string | null, benchmark: string | null, employerBenchmark: boolean | null, employerProfileId: string, fiveYear: number | null, ltm: number | null, oneYear: number | null, sevenYear: number | null, sinceInception: number | null, status: string | null, tenYear: number | null, threeYear: number | null, ytd: number | null }> | null, returnsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, category: string | null, description: string | null, filename: string | null, name: string | null, url: string | null }> | null, featuredResearch: Array<{ __typename?: 'Idea', id: string, postedAt: string | null, totalReturn: number | null, elevatorPitch: string | null, canCurrentUserViewIdeaFilterDetails: boolean, updated: string, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', name: string | null } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } | null }> | null, featuredWhitePaperResearch: Array<{ __typename?: 'WhitePaper', id: string, elevatorPitch: string, submittedAt: string | null, title: string, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } }> | null, holdings: Array<{ __typename?: 'EmployerProfileHolding', id: string, percentOfPortfolio: number | null, entityName: string | null, primarySymbol: string | null, assetClass: string | null, realizedReturn: number | null, expectedReturn: number | null, averageCost: number | null, action: string | null, priceTarget: string | null, timeframe: string | null }> | null, holdingsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null, marketingMaterials: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null, filename: string | null, url: string | null }> | null, presses: Array<{ __typename?: 'EmployerProfilePress', id: string, title: string | null, url: string | null, filename: string | null, fileUrl: string | null, publishDate: string | null, description: string | null, previewImageUrl: string | null }> | null, metricsDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null, feeStructureDocuments: Array<{ __typename?: 'EmployerProfileDocument', id: string, name: string | null, description: string | null, filename: string | null }> | null, dueDiligenceDocuments: Array<{ __typename?: 'EmployerProfileDueDiligenceDocument', id: string, name: string, category: string, description: string, filename: string | null }> | null, serviceProviders: Array<{ __typename?: 'EmployerProfileServiceProvider', id: string, category: string | null, firmName: string | null, contactName: string | null, contactEmail: string | null, contactPhoneNumber: string | null }> | null } | null };

export type HomePageCommentsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  searchParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePageCommentsQuery = { __typename?: 'Query', maxOffset: number, homeComments: Array<{ __typename?: 'Comment', parsedBody: string | null, id: string, body: string | null, byAllocator: boolean, commentableType: string | null, commentCreationTime: string, currentUserHasLiked: boolean, likeCount: number, parentId: string | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile' } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, assetSymbol: string, entityName: string } | { __typename?: 'IdeaUpdate', id: string, idea: { __typename?: 'Idea', id: string, assetSymbol: string, entityName: string } | null } | { __typename?: 'Post' } | { __typename?: 'WhitePaper' } | null, anonUser: { __typename?: 'AnonUser', id: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null }> };

export type HomePageIdeaUpdatesQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  searchParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type HomePageIdeaUpdatesQuery = { __typename?: 'Query', maxOffset: number, homeIdeaUpdates: Array<{ __typename?: 'IdeaUpdate', id: string, changesHash: any, closed: boolean, impact: string | null, postedAt: string, text: string | null, idea: { __typename?: 'Idea', id: string, assetSymbol: string, entityName: string } | null, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null }> };

export type HomePageTrendingIdeasQueryVariables = Exact<{ [key: string]: never; }>;


export type HomePageTrendingIdeasQuery = { __typename?: 'Query', trendingIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, totalReturn: number | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null> | null } | null };

export type IdeaIndexCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type IdeaIndexCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, profileImageUrl: string | null, isPaladin: boolean, isBuyside: boolean, canWriteIdeas: boolean | null, canViewUserDetails: boolean | null, canViewIdeas: boolean | null, canViewIdeaFilterDetails: boolean | null } | null };

export type IdeaIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type IdeaIndexListQuery = { __typename?: 'Query', ideasIndexListResultCount: number | null, ideasIndexList: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type IdeaIndexSavedSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type IdeaIndexSavedSearchQuery = { __typename?: 'Query', ideasSavedSearchList: { __typename?: 'IdeaSearchAlertConnection', edges: Array<{ __typename?: 'IdeaSearchAlertEdge', node: { __typename?: 'IdeaSearchAlert', id: string, name: string | null, savedSearch: { __typename?: 'SavedSearch', id: string, criteria: any | null, searchKey: string } | null } | null } | null> | null } | null };

export type IdeaSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IdeaSubmissionQuery = { __typename?: 'Query', termsOfUse: string | null, currentContests: Array<{ __typename?: 'Contest', id: string, name: string | null }>, currentUser: { __typename?: 'User', id: string, isAdmin: boolean, currentEmployers: Array<{ __typename?: 'Employer', id: string, canExtendCapIntroAccess: boolean, hasFundProfile: boolean, name: string }> } | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, catalystNames: Array<string>, contestIds: Array<string>, elevatorPitch: string | null, employerApprovalDisclaimer: boolean | null, featuredOnAFundProfile: boolean | null, isPairTrade: boolean | null, noPriorAgreementDisclaimer: boolean | null, pairRatio: Array<number> | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, publicInformationDisclaimer: boolean | null, returnTarget: number | null, situation: string | null, status: string | null, tagList: Array<string>, targetAllocation: string | null, thesis: string | null, timeframe: string | null, associatedEmployer: { __typename?: 'Employer', id: string } | null, ideaAttachments: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, positions: Array<{ __typename?: 'Position', id: string, latestPrice: number | null, priceTarget: number | null, direction: string, asset: { __typename?: 'Asset', id: string } | null }>, user: { __typename?: 'User', id: string } | null } };

export type IdeaSubmissionAssetQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type IdeaSubmissionAssetQuery = { __typename?: 'Query', asset: { __typename?: 'Asset', id: string, currencyCode: string | null, latestPrice: number | null, name: string | null, primarySymbol: string | null, entity: { __typename?: 'Entity', name: string | null } } | null };

export type IdeaSubmissionAssetLookupQueryVariables = Exact<{
  fsymId: Scalars['ID']['input'];
}>;


export type IdeaSubmissionAssetLookupQuery = { __typename?: 'Query', ideaSubmissionAssetLookup: { __typename?: 'Asset', id: string } | null };

export type IdeaSubmissionAttachmentsQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaSubmissionAttachmentsQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, ideaAttachments: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null } };

export type IdeaUpdateCommentsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  controlName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IdeaUpdateCommentsQuery = { __typename?: 'Query', ideaUpdate: { __typename?: 'IdeaUpdate', id: string, comments: { __typename?: 'CommentConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, likeCount: number, currentUserHasLiked: boolean, parentId: string | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, commentAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, commentMentionables: Array<{ __typename?: 'Mentionable', id: string, display: string }> | null }, currentUser: { __typename?: 'User', id: string, canCommentAnonymously: boolean, isAllocator: boolean, isRetail: boolean, profileImageUrl: string | null } | null };

export type IdeaViewsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type IdeaViewsQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, anonymous: boolean, openedAt: string | null, lastUpdatedAt: string, totalReturn: number | null, closedAt: string | null, newViewsCount: number, isCurrentUserAuthor: boolean, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }>, ideaViews: { __typename?: 'IdeaViewConnection', edges: Array<{ __typename?: 'IdeaViewEdge', node: { __typename?: 'IdeaView', actions: Array<string>, id: string, ideaAssetSymbol: string | null, ideaId: string, timestamp: string, timeAgo: string, viewerAumRange: string | null, viewerCityName: string | null, viewerFundType: string | null, viewerTitle: string | null, viewer: { __typename?: 'User', canReceiveViewerIntroRequest: boolean | null, id: string, emailPreferences: Array<{ __typename?: 'EmailPreference', id: string, emailType: string, subscribed: boolean | null }> | null }, viewerIntroRequest: { __typename?: 'ViewerIntroRequest', id: string, status: string } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } };

export type InsiderTradesQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  watchlistedTickers?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
}>;


export type InsiderTradesQuery = { __typename?: 'Query', insiderTrades: { __typename?: 'PaginatedInsiderTrades', maxPage: number, resultCount: number, trades: Array<{ __typename?: 'InsiderTrade', id: string, date: string, entityId: string | null, name: string, numShares: number, ownershipChangePct: string | null, sharePrice: string, symbol: string, title: string, tradeType: string }> } };

export type JobApplicationCurrentUserQueryVariables = Exact<{
  jobPostId: Scalars['ID']['input'];
}>;


export type JobApplicationCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, displayName: string, email: string, profile: { __typename?: 'Profile', id: string, mobilePhone: string | null, workPhone: string | null, resume: string | null } | null } | null, jobPost: { __typename?: 'JobPosting', id: string, coverLetter: string | null } | null };

export type JobApplicationIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type JobApplicationIndexListQuery = { __typename?: 'Query', indexListResultCount: number | null, jobApplicationsIndexList: Array<{ __typename?: 'JobApplication', id: string, coverNote: string | null, createdAt: string, email: string | null, name: string | null, phone: string | null, resumeUrl: string | null, starred: boolean | null, status: string, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string } | null } | null, profile: { __typename?: 'Profile', id: string, imageProfileUrl: string | null, city: string | null, summary: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null }> | null };

export type JobPostingAndApplicationQueryVariables = Exact<{
  jobApplicationId: Scalars['ID']['input'];
}>;


export type JobPostingAndApplicationQuery = { __typename?: 'Query', jobApplication: { __typename?: 'JobApplication', id: string, coverNote: string | null, name: string | null, phone: string | null, email: string | null, userId: string, starred: boolean | null, status: string, resumeUrl: string | null, otherApplications: Array<{ __typename?: 'JobApplication', id: string, name: string | null }> | null, jobPosting: { __typename?: 'JobPosting', id: string, title: string, applicationCount: number | null } } | null };

export type JobPostingApplicationsQueryVariables = Exact<{
  jobPostingId: Scalars['ID']['input'];
}>;


export type JobPostingApplicationsQuery = { __typename?: 'Query', jobPost: { __typename?: 'JobPosting', id: string, applications: Array<{ __typename?: 'JobApplication', id: string, createdAt: string, name: string | null, resumeUrl: string | null, starred: boolean | null, status: string, user: { __typename?: 'User', id: string, publishedIdeasCount: number } | null }> | null } | null };

export type JobPostingIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type JobPostingIndexListQuery = { __typename?: 'Query', jobPostingIndexListResultCount: number | null, jobPostingIndexList: { __typename?: 'JobPostingConnection', edges: Array<{ __typename?: 'JobPostingEdge', node: { __typename?: 'JobPosting', id: string, title: string, description: string | null, city: string | null, postedAt: string | null, sectors: string | null, employer: { __typename?: 'Employer', aumRange: string | null, strategy: string | null, fundType: string | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, currentUser: { __typename?: 'User', id: string, canPostJobs: boolean, missingJobPostReqDescription: string | null, isAdmin: boolean, hasJobApplications: boolean | null, hasJobPostings: boolean, displayName: string, profileImageUrl: string | null, jobPostingIds: Array<string> | null, jobPostsAppliedIds: Array<string> | null } | null };

export type JobVaultShowQueryVariables = Exact<{
  jobPostId: Scalars['ID']['input'];
}>;


export type JobVaultShowQuery = { __typename?: 'Query', jobPost: { __typename?: 'JobPosting', id: string, assets: Array<string> | null, actScore: number | null, userId: string | null, city: string | null, degreesAndCertifications: Array<string> | null, description: string | null, disqualifiedReasons: Array<string> | null, firmExperience: Array<string> | null, regions: Array<string> | null, minimumGpa: string | null, maximumGpa: string | null, minimumSat: string | null, maximumSat: string | null, postedAt: string | null, sectors: string | null, status: string | null, title: string, useCompanyInvestmentMandate: boolean | null, yearsOfExperience: string | null, employer: { __typename?: 'Employer', id: string, name: string, assets: Array<string> | null, aumRange: string | null, description: string | null, fundType: string | null, investmentStyle: string | null, regions: Array<string> | null, strategy: string | null, sectors: Array<string> | null } | null } | null };

export type JobVaultShowCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type JobVaultShowCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAdmin: boolean, isAllocator: boolean, isHighProfile: boolean | null, canApplyToJobs: boolean, displayName: string, hasActiveContract: boolean | null, hasJobAccess: boolean | null, jobPostsAppliedIds: Array<string> | null, canCreateIdea: boolean | null, profile: { __typename?: 'Profile', id: string } | null } | null };

export type JobVaultSubmissionCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type JobVaultSubmissionCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, city: string | null, aum: number | null, aumRangePresent: boolean | null, name: string, assets: Array<string> | null, aumRange: string | null, description: string | null, fundType: string | null, investmentStyle: string | null, regions: Array<string> | null, strategy: string | null, sectors: Array<string> | null } | null } | null } | null };

export type JoinCapIntroCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type JoinCapIntroCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, currentEmployers: Array<{ __typename?: 'Employer', id: string, canExtendCapIntroAccess: boolean, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, status: string | null } | null }>, profile: { __typename?: 'Profile', id: string } | null } | null };

export type LargestInsiderTradesQueryVariables = Exact<{
  timeframe: Scalars['String']['input'];
}>;


export type LargestInsiderTradesQuery = { __typename?: 'Query', largestInsiderTrades: Array<{ __typename?: 'InsiderTrade', id: string, date: string, entityId: string | null, name: string, numShares: number, ownershipChangePct: string | null, sharePrice: string, symbol: string, title: string, tradeType: string }> };

export type LastNIdeaViewsCurrentUserQueryVariables = Exact<{
  n: Scalars['Int']['input'];
}>;


export type LastNIdeaViewsCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, publishedIdeasCount: number, canWriteIdeas: boolean | null, ideaIsBlocked: boolean | null, lastNViews: { __typename?: 'IdeaViewConnection', edges: Array<{ __typename?: 'IdeaViewEdge', node: { __typename?: 'IdeaView', actions: Array<string>, id: string, ideaAssetSymbol: string | null, ideaId: string, timestamp: string, timeAgo: string, viewerAumRange: string | null, viewerCityName: string | null, viewerFundType: string | null, viewerTitle: string | null, viewer: { __typename?: 'User', canReceiveViewerIntroRequest: boolean | null, id: string, emailPreferences: Array<{ __typename?: 'EmailPreference', id: string, emailType: string, subscribed: boolean | null }> | null }, viewerIntroRequest: { __typename?: 'ViewerIntroRequest', id: string, status: string } | null } | null } | null> | null } | null, publishedIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, createdAt: string, newViewsCount: number, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null } | null }> } | null } | null> | null } | null } | null };

export type MainNavigationCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type MainNavigationCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canEditProfile: boolean | null, displayName: string, hasActiveSubscription: boolean, hasCompletedAccreditedInvestorProfile: boolean | null, hasIdeas: boolean, hasJobApplications: boolean | null, hasJobPostings: boolean, isAdmin: boolean, isAllocator: boolean, isBuyside: boolean, isFundProfileAdmin: boolean | null, isRetail: boolean, isTopDown: boolean, isTokenBased: boolean | null, profileImageUrl: string | null, unaddressedApplicationsCount: number | null, unseenMessageCount: number | null, followedFundIds: Array<string>, followedUserIds: Array<string>, followedEntityIds: Array<string>, followedEsgIds: Array<string>, followedGeographyIds: Array<string>, followedGlobalMacroIds: Array<string>, followedSectorIds: Array<string>, canAccessCompensations: boolean | null, canAccessJobPostings: boolean | null, canAccessMessages: boolean | null, canManageMessages: boolean | null, canAccessUserDetails: boolean | null, canViewUserDetails: boolean | null, canWriteIdeas: boolean | null, canViewIdeas: boolean | null, allocatorProfile: { __typename?: 'AllocatorProfile', id: string } | null, currentEmployers: Array<{ __typename?: 'Employer', id: string, name: string }>, profile: { __typename?: 'Profile', id: string, isAccredited: boolean | null } | null, readingListItems: { __typename?: 'ReadingListItemConnection', edges: Array<{ __typename?: 'ReadingListItemEdge', node: { __typename?: 'ReadingListItem', id: string, archived: boolean, ideaId: string } | null } | null> | null } | null } | null };

export type MainSiteNavigationMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type MainSiteNavigationMessagesQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, unreadMessageCount: number | null, incomingMessageThreads: Array<{ __typename?: 'Message', id: string, receiverStatus: string | null, threadCount: number | null, body: string | null, createdAt: string | null, sender: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null } | null }> | null } | null };

export type MassTickerSearchQueryVariables = Exact<{
  tickers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type MassTickerSearchQuery = { __typename?: 'Query', massTickerSearch: { __typename?: 'MassTickerSearch', unfoundSymbols: Array<string>, foundEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> } | null };

export type MediaIndexListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
  type: Scalars['String']['input'];
}>;


export type MediaIndexListQuery = { __typename?: 'Query', indexListResultCount: number | null, mostPopularMediaHashtags: Array<string>, mediaIndexList: { __typename?: 'MediaConnection', edges: Array<{ __typename?: 'MediaEdge', node: { __typename?: 'PodcastEpisode', id: string, description: string, tagList: Array<string>, thumbnailImageUrl: string | null, vanityLink: string | null, publishedAt: string, title: string, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> } | { __typename?: 'Video', id: string, description: string, publishedAt: string, tagList: Array<string>, thumbnailImageUrl: string | null, title: string, vanityLink: string | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type MediaShowQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  type: Scalars['String']['input'];
}>;


export type MediaShowQuery = { __typename?: 'Query', media: { __typename?: 'PodcastEpisode', id: string, description: string, tagList: Array<string>, mediaId: string, publishedAt: string, title: string, mentionedEntities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }>, relatedMedia: Array<{ __typename?: 'PodcastEpisode', id: string, description: string, tagList: Array<string>, vanityLink: string | null, title: string }> } | { __typename?: 'Video', id: string, description: string, publishedAt: string, tagList: Array<string>, title: string, mediaId: string, mentionedEntities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }>, relatedMedia: Array<{ __typename?: 'Video', id: string, description: string, tagList: Array<string>, title: string, vanityLink: string | null }> } };

export type MentionableAssetQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type MentionableAssetQuery = { __typename?: 'Query', assetsByBloombergSymbol: Array<{ __typename?: 'Asset', mentionDisplay: string, mentionId: string }> | null };

export type MessageThreadsQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
}>;


export type MessageThreadsQuery = { __typename?: 'Query', latestMessagePerThread: { __typename?: 'MessageConnection', edges: Array<{ __typename?: 'MessageEdge', node: { __typename?: 'Message', id: string, thread: string | null, threadCount: number | null, createdAt: string | null, body: string | null, subject: string | null, senderIsCurrentUser: boolean | null, readStatus: boolean | null, isCapIntroMessage: boolean | null, otherParty: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string } | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type ThreadMessagesQueryVariables = Exact<{
  threadNum: Scalars['Int']['input'];
  beforeCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type ThreadMessagesQuery = { __typename?: 'Query', threadMessages: { __typename?: 'MessageConnection', edges: Array<{ __typename?: 'MessageEdge', node: { __typename?: 'Message', id: string, thread: string | null, subject: string | null, body: string | null, createdAt: string | null, readStatus: boolean | null, archiveStatus: boolean | null, isCapIntroMessage: boolean | null, rootMessage: { __typename?: 'Message', id: string } | null, jobPosting: { __typename?: 'JobPosting', id: string, title: string } | null, otherParty: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string } | null } | null } | null, sender: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, currentEmployerName: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } | null, introRequest: { __typename?: 'IntroRequest', id: string, status: string } | null, messageAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasPreviousPage: boolean, startCursor: string | null } } | null, currentUser: { __typename?: 'User', id: string } | null };

export type NavigationUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type NavigationUserInfoQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, activeFollowedUsersCount: number, activeFollowersCount: number, isPaladin: boolean, publishedIdeasCount: number, ideaIsBlocked: boolean | null, ideaDaysLeft: string | null, compensationIsBlocked: boolean | null, compensationDaysLeft: string | null, capIntroIsBlocked: boolean | null, capIntroDaysLeft: string | null, jobIsBlocked: boolean | null, jobDaysLeft: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, paladin: { __typename?: 'Paladin', nextQuotaDeadline: string, ratingQuota: string | null, ratingCurrentMonth: string | null, ratingPercent: string | null, commentQuota: string | null, commentCurrentMonth: string | null, commentPercent: string | null, pollAnswerQuota: string | null, pollAnswerCurrentMonth: string | null, pollAnswerPercent: string | null, hasPollAnswerQuota: boolean | null } | null, primaryContact: { __typename?: 'User', id: string, displayName: string, email: string } | null } | null };

export type OmnisearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type OmnisearchQuery = { __typename?: 'Query', omnisearch: { __typename?: 'Omnisearch', allocators: Array<{ __typename?: 'AllocatorProfile', id: string, name: string | null }> | null, anonUsers: Array<{ __typename?: 'AnonUser', id: string, username: string | null }>, employers: Array<{ __typename?: 'Employer', id: string, name: string }> | null, entities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, funds: Array<{ __typename?: 'EmployerProfile', id: string, name: string | null }> | null, ideas: Array<{ __typename?: 'Idea', id: string, assetSymbol: string, direction: string | null, elevatorPitch: string | null, entityName: string, phraseCount: number | null }>, podcastEpisodes: Array<{ __typename?: 'PodcastEpisode', id: string, name: string, vanityLink: string | null }>, users: Array<{ __typename?: 'User', id: string, displayName: string, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null }>, videos: Array<{ __typename?: 'Video', id: string, title: string, vanityLink: string | null }> | null } };

export type OnboardingFundRecommendationsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
}>;


export type OnboardingFundRecommendationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, onboardingFundRecommendationMaxOffset: number | null, onboardingFundRecommendations: Array<{ __typename?: 'EmployerProfile', id: string, aumRange: string | null, focus: string | null, foundingYear: string | null, fundType: string | null, logoProfileUrl: string | null, name: string | null, strategy: string | null, lastReturn: { __typename?: 'EmployerReturn', ltm: number | null, sinceInception: number | null, ytd: number | null } | null }> | null } | null };

export type OpenGraphDataQueryVariables = Exact<{
  ogUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type OpenGraphDataQuery = { __typename?: 'Query', openGraphData: { __typename?: 'OpenGraphData', ogUrl: string, ogTitle: string | null, ogPreviewImageUrl: string | null, ogDescription: string | null, domain: string | null } | null };

export type PaymentMethodQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentMethodQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, stripeCustomerId: string | null, cardDetails: { __typename?: 'CardDetails', expiryYear: number, expiryMonth: number, lastFour: string, brand: string } | null, subscriptions: Array<{ __typename?: 'StripeSubscription', status: string }> | null } | null };

export type PodcastEpisodesIndexListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type PodcastEpisodesIndexListQuery = { __typename?: 'Query', indexListResultCount: number | null, podcastEpisodesIndexList: { __typename?: 'PodcastEpisodeConnection', edges: Array<{ __typename?: 'PodcastEpisodeEdge', node: { __typename?: 'PodcastEpisode', id: string, description: string, episodeId: string, name: string, releasedAt: string, tagList: Array<string>, vanityLink: string | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } };

export type PopularAssetSearchQueryVariables = Exact<{
  categoryName: Scalars['String']['input'];
  categoryType: Scalars['String']['input'];
}>;


export type PopularAssetSearchQuery = { __typename?: 'Query', popularAssetSearch: Array<{ __typename?: 'Asset', id: string, name: string | null, primarySymbol: string | null, entityId: string }> | null };

export type PostCommentsQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  postId: Scalars['ID']['input'];
}>;


export type PostCommentsQuery = { __typename?: 'Query', post: { __typename?: 'Post', id: string, commentsCount: number | null, comments: { __typename?: 'CommentConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'Comment', id: string, anonymous: boolean | null, body: string | null, byAllocator: boolean, createdAt: string, commentableType: string | null, commentCreationTime: string, currentUserHasLiked: boolean, likeCount: number, parentId: string | null, anonUser: { __typename?: 'AnonUser', id: string, aumRange: string | null, fundType: string | null, title: string | null } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, commentMentionables: Array<{ __typename?: 'Mentionable', id: string, display: string }> | null } | null, currentUser: { __typename?: 'User', id: string, canCommentAnonymously: boolean, isAllocator: boolean, isRetail: boolean, profileImageUrl: string | null } | null };

export type PostIndexCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostIndexCardQuery = { __typename?: 'Query', post: { __typename?: 'Post', id: string, currentUserHasLiked: boolean, postedAt: string | null, youtubeId: string | null } | null };

export type PostRelatedResearchQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type PostRelatedResearchQuery = { __typename?: 'Query', post: { __typename?: 'Post', id: string, relatedIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null> | null } | null } | null, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null } | null };

export type PostShowQueryVariables = Exact<{
  postId: Scalars['ID']['input'];
}>;


export type PostShowQuery = { __typename?: 'Query', post: { __typename?: 'Post', id: string, body: string | null, commentsCount: number | null, createdAt: string, currentUserHasLiked: boolean, domain: string | null, eventId: string | null, likeCount: number, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, tagList: Array<string> | null, untaggedBody: string | null, youtubeId: string | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, firstName: string, activeFollowersCount: number, featuredRank: { __typename?: 'Rank', id: string, rankString: string } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null } | null } | null, currentUser: { __typename?: 'User', id: string, profileImageUrl: string | null, canViewUserDetails: boolean | null } | null };

export type PostsIndexListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  searchParams?: InputMaybe<Scalars['String']['input']>;
}>;


export type PostsIndexListQuery = { __typename?: 'Query', postsIndexListResultCount: number | null, postsIndexList: { __typename?: 'PostConnection', edges: Array<{ __typename?: 'PostEdge', node: { __typename?: 'Post', id: string, body: string | null, commentsCount: number | null, domain: string | null, eventId: string | null, likeCount: number, ogDescription: string | null, ogUrl: string | null, ogPreviewImageUrl: string | null, ogTitle: string | null, tagList: Array<string> | null, untaggedBody: string | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, currentUser: { __typename?: 'User', id: string, acceptedPostTerms: boolean | null, isAdmin: boolean, profileImageUrl: string | null, canPost: boolean, canViewUserDetails: boolean | null } | null };

export type PublicUserQueryVariables = Exact<{
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
}>;


export type PublicUserQuery = { __typename?: 'Query', userLookUp: { __typename?: 'User', id: string, activeFollowedUsersCount: number, activeFollowersCount: number, displayName: string, firstName: string, profileImageUrl: string | null, publishedIdeasCount: number, username: string | null, profile: { __typename?: 'Profile', id: string, ideaTotalReturnAverage: string | null, ideaReturnVsBenchmarkAverage: string | null, ideaAnnualizedReturnMedian: string | null } | null } | null };

export type PublicUserFollowersQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserFollowersQuery = { __typename?: 'Query', userLookUp: { __typename?: 'User', id: string, followersList: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null };

export type PublicUserFollowingQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PublicUserFollowingQuery = { __typename?: 'Query', userLookUp: { __typename?: 'User', id: string, followingList: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null };

export type PublicUserIdeasQueryVariables = Exact<{
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicUserIdeasQuery = { __typename?: 'Query', userLookUp: { __typename?: 'User', id: string, publishedIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null } | null };

export type QuickPositionAssetQueryVariables = Exact<{
  assetId: Scalars['ID']['input'];
}>;


export type QuickPositionAssetQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isHidden: boolean } | null, asset: { __typename?: 'Asset', id: string, currencyCode: string | null, latestPrice: number | null, longQuickPositionRatio: number | null, shortQuickPositionRatio: number | null, symbol: string | null, currentUserQuickPosition: { __typename?: 'QuickPosition', id: string, direction: string, openedAt: string | null, openingPrice: number | null, returnToDate: number | null, chat: { __typename?: 'Chat', id: string } } | null } | null };

export type QuickPositionChatsNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickPositionChatsNavigationQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, openQuickPositions: Array<{ __typename?: 'QuickPosition', id: string, direction: string, chat: { __typename?: 'Chat', id: string, unreadMessagesCount: number }, asset: { __typename?: 'Asset', id: string, symbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } }> } | null };

export type RankingsWidgetQueryVariables = Exact<{
  category: Scalars['String']['input'];
  first: Scalars['Int']['input'];
}>;


export type RankingsWidgetQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null } | null, currentRanksForCategory: { __typename?: 'RankConnection', edges: Array<{ __typename?: 'RankEdge', node: { __typename?: 'Rank', id: string, user: { __typename?: 'User', id: string, displayName: string, profileCity: string | null, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, isCurrentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null } | null } | null> | null } | null };

export type CurrentRanksQueryVariables = Exact<{
  category: Scalars['String']['input'];
  afterCursor?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CurrentRanksQuery = { __typename?: 'Query', currentRanksForCategory: { __typename?: 'RankConnection', edges: Array<{ __typename?: 'RankEdge', node: { __typename?: 'Rank', id: string, value: number | null, rankString: string, viewDeltaString: string | null, privateDeltaString: string | null, user: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, profileImageUrl: string | null, profileCity: string | null, isFollowedByCurrentUser: boolean, mostRecentEmployer: { __typename?: 'EmployerHistory', currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null, topIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null> | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null, badgeCollectionRelationships: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string } | null } | null } | null> | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean, hasPreviousPage: boolean } } | null };

export type RecommendedIdeaQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
  lastSeenIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecommendedIdeaQuery = { __typename?: 'Query', recommendedIdea: { __typename?: 'IdeaRecommendation', id: string, userId: string, idea: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null };

export type RecommendedUsersToFollowQueryVariables = Exact<{
  afterCursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type RecommendedUsersToFollowQuery = { __typename?: 'Query', recommendedUsersToFollowCount: number, recommendedUsersToFollow: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node: { __typename?: 'User', isFollowedByCurrentUser: boolean, currentRanksCount: number | null, watchlistIdeasCount: number | null, wroteOnSameEntitiesCount: number | null, wroteOnWatchlistedSectors: number | null, userInWatchlistedGeography: boolean | null, id: string, displayName: string, publishedIdeasCount: number, profile: { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type RegistrantSearchQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RegistrantSearchQuery = { __typename?: 'Query', registrantSearch: boolean };

export type SampleFeedQueryVariables = Exact<{ [key: string]: never; }>;


export type SampleFeedQuery = { __typename?: 'Query', sampleFeedItems: { __typename?: 'FeedItemConnection', edges: Array<{ __typename?: 'FeedItemEdge', node: { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost', id: string, body: string | null, createdAt: string, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'AllocatorProfile', id: string, vanityLink: string | null, name: string | null, undisclosed: boolean | null, aumRange: string | null, employerType: string | null, location: string | null, fundManager: string | null, bio: string | null, publicBio: string | null } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | { __typename?: 'EmployerProfileUpdate', expertiseChanges: string | null, fundReturnsChanges: string | null, fundHoldingsChanges: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string, logoUrl: string | null, logoProfileUrl: string | null, vanityLink: string | null, name: string | null, aumRange: string | null, foundingDate: string | null, fundType: string | null, strategy: string | null, focus: string | null, location: string | null, fundManager: string | null, description: string | null } | null, marketingMaterials: { __typename?: 'EmployerProfileDocumentConnection', edges: Array<{ __typename?: 'EmployerProfileDocumentEdge', node: { __typename?: 'EmployerProfileDocument', id: string, name: string | null, category: string | null } | null } | null> | null } | null, pressMediaList: { __typename?: 'EmployerProfilePressConnection', edges: Array<{ __typename?: 'EmployerProfilePressEdge', node: { __typename?: 'EmployerProfilePress', title: string | null, url: string | null, publishDate: string | null, description: string | null } | null } | null> | null } | null } | { __typename?: 'FeaturedItem', id: string, feature: string, featuredType: string, featuredIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string, entityName: string }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profile: { __typename?: 'Profile', id: string, companyString: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null } | null } | null } | null } | null> | null } | null } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting', id: string, title: string, description: string | null, sectors: string | null, city: string | null, postedAt: string | null, updatedAt: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, strategy: string | null } | null } | { __typename?: 'Post', id: string, body: string | null, createdAt: string, postedAt: string | null, ogUrl: string | null, ogTitle: string | null, ogDescription: string | null, ogPreviewImageUrl: string | null, domain: string | null, youtubeId: string | null, commentsCount: number | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, submittedAt: string | null, tagList: Array<string>, thesis: string, title: string, youtubeIds: Array<string> | null, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, wpElevatorPitch: string, wpUpdatedAt: string, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string }> | null, wpUser: { __typename?: 'User', isRanked: boolean | null, id: string, displayName: string, profileImageUrl: string | null, fundProfile: { __typename?: 'EmployerProfile', id: string } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean } } | null };

export type SchoolNameSearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
}>;


export type SchoolNameSearchQuery = { __typename?: 'Query', schoolNameSearch: Array<string> | null };

export type SectorChatsNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type SectorChatsNavigationQuery = { __typename?: 'Query', sectorChats: Array<{ __typename?: 'Chat', id: string, unreadMessagesCount: number, sector: { __typename?: 'Sector', id: string, name: string } | null }> };

export type SecuritiesQueryVariables = Exact<{
  symbol: Scalars['String']['input'];
}>;


export type SecuritiesQuery = { __typename?: 'Query', securities: { __typename?: 'SecurityConnection', edges: Array<{ __typename?: 'SecurityEdge', node: { __typename?: 'Security', id: string | null, display: string | null } | null } | null> | null } };

export type SecuritySearchQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  assetClass?: InputMaybe<Scalars['String']['input']>;
  includeLocalAsset?: InputMaybe<Scalars['Boolean']['input']>;
  skip: Scalars['Boolean']['input'];
}>;


export type SecuritySearchQuery = { __typename?: 'Query', securitySearch?: string | null };

export type SiteMessageQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteMessageQuery = { __typename?: 'Query', latestSiteMessage: { __typename?: 'SiteMessage', id: string, body: string | null, linkUrl: string | null, linkText: string | null, isContest: boolean | null } | null };

export type SiteWideModalContestQueryVariables = Exact<{ [key: string]: never; }>;


export type SiteWideModalContestQuery = { __typename?: 'Query', promotedContest: { __typename?: 'Contest', id: string, active: boolean | null, name: string | null, promoSummary: string | null, judgesDisplayNames: Array<string> | null, countdownDate: string | null, disableSiteWideModal: boolean | null, prizes: Array<{ __typename?: 'ContestPrizeType', id: string, description: string | null, sponsorImage: string | null, sponsorTrackingLink: string | null }> | null } | null };

export type StripeSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type StripeSubscriptionQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, subscriptions: Array<{ __typename?: 'StripeSubscription', id: string, currentPeriodEnd: string, description: string, isAutoRenewing: boolean }> | null } | null };

export type TopStockWinnersQueryVariables = Exact<{ [key: string]: never; }>;


export type TopStockWinnersQuery = { __typename?: 'Query', topStockWinners: Array<{ __typename?: 'Idea', id: string, entityName: string, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, employer: { __typename?: 'Employer', id: string, name: string } | null } | null } | null }> };

export type TrendingResearchItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type TrendingResearchItemsQuery = { __typename?: 'Query', trendingIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, communityRating: number | null, positions: Array<{ __typename?: 'Position', id: string, entityName: string, primarySymbol: string, asset: { __typename?: 'Asset', id: string, entity: { __typename?: 'Entity', id: string } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profileCity: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null> | null } | null, activeConversationIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, communityRating: number | null, positions: Array<{ __typename?: 'Position', id: string, entityName: string, primarySymbol: string, asset: { __typename?: 'Asset', id: string, entity: { __typename?: 'Entity', id: string } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profileCity: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null> | null } | null, biggestMoverIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', thirtyDayReturnChange: number | null, id: string, communityRating: number | null, positions: Array<{ __typename?: 'Position', id: string, entityName: string, primarySymbol: string, asset: { __typename?: 'Asset', id: string, entity: { __typename?: 'Entity', id: string } } | null }>, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profileCity: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null> | null } | null };

export type TwitterCurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type TwitterCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, hasTwitterToken: boolean | null, profileImageUrl: string | null } | null };

export type UserApplicationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserApplicationQuery = { __typename?: 'Query', userApplication: { __typename?: 'UserApplication', firstName: string | null, lastName: string | null, email: string, linkedinUrl: string | null, city: string | null, phone: string | null, employmentStatus: string | null, isAccredited: boolean | null, title: string | null, employerName: string | null, basicEmployerName: string | null, employerFundType: string | null, employerAumRange: string | null, schoolName: string | null, degree: string | null, fieldOfStudy: string | null, yearStart: number | null, expectedGraduation: number | null, applicantType: string | null, basicInvestorType: string | null } };

export type UserFeedbackSubmittedQueryVariables = Exact<{
  prompt: Scalars['String']['input'];
}>;


export type UserFeedbackSubmittedQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, userFeedbackSubmitted: boolean } | null };

export type UserProfileIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type UserProfileIndexListQuery = { __typename?: 'Query', userProfileIndexListResultCount: number | null, userProfileIndexList: { __typename?: 'ProfileConnection', edges: Array<{ __typename?: 'ProfileEdge', node: { __typename?: 'Profile', id: string, city: string | null, imageProfileUrl: string | null, summary: string | null, user: { __typename?: 'User', id: string, displayName: string, publishedIdeasCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null, currentUser: { __typename?: 'User', id: string, isCapIntroMember: boolean, canViewUserDetails: boolean | null } | null };

export type UserProfileRankingChartQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  timeframe: Scalars['String']['input'];
}>;


export type UserProfileRankingChartQuery = { __typename?: 'Query', userProfile: { __typename?: 'Profile', id: string, user: { __typename?: 'User', id: string, publicRankings: Array<{ __typename?: 'Rank', id: string, value: number | null, createdAt: string, category: string }> | null } | null } };

export type UserProfileShowPageQueryVariables = Exact<{
  profileId: Scalars['ID']['input'];
  controlIdeaAccess?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserProfileShowPageQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAdmin: boolean, isUserProfileAdmin: boolean, isHiringManager: boolean, canViewUserDetails: boolean | null, canManageMessages: boolean | null } | null, userProfile: { __typename?: 'Profile', id: string, isAccredited: boolean | null, backgroundImageUrl: string | null, backgroundImageCroppedUrl: string | null, defaultBackgroundImage: string | null, imageProfileUrl: string | null, imageUrl: string | null, defaultImage: string | null, certifications: Array<string> | null, city: string | null, summary: string | null, hasFilledPrivateProfile: boolean | null, email: string | null, mobilePhone: string | null, workPhone: string | null, ideaTotalReturnAverage: string | null, ideaReturnVsBenchmarkAverage: string | null, ideaAnnualizedReturnMedian: string | null, experienceByFirmType: string | null, sectorExpertise: Array<string> | null, geographicExpertise: Array<string> | null, assetClassExpertise: Array<string> | null, hometown: string | null, investmentHero: string | null, favoriteInvestmentBook: string | null, investingStyle: string | null, languagesSpoken: string | null, resume: string | null, hasGpa: boolean | null, hasSatOrAct: boolean | null, postedInLast3Months: boolean | null, hasAnyProfileAnswers: boolean | null, hasAllProfileAnswers: boolean | null, user: { __typename?: 'User', id: string, isRetail: boolean, displayName: string, publishedIdeasCount: number, activeFollowedUsersCount: number, activeFollowersCount: number, canPostJobs: boolean, isHighProfile: boolean | null, historicalPublicRankings: Array<string> | null, accreditedInvestorProfile: { __typename?: 'AccreditedInvestorProfile', id: string, bonds: string | null, foreignCurrencies: string | null, futuresOrCommodities: string | null, hedgeFunds: string | null, investmentSize: string | null, netWorth: string | null, next12MoAllocation: string | null, privateCompanies: string | null, privateEquityFunds: string | null, publiclyTradedStocks: string | null, realEstate: string | null, updatedAt: string, yearsInvesting: string | null } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, hasFundProfile: boolean } | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, earnedAt: string | null, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null, recentIdea: { __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null } | null } | null, employerHistories: Array<{ __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, fromDate: string | null, primary: boolean, title: string | null, toDate: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, aumRangePresent: boolean | null, fundType: string | null } | null }> | null, schoolHistories: Array<{ __typename?: 'SchoolHistory', id: string, schoolName: string, degree: string | null, fieldOfStudy: string | null, currentStudent: boolean | null, startYear: number | null, gradYear: number | null }> | null, profileTestResults: Array<{ __typename?: 'ProfileTestResult', id: string, name: string | null, score: number | null, maxScore: string | null, date: string | null, url: string | null, filename: string | null }> | null, profileAttachments: Array<{ __typename?: 'ProfileAttachmentType', id: string, name: string | null, description: string | null, filename: string | null }> | null, profileAnswers: Array<{ __typename?: 'ProfileAnswer', profileQuestionId: number | null, answer: string | null }> | null } };

export type UserSearchQueryVariables = Exact<{
  user?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserSearchQuery = { __typename?: 'Query', userSearch: Array<{ __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null }> | null };

export type WatchlistTickerAssetDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type WatchlistTickerAssetDataQuery = { __typename?: 'Query', watchlistTickerAssetData: { __typename?: 'Asset', id: string, entityId: string, name: string | null, entity: { __typename?: 'Entity', name: string | null } } | null };

export type WhitePaperCommentMentionablesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WhitePaperCommentMentionablesQuery = { __typename?: 'Query', whitePaper: { __typename?: 'WhitePaper', id: string, commentsMentionableList: Array<{ __typename?: 'Mentionable', id: string, display: string }> | null } };

export type WhitePaperCommentsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WhitePaperCommentsQuery = { __typename?: 'Query', whitePaper: { __typename?: 'WhitePaper', id: string, comments: { __typename?: 'CommentConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, currentUserHasLiked: boolean, parentId: string | null, likeCount: number, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, isAllocator: boolean, fundType: string | null, title: string | null, username: string | null } | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null } | null } | null> | null } | null }, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null } | null };

export type WhitePapersIndexListQueryVariables = Exact<{
  searchParams?: InputMaybe<Scalars['String']['input']>;
  indexType: Scalars['String']['input'];
}>;


export type WhitePapersIndexListQuery = { __typename?: 'Query', indexListResultCount: number | null, whitePapersIndexList: Array<{ __typename?: 'WhitePaper', id: string, attachmentExtensions: Array<string> | null, commentsCount: number | null, elevatorPitch: string, esgNames: string, geographyNames: string, globalMacroNames: string, sectorNames: string, submittedAt: string | null, tagList: Array<string>, title: string, updatedAt: string, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } }> | null, currentUser: { __typename?: 'User', id: string, canViewUserDetails: boolean | null, canWriteWhitePapers: boolean | null } | null };

export type WhitePaperShowPageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WhitePaperShowPageQuery = { __typename?: 'Query', whitePaper: { __typename?: 'WhitePaper', id: string, elevatorPitch: string, pdfThesisUrl: string | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, status: string, thesis: string, tagList: Array<string>, thesisText: string, submittedAt: string | null, updatedAt: string, isAuthor: boolean | null, title: string, youtubeIds: Array<string> | null, associatedEmployer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, followerCount: number | null } | null } | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }> | null, whitePaperUpdates: Array<{ __typename?: 'WhitePaperUpdate', id: string }>, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, filename: string, researchType: string, attachmentType: string, createdAt: string, fileType: string }> | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, profileCity: string | null, activeFollowersCount: number, followersCount: number, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, followerCount: number | null } | null } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null, profile: { __typename?: 'Profile', id: string, summary: string | null, ideaTotalReturnAverage: string | null, ideaReturnVsBenchmarkAverage: string | null, ideaAnnualizedReturnMedian: string | null } | null }, esgs: Array<{ __typename?: 'Esg', id: string, name: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string, name: string }> | null, globalMacros: Array<{ __typename?: 'GlobalMacro', id: string, name: string }> | null, sectors: Array<{ __typename?: 'Sector', id: string, name: string }> | null }, currentUser: { __typename?: 'User', id: string, canCommentAnonymously: boolean, isAdmin: boolean, canWriteWhitePaperComments: boolean | null, canViewUserDetails: boolean | null } | null };

export type WhitePaperShowPageRelatedIdeasQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WhitePaperShowPageRelatedIdeasQuery = { __typename?: 'Query', whitePaper: { __typename?: 'WhitePaper', id: string, relatedIdeas: Array<{ __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null }> | null }, currentUser: { __typename?: 'User', id: string, isBuyside: boolean, canViewIdeas: boolean | null, canWriteIdeas: boolean | null } | null };

export type WhitePaperSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WhitePaperSubmissionQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, isAdmin: boolean, currentEmployers: Array<{ __typename?: 'Employer', id: string, canExtendCapIntroAccess: boolean, hasFundProfile: boolean, name: string }> } | null, whitePaper: { __typename?: 'WhitePaper', id: string, elevatorPitch: string, featuredOnAFundProfile: boolean | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, status: string, tagList: Array<string>, thesis: string, thesisText: string, title: string, associatedEmployer: { __typename?: 'Employer', id: string } | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null }> | null, esgs: Array<{ __typename?: 'Esg', id: string }> | null, geographies: Array<{ __typename?: 'Geography', id: string }> | null, globalMacros: Array<{ __typename?: 'GlobalMacro', id: string }> | null, sectors: Array<{ __typename?: 'Sector', id: string }> | null, user: { __typename?: 'User', id: string }, whitePaperAttachments: Array<{ __typename?: 'WhitePaperAttachment', id: string, attachmentType: string, filename: string, createdAt: string, researchType: string, fileType: string, url: string }> | null } };

export type CurrentUserRankHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserRankHistoryQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, ranks: Array<{ __typename?: 'Rank', rankString: string, createdAt: string }> | null } | null };

export type CurrentUserRanksQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserRanksQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, currentRanks: Array<{ __typename?: 'Rank', category: string, createdAt: string, id: string, value: number | null, rankString: string, viewDeltaString: string | null, privateDeltaString: string | null, user: { __typename?: 'User', id: string, displayName: string, currentEmployerName: string | null, profileImageUrl: string | null, profileCity: string | null, isFollowedByCurrentUser: boolean, mostRecentEmployer: { __typename?: 'EmployerHistory', currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null } | null } | null, topIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null } | null> | null } | null, recentIdea: { __typename?: 'Idea', id: string, totalReturn: number | null, isPairTrade: boolean | null, positions: Array<{ __typename?: 'Position', id: string, primarySymbol: string }> } | null, badgeCollectionRelationships: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string } | null } | null } | null> | null } | null } | null }> | null } | null };

export type IdeaAttachmentsQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaAttachmentsQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, ideaAttachments: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, createdAt: string, filename: string | null, fileType: string | null, researchType: string }> | null } };

export type IdeaAuthorQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaAuthorQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, authorName: string | null, isNonBuyside: boolean, associatedEmployer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, followerCount: number | null } | null } | null, user: { __typename?: 'User', id: string, activeFollowersCount: number, displayName: string, profileCity: string | null, profileImageUrl: string | null, username: string | null, featuredRank: { __typename?: 'Rank', id: string, category: string, rankString: string } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string, followerCount: number | null } | null } | null } | null, profile: { __typename?: 'Profile', id: string, ideaTotalReturnAverage: string | null, ideaReturnVsBenchmarkAverage: string | null, ideaAnnualizedReturnMedian: string | null } | null } | null } };

export type IdeaCommentsQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
  controlName?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IdeaCommentsQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, commentsCount: number | null, comments: { __typename?: 'CommentConnection', edges: Array<{ __typename?: 'CommentEdge', node: { __typename?: 'Comment', id: string, body: string | null, createdAt: string, responseRequested: boolean | null, likeCount: number, currentUserHasLiked: boolean, parentId: string | null, user: { __typename?: 'User', id: string, anonymousUserId: string, displayName: string, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null } | null, anonUser: { __typename?: 'AnonUser', id: string, anonymousUserId: string, aumRange: string | null, fundType: string | null, isAllocator: boolean, title: string | null, username: string | null } | null, commentAttachments: Array<{ __typename?: 'AttachmentType', id: string, fileName: string, customName: string | null }> | null } | null } | null> | null } | null, commentsMentionableList: Array<{ __typename?: 'Mentionable', id: string, display: string }> } };

export type IdeaCoreQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaCoreQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, anonymous: boolean, annualizedReturn: number | null, approved: boolean | null, autoclosed: boolean | null, benchmarkNames: string | null, catalystNames: Array<string>, closedAt: string | null, closeToTimeframe: boolean | null, createdAt: string, dateToClose: string | null, direction: string | null, elevatorPitch: string | null, expectedReturn: number | null, featuredOnAFundProfile: boolean | null, pdfThesisUrl: string | null, hasPendingEdit: boolean, ideaPdfLink: string | null, ideaUpdatesCount: number, isOpenAccess: boolean, isPairTrade: boolean | null, lastUpdatedAt: string, legacyPositionDisclaimer: boolean | null, openedAt: string | null, pairRatio: Array<number> | null, positionDisclaimerFund: boolean | null, positionDisclaimerIndividual: boolean | null, returnTarget: number | null, returnVsBenchmark: number | null, situation: string | null, status: string | null, tagList: Array<string>, targetAllocation: string | null, thesis: string | null, timeframe: string | null, totalReturn: number | null, weeklyTopIdea: boolean, youtubeIds: Array<string> | null, canCurrentUserAccessIdeaComments: boolean, canCurrentUserViewIdeaAttachments: boolean, canCurrentUserViewIdeaFilterDetails: boolean, situationUnformatted: string | null, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, mentionedEntities: Array<{ __typename?: 'Entity', id: string, primarySymbol: string | null }> | null, paladinReviews: Array<{ __typename?: 'PaladinReview', id: string, description: string | null, status: string | null, paladin: { __typename?: 'Paladin', id: string, displayName: string | null, userId: string | null } | null }> | null, pendingContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, contestId: string, contestName: string }> | null, pendingIntroRequest: { __typename?: 'IntroRequest', id: string, employerName: string, messageThread: string | null, status: string } | null } };

export type IdeaCurrentUserQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaCurrentUserQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, availableTokenCount: number | null, canCommentAnonymously: boolean, isAdmin: boolean, isAllocator: boolean, isPaladin: boolean, isRetail: boolean, profileImageUrl: string | null, canComment: boolean | null, canDownloadIdeaPdf: boolean | null, canManageMessages: boolean | null, canRateIdeas: boolean | null, canViewIdeas: boolean | null, canViewUserDetails: boolean | null, canWriteIdeas: boolean | null, ideaRating: { __typename?: 'UserRating', id: string, score: number } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean } | null } | null };

export type IdeaPositionsQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaPositionsQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, hasEntitiesHaveOtherIdeas: boolean | null, positions: Array<{ __typename?: 'Position', id: string, closingPrice: number | null, direction: string, isCurrencySubunit: boolean, priceTarget: number | null, totalReturn: number | null, asset: { __typename?: 'Asset', id: string, assetClassName: string | null, currencyCode: string | null, currencyName: string | null, fundamentalCurrencyCode: string | null, fundamentalCurrencyName: string | null, isCredit: boolean | null, name: string | null, symbol: string | null, companyData: { __typename?: 'CompanyData', id: string, country: string | null, geography: string | null, industry: string, sector: string } | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null, userCompanyData: { __typename?: 'UserCompanyData', id: string, currencyName: string | null, currencyCode: string | null } | null, userCreditData: { __typename?: 'UserCreditData', id: string, amountOutstanding: number | null, convertible: boolean | null, couponFrequency: string | null, couponRate: number | null, couponType: string | null, fitchCreditRating: string | null, guaranteed: boolean | null, issueSize: number | null, lien: string | null, maturityDate: string | null, moodyCreditRating: string | null, securedBy: string | null, securityClass: string | null, seniority: string | null, standardCreditRating: string | null } | null }> } };

export type IdeaPositionsPricingQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaPositionsPricingQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, closeToTarget: boolean | null, positions: Array<{ __typename?: 'Position', id: string, latestPrice: number | null, latestPriceDate: string | null, openingPrice: number | null, adjOpeningPrice: number | null, asset: { __typename?: 'Asset', id: string, fiftyTwoWeekRangeHigh: string | null, fiftyTwoWeekRangeLow: string | null, fundamental: { __typename?: 'Fundamental', id: string, bookValue: number | null, currentPe: number | null, debtBook: number | null, divYield: number | null, ev: number | null, evEbitda: number | null, evFcf: number | null, evSales: number | null, fcfYield: number | null, forwardPe: number | null, marketCap: number | null, priceBook: number | null, sellsideConsensus: number | null, threeMonthAdv: number | null, totalCash: number | null, totalDebt: number | null } | null } | null }> } };

export type IdeaRatingQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type IdeaRatingQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null } };

export type IdeaUpdatesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type IdeaUpdatesQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, benchmarkUpdate: { __typename?: 'IdeaUpdate', id: string, createdAt: string, priceTarget: number | null } | null, ideaUpdates: Array<{ __typename?: 'IdeaUpdate', id: string, addedCatalystNames: Array<string> | null, body: string | null, catalystNames: Array<string>, closed: boolean, createdAt: string, commentsCount: number | null, impact: string | null, priceTarget: number | null, removedCatalystNames: Array<string> | null, removedPriceTarget: number | null, removedReturnTarget: number | null, removedSituation: string | null, removedTargetAllocation: string | null, removedTimeframe: string | null, returnTarget: number | null, situation: string | null, targetAllocation: string | null, timeframe: string | null, truncated: boolean, youtubeIds: Array<string> | null, ideaAttachmentsArray: Array<{ __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, description: string | null, filename: string | null, createdAt: string, fromUpdate: boolean | null, researchType: string, fileType: string | null, url: string | null }> | null }> } };

export type RelatedIdeasQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type RelatedIdeasQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, relatedIdeas: Array<{ __typename?: 'Idea', id: string, anonymous: boolean, attachmentExtensions: Array<string> | null, authorName: string | null, closedAt: string | null, commentsCount: number | null, elevatorPitch: string | null, expectedReturn: number | null, isNonBuyside: boolean, phraseCount: number | null, tagList: Array<string>, totalReturn: number | null, weeklyTopIdea: boolean, canCurrentUserViewIdeaFilterDetails: boolean, submittedAt: string | null, updatedAt: string, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, user: { __typename?: 'User', id: string, displayName: string, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, title: string | null, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean, name: string } | null } | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null } | null }> } };

export type RelatedPostsQueryVariables = Exact<{
  ideaId: Scalars['ID']['input'];
}>;


export type RelatedPostsQuery = { __typename?: 'Query', idea: { __typename?: 'Idea', id: string, relatedPosts: Array<{ __typename?: 'Post', id: string, commentsCount: number | null, currentUserHasLiked: boolean, eventId: string | null, likeCount: number, untaggedBody: string | null }> | null } };

export type TestFeedQueryVariables = Exact<{
  feedId?: InputMaybe<Scalars['ID']['input']>;
  feedType?: InputMaybe<Scalars['String']['input']>;
  feedFilter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type TestFeedQuery = { __typename?: 'Query', feedItems: { __typename?: 'FeedItemConnection', edges: Array<{ __typename?: 'FeedItemEdge', node: { __typename?: 'FeedItem', id: string, createdAt: string, forMentionedEntity: boolean | null, event: { __typename?: 'Event', id: string, currentUserHasLiked: boolean, likeCount: number, verb: string | null, eventObject: { __typename?: 'AdminPost' } | { __typename?: 'AllocatorProfile' } | { __typename?: 'Comment', id: string, body: string | null, byAllocator: boolean, commentCreationTime: string, anonUser: { __typename?: 'AnonUser', id: string, title: string | null, username: string | null } | null, commentObject: { __typename?: 'AdminPost' } | { __typename?: 'EmployerProfile' } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'Post' } | { __typename?: 'WhitePaper' } | null, user: { __typename?: 'User', id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'CorporateAction', id: string, parentPreActionPrice: number | null, parentPostActionPrice: number | null, parentActionPeriodReturn: number | null, childPreActionPrice: number | null, childPostActionPrice: number | null, childActionPeriodReturn: number | null, actionDate: string | null, actionType: string | null, parentEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, parentAsset: { __typename?: 'Asset', fsPermSecId: string | null, name: string | null, symbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null, childEntity: { __typename?: 'Entity', id: string, name: string | null, primarySymbol: string | null, recentIdeas: { __typename?: 'IdeaConnection', edges: Array<{ __typename?: 'IdeaEdge', node: { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | null } | null> | null } | null } | null } | { __typename?: 'EmployerProfile' } | { __typename?: 'EmployerProfileUpdate' } | { __typename?: 'FeaturedItem' } | { __typename?: 'Idea', id: string, anonymous: boolean, elevatorPitch: string | null, weeklyTopIdea: boolean, closedAt: string | null, expectedReturn: number | null, totalReturn: number | null, returnVsBenchmark: number | null, attachmentExtensions: Array<string> | null, commentsCount: number | null, phraseCount: number | null, isNonBuyside: boolean, authorName: string | null, tagList: Array<string>, youtubeIds: Array<string> | null, posted: string | null, updated: string, canCurrentUserViewIdeaFilterDetails: boolean, awardWinningContestIdeas: Array<{ __typename?: 'ContestIdea', id: string, award: string | null, contestId: string }> | null, positions: Array<{ __typename?: 'Position', id: string, direction: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, assetClassName: string | null, name: string | null, fundamental: { __typename?: 'Fundamental', id: string, marketCap: number | null } | null } | null }>, expectedPerformanceRating: { __typename?: 'Rating', id: string, averageRating: number | null, userRatingCount: number } | null, user: { __typename?: 'User', isRanked: boolean | null, username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null, hasFundProfile: boolean } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null } | { __typename?: 'IdeaUpdate', id: string, text: string | null, closed: boolean, createdAt: string, impact: string | null, changesHash: any, youtubeIds: Array<string> | null, idea: { __typename?: 'Idea', id: string, anonymous: boolean, canCurrentUserViewIdeaFilterDetails: boolean, positions: Array<{ __typename?: 'Position', id: string, asset: { __typename?: 'Asset', id: string, primarySymbol: string | null, entity: { __typename?: 'Entity', id: string, name: string | null } } | null }> } | null, user: { __typename?: 'User', username: string | null, id: string, displayName: string, profileImageUrl: string | null, featuredRank: { __typename?: 'Rank', id: string, rankString: string, category: string, current: boolean } | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, title: string | null, employer: { __typename?: 'Employer', id: string, name: string, aumRange: string | null, fundType: string | null } | null } | null, profile: { __typename?: 'Profile', id: string, city: string | null } | null, userBadges: { __typename?: 'BadgeCollectionRelationshipConnection', edges: Array<{ __typename?: 'BadgeCollectionRelationshipEdge', node: { __typename?: 'BadgeCollectionRelationship', id: string, badgeNumber: number, visible: boolean, badge: { __typename?: 'Badge', id: string, name: string, description: string, order: number } | null } | null } | null> | null } | null } | null, ideaAttachments: { __typename?: 'IdeaAttachmentConnection', edges: Array<{ __typename?: 'IdeaAttachmentEdge', node: { __typename?: 'IdeaAttachment', id: string, attachmentType: string | null, filename: string | null } | null } | null> | null } | null } | { __typename?: 'JobPosting' } | { __typename?: 'Post' } | { __typename?: 'Rank' } | { __typename?: 'WhitePaper' } | null } | null } | null } | null> | null, pageInfo: { __typename?: 'PageInfo', endCursor: string | null, hasNextPage: boolean } } | null };

export type OnChatMessageCreatedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type OnChatMessageCreatedSubscription = { __typename?: 'Subscription', chatMessageCreated: { __typename?: 'ChatMessageCreatedPayload', chatId: string, chatMessage: { __typename?: 'ChatMessage', id: string, anonymous: boolean | null, body: string, createdAt: string, direction: string | null, participantName: string, user: { __typename?: 'User', id: string, profileCity: string | null, profileImageUrl: string | null, mostRecentEmployer: { __typename?: 'EmployerHistory', id: string, currentEmployer: boolean, employer: { __typename?: 'Employer', id: string, aumRange: string | null, fundType: string | null, name: string, employerProfile: { __typename?: 'EmployerProfile', id: string } | null } | null } | null } } } };

export const AdminAssetFragmentDoc = gql`
    fragment AdminAsset on Asset {
  id
  assetClassName
  bbgId
  currencyCode
  currencyName
  cusip
  factsetSymbol
  forcePrimaryEntityAsset
  fsPermSecId
  fundamentalCurrencyCode
  fundamentalCurrencyName
  ideaIds
  name
  symbol
  userSymbol
  yahooSymbol
}
    `;
export const AdminEntityFragmentDoc = gql`
    fragment AdminEntity on Entity {
  id
  name
  status
  factsetEntityId
  hideFromIndex
}
    `;
export const AccreditedInvestorProfileFragmentDoc = gql`
    fragment AccreditedInvestorProfile on AccreditedInvestorProfile {
  id
  bonds
  foreignCurrencies
  futuresOrCommodities
  hedgeFunds
  investmentSize
  netWorth
  next12MoAllocation
  privateCompanies
  privateEquityFunds
  publiclyTradedStocks
  realEstate
  updatedAt
  yearsInvesting
}
    `;
export const AccreditedInvestorProfileIndexItemFragmentDoc = gql`
    fragment AccreditedInvestorProfileIndexItem on AccreditedInvestorProfile {
  id
  user {
    id
    profileCity
    displayName
    profileImageUrl
    profile {
      id
      summary
    }
  }
}
    `;
export const FeaturedRankingFragmentDoc = gql`
    fragment FeaturedRanking on Rank {
  id
  rankString
  category
  current
}
    `;
export const BadgesFragmentDoc = gql`
    fragment Badges on Badge {
  id
  name
  description
  order
}
    `;
export const ActivityFeedUserFragmentDoc = gql`
    fragment ActivityFeedUser on User {
  id
  displayName
  featuredRank {
    ...FeaturedRanking
  }
  profileImageUrl
  mostRecentEmployer {
    id
    currentEmployer
    title
    employer {
      id
      name
      aumRange
      fundType
    }
  }
  profile {
    id
    city
  }
  userBadges: badgeCollectionRelationships {
    edges {
      node {
        id
        badgeNumber
        visible
        badge {
          ...Badges
        }
      }
    }
  }
}
    ${FeaturedRankingFragmentDoc}
${BadgesFragmentDoc}`;
export const ActivityFeedCommentFragmentDoc = gql`
    fragment ActivityFeedComment on Comment {
  id
  anonUser {
    id
    aumRange
    fundType
    isAllocator
    title
    username
  }
  body
  byAllocator
  commentableType
  commentCreationTime
  currentUserHasLiked
  likeCount
  parentId
  user {
    ...ActivityFeedUser
  }
}
    ${ActivityFeedUserFragmentDoc}`;
export const ActivityFeedAdminPostFragmentDoc = gql`
    fragment ActivityFeedAdminPost on AdminPost {
  id
  body
  createdAt
  ogUrl
  ogTitle
  ogDescription
  ogPreviewImageUrl
  domain
  user {
    ...ActivityFeedUser
  }
  commentsCount
}
    ${ActivityFeedUserFragmentDoc}`;
export const ActivityFeedAllocatorProfileFragmentDoc = gql`
    fragment ActivityFeedAllocatorProfile on AllocatorProfile {
  id
  vanityLink
  name
  undisclosed
  aumRange
  employerType
  location
  fundManager
  bio
  publicBio
}
    `;
export const ResearchItemUserFragmentDoc = gql`
    fragment ResearchItemUser on User {
  id
  displayName
  mostRecentEmployer {
    id
    employer {
      id
      aumRange
      fundType
      hasFundProfile
      name
    }
    title
  }
  featuredRank {
    id
    rankString
    category
    current
  }
}
    `;
export const ActivityFeedIdeaFragmentDoc = gql`
    fragment ActivityFeedIdea on Idea {
  id
  anonymous
  awardWinningContestIdeas {
    id
    award
    contestId
  }
  elevatorPitch
  weeklyTopIdea
  closedAt
  expectedReturn
  totalReturn
  returnVsBenchmark
  attachmentExtensions
  posted: openedAt
  updated: lastUpdatedAt
  commentsCount
  phraseCount
  canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(
    resource: "idea_filter_details"
    permission: "view"
  )
  positions {
    id
    direction
    asset {
      id
      primarySymbol
      assetClassName
      name
      fundamental {
        id
        marketCap
      }
    }
  }
  expectedPerformanceRating {
    id
    averageRating
    userRatingCount
  }
  isNonBuyside
  authorName
  tagList
  user {
    ...ActivityFeedUser
    ...ResearchItemUser
    isRanked
    username
  }
  commentsCount
  youtubeIds
}
    ${ActivityFeedUserFragmentDoc}
${ResearchItemUserFragmentDoc}`;
export const ActivityFeedEntityFragmentDoc = gql`
    fragment ActivityFeedEntity on Entity {
  id
  name
  primarySymbol
  recentIdeas {
    edges {
      node {
        ...ActivityFeedIdea
      }
    }
  }
}
    ${ActivityFeedIdeaFragmentDoc}`;
export const ActivityFeedAssetFragmentDoc = gql`
    fragment ActivityFeedAsset on Asset {
  fsPermSecId
  name
  symbol
  recentIdeas {
    edges {
      node {
        ...ActivityFeedIdea
      }
    }
  }
}
    ${ActivityFeedIdeaFragmentDoc}`;
export const ActivityFeedCorporateActionFragmentDoc = gql`
    fragment ActivityFeedCorporateAction on CorporateAction {
  id
  parentEntity {
    ...ActivityFeedEntity
  }
  parentAsset {
    ...ActivityFeedAsset
  }
  parentPreActionPrice
  parentPostActionPrice
  parentActionPeriodReturn
  childEntity {
    ...ActivityFeedEntity
  }
  childPreActionPrice
  childPostActionPrice
  childActionPeriodReturn
  actionDate
  actionType
}
    ${ActivityFeedEntityFragmentDoc}
${ActivityFeedAssetFragmentDoc}`;
export const ActivityFeedEmployerProfileFragmentDoc = gql`
    fragment ActivityFeedEmployerProfile on EmployerProfile {
  id
  logoUrl
  logoProfileUrl
  vanityLink
  name
  aumRange
  foundingDate
  fundType
  strategy
  focus
  location
  fundManager
  description
}
    `;
export const ActivityFeedEmployerProfileDocumentFragmentDoc = gql`
    fragment ActivityFeedEmployerProfileDocument on EmployerProfileDocument {
  id
  name
  category
}
    `;
export const ActivityFeedEmployerProfilePressFragmentDoc = gql`
    fragment ActivityFeedEmployerProfilePress on EmployerProfilePress {
  title
  url
  publishDate
  description
}
    `;
export const ActivityFeedEmployerProfileUpdateFragmentDoc = gql`
    fragment ActivityFeedEmployerProfileUpdate on EmployerProfileUpdate {
  fundProfile {
    ...ActivityFeedEmployerProfile
  }
  expertiseChanges
  fundReturnsChanges
  fundHoldingsChanges
  marketingMaterials {
    edges {
      node {
        ...ActivityFeedEmployerProfileDocument
      }
    }
  }
  pressMediaList {
    edges {
      node {
        ...ActivityFeedEmployerProfilePress
      }
    }
  }
}
    ${ActivityFeedEmployerProfileFragmentDoc}
${ActivityFeedEmployerProfileDocumentFragmentDoc}
${ActivityFeedEmployerProfilePressFragmentDoc}`;
export const FeaturedIdeaFragmentDoc = gql`
    fragment FeaturedIdea on Idea {
  id
  positions {
    id
    primarySymbol
    entityName
  }
  user {
    id
    displayName
    profileImageUrl
    profile {
      id
      companyString
    }
    mostRecentEmployer {
      id
      title
    }
  }
}
    `;
export const ActivityFeedFeatureFragmentDoc = gql`
    fragment ActivityFeedFeature on FeaturedItem {
  id
  feature
  featuredType
  featuredIdeas {
    edges {
      node {
        ...FeaturedIdea
      }
    }
  }
}
    ${FeaturedIdeaFragmentDoc}`;
export const ActivityFeedIdeaUpdateFragmentDoc = gql`
    fragment ActivityFeedIdeaUpdate on IdeaUpdate {
  id
  text
  closed
  createdAt
  impact
  changesHash
  idea {
    id
    anonymous
    canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(
      resource: "idea_filter_details"
      permission: "view"
    )
    positions {
      id
      asset {
        id
        primarySymbol
        entity {
          id
          name
        }
      }
    }
  }
  user {
    ...ActivityFeedUser
    username
  }
  ideaAttachments {
    edges {
      node {
        id
        attachmentType
        filename
      }
    }
  }
  youtubeIds
}
    ${ActivityFeedUserFragmentDoc}`;
export const ActivityFeedJobPostingFragmentDoc = gql`
    fragment ActivityFeedJobPosting on JobPosting {
  id
  title
  description
  sectors
  city
  postedAt
  updatedAt
  employer {
    id
    aumRange
    fundType
    strategy
  }
}
    `;
export const ActivityFeedPostFragmentDoc = gql`
    fragment ActivityFeedPost on Post {
  id
  body
  createdAt
  postedAt
  ogUrl
  ogTitle
  ogDescription
  ogPreviewImageUrl
  domain
  youtubeId
  user {
    ...ActivityFeedUser
  }
  commentsCount
}
    ${ActivityFeedUserFragmentDoc}`;
export const WhitePaperCategoryNamesFragmentDoc = gql`
    fragment WhitePaperCategoryNames on WhitePaper {
  esgNames
  geographyNames
  globalMacroNames
  sectorNames
}
    `;
export const ActivityFeedWhitePaperFragmentDoc = gql`
    fragment ActivityFeedWhitePaper on WhitePaper {
  id
  attachmentExtensions
  commentsCount
  submittedAt
  tagList
  thesis
  title
  whitePaperAttachments {
    id
    filename
  }
  wpElevatorPitch: elevatorPitch
  wpUpdatedAt: updatedAt
  wpUser: user {
    ...ActivityFeedUser
    ...ResearchItemUser
    isRanked
    fundProfile {
      id
    }
  }
  youtubeIds
  ...WhitePaperCategoryNames
}
    ${ActivityFeedUserFragmentDoc}
${ResearchItemUserFragmentDoc}
${WhitePaperCategoryNamesFragmentDoc}`;
export const ActivityFeedPublishedCommentFragmentDoc = gql`
    fragment ActivityFeedPublishedComment on Comment {
  id
  anonUser {
    id
    title
    username
  }
  body
  byAllocator
  commentCreationTime
  commentObject {
    ...ActivityFeedEmployerProfile
    ...ActivityFeedIdea
    ...ActivityFeedPost
    ...ActivityFeedWhitePaper
    ...ActivityFeedIdeaUpdate
  }
  user {
    ...ActivityFeedUser
  }
}
    ${ActivityFeedEmployerProfileFragmentDoc}
${ActivityFeedIdeaFragmentDoc}
${ActivityFeedPostFragmentDoc}
${ActivityFeedWhitePaperFragmentDoc}
${ActivityFeedIdeaUpdateFragmentDoc}
${ActivityFeedUserFragmentDoc}`;
export const ActivityFeedItemFragmentDoc = gql`
    fragment ActivityFeedItem on FeedItem {
  id
  createdAt
  forMentionedEntity
  event {
    id
    currentUserHasLiked
    eventObject {
      ...ActivityFeedAdminPost
      ...ActivityFeedAllocatorProfile
      ...ActivityFeedCorporateAction
      ...ActivityFeedEmployerProfile
      ...ActivityFeedEmployerProfileUpdate
      ...ActivityFeedFeature
      ...ActivityFeedIdea
      ...ActivityFeedIdeaUpdate
      ...ActivityFeedJobPosting
      ...ActivityFeedPost
      ...ActivityFeedPublishedComment
      ...ActivityFeedWhitePaper
    }
    likeCount
    verb
  }
}
    ${ActivityFeedAdminPostFragmentDoc}
${ActivityFeedAllocatorProfileFragmentDoc}
${ActivityFeedCorporateActionFragmentDoc}
${ActivityFeedEmployerProfileFragmentDoc}
${ActivityFeedEmployerProfileUpdateFragmentDoc}
${ActivityFeedFeatureFragmentDoc}
${ActivityFeedIdeaFragmentDoc}
${ActivityFeedIdeaUpdateFragmentDoc}
${ActivityFeedJobPostingFragmentDoc}
${ActivityFeedPostFragmentDoc}
${ActivityFeedPublishedCommentFragmentDoc}
${ActivityFeedWhitePaperFragmentDoc}`;
export const ActivityFeedRankFragmentDoc = gql`
    fragment ActivityFeedRank on Rank {
  id
  category
  value
  user {
    ...ActivityFeedUser
    userBadges: badgeCollectionRelationships {
      edges {
        node {
          id
          badgeNumber
          visible
          badge {
            ...Badges
          }
        }
      }
    }
    publishedIdeasCount
    recentIdea {
      id
      positions {
        id
        primarySymbol
      }
      totalReturn
    }
    topIdeas {
      edges {
        node {
          id
          positions {
            id
            primarySymbol
          }
          totalReturn
        }
      }
    }
  }
  pastRank {
    id
    category
    value
  }
}
    ${ActivityFeedUserFragmentDoc}
${BadgesFragmentDoc}`;
export const AllocatorProfileBackgroundImageFragmentDoc = gql`
    fragment AllocatorProfileBackgroundImage on AllocatorProfile {
  backgroundImageUrl
  backgroundImageCroppedUrl
  defaultBackgroundImage
}
    `;
export const AllocatorProfileCardFragmentDoc = gql`
    fragment AllocatorProfileCard on AllocatorProfile {
  id
  vanityLink
  name
  undisclosed
  aumRange
  employerType
  location
  fundManager
  bio
  publicBio
  highlights
}
    `;
export const AllocatorProfileRecommendationFragmentDoc = gql`
    fragment AllocatorProfileRecommendation on FundRecommendation {
  id
  matchesStrategy
  matchesAumRange
  matchesFundType
  matchesGeographies
  matchesSectors
  matchesAssetClasses
  geographiesMatching
  sectorsMatching
  assetClassesMatching
  hide
  allocatorProfile {
    ...AllocatorProfileCard
  }
  fundProfile {
    id
    name
  }
}
    ${AllocatorProfileCardFragmentDoc}`;
export const AllocatorProfileExecutiveManagementFragmentDoc = gql`
    fragment AllocatorProfileExecutiveManagement on AllocatorProfile {
  executives {
    id
    name
    bio
    photoUrl
    photoProfileUrl
    defaultPhoto
  }
}
    `;
export const AllocatorProfileInvestmentPreferencesFragmentDoc = gql`
    fragment AllocatorProfileInvestmentPreferences on AllocatorProfile {
  sectorPreferences
  geographyPreferences
  assetClassPreferences
  fundTypePreferences
  fundStrategyPreferences
  aumRangePreferences
}
    `;
export const ChatMessageFragmentDoc = gql`
    fragment ChatMessage on ChatMessage {
  id
  anonymous
  body
  createdAt
  direction
  participantName
  user {
    id
    mostRecentEmployer {
      id
      currentEmployer
      employer {
        id
        aumRange
        fundType
        name
        employerProfile {
          id
        }
      }
    }
    profileCity
    profileImageUrl
  }
}
    `;
export const CompanyPageFundamentalFragmentDoc = gql`
    fragment CompanyPageFundamental on Fundamental {
  id
  bookValue
  currentPe
  debtBook
  divYield
  ev
  evEbitda
  evFcf
  evSales
  fcfYield
  forwardPe
  marketCap
  priceBook
  sellsideConsensus
  threeMonthAdv
  totalCash
  totalDebt
}
    `;
export const CompanyQuestionFragmentDoc = gql`
    fragment CompanyQuestion on CompanyQuestion {
  answerOptions
  expirationMonths
  name
  questionType
  text
}
    `;
export const CompensationFieldsFragmentDoc = gql`
    fragment CompensationFields on Compensation {
  id
  completed
  status
  category
  year
  title
  experience
  industry
  location
  fundType
  fundStrategy
  fundSize
  assetClass
  baseSalary
  interestMgmtFeesPerc
  interestMgmtFeesValue
  vestingMgmtFees
  interestIncentiveFeesPerc
  interestIncentiveFeesValue
  vestingIncentiveFees
  annualDiscrBonus
  totalDeferredComp
  investInFund
  buildPersonalTrackRecord
  marketPersonalTrackRecord
  comments
}
    `;
export const ContestIndexCardFragmentDoc = gql`
    fragment ContestIndexCard on Contest {
  id
  active
  startDate
  endDate
  name
  promoSummary
  prizes {
    id
    description
    sponsorImage
    sponsorTrackingLink
  }
}
    `;
export const CryptoQuoteFragmentDoc = gql`
    fragment CryptoQuote on CryptoMarketData {
  circulatingSupply
  fullyDilutedMarketCap
  marketCap
  maxSupply
  percentChange24h
  percentChange7d
  totalSupply
  volume24h
}
    `;
export const FollowIdsFragmentDoc = gql`
    fragment FollowIds on User {
  followedFundIds
  followedUserIds
  followedEntityIds
  followedEsgIds
  followedGeographyIds
  followedGlobalMacroIds
  followedSectorIds
}
    `;
export const FundProfileAdminDashboardFragmentDoc = gql`
    fragment FundProfileAdminDashboard on EmployerProfile {
  status
  updatedAt
  introRequestsLeft
  introRequestPeriodEnd
}
    `;
export const FundProfileBackgroundImageFragmentDoc = gql`
    fragment FundProfileBackgroundImage on EmployerProfile {
  backgroundImageUrl
  backgroundImageCroppedUrl
  defaultBackgroundImage
}
    `;
export const FundProfileCardFragmentDoc = gql`
    fragment FundProfileCard on EmployerProfile {
  id
  aumRange
  description
  focus
  followerCount
  foundingYear
  fundType
  lastReturn {
    ltm
    sinceInception
    ytd
  }
  location
  logoProfileUrl
  name
  sharpeRatio
  strategy
  vanityLink
}
    `;
export const FundProfileIndexItemFragmentDoc = gql`
    fragment FundProfileIndexItem on EmployerProfile {
  id
  aumRange
  focus
  foundingYear
  fundType
  highlights
  lastReturn {
    id
    ltm
    sinceInception
    ytd
  }
  logoProfileUrl
  name
  pendingIntroRequest {
    id
    status
    messageThread
  }
  sharpeRatio
  strategy
  vanityLink
}
    `;
export const FundProfileRecommendationFragmentDoc = gql`
    fragment FundProfileRecommendation on FundRecommendation {
  id
  matchesStrategy
  matchesAumRange
  matchesFundType
  fundProfile {
    ...FundProfileIndexItem
  }
}
    ${FundProfileIndexItemFragmentDoc}`;
export const FundProfileSavedSearchFragmentDoc = gql`
    fragment FundProfileSavedSearch on EmployerProfileSearchAlert {
  id
  name
  savedSearch: employerProfileSavedSearch {
    id
    criteria
    searchKey
  }
}
    `;
export const FundProfileDueDiligenceFragmentDoc = gql`
    fragment FundProfileDueDiligence on EmployerProfile {
  dueDiligenceDocuments {
    id
    name
    category
    description
    filename
  }
  serviceProviders {
    id
    category
    firmName
    contactName
    contactEmail
    contactPhoneNumber
  }
}
    `;
export const FundProfileExecutiveManagementFragmentDoc = gql`
    fragment FundProfileExecutiveManagement on EmployerProfile {
  executives {
    id
    name
    bio
    photoUrl
    photoProfileUrl
    defaultPhoto
  }
}
    `;
export const FundProfileExpertiseFragmentDoc = gql`
    fragment FundProfileExpertise on EmployerProfile {
  sectorExpertise
  geographicExpertise
  assetClassExpertise
  subsectorExpertise
}
    `;
export const FundProfileFeaturedResearchFragmentDoc = gql`
    fragment FundProfileFeaturedResearch on EmployerProfile {
  featuredResearch {
    id
    canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(
      resource: "idea_filter_details"
      permission: "view"
    )
    positions {
      id
      direction
      asset {
        id
        primarySymbol
        entity {
          name
        }
      }
    }
    user {
      id
      displayName
      profileImageUrl
    }
    postedAt
    totalReturn
    elevatorPitch
    updated: lastUpdatedAt
  }
}
    `;
export const FundProfileFeaturedWhitePaperResearchFragmentDoc = gql`
    fragment FundProfileFeaturedWhitePaperResearch on EmployerProfile {
  featuredWhitePaperResearch {
    id
    elevatorPitch
    submittedAt
    title
    user {
      id
      displayName
      profileImageUrl
    }
    ...WhitePaperCategoryNames
  }
}
    ${WhitePaperCategoryNamesFragmentDoc}`;
export const FundProfileFeeStructureFragmentDoc = gql`
    fragment FundProfileFeeStructure on EmployerProfile {
  managementFee
  incentiveFee
  hurdleRate
  lockUp
  highwaterMark
  seedDeal
  foundersShares
  investorLevelGates
  feeStructureDocuments {
    id
    name
    description
    filename
  }
}
    `;
export const FundProfileFirmReferencesFragmentDoc = gql`
    fragment FundProfileFirmReferences on EmployerProfile {
  firmReferences {
    id
    name
    employer
    title
    contactEmail
    relationshipToFund
  }
}
    `;
export const FundProfileFundHoldingsFragmentDoc = gql`
    fragment FundProfileFundHoldings on EmployerProfile {
  holdingsUpdatedDate
  holdings {
    id
    percentOfPortfolio
    entityName
    primarySymbol
    assetClass
    realizedReturn
    expectedReturn
    averageCost
    action
    priceTarget
    timeframe
  }
  holdingsDocuments {
    id
    name
    description
    filename
  }
}
    `;
export const FundProfileMarketingMaterialsFragmentDoc = gql`
    fragment FundProfileMarketingMaterials on EmployerProfile {
  marketingMaterials {
    id
    name
    category
    filename
    url
  }
}
    `;
export const FundProfileMetricsFragmentDoc = gql`
    fragment FundProfileMetrics on EmployerProfile {
  beta
  sharpeRatio
  turnoverRatio
  metricsUpdatedAt
  metricsDocuments {
    id
    name
    description
    filename
  }
}
    `;
export const FundProfileNotesFragmentDoc = gql`
    fragment FundProfileNotes on EmployerProfile {
  notes
}
    `;
export const FundProfilePressMediaFragmentDoc = gql`
    fragment FundProfilePressMedia on EmployerProfile {
  presses {
    id
    title
    url
    filename
    fileUrl
    publishDate
    description
    previewImageUrl
  }
}
    `;
export const FundProfileReturnsFragmentDoc = gql`
    fragment FundProfileReturns on EmployerProfile {
  name
  returnsUpdatedDate
  returns {
    id
    benchmark
    employerBenchmark
    employerProfileId
    fiveYear
    ltm
    oneYear
    sevenYear
    sinceInception
    status
    tenYear
    threeYear
    ytd
  }
  returnsDocuments {
    id
    category
    description
    filename
    name
    url
  }
}
    `;
export const FundProfileTagsFragmentDoc = gql`
    fragment FundProfileTags on EmployerProfile {
  tagNames
}
    `;
export const IdeaSavedSearchFragmentDoc = gql`
    fragment IdeaSavedSearch on IdeaSearchAlert {
  id
  name
  savedSearch: ideaSavedSearch {
    id
    criteria
    searchKey
  }
}
    `;
export const IdeaShowPageCommentFragmentDoc = gql`
    fragment IdeaShowPageComment on Comment {
  id
  body
  createdAt
  responseRequested
  likeCount
  currentUserHasLiked
  parentId
  user {
    id
    anonymousUserId
    displayName(controlled: $controlName)
    profileImageUrl
    mostRecentEmployer {
      id
      title
      currentEmployer
      employer {
        id
        name
        aumRange
        fundType
      }
    }
  }
  anonUser {
    id
    anonymousUserId
    aumRange
    fundType
    isAllocator
    title
    username
  }
  commentAttachments {
    id
    fileName
    customName
  }
}
    `;
export const IdeaSubmissionAssetFragmentDoc = gql`
    fragment IdeaSubmissionAsset on Asset {
  id
  currencyCode
  entity {
    name
  }
  latestPrice
  name
  primarySymbol
}
    `;
export const IdeaAttachmentsFragmentDoc = gql`
    fragment IdeaAttachments on IdeaAttachment {
  id
  attachmentType
  description
  filename
  createdAt
  fromUpdate
  researchType
  fileType
  url
}
    `;
export const IdeaSubmissionDraftFragmentDoc = gql`
    fragment IdeaSubmissionDraft on Idea {
  id
  anonymous
  associatedEmployer {
    id
  }
  catalystNames
  contestIds
  elevatorPitch
  employerApprovalDisclaimer
  featuredOnAFundProfile
  ideaAttachments {
    ...IdeaAttachments
  }
  isPairTrade
  mentionedEntities {
    id
    name
    primarySymbol
  }
  noPriorAgreementDisclaimer
  pairRatio
  positions {
    id
    latestPrice
    priceTarget
    direction
    asset {
      id
    }
  }
  positionDisclaimerFund
  positionDisclaimerIndividual
  publicInformationDisclaimer
  returnTarget
  situation(raw: true)
  status
  tagList
  targetAllocation
  thesis
  timeframe(raw: true)
  user {
    id
  }
}
    ${IdeaAttachmentsFragmentDoc}`;
export const IdeaUpdatesFragmentDoc = gql`
    fragment IdeaUpdates on IdeaUpdate {
  id
  addedCatalystNames
  body
  catalystNames
  closed
  createdAt
  commentsCount
  ideaAttachmentsArray {
    ...IdeaAttachments
  }
  impact
  priceTarget
  removedCatalystNames
  removedPriceTarget
  removedReturnTarget
  removedSituation
  removedTargetAllocation
  removedTimeframe
  returnTarget
  situation
  targetAllocation
  timeframe
  truncated
  youtubeIds
}
    ${IdeaAttachmentsFragmentDoc}`;
export const IdeaViewFragmentDoc = gql`
    fragment IdeaView on IdeaView {
  actions
  id
  ideaAssetSymbol
  ideaId
  timestamp
  timeAgo
  viewer {
    canReceiveViewerIntroRequest
    emailPreferences {
      id
      emailType
      subscribed
    }
    id
  }
  viewerAumRange
  viewerCityName
  viewerFundType
  viewerIntroRequest {
    id
    status
  }
  viewerTitle
}
    `;
export const InsiderTradeFragmentDoc = gql`
    fragment InsiderTrade on InsiderTrade {
  id
  date
  entityId
  name
  numShares
  ownershipChangePct
  sharePrice
  symbol
  title
  tradeType
}
    `;
export const JobVaultEmployerFragmentDoc = gql`
    fragment JobVaultEmployer on Employer {
  id
  name
  assets
  aumRange
  description
  fundType
  investmentStyle
  regions
  strategy
  sectors
}
    `;
export const MembersIndexCardUserFragmentDoc = gql`
    fragment MembersIndexCardUser on User {
  id
  displayName
  publishedIdeasCount
  mostRecentEmployer {
    id
    currentEmployer
    title
    employer {
      id
      name
      aumRange
      fundType
    }
  }
  userBadges: badgeCollectionRelationships {
    edges {
      node {
        id
        badgeNumber
        visible
        badge {
          ...Badges
        }
      }
    }
  }
}
    ${BadgesFragmentDoc}`;
export const MembersIndexCardFragmentDoc = gql`
    fragment MembersIndexCard on Profile {
  id
  city
  imageProfileUrl
  summary
  user {
    ...MembersIndexCardUser
  }
}
    ${MembersIndexCardUserFragmentDoc}`;
export const MessageItemFragmentDoc = gql`
    fragment MessageItem on Message {
  id
  thread
  threadCount
  createdAt
  body
  subject
  senderIsCurrentUser
  readStatus
  isCapIntroMessage
  otherParty {
    id
    displayName
    profileImageUrl
    currentEmployerName
    mostRecentEmployer {
      id
      employer {
        id
        name
      }
    }
  }
}
    `;
export const MessageThreadItemFragmentDoc = gql`
    fragment MessageThreadItem on Message {
  id
  thread
  subject
  body
  createdAt
  readStatus
  archiveStatus
  isCapIntroMessage
  rootMessage {
    id
  }
  jobPosting {
    id
    title
  }
  otherParty {
    id
    displayName
    currentEmployerName
    mostRecentEmployer {
      id
      employer {
        id
        name
      }
    }
  }
  sender {
    id
    displayName
    profileImageUrl
    currentEmployerName
    mostRecentEmployer {
      id
      employer {
        id
        name
        employerProfile {
          id
        }
      }
    }
  }
  introRequest {
    id
    status
  }
  messageAttachments {
    id
    fileName
    customName
  }
}
    `;
export const PaladinQuotaFragmentDoc = gql`
    fragment PaladinQuota on Paladin {
  nextQuotaDeadline
  ratingQuota: quota(type: "user_rating")
  ratingCurrentMonth: quotaCurrentMonth(type: "user_rating")
  ratingPercent: quotaPercent(type: "user_rating")
  commentQuota: quota(type: "comment")
  commentCurrentMonth: quotaCurrentMonth(type: "comment")
  commentPercent: quotaPercent(type: "comment")
  pollAnswerQuota: quota(type: "company_question_response")
  pollAnswerCurrentMonth: quotaCurrentMonth(type: "company_question_response")
  pollAnswerPercent: quotaPercent(type: "company_question_response")
  hasPollAnswerQuota: hasQuota(type: "company_question_response")
}
    `;
export const PartnerOfferFragmentFragmentDoc = gql`
    fragment PartnerOfferFragment on AdCampaign {
  id
  partnerName
  name
  headline
  body
  actionText
  modalText
  modalHeaderText
  headlineImageUrl
  additionalModalLinkLink
  additionalModalLinkText
  redirectLink
  showTicker
}
    `;
export const PodcastEpisodeMediaFragmentDoc = gql`
    fragment PodcastEpisodeMedia on PodcastEpisode {
  id
  description
  mediaId: episodeId
  mentionedEntities {
    id
    primarySymbol
  }
  publishedAt: releasedAt
  relatedMedia: relatedPodcastEpisodes {
    id
    description
    tagList
    title: name
    vanityLink
  }
  tagList
  title: name
}
    `;
export const PodcastEpisodeMediaIndexFragmentDoc = gql`
    fragment PodcastEpisodeMediaIndex on PodcastEpisode {
  id
  description
  mentionedEntities {
    id
    name
    primarySymbol
  }
  publishedAt: releasedAt(isTimeAgo: true)
  tagList
  thumbnailImageUrl
  title: name
  vanityLink
}
    `;
export const RankCardFragmentDoc = gql`
    fragment RankCard on Rank {
  id
  value
  rankString
  viewDeltaString
  privateDeltaString
  user {
    id
    displayName
    currentEmployerName
    profileImageUrl
    profileCity
    isFollowedByCurrentUser
    mostRecentEmployer {
      currentEmployer
      title
      employer {
        id
        aumRange
        fundType
      }
    }
    topIdeas(first: 3) {
      edges {
        node {
          id
          totalReturn
          isPairTrade
          positions {
            id
            primarySymbol
          }
        }
      }
    }
    recentIdea {
      id
      totalReturn
      isPairTrade
      positions {
        id
        primarySymbol
      }
    }
    badgeCollectionRelationships {
      edges {
        node {
          id
          badge {
            id
            name
            description
          }
          badgeNumber
          visible
        }
      }
    }
  }
}
    `;
export const RankingsWidgetRankFragmentDoc = gql`
    fragment RankingsWidgetRank on Rank {
  id
  user {
    id
    displayName
    mostRecentEmployer {
      id
      isCurrentEmployer: currentEmployer
      employer {
        id
        name
        aumRange
        fundType
        hasFundProfile
      }
      title
    }
    profileCity
    profileImageUrl
    recentIdea {
      id
      totalReturn
      isPairTrade
      positions {
        id
        primarySymbol
      }
    }
  }
}
    `;
export const ReadingListItemFragmentDoc = gql`
    fragment ReadingListItem on ReadingListItem {
  id
  archived
  ideaId
}
    `;
export const ResearchItemFragmentDoc = gql`
    fragment ResearchItem on Idea {
  id
  positions {
    id
    entityName
    primarySymbol
    asset {
      id
      entity {
        id
      }
    }
  }
  communityRating
  user {
    id
    displayName
    profileImageUrl
    profileCity
    mostRecentEmployer {
      id
      title
      currentEmployer
      employer {
        id
        name
        aumRange
        fundType
      }
    }
  }
}
    `;
export const UserAccessFragmentDoc = gql`
    fragment UserAccess on User {
  ideaIsBlocked: isBlocked(feature: "research")
  ideaDaysLeft: numDaysAccessLeft(itemType: "idea")
  compensationIsBlocked: isCompensationAccessExpired
  compensationDaysLeft: numDaysCompensationViewRemaining
  capIntroIsBlocked: isCapIntroAccessBlocked
  capIntroDaysLeft: numDaysCapIntroAccessRemaining
  jobIsBlocked: isJobAccessBlocked
  jobDaysLeft: numDaysJobViewRemaining
}
    `;
export const UserEmployerFragmentDoc = gql`
    fragment UserEmployer on Employer {
  id
  aumRange
  employerProfile {
    id
    followerCount
  }
  fundType
  name
}
    `;
export const UserNotificationFragmentDoc = gql`
    fragment UserNotification on Notification {
  id
  description
  createdAt
  viewed
  linkId
  customLink
  notificationClass
  hidden
  associatedUser {
    id
    isAllocator
    allocatorProfileLogoUrl
    profileImageUrl
  }
}
    `;
export const UserProfileFragmentDoc = gql`
    fragment UserProfile on User {
  currentEmployers {
    id
    name
  }
  displayName
  featuredRank {
    id
    rankString
    category
    current
  }
  activeFollowedUsersCount
  activeFollowersCount
  isAllocator
  profileImageUrl
  profile {
    id
  }
  publishedIdeasCount
  primaryContact {
    id
    displayName
    email
  }
}
    `;
export const UserProfileAdminDashboardFragmentDoc = gql`
    fragment UserProfileAdminDashboard on Profile {
  user {
    canPostJobs
    isHighProfile
  }
  hasFilledPrivateProfile
}
    `;
export const UserProfileBackgroundImageFragmentDoc = gql`
    fragment UserProfileBackgroundImage on Profile {
  backgroundImageUrl
  backgroundImageCroppedUrl
  defaultBackgroundImage
}
    `;
export const UserProfileCardFragmentDoc = gql`
    fragment UserProfileCard on Profile {
  imageProfileUrl
  imageUrl
  defaultImage
  certifications
  city
  summary
  user {
    id
    displayName
    mostRecentEmployer {
      id
      currentEmployer
      employer {
        id
        name
        hasFundProfile
      }
    }
    publishedIdeasCount
    activeFollowedUsersCount
    activeFollowersCount
  }
}
    `;
export const UserProfileContactFragmentDoc = gql`
    fragment UserProfileContact on Profile {
  email
  mobilePhone
  workPhone
}
    `;
export const UserProfileAcademicPerformanceFragmentDoc = gql`
    fragment UserProfileAcademicPerformance on Profile {
  profileTestResults {
    id
    name
    score
    maxScore
    date
    url
    filename
  }
  hasGpa
  hasSatOrAct
}
    `;
export const UserProfileAwardsFragmentDoc = gql`
    fragment UserProfileAwards on Profile {
  user {
    historicalPublicRankings
    userBadges: badgeCollectionRelationships {
      edges {
        node {
          id
          badgeNumber
          visible
          earnedAt
          badge {
            ...Badges
          }
        }
      }
    }
  }
}
    ${BadgesFragmentDoc}`;
export const UserProfileEducationFragmentDoc = gql`
    fragment UserProfileEducation on Profile {
  schoolHistories {
    id
    schoolName
    degree
    fieldOfStudy
    currentStudent
    startYear
    gradYear
  }
}
    `;
export const UserProfileExpertiseFragmentDoc = gql`
    fragment UserProfileExpertise on Profile {
  sectorExpertise
  geographicExpertise
  assetClassExpertise
}
    `;
export const UserProfilePersonalDetailsFragmentDoc = gql`
    fragment UserProfilePersonalDetails on Profile {
  hometown
  investmentHero
  favoriteInvestmentBook
  investingStyle
  languagesSpoken
}
    `;
export const UserProfileQAndAFragmentDoc = gql`
    fragment UserProfileQAndA on Profile {
  hasAnyProfileAnswers
  hasAllProfileAnswers
  profileAnswers {
    profileQuestionId
    answer
  }
}
    `;
export const IdeaResearchItemFragmentDoc = gql`
    fragment IdeaResearchItem on Idea {
  id
  anonymous
  attachmentExtensions
  authorName
  canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(
    resource: "idea_filter_details"
    permission: "view"
  )
  closedAt
  commentsCount
  awardWinningContestIdeas {
    id
    award
    contestId
  }
  elevatorPitch
  expectedReturn
  expectedPerformanceRating {
    id
    averageRating
    userRatingCount
  }
  isNonBuyside
  phraseCount
  positions {
    id
    direction
    asset {
      id
      primarySymbol
      assetClassName
      name
      fundamental {
        id
        marketCap
      }
    }
  }
  submittedAt: openedAt
  tagList
  totalReturn
  user {
    ...ResearchItemUser
  }
  updatedAt: lastUpdatedAt
  weeklyTopIdea
}
    ${ResearchItemUserFragmentDoc}`;
export const UserProfileResearchFragmentDoc = gql`
    fragment UserProfileResearch on Profile {
  user {
    recentIdea(controlled: $controlIdeaAccess) {
      ...IdeaResearchItem
    }
  }
  postedInLast3Months
  profileAttachments {
    id
    name
    description
    filename
  }
}
    ${IdeaResearchItemFragmentDoc}`;
export const UserProfileResearchPerformanceFragmentDoc = gql`
    fragment UserProfileResearchPerformance on Profile {
  ideaTotalReturnAverage
  ideaReturnVsBenchmarkAverage
  ideaAnnualizedReturnMedian
}
    `;
export const UserProfileResumePhoneFragmentDoc = gql`
    fragment UserProfileResumePhone on Profile {
  resume
  workPhone
}
    `;
export const UserProfileWorkExperienceFragmentDoc = gql`
    fragment UserProfileWorkExperience on Profile {
  experienceByFirmType
  employerHistories {
    id
    currentEmployer
    employer {
      id
      name
      aumRange
      aumRangePresent
      fundType
    }
    fromDate
    primary
    title
    toDate
  }
}
    `;
export const UserWatchlistFragmentDoc = gql`
    fragment UserWatchlist on Watchlist {
  id
  sectors {
    id
    name
  }
  geographies {
    id
    name
  }
  assetClasses {
    id
    name
  }
  entitiesFromMassImport {
    id
    name
    primarySymbol
  }
  entitiesRegularFollows {
    id
    name
    primarySymbol
  }
  massImports {
    id
    numberOfTickers
    fileName
  }
  users {
    id
    displayName
    profileImageUrl
    currentEmployerName
    mostRecentEmployer {
      id
      title
      employer {
        id
        aumRange
        fundType
      }
    }
  }
  aumRanges {
    id
    name
  }
  fundTypes {
    id
    name
  }
  fundStrategies {
    id
    name
  }
  onboardingStatus
}
    `;
export const VideoMediaFragmentDoc = gql`
    fragment VideoMedia on Video {
  id
  description
  mediaId: videoId
  mentionedEntities {
    id
    primarySymbol
  }
  publishedAt
  relatedMedia: relatedVideos {
    id
    description
    tagList
    title
    vanityLink
  }
  tagList
  title
}
    `;
export const VideoMediaIndexFragmentDoc = gql`
    fragment VideoMediaIndex on Video {
  id
  description
  mentionedEntities {
    id
    name
    primarySymbol
  }
  publishedAt(isTimeAgo: true)
  tagList
  thumbnailImageUrl
  title
  vanityLink
}
    `;
export const WhitePaperResearchItemFragmentDoc = gql`
    fragment WhitePaperResearchItem on WhitePaper {
  id
  attachmentExtensions
  commentsCount
  elevatorPitch
  esgNames
  geographyNames
  globalMacroNames
  sectorNames
  submittedAt
  tagList
  title
  updatedAt
  user {
    ...ResearchItemUser
  }
}
    ${ResearchItemUserFragmentDoc}`;
export const WhitePaperSubmissionDraftFragmentDoc = gql`
    fragment WhitePaperSubmissionDraft on WhitePaper {
  id
  elevatorPitch
  associatedEmployer {
    id
  }
  featuredOnAFundProfile
  mentionedEntities {
    id
    name
    primarySymbol
  }
  esgs {
    id
  }
  geographies {
    id
  }
  globalMacros {
    id
  }
  sectors {
    id
  }
  positionDisclaimerFund
  positionDisclaimerIndividual
  status
  tagList
  thesis
  thesisText
  title
  user {
    id
  }
  whitePaperAttachments {
    id
    attachmentType
    filename
    createdAt
    researchType
    fileType
    url
  }
}
    `;
export const CreateApiKeyDocument = gql`
    mutation CreateApiKey($userId: ID!, $prefix: String!, $demo: Boolean, $rawText: Boolean) {
  createApiKey(
    input: {userId: $userId, prefix: $prefix, demo: $demo, rawText: $rawText}
  ) {
    key
  }
}
    `;
export type CreateApiKeyMutationFn = Apollo.MutationFunction<CreateApiKeyMutation, CreateApiKeyMutationVariables>;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      prefix: // value for 'prefix'
 *      demo: // value for 'demo'
 *      rawText: // value for 'rawText'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export type CreateApiKeyMutationResult = Apollo.MutationResult<CreateApiKeyMutation>;
export type CreateApiKeyMutationOptions = Apollo.BaseMutationOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>;
export const MergeEntitiesDocument = gql`
    mutation MergeEntities($toMergeId: ID!, $destinationId: ID!, $assetsToMerge: [AssetsToMergeAttributes!]!) {
  mergeEntities(
    input: {toMergeId: $toMergeId, destinationId: $destinationId, assetsToMerge: $assetsToMerge}
  ) {
    entity {
      id
    }
  }
}
    `;
export type MergeEntitiesMutationFn = Apollo.MutationFunction<MergeEntitiesMutation, MergeEntitiesMutationVariables>;

/**
 * __useMergeEntitiesMutation__
 *
 * To run a mutation, you first call `useMergeEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeEntitiesMutation, { data, loading, error }] = useMergeEntitiesMutation({
 *   variables: {
 *      toMergeId: // value for 'toMergeId'
 *      destinationId: // value for 'destinationId'
 *      assetsToMerge: // value for 'assetsToMerge'
 *   },
 * });
 */
export function useMergeEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<MergeEntitiesMutation, MergeEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeEntitiesMutation, MergeEntitiesMutationVariables>(MergeEntitiesDocument, options);
      }
export type MergeEntitiesMutationHookResult = ReturnType<typeof useMergeEntitiesMutation>;
export type MergeEntitiesMutationResult = Apollo.MutationResult<MergeEntitiesMutation>;
export type MergeEntitiesMutationOptions = Apollo.BaseMutationOptions<MergeEntitiesMutation, MergeEntitiesMutationVariables>;
export const UpdateApiKeyDocument = gql`
    mutation UpdateApiKey($id: ID!, $demo: Boolean, $active: Boolean) {
  updateApiKey(input: {keyId: $id, demo: $demo, active: $active}) {
    apiKey {
      id
    }
  }
}
    `;
export type UpdateApiKeyMutationFn = Apollo.MutationFunction<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;

/**
 * __useUpdateApiKeyMutation__
 *
 * To run a mutation, you first call `useUpdateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateApiKeyMutation, { data, loading, error }] = useUpdateApiKeyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      demo: // value for 'demo'
 *      active: // value for 'active'
 *   },
 * });
 */
export function useUpdateApiKeyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>(UpdateApiKeyDocument, options);
      }
export type UpdateApiKeyMutationHookResult = ReturnType<typeof useUpdateApiKeyMutation>;
export type UpdateApiKeyMutationResult = Apollo.MutationResult<UpdateApiKeyMutation>;
export type UpdateApiKeyMutationOptions = Apollo.BaseMutationOptions<UpdateApiKeyMutation, UpdateApiKeyMutationVariables>;
export const UpdateEntityAdminDocument = gql`
    mutation UpdateEntityAdmin($id: ID!, $name: String!, $factsetEntityId: String!, $approve: Boolean, $hideFromIndex: Boolean!) {
  updateEntityAdmin(
    input: {id: $id, name: $name, factsetEntityId: $factsetEntityId, approve: $approve, hideFromIndex: $hideFromIndex}
  ) {
    entity {
      ...AdminEntity
    }
  }
}
    ${AdminEntityFragmentDoc}`;
export type UpdateEntityAdminMutationFn = Apollo.MutationFunction<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>;

/**
 * __useUpdateEntityAdminMutation__
 *
 * To run a mutation, you first call `useUpdateEntityAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEntityAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEntityAdminMutation, { data, loading, error }] = useUpdateEntityAdminMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      factsetEntityId: // value for 'factsetEntityId'
 *      approve: // value for 'approve'
 *      hideFromIndex: // value for 'hideFromIndex'
 *   },
 * });
 */
export function useUpdateEntityAdminMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>(UpdateEntityAdminDocument, options);
      }
export type UpdateEntityAdminMutationHookResult = ReturnType<typeof useUpdateEntityAdminMutation>;
export type UpdateEntityAdminMutationResult = Apollo.MutationResult<UpdateEntityAdminMutation>;
export type UpdateEntityAdminMutationOptions = Apollo.BaseMutationOptions<UpdateEntityAdminMutation, UpdateEntityAdminMutationVariables>;
export const AdminEntityDocument = gql`
    query AdminEntity($entityId: ID!) {
  entity(id: $entityId) {
    ...AdminEntity
  }
}
    ${AdminEntityFragmentDoc}`;

/**
 * __useAdminEntityQuery__
 *
 * To run a query within a React component, call `useAdminEntityQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminEntityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEntityQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useAdminEntityQuery(baseOptions: Apollo.QueryHookOptions<AdminEntityQuery, AdminEntityQueryVariables> & ({ variables: AdminEntityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminEntityQuery, AdminEntityQueryVariables>(AdminEntityDocument, options);
      }
export function useAdminEntityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminEntityQuery, AdminEntityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminEntityQuery, AdminEntityQueryVariables>(AdminEntityDocument, options);
        }
export function useAdminEntitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminEntityQuery, AdminEntityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminEntityQuery, AdminEntityQueryVariables>(AdminEntityDocument, options);
        }
export type AdminEntityQueryHookResult = ReturnType<typeof useAdminEntityQuery>;
export type AdminEntityLazyQueryHookResult = ReturnType<typeof useAdminEntityLazyQuery>;
export type AdminEntitySuspenseQueryHookResult = ReturnType<typeof useAdminEntitySuspenseQuery>;
export type AdminEntityQueryResult = Apollo.QueryResult<AdminEntityQuery, AdminEntityQueryVariables>;
export const EntitiesMergeSearchDocument = gql`
    query EntitiesMergeSearch($query: String!) {
  entitiesSearch(query: $query) {
    id
    name
    factsetEntityId
  }
}
    `;

/**
 * __useEntitiesMergeSearchQuery__
 *
 * To run a query within a React component, call `useEntitiesMergeSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesMergeSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesMergeSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEntitiesMergeSearchQuery(baseOptions: Apollo.QueryHookOptions<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables> & ({ variables: EntitiesMergeSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables>(EntitiesMergeSearchDocument, options);
      }
export function useEntitiesMergeSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables>(EntitiesMergeSearchDocument, options);
        }
export function useEntitiesMergeSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables>(EntitiesMergeSearchDocument, options);
        }
export type EntitiesMergeSearchQueryHookResult = ReturnType<typeof useEntitiesMergeSearchQuery>;
export type EntitiesMergeSearchLazyQueryHookResult = ReturnType<typeof useEntitiesMergeSearchLazyQuery>;
export type EntitiesMergeSearchSuspenseQueryHookResult = ReturnType<typeof useEntitiesMergeSearchSuspenseQuery>;
export type EntitiesMergeSearchQueryResult = Apollo.QueryResult<EntitiesMergeSearchQuery, EntitiesMergeSearchQueryVariables>;
export const MergeEntityAssetsDocument = gql`
    query MergeEntityAssets($mergeToEntityId: ID!, $destinationEntityId: ID!) {
  mergeToEntity: entity(id: $mergeToEntityId) {
    id
    name
    assets(showAll: true) {
      ...AdminAsset
    }
  }
  destinationEntity: entity(id: $destinationEntityId) {
    id
    name
    assets(showAll: true) {
      ...AdminAsset
    }
  }
}
    ${AdminAssetFragmentDoc}`;

/**
 * __useMergeEntityAssetsQuery__
 *
 * To run a query within a React component, call `useMergeEntityAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeEntityAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeEntityAssetsQuery({
 *   variables: {
 *      mergeToEntityId: // value for 'mergeToEntityId'
 *      destinationEntityId: // value for 'destinationEntityId'
 *   },
 * });
 */
export function useMergeEntityAssetsQuery(baseOptions: Apollo.QueryHookOptions<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables> & ({ variables: MergeEntityAssetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables>(MergeEntityAssetsDocument, options);
      }
export function useMergeEntityAssetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables>(MergeEntityAssetsDocument, options);
        }
export function useMergeEntityAssetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables>(MergeEntityAssetsDocument, options);
        }
export type MergeEntityAssetsQueryHookResult = ReturnType<typeof useMergeEntityAssetsQuery>;
export type MergeEntityAssetsLazyQueryHookResult = ReturnType<typeof useMergeEntityAssetsLazyQuery>;
export type MergeEntityAssetsSuspenseQueryHookResult = ReturnType<typeof useMergeEntityAssetsSuspenseQuery>;
export type MergeEntityAssetsQueryResult = Apollo.QueryResult<MergeEntityAssetsQuery, MergeEntityAssetsQueryVariables>;
export const WatchlistFilterEntitiesSearchDocument = gql`
    query WatchlistFilterEntitiesSearch($ids: [String!]) {
  entities(ids: $ids) {
    id
    primarySymbol
  }
}
    `;

/**
 * __useWatchlistFilterEntitiesSearchQuery__
 *
 * To run a query within a React component, call `useWatchlistFilterEntitiesSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistFilterEntitiesSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistFilterEntitiesSearchQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useWatchlistFilterEntitiesSearchQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>(WatchlistFilterEntitiesSearchDocument, options);
      }
export function useWatchlistFilterEntitiesSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>(WatchlistFilterEntitiesSearchDocument, options);
        }
export function useWatchlistFilterEntitiesSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>(WatchlistFilterEntitiesSearchDocument, options);
        }
export type WatchlistFilterEntitiesSearchQueryHookResult = ReturnType<typeof useWatchlistFilterEntitiesSearchQuery>;
export type WatchlistFilterEntitiesSearchLazyQueryHookResult = ReturnType<typeof useWatchlistFilterEntitiesSearchLazyQuery>;
export type WatchlistFilterEntitiesSearchSuspenseQueryHookResult = ReturnType<typeof useWatchlistFilterEntitiesSearchSuspenseQuery>;
export type WatchlistFilterEntitiesSearchQueryResult = Apollo.QueryResult<WatchlistFilterEntitiesSearchQuery, WatchlistFilterEntitiesSearchQueryVariables>;
export const ApiKeyRetrievalDocument = gql`
    query ApiKeyRetrieval {
  apiKeys {
    id
    active
    demo
    prefix
    user {
      displayName
    }
  }
}
    `;

/**
 * __useApiKeyRetrievalQuery__
 *
 * To run a query within a React component, call `useApiKeyRetrievalQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeyRetrievalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeyRetrievalQuery({
 *   variables: {
 *   },
 * });
 */
export function useApiKeyRetrievalQuery(baseOptions?: Apollo.QueryHookOptions<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>(ApiKeyRetrievalDocument, options);
      }
export function useApiKeyRetrievalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>(ApiKeyRetrievalDocument, options);
        }
export function useApiKeyRetrievalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>(ApiKeyRetrievalDocument, options);
        }
export type ApiKeyRetrievalQueryHookResult = ReturnType<typeof useApiKeyRetrievalQuery>;
export type ApiKeyRetrievalLazyQueryHookResult = ReturnType<typeof useApiKeyRetrievalLazyQuery>;
export type ApiKeyRetrievalSuspenseQueryHookResult = ReturnType<typeof useApiKeyRetrievalSuspenseQuery>;
export type ApiKeyRetrievalQueryResult = Apollo.QueryResult<ApiKeyRetrievalQuery, ApiKeyRetrievalQueryVariables>;
export const SearchDocument = gql`
    query Search($name: String) {
  userSearch(query: $name) {
    id
    displayName
    currentEmployerName
  }
}
    `;

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSearchQuery(baseOptions?: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export function useSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchSuspenseQueryHookResult = ReturnType<typeof useSearchSuspenseQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const AcceptFundDisclaimerDocument = gql`
    mutation AcceptFundDisclaimer {
  acceptFundDisclaimer(input: {}) {
    currentUser {
      id
      acceptedFundDisclaimer
    }
  }
}
    `;
export type AcceptFundDisclaimerMutationFn = Apollo.MutationFunction<AcceptFundDisclaimerMutation, AcceptFundDisclaimerMutationVariables>;

/**
 * __useAcceptFundDisclaimerMutation__
 *
 * To run a mutation, you first call `useAcceptFundDisclaimerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptFundDisclaimerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptFundDisclaimerMutation, { data, loading, error }] = useAcceptFundDisclaimerMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcceptFundDisclaimerMutation(baseOptions?: Apollo.MutationHookOptions<AcceptFundDisclaimerMutation, AcceptFundDisclaimerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptFundDisclaimerMutation, AcceptFundDisclaimerMutationVariables>(AcceptFundDisclaimerDocument, options);
      }
export type AcceptFundDisclaimerMutationHookResult = ReturnType<typeof useAcceptFundDisclaimerMutation>;
export type AcceptFundDisclaimerMutationResult = Apollo.MutationResult<AcceptFundDisclaimerMutation>;
export type AcceptFundDisclaimerMutationOptions = Apollo.BaseMutationOptions<AcceptFundDisclaimerMutation, AcceptFundDisclaimerMutationVariables>;
export const ArchiveThreadDocument = gql`
    mutation ArchiveThread($threadNum: ID!) {
  archiveThread(input: {threadNum: $threadNum}) {
    id
  }
}
    `;
export type ArchiveThreadMutationFn = Apollo.MutationFunction<ArchiveThreadMutation, ArchiveThreadMutationVariables>;

/**
 * __useArchiveThreadMutation__
 *
 * To run a mutation, you first call `useArchiveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveThreadMutation, { data, loading, error }] = useArchiveThreadMutation({
 *   variables: {
 *      threadNum: // value for 'threadNum'
 *   },
 * });
 */
export function useArchiveThreadMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveThreadMutation, ArchiveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveThreadMutation, ArchiveThreadMutationVariables>(ArchiveThreadDocument, options);
      }
export type ArchiveThreadMutationHookResult = ReturnType<typeof useArchiveThreadMutation>;
export type ArchiveThreadMutationResult = Apollo.MutationResult<ArchiveThreadMutation>;
export type ArchiveThreadMutationOptions = Apollo.BaseMutationOptions<ArchiveThreadMutation, ArchiveThreadMutationVariables>;
export const AssociateViewerIntroRequestMessageDocument = gql`
    mutation AssociateViewerIntroRequestMessage($viewerIntroRequestId: ID!, $messageId: ID!) {
  associateViewerIntroRequestMessage(
    input: {viewerIntroRequestId: $viewerIntroRequestId, messageId: $messageId}
  ) {
    success
  }
}
    `;
export type AssociateViewerIntroRequestMessageMutationFn = Apollo.MutationFunction<AssociateViewerIntroRequestMessageMutation, AssociateViewerIntroRequestMessageMutationVariables>;

/**
 * __useAssociateViewerIntroRequestMessageMutation__
 *
 * To run a mutation, you first call `useAssociateViewerIntroRequestMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssociateViewerIntroRequestMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [associateViewerIntroRequestMessageMutation, { data, loading, error }] = useAssociateViewerIntroRequestMessageMutation({
 *   variables: {
 *      viewerIntroRequestId: // value for 'viewerIntroRequestId'
 *      messageId: // value for 'messageId'
 *   },
 * });
 */
export function useAssociateViewerIntroRequestMessageMutation(baseOptions?: Apollo.MutationHookOptions<AssociateViewerIntroRequestMessageMutation, AssociateViewerIntroRequestMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssociateViewerIntroRequestMessageMutation, AssociateViewerIntroRequestMessageMutationVariables>(AssociateViewerIntroRequestMessageDocument, options);
      }
export type AssociateViewerIntroRequestMessageMutationHookResult = ReturnType<typeof useAssociateViewerIntroRequestMessageMutation>;
export type AssociateViewerIntroRequestMessageMutationResult = Apollo.MutationResult<AssociateViewerIntroRequestMessageMutation>;
export type AssociateViewerIntroRequestMessageMutationOptions = Apollo.BaseMutationOptions<AssociateViewerIntroRequestMessageMutation, AssociateViewerIntroRequestMessageMutationVariables>;
export const ClickIdeaRecommendationDocument = gql`
    mutation ClickIdeaRecommendation($id: ID!, $userId: ID!, $ideaId: ID!) {
  clickIdeaRecommendation(input: {id: $id, userId: $userId, ideaId: $ideaId}) {
    currentUser {
      id
    }
  }
}
    `;
export type ClickIdeaRecommendationMutationFn = Apollo.MutationFunction<ClickIdeaRecommendationMutation, ClickIdeaRecommendationMutationVariables>;

/**
 * __useClickIdeaRecommendationMutation__
 *
 * To run a mutation, you first call `useClickIdeaRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickIdeaRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickIdeaRecommendationMutation, { data, loading, error }] = useClickIdeaRecommendationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useClickIdeaRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<ClickIdeaRecommendationMutation, ClickIdeaRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClickIdeaRecommendationMutation, ClickIdeaRecommendationMutationVariables>(ClickIdeaRecommendationDocument, options);
      }
export type ClickIdeaRecommendationMutationHookResult = ReturnType<typeof useClickIdeaRecommendationMutation>;
export type ClickIdeaRecommendationMutationResult = Apollo.MutationResult<ClickIdeaRecommendationMutation>;
export type ClickIdeaRecommendationMutationOptions = Apollo.BaseMutationOptions<ClickIdeaRecommendationMutation, ClickIdeaRecommendationMutationVariables>;
export const ClickedNotificationsDocument = gql`
    mutation ClickedNotifications {
  clickedNotifications(input: {}) {
    currentUser {
      id
      newNotificationsCount
    }
  }
}
    `;
export type ClickedNotificationsMutationFn = Apollo.MutationFunction<ClickedNotificationsMutation, ClickedNotificationsMutationVariables>;

/**
 * __useClickedNotificationsMutation__
 *
 * To run a mutation, you first call `useClickedNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClickedNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clickedNotificationsMutation, { data, loading, error }] = useClickedNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useClickedNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ClickedNotificationsMutation, ClickedNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClickedNotificationsMutation, ClickedNotificationsMutationVariables>(ClickedNotificationsDocument, options);
      }
export type ClickedNotificationsMutationHookResult = ReturnType<typeof useClickedNotificationsMutation>;
export type ClickedNotificationsMutationResult = Apollo.MutationResult<ClickedNotificationsMutation>;
export type ClickedNotificationsMutationOptions = Apollo.BaseMutationOptions<ClickedNotificationsMutation, ClickedNotificationsMutationVariables>;
export const CloseQuickPositionDocument = gql`
    mutation CloseQuickPosition($quickPositionId: ID!) {
  closeQuickPosition(input: {quickPositionId: $quickPositionId}) {
    quickPosition {
      id
      asset {
        id
        symbol
        entity {
          id
          name
        }
      }
      closedAt
      closingPrice
      direction
    }
  }
}
    `;
export type CloseQuickPositionMutationFn = Apollo.MutationFunction<CloseQuickPositionMutation, CloseQuickPositionMutationVariables>;

/**
 * __useCloseQuickPositionMutation__
 *
 * To run a mutation, you first call `useCloseQuickPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseQuickPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeQuickPositionMutation, { data, loading, error }] = useCloseQuickPositionMutation({
 *   variables: {
 *      quickPositionId: // value for 'quickPositionId'
 *   },
 * });
 */
export function useCloseQuickPositionMutation(baseOptions?: Apollo.MutationHookOptions<CloseQuickPositionMutation, CloseQuickPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseQuickPositionMutation, CloseQuickPositionMutationVariables>(CloseQuickPositionDocument, options);
      }
export type CloseQuickPositionMutationHookResult = ReturnType<typeof useCloseQuickPositionMutation>;
export type CloseQuickPositionMutationResult = Apollo.MutationResult<CloseQuickPositionMutation>;
export type CloseQuickPositionMutationOptions = Apollo.BaseMutationOptions<CloseQuickPositionMutation, CloseQuickPositionMutationVariables>;
export const CloseJobPostDocument = gql`
    mutation CloseJobPost($jobPostId: ID!, $hired: Boolean!, $applicationId: ID) {
  closeJobPost(
    input: {jobPostId: $jobPostId, hired: $hired, applicationId: $applicationId}
  ) {
    currentUser {
      id
      jobPostings {
        id
        status
        title
        postedAt
        updatedAt
      }
    }
  }
}
    `;
export type CloseJobPostMutationFn = Apollo.MutationFunction<CloseJobPostMutation, CloseJobPostMutationVariables>;

/**
 * __useCloseJobPostMutation__
 *
 * To run a mutation, you first call `useCloseJobPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloseJobPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [closeJobPostMutation, { data, loading, error }] = useCloseJobPostMutation({
 *   variables: {
 *      jobPostId: // value for 'jobPostId'
 *      hired: // value for 'hired'
 *      applicationId: // value for 'applicationId'
 *   },
 * });
 */
export function useCloseJobPostMutation(baseOptions?: Apollo.MutationHookOptions<CloseJobPostMutation, CloseJobPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloseJobPostMutation, CloseJobPostMutationVariables>(CloseJobPostDocument, options);
      }
export type CloseJobPostMutationHookResult = ReturnType<typeof useCloseJobPostMutation>;
export type CloseJobPostMutationResult = Apollo.MutationResult<CloseJobPostMutation>;
export type CloseJobPostMutationOptions = Apollo.BaseMutationOptions<CloseJobPostMutation, CloseJobPostMutationVariables>;
export const CreateAdLeadDocument = gql`
    mutation CreateAdLead($adId: ID!, $requestedTicker: String, $tickerOnPage: String, $pageType: String) {
  createAdLead(
    input: {adId: $adId, requestedTicker: $requestedTicker, tickerOnPage: $tickerOnPage, pageType: $pageType}
  ) {
    partnerOffer {
      ...PartnerOfferFragment
    }
  }
}
    ${PartnerOfferFragmentFragmentDoc}`;
export type CreateAdLeadMutationFn = Apollo.MutationFunction<CreateAdLeadMutation, CreateAdLeadMutationVariables>;

/**
 * __useCreateAdLeadMutation__
 *
 * To run a mutation, you first call `useCreateAdLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdLeadMutation, { data, loading, error }] = useCreateAdLeadMutation({
 *   variables: {
 *      adId: // value for 'adId'
 *      requestedTicker: // value for 'requestedTicker'
 *      tickerOnPage: // value for 'tickerOnPage'
 *      pageType: // value for 'pageType'
 *   },
 * });
 */
export function useCreateAdLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdLeadMutation, CreateAdLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdLeadMutation, CreateAdLeadMutationVariables>(CreateAdLeadDocument, options);
      }
export type CreateAdLeadMutationHookResult = ReturnType<typeof useCreateAdLeadMutation>;
export type CreateAdLeadMutationResult = Apollo.MutationResult<CreateAdLeadMutation>;
export type CreateAdLeadMutationOptions = Apollo.BaseMutationOptions<CreateAdLeadMutation, CreateAdLeadMutationVariables>;
export const CreateBlocklistEntryDocument = gql`
    mutation createBlocklistEntry($allocatorProfileId: ID!, $employerProfileId: ID!) {
  createAllocatorBlocklistEntry(
    input: {allocatorProfileId: $allocatorProfileId, employerProfileId: $employerProfileId}
  ) {
    newBlocklistEntry {
      id
      allocatorProfile {
        id
      }
    }
  }
}
    `;
export type CreateBlocklistEntryMutationFn = Apollo.MutationFunction<CreateBlocklistEntryMutation, CreateBlocklistEntryMutationVariables>;

/**
 * __useCreateBlocklistEntryMutation__
 *
 * To run a mutation, you first call `useCreateBlocklistEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBlocklistEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBlocklistEntryMutation, { data, loading, error }] = useCreateBlocklistEntryMutation({
 *   variables: {
 *      allocatorProfileId: // value for 'allocatorProfileId'
 *      employerProfileId: // value for 'employerProfileId'
 *   },
 * });
 */
export function useCreateBlocklistEntryMutation(baseOptions?: Apollo.MutationHookOptions<CreateBlocklistEntryMutation, CreateBlocklistEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBlocklistEntryMutation, CreateBlocklistEntryMutationVariables>(CreateBlocklistEntryDocument, options);
      }
export type CreateBlocklistEntryMutationHookResult = ReturnType<typeof useCreateBlocklistEntryMutation>;
export type CreateBlocklistEntryMutationResult = Apollo.MutationResult<CreateBlocklistEntryMutation>;
export type CreateBlocklistEntryMutationOptions = Apollo.BaseMutationOptions<CreateBlocklistEntryMutation, CreateBlocklistEntryMutationVariables>;
export const CreateAuditRecordDocument = gql`
    mutation CreateAuditRecord($auditableId: ID!, $auditableType: String!, $action: String!, $parentId: ID, $parentType: String) {
  createAuditRecord(
    input: {auditableId: $auditableId, auditableType: $auditableType, action: $action, parentId: $parentId, parentType: $parentType}
  ) {
    success
  }
}
    `;
export type CreateAuditRecordMutationFn = Apollo.MutationFunction<CreateAuditRecordMutation, CreateAuditRecordMutationVariables>;

/**
 * __useCreateAuditRecordMutation__
 *
 * To run a mutation, you first call `useCreateAuditRecordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAuditRecordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAuditRecordMutation, { data, loading, error }] = useCreateAuditRecordMutation({
 *   variables: {
 *      auditableId: // value for 'auditableId'
 *      auditableType: // value for 'auditableType'
 *      action: // value for 'action'
 *      parentId: // value for 'parentId'
 *      parentType: // value for 'parentType'
 *   },
 * });
 */
export function useCreateAuditRecordMutation(baseOptions?: Apollo.MutationHookOptions<CreateAuditRecordMutation, CreateAuditRecordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAuditRecordMutation, CreateAuditRecordMutationVariables>(CreateAuditRecordDocument, options);
      }
export type CreateAuditRecordMutationHookResult = ReturnType<typeof useCreateAuditRecordMutation>;
export type CreateAuditRecordMutationResult = Apollo.MutationResult<CreateAuditRecordMutation>;
export type CreateAuditRecordMutationOptions = Apollo.BaseMutationOptions<CreateAuditRecordMutation, CreateAuditRecordMutationVariables>;
export const CreateChatMessageDocument = gql`
    mutation CreateChatMessage($anonymous: Boolean!, $body: String!, $chatId: ID!) {
  createChatMessage(input: {anonymous: $anonymous, body: $body, chatId: $chatId}) {
    chatMessage {
      ...ChatMessage
    }
  }
}
    ${ChatMessageFragmentDoc}`;
export type CreateChatMessageMutationFn = Apollo.MutationFunction<CreateChatMessageMutation, CreateChatMessageMutationVariables>;

/**
 * __useCreateChatMessageMutation__
 *
 * To run a mutation, you first call `useCreateChatMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMessageMutation, { data, loading, error }] = useCreateChatMessageMutation({
 *   variables: {
 *      anonymous: // value for 'anonymous'
 *      body: // value for 'body'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useCreateChatMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMessageMutation, CreateChatMessageMutationVariables>(CreateChatMessageDocument, options);
      }
export type CreateChatMessageMutationHookResult = ReturnType<typeof useCreateChatMessageMutation>;
export type CreateChatMessageMutationResult = Apollo.MutationResult<CreateChatMessageMutation>;
export type CreateChatMessageMutationOptions = Apollo.BaseMutationOptions<CreateChatMessageMutation, CreateChatMessageMutationVariables>;
export const CreateCommentDocument = gql`
    mutation CreateComment($feedItemId: ID!, $body: String, $anonymous: Boolean) {
  createComment(
    input: {feedItemId: $feedItemId, body: $body, anonymous: $anonymous}
  ) {
    comment {
      ...ActivityFeedComment
    }
  }
}
    ${ActivityFeedCommentFragmentDoc}`;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      feedItemId: // value for 'feedItemId'
 *      body: // value for 'body'
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateEventImpressionDocument = gql`
    mutation CreateEventImpression($eventId: ID!, $elapsedTime: Int, $index: Int, $sessionId: String, $source: String) {
  createEventImpression(
    input: {eventId: $eventId, elapsedTime: $elapsedTime, index: $index, sessionId: $sessionId, source: $source}
  ) {
    event {
      id
    }
  }
}
    `;
export type CreateEventImpressionMutationFn = Apollo.MutationFunction<CreateEventImpressionMutation, CreateEventImpressionMutationVariables>;

/**
 * __useCreateEventImpressionMutation__
 *
 * To run a mutation, you first call `useCreateEventImpressionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEventImpressionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEventImpressionMutation, { data, loading, error }] = useCreateEventImpressionMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      elapsedTime: // value for 'elapsedTime'
 *      index: // value for 'index'
 *      sessionId: // value for 'sessionId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useCreateEventImpressionMutation(baseOptions?: Apollo.MutationHookOptions<CreateEventImpressionMutation, CreateEventImpressionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEventImpressionMutation, CreateEventImpressionMutationVariables>(CreateEventImpressionDocument, options);
      }
export type CreateEventImpressionMutationHookResult = ReturnType<typeof useCreateEventImpressionMutation>;
export type CreateEventImpressionMutationResult = Apollo.MutationResult<CreateEventImpressionMutation>;
export type CreateEventImpressionMutationOptions = Apollo.BaseMutationOptions<CreateEventImpressionMutation, CreateEventImpressionMutationVariables>;
export const CreateFundProfileDocument = gql`
    mutation CreateFundProfile($employerId: ID!) {
  createFundProfile(input: {employerId: $employerId}) {
    success
  }
}
    `;
export type CreateFundProfileMutationFn = Apollo.MutationFunction<CreateFundProfileMutation, CreateFundProfileMutationVariables>;

/**
 * __useCreateFundProfileMutation__
 *
 * To run a mutation, you first call `useCreateFundProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFundProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFundProfileMutation, { data, loading, error }] = useCreateFundProfileMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useCreateFundProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateFundProfileMutation, CreateFundProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFundProfileMutation, CreateFundProfileMutationVariables>(CreateFundProfileDocument, options);
      }
export type CreateFundProfileMutationHookResult = ReturnType<typeof useCreateFundProfileMutation>;
export type CreateFundProfileMutationResult = Apollo.MutationResult<CreateFundProfileMutation>;
export type CreateFundProfileMutationOptions = Apollo.BaseMutationOptions<CreateFundProfileMutation, CreateFundProfileMutationVariables>;
export const CreateFundProfileMessageDocument = gql`
    mutation CreateFundProfileMessage($employerProfileId: ID!, $body: String!) {
  createFundProfileMessage(
    input: {employerProfileId: $employerProfileId, body: $body}
  ) {
    success
  }
}
    `;
export type CreateFundProfileMessageMutationFn = Apollo.MutationFunction<CreateFundProfileMessageMutation, CreateFundProfileMessageMutationVariables>;

/**
 * __useCreateFundProfileMessageMutation__
 *
 * To run a mutation, you first call `useCreateFundProfileMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFundProfileMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFundProfileMessageMutation, { data, loading, error }] = useCreateFundProfileMessageMutation({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateFundProfileMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateFundProfileMessageMutation, CreateFundProfileMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFundProfileMessageMutation, CreateFundProfileMessageMutationVariables>(CreateFundProfileMessageDocument, options);
      }
export type CreateFundProfileMessageMutationHookResult = ReturnType<typeof useCreateFundProfileMessageMutation>;
export type CreateFundProfileMessageMutationResult = Apollo.MutationResult<CreateFundProfileMessageMutation>;
export type CreateFundProfileMessageMutationOptions = Apollo.BaseMutationOptions<CreateFundProfileMessageMutation, CreateFundProfileMessageMutationVariables>;
export const CreateFundProfileSearchAlertDocument = gql`
    mutation CreateFundProfileSearchAlert($query: String!, $active: Boolean, $name: String) {
  createEmployerProfileSearchAlert(
    input: {query: $query, active: $active, name: $name}
  ) {
    searchAlert {
      ...FundProfileSavedSearch
    }
  }
}
    ${FundProfileSavedSearchFragmentDoc}`;
export type CreateFundProfileSearchAlertMutationFn = Apollo.MutationFunction<CreateFundProfileSearchAlertMutation, CreateFundProfileSearchAlertMutationVariables>;

/**
 * __useCreateFundProfileSearchAlertMutation__
 *
 * To run a mutation, you first call `useCreateFundProfileSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFundProfileSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFundProfileSearchAlertMutation, { data, loading, error }] = useCreateFundProfileSearchAlertMutation({
 *   variables: {
 *      query: // value for 'query'
 *      active: // value for 'active'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateFundProfileSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateFundProfileSearchAlertMutation, CreateFundProfileSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFundProfileSearchAlertMutation, CreateFundProfileSearchAlertMutationVariables>(CreateFundProfileSearchAlertDocument, options);
      }
export type CreateFundProfileSearchAlertMutationHookResult = ReturnType<typeof useCreateFundProfileSearchAlertMutation>;
export type CreateFundProfileSearchAlertMutationResult = Apollo.MutationResult<CreateFundProfileSearchAlertMutation>;
export type CreateFundProfileSearchAlertMutationOptions = Apollo.BaseMutationOptions<CreateFundProfileSearchAlertMutation, CreateFundProfileSearchAlertMutationVariables>;
export const CreateIdeaCommentDocument = gql`
    mutation CreateIdeaComment($body: String, $ideaId: ID!, $parentId: ID, $anonymous: Boolean, $response: Boolean, $files: String, $controlName: Boolean) {
  createComment(
    input: {body: $body, ideaId: $ideaId, parentId: $parentId, anonymous: $anonymous, requestResponse: $response, files: $files}
  ) {
    comment {
      ...IdeaShowPageComment
    }
  }
}
    ${IdeaShowPageCommentFragmentDoc}`;
export type CreateIdeaCommentMutationFn = Apollo.MutationFunction<CreateIdeaCommentMutation, CreateIdeaCommentMutationVariables>;

/**
 * __useCreateIdeaCommentMutation__
 *
 * To run a mutation, you first call `useCreateIdeaCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdeaCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdeaCommentMutation, { data, loading, error }] = useCreateIdeaCommentMutation({
 *   variables: {
 *      body: // value for 'body'
 *      ideaId: // value for 'ideaId'
 *      parentId: // value for 'parentId'
 *      anonymous: // value for 'anonymous'
 *      response: // value for 'response'
 *      files: // value for 'files'
 *      controlName: // value for 'controlName'
 *   },
 * });
 */
export function useCreateIdeaCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdeaCommentMutation, CreateIdeaCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdeaCommentMutation, CreateIdeaCommentMutationVariables>(CreateIdeaCommentDocument, options);
      }
export type CreateIdeaCommentMutationHookResult = ReturnType<typeof useCreateIdeaCommentMutation>;
export type CreateIdeaCommentMutationResult = Apollo.MutationResult<CreateIdeaCommentMutation>;
export type CreateIdeaCommentMutationOptions = Apollo.BaseMutationOptions<CreateIdeaCommentMutation, CreateIdeaCommentMutationVariables>;
export const CreateIdeaSearchAlertDocument = gql`
    mutation CreateIdeaSearchAlert($query: String!, $active: Boolean, $name: String) {
  createIdeaSearchAlert(input: {query: $query, active: $active, name: $name}) {
    searchAlert {
      ...IdeaSavedSearch
    }
  }
}
    ${IdeaSavedSearchFragmentDoc}`;
export type CreateIdeaSearchAlertMutationFn = Apollo.MutationFunction<CreateIdeaSearchAlertMutation, CreateIdeaSearchAlertMutationVariables>;

/**
 * __useCreateIdeaSearchAlertMutation__
 *
 * To run a mutation, you first call `useCreateIdeaSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdeaSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdeaSearchAlertMutation, { data, loading, error }] = useCreateIdeaSearchAlertMutation({
 *   variables: {
 *      query: // value for 'query'
 *      active: // value for 'active'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useCreateIdeaSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdeaSearchAlertMutation, CreateIdeaSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdeaSearchAlertMutation, CreateIdeaSearchAlertMutationVariables>(CreateIdeaSearchAlertDocument, options);
      }
export type CreateIdeaSearchAlertMutationHookResult = ReturnType<typeof useCreateIdeaSearchAlertMutation>;
export type CreateIdeaSearchAlertMutationResult = Apollo.MutationResult<CreateIdeaSearchAlertMutation>;
export type CreateIdeaSearchAlertMutationOptions = Apollo.BaseMutationOptions<CreateIdeaSearchAlertMutation, CreateIdeaSearchAlertMutationVariables>;
export const CreateIdeaUpdateCommentDocument = gql`
    mutation CreateIdeaUpdateComment($anonymous: Boolean, $body: String, $ideaUpdateId: ID!, $requestResponse: Boolean, $files: String, $parentId: ID, $controlName: Boolean) {
  createComment(
    input: {body: $body, ideaUpdateId: $ideaUpdateId, anonymous: $anonymous, requestResponse: $requestResponse, files: $files, parentId: $parentId}
  ) {
    comment {
      ...IdeaShowPageComment
    }
  }
}
    ${IdeaShowPageCommentFragmentDoc}`;
export type CreateIdeaUpdateCommentMutationFn = Apollo.MutationFunction<CreateIdeaUpdateCommentMutation, CreateIdeaUpdateCommentMutationVariables>;

/**
 * __useCreateIdeaUpdateCommentMutation__
 *
 * To run a mutation, you first call `useCreateIdeaUpdateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIdeaUpdateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIdeaUpdateCommentMutation, { data, loading, error }] = useCreateIdeaUpdateCommentMutation({
 *   variables: {
 *      anonymous: // value for 'anonymous'
 *      body: // value for 'body'
 *      ideaUpdateId: // value for 'ideaUpdateId'
 *      requestResponse: // value for 'requestResponse'
 *      files: // value for 'files'
 *      parentId: // value for 'parentId'
 *      controlName: // value for 'controlName'
 *   },
 * });
 */
export function useCreateIdeaUpdateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateIdeaUpdateCommentMutation, CreateIdeaUpdateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIdeaUpdateCommentMutation, CreateIdeaUpdateCommentMutationVariables>(CreateIdeaUpdateCommentDocument, options);
      }
export type CreateIdeaUpdateCommentMutationHookResult = ReturnType<typeof useCreateIdeaUpdateCommentMutation>;
export type CreateIdeaUpdateCommentMutationResult = Apollo.MutationResult<CreateIdeaUpdateCommentMutation>;
export type CreateIdeaUpdateCommentMutationOptions = Apollo.BaseMutationOptions<CreateIdeaUpdateCommentMutation, CreateIdeaUpdateCommentMutationVariables>;
export const CreateIntroRequestDocument = gql`
    mutation CreateIntroRequest($allocatorProfileId: ID!, $fundProfileId: ID!, $message: String) {
  createIntroRequest(
    input: {allocatorProfileId: $allocatorProfileId, fundProfileId: $fundProfileId, message: $message}
  ) {
    currentUser {
      id
    }
    fundProfile {
      id
      introRequestsLeft
      alreadyRequestedIntro(allocatorProfileId: $allocatorProfileId)
    }
  }
}
    `;
export type CreateIntroRequestMutationFn = Apollo.MutationFunction<CreateIntroRequestMutation, CreateIntroRequestMutationVariables>;

/**
 * __useCreateIntroRequestMutation__
 *
 * To run a mutation, you first call `useCreateIntroRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntroRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntroRequestMutation, { data, loading, error }] = useCreateIntroRequestMutation({
 *   variables: {
 *      allocatorProfileId: // value for 'allocatorProfileId'
 *      fundProfileId: // value for 'fundProfileId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useCreateIntroRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntroRequestMutation, CreateIntroRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntroRequestMutation, CreateIntroRequestMutationVariables>(CreateIntroRequestDocument, options);
      }
export type CreateIntroRequestMutationHookResult = ReturnType<typeof useCreateIntroRequestMutation>;
export type CreateIntroRequestMutationResult = Apollo.MutationResult<CreateIntroRequestMutation>;
export type CreateIntroRequestMutationOptions = Apollo.BaseMutationOptions<CreateIntroRequestMutation, CreateIntroRequestMutationVariables>;
export const CreateJobApplicationDocument = gql`
    mutation CreateJobApplication($jobPostId: ID!, $phone: String!, $email: String!, $coverLetter: String) {
  createJobApplication(
    input: {jobPostId: $jobPostId, phone: $phone, email: $email, coverLetter: $coverLetter}
  ) {
    success
  }
}
    `;
export type CreateJobApplicationMutationFn = Apollo.MutationFunction<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;

/**
 * __useCreateJobApplicationMutation__
 *
 * To run a mutation, you first call `useCreateJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobApplicationMutation, { data, loading, error }] = useCreateJobApplicationMutation({
 *   variables: {
 *      jobPostId: // value for 'jobPostId'
 *      phone: // value for 'phone'
 *      email: // value for 'email'
 *      coverLetter: // value for 'coverLetter'
 *   },
 * });
 */
export function useCreateJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>(CreateJobApplicationDocument, options);
      }
export type CreateJobApplicationMutationHookResult = ReturnType<typeof useCreateJobApplicationMutation>;
export type CreateJobApplicationMutationResult = Apollo.MutationResult<CreateJobApplicationMutation>;
export type CreateJobApplicationMutationOptions = Apollo.BaseMutationOptions<CreateJobApplicationMutation, CreateJobApplicationMutationVariables>;
export const CreateJobPostingDocument = gql`
    mutation CreateJobPosting($aum: Int!, $fund_type: String!, $strategy: String!, $employer_city: String!, $employer_description: String!, $asset_class_names: [String!], $sector_names: [String!], $geography_names: [String!], $title: String!, $description: String!, $years_of_experience: String!, $minimum_gpa: String, $minimum_sat: Int, $use_company_investment_mandate: Boolean!, $max_gpa: String!, $max_sat: String!, $act_score: Int, $cover_letter: String!, $position_city: String!, $firm_experience: [String!], $degrees_and_certifications: [String!], $position_asset_class_names: [String!], $position_sector_names: [String!], $position_geography_names: [String!]) {
  createJobPosting(
    input: {aum: $aum, fundType: $fund_type, strategy: $strategy, employerCity: $employer_city, employerDescription: $employer_description, assetClassNames: $asset_class_names, sectorNames: $sector_names, geographyNames: $geography_names, title: $title, description: $description, yearsOfExperience: $years_of_experience, minimumGpa: $minimum_gpa, minimumSat: $minimum_sat, useCompanyInvestmentMandate: $use_company_investment_mandate, maxGpa: $max_gpa, maxSat: $max_sat, actScore: $act_score, coverLetter: $cover_letter, positionCity: $position_city, firmExperience: $firm_experience, degreesAndCertifications: $degrees_and_certifications, positionAssetClassNames: $position_asset_class_names, positionSectorNames: $position_sector_names, positionGeographyNames: $position_geography_names}
  ) {
    jobPost {
      id
      isActive
    }
  }
}
    `;
export type CreateJobPostingMutationFn = Apollo.MutationFunction<CreateJobPostingMutation, CreateJobPostingMutationVariables>;

/**
 * __useCreateJobPostingMutation__
 *
 * To run a mutation, you first call `useCreateJobPostingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobPostingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobPostingMutation, { data, loading, error }] = useCreateJobPostingMutation({
 *   variables: {
 *      aum: // value for 'aum'
 *      fund_type: // value for 'fund_type'
 *      strategy: // value for 'strategy'
 *      employer_city: // value for 'employer_city'
 *      employer_description: // value for 'employer_description'
 *      asset_class_names: // value for 'asset_class_names'
 *      sector_names: // value for 'sector_names'
 *      geography_names: // value for 'geography_names'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *      years_of_experience: // value for 'years_of_experience'
 *      minimum_gpa: // value for 'minimum_gpa'
 *      minimum_sat: // value for 'minimum_sat'
 *      use_company_investment_mandate: // value for 'use_company_investment_mandate'
 *      max_gpa: // value for 'max_gpa'
 *      max_sat: // value for 'max_sat'
 *      act_score: // value for 'act_score'
 *      cover_letter: // value for 'cover_letter'
 *      position_city: // value for 'position_city'
 *      firm_experience: // value for 'firm_experience'
 *      degrees_and_certifications: // value for 'degrees_and_certifications'
 *      position_asset_class_names: // value for 'position_asset_class_names'
 *      position_sector_names: // value for 'position_sector_names'
 *      position_geography_names: // value for 'position_geography_names'
 *   },
 * });
 */
export function useCreateJobPostingMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobPostingMutation, CreateJobPostingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobPostingMutation, CreateJobPostingMutationVariables>(CreateJobPostingDocument, options);
      }
export type CreateJobPostingMutationHookResult = ReturnType<typeof useCreateJobPostingMutation>;
export type CreateJobPostingMutationResult = Apollo.MutationResult<CreateJobPostingMutation>;
export type CreateJobPostingMutationOptions = Apollo.BaseMutationOptions<CreateJobPostingMutation, CreateJobPostingMutationVariables>;
export const CreateLeadDocument = gql`
    mutation CreateLead($firstName: String, $lastName: String, $email: String!, $firmName: String) {
  createLead(
    input: {firstName: $firstName, lastName: $lastName, email: $email, firmName: $firmName}
  ) {
    message
  }
}
    `;
export type CreateLeadMutationFn = Apollo.MutationFunction<CreateLeadMutation, CreateLeadMutationVariables>;

/**
 * __useCreateLeadMutation__
 *
 * To run a mutation, you first call `useCreateLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createLeadMutation, { data, loading, error }] = useCreateLeadMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      firmName: // value for 'firmName'
 *   },
 * });
 */
export function useCreateLeadMutation(baseOptions?: Apollo.MutationHookOptions<CreateLeadMutation, CreateLeadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument, options);
      }
export type CreateLeadMutationHookResult = ReturnType<typeof useCreateLeadMutation>;
export type CreateLeadMutationResult = Apollo.MutationResult<CreateLeadMutation>;
export type CreateLeadMutationOptions = Apollo.BaseMutationOptions<CreateLeadMutation, CreateLeadMutationVariables>;
export const CreateMessageDocument = gql`
    mutation CreateMessage($body: String!, $receiverUserId: ID!, $subject: String, $thread: ID, $files: String) {
  createMessage(
    input: {body: $body, receiverUserId: $receiverUserId, subject: $subject, thread: $thread, files: $files}
  ) {
    id
  }
}
    `;
export type CreateMessageMutationFn = Apollo.MutationFunction<CreateMessageMutation, CreateMessageMutationVariables>;

/**
 * __useCreateMessageMutation__
 *
 * To run a mutation, you first call `useCreateMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageMutation, { data, loading, error }] = useCreateMessageMutation({
 *   variables: {
 *      body: // value for 'body'
 *      receiverUserId: // value for 'receiverUserId'
 *      subject: // value for 'subject'
 *      thread: // value for 'thread'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateMessageMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageMutation, CreateMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageMutation, CreateMessageMutationVariables>(CreateMessageDocument, options);
      }
export type CreateMessageMutationHookResult = ReturnType<typeof useCreateMessageMutation>;
export type CreateMessageMutationResult = Apollo.MutationResult<CreateMessageMutation>;
export type CreateMessageMutationOptions = Apollo.BaseMutationOptions<CreateMessageMutation, CreateMessageMutationVariables>;
export const CreateMessageForThreadDocument = gql`
    mutation CreateMessageForThread($body: String!, $subject: String, $thread: ID!, $files: String) {
  createMessageForThread(
    input: {body: $body, subject: $subject, thread: $thread, files: $files}
  ) {
    createdMessage {
      ...MessageThreadItem
    }
  }
}
    ${MessageThreadItemFragmentDoc}`;
export type CreateMessageForThreadMutationFn = Apollo.MutationFunction<CreateMessageForThreadMutation, CreateMessageForThreadMutationVariables>;

/**
 * __useCreateMessageForThreadMutation__
 *
 * To run a mutation, you first call `useCreateMessageForThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageForThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageForThreadMutation, { data, loading, error }] = useCreateMessageForThreadMutation({
 *   variables: {
 *      body: // value for 'body'
 *      subject: // value for 'subject'
 *      thread: // value for 'thread'
 *      files: // value for 'files'
 *   },
 * });
 */
export function useCreateMessageForThreadMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageForThreadMutation, CreateMessageForThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageForThreadMutation, CreateMessageForThreadMutationVariables>(CreateMessageForThreadDocument, options);
      }
export type CreateMessageForThreadMutationHookResult = ReturnType<typeof useCreateMessageForThreadMutation>;
export type CreateMessageForThreadMutationResult = Apollo.MutationResult<CreateMessageForThreadMutation>;
export type CreateMessageForThreadMutationOptions = Apollo.BaseMutationOptions<CreateMessageForThreadMutation, CreateMessageForThreadMutationVariables>;
export const CreateOrEditIdeaUpdateDocument = gql`
    mutation CreateOrEditIdeaUpdate($ideaId: ID!, $ideaUpdateId: ID, $attachments: [ResearchAttachmentAttributes!], $body: String, $catalysts: [String!], $closeIdea: Boolean!, $impact: String, $priceTarget: String, $returnTarget: String, $situation: String, $targetAllocation: String, $timeframe: String) {
  createOrEditIdeaUpdate(
    input: {ideaId: $ideaId, ideaUpdateId: $ideaUpdateId, attachments: $attachments, body: $body, catalysts: $catalysts, closeIdea: $closeIdea, impact: $impact, priceTarget: $priceTarget, returnTarget: $returnTarget, situation: $situation, targetAllocation: $targetAllocation, timeframe: $timeframe}
  ) {
    ideaUpdate {
      ...IdeaUpdates
    }
  }
}
    ${IdeaUpdatesFragmentDoc}`;
export type CreateOrEditIdeaUpdateMutationFn = Apollo.MutationFunction<CreateOrEditIdeaUpdateMutation, CreateOrEditIdeaUpdateMutationVariables>;

/**
 * __useCreateOrEditIdeaUpdateMutation__
 *
 * To run a mutation, you first call `useCreateOrEditIdeaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrEditIdeaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrEditIdeaUpdateMutation, { data, loading, error }] = useCreateOrEditIdeaUpdateMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *      ideaUpdateId: // value for 'ideaUpdateId'
 *      attachments: // value for 'attachments'
 *      body: // value for 'body'
 *      catalysts: // value for 'catalysts'
 *      closeIdea: // value for 'closeIdea'
 *      impact: // value for 'impact'
 *      priceTarget: // value for 'priceTarget'
 *      returnTarget: // value for 'returnTarget'
 *      situation: // value for 'situation'
 *      targetAllocation: // value for 'targetAllocation'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useCreateOrEditIdeaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrEditIdeaUpdateMutation, CreateOrEditIdeaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrEditIdeaUpdateMutation, CreateOrEditIdeaUpdateMutationVariables>(CreateOrEditIdeaUpdateDocument, options);
      }
export type CreateOrEditIdeaUpdateMutationHookResult = ReturnType<typeof useCreateOrEditIdeaUpdateMutation>;
export type CreateOrEditIdeaUpdateMutationResult = Apollo.MutationResult<CreateOrEditIdeaUpdateMutation>;
export type CreateOrEditIdeaUpdateMutationOptions = Apollo.BaseMutationOptions<CreateOrEditIdeaUpdateMutation, CreateOrEditIdeaUpdateMutationVariables>;
export const CreateOrUpdateAccreditedInvestorProfileDocument = gql`
    mutation CreateOrUpdateAccreditedInvestorProfile($userId: ID!, $netWorth: String, $next12MoAllocation: String, $investmentSize: String, $yearsInvesting: String, $bonds: String, $hedgeFunds: String, $realEstate: String, $foreignCurrencies: String, $futuresOrCommodities: String, $privateEquityFunds: String, $publiclyTradedStocks: String, $privateCompanies: String, $netWorthReq: Boolean, $incomeReq: Boolean) {
  createOrUpdateAccreditedInvestorProfile(
    input: {userId: $userId, netWorth: $netWorth, next12MoAllocation: $next12MoAllocation, investmentSize: $investmentSize, yearsInvesting: $yearsInvesting, bonds: $bonds, hedgeFunds: $hedgeFunds, realEstate: $realEstate, foreignCurrencies: $foreignCurrencies, futuresOrCommodities: $futuresOrCommodities, privateEquityFunds: $privateEquityFunds, publiclyTradedStocks: $publiclyTradedStocks, privateCompanies: $privateCompanies, netWorthReq: $netWorthReq, incomeReq: $incomeReq}
  ) {
    accreditedInvestorProfile {
      id
      userId
      netWorth
      next12MoAllocation
      investmentSize
      yearsInvesting
      bonds
      hedgeFunds
      realEstate
      foreignCurrencies
      futuresOrCommodities
      privateEquityFunds
      publiclyTradedStocks
      privateCompanies
    }
    unaccredited
  }
}
    `;
export type CreateOrUpdateAccreditedInvestorProfileMutationFn = Apollo.MutationFunction<CreateOrUpdateAccreditedInvestorProfileMutation, CreateOrUpdateAccreditedInvestorProfileMutationVariables>;

/**
 * __useCreateOrUpdateAccreditedInvestorProfileMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateAccreditedInvestorProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateAccreditedInvestorProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateAccreditedInvestorProfileMutation, { data, loading, error }] = useCreateOrUpdateAccreditedInvestorProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      netWorth: // value for 'netWorth'
 *      next12MoAllocation: // value for 'next12MoAllocation'
 *      investmentSize: // value for 'investmentSize'
 *      yearsInvesting: // value for 'yearsInvesting'
 *      bonds: // value for 'bonds'
 *      hedgeFunds: // value for 'hedgeFunds'
 *      realEstate: // value for 'realEstate'
 *      foreignCurrencies: // value for 'foreignCurrencies'
 *      futuresOrCommodities: // value for 'futuresOrCommodities'
 *      privateEquityFunds: // value for 'privateEquityFunds'
 *      publiclyTradedStocks: // value for 'publiclyTradedStocks'
 *      privateCompanies: // value for 'privateCompanies'
 *      netWorthReq: // value for 'netWorthReq'
 *      incomeReq: // value for 'incomeReq'
 *   },
 * });
 */
export function useCreateOrUpdateAccreditedInvestorProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateAccreditedInvestorProfileMutation, CreateOrUpdateAccreditedInvestorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateAccreditedInvestorProfileMutation, CreateOrUpdateAccreditedInvestorProfileMutationVariables>(CreateOrUpdateAccreditedInvestorProfileDocument, options);
      }
export type CreateOrUpdateAccreditedInvestorProfileMutationHookResult = ReturnType<typeof useCreateOrUpdateAccreditedInvestorProfileMutation>;
export type CreateOrUpdateAccreditedInvestorProfileMutationResult = Apollo.MutationResult<CreateOrUpdateAccreditedInvestorProfileMutation>;
export type CreateOrUpdateAccreditedInvestorProfileMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateAccreditedInvestorProfileMutation, CreateOrUpdateAccreditedInvestorProfileMutationVariables>;
export const CreateOrUpdateCompanyQuestionDocument = gql`
    mutation CreateOrUpdateCompanyQuestion($id: ID, $questionType: String, $text: String, $name: String, $expirationMonths: Int, $answers: [String!]) {
  createOrUpdateCompanyQuestion(
    input: {id: $id, questionType: $questionType, text: $text, name: $name, expirationMonths: $expirationMonths, answerOptions: $answers}
  ) {
    companyQuestion {
      id
      ...CompanyQuestion
      answerOptions
    }
  }
}
    ${CompanyQuestionFragmentDoc}`;
export type CreateOrUpdateCompanyQuestionMutationFn = Apollo.MutationFunction<CreateOrUpdateCompanyQuestionMutation, CreateOrUpdateCompanyQuestionMutationVariables>;

/**
 * __useCreateOrUpdateCompanyQuestionMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCompanyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCompanyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCompanyQuestionMutation, { data, loading, error }] = useCreateOrUpdateCompanyQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      questionType: // value for 'questionType'
 *      text: // value for 'text'
 *      name: // value for 'name'
 *      expirationMonths: // value for 'expirationMonths'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useCreateOrUpdateCompanyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCompanyQuestionMutation, CreateOrUpdateCompanyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCompanyQuestionMutation, CreateOrUpdateCompanyQuestionMutationVariables>(CreateOrUpdateCompanyQuestionDocument, options);
      }
export type CreateOrUpdateCompanyQuestionMutationHookResult = ReturnType<typeof useCreateOrUpdateCompanyQuestionMutation>;
export type CreateOrUpdateCompanyQuestionMutationResult = Apollo.MutationResult<CreateOrUpdateCompanyQuestionMutation>;
export type CreateOrUpdateCompanyQuestionMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCompanyQuestionMutation, CreateOrUpdateCompanyQuestionMutationVariables>;
export const CreateOrUpdateCompensationDocument = gql`
    mutation CreateOrUpdateCompensation($id: ID, $status: String!, $category: String!, $year: Int!, $title: String, $experience: String, $industry: String, $location: String, $fundType: String, $fundStrategy: String, $fundSize: String, $assetClass: String, $baseSalary: Float, $interestMgmtFeesPerc: Float, $interestMgmtFeesValue: Float, $vestingMgmtFees: Int, $interestIncentiveFeesPerc: Float, $interestIncentiveFeesValue: Float, $vestingIncentiveFees: Int, $annualDiscrBonus: Float, $totalDeferredComp: Float, $investInFund: Boolean, $buildPersonalTrackRecord: Boolean, $marketPersonalTrackRecord: Boolean, $comments: String) {
  createOrUpdateCompensation(
    input: {id: $id, status: $status, category: $category, year: $year, title: $title, experience: $experience, industry: $industry, location: $location, fundType: $fundType, fundStrategy: $fundStrategy, fundSize: $fundSize, assetClass: $assetClass, baseSalary: $baseSalary, interestMgmtFeesPerc: $interestMgmtFeesPerc, interestMgmtFeesValue: $interestMgmtFeesValue, vestingMgmtFees: $vestingMgmtFees, interestIncentiveFeesPerc: $interestIncentiveFeesPerc, interestIncentiveFeesValue: $interestIncentiveFeesValue, vestingIncentiveFees: $vestingIncentiveFees, annualDiscrBonus: $annualDiscrBonus, totalDeferredComp: $totalDeferredComp, investInFund: $investInFund, buildPersonalTrackRecord: $buildPersonalTrackRecord, marketPersonalTrackRecord: $marketPersonalTrackRecord, comments: $comments}
  ) {
    compensation {
      ...CompensationFields
    }
    currentUser {
      id
      numDaysCompensationViewRemaining
    }
  }
}
    ${CompensationFieldsFragmentDoc}`;
export type CreateOrUpdateCompensationMutationFn = Apollo.MutationFunction<CreateOrUpdateCompensationMutation, CreateOrUpdateCompensationMutationVariables>;

/**
 * __useCreateOrUpdateCompensationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateCompensationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateCompensationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateCompensationMutation, { data, loading, error }] = useCreateOrUpdateCompensationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      category: // value for 'category'
 *      year: // value for 'year'
 *      title: // value for 'title'
 *      experience: // value for 'experience'
 *      industry: // value for 'industry'
 *      location: // value for 'location'
 *      fundType: // value for 'fundType'
 *      fundStrategy: // value for 'fundStrategy'
 *      fundSize: // value for 'fundSize'
 *      assetClass: // value for 'assetClass'
 *      baseSalary: // value for 'baseSalary'
 *      interestMgmtFeesPerc: // value for 'interestMgmtFeesPerc'
 *      interestMgmtFeesValue: // value for 'interestMgmtFeesValue'
 *      vestingMgmtFees: // value for 'vestingMgmtFees'
 *      interestIncentiveFeesPerc: // value for 'interestIncentiveFeesPerc'
 *      interestIncentiveFeesValue: // value for 'interestIncentiveFeesValue'
 *      vestingIncentiveFees: // value for 'vestingIncentiveFees'
 *      annualDiscrBonus: // value for 'annualDiscrBonus'
 *      totalDeferredComp: // value for 'totalDeferredComp'
 *      investInFund: // value for 'investInFund'
 *      buildPersonalTrackRecord: // value for 'buildPersonalTrackRecord'
 *      marketPersonalTrackRecord: // value for 'marketPersonalTrackRecord'
 *      comments: // value for 'comments'
 *   },
 * });
 */
export function useCreateOrUpdateCompensationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateCompensationMutation, CreateOrUpdateCompensationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateCompensationMutation, CreateOrUpdateCompensationMutationVariables>(CreateOrUpdateCompensationDocument, options);
      }
export type CreateOrUpdateCompensationMutationHookResult = ReturnType<typeof useCreateOrUpdateCompensationMutation>;
export type CreateOrUpdateCompensationMutationResult = Apollo.MutationResult<CreateOrUpdateCompensationMutation>;
export type CreateOrUpdateCompensationMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateCompensationMutation, CreateOrUpdateCompensationMutationVariables>;
export const CreateOrUpdateIdeaDocument = gql`
    mutation CreateOrUpdateIdea($ideaId: ID, $anonymous: Boolean!, $attachments: [ResearchAttachmentAttributes!]!, $catalystNames: [String!]!, $contests: [ID!]!, $currentStep: String!, $elevatorPitch: String!, $employerApprovalDisclaimer: Boolean!, $employerId: ID, $isSubmission: Boolean!, $mentionedEntities: [String!]!, $noPriorAgreementDisclaimer: Boolean!, $pairRatio: [Float!], $portfolioPercentage: String!, $positionDisclaimerFund: Boolean!, $positionDisclaimerIndividual: Boolean!, $positions: [PositionAttributes!]!, $fundProfileDisplay: Boolean!, $publicInformationDisclaimer: Boolean!, $returnTarget: Float, $situation: String!, $tagList: [String!]!, $thesis: String!, $timeframe: String!) {
  createOrUpdateIdea(
    input: {ideaId: $ideaId, anonymous: $anonymous, attachments: $attachments, catalystNames: $catalystNames, contests: $contests, currentStep: $currentStep, elevatorPitch: $elevatorPitch, employerApprovalDisclaimer: $employerApprovalDisclaimer, employerId: $employerId, isSubmission: $isSubmission, mentionedEntities: $mentionedEntities, noPriorAgreementDisclaimer: $noPriorAgreementDisclaimer, pairRatio: $pairRatio, portfolioPercentage: $portfolioPercentage, positionDisclaimerFund: $positionDisclaimerFund, positionDisclaimerIndividual: $positionDisclaimerIndividual, positions: $positions, fundProfileDisplay: $fundProfileDisplay, publicInformationDisclaimer: $publicInformationDisclaimer, returnTarget: $returnTarget, situation: $situation, tagList: $tagList, thesis: $thesis, timeframe: $timeframe}
  ) {
    idea {
      ...IdeaSubmissionDraft
    }
  }
}
    ${IdeaSubmissionDraftFragmentDoc}`;
export type CreateOrUpdateIdeaMutationFn = Apollo.MutationFunction<CreateOrUpdateIdeaMutation, CreateOrUpdateIdeaMutationVariables>;

/**
 * __useCreateOrUpdateIdeaMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateIdeaMutation, { data, loading, error }] = useCreateOrUpdateIdeaMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *      anonymous: // value for 'anonymous'
 *      attachments: // value for 'attachments'
 *      catalystNames: // value for 'catalystNames'
 *      contests: // value for 'contests'
 *      currentStep: // value for 'currentStep'
 *      elevatorPitch: // value for 'elevatorPitch'
 *      employerApprovalDisclaimer: // value for 'employerApprovalDisclaimer'
 *      employerId: // value for 'employerId'
 *      isSubmission: // value for 'isSubmission'
 *      mentionedEntities: // value for 'mentionedEntities'
 *      noPriorAgreementDisclaimer: // value for 'noPriorAgreementDisclaimer'
 *      pairRatio: // value for 'pairRatio'
 *      portfolioPercentage: // value for 'portfolioPercentage'
 *      positionDisclaimerFund: // value for 'positionDisclaimerFund'
 *      positionDisclaimerIndividual: // value for 'positionDisclaimerIndividual'
 *      positions: // value for 'positions'
 *      fundProfileDisplay: // value for 'fundProfileDisplay'
 *      publicInformationDisclaimer: // value for 'publicInformationDisclaimer'
 *      returnTarget: // value for 'returnTarget'
 *      situation: // value for 'situation'
 *      tagList: // value for 'tagList'
 *      thesis: // value for 'thesis'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useCreateOrUpdateIdeaMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateIdeaMutation, CreateOrUpdateIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateIdeaMutation, CreateOrUpdateIdeaMutationVariables>(CreateOrUpdateIdeaDocument, options);
      }
export type CreateOrUpdateIdeaMutationHookResult = ReturnType<typeof useCreateOrUpdateIdeaMutation>;
export type CreateOrUpdateIdeaMutationResult = Apollo.MutationResult<CreateOrUpdateIdeaMutation>;
export type CreateOrUpdateIdeaMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateIdeaMutation, CreateOrUpdateIdeaMutationVariables>;
export const CreateOrUpdateWhitePaperDocument = gql`
    mutation CreateOrUpdateWhitePaper($whitePaperId: ID, $attachments: [ResearchAttachmentAttributes!]!, $currentStep: String!, $elevatorPitch: String!, $employerId: ID, $esgs: [ID!]!, $fundProfileDisplay: Boolean!, $geographies: [ID!]!, $globalMacros: [ID!]!, $isSubmission: Boolean!, $mentionedEntities: [ID!]!, $positionDisclaimerFund: Boolean!, $positionDisclaimerIndividual: Boolean!, $sectors: [ID!]!, $tagList: [String!]!, $thesis: String!, $title: String!) {
  createOrUpdateWhitePaper(
    input: {whitePaperId: $whitePaperId, attachments: $attachments, currentStep: $currentStep, elevatorPitch: $elevatorPitch, employerId: $employerId, esgs: $esgs, fundProfileDisplay: $fundProfileDisplay, geographies: $geographies, globalMacros: $globalMacros, isSubmission: $isSubmission, mentionedEntities: $mentionedEntities, positionDisclaimerFund: $positionDisclaimerFund, positionDisclaimerIndividual: $positionDisclaimerIndividual, sectors: $sectors, tagList: $tagList, thesis: $thesis, title: $title}
  ) {
    whitePaper {
      ...WhitePaperSubmissionDraft
    }
  }
}
    ${WhitePaperSubmissionDraftFragmentDoc}`;
export type CreateOrUpdateWhitePaperMutationFn = Apollo.MutationFunction<CreateOrUpdateWhitePaperMutation, CreateOrUpdateWhitePaperMutationVariables>;

/**
 * __useCreateOrUpdateWhitePaperMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateWhitePaperMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateWhitePaperMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateWhitePaperMutation, { data, loading, error }] = useCreateOrUpdateWhitePaperMutation({
 *   variables: {
 *      whitePaperId: // value for 'whitePaperId'
 *      attachments: // value for 'attachments'
 *      currentStep: // value for 'currentStep'
 *      elevatorPitch: // value for 'elevatorPitch'
 *      employerId: // value for 'employerId'
 *      esgs: // value for 'esgs'
 *      fundProfileDisplay: // value for 'fundProfileDisplay'
 *      geographies: // value for 'geographies'
 *      globalMacros: // value for 'globalMacros'
 *      isSubmission: // value for 'isSubmission'
 *      mentionedEntities: // value for 'mentionedEntities'
 *      positionDisclaimerFund: // value for 'positionDisclaimerFund'
 *      positionDisclaimerIndividual: // value for 'positionDisclaimerIndividual'
 *      sectors: // value for 'sectors'
 *      tagList: // value for 'tagList'
 *      thesis: // value for 'thesis'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateOrUpdateWhitePaperMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateWhitePaperMutation, CreateOrUpdateWhitePaperMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateWhitePaperMutation, CreateOrUpdateWhitePaperMutationVariables>(CreateOrUpdateWhitePaperDocument, options);
      }
export type CreateOrUpdateWhitePaperMutationHookResult = ReturnType<typeof useCreateOrUpdateWhitePaperMutation>;
export type CreateOrUpdateWhitePaperMutationResult = Apollo.MutationResult<CreateOrUpdateWhitePaperMutation>;
export type CreateOrUpdateWhitePaperMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateWhitePaperMutation, CreateOrUpdateWhitePaperMutationVariables>;
export const CreatePostDocument = gql`
    mutation CreatePost($body: String!, $ogUrl: String, $postFiles: String, $asAdmin: Boolean, $tagList: String) {
  createPost(
    input: {body: $body, ogUrl: $ogUrl, postFiles: $postFiles, asAdmin: $asAdmin, tagList: $tagList}
  ) {
    feedItem {
      ...ActivityFeedItem
    }
    post {
      id
      body
      commentsCount
      domain
      eventId
      likeCount
      ogDescription
      ogUrl
      ogPreviewImageUrl
      ogTitle
      postedAt
      tagList
      untaggedBody
      user {
        id
        displayName
        featuredRank {
          id
          rankString
        }
        mostRecentEmployer {
          id
          currentEmployer
          employer {
            id
            aumRange
            fundType
            name
          }
          title
        }
        profile {
          id
          city
        }
        profileImageUrl
      }
    }
  }
}
    ${ActivityFeedItemFragmentDoc}`;
export type CreatePostMutationFn = Apollo.MutationFunction<CreatePostMutation, CreatePostMutationVariables>;

/**
 * __useCreatePostMutation__
 *
 * To run a mutation, you first call `useCreatePostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostMutation, { data, loading, error }] = useCreatePostMutation({
 *   variables: {
 *      body: // value for 'body'
 *      ogUrl: // value for 'ogUrl'
 *      postFiles: // value for 'postFiles'
 *      asAdmin: // value for 'asAdmin'
 *      tagList: // value for 'tagList'
 *   },
 * });
 */
export function useCreatePostMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostMutation, CreatePostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostMutation, CreatePostMutationVariables>(CreatePostDocument, options);
      }
export type CreatePostMutationHookResult = ReturnType<typeof useCreatePostMutation>;
export type CreatePostMutationResult = Apollo.MutationResult<CreatePostMutation>;
export type CreatePostMutationOptions = Apollo.BaseMutationOptions<CreatePostMutation, CreatePostMutationVariables>;
export const CreatePostCommentDocument = gql`
    mutation CreatePostComment($parentId: ID, $postId: ID!, $body: String, $anonymous: Boolean) {
  createComment(
    input: {parentId: $parentId, postId: $postId, body: $body, anonymous: $anonymous}
  ) {
    comment {
      id
      anonUser {
        id
        aumRange
        fundType
        title
      }
      anonymous
      body
      byAllocator
      createdAt
      commentableType
      commentCreationTime
      currentUserHasLiked
      likeCount
      parentId
      user {
        id
        displayName
        mostRecentEmployer {
          id
          currentEmployer
          employer {
            id
            name
            aumRange
            fundType
          }
          title
        }
        profileImageUrl
      }
    }
  }
}
    `;
export type CreatePostCommentMutationFn = Apollo.MutationFunction<CreatePostCommentMutation, CreatePostCommentMutationVariables>;

/**
 * __useCreatePostCommentMutation__
 *
 * To run a mutation, you first call `useCreatePostCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePostCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPostCommentMutation, { data, loading, error }] = useCreatePostCommentMutation({
 *   variables: {
 *      parentId: // value for 'parentId'
 *      postId: // value for 'postId'
 *      body: // value for 'body'
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */
export function useCreatePostCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePostCommentMutation, CreatePostCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePostCommentMutation, CreatePostCommentMutationVariables>(CreatePostCommentDocument, options);
      }
export type CreatePostCommentMutationHookResult = ReturnType<typeof useCreatePostCommentMutation>;
export type CreatePostCommentMutationResult = Apollo.MutationResult<CreatePostCommentMutation>;
export type CreatePostCommentMutationOptions = Apollo.BaseMutationOptions<CreatePostCommentMutation, CreatePostCommentMutationVariables>;
export const CreateQuickPositionDocument = gql`
    mutation CreateQuickPosition($assetId: ID!, $direction: String!, $anonymous: Boolean!) {
  createQuickPosition(
    input: {assetId: $assetId, direction: $direction, anonymous: $anonymous}
  ) {
    quickPosition {
      id
      asset {
        id
        longQuickPositionRatio
        shortQuickPositionRatio
      }
      direction
      openedAt
      openingPrice
    }
  }
}
    `;
export type CreateQuickPositionMutationFn = Apollo.MutationFunction<CreateQuickPositionMutation, CreateQuickPositionMutationVariables>;

/**
 * __useCreateQuickPositionMutation__
 *
 * To run a mutation, you first call `useCreateQuickPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuickPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuickPositionMutation, { data, loading, error }] = useCreateQuickPositionMutation({
 *   variables: {
 *      assetId: // value for 'assetId'
 *      direction: // value for 'direction'
 *      anonymous: // value for 'anonymous'
 *   },
 * });
 */
export function useCreateQuickPositionMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuickPositionMutation, CreateQuickPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuickPositionMutation, CreateQuickPositionMutationVariables>(CreateQuickPositionDocument, options);
      }
export type CreateQuickPositionMutationHookResult = ReturnType<typeof useCreateQuickPositionMutation>;
export type CreateQuickPositionMutationResult = Apollo.MutationResult<CreateQuickPositionMutation>;
export type CreateQuickPositionMutationOptions = Apollo.BaseMutationOptions<CreateQuickPositionMutation, CreateQuickPositionMutationVariables>;
export const CreateReadingListItemDocument = gql`
    mutation CreateReadingListItem($ideaId: ID) {
  createOrUpdateReadingListItem(input: {ideaId: $ideaId}) {
    currentUser {
      id
    }
    readingListItem {
      ...ReadingListItem
    }
  }
}
    ${ReadingListItemFragmentDoc}`;
export type CreateReadingListItemMutationFn = Apollo.MutationFunction<CreateReadingListItemMutation, CreateReadingListItemMutationVariables>;

/**
 * __useCreateReadingListItemMutation__
 *
 * To run a mutation, you first call `useCreateReadingListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReadingListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReadingListItemMutation, { data, loading, error }] = useCreateReadingListItemMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useCreateReadingListItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateReadingListItemMutation, CreateReadingListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReadingListItemMutation, CreateReadingListItemMutationVariables>(CreateReadingListItemDocument, options);
      }
export type CreateReadingListItemMutationHookResult = ReturnType<typeof useCreateReadingListItemMutation>;
export type CreateReadingListItemMutationResult = Apollo.MutationResult<CreateReadingListItemMutation>;
export type CreateReadingListItemMutationOptions = Apollo.BaseMutationOptions<CreateReadingListItemMutation, CreateReadingListItemMutationVariables>;
export const CreateThesisImageDocument = gql`
    mutation CreateThesisImage($imageableId: ID!, $image: String!, $type: String!) {
  createThesisImage(
    input: {imageableId: $imageableId, image: $image, type: $type}
  ) {
    thesisImageUrl
  }
}
    `;
export type CreateThesisImageMutationFn = Apollo.MutationFunction<CreateThesisImageMutation, CreateThesisImageMutationVariables>;

/**
 * __useCreateThesisImageMutation__
 *
 * To run a mutation, you first call `useCreateThesisImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateThesisImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createThesisImageMutation, { data, loading, error }] = useCreateThesisImageMutation({
 *   variables: {
 *      imageableId: // value for 'imageableId'
 *      image: // value for 'image'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateThesisImageMutation(baseOptions?: Apollo.MutationHookOptions<CreateThesisImageMutation, CreateThesisImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateThesisImageMutation, CreateThesisImageMutationVariables>(CreateThesisImageDocument, options);
      }
export type CreateThesisImageMutationHookResult = ReturnType<typeof useCreateThesisImageMutation>;
export type CreateThesisImageMutationResult = Apollo.MutationResult<CreateThesisImageMutation>;
export type CreateThesisImageMutationOptions = Apollo.BaseMutationOptions<CreateThesisImageMutation, CreateThesisImageMutationVariables>;
export const CreateTweetDocument = gql`
    mutation CreateTweet($tweetBody: String!) {
  createTweet(input: {tweetBody: $tweetBody}) {
    tweetUrl
  }
}
    `;
export type CreateTweetMutationFn = Apollo.MutationFunction<CreateTweetMutation, CreateTweetMutationVariables>;

/**
 * __useCreateTweetMutation__
 *
 * To run a mutation, you first call `useCreateTweetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTweetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTweetMutation, { data, loading, error }] = useCreateTweetMutation({
 *   variables: {
 *      tweetBody: // value for 'tweetBody'
 *   },
 * });
 */
export function useCreateTweetMutation(baseOptions?: Apollo.MutationHookOptions<CreateTweetMutation, CreateTweetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTweetMutation, CreateTweetMutationVariables>(CreateTweetDocument, options);
      }
export type CreateTweetMutationHookResult = ReturnType<typeof useCreateTweetMutation>;
export type CreateTweetMutationResult = Apollo.MutationResult<CreateTweetMutation>;
export type CreateTweetMutationOptions = Apollo.BaseMutationOptions<CreateTweetMutation, CreateTweetMutationVariables>;
export const CreateUserFeedbackDocument = gql`
    mutation CreateUserFeedback($rating: Int!, $comment: String, $prompt: String!) {
  createUserFeedback(input: {rating: $rating, comment: $comment, prompt: $prompt}) {
    userFeedback {
      id
      sentiment
    }
  }
}
    `;
export type CreateUserFeedbackMutationFn = Apollo.MutationFunction<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>;

/**
 * __useCreateUserFeedbackMutation__
 *
 * To run a mutation, you first call `useCreateUserFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserFeedbackMutation, { data, loading, error }] = useCreateUserFeedbackMutation({
 *   variables: {
 *      rating: // value for 'rating'
 *      comment: // value for 'comment'
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useCreateUserFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>(CreateUserFeedbackDocument, options);
      }
export type CreateUserFeedbackMutationHookResult = ReturnType<typeof useCreateUserFeedbackMutation>;
export type CreateUserFeedbackMutationResult = Apollo.MutationResult<CreateUserFeedbackMutation>;
export type CreateUserFeedbackMutationOptions = Apollo.BaseMutationOptions<CreateUserFeedbackMutation, CreateUserFeedbackMutationVariables>;
export const CreateViewerIntroRequestDocument = gql`
    mutation CreateViewerIntroRequest($viewerId: ID!, $viewableId: ID!, $viewableType: String!) {
  createViewerIntroRequest(
    input: {viewerId: $viewerId, viewableId: $viewableId, viewableType: $viewableType}
  ) {
    viewerIntroRequest {
      id
      author {
        id
      }
      status
      updatedAt
      viewableDisplayTitle
      viewableId
      viewableType
      viewer {
        id
        displayName
      }
    }
  }
}
    `;
export type CreateViewerIntroRequestMutationFn = Apollo.MutationFunction<CreateViewerIntroRequestMutation, CreateViewerIntroRequestMutationVariables>;

/**
 * __useCreateViewerIntroRequestMutation__
 *
 * To run a mutation, you first call `useCreateViewerIntroRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateViewerIntroRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createViewerIntroRequestMutation, { data, loading, error }] = useCreateViewerIntroRequestMutation({
 *   variables: {
 *      viewerId: // value for 'viewerId'
 *      viewableId: // value for 'viewableId'
 *      viewableType: // value for 'viewableType'
 *   },
 * });
 */
export function useCreateViewerIntroRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateViewerIntroRequestMutation, CreateViewerIntroRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateViewerIntroRequestMutation, CreateViewerIntroRequestMutationVariables>(CreateViewerIntroRequestDocument, options);
      }
export type CreateViewerIntroRequestMutationHookResult = ReturnType<typeof useCreateViewerIntroRequestMutation>;
export type CreateViewerIntroRequestMutationResult = Apollo.MutationResult<CreateViewerIntroRequestMutation>;
export type CreateViewerIntroRequestMutationOptions = Apollo.BaseMutationOptions<CreateViewerIntroRequestMutation, CreateViewerIntroRequestMutationVariables>;
export const CreateWhitePaperCommentDocument = gql`
    mutation CreateWhitePaperComment($body: String, $whitePaperId: ID!, $parentId: ID, $anonymous: Boolean, $hideFromFundAdmins: Boolean, $requestResponse: Boolean) {
  createComment(
    input: {body: $body, whitePaperId: $whitePaperId, parentId: $parentId, anonymous: $anonymous, hideFromFundAdmins: $hideFromFundAdmins, requestResponse: $requestResponse}
  ) {
    comment {
      id
      body
      createdAt
      responseRequested
      currentUserHasLiked
      parentId
      likeCount
      anonUser {
        id
        anonymousUserId
        aumRange
        isAllocator
        fundType
        title
        username
      }
      user {
        id
        anonymousUserId
        displayName
        mostRecentEmployer {
          id
          title
          employer {
            id
            name
            aumRange
            fundType
          }
          currentEmployer
        }
        profileImageUrl
      }
    }
  }
}
    `;
export type CreateWhitePaperCommentMutationFn = Apollo.MutationFunction<CreateWhitePaperCommentMutation, CreateWhitePaperCommentMutationVariables>;

/**
 * __useCreateWhitePaperCommentMutation__
 *
 * To run a mutation, you first call `useCreateWhitePaperCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWhitePaperCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWhitePaperCommentMutation, { data, loading, error }] = useCreateWhitePaperCommentMutation({
 *   variables: {
 *      body: // value for 'body'
 *      whitePaperId: // value for 'whitePaperId'
 *      parentId: // value for 'parentId'
 *      anonymous: // value for 'anonymous'
 *      hideFromFundAdmins: // value for 'hideFromFundAdmins'
 *      requestResponse: // value for 'requestResponse'
 *   },
 * });
 */
export function useCreateWhitePaperCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateWhitePaperCommentMutation, CreateWhitePaperCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWhitePaperCommentMutation, CreateWhitePaperCommentMutationVariables>(CreateWhitePaperCommentDocument, options);
      }
export type CreateWhitePaperCommentMutationHookResult = ReturnType<typeof useCreateWhitePaperCommentMutation>;
export type CreateWhitePaperCommentMutationResult = Apollo.MutationResult<CreateWhitePaperCommentMutation>;
export type CreateWhitePaperCommentMutationOptions = Apollo.BaseMutationOptions<CreateWhitePaperCommentMutation, CreateWhitePaperCommentMutationVariables>;
export const DeleteFundSearchAlertDocument = gql`
    mutation DeleteFundSearchAlert($fundSearchAlertId: ID!) {
  deleteFundSearchAlert(input: {fundSearchAlertId: $fundSearchAlertId}) {
    currentUser {
      id
      fundProfileSearchAlerts {
        id
        active
        display
        name
        employerProfileSavedSearch {
          id
          criteria
        }
      }
    }
  }
}
    `;
export type DeleteFundSearchAlertMutationFn = Apollo.MutationFunction<DeleteFundSearchAlertMutation, DeleteFundSearchAlertMutationVariables>;

/**
 * __useDeleteFundSearchAlertMutation__
 *
 * To run a mutation, you first call `useDeleteFundSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFundSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFundSearchAlertMutation, { data, loading, error }] = useDeleteFundSearchAlertMutation({
 *   variables: {
 *      fundSearchAlertId: // value for 'fundSearchAlertId'
 *   },
 * });
 */
export function useDeleteFundSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFundSearchAlertMutation, DeleteFundSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFundSearchAlertMutation, DeleteFundSearchAlertMutationVariables>(DeleteFundSearchAlertDocument, options);
      }
export type DeleteFundSearchAlertMutationHookResult = ReturnType<typeof useDeleteFundSearchAlertMutation>;
export type DeleteFundSearchAlertMutationResult = Apollo.MutationResult<DeleteFundSearchAlertMutation>;
export type DeleteFundSearchAlertMutationOptions = Apollo.BaseMutationOptions<DeleteFundSearchAlertMutation, DeleteFundSearchAlertMutationVariables>;
export const DeleteIdeaSearchAlertDocument = gql`
    mutation DeleteIdeaSearchAlert($ideaSearchAlertId: ID!) {
  deleteIdeaSearchAlert(input: {ideaSearchAlertId: $ideaSearchAlertId}) {
    currentUser {
      id
      ideaSearchAlerts {
        id
        active
        display
        name
        ideaSavedSearch {
          id
          criteria
        }
      }
    }
  }
}
    `;
export type DeleteIdeaSearchAlertMutationFn = Apollo.MutationFunction<DeleteIdeaSearchAlertMutation, DeleteIdeaSearchAlertMutationVariables>;

/**
 * __useDeleteIdeaSearchAlertMutation__
 *
 * To run a mutation, you first call `useDeleteIdeaSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIdeaSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIdeaSearchAlertMutation, { data, loading, error }] = useDeleteIdeaSearchAlertMutation({
 *   variables: {
 *      ideaSearchAlertId: // value for 'ideaSearchAlertId'
 *   },
 * });
 */
export function useDeleteIdeaSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIdeaSearchAlertMutation, DeleteIdeaSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIdeaSearchAlertMutation, DeleteIdeaSearchAlertMutationVariables>(DeleteIdeaSearchAlertDocument, options);
      }
export type DeleteIdeaSearchAlertMutationHookResult = ReturnType<typeof useDeleteIdeaSearchAlertMutation>;
export type DeleteIdeaSearchAlertMutationResult = Apollo.MutationResult<DeleteIdeaSearchAlertMutation>;
export type DeleteIdeaSearchAlertMutationOptions = Apollo.BaseMutationOptions<DeleteIdeaSearchAlertMutation, DeleteIdeaSearchAlertMutationVariables>;
export const DestroyPostDocument = gql`
    mutation destroyPost($feedItemId: ID!) {
  destroyPost(input: {feedItemId: $feedItemId}) {
    feedItem {
      id
      feedId
    }
  }
}
    `;
export type DestroyPostMutationFn = Apollo.MutationFunction<DestroyPostMutation, DestroyPostMutationVariables>;

/**
 * __useDestroyPostMutation__
 *
 * To run a mutation, you first call `useDestroyPostMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyPostMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyPostMutation, { data, loading, error }] = useDestroyPostMutation({
 *   variables: {
 *      feedItemId: // value for 'feedItemId'
 *   },
 * });
 */
export function useDestroyPostMutation(baseOptions?: Apollo.MutationHookOptions<DestroyPostMutation, DestroyPostMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyPostMutation, DestroyPostMutationVariables>(DestroyPostDocument, options);
      }
export type DestroyPostMutationHookResult = ReturnType<typeof useDestroyPostMutation>;
export type DestroyPostMutationResult = Apollo.MutationResult<DestroyPostMutation>;
export type DestroyPostMutationOptions = Apollo.BaseMutationOptions<DestroyPostMutation, DestroyPostMutationVariables>;
export const DestroyBlocklistEntryDocument = gql`
    mutation destroyBlocklistEntry($allocatorProfileId: ID!, $employerProfileId: ID!) {
  destroyAllocatorBlocklistEntry(
    input: {allocatorProfileId: $allocatorProfileId, employerProfileId: $employerProfileId}
  ) {
    destroyedBlocklistEntry {
      id
      allocatorProfile {
        id
      }
    }
  }
}
    `;
export type DestroyBlocklistEntryMutationFn = Apollo.MutationFunction<DestroyBlocklistEntryMutation, DestroyBlocklistEntryMutationVariables>;

/**
 * __useDestroyBlocklistEntryMutation__
 *
 * To run a mutation, you first call `useDestroyBlocklistEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyBlocklistEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyBlocklistEntryMutation, { data, loading, error }] = useDestroyBlocklistEntryMutation({
 *   variables: {
 *      allocatorProfileId: // value for 'allocatorProfileId'
 *      employerProfileId: // value for 'employerProfileId'
 *   },
 * });
 */
export function useDestroyBlocklistEntryMutation(baseOptions?: Apollo.MutationHookOptions<DestroyBlocklistEntryMutation, DestroyBlocklistEntryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyBlocklistEntryMutation, DestroyBlocklistEntryMutationVariables>(DestroyBlocklistEntryDocument, options);
      }
export type DestroyBlocklistEntryMutationHookResult = ReturnType<typeof useDestroyBlocklistEntryMutation>;
export type DestroyBlocklistEntryMutationResult = Apollo.MutationResult<DestroyBlocklistEntryMutation>;
export type DestroyBlocklistEntryMutationOptions = Apollo.BaseMutationOptions<DestroyBlocklistEntryMutation, DestroyBlocklistEntryMutationVariables>;
export const DestroyCompanyQuestionDocument = gql`
    mutation DestroyCompanyQuestion($id: ID!) {
  destroyCompanyQuestion(input: {id: $id}) {
    companyQuestion {
      id
      deleted
    }
  }
}
    `;
export type DestroyCompanyQuestionMutationFn = Apollo.MutationFunction<DestroyCompanyQuestionMutation, DestroyCompanyQuestionMutationVariables>;

/**
 * __useDestroyCompanyQuestionMutation__
 *
 * To run a mutation, you first call `useDestroyCompanyQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyCompanyQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyCompanyQuestionMutation, { data, loading, error }] = useDestroyCompanyQuestionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyCompanyQuestionMutation(baseOptions?: Apollo.MutationHookOptions<DestroyCompanyQuestionMutation, DestroyCompanyQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyCompanyQuestionMutation, DestroyCompanyQuestionMutationVariables>(DestroyCompanyQuestionDocument, options);
      }
export type DestroyCompanyQuestionMutationHookResult = ReturnType<typeof useDestroyCompanyQuestionMutation>;
export type DestroyCompanyQuestionMutationResult = Apollo.MutationResult<DestroyCompanyQuestionMutation>;
export type DestroyCompanyQuestionMutationOptions = Apollo.BaseMutationOptions<DestroyCompanyQuestionMutation, DestroyCompanyQuestionMutationVariables>;
export const DestroyCompensationDocument = gql`
    mutation DestroyCompensation($id: ID!) {
  destroyCompensation(input: {id: $id}) {
    currentUser {
      id
      draftCompensations {
        id
      }
    }
  }
}
    `;
export type DestroyCompensationMutationFn = Apollo.MutationFunction<DestroyCompensationMutation, DestroyCompensationMutationVariables>;

/**
 * __useDestroyCompensationMutation__
 *
 * To run a mutation, you first call `useDestroyCompensationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyCompensationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyCompensationMutation, { data, loading, error }] = useDestroyCompensationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDestroyCompensationMutation(baseOptions?: Apollo.MutationHookOptions<DestroyCompensationMutation, DestroyCompensationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyCompensationMutation, DestroyCompensationMutationVariables>(DestroyCompensationDocument, options);
      }
export type DestroyCompensationMutationHookResult = ReturnType<typeof useDestroyCompensationMutation>;
export type DestroyCompensationMutationResult = Apollo.MutationResult<DestroyCompensationMutation>;
export type DestroyCompensationMutationOptions = Apollo.BaseMutationOptions<DestroyCompensationMutation, DestroyCompensationMutationVariables>;
export const DestroyIdeaDraftDocument = gql`
    mutation DestroyIdeaDraft($ideaId: ID!) {
  destroyIdeaDraft(input: {ideaId: $ideaId}) {
    currentUserId
    ideaId
  }
}
    `;
export type DestroyIdeaDraftMutationFn = Apollo.MutationFunction<DestroyIdeaDraftMutation, DestroyIdeaDraftMutationVariables>;

/**
 * __useDestroyIdeaDraftMutation__
 *
 * To run a mutation, you first call `useDestroyIdeaDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDestroyIdeaDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [destroyIdeaDraftMutation, { data, loading, error }] = useDestroyIdeaDraftMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useDestroyIdeaDraftMutation(baseOptions?: Apollo.MutationHookOptions<DestroyIdeaDraftMutation, DestroyIdeaDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DestroyIdeaDraftMutation, DestroyIdeaDraftMutationVariables>(DestroyIdeaDraftDocument, options);
      }
export type DestroyIdeaDraftMutationHookResult = ReturnType<typeof useDestroyIdeaDraftMutation>;
export type DestroyIdeaDraftMutationResult = Apollo.MutationResult<DestroyIdeaDraftMutation>;
export type DestroyIdeaDraftMutationOptions = Apollo.BaseMutationOptions<DestroyIdeaDraftMutation, DestroyIdeaDraftMutationVariables>;
export const DeleteWhitePaperDraftDocument = gql`
    mutation DeleteWhitePaperDraft($whitePaperId: ID!) {
  destroyWhitePaperDraft(input: {whitePaperId: $whitePaperId}) {
    currentUserId
    whitePaperId
  }
}
    `;
export type DeleteWhitePaperDraftMutationFn = Apollo.MutationFunction<DeleteWhitePaperDraftMutation, DeleteWhitePaperDraftMutationVariables>;

/**
 * __useDeleteWhitePaperDraftMutation__
 *
 * To run a mutation, you first call `useDeleteWhitePaperDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWhitePaperDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWhitePaperDraftMutation, { data, loading, error }] = useDeleteWhitePaperDraftMutation({
 *   variables: {
 *      whitePaperId: // value for 'whitePaperId'
 *   },
 * });
 */
export function useDeleteWhitePaperDraftMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWhitePaperDraftMutation, DeleteWhitePaperDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWhitePaperDraftMutation, DeleteWhitePaperDraftMutationVariables>(DeleteWhitePaperDraftDocument, options);
      }
export type DeleteWhitePaperDraftMutationHookResult = ReturnType<typeof useDeleteWhitePaperDraftMutation>;
export type DeleteWhitePaperDraftMutationResult = Apollo.MutationResult<DeleteWhitePaperDraftMutation>;
export type DeleteWhitePaperDraftMutationOptions = Apollo.BaseMutationOptions<DeleteWhitePaperDraftMutation, DeleteWhitePaperDraftMutationVariables>;
export const EventRegistrationDocument = gql`
    mutation EventRegistration($email: String, $firstName: String, $lastName: String, $firmName: String) {
  createEventRegistration(
    input: {email: $email, firstName: $firstName, lastName: $lastName, firmName: $firmName}
  ) {
    registered
  }
}
    `;
export type EventRegistrationMutationFn = Apollo.MutationFunction<EventRegistrationMutation, EventRegistrationMutationVariables>;

/**
 * __useEventRegistrationMutation__
 *
 * To run a mutation, you first call `useEventRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEventRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eventRegistrationMutation, { data, loading, error }] = useEventRegistrationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      firmName: // value for 'firmName'
 *   },
 * });
 */
export function useEventRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<EventRegistrationMutation, EventRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EventRegistrationMutation, EventRegistrationMutationVariables>(EventRegistrationDocument, options);
      }
export type EventRegistrationMutationHookResult = ReturnType<typeof useEventRegistrationMutation>;
export type EventRegistrationMutationResult = Apollo.MutationResult<EventRegistrationMutation>;
export type EventRegistrationMutationOptions = Apollo.BaseMutationOptions<EventRegistrationMutation, EventRegistrationMutationVariables>;
export const FlagItemDocument = gql`
    mutation FlagItem($itemId: ID!, $category: String!, $description: String!, $type: String!) {
  flagItem(
    input: {itemId: $itemId, category: $category, description: $description, type: $type}
  ) {
    flagMarker {
      id
      flagCategory
    }
  }
}
    `;
export type FlagItemMutationFn = Apollo.MutationFunction<FlagItemMutation, FlagItemMutationVariables>;

/**
 * __useFlagItemMutation__
 *
 * To run a mutation, you first call `useFlagItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFlagItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [flagItemMutation, { data, loading, error }] = useFlagItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      category: // value for 'category'
 *      description: // value for 'description'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFlagItemMutation(baseOptions?: Apollo.MutationHookOptions<FlagItemMutation, FlagItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FlagItemMutation, FlagItemMutationVariables>(FlagItemDocument, options);
      }
export type FlagItemMutationHookResult = ReturnType<typeof useFlagItemMutation>;
export type FlagItemMutationResult = Apollo.MutationResult<FlagItemMutation>;
export type FlagItemMutationOptions = Apollo.BaseMutationOptions<FlagItemMutation, FlagItemMutationVariables>;
export const FollowEntityOnboardingDocument = gql`
    mutation FollowEntityOnboarding($id: String, $entityId: ID) {
  followObject(
    input: {id: $id, followId: $entityId, type: "ENTITY", skipSideEffects: false}
  ) {
    currentUser {
      id
      watchlist {
        id
        entitiesFromMassImport {
          id
          name
          primarySymbol
        }
        entitiesRegularFollows {
          id
          name
          primarySymbol
        }
      }
    }
    message
  }
}
    `;
export type FollowEntityOnboardingMutationFn = Apollo.MutationFunction<FollowEntityOnboardingMutation, FollowEntityOnboardingMutationVariables>;

/**
 * __useFollowEntityOnboardingMutation__
 *
 * To run a mutation, you first call `useFollowEntityOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowEntityOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followEntityOnboardingMutation, { data, loading, error }] = useFollowEntityOnboardingMutation({
 *   variables: {
 *      id: // value for 'id'
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useFollowEntityOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<FollowEntityOnboardingMutation, FollowEntityOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowEntityOnboardingMutation, FollowEntityOnboardingMutationVariables>(FollowEntityOnboardingDocument, options);
      }
export type FollowEntityOnboardingMutationHookResult = ReturnType<typeof useFollowEntityOnboardingMutation>;
export type FollowEntityOnboardingMutationResult = Apollo.MutationResult<FollowEntityOnboardingMutation>;
export type FollowEntityOnboardingMutationOptions = Apollo.BaseMutationOptions<FollowEntityOnboardingMutation, FollowEntityOnboardingMutationVariables>;
export const FollowItemDocument = gql`
    mutation FollowItem($followId: ID, $type: String) {
  followObject(input: {followId: $followId, type: $type}) {
    user {
      id
      ...FollowIds
    }
  }
}
    ${FollowIdsFragmentDoc}`;
export type FollowItemMutationFn = Apollo.MutationFunction<FollowItemMutation, FollowItemMutationVariables>;

/**
 * __useFollowItemMutation__
 *
 * To run a mutation, you first call `useFollowItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followItemMutation, { data, loading, error }] = useFollowItemMutation({
 *   variables: {
 *      followId: // value for 'followId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useFollowItemMutation(baseOptions?: Apollo.MutationHookOptions<FollowItemMutation, FollowItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowItemMutation, FollowItemMutationVariables>(FollowItemDocument, options);
      }
export type FollowItemMutationHookResult = ReturnType<typeof useFollowItemMutation>;
export type FollowItemMutationResult = Apollo.MutationResult<FollowItemMutation>;
export type FollowItemMutationOptions = Apollo.BaseMutationOptions<FollowItemMutation, FollowItemMutationVariables>;
export const FollowMultipleDocument = gql`
    mutation FollowMultiple($sectorNames: [String!], $assetClassNames: [String!], $geographyNames: [String!], $fundTypeNames: [String!], $fundStrategyNames: [String!], $aumRangeNames: [String!], $section: Int) {
  followMultiple(
    input: {sectorNames: $sectorNames, assetClassNames: $assetClassNames, geographyNames: $geographyNames, fundTypeNames: $fundTypeNames, fundStrategyNames: $fundStrategyNames, aumRangeNames: $aumRangeNames, section: $section}
  ) {
    currentUser {
      id
      watchlist {
        ...UserWatchlist
      }
    }
  }
}
    ${UserWatchlistFragmentDoc}`;
export type FollowMultipleMutationFn = Apollo.MutationFunction<FollowMultipleMutation, FollowMultipleMutationVariables>;

/**
 * __useFollowMultipleMutation__
 *
 * To run a mutation, you first call `useFollowMultipleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowMultipleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followMultipleMutation, { data, loading, error }] = useFollowMultipleMutation({
 *   variables: {
 *      sectorNames: // value for 'sectorNames'
 *      assetClassNames: // value for 'assetClassNames'
 *      geographyNames: // value for 'geographyNames'
 *      fundTypeNames: // value for 'fundTypeNames'
 *      fundStrategyNames: // value for 'fundStrategyNames'
 *      aumRangeNames: // value for 'aumRangeNames'
 *      section: // value for 'section'
 *   },
 * });
 */
export function useFollowMultipleMutation(baseOptions?: Apollo.MutationHookOptions<FollowMultipleMutation, FollowMultipleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowMultipleMutation, FollowMultipleMutationVariables>(FollowMultipleDocument, options);
      }
export type FollowMultipleMutationHookResult = ReturnType<typeof useFollowMultipleMutation>;
export type FollowMultipleMutationResult = Apollo.MutationResult<FollowMultipleMutation>;
export type FollowMultipleMutationOptions = Apollo.BaseMutationOptions<FollowMultipleMutation, FollowMultipleMutationVariables>;
export const FollowUserOnboardingDocument = gql`
    mutation FollowUserOnboarding($userId: ID) {
  followObject(input: {followId: $userId, type: "USER", skipSideEffects: false}) {
    currentUser {
      id
      watchlist {
        id
        users {
          id
          displayName
          profileImageUrl
          currentEmployerName
        }
      }
    }
    message
  }
}
    `;
export type FollowUserOnboardingMutationFn = Apollo.MutationFunction<FollowUserOnboardingMutation, FollowUserOnboardingMutationVariables>;

/**
 * __useFollowUserOnboardingMutation__
 *
 * To run a mutation, you first call `useFollowUserOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowUserOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followUserOnboardingMutation, { data, loading, error }] = useFollowUserOnboardingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFollowUserOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<FollowUserOnboardingMutation, FollowUserOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FollowUserOnboardingMutation, FollowUserOnboardingMutationVariables>(FollowUserOnboardingDocument, options);
      }
export type FollowUserOnboardingMutationHookResult = ReturnType<typeof useFollowUserOnboardingMutation>;
export type FollowUserOnboardingMutationResult = Apollo.MutationResult<FollowUserOnboardingMutation>;
export type FollowUserOnboardingMutationOptions = Apollo.BaseMutationOptions<FollowUserOnboardingMutation, FollowUserOnboardingMutationVariables>;
export const GoogleReCaptchaDocument = gql`
    mutation GoogleReCAPTCHA($response: String!, $action: String!) {
  googleReCAPTCHA(input: {response: $response, action: $action}) {
    verified
  }
}
    `;
export type GoogleReCaptchaMutationFn = Apollo.MutationFunction<GoogleReCaptchaMutation, GoogleReCaptchaMutationVariables>;

/**
 * __useGoogleReCaptchaMutation__
 *
 * To run a mutation, you first call `useGoogleReCaptchaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGoogleReCaptchaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [googleReCaptchaMutation, { data, loading, error }] = useGoogleReCaptchaMutation({
 *   variables: {
 *      response: // value for 'response'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useGoogleReCaptchaMutation(baseOptions?: Apollo.MutationHookOptions<GoogleReCaptchaMutation, GoogleReCaptchaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GoogleReCaptchaMutation, GoogleReCaptchaMutationVariables>(GoogleReCaptchaDocument, options);
      }
export type GoogleReCaptchaMutationHookResult = ReturnType<typeof useGoogleReCaptchaMutation>;
export type GoogleReCaptchaMutationResult = Apollo.MutationResult<GoogleReCaptchaMutation>;
export type GoogleReCaptchaMutationOptions = Apollo.BaseMutationOptions<GoogleReCaptchaMutation, GoogleReCaptchaMutationVariables>;
export const HideFundRecommendationDocument = gql`
    mutation HideFundRecommendation($fundRecommendationId: ID!) {
  hideFundRecommendation(input: {fundRecommendationId: $fundRecommendationId}) {
    fundRecommendation {
      id
    }
  }
}
    `;
export type HideFundRecommendationMutationFn = Apollo.MutationFunction<HideFundRecommendationMutation, HideFundRecommendationMutationVariables>;

/**
 * __useHideFundRecommendationMutation__
 *
 * To run a mutation, you first call `useHideFundRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideFundRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideFundRecommendationMutation, { data, loading, error }] = useHideFundRecommendationMutation({
 *   variables: {
 *      fundRecommendationId: // value for 'fundRecommendationId'
 *   },
 * });
 */
export function useHideFundRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<HideFundRecommendationMutation, HideFundRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideFundRecommendationMutation, HideFundRecommendationMutationVariables>(HideFundRecommendationDocument, options);
      }
export type HideFundRecommendationMutationHookResult = ReturnType<typeof useHideFundRecommendationMutation>;
export type HideFundRecommendationMutationResult = Apollo.MutationResult<HideFundRecommendationMutation>;
export type HideFundRecommendationMutationOptions = Apollo.BaseMutationOptions<HideFundRecommendationMutation, HideFundRecommendationMutationVariables>;
export const HideIdeaRecommendationDocument = gql`
    mutation HideIdeaRecommendation($id: ID!, $userId: ID!, $ideaId: ID!) {
  hideIdeaRecommendation(input: {id: $id, userId: $userId, ideaId: $ideaId}) {
    currentUser {
      id
    }
  }
}
    `;
export type HideIdeaRecommendationMutationFn = Apollo.MutationFunction<HideIdeaRecommendationMutation, HideIdeaRecommendationMutationVariables>;

/**
 * __useHideIdeaRecommendationMutation__
 *
 * To run a mutation, you first call `useHideIdeaRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideIdeaRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideIdeaRecommendationMutation, { data, loading, error }] = useHideIdeaRecommendationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useHideIdeaRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<HideIdeaRecommendationMutation, HideIdeaRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideIdeaRecommendationMutation, HideIdeaRecommendationMutationVariables>(HideIdeaRecommendationDocument, options);
      }
export type HideIdeaRecommendationMutationHookResult = ReturnType<typeof useHideIdeaRecommendationMutation>;
export type HideIdeaRecommendationMutationResult = Apollo.MutationResult<HideIdeaRecommendationMutation>;
export type HideIdeaRecommendationMutationOptions = Apollo.BaseMutationOptions<HideIdeaRecommendationMutation, HideIdeaRecommendationMutationVariables>;
export const InviteNewMembersMutationDocument = gql`
    mutation InviteNewMembersMutation($emails: String!, $personalMessage: String) {
  createNewMemberInvitation(
    input: {emails: $emails, personalMessage: $personalMessage}
  ) {
    success
  }
}
    `;
export type InviteNewMembersMutationMutationFn = Apollo.MutationFunction<InviteNewMembersMutationMutation, InviteNewMembersMutationMutationVariables>;

/**
 * __useInviteNewMembersMutationMutation__
 *
 * To run a mutation, you first call `useInviteNewMembersMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteNewMembersMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteNewMembersMutationMutation, { data, loading, error }] = useInviteNewMembersMutationMutation({
 *   variables: {
 *      emails: // value for 'emails'
 *      personalMessage: // value for 'personalMessage'
 *   },
 * });
 */
export function useInviteNewMembersMutationMutation(baseOptions?: Apollo.MutationHookOptions<InviteNewMembersMutationMutation, InviteNewMembersMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteNewMembersMutationMutation, InviteNewMembersMutationMutationVariables>(InviteNewMembersMutationDocument, options);
      }
export type InviteNewMembersMutationMutationHookResult = ReturnType<typeof useInviteNewMembersMutationMutation>;
export type InviteNewMembersMutationMutationResult = Apollo.MutationResult<InviteNewMembersMutationMutation>;
export type InviteNewMembersMutationMutationOptions = Apollo.BaseMutationOptions<InviteNewMembersMutationMutation, InviteNewMembersMutationMutationVariables>;
export const LikeCommentDocument = gql`
    mutation LikeComment($commentId: ID!) {
  likeComment(input: {commentId: $commentId}) {
    comment {
      id
      likeCount
      currentUserHasLiked
    }
  }
}
    `;
export type LikeCommentMutationFn = Apollo.MutationFunction<LikeCommentMutation, LikeCommentMutationVariables>;

/**
 * __useLikeCommentMutation__
 *
 * To run a mutation, you first call `useLikeCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeCommentMutation, { data, loading, error }] = useLikeCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useLikeCommentMutation(baseOptions?: Apollo.MutationHookOptions<LikeCommentMutation, LikeCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeCommentMutation, LikeCommentMutationVariables>(LikeCommentDocument, options);
      }
export type LikeCommentMutationHookResult = ReturnType<typeof useLikeCommentMutation>;
export type LikeCommentMutationResult = Apollo.MutationResult<LikeCommentMutation>;
export type LikeCommentMutationOptions = Apollo.BaseMutationOptions<LikeCommentMutation, LikeCommentMutationVariables>;
export const LikeEventDocument = gql`
    mutation LikeEvent($eventId: ID!) {
  likeEvent(input: {eventId: $eventId}) {
    event {
      id
      likeCount
      currentUserHasLiked
    }
  }
}
    `;
export type LikeEventMutationFn = Apollo.MutationFunction<LikeEventMutation, LikeEventMutationVariables>;

/**
 * __useLikeEventMutation__
 *
 * To run a mutation, you first call `useLikeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLikeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [likeEventMutation, { data, loading, error }] = useLikeEventMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useLikeEventMutation(baseOptions?: Apollo.MutationHookOptions<LikeEventMutation, LikeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LikeEventMutation, LikeEventMutationVariables>(LikeEventDocument, options);
      }
export type LikeEventMutationHookResult = ReturnType<typeof useLikeEventMutation>;
export type LikeEventMutationResult = Apollo.MutationResult<LikeEventMutation>;
export type LikeEventMutationOptions = Apollo.BaseMutationOptions<LikeEventMutation, LikeEventMutationVariables>;
export const MakeCheckoutSessionUpdatePaymentMethodDocument = gql`
    mutation MakeCheckoutSessionUpdatePaymentMethod {
  makeCheckoutSessionUpdatePaymentMethod(input: {}) {
    sessionId
  }
}
    `;
export type MakeCheckoutSessionUpdatePaymentMethodMutationFn = Apollo.MutationFunction<MakeCheckoutSessionUpdatePaymentMethodMutation, MakeCheckoutSessionUpdatePaymentMethodMutationVariables>;

/**
 * __useMakeCheckoutSessionUpdatePaymentMethodMutation__
 *
 * To run a mutation, you first call `useMakeCheckoutSessionUpdatePaymentMethodMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeCheckoutSessionUpdatePaymentMethodMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeCheckoutSessionUpdatePaymentMethodMutation, { data, loading, error }] = useMakeCheckoutSessionUpdatePaymentMethodMutation({
 *   variables: {
 *   },
 * });
 */
export function useMakeCheckoutSessionUpdatePaymentMethodMutation(baseOptions?: Apollo.MutationHookOptions<MakeCheckoutSessionUpdatePaymentMethodMutation, MakeCheckoutSessionUpdatePaymentMethodMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeCheckoutSessionUpdatePaymentMethodMutation, MakeCheckoutSessionUpdatePaymentMethodMutationVariables>(MakeCheckoutSessionUpdatePaymentMethodDocument, options);
      }
export type MakeCheckoutSessionUpdatePaymentMethodMutationHookResult = ReturnType<typeof useMakeCheckoutSessionUpdatePaymentMethodMutation>;
export type MakeCheckoutSessionUpdatePaymentMethodMutationResult = Apollo.MutationResult<MakeCheckoutSessionUpdatePaymentMethodMutation>;
export type MakeCheckoutSessionUpdatePaymentMethodMutationOptions = Apollo.BaseMutationOptions<MakeCheckoutSessionUpdatePaymentMethodMutation, MakeCheckoutSessionUpdatePaymentMethodMutationVariables>;
export const MakeStripeCheckoutDocument = gql`
    mutation MakeStripeCheckout($plan: String!, $currentUrl: String!, $email: String) {
  makeStripeCheckout(input: {plan: $plan, currentUrl: $currentUrl, email: $email}) {
    sessionId
  }
}
    `;
export type MakeStripeCheckoutMutationFn = Apollo.MutationFunction<MakeStripeCheckoutMutation, MakeStripeCheckoutMutationVariables>;

/**
 * __useMakeStripeCheckoutMutation__
 *
 * To run a mutation, you first call `useMakeStripeCheckoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMakeStripeCheckoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [makeStripeCheckoutMutation, { data, loading, error }] = useMakeStripeCheckoutMutation({
 *   variables: {
 *      plan: // value for 'plan'
 *      currentUrl: // value for 'currentUrl'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useMakeStripeCheckoutMutation(baseOptions?: Apollo.MutationHookOptions<MakeStripeCheckoutMutation, MakeStripeCheckoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MakeStripeCheckoutMutation, MakeStripeCheckoutMutationVariables>(MakeStripeCheckoutDocument, options);
      }
export type MakeStripeCheckoutMutationHookResult = ReturnType<typeof useMakeStripeCheckoutMutation>;
export type MakeStripeCheckoutMutationResult = Apollo.MutationResult<MakeStripeCheckoutMutation>;
export type MakeStripeCheckoutMutationOptions = Apollo.BaseMutationOptions<MakeStripeCheckoutMutation, MakeStripeCheckoutMutationVariables>;
export const MarkChatReadDocument = gql`
    mutation MarkChatRead($chatId: ID!) {
  markChatRead(input: {chatId: $chatId}) {
    success
  }
}
    `;
export type MarkChatReadMutationFn = Apollo.MutationFunction<MarkChatReadMutation, MarkChatReadMutationVariables>;

/**
 * __useMarkChatReadMutation__
 *
 * To run a mutation, you first call `useMarkChatReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkChatReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markChatReadMutation, { data, loading, error }] = useMarkChatReadMutation({
 *   variables: {
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useMarkChatReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkChatReadMutation, MarkChatReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkChatReadMutation, MarkChatReadMutationVariables>(MarkChatReadDocument, options);
      }
export type MarkChatReadMutationHookResult = ReturnType<typeof useMarkChatReadMutation>;
export type MarkChatReadMutationResult = Apollo.MutationResult<MarkChatReadMutation>;
export type MarkChatReadMutationOptions = Apollo.BaseMutationOptions<MarkChatReadMutation, MarkChatReadMutationVariables>;
export const MarkJobApplicationViewedDocument = gql`
    mutation MarkJobApplicationViewed($jobApplicationId: ID!) {
  markJobApplicationViewed(input: {jobApplicationId: $jobApplicationId}) {
    jobApplication {
      id
      status
    }
  }
}
    `;
export type MarkJobApplicationViewedMutationFn = Apollo.MutationFunction<MarkJobApplicationViewedMutation, MarkJobApplicationViewedMutationVariables>;

/**
 * __useMarkJobApplicationViewedMutation__
 *
 * To run a mutation, you first call `useMarkJobApplicationViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkJobApplicationViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markJobApplicationViewedMutation, { data, loading, error }] = useMarkJobApplicationViewedMutation({
 *   variables: {
 *      jobApplicationId: // value for 'jobApplicationId'
 *   },
 * });
 */
export function useMarkJobApplicationViewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkJobApplicationViewedMutation, MarkJobApplicationViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkJobApplicationViewedMutation, MarkJobApplicationViewedMutationVariables>(MarkJobApplicationViewedDocument, options);
      }
export type MarkJobApplicationViewedMutationHookResult = ReturnType<typeof useMarkJobApplicationViewedMutation>;
export type MarkJobApplicationViewedMutationResult = Apollo.MutationResult<MarkJobApplicationViewedMutation>;
export type MarkJobApplicationViewedMutationOptions = Apollo.BaseMutationOptions<MarkJobApplicationViewedMutation, MarkJobApplicationViewedMutationVariables>;
export const MarkMessageAsReadDocument = gql`
    mutation MarkMessageAsRead($id: ID!) {
  markMessageAsRead(input: {id: $id}) {
    updatedMessage {
      id
      thread
      subject
      body
      createdAt
      readStatus
      receiverStatus
      sender {
        id
        displayName
        profileImageUrl
        currentEmployerName
      }
    }
  }
}
    `;
export type MarkMessageAsReadMutationFn = Apollo.MutationFunction<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>;

/**
 * __useMarkMessageAsReadMutation__
 *
 * To run a mutation, you first call `useMarkMessageAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkMessageAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markMessageAsReadMutation, { data, loading, error }] = useMarkMessageAsReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkMessageAsReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>(MarkMessageAsReadDocument, options);
      }
export type MarkMessageAsReadMutationHookResult = ReturnType<typeof useMarkMessageAsReadMutation>;
export type MarkMessageAsReadMutationResult = Apollo.MutationResult<MarkMessageAsReadMutation>;
export type MarkMessageAsReadMutationOptions = Apollo.BaseMutationOptions<MarkMessageAsReadMutation, MarkMessageAsReadMutationVariables>;
export const MassFollowEntitiesDocument = gql`
    mutation MassFollowEntities($entityIds: [ID!]!, $fileName: String!) {
  massFollowEntities(input: {entityIds: $entityIds, fileName: $fileName}) {
    currentUser {
      id
      followedEntityIds
      watchlistTickers {
        id
        createdAt
        entity {
          id
          name
          primaryAsset {
            primarySymbol
          }
        }
      }
    }
  }
}
    `;
export type MassFollowEntitiesMutationFn = Apollo.MutationFunction<MassFollowEntitiesMutation, MassFollowEntitiesMutationVariables>;

/**
 * __useMassFollowEntitiesMutation__
 *
 * To run a mutation, you first call `useMassFollowEntitiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMassFollowEntitiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [massFollowEntitiesMutation, { data, loading, error }] = useMassFollowEntitiesMutation({
 *   variables: {
 *      entityIds: // value for 'entityIds'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useMassFollowEntitiesMutation(baseOptions?: Apollo.MutationHookOptions<MassFollowEntitiesMutation, MassFollowEntitiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MassFollowEntitiesMutation, MassFollowEntitiesMutationVariables>(MassFollowEntitiesDocument, options);
      }
export type MassFollowEntitiesMutationHookResult = ReturnType<typeof useMassFollowEntitiesMutation>;
export type MassFollowEntitiesMutationResult = Apollo.MutationResult<MassFollowEntitiesMutation>;
export type MassFollowEntitiesMutationOptions = Apollo.BaseMutationOptions<MassFollowEntitiesMutation, MassFollowEntitiesMutationVariables>;
export const PublishFundProfileDocument = gql`
    mutation PublishFundProfile($employerProfileId: ID!) {
  publishFundProfile(input: {employerProfileId: $employerProfileId}) {
    employerProfile {
      id
      status
    }
  }
}
    `;
export type PublishFundProfileMutationFn = Apollo.MutationFunction<PublishFundProfileMutation, PublishFundProfileMutationVariables>;

/**
 * __usePublishFundProfileMutation__
 *
 * To run a mutation, you first call `usePublishFundProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePublishFundProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [publishFundProfileMutation, { data, loading, error }] = usePublishFundProfileMutation({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *   },
 * });
 */
export function usePublishFundProfileMutation(baseOptions?: Apollo.MutationHookOptions<PublishFundProfileMutation, PublishFundProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PublishFundProfileMutation, PublishFundProfileMutationVariables>(PublishFundProfileDocument, options);
      }
export type PublishFundProfileMutationHookResult = ReturnType<typeof usePublishFundProfileMutation>;
export type PublishFundProfileMutationResult = Apollo.MutationResult<PublishFundProfileMutation>;
export type PublishFundProfileMutationOptions = Apollo.BaseMutationOptions<PublishFundProfileMutation, PublishFundProfileMutationVariables>;
export const PurchaseIdeaDocument = gql`
    mutation PurchaseIdea($ideaId: ID!) {
  spendIdeaToken(input: {ideaId: $ideaId}) {
    availableTokenCount
  }
}
    `;
export type PurchaseIdeaMutationFn = Apollo.MutationFunction<PurchaseIdeaMutation, PurchaseIdeaMutationVariables>;

/**
 * __usePurchaseIdeaMutation__
 *
 * To run a mutation, you first call `usePurchaseIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePurchaseIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [purchaseIdeaMutation, { data, loading, error }] = usePurchaseIdeaMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function usePurchaseIdeaMutation(baseOptions?: Apollo.MutationHookOptions<PurchaseIdeaMutation, PurchaseIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PurchaseIdeaMutation, PurchaseIdeaMutationVariables>(PurchaseIdeaDocument, options);
      }
export type PurchaseIdeaMutationHookResult = ReturnType<typeof usePurchaseIdeaMutation>;
export type PurchaseIdeaMutationResult = Apollo.MutationResult<PurchaseIdeaMutation>;
export type PurchaseIdeaMutationOptions = Apollo.BaseMutationOptions<PurchaseIdeaMutation, PurchaseIdeaMutationVariables>;
export const RateIdeaDocument = gql`
    mutation RateIdea($ideaId: ID!, $score: Int!) {
  rateIdea(input: {ideaId: $ideaId, score: $score}) {
    userRating {
      id
      score
    }
    idea {
      id
      expectedPerformanceRating {
        id
        averageRating
        userRatingCount
      }
    }
  }
}
    `;
export type RateIdeaMutationFn = Apollo.MutationFunction<RateIdeaMutation, RateIdeaMutationVariables>;

/**
 * __useRateIdeaMutation__
 *
 * To run a mutation, you first call `useRateIdeaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRateIdeaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rateIdeaMutation, { data, loading, error }] = useRateIdeaMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *      score: // value for 'score'
 *   },
 * });
 */
export function useRateIdeaMutation(baseOptions?: Apollo.MutationHookOptions<RateIdeaMutation, RateIdeaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RateIdeaMutation, RateIdeaMutationVariables>(RateIdeaDocument, options);
      }
export type RateIdeaMutationHookResult = ReturnType<typeof useRateIdeaMutation>;
export type RateIdeaMutationResult = Apollo.MutationResult<RateIdeaMutation>;
export type RateIdeaMutationOptions = Apollo.BaseMutationOptions<RateIdeaMutation, RateIdeaMutationVariables>;
export const RemoveMassImportDocument = gql`
    mutation RemoveMassImport($massImportId: ID!) {
  removeMassImport(input: {massImportId: $massImportId}) {
    currentUser {
      id
      watchlist {
        ...UserWatchlist
      }
    }
  }
}
    ${UserWatchlistFragmentDoc}`;
export type RemoveMassImportMutationFn = Apollo.MutationFunction<RemoveMassImportMutation, RemoveMassImportMutationVariables>;

/**
 * __useRemoveMassImportMutation__
 *
 * To run a mutation, you first call `useRemoveMassImportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveMassImportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeMassImportMutation, { data, loading, error }] = useRemoveMassImportMutation({
 *   variables: {
 *      massImportId: // value for 'massImportId'
 *   },
 * });
 */
export function useRemoveMassImportMutation(baseOptions?: Apollo.MutationHookOptions<RemoveMassImportMutation, RemoveMassImportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveMassImportMutation, RemoveMassImportMutationVariables>(RemoveMassImportDocument, options);
      }
export type RemoveMassImportMutationHookResult = ReturnType<typeof useRemoveMassImportMutation>;
export type RemoveMassImportMutationResult = Apollo.MutationResult<RemoveMassImportMutation>;
export type RemoveMassImportMutationOptions = Apollo.BaseMutationOptions<RemoveMassImportMutation, RemoveMassImportMutationVariables>;
export const RequestIdeaUpdateDocument = gql`
    mutation RequestIdeaUpdate($body: String!, $ideaId: ID!) {
  requestIdeaUpdate(input: {body: $body, ideaId: $ideaId}) {
    complete
  }
}
    `;
export type RequestIdeaUpdateMutationFn = Apollo.MutationFunction<RequestIdeaUpdateMutation, RequestIdeaUpdateMutationVariables>;

/**
 * __useRequestIdeaUpdateMutation__
 *
 * To run a mutation, you first call `useRequestIdeaUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestIdeaUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestIdeaUpdateMutation, { data, loading, error }] = useRequestIdeaUpdateMutation({
 *   variables: {
 *      body: // value for 'body'
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useRequestIdeaUpdateMutation(baseOptions?: Apollo.MutationHookOptions<RequestIdeaUpdateMutation, RequestIdeaUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestIdeaUpdateMutation, RequestIdeaUpdateMutationVariables>(RequestIdeaUpdateDocument, options);
      }
export type RequestIdeaUpdateMutationHookResult = ReturnType<typeof useRequestIdeaUpdateMutation>;
export type RequestIdeaUpdateMutationResult = Apollo.MutationResult<RequestIdeaUpdateMutation>;
export type RequestIdeaUpdateMutationOptions = Apollo.BaseMutationOptions<RequestIdeaUpdateMutation, RequestIdeaUpdateMutationVariables>;
export const RequestResearchAccessDocument = gql`
    mutation RequestResearchAccess {
  requestResearchAccess(input: {}) {
    success
  }
}
    `;
export type RequestResearchAccessMutationFn = Apollo.MutationFunction<RequestResearchAccessMutation, RequestResearchAccessMutationVariables>;

/**
 * __useRequestResearchAccessMutation__
 *
 * To run a mutation, you first call `useRequestResearchAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResearchAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResearchAccessMutation, { data, loading, error }] = useRequestResearchAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useRequestResearchAccessMutation(baseOptions?: Apollo.MutationHookOptions<RequestResearchAccessMutation, RequestResearchAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResearchAccessMutation, RequestResearchAccessMutationVariables>(RequestResearchAccessDocument, options);
      }
export type RequestResearchAccessMutationHookResult = ReturnType<typeof useRequestResearchAccessMutation>;
export type RequestResearchAccessMutationResult = Apollo.MutationResult<RequestResearchAccessMutation>;
export type RequestResearchAccessMutationOptions = Apollo.BaseMutationOptions<RequestResearchAccessMutation, RequestResearchAccessMutationVariables>;
export const RestoreFundSearchAlertDocument = gql`
    mutation RestoreFundSearchAlert($employerProfileSavedSearchId: ID!, $name: String!, $active: Boolean!, $display: Boolean!) {
  restoreFundSearchAlert(
    input: {employerProfileSavedSearchId: $employerProfileSavedSearchId, name: $name, active: $active, display: $display}
  ) {
    currentUser {
      id
      fundProfileSearchAlerts {
        id
        active
        display
        name
        employerProfileSavedSearch {
          id
          criteria
        }
      }
    }
  }
}
    `;
export type RestoreFundSearchAlertMutationFn = Apollo.MutationFunction<RestoreFundSearchAlertMutation, RestoreFundSearchAlertMutationVariables>;

/**
 * __useRestoreFundSearchAlertMutation__
 *
 * To run a mutation, you first call `useRestoreFundSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreFundSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreFundSearchAlertMutation, { data, loading, error }] = useRestoreFundSearchAlertMutation({
 *   variables: {
 *      employerProfileSavedSearchId: // value for 'employerProfileSavedSearchId'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      display: // value for 'display'
 *   },
 * });
 */
export function useRestoreFundSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<RestoreFundSearchAlertMutation, RestoreFundSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreFundSearchAlertMutation, RestoreFundSearchAlertMutationVariables>(RestoreFundSearchAlertDocument, options);
      }
export type RestoreFundSearchAlertMutationHookResult = ReturnType<typeof useRestoreFundSearchAlertMutation>;
export type RestoreFundSearchAlertMutationResult = Apollo.MutationResult<RestoreFundSearchAlertMutation>;
export type RestoreFundSearchAlertMutationOptions = Apollo.BaseMutationOptions<RestoreFundSearchAlertMutation, RestoreFundSearchAlertMutationVariables>;
export const RestoreIdeaSearchAlertDocument = gql`
    mutation RestoreIdeaSearchAlert($ideaSavedSearchId: ID!, $name: String, $active: Boolean, $display: Boolean) {
  restoreIdeaSearchAlert(
    input: {ideaSavedSearchId: $ideaSavedSearchId, name: $name, active: $active, display: $display}
  ) {
    currentUser {
      id
      ideaSearchAlerts {
        id
        active
        display
        name
        ideaSavedSearch {
          id
          criteria
        }
      }
    }
  }
}
    `;
export type RestoreIdeaSearchAlertMutationFn = Apollo.MutationFunction<RestoreIdeaSearchAlertMutation, RestoreIdeaSearchAlertMutationVariables>;

/**
 * __useRestoreIdeaSearchAlertMutation__
 *
 * To run a mutation, you first call `useRestoreIdeaSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreIdeaSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreIdeaSearchAlertMutation, { data, loading, error }] = useRestoreIdeaSearchAlertMutation({
 *   variables: {
 *      ideaSavedSearchId: // value for 'ideaSavedSearchId'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      display: // value for 'display'
 *   },
 * });
 */
export function useRestoreIdeaSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<RestoreIdeaSearchAlertMutation, RestoreIdeaSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreIdeaSearchAlertMutation, RestoreIdeaSearchAlertMutationVariables>(RestoreIdeaSearchAlertDocument, options);
      }
export type RestoreIdeaSearchAlertMutationHookResult = ReturnType<typeof useRestoreIdeaSearchAlertMutation>;
export type RestoreIdeaSearchAlertMutationResult = Apollo.MutationResult<RestoreIdeaSearchAlertMutation>;
export type RestoreIdeaSearchAlertMutationOptions = Apollo.BaseMutationOptions<RestoreIdeaSearchAlertMutation, RestoreIdeaSearchAlertMutationVariables>;
export const SetUsernameDocument = gql`
    mutation SetUsername($username: String!) {
  setUsername(input: {username: $username}) {
    currentUser {
      id
      username
    }
  }
}
    `;
export type SetUsernameMutationFn = Apollo.MutationFunction<SetUsernameMutation, SetUsernameMutationVariables>;

/**
 * __useSetUsernameMutation__
 *
 * To run a mutation, you first call `useSetUsernameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUsernameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUsernameMutation, { data, loading, error }] = useSetUsernameMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useSetUsernameMutation(baseOptions?: Apollo.MutationHookOptions<SetUsernameMutation, SetUsernameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUsernameMutation, SetUsernameMutationVariables>(SetUsernameDocument, options);
      }
export type SetUsernameMutationHookResult = ReturnType<typeof useSetUsernameMutation>;
export type SetUsernameMutationResult = Apollo.MutationResult<SetUsernameMutation>;
export type SetUsernameMutationOptions = Apollo.BaseMutationOptions<SetUsernameMutation, SetUsernameMutationVariables>;
export const StarJobApplicationDocument = gql`
    mutation StarJobApplication($jobApplicationId: ID!, $starredBoolean: Boolean!) {
  starJobApplication(
    input: {jobApplicationId: $jobApplicationId, starredBoolean: $starredBoolean}
  ) {
    jobApplication {
      id
      starred
    }
  }
}
    `;
export type StarJobApplicationMutationFn = Apollo.MutationFunction<StarJobApplicationMutation, StarJobApplicationMutationVariables>;

/**
 * __useStarJobApplicationMutation__
 *
 * To run a mutation, you first call `useStarJobApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStarJobApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [starJobApplicationMutation, { data, loading, error }] = useStarJobApplicationMutation({
 *   variables: {
 *      jobApplicationId: // value for 'jobApplicationId'
 *      starredBoolean: // value for 'starredBoolean'
 *   },
 * });
 */
export function useStarJobApplicationMutation(baseOptions?: Apollo.MutationHookOptions<StarJobApplicationMutation, StarJobApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StarJobApplicationMutation, StarJobApplicationMutationVariables>(StarJobApplicationDocument, options);
      }
export type StarJobApplicationMutationHookResult = ReturnType<typeof useStarJobApplicationMutation>;
export type StarJobApplicationMutationResult = Apollo.MutationResult<StarJobApplicationMutation>;
export type StarJobApplicationMutationOptions = Apollo.BaseMutationOptions<StarJobApplicationMutation, StarJobApplicationMutationVariables>;
export const SubmitCompanyQuestionResponseDocument = gql`
    mutation SubmitCompanyQuestionResponse($id: ID!, $answers: [String!]!, $entityId: ID!, $skipped: Boolean!) {
  submitCompanyQuestionResponse(
    input: {id: $id, answers: $answers, entityId: $entityId, skipped: $skipped}
  ) {
    companyQuestionResponse {
      id
      text
      skipped
      updatedAt
      pollQuestion {
        id
        yMin
        yMax
        tickCount
        showTooltip
        tickValues
        ...CompanyQuestion
        pollResponseData(entityId: $entityId) {
          answeredByCurrentUser
          buysidePollResultStats {
            monthlyAvg {
              label
              value
            }
            twelveMonthsPct {
              label
              value
            }
            currentMonthPct {
              label
              value
            }
          }
          retailPollResultStats {
            monthlyAvg {
              label
              value
            }
            twelveMonthsPct {
              label
              value
            }
            currentMonthPct {
              label
              value
            }
          }
        }
      }
    }
  }
}
    ${CompanyQuestionFragmentDoc}`;
export type SubmitCompanyQuestionResponseMutationFn = Apollo.MutationFunction<SubmitCompanyQuestionResponseMutation, SubmitCompanyQuestionResponseMutationVariables>;

/**
 * __useSubmitCompanyQuestionResponseMutation__
 *
 * To run a mutation, you first call `useSubmitCompanyQuestionResponseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCompanyQuestionResponseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCompanyQuestionResponseMutation, { data, loading, error }] = useSubmitCompanyQuestionResponseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      answers: // value for 'answers'
 *      entityId: // value for 'entityId'
 *      skipped: // value for 'skipped'
 *   },
 * });
 */
export function useSubmitCompanyQuestionResponseMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCompanyQuestionResponseMutation, SubmitCompanyQuestionResponseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCompanyQuestionResponseMutation, SubmitCompanyQuestionResponseMutationVariables>(SubmitCompanyQuestionResponseDocument, options);
      }
export type SubmitCompanyQuestionResponseMutationHookResult = ReturnType<typeof useSubmitCompanyQuestionResponseMutation>;
export type SubmitCompanyQuestionResponseMutationResult = Apollo.MutationResult<SubmitCompanyQuestionResponseMutation>;
export type SubmitCompanyQuestionResponseMutationOptions = Apollo.BaseMutationOptions<SubmitCompanyQuestionResponseMutation, SubmitCompanyQuestionResponseMutationVariables>;
export const SuggestTagDocument = gql`
    mutation SuggestTag($employerProfileId: ID!, $name: String, $description: String) {
  suggestTag(
    input: {employerProfileId: $employerProfileId, name: $name, description: $description}
  ) {
    success
  }
}
    `;
export type SuggestTagMutationFn = Apollo.MutationFunction<SuggestTagMutation, SuggestTagMutationVariables>;

/**
 * __useSuggestTagMutation__
 *
 * To run a mutation, you first call `useSuggestTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuggestTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [suggestTagMutation, { data, loading, error }] = useSuggestTagMutation({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useSuggestTagMutation(baseOptions?: Apollo.MutationHookOptions<SuggestTagMutation, SuggestTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SuggestTagMutation, SuggestTagMutationVariables>(SuggestTagDocument, options);
      }
export type SuggestTagMutationHookResult = ReturnType<typeof useSuggestTagMutation>;
export type SuggestTagMutationResult = Apollo.MutationResult<SuggestTagMutation>;
export type SuggestTagMutationOptions = Apollo.BaseMutationOptions<SuggestTagMutation, SuggestTagMutationVariables>;
export const ToggleFundProfileAdminDocument = gql`
    mutation ToggleFundProfileAdmin($currentEmployeeId: ID!, $employerProfileId: ID!) {
  toggleFundProfileAdmin(
    input: {currentEmployeeId: $currentEmployeeId, employerProfileId: $employerProfileId}
  ) {
    employerProfile {
      id
      fundAdminIds
    }
  }
}
    `;
export type ToggleFundProfileAdminMutationFn = Apollo.MutationFunction<ToggleFundProfileAdminMutation, ToggleFundProfileAdminMutationVariables>;

/**
 * __useToggleFundProfileAdminMutation__
 *
 * To run a mutation, you first call `useToggleFundProfileAdminMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFundProfileAdminMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFundProfileAdminMutation, { data, loading, error }] = useToggleFundProfileAdminMutation({
 *   variables: {
 *      currentEmployeeId: // value for 'currentEmployeeId'
 *      employerProfileId: // value for 'employerProfileId'
 *   },
 * });
 */
export function useToggleFundProfileAdminMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFundProfileAdminMutation, ToggleFundProfileAdminMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFundProfileAdminMutation, ToggleFundProfileAdminMutationVariables>(ToggleFundProfileAdminDocument, options);
      }
export type ToggleFundProfileAdminMutationHookResult = ReturnType<typeof useToggleFundProfileAdminMutation>;
export type ToggleFundProfileAdminMutationResult = Apollo.MutationResult<ToggleFundProfileAdminMutation>;
export type ToggleFundProfileAdminMutationOptions = Apollo.BaseMutationOptions<ToggleFundProfileAdminMutation, ToggleFundProfileAdminMutationVariables>;
export const ToggleHideNotificationDocument = gql`
    mutation ToggleHideNotification($notificationId: ID!, $hidden: Boolean!) {
  toggleHideNotification(
    input: {notificationId: $notificationId, hidden: $hidden}
  ) {
    notification {
      id
      hidden
    }
  }
}
    `;
export type ToggleHideNotificationMutationFn = Apollo.MutationFunction<ToggleHideNotificationMutation, ToggleHideNotificationMutationVariables>;

/**
 * __useToggleHideNotificationMutation__
 *
 * To run a mutation, you first call `useToggleHideNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleHideNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleHideNotificationMutation, { data, loading, error }] = useToggleHideNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *      hidden: // value for 'hidden'
 *   },
 * });
 */
export function useToggleHideNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleHideNotificationMutation, ToggleHideNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleHideNotificationMutation, ToggleHideNotificationMutationVariables>(ToggleHideNotificationDocument, options);
      }
export type ToggleHideNotificationMutationHookResult = ReturnType<typeof useToggleHideNotificationMutation>;
export type ToggleHideNotificationMutationResult = Apollo.MutationResult<ToggleHideNotificationMutation>;
export type ToggleHideNotificationMutationOptions = Apollo.BaseMutationOptions<ToggleHideNotificationMutation, ToggleHideNotificationMutationVariables>;
export const UnarchiveThreadDocument = gql`
    mutation UnarchiveThread($threadNum: ID!) {
  unarchiveThread(input: {threadNum: $threadNum}) {
    id
  }
}
    `;
export type UnarchiveThreadMutationFn = Apollo.MutationFunction<UnarchiveThreadMutation, UnarchiveThreadMutationVariables>;

/**
 * __useUnarchiveThreadMutation__
 *
 * To run a mutation, you first call `useUnarchiveThreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnarchiveThreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unarchiveThreadMutation, { data, loading, error }] = useUnarchiveThreadMutation({
 *   variables: {
 *      threadNum: // value for 'threadNum'
 *   },
 * });
 */
export function useUnarchiveThreadMutation(baseOptions?: Apollo.MutationHookOptions<UnarchiveThreadMutation, UnarchiveThreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnarchiveThreadMutation, UnarchiveThreadMutationVariables>(UnarchiveThreadDocument, options);
      }
export type UnarchiveThreadMutationHookResult = ReturnType<typeof useUnarchiveThreadMutation>;
export type UnarchiveThreadMutationResult = Apollo.MutationResult<UnarchiveThreadMutation>;
export type UnarchiveThreadMutationOptions = Apollo.BaseMutationOptions<UnarchiveThreadMutation, UnarchiveThreadMutationVariables>;
export const UnfollowEntityOnboardingDocument = gql`
    mutation UnfollowEntityOnboarding($entityId: ID) {
  unfollowObject(
    input: {followId: $entityId, type: "ENTITY", skipSideEffects: false}
  ) {
    currentUser {
      id
      watchlist {
        id
        entitiesFromMassImport {
          id
          name
          primarySymbol
        }
        entitiesRegularFollows {
          id
          name
          primarySymbol
        }
      }
    }
  }
}
    `;
export type UnfollowEntityOnboardingMutationFn = Apollo.MutationFunction<UnfollowEntityOnboardingMutation, UnfollowEntityOnboardingMutationVariables>;

/**
 * __useUnfollowEntityOnboardingMutation__
 *
 * To run a mutation, you first call `useUnfollowEntityOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowEntityOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowEntityOnboardingMutation, { data, loading, error }] = useUnfollowEntityOnboardingMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useUnfollowEntityOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowEntityOnboardingMutation, UnfollowEntityOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowEntityOnboardingMutation, UnfollowEntityOnboardingMutationVariables>(UnfollowEntityOnboardingDocument, options);
      }
export type UnfollowEntityOnboardingMutationHookResult = ReturnType<typeof useUnfollowEntityOnboardingMutation>;
export type UnfollowEntityOnboardingMutationResult = Apollo.MutationResult<UnfollowEntityOnboardingMutation>;
export type UnfollowEntityOnboardingMutationOptions = Apollo.BaseMutationOptions<UnfollowEntityOnboardingMutation, UnfollowEntityOnboardingMutationVariables>;
export const UnfollowItemDocument = gql`
    mutation UnfollowItem($followId: ID, $type: String) {
  unfollowObject(input: {followId: $followId, type: $type}) {
    user {
      id
      ...FollowIds
    }
  }
}
    ${FollowIdsFragmentDoc}`;
export type UnfollowItemMutationFn = Apollo.MutationFunction<UnfollowItemMutation, UnfollowItemMutationVariables>;

/**
 * __useUnfollowItemMutation__
 *
 * To run a mutation, you first call `useUnfollowItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowItemMutation, { data, loading, error }] = useUnfollowItemMutation({
 *   variables: {
 *      followId: // value for 'followId'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useUnfollowItemMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowItemMutation, UnfollowItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowItemMutation, UnfollowItemMutationVariables>(UnfollowItemDocument, options);
      }
export type UnfollowItemMutationHookResult = ReturnType<typeof useUnfollowItemMutation>;
export type UnfollowItemMutationResult = Apollo.MutationResult<UnfollowItemMutation>;
export type UnfollowItemMutationOptions = Apollo.BaseMutationOptions<UnfollowItemMutation, UnfollowItemMutationVariables>;
export const UnfollowUserOnboardingDocument = gql`
    mutation UnfollowUserOnboarding($userId: ID) {
  unfollowObject(input: {followId: $userId, type: "USER", skipSideEffects: false}) {
    currentUser {
      id
      watchlist {
        id
        users {
          id
          displayName
          profileImageUrl
          currentEmployerName
        }
      }
    }
  }
}
    `;
export type UnfollowUserOnboardingMutationFn = Apollo.MutationFunction<UnfollowUserOnboardingMutation, UnfollowUserOnboardingMutationVariables>;

/**
 * __useUnfollowUserOnboardingMutation__
 *
 * To run a mutation, you first call `useUnfollowUserOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowUserOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowUserOnboardingMutation, { data, loading, error }] = useUnfollowUserOnboardingMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUnfollowUserOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UnfollowUserOnboardingMutation, UnfollowUserOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnfollowUserOnboardingMutation, UnfollowUserOnboardingMutationVariables>(UnfollowUserOnboardingDocument, options);
      }
export type UnfollowUserOnboardingMutationHookResult = ReturnType<typeof useUnfollowUserOnboardingMutation>;
export type UnfollowUserOnboardingMutationResult = Apollo.MutationResult<UnfollowUserOnboardingMutation>;
export type UnfollowUserOnboardingMutationOptions = Apollo.BaseMutationOptions<UnfollowUserOnboardingMutation, UnfollowUserOnboardingMutationVariables>;
export const UnviewNotificationDocument = gql`
    mutation UnviewNotification($notificationId: ID!) {
  unviewNotification(input: {notificationId: $notificationId}) {
    notification {
      id
      viewed
    }
    currentUser {
      id
      unreadNotificationsCount
    }
  }
}
    `;
export type UnviewNotificationMutationFn = Apollo.MutationFunction<UnviewNotificationMutation, UnviewNotificationMutationVariables>;

/**
 * __useUnviewNotificationMutation__
 *
 * To run a mutation, you first call `useUnviewNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnviewNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unviewNotificationMutation, { data, loading, error }] = useUnviewNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useUnviewNotificationMutation(baseOptions?: Apollo.MutationHookOptions<UnviewNotificationMutation, UnviewNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnviewNotificationMutation, UnviewNotificationMutationVariables>(UnviewNotificationDocument, options);
      }
export type UnviewNotificationMutationHookResult = ReturnType<typeof useUnviewNotificationMutation>;
export type UnviewNotificationMutationResult = Apollo.MutationResult<UnviewNotificationMutation>;
export type UnviewNotificationMutationOptions = Apollo.BaseMutationOptions<UnviewNotificationMutation, UnviewNotificationMutationVariables>;
export const UpdateAllocatorProfileDocument = gql`
    mutation UpdateAllocatorProfile($allocatorProfileId: ID!, $section: String!, $aumRange: String, $employerType: String, $location: String, $fundManager: String, $bio: String, $executives: String, $investmentCriteria: String) {
  updateAllocatorProfile(
    input: {allocatorProfileId: $allocatorProfileId, section: $section, aumRange: $aumRange, employerType: $employerType, location: $location, fundManager: $fundManager, bio: $bio, executives: $executives, investmentCriteria: $investmentCriteria}
  ) {
    allocatorProfile {
      ...AllocatorProfileCard
      ...AllocatorProfileExecutiveManagement
      ...AllocatorProfileInvestmentPreferences
      investmentCriteria
    }
  }
}
    ${AllocatorProfileCardFragmentDoc}
${AllocatorProfileExecutiveManagementFragmentDoc}
${AllocatorProfileInvestmentPreferencesFragmentDoc}`;
export type UpdateAllocatorProfileMutationFn = Apollo.MutationFunction<UpdateAllocatorProfileMutation, UpdateAllocatorProfileMutationVariables>;

/**
 * __useUpdateAllocatorProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAllocatorProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocatorProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocatorProfileMutation, { data, loading, error }] = useUpdateAllocatorProfileMutation({
 *   variables: {
 *      allocatorProfileId: // value for 'allocatorProfileId'
 *      section: // value for 'section'
 *      aumRange: // value for 'aumRange'
 *      employerType: // value for 'employerType'
 *      location: // value for 'location'
 *      fundManager: // value for 'fundManager'
 *      bio: // value for 'bio'
 *      executives: // value for 'executives'
 *      investmentCriteria: // value for 'investmentCriteria'
 *   },
 * });
 */
export function useUpdateAllocatorProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllocatorProfileMutation, UpdateAllocatorProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllocatorProfileMutation, UpdateAllocatorProfileMutationVariables>(UpdateAllocatorProfileDocument, options);
      }
export type UpdateAllocatorProfileMutationHookResult = ReturnType<typeof useUpdateAllocatorProfileMutation>;
export type UpdateAllocatorProfileMutationResult = Apollo.MutationResult<UpdateAllocatorProfileMutation>;
export type UpdateAllocatorProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAllocatorProfileMutation, UpdateAllocatorProfileMutationVariables>;
export const UpdateAllocatorProfileBackgroundImageDocument = gql`
    mutation UpdateAllocatorProfileBackgroundImage($allocatorProfileId: ID!, $imageData: String, $cropData: String, $removeImage: Boolean) {
  updateAllocatorProfileBackgroundImage(
    input: {allocatorProfileId: $allocatorProfileId, imageData: $imageData, cropData: $cropData, removeImage: $removeImage}
  ) {
    allocatorProfile {
      id
      backgroundImageUrl
      backgroundImageCroppedUrl
    }
  }
}
    `;
export type UpdateAllocatorProfileBackgroundImageMutationFn = Apollo.MutationFunction<UpdateAllocatorProfileBackgroundImageMutation, UpdateAllocatorProfileBackgroundImageMutationVariables>;

/**
 * __useUpdateAllocatorProfileBackgroundImageMutation__
 *
 * To run a mutation, you first call `useUpdateAllocatorProfileBackgroundImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAllocatorProfileBackgroundImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAllocatorProfileBackgroundImageMutation, { data, loading, error }] = useUpdateAllocatorProfileBackgroundImageMutation({
 *   variables: {
 *      allocatorProfileId: // value for 'allocatorProfileId'
 *      imageData: // value for 'imageData'
 *      cropData: // value for 'cropData'
 *      removeImage: // value for 'removeImage'
 *   },
 * });
 */
export function useUpdateAllocatorProfileBackgroundImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAllocatorProfileBackgroundImageMutation, UpdateAllocatorProfileBackgroundImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAllocatorProfileBackgroundImageMutation, UpdateAllocatorProfileBackgroundImageMutationVariables>(UpdateAllocatorProfileBackgroundImageDocument, options);
      }
export type UpdateAllocatorProfileBackgroundImageMutationHookResult = ReturnType<typeof useUpdateAllocatorProfileBackgroundImageMutation>;
export type UpdateAllocatorProfileBackgroundImageMutationResult = Apollo.MutationResult<UpdateAllocatorProfileBackgroundImageMutation>;
export type UpdateAllocatorProfileBackgroundImageMutationOptions = Apollo.BaseMutationOptions<UpdateAllocatorProfileBackgroundImageMutation, UpdateAllocatorProfileBackgroundImageMutationVariables>;
export const UpdateCurrentUserLastViewedMessagesAtDocument = gql`
    mutation UpdateCurrentUserLastViewedMessagesAt {
  updateCurrentUserLastViewedMessagesAt(input: {}) {
    user {
      id
      unseenMessageCount
    }
  }
}
    `;
export type UpdateCurrentUserLastViewedMessagesAtMutationFn = Apollo.MutationFunction<UpdateCurrentUserLastViewedMessagesAtMutation, UpdateCurrentUserLastViewedMessagesAtMutationVariables>;

/**
 * __useUpdateCurrentUserLastViewedMessagesAtMutation__
 *
 * To run a mutation, you first call `useUpdateCurrentUserLastViewedMessagesAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCurrentUserLastViewedMessagesAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCurrentUserLastViewedMessagesAtMutation, { data, loading, error }] = useUpdateCurrentUserLastViewedMessagesAtMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateCurrentUserLastViewedMessagesAtMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCurrentUserLastViewedMessagesAtMutation, UpdateCurrentUserLastViewedMessagesAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCurrentUserLastViewedMessagesAtMutation, UpdateCurrentUserLastViewedMessagesAtMutationVariables>(UpdateCurrentUserLastViewedMessagesAtDocument, options);
      }
export type UpdateCurrentUserLastViewedMessagesAtMutationHookResult = ReturnType<typeof useUpdateCurrentUserLastViewedMessagesAtMutation>;
export type UpdateCurrentUserLastViewedMessagesAtMutationResult = Apollo.MutationResult<UpdateCurrentUserLastViewedMessagesAtMutation>;
export type UpdateCurrentUserLastViewedMessagesAtMutationOptions = Apollo.BaseMutationOptions<UpdateCurrentUserLastViewedMessagesAtMutation, UpdateCurrentUserLastViewedMessagesAtMutationVariables>;
export const UpdateFundProfileDocument = gql`
    mutation UpdateFundProfile($employerProfileId: ID!, $section: String!, $fundType: String, $strategy: String, $focus: String, $location: String, $fundManager: String, $aum: Int, $foundingDate: String, $description: String, $imageData: String, $cropData: String, $removeImage: Boolean, $executives: String, $firmReferences: String, $sectorExpertise: [String!], $geographicExpertise: [String!], $assetClassExpertise: [String!], $subsectorExpertise: String, $tagNames: [String!], $returns: String, $returnsUpdatedDate: String, $returnsDocuments: String, $ideaIds: [ID!], $whitePaperIds: [ID!], $holdings: String, $holdingsDocuments: String, $marketingMaterials: String, $presses: String, $sharpeRatio: Float, $beta: Float, $turnoverRatio: Float, $metricsDocuments: String, $managementFee: Float, $incentiveFee: Float, $hurdleRate: Float, $lockUp: Int, $highwaterMark: Boolean, $seedDeal: Boolean, $foundersShares: Boolean, $investorLevelGates: Boolean, $feeStructureDocuments: String, $dueDiligenceDocuments: String, $serviceProviders: String, $notes: String) {
  updateFundProfile(
    input: {employerProfileId: $employerProfileId, section: $section, fundType: $fundType, strategy: $strategy, focus: $focus, location: $location, fundManager: $fundManager, aum: $aum, foundingDate: $foundingDate, description: $description, imageData: $imageData, cropData: $cropData, removeImage: $removeImage, executives: $executives, firmReferences: $firmReferences, sectorNames: $sectorExpertise, geographyNames: $geographicExpertise, assetClassNames: $assetClassExpertise, subsectorExpertise: $subsectorExpertise, tagNames: $tagNames, returns: $returns, returnsUpdatedDate: $returnsUpdatedDate, returnsDocuments: $returnsDocuments, ideaIds: $ideaIds, whitePaperIds: $whitePaperIds, holdings: $holdings, holdingsDocuments: $holdingsDocuments, marketingMaterials: $marketingMaterials, presses: $presses, sharpeRatio: $sharpeRatio, beta: $beta, turnoverRatio: $turnoverRatio, metricsDocuments: $metricsDocuments, managementFee: $managementFee, incentiveFee: $incentiveFee, hurdleRate: $hurdleRate, lockUp: $lockUp, highwaterMark: $highwaterMark, seedDeal: $seedDeal, foundersShares: $foundersShares, investorLevelGates: $investorLevelGates, feeStructureDocuments: $feeStructureDocuments, dueDiligenceDocuments: $dueDiligenceDocuments, serviceProviders: $serviceProviders, notes: $notes}
  ) {
    employerProfile {
      aum
      foundingDate
      fundManager
      ...FundProfileBackgroundImage
      fundRecommendation {
        ...FundProfileRecommendation
      }
      pendingIntroRequest {
        id
        status
        messageThread
      }
      ...FundProfileCard
      ...FundProfileAdminDashboard
      sectionCompletenessPercents
      excludedSections
      sectionVisibilities
      ...FundProfileExecutiveManagement
      ...FundProfileFirmReferences
      ...FundProfileExpertise
      ...FundProfileTags
      ...FundProfileReturns
      ...FundProfileFeaturedResearch
      ...FundProfileFeaturedWhitePaperResearch
      ...FundProfileFundHoldings
      ...FundProfileMarketingMaterials
      ...FundProfilePressMedia
      ...FundProfileMetrics
      ...FundProfileFeeStructure
      ...FundProfileDueDiligence
      ...FundProfileNotes
      currentUserOnBlocklist
      currentUserViewCount
      currentUserHasMessagedFund
    }
  }
}
    ${FundProfileBackgroundImageFragmentDoc}
${FundProfileRecommendationFragmentDoc}
${FundProfileCardFragmentDoc}
${FundProfileAdminDashboardFragmentDoc}
${FundProfileExecutiveManagementFragmentDoc}
${FundProfileFirmReferencesFragmentDoc}
${FundProfileExpertiseFragmentDoc}
${FundProfileTagsFragmentDoc}
${FundProfileReturnsFragmentDoc}
${FundProfileFeaturedResearchFragmentDoc}
${FundProfileFeaturedWhitePaperResearchFragmentDoc}
${FundProfileFundHoldingsFragmentDoc}
${FundProfileMarketingMaterialsFragmentDoc}
${FundProfilePressMediaFragmentDoc}
${FundProfileMetricsFragmentDoc}
${FundProfileFeeStructureFragmentDoc}
${FundProfileDueDiligenceFragmentDoc}
${FundProfileNotesFragmentDoc}`;
export type UpdateFundProfileMutationFn = Apollo.MutationFunction<UpdateFundProfileMutation, UpdateFundProfileMutationVariables>;

/**
 * __useUpdateFundProfileMutation__
 *
 * To run a mutation, you first call `useUpdateFundProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFundProfileMutation, { data, loading, error }] = useUpdateFundProfileMutation({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *      section: // value for 'section'
 *      fundType: // value for 'fundType'
 *      strategy: // value for 'strategy'
 *      focus: // value for 'focus'
 *      location: // value for 'location'
 *      fundManager: // value for 'fundManager'
 *      aum: // value for 'aum'
 *      foundingDate: // value for 'foundingDate'
 *      description: // value for 'description'
 *      imageData: // value for 'imageData'
 *      cropData: // value for 'cropData'
 *      removeImage: // value for 'removeImage'
 *      executives: // value for 'executives'
 *      firmReferences: // value for 'firmReferences'
 *      sectorExpertise: // value for 'sectorExpertise'
 *      geographicExpertise: // value for 'geographicExpertise'
 *      assetClassExpertise: // value for 'assetClassExpertise'
 *      subsectorExpertise: // value for 'subsectorExpertise'
 *      tagNames: // value for 'tagNames'
 *      returns: // value for 'returns'
 *      returnsUpdatedDate: // value for 'returnsUpdatedDate'
 *      returnsDocuments: // value for 'returnsDocuments'
 *      ideaIds: // value for 'ideaIds'
 *      whitePaperIds: // value for 'whitePaperIds'
 *      holdings: // value for 'holdings'
 *      holdingsDocuments: // value for 'holdingsDocuments'
 *      marketingMaterials: // value for 'marketingMaterials'
 *      presses: // value for 'presses'
 *      sharpeRatio: // value for 'sharpeRatio'
 *      beta: // value for 'beta'
 *      turnoverRatio: // value for 'turnoverRatio'
 *      metricsDocuments: // value for 'metricsDocuments'
 *      managementFee: // value for 'managementFee'
 *      incentiveFee: // value for 'incentiveFee'
 *      hurdleRate: // value for 'hurdleRate'
 *      lockUp: // value for 'lockUp'
 *      highwaterMark: // value for 'highwaterMark'
 *      seedDeal: // value for 'seedDeal'
 *      foundersShares: // value for 'foundersShares'
 *      investorLevelGates: // value for 'investorLevelGates'
 *      feeStructureDocuments: // value for 'feeStructureDocuments'
 *      dueDiligenceDocuments: // value for 'dueDiligenceDocuments'
 *      serviceProviders: // value for 'serviceProviders'
 *      notes: // value for 'notes'
 *   },
 * });
 */
export function useUpdateFundProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFundProfileMutation, UpdateFundProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFundProfileMutation, UpdateFundProfileMutationVariables>(UpdateFundProfileDocument, options);
      }
export type UpdateFundProfileMutationHookResult = ReturnType<typeof useUpdateFundProfileMutation>;
export type UpdateFundProfileMutationResult = Apollo.MutationResult<UpdateFundProfileMutation>;
export type UpdateFundProfileMutationOptions = Apollo.BaseMutationOptions<UpdateFundProfileMutation, UpdateFundProfileMutationVariables>;
export const UpdateFundProfileBackgroundImageDocument = gql`
    mutation UpdateFundProfileBackgroundImage($employerProfileId: ID!, $imageData: String, $cropData: String, $removeImage: Boolean) {
  updateFundProfileBackgroundImage(
    input: {employerProfileId: $employerProfileId, imageData: $imageData, cropData: $cropData, removeImage: $removeImage}
  ) {
    employerProfile {
      id
      backgroundImageUrl
      backgroundImageCroppedUrl
    }
  }
}
    `;
export type UpdateFundProfileBackgroundImageMutationFn = Apollo.MutationFunction<UpdateFundProfileBackgroundImageMutation, UpdateFundProfileBackgroundImageMutationVariables>;

/**
 * __useUpdateFundProfileBackgroundImageMutation__
 *
 * To run a mutation, you first call `useUpdateFundProfileBackgroundImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundProfileBackgroundImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFundProfileBackgroundImageMutation, { data, loading, error }] = useUpdateFundProfileBackgroundImageMutation({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *      imageData: // value for 'imageData'
 *      cropData: // value for 'cropData'
 *      removeImage: // value for 'removeImage'
 *   },
 * });
 */
export function useUpdateFundProfileBackgroundImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFundProfileBackgroundImageMutation, UpdateFundProfileBackgroundImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFundProfileBackgroundImageMutation, UpdateFundProfileBackgroundImageMutationVariables>(UpdateFundProfileBackgroundImageDocument, options);
      }
export type UpdateFundProfileBackgroundImageMutationHookResult = ReturnType<typeof useUpdateFundProfileBackgroundImageMutation>;
export type UpdateFundProfileBackgroundImageMutationResult = Apollo.MutationResult<UpdateFundProfileBackgroundImageMutation>;
export type UpdateFundProfileBackgroundImageMutationOptions = Apollo.BaseMutationOptions<UpdateFundProfileBackgroundImageMutation, UpdateFundProfileBackgroundImageMutationVariables>;
export const UpdateFundProfileSectionVisibilityDocument = gql`
    mutation UpdateFundProfileSectionVisibility($employerProfileId: ID!, $section: String!, $sectionVisibility: String!) {
  updateFundProfileSectionVisibility(
    input: {employerProfileId: $employerProfileId, section: $section, sectionVisibility: $sectionVisibility}
  ) {
    employerProfile {
      id
      sectionVisibilities
    }
  }
}
    `;
export type UpdateFundProfileSectionVisibilityMutationFn = Apollo.MutationFunction<UpdateFundProfileSectionVisibilityMutation, UpdateFundProfileSectionVisibilityMutationVariables>;

/**
 * __useUpdateFundProfileSectionVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateFundProfileSectionVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundProfileSectionVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFundProfileSectionVisibilityMutation, { data, loading, error }] = useUpdateFundProfileSectionVisibilityMutation({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *      section: // value for 'section'
 *      sectionVisibility: // value for 'sectionVisibility'
 *   },
 * });
 */
export function useUpdateFundProfileSectionVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFundProfileSectionVisibilityMutation, UpdateFundProfileSectionVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFundProfileSectionVisibilityMutation, UpdateFundProfileSectionVisibilityMutationVariables>(UpdateFundProfileSectionVisibilityDocument, options);
      }
export type UpdateFundProfileSectionVisibilityMutationHookResult = ReturnType<typeof useUpdateFundProfileSectionVisibilityMutation>;
export type UpdateFundProfileSectionVisibilityMutationResult = Apollo.MutationResult<UpdateFundProfileSectionVisibilityMutation>;
export type UpdateFundProfileSectionVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateFundProfileSectionVisibilityMutation, UpdateFundProfileSectionVisibilityMutationVariables>;
export const UpdateIdeaViewsLastViewedDocument = gql`
    mutation UpdateIdeaViewsLastViewed($ideaId: ID!) {
  updateIdeaViewsLastViewed(input: {ideaId: $ideaId}) {
    idea {
      id
      newViewsCount
    }
  }
}
    `;
export type UpdateIdeaViewsLastViewedMutationFn = Apollo.MutationFunction<UpdateIdeaViewsLastViewedMutation, UpdateIdeaViewsLastViewedMutationVariables>;

/**
 * __useUpdateIdeaViewsLastViewedMutation__
 *
 * To run a mutation, you first call `useUpdateIdeaViewsLastViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdeaViewsLastViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdeaViewsLastViewedMutation, { data, loading, error }] = useUpdateIdeaViewsLastViewedMutation({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useUpdateIdeaViewsLastViewedMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdeaViewsLastViewedMutation, UpdateIdeaViewsLastViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdeaViewsLastViewedMutation, UpdateIdeaViewsLastViewedMutationVariables>(UpdateIdeaViewsLastViewedDocument, options);
      }
export type UpdateIdeaViewsLastViewedMutationHookResult = ReturnType<typeof useUpdateIdeaViewsLastViewedMutation>;
export type UpdateIdeaViewsLastViewedMutationResult = Apollo.MutationResult<UpdateIdeaViewsLastViewedMutation>;
export type UpdateIdeaViewsLastViewedMutationOptions = Apollo.BaseMutationOptions<UpdateIdeaViewsLastViewedMutation, UpdateIdeaViewsLastViewedMutationVariables>;
export const UpdateIntroRequestStatusDocument = gql`
    mutation UpdateIntroRequestStatus($status: String!, $introRequestId: ID!) {
  updateIntroRequest(input: {introRequestId: $introRequestId, status: $status}) {
    introRequest {
      id
      status
      messageThread
    }
  }
}
    `;
export type UpdateIntroRequestStatusMutationFn = Apollo.MutationFunction<UpdateIntroRequestStatusMutation, UpdateIntroRequestStatusMutationVariables>;

/**
 * __useUpdateIntroRequestStatusMutation__
 *
 * To run a mutation, you first call `useUpdateIntroRequestStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntroRequestStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntroRequestStatusMutation, { data, loading, error }] = useUpdateIntroRequestStatusMutation({
 *   variables: {
 *      status: // value for 'status'
 *      introRequestId: // value for 'introRequestId'
 *   },
 * });
 */
export function useUpdateIntroRequestStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntroRequestStatusMutation, UpdateIntroRequestStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntroRequestStatusMutation, UpdateIntroRequestStatusMutationVariables>(UpdateIntroRequestStatusDocument, options);
      }
export type UpdateIntroRequestStatusMutationHookResult = ReturnType<typeof useUpdateIntroRequestStatusMutation>;
export type UpdateIntroRequestStatusMutationResult = Apollo.MutationResult<UpdateIntroRequestStatusMutation>;
export type UpdateIntroRequestStatusMutationOptions = Apollo.BaseMutationOptions<UpdateIntroRequestStatusMutation, UpdateIntroRequestStatusMutationVariables>;
export const UpdateJobAppStatusDocument = gql`
    mutation UpdateJobAppStatus($jobApplicationId: ID!, $message: String, $status: String!) {
  updateJobAppStatus(
    input: {jobApplicationId: $jobApplicationId, message: $message, status: $status}
  ) {
    jobApplication {
      id
      status
    }
  }
}
    `;
export type UpdateJobAppStatusMutationFn = Apollo.MutationFunction<UpdateJobAppStatusMutation, UpdateJobAppStatusMutationVariables>;

/**
 * __useUpdateJobAppStatusMutation__
 *
 * To run a mutation, you first call `useUpdateJobAppStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateJobAppStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateJobAppStatusMutation, { data, loading, error }] = useUpdateJobAppStatusMutation({
 *   variables: {
 *      jobApplicationId: // value for 'jobApplicationId'
 *      message: // value for 'message'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateJobAppStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateJobAppStatusMutation, UpdateJobAppStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateJobAppStatusMutation, UpdateJobAppStatusMutationVariables>(UpdateJobAppStatusDocument, options);
      }
export type UpdateJobAppStatusMutationHookResult = ReturnType<typeof useUpdateJobAppStatusMutation>;
export type UpdateJobAppStatusMutationResult = Apollo.MutationResult<UpdateJobAppStatusMutation>;
export type UpdateJobAppStatusMutationOptions = Apollo.BaseMutationOptions<UpdateJobAppStatusMutation, UpdateJobAppStatusMutationVariables>;
export const UpdateLinkClickCountDocument = gql`
    mutation UpdateLinkClickCount($adminPostId: ID!, $clickedUrl: String!) {
  updateClickCount(input: {adminPostId: $adminPostId, clickedUrl: $clickedUrl}) {
    updatedAdminPost {
      id
    }
  }
}
    `;
export type UpdateLinkClickCountMutationFn = Apollo.MutationFunction<UpdateLinkClickCountMutation, UpdateLinkClickCountMutationVariables>;

/**
 * __useUpdateLinkClickCountMutation__
 *
 * To run a mutation, you first call `useUpdateLinkClickCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLinkClickCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLinkClickCountMutation, { data, loading, error }] = useUpdateLinkClickCountMutation({
 *   variables: {
 *      adminPostId: // value for 'adminPostId'
 *      clickedUrl: // value for 'clickedUrl'
 *   },
 * });
 */
export function useUpdateLinkClickCountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLinkClickCountMutation, UpdateLinkClickCountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLinkClickCountMutation, UpdateLinkClickCountMutationVariables>(UpdateLinkClickCountDocument, options);
      }
export type UpdateLinkClickCountMutationHookResult = ReturnType<typeof useUpdateLinkClickCountMutation>;
export type UpdateLinkClickCountMutationResult = Apollo.MutationResult<UpdateLinkClickCountMutation>;
export type UpdateLinkClickCountMutationOptions = Apollo.BaseMutationOptions<UpdateLinkClickCountMutation, UpdateLinkClickCountMutationVariables>;
export const UpdateNotificationSettingsDocument = gql`
    mutation UpdateNotificationSettings($showAll: Boolean, $showContests: Boolean, $showComments: Boolean, $showIdeas: Boolean, $showBadges: Boolean, $showRankings: Boolean, $showCapIntro: Boolean, $showFundFollower: Boolean, $showNewRecommended: Boolean, $showWatchlist: Boolean, $showWhitePapers: Boolean, $showFollowers: Boolean, $showFolloweeActivity: Boolean, $showJobVault: Boolean, $showTrendingResearch: Boolean, $showActivelyDiscussed: Boolean, $showBiggestMovers: Boolean, $showViewerIntroRequests: Boolean) {
  updateUserNotificationSettings(
    input: {showAll: $showAll, showContests: $showContests, showComments: $showComments, showIdeas: $showIdeas, showBadges: $showBadges, showRankings: $showRankings, showCapIntro: $showCapIntro, showFundFollower: $showFundFollower, showNewRecommended: $showNewRecommended, showWatchlist: $showWatchlist, showWhitePapers: $showWhitePapers, showFollowers: $showFollowers, showFolloweeActivity: $showFolloweeActivity, showJobVault: $showJobVault, showTrendingResearch: $showTrendingResearch, showActivelyDiscussed: $showActivelyDiscussed, showBiggestMovers: $showBiggestMovers, showViewerIntroRequests: $showViewerIntroRequests}
  ) {
    userNotificationSetting {
      id
      showAll
      showContests
      showComments
      showRankings
      showIdeas
      showBadges
      showCapIntro
      showFundFollower
      showNewRecommended
      showWatchlist
      showWhitePapers
      showFollowers
      showFolloweeActivity
      showJobVault
      showTrendingResearch
      showActivelyDiscussed
      showBiggestMovers
      showViewerIntroRequests
    }
  }
}
    `;
export type UpdateNotificationSettingsMutationFn = Apollo.MutationFunction<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;

/**
 * __useUpdateNotificationSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateNotificationSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNotificationSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNotificationSettingsMutation, { data, loading, error }] = useUpdateNotificationSettingsMutation({
 *   variables: {
 *      showAll: // value for 'showAll'
 *      showContests: // value for 'showContests'
 *      showComments: // value for 'showComments'
 *      showIdeas: // value for 'showIdeas'
 *      showBadges: // value for 'showBadges'
 *      showRankings: // value for 'showRankings'
 *      showCapIntro: // value for 'showCapIntro'
 *      showFundFollower: // value for 'showFundFollower'
 *      showNewRecommended: // value for 'showNewRecommended'
 *      showWatchlist: // value for 'showWatchlist'
 *      showWhitePapers: // value for 'showWhitePapers'
 *      showFollowers: // value for 'showFollowers'
 *      showFolloweeActivity: // value for 'showFolloweeActivity'
 *      showJobVault: // value for 'showJobVault'
 *      showTrendingResearch: // value for 'showTrendingResearch'
 *      showActivelyDiscussed: // value for 'showActivelyDiscussed'
 *      showBiggestMovers: // value for 'showBiggestMovers'
 *      showViewerIntroRequests: // value for 'showViewerIntroRequests'
 *   },
 * });
 */
export function useUpdateNotificationSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>(UpdateNotificationSettingsDocument, options);
      }
export type UpdateNotificationSettingsMutationHookResult = ReturnType<typeof useUpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationResult = Apollo.MutationResult<UpdateNotificationSettingsMutation>;
export type UpdateNotificationSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateNotificationSettingsMutation, UpdateNotificationSettingsMutationVariables>;
export const UpdatePaladinReviewDocument = gql`
    mutation UpdatePaladinReview($paladinReviewId: ID!, $approvedContestIdeas: [ID!], $description: String, $status: String!) {
  updatePaladinReview(
    input: {paladinReviewId: $paladinReviewId, approvedContestIdeas: $approvedContestIdeas, description: $description, status: $status}
  ) {
    paladinReview {
      id
      status
      description
    }
  }
}
    `;
export type UpdatePaladinReviewMutationFn = Apollo.MutationFunction<UpdatePaladinReviewMutation, UpdatePaladinReviewMutationVariables>;

/**
 * __useUpdatePaladinReviewMutation__
 *
 * To run a mutation, you first call `useUpdatePaladinReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaladinReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaladinReviewMutation, { data, loading, error }] = useUpdatePaladinReviewMutation({
 *   variables: {
 *      paladinReviewId: // value for 'paladinReviewId'
 *      approvedContestIdeas: // value for 'approvedContestIdeas'
 *      description: // value for 'description'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdatePaladinReviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaladinReviewMutation, UpdatePaladinReviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaladinReviewMutation, UpdatePaladinReviewMutationVariables>(UpdatePaladinReviewDocument, options);
      }
export type UpdatePaladinReviewMutationHookResult = ReturnType<typeof useUpdatePaladinReviewMutation>;
export type UpdatePaladinReviewMutationResult = Apollo.MutationResult<UpdatePaladinReviewMutation>;
export type UpdatePaladinReviewMutationOptions = Apollo.BaseMutationOptions<UpdatePaladinReviewMutation, UpdatePaladinReviewMutationVariables>;
export const UpdateReadingListItemDocument = gql`
    mutation UpdateReadingListItem($readingListItemId: ID, $archived: Boolean) {
  createOrUpdateReadingListItem(
    input: {readingListItemId: $readingListItemId, archived: $archived}
  ) {
    currentUser {
      id
    }
    readingListItem {
      ...ReadingListItem
    }
  }
}
    ${ReadingListItemFragmentDoc}`;
export type UpdateReadingListItemMutationFn = Apollo.MutationFunction<UpdateReadingListItemMutation, UpdateReadingListItemMutationVariables>;

/**
 * __useUpdateReadingListItemMutation__
 *
 * To run a mutation, you first call `useUpdateReadingListItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReadingListItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReadingListItemMutation, { data, loading, error }] = useUpdateReadingListItemMutation({
 *   variables: {
 *      readingListItemId: // value for 'readingListItemId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useUpdateReadingListItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReadingListItemMutation, UpdateReadingListItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReadingListItemMutation, UpdateReadingListItemMutationVariables>(UpdateReadingListItemDocument, options);
      }
export type UpdateReadingListItemMutationHookResult = ReturnType<typeof useUpdateReadingListItemMutation>;
export type UpdateReadingListItemMutationResult = Apollo.MutationResult<UpdateReadingListItemMutation>;
export type UpdateReadingListItemMutationOptions = Apollo.BaseMutationOptions<UpdateReadingListItemMutation, UpdateReadingListItemMutationVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($id: String!) {
  updateSubscription(input: {id: $id}) {
    subscription {
      id
      currentPeriodEnd
      description
      isAutoRenewing
    }
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const UpdateBadgeVisibilityDocument = gql`
    mutation UpdateBadgeVisibility($badgeCollectionRelationshipId: ID!, $visible: Boolean!) {
  updateBadgeVisibility(
    input: {badgeCollectionRelationshipId: $badgeCollectionRelationshipId, visible: $visible}
  ) {
    currentUser {
      id
      userBadges: badgeCollectionRelationships {
        edges {
          node {
            id
            visible
          }
        }
      }
    }
  }
}
    `;
export type UpdateBadgeVisibilityMutationFn = Apollo.MutationFunction<UpdateBadgeVisibilityMutation, UpdateBadgeVisibilityMutationVariables>;

/**
 * __useUpdateBadgeVisibilityMutation__
 *
 * To run a mutation, you first call `useUpdateBadgeVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBadgeVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBadgeVisibilityMutation, { data, loading, error }] = useUpdateBadgeVisibilityMutation({
 *   variables: {
 *      badgeCollectionRelationshipId: // value for 'badgeCollectionRelationshipId'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useUpdateBadgeVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBadgeVisibilityMutation, UpdateBadgeVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBadgeVisibilityMutation, UpdateBadgeVisibilityMutationVariables>(UpdateBadgeVisibilityDocument, options);
      }
export type UpdateBadgeVisibilityMutationHookResult = ReturnType<typeof useUpdateBadgeVisibilityMutation>;
export type UpdateBadgeVisibilityMutationResult = Apollo.MutationResult<UpdateBadgeVisibilityMutation>;
export type UpdateBadgeVisibilityMutationOptions = Apollo.BaseMutationOptions<UpdateBadgeVisibilityMutation, UpdateBadgeVisibilityMutationVariables>;
export const UpdateEmailDocument = gql`
    mutation UpdateEmail($email: String!, $password: String!) {
  updateEmail(input: {email: $email, password: $password}) {
    currentUser {
      id
      email
    }
  }
}
    `;
export type UpdateEmailMutationFn = Apollo.MutationFunction<UpdateEmailMutation, UpdateEmailMutationVariables>;

/**
 * __useUpdateEmailMutation__
 *
 * To run a mutation, you first call `useUpdateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailMutation, { data, loading, error }] = useUpdateEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useUpdateEmailMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailMutation, UpdateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailMutation, UpdateEmailMutationVariables>(UpdateEmailDocument, options);
      }
export type UpdateEmailMutationHookResult = ReturnType<typeof useUpdateEmailMutation>;
export type UpdateEmailMutationResult = Apollo.MutationResult<UpdateEmailMutation>;
export type UpdateEmailMutationOptions = Apollo.BaseMutationOptions<UpdateEmailMutation, UpdateEmailMutationVariables>;
export const UpdateEmailPreferencesDocument = gql`
    mutation UpdateEmailPreferences($activityDigestMailer: Boolean, $activityDigestMailerWeekly: Boolean, $all: Boolean, $allocatorDigest: Boolean, $buysideEventNotifications: Boolean, $buysideJobsEmail: Boolean, $capIntro: Boolean, $commentCreateAuthorFollowedIdea: Boolean, $commentCreateFollowedEntity: Boolean, $commentCreateFollowedIdea: Boolean, $commentCreateFollowedPost: Boolean, $commentCreateFollowedUser: Boolean, $commentCreateFollowedUserIdea: Boolean, $commentCreateFollowedWhitePaper: Boolean, $commentCreateFundAdmin: Boolean, $commentCreatePostAuthor: Boolean, $commentCreateWhitePaperAuthor: Boolean, $companyPriceChange: Boolean, $dailyChatDigest: Boolean, $generalRankingsEmail: Boolean, $ideaCreateFollowedEntity: Boolean, $ideaCreateFollowedUser: Boolean, $ideaToken: Boolean, $ideaUpdateCreateFollowedEntity: Boolean, $ideaUpdateCreateFollowedIdea: Boolean, $ideaUpdateCreateFollowedUser: Boolean, $memberEngagement: Boolean, $newAllocatorEnquiry: Boolean, $newAllocatorProfile: Boolean, $newAllocatorUpdateRequest: Boolean, $newBuysideUserFundProfileMessage: Boolean, $newFundProfile: Boolean, $personalRankingsEmail: Boolean, $positionCreate: Boolean, $postCreateFollowedEntity: Boolean, $postCreateFollowedSector: Boolean, $rateIdea: Boolean, $researchAccess: Boolean, $retailWeeklyMarketDispatch: Boolean, $siteNewsEmail: Boolean, $updateIdea: Boolean, $userToUser: Boolean, $viewerIntroRequest: Boolean, $weeklyDigestEmail: Boolean, $weeklyTopIdea: Boolean) {
  updateEmailPreferences(
    input: {activityDigestMailer: $activityDigestMailer, activityDigestMailerWeekly: $activityDigestMailerWeekly, all: $all, allocatorDigest: $allocatorDigest, buysideEventNotifications: $buysideEventNotifications, buysideJobsEmail: $buysideJobsEmail, capIntro: $capIntro, commentCreateAuthorFollowedIdea: $commentCreateAuthorFollowedIdea, commentCreateFollowedEntity: $commentCreateFollowedEntity, commentCreateFollowedIdea: $commentCreateFollowedIdea, commentCreateFollowedPost: $commentCreateFollowedPost, commentCreateFollowedUser: $commentCreateFollowedUser, commentCreateFollowedUserIdea: $commentCreateFollowedUserIdea, commentCreateFollowedWhitePaper: $commentCreateFollowedWhitePaper, commentCreateFundAdmin: $commentCreateFundAdmin, commentCreatePostAuthor: $commentCreatePostAuthor, commentCreateWhitePaperAuthor: $commentCreateWhitePaperAuthor, companyPriceChange: $companyPriceChange, dailyChatDigest: $dailyChatDigest, generalRankingsEmail: $generalRankingsEmail, ideaCreateFollowedEntity: $ideaCreateFollowedEntity, ideaCreateFollowedUser: $ideaCreateFollowedUser, ideaToken: $ideaToken, ideaUpdateCreateFollowedEntity: $ideaUpdateCreateFollowedEntity, ideaUpdateCreateFollowedIdea: $ideaUpdateCreateFollowedIdea, ideaUpdateCreateFollowedUser: $ideaUpdateCreateFollowedUser, memberEngagement: $memberEngagement, newAllocatorEnquiry: $newAllocatorEnquiry, newAllocatorProfile: $newAllocatorProfile, newAllocatorUpdateRequest: $newAllocatorUpdateRequest, newBuysideUserFundProfileMessage: $newBuysideUserFundProfileMessage, newFundProfile: $newFundProfile, personalRankingsEmail: $personalRankingsEmail, positionCreate: $positionCreate, postCreateFollowedEntity: $postCreateFollowedEntity, postCreateFollowedSector: $postCreateFollowedSector, rateIdea: $rateIdea, researchAccess: $researchAccess, retailWeeklyMarketDispatch: $retailWeeklyMarketDispatch, siteNewsEmail: $siteNewsEmail, updateIdea: $updateIdea, userToUser: $userToUser, viewerIntroRequest: $viewerIntroRequest, weeklyDigestEmail: $weeklyDigestEmail, weeklyTopIdea: $weeklyTopIdea}
  ) {
    currentUser {
      id
      emailPreferences {
        id
        emailType
        subscribed
      }
    }
  }
}
    `;
export type UpdateEmailPreferencesMutationFn = Apollo.MutationFunction<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;

/**
 * __useUpdateEmailPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateEmailPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailPreferencesMutation, { data, loading, error }] = useUpdateEmailPreferencesMutation({
 *   variables: {
 *      activityDigestMailer: // value for 'activityDigestMailer'
 *      activityDigestMailerWeekly: // value for 'activityDigestMailerWeekly'
 *      all: // value for 'all'
 *      allocatorDigest: // value for 'allocatorDigest'
 *      buysideEventNotifications: // value for 'buysideEventNotifications'
 *      buysideJobsEmail: // value for 'buysideJobsEmail'
 *      capIntro: // value for 'capIntro'
 *      commentCreateAuthorFollowedIdea: // value for 'commentCreateAuthorFollowedIdea'
 *      commentCreateFollowedEntity: // value for 'commentCreateFollowedEntity'
 *      commentCreateFollowedIdea: // value for 'commentCreateFollowedIdea'
 *      commentCreateFollowedPost: // value for 'commentCreateFollowedPost'
 *      commentCreateFollowedUser: // value for 'commentCreateFollowedUser'
 *      commentCreateFollowedUserIdea: // value for 'commentCreateFollowedUserIdea'
 *      commentCreateFollowedWhitePaper: // value for 'commentCreateFollowedWhitePaper'
 *      commentCreateFundAdmin: // value for 'commentCreateFundAdmin'
 *      commentCreatePostAuthor: // value for 'commentCreatePostAuthor'
 *      commentCreateWhitePaperAuthor: // value for 'commentCreateWhitePaperAuthor'
 *      companyPriceChange: // value for 'companyPriceChange'
 *      dailyChatDigest: // value for 'dailyChatDigest'
 *      generalRankingsEmail: // value for 'generalRankingsEmail'
 *      ideaCreateFollowedEntity: // value for 'ideaCreateFollowedEntity'
 *      ideaCreateFollowedUser: // value for 'ideaCreateFollowedUser'
 *      ideaToken: // value for 'ideaToken'
 *      ideaUpdateCreateFollowedEntity: // value for 'ideaUpdateCreateFollowedEntity'
 *      ideaUpdateCreateFollowedIdea: // value for 'ideaUpdateCreateFollowedIdea'
 *      ideaUpdateCreateFollowedUser: // value for 'ideaUpdateCreateFollowedUser'
 *      memberEngagement: // value for 'memberEngagement'
 *      newAllocatorEnquiry: // value for 'newAllocatorEnquiry'
 *      newAllocatorProfile: // value for 'newAllocatorProfile'
 *      newAllocatorUpdateRequest: // value for 'newAllocatorUpdateRequest'
 *      newBuysideUserFundProfileMessage: // value for 'newBuysideUserFundProfileMessage'
 *      newFundProfile: // value for 'newFundProfile'
 *      personalRankingsEmail: // value for 'personalRankingsEmail'
 *      positionCreate: // value for 'positionCreate'
 *      postCreateFollowedEntity: // value for 'postCreateFollowedEntity'
 *      postCreateFollowedSector: // value for 'postCreateFollowedSector'
 *      rateIdea: // value for 'rateIdea'
 *      researchAccess: // value for 'researchAccess'
 *      retailWeeklyMarketDispatch: // value for 'retailWeeklyMarketDispatch'
 *      siteNewsEmail: // value for 'siteNewsEmail'
 *      updateIdea: // value for 'updateIdea'
 *      userToUser: // value for 'userToUser'
 *      viewerIntroRequest: // value for 'viewerIntroRequest'
 *      weeklyDigestEmail: // value for 'weeklyDigestEmail'
 *      weeklyTopIdea: // value for 'weeklyTopIdea'
 *   },
 * });
 */
export function useUpdateEmailPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>(UpdateEmailPreferencesDocument, options);
      }
export type UpdateEmailPreferencesMutationHookResult = ReturnType<typeof useUpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationResult = Apollo.MutationResult<UpdateEmailPreferencesMutation>;
export type UpdateEmailPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateEmailPreferencesMutation, UpdateEmailPreferencesMutationVariables>;
export const UpdateFundSearchAlertDocument = gql`
    mutation UpdateFundSearchAlert($fundSearchAlertId: ID!, $name: String, $active: Boolean, $display: Boolean) {
  updateFundSearchAlert(
    input: {fundSearchAlertId: $fundSearchAlertId, name: $name, active: $active, display: $display}
  ) {
    currentUser {
      id
      fundProfileSearchAlerts {
        id
        active
        display
        name
      }
    }
  }
}
    `;
export type UpdateFundSearchAlertMutationFn = Apollo.MutationFunction<UpdateFundSearchAlertMutation, UpdateFundSearchAlertMutationVariables>;

/**
 * __useUpdateFundSearchAlertMutation__
 *
 * To run a mutation, you first call `useUpdateFundSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFundSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFundSearchAlertMutation, { data, loading, error }] = useUpdateFundSearchAlertMutation({
 *   variables: {
 *      fundSearchAlertId: // value for 'fundSearchAlertId'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      display: // value for 'display'
 *   },
 * });
 */
export function useUpdateFundSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFundSearchAlertMutation, UpdateFundSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFundSearchAlertMutation, UpdateFundSearchAlertMutationVariables>(UpdateFundSearchAlertDocument, options);
      }
export type UpdateFundSearchAlertMutationHookResult = ReturnType<typeof useUpdateFundSearchAlertMutation>;
export type UpdateFundSearchAlertMutationResult = Apollo.MutationResult<UpdateFundSearchAlertMutation>;
export type UpdateFundSearchAlertMutationOptions = Apollo.BaseMutationOptions<UpdateFundSearchAlertMutation, UpdateFundSearchAlertMutationVariables>;
export const UpdateIdeaSearchAlertDocument = gql`
    mutation UpdateIdeaSearchAlert($ideaSearchAlertId: ID!, $name: String, $active: Boolean, $frequency: String, $display: Boolean) {
  updateIdeaSearchAlert(
    input: {ideaSearchAlertId: $ideaSearchAlertId, name: $name, active: $active, frequency: $frequency, display: $display}
  ) {
    currentUser {
      id
      ideaSearchAlerts {
        id
        active
        frequency
        display
        name
      }
    }
  }
}
    `;
export type UpdateIdeaSearchAlertMutationFn = Apollo.MutationFunction<UpdateIdeaSearchAlertMutation, UpdateIdeaSearchAlertMutationVariables>;

/**
 * __useUpdateIdeaSearchAlertMutation__
 *
 * To run a mutation, you first call `useUpdateIdeaSearchAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIdeaSearchAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIdeaSearchAlertMutation, { data, loading, error }] = useUpdateIdeaSearchAlertMutation({
 *   variables: {
 *      ideaSearchAlertId: // value for 'ideaSearchAlertId'
 *      name: // value for 'name'
 *      active: // value for 'active'
 *      frequency: // value for 'frequency'
 *      display: // value for 'display'
 *   },
 * });
 */
export function useUpdateIdeaSearchAlertMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIdeaSearchAlertMutation, UpdateIdeaSearchAlertMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIdeaSearchAlertMutation, UpdateIdeaSearchAlertMutationVariables>(UpdateIdeaSearchAlertDocument, options);
      }
export type UpdateIdeaSearchAlertMutationHookResult = ReturnType<typeof useUpdateIdeaSearchAlertMutation>;
export type UpdateIdeaSearchAlertMutationResult = Apollo.MutationResult<UpdateIdeaSearchAlertMutation>;
export type UpdateIdeaSearchAlertMutationOptions = Apollo.BaseMutationOptions<UpdateIdeaSearchAlertMutation, UpdateIdeaSearchAlertMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($currentPassword: String!, $password: String!, $passwordConfirmation: String!) {
  updatePassword(
    input: {currentPassword: $currentPassword, password: $password, passwordConfirmation: $passwordConfirmation}
  ) {
    currentUser {
      id
      email
    }
  }
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      password: // value for 'password'
 *      passwordConfirmation: // value for 'passwordConfirmation'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserProfileDocument = gql`
    mutation UpdateUserProfile($profileId: ID!, $section: String!, $city: String, $summary: String, $imageData: String, $cropData: String, $removeImage: Boolean, $employerHistories: String, $sectorExpertise: [String!], $geographicExpertise: [String!], $assetClassExpertise: [String!], $schoolHistories: String, $hometown: String, $investmentHero: String, $favoriteInvestmentBook: String, $investingStyle: String, $languagesSpoken: String, $certifications: [String!], $resume: String, $workPhone: String, $profileTestResults: String, $profileAttachments: String, $profileAnswers: String, $controlIdeaAccess: Boolean = false) {
  updateUserProfile(
    input: {profileId: $profileId, section: $section, city: $city, summary: $summary, imageData: $imageData, cropData: $cropData, removeImage: $removeImage, employerHistories: $employerHistories, sectorNames: $sectorExpertise, geographyNames: $geographicExpertise, assetClassNames: $assetClassExpertise, schoolHistories: $schoolHistories, hometown: $hometown, investmentHero: $investmentHero, favoriteInvestmentBook: $favoriteInvestmentBook, investingStyle: $investingStyle, languagesSpoken: $languagesSpoken, certifications: $certifications, resume: $resume, workPhone: $workPhone, profileTestResults: $profileTestResults, profileAttachments: $profileAttachments, profileAnswers: $profileAnswers}
  ) {
    profile {
      id
      ...UserProfileCard
      ...UserProfileAdminDashboard
      ...UserProfileResearchPerformance
      ...UserProfileWorkExperience
      ...UserProfileExpertise
      ...UserProfileEducation
      ...UserProfilePersonalDetails
      ...UserProfileResumePhone
      ...UserProfileAcademicPerformance
      ...UserProfileResearch
      ...UserProfileQAndA
    }
  }
}
    ${UserProfileCardFragmentDoc}
${UserProfileAdminDashboardFragmentDoc}
${UserProfileResearchPerformanceFragmentDoc}
${UserProfileWorkExperienceFragmentDoc}
${UserProfileExpertiseFragmentDoc}
${UserProfileEducationFragmentDoc}
${UserProfilePersonalDetailsFragmentDoc}
${UserProfileResumePhoneFragmentDoc}
${UserProfileAcademicPerformanceFragmentDoc}
${UserProfileResearchFragmentDoc}
${UserProfileQAndAFragmentDoc}`;
export type UpdateUserProfileMutationFn = Apollo.MutationFunction<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;

/**
 * __useUpdateUserProfileMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileMutation, { data, loading, error }] = useUpdateUserProfileMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      section: // value for 'section'
 *      city: // value for 'city'
 *      summary: // value for 'summary'
 *      imageData: // value for 'imageData'
 *      cropData: // value for 'cropData'
 *      removeImage: // value for 'removeImage'
 *      employerHistories: // value for 'employerHistories'
 *      sectorExpertise: // value for 'sectorExpertise'
 *      geographicExpertise: // value for 'geographicExpertise'
 *      assetClassExpertise: // value for 'assetClassExpertise'
 *      schoolHistories: // value for 'schoolHistories'
 *      hometown: // value for 'hometown'
 *      investmentHero: // value for 'investmentHero'
 *      favoriteInvestmentBook: // value for 'favoriteInvestmentBook'
 *      investingStyle: // value for 'investingStyle'
 *      languagesSpoken: // value for 'languagesSpoken'
 *      certifications: // value for 'certifications'
 *      resume: // value for 'resume'
 *      workPhone: // value for 'workPhone'
 *      profileTestResults: // value for 'profileTestResults'
 *      profileAttachments: // value for 'profileAttachments'
 *      profileAnswers: // value for 'profileAnswers'
 *      controlIdeaAccess: // value for 'controlIdeaAccess'
 *   },
 * });
 */
export function useUpdateUserProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>(UpdateUserProfileDocument, options);
      }
export type UpdateUserProfileMutationHookResult = ReturnType<typeof useUpdateUserProfileMutation>;
export type UpdateUserProfileMutationResult = Apollo.MutationResult<UpdateUserProfileMutation>;
export type UpdateUserProfileMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileMutation, UpdateUserProfileMutationVariables>;
export const UpdateUserProfileBackgroundImageDocument = gql`
    mutation UpdateUserProfileBackgroundImage($profileId: ID!, $imageData: String, $cropData: String, $removeImage: Boolean) {
  updateUserProfileBackgroundImage(
    input: {profileId: $profileId, imageData: $imageData, cropData: $cropData, removeImage: $removeImage}
  ) {
    profile {
      id
      backgroundImageUrl
      backgroundImageCroppedUrl
    }
  }
}
    `;
export type UpdateUserProfileBackgroundImageMutationFn = Apollo.MutationFunction<UpdateUserProfileBackgroundImageMutation, UpdateUserProfileBackgroundImageMutationVariables>;

/**
 * __useUpdateUserProfileBackgroundImageMutation__
 *
 * To run a mutation, you first call `useUpdateUserProfileBackgroundImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserProfileBackgroundImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserProfileBackgroundImageMutation, { data, loading, error }] = useUpdateUserProfileBackgroundImageMutation({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      imageData: // value for 'imageData'
 *      cropData: // value for 'cropData'
 *      removeImage: // value for 'removeImage'
 *   },
 * });
 */
export function useUpdateUserProfileBackgroundImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserProfileBackgroundImageMutation, UpdateUserProfileBackgroundImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserProfileBackgroundImageMutation, UpdateUserProfileBackgroundImageMutationVariables>(UpdateUserProfileBackgroundImageDocument, options);
      }
export type UpdateUserProfileBackgroundImageMutationHookResult = ReturnType<typeof useUpdateUserProfileBackgroundImageMutation>;
export type UpdateUserProfileBackgroundImageMutationResult = Apollo.MutationResult<UpdateUserProfileBackgroundImageMutation>;
export type UpdateUserProfileBackgroundImageMutationOptions = Apollo.BaseMutationOptions<UpdateUserProfileBackgroundImageMutation, UpdateUserProfileBackgroundImageMutationVariables>;
export const UpdateViewerIntroRequestDocument = gql`
    mutation UpdateViewerIntroRequest($id: ID!, $status: String!) {
  updateViewerIntroRequest(input: {id: $id, status: $status}) {
    viewerIntroRequest {
      id
      status
    }
  }
}
    `;
export type UpdateViewerIntroRequestMutationFn = Apollo.MutationFunction<UpdateViewerIntroRequestMutation, UpdateViewerIntroRequestMutationVariables>;

/**
 * __useUpdateViewerIntroRequestMutation__
 *
 * To run a mutation, you first call `useUpdateViewerIntroRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateViewerIntroRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateViewerIntroRequestMutation, { data, loading, error }] = useUpdateViewerIntroRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateViewerIntroRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateViewerIntroRequestMutation, UpdateViewerIntroRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateViewerIntroRequestMutation, UpdateViewerIntroRequestMutationVariables>(UpdateViewerIntroRequestDocument, options);
      }
export type UpdateViewerIntroRequestMutationHookResult = ReturnType<typeof useUpdateViewerIntroRequestMutation>;
export type UpdateViewerIntroRequestMutationResult = Apollo.MutationResult<UpdateViewerIntroRequestMutation>;
export type UpdateViewerIntroRequestMutationOptions = Apollo.BaseMutationOptions<UpdateViewerIntroRequestMutation, UpdateViewerIntroRequestMutationVariables>;
export const CreateOrUpdateUserApplicationDocument = gql`
    mutation CreateOrUpdateUserApplication($acceptedDisclaimer: Boolean, $applicantType: String, $basicEmployerName: String, $basicInvestorType: String, $city: String, $degree: String, $email: String!, $employerAumRange: String, $employerFundType: String, $employerName: String, $employmentStatus: String, $expectedGraduation: Int, $fieldOfStudy: String, $firstName: String, $investorType: String, $isAccredited: Boolean, $lastName: String, $linkedinUrl: String, $phone: String, $referrerId: String, $resume: String, $schoolName: String, $title: String, $yearStart: Int) {
  createOrUpdateUserApplication(
    input: {acceptedDisclaimer: $acceptedDisclaimer, applicantType: $applicantType, basicEmployerName: $basicEmployerName, basicInvestorType: $basicInvestorType, city: $city, degree: $degree, email: $email, employerAumRange: $employerAumRange, employerFundType: $employerFundType, employerName: $employerName, employmentStatus: $employmentStatus, expectedGraduation: $expectedGraduation, fieldOfStudy: $fieldOfStudy, firstName: $firstName, investorType: $investorType, isAccredited: $isAccredited, lastName: $lastName, linkedinUrl: $linkedinUrl, phone: $phone, referrerId: $referrerId, resume: $resume, schoolName: $schoolName, title: $title, yearStart: $yearStart}
  ) {
    userApplication {
      id
    }
  }
}
    `;
export type CreateOrUpdateUserApplicationMutationFn = Apollo.MutationFunction<CreateOrUpdateUserApplicationMutation, CreateOrUpdateUserApplicationMutationVariables>;

/**
 * __useCreateOrUpdateUserApplicationMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateUserApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateUserApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateUserApplicationMutation, { data, loading, error }] = useCreateOrUpdateUserApplicationMutation({
 *   variables: {
 *      acceptedDisclaimer: // value for 'acceptedDisclaimer'
 *      applicantType: // value for 'applicantType'
 *      basicEmployerName: // value for 'basicEmployerName'
 *      basicInvestorType: // value for 'basicInvestorType'
 *      city: // value for 'city'
 *      degree: // value for 'degree'
 *      email: // value for 'email'
 *      employerAumRange: // value for 'employerAumRange'
 *      employerFundType: // value for 'employerFundType'
 *      employerName: // value for 'employerName'
 *      employmentStatus: // value for 'employmentStatus'
 *      expectedGraduation: // value for 'expectedGraduation'
 *      fieldOfStudy: // value for 'fieldOfStudy'
 *      firstName: // value for 'firstName'
 *      investorType: // value for 'investorType'
 *      isAccredited: // value for 'isAccredited'
 *      lastName: // value for 'lastName'
 *      linkedinUrl: // value for 'linkedinUrl'
 *      phone: // value for 'phone'
 *      referrerId: // value for 'referrerId'
 *      resume: // value for 'resume'
 *      schoolName: // value for 'schoolName'
 *      title: // value for 'title'
 *      yearStart: // value for 'yearStart'
 *   },
 * });
 */
export function useCreateOrUpdateUserApplicationMutation(baseOptions?: Apollo.MutationHookOptions<CreateOrUpdateUserApplicationMutation, CreateOrUpdateUserApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOrUpdateUserApplicationMutation, CreateOrUpdateUserApplicationMutationVariables>(CreateOrUpdateUserApplicationDocument, options);
      }
export type CreateOrUpdateUserApplicationMutationHookResult = ReturnType<typeof useCreateOrUpdateUserApplicationMutation>;
export type CreateOrUpdateUserApplicationMutationResult = Apollo.MutationResult<CreateOrUpdateUserApplicationMutation>;
export type CreateOrUpdateUserApplicationMutationOptions = Apollo.BaseMutationOptions<CreateOrUpdateUserApplicationMutation, CreateOrUpdateUserApplicationMutationVariables>;
export const ViewAllNotificationsDocument = gql`
    mutation ViewAllNotifications {
  viewAllNotifications(input: {}) {
    currentUser {
      id
      newNotificationsCount
      unreadNotificationsCount
      notifications(desc: true, first: 24) {
        edges {
          node {
            ...UserNotification
          }
        }
      }
    }
  }
}
    ${UserNotificationFragmentDoc}`;
export type ViewAllNotificationsMutationFn = Apollo.MutationFunction<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>;

/**
 * __useViewAllNotificationsMutation__
 *
 * To run a mutation, you first call `useViewAllNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewAllNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewAllNotificationsMutation, { data, loading, error }] = useViewAllNotificationsMutation({
 *   variables: {
 *   },
 * });
 */
export function useViewAllNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>(ViewAllNotificationsDocument, options);
      }
export type ViewAllNotificationsMutationHookResult = ReturnType<typeof useViewAllNotificationsMutation>;
export type ViewAllNotificationsMutationResult = Apollo.MutationResult<ViewAllNotificationsMutation>;
export type ViewAllNotificationsMutationOptions = Apollo.BaseMutationOptions<ViewAllNotificationsMutation, ViewAllNotificationsMutationVariables>;
export const ViewIdeaRecommendationDocument = gql`
    mutation ViewIdeaRecommendation($id: ID!, $userId: ID!, $ideaId: ID!) {
  viewIdeaRecommendation(input: {id: $id, userId: $userId, ideaId: $ideaId}) {
    currentUser {
      id
    }
  }
}
    `;
export type ViewIdeaRecommendationMutationFn = Apollo.MutationFunction<ViewIdeaRecommendationMutation, ViewIdeaRecommendationMutationVariables>;

/**
 * __useViewIdeaRecommendationMutation__
 *
 * To run a mutation, you first call `useViewIdeaRecommendationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewIdeaRecommendationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewIdeaRecommendationMutation, { data, loading, error }] = useViewIdeaRecommendationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      userId: // value for 'userId'
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useViewIdeaRecommendationMutation(baseOptions?: Apollo.MutationHookOptions<ViewIdeaRecommendationMutation, ViewIdeaRecommendationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewIdeaRecommendationMutation, ViewIdeaRecommendationMutationVariables>(ViewIdeaRecommendationDocument, options);
      }
export type ViewIdeaRecommendationMutationHookResult = ReturnType<typeof useViewIdeaRecommendationMutation>;
export type ViewIdeaRecommendationMutationResult = Apollo.MutationResult<ViewIdeaRecommendationMutation>;
export type ViewIdeaRecommendationMutationOptions = Apollo.BaseMutationOptions<ViewIdeaRecommendationMutation, ViewIdeaRecommendationMutationVariables>;
export const ViewNotificationDocument = gql`
    mutation ViewNotification($notificationId: ID!) {
  viewNotification(input: {notificationId: $notificationId}) {
    notification {
      id
      viewed
    }
    currentUser {
      id
      unreadNotificationsCount
    }
  }
}
    `;
export type ViewNotificationMutationFn = Apollo.MutationFunction<ViewNotificationMutation, ViewNotificationMutationVariables>;

/**
 * __useViewNotificationMutation__
 *
 * To run a mutation, you first call `useViewNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useViewNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [viewNotificationMutation, { data, loading, error }] = useViewNotificationMutation({
 *   variables: {
 *      notificationId: // value for 'notificationId'
 *   },
 * });
 */
export function useViewNotificationMutation(baseOptions?: Apollo.MutationHookOptions<ViewNotificationMutation, ViewNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ViewNotificationMutation, ViewNotificationMutationVariables>(ViewNotificationDocument, options);
      }
export type ViewNotificationMutationHookResult = ReturnType<typeof useViewNotificationMutation>;
export type ViewNotificationMutationResult = Apollo.MutationResult<ViewNotificationMutation>;
export type ViewNotificationMutationOptions = Apollo.BaseMutationOptions<ViewNotificationMutation, ViewNotificationMutationVariables>;
export const AccessProfileCurrentUserDocument = gql`
    query AccessProfileCurrentUser {
  currentUser {
    id
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    isPaladin
    isTokenBased
    inTrial
    paladin {
      ...PaladinQuota
    }
    readingListItemsCount
    ...UserAccess
    ...UserProfile
  }
}
    ${PaladinQuotaFragmentDoc}
${UserAccessFragmentDoc}
${UserProfileFragmentDoc}`;

/**
 * __useAccessProfileCurrentUserQuery__
 *
 * To run a query within a React component, call `useAccessProfileCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccessProfileCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccessProfileCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccessProfileCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>(AccessProfileCurrentUserDocument, options);
      }
export function useAccessProfileCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>(AccessProfileCurrentUserDocument, options);
        }
export function useAccessProfileCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>(AccessProfileCurrentUserDocument, options);
        }
export type AccessProfileCurrentUserQueryHookResult = ReturnType<typeof useAccessProfileCurrentUserQuery>;
export type AccessProfileCurrentUserLazyQueryHookResult = ReturnType<typeof useAccessProfileCurrentUserLazyQuery>;
export type AccessProfileCurrentUserSuspenseQueryHookResult = ReturnType<typeof useAccessProfileCurrentUserSuspenseQuery>;
export type AccessProfileCurrentUserQueryResult = Apollo.QueryResult<AccessProfileCurrentUserQuery, AccessProfileCurrentUserQueryVariables>;
export const AccreditedInvestorProfilesIndexListDocument = gql`
    query AccreditedInvestorProfilesIndexList($searchParams: String, $indexType: String!) {
  accreditedInvestorProfilesIndexList(searchParams: $searchParams) {
    ...AccreditedInvestorProfileIndexItem
  }
  indexListResultCount(searchParams: $searchParams, indexType: $indexType)
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    ${AccreditedInvestorProfileIndexItemFragmentDoc}`;

/**
 * __useAccreditedInvestorProfilesIndexListQuery__
 *
 * To run a query within a React component, call `useAccreditedInvestorProfilesIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccreditedInvestorProfilesIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccreditedInvestorProfilesIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useAccreditedInvestorProfilesIndexListQuery(baseOptions: Apollo.QueryHookOptions<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables> & ({ variables: AccreditedInvestorProfilesIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables>(AccreditedInvestorProfilesIndexListDocument, options);
      }
export function useAccreditedInvestorProfilesIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables>(AccreditedInvestorProfilesIndexListDocument, options);
        }
export function useAccreditedInvestorProfilesIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables>(AccreditedInvestorProfilesIndexListDocument, options);
        }
export type AccreditedInvestorProfilesIndexListQueryHookResult = ReturnType<typeof useAccreditedInvestorProfilesIndexListQuery>;
export type AccreditedInvestorProfilesIndexListLazyQueryHookResult = ReturnType<typeof useAccreditedInvestorProfilesIndexListLazyQuery>;
export type AccreditedInvestorProfilesIndexListSuspenseQueryHookResult = ReturnType<typeof useAccreditedInvestorProfilesIndexListSuspenseQuery>;
export type AccreditedInvestorProfilesIndexListQueryResult = Apollo.QueryResult<AccreditedInvestorProfilesIndexListQuery, AccreditedInvestorProfilesIndexListQueryVariables>;
export const ActivityFeedJoyrideDocument = gql`
    query ActivityFeedJoyride {
  currentUser {
    id
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
  }
}
    `;

/**
 * __useActivityFeedJoyrideQuery__
 *
 * To run a query within a React component, call `useActivityFeedJoyrideQuery` and pass it any options that fit your needs.
 * When your component renders, `useActivityFeedJoyrideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActivityFeedJoyrideQuery({
 *   variables: {
 *   },
 * });
 */
export function useActivityFeedJoyrideQuery(baseOptions?: Apollo.QueryHookOptions<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>(ActivityFeedJoyrideDocument, options);
      }
export function useActivityFeedJoyrideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>(ActivityFeedJoyrideDocument, options);
        }
export function useActivityFeedJoyrideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>(ActivityFeedJoyrideDocument, options);
        }
export type ActivityFeedJoyrideQueryHookResult = ReturnType<typeof useActivityFeedJoyrideQuery>;
export type ActivityFeedJoyrideLazyQueryHookResult = ReturnType<typeof useActivityFeedJoyrideLazyQuery>;
export type ActivityFeedJoyrideSuspenseQueryHookResult = ReturnType<typeof useActivityFeedJoyrideSuspenseQuery>;
export type ActivityFeedJoyrideQueryResult = Apollo.QueryResult<ActivityFeedJoyrideQuery, ActivityFeedJoyrideQueryVariables>;
export const AdminCompanyQuestionsDocument = gql`
    query AdminCompanyQuestions($entityId: ID!) {
  companyQuestions {
    id
    ...CompanyQuestion
    pollResponseData(entityId: $entityId) {
      answeredByCurrentUser
    }
    answerOptions
    responses(entityId: $entityId) {
      text
      numChose(entityId: $entityId)
    }
  }
}
    ${CompanyQuestionFragmentDoc}`;

/**
 * __useAdminCompanyQuestionsQuery__
 *
 * To run a query within a React component, call `useAdminCompanyQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdminCompanyQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminCompanyQuestionsQuery({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useAdminCompanyQuestionsQuery(baseOptions: Apollo.QueryHookOptions<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables> & ({ variables: AdminCompanyQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables>(AdminCompanyQuestionsDocument, options);
      }
export function useAdminCompanyQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables>(AdminCompanyQuestionsDocument, options);
        }
export function useAdminCompanyQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables>(AdminCompanyQuestionsDocument, options);
        }
export type AdminCompanyQuestionsQueryHookResult = ReturnType<typeof useAdminCompanyQuestionsQuery>;
export type AdminCompanyQuestionsLazyQueryHookResult = ReturnType<typeof useAdminCompanyQuestionsLazyQuery>;
export type AdminCompanyQuestionsSuspenseQueryHookResult = ReturnType<typeof useAdminCompanyQuestionsSuspenseQuery>;
export type AdminCompanyQuestionsQueryResult = Apollo.QueryResult<AdminCompanyQuestionsQuery, AdminCompanyQuestionsQueryVariables>;
export const AggregatedFeedItemsDocument = gql`
    query AggregatedFeedItems($id: ID) {
  aggregatedFeedItems(id: $id) {
    edges {
      node {
        ...ActivityFeedItem
      }
    }
  }
}
    ${ActivityFeedItemFragmentDoc}`;

/**
 * __useAggregatedFeedItemsQuery__
 *
 * To run a query within a React component, call `useAggregatedFeedItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAggregatedFeedItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAggregatedFeedItemsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAggregatedFeedItemsQuery(baseOptions?: Apollo.QueryHookOptions<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>(AggregatedFeedItemsDocument, options);
      }
export function useAggregatedFeedItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>(AggregatedFeedItemsDocument, options);
        }
export function useAggregatedFeedItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>(AggregatedFeedItemsDocument, options);
        }
export type AggregatedFeedItemsQueryHookResult = ReturnType<typeof useAggregatedFeedItemsQuery>;
export type AggregatedFeedItemsLazyQueryHookResult = ReturnType<typeof useAggregatedFeedItemsLazyQuery>;
export type AggregatedFeedItemsSuspenseQueryHookResult = ReturnType<typeof useAggregatedFeedItemsSuspenseQuery>;
export type AggregatedFeedItemsQueryResult = Apollo.QueryResult<AggregatedFeedItemsQuery, AggregatedFeedItemsQueryVariables>;
export const AllocatorBlocklistDocument = gql`
    query allocatorBlocklist($id: ID!) {
  fundProfile(id: $id) {
    id
    allocatorBlocklist {
      id
      allocatorProfile {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useAllocatorBlocklistQuery__
 *
 * To run a query within a React component, call `useAllocatorBlocklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocatorBlocklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocatorBlocklistQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAllocatorBlocklistQuery(baseOptions: Apollo.QueryHookOptions<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables> & ({ variables: AllocatorBlocklistQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables>(AllocatorBlocklistDocument, options);
      }
export function useAllocatorBlocklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables>(AllocatorBlocklistDocument, options);
        }
export function useAllocatorBlocklistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables>(AllocatorBlocklistDocument, options);
        }
export type AllocatorBlocklistQueryHookResult = ReturnType<typeof useAllocatorBlocklistQuery>;
export type AllocatorBlocklistLazyQueryHookResult = ReturnType<typeof useAllocatorBlocklistLazyQuery>;
export type AllocatorBlocklistSuspenseQueryHookResult = ReturnType<typeof useAllocatorBlocklistSuspenseQuery>;
export type AllocatorBlocklistQueryResult = Apollo.QueryResult<AllocatorBlocklistQuery, AllocatorBlocklistQueryVariables>;
export const AllocatorProfileCurrentUserDocument = gql`
    query AllocatorProfileCurrentUser {
  currentUser {
    id
    isCapIntroMember
    adminFundProfiles {
      id
      name
    }
  }
}
    `;

/**
 * __useAllocatorProfileCurrentUserQuery__
 *
 * To run a query within a React component, call `useAllocatorProfileCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocatorProfileCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocatorProfileCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllocatorProfileCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>(AllocatorProfileCurrentUserDocument, options);
      }
export function useAllocatorProfileCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>(AllocatorProfileCurrentUserDocument, options);
        }
export function useAllocatorProfileCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>(AllocatorProfileCurrentUserDocument, options);
        }
export type AllocatorProfileCurrentUserQueryHookResult = ReturnType<typeof useAllocatorProfileCurrentUserQuery>;
export type AllocatorProfileCurrentUserLazyQueryHookResult = ReturnType<typeof useAllocatorProfileCurrentUserLazyQuery>;
export type AllocatorProfileCurrentUserSuspenseQueryHookResult = ReturnType<typeof useAllocatorProfileCurrentUserSuspenseQuery>;
export type AllocatorProfileCurrentUserQueryResult = Apollo.QueryResult<AllocatorProfileCurrentUserQuery, AllocatorProfileCurrentUserQueryVariables>;
export const AllocatorProfileIndexListDocument = gql`
    query AllocatorProfileIndexList($searchParams: String, $indexType: String!) {
  allocatorProfilesIndexList(searchParams: $searchParams) {
    ...AllocatorProfileCard
  }
  allocatorProfilesIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: $indexType
  )
}
    ${AllocatorProfileCardFragmentDoc}`;

/**
 * __useAllocatorProfileIndexListQuery__
 *
 * To run a query within a React component, call `useAllocatorProfileIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocatorProfileIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocatorProfileIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useAllocatorProfileIndexListQuery(baseOptions: Apollo.QueryHookOptions<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables> & ({ variables: AllocatorProfileIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables>(AllocatorProfileIndexListDocument, options);
      }
export function useAllocatorProfileIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables>(AllocatorProfileIndexListDocument, options);
        }
export function useAllocatorProfileIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables>(AllocatorProfileIndexListDocument, options);
        }
export type AllocatorProfileIndexListQueryHookResult = ReturnType<typeof useAllocatorProfileIndexListQuery>;
export type AllocatorProfileIndexListLazyQueryHookResult = ReturnType<typeof useAllocatorProfileIndexListLazyQuery>;
export type AllocatorProfileIndexListSuspenseQueryHookResult = ReturnType<typeof useAllocatorProfileIndexListSuspenseQuery>;
export type AllocatorProfileIndexListQueryResult = Apollo.QueryResult<AllocatorProfileIndexListQuery, AllocatorProfileIndexListQueryVariables>;
export const AllocatorProfileRecommendationsDocument = gql`
    query AllocatorProfileRecommendations($showAll: Boolean, $fundProfileId: ID) {
  allocatorRecommendations(showAll: $showAll, fundProfileId: $fundProfileId) {
    edges {
      node {
        ...AllocatorProfileRecommendation
      }
    }
  }
}
    ${AllocatorProfileRecommendationFragmentDoc}`;

/**
 * __useAllocatorProfileRecommendationsQuery__
 *
 * To run a query within a React component, call `useAllocatorProfileRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocatorProfileRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocatorProfileRecommendationsQuery({
 *   variables: {
 *      showAll: // value for 'showAll'
 *      fundProfileId: // value for 'fundProfileId'
 *   },
 * });
 */
export function useAllocatorProfileRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>(AllocatorProfileRecommendationsDocument, options);
      }
export function useAllocatorProfileRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>(AllocatorProfileRecommendationsDocument, options);
        }
export function useAllocatorProfileRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>(AllocatorProfileRecommendationsDocument, options);
        }
export type AllocatorProfileRecommendationsQueryHookResult = ReturnType<typeof useAllocatorProfileRecommendationsQuery>;
export type AllocatorProfileRecommendationsLazyQueryHookResult = ReturnType<typeof useAllocatorProfileRecommendationsLazyQuery>;
export type AllocatorProfileRecommendationsSuspenseQueryHookResult = ReturnType<typeof useAllocatorProfileRecommendationsSuspenseQuery>;
export type AllocatorProfileRecommendationsQueryResult = Apollo.QueryResult<AllocatorProfileRecommendationsQuery, AllocatorProfileRecommendationsQueryVariables>;
export const AllocatorProfileShowPageDocument = gql`
    query AllocatorProfileShowPage($allocatorProfileId: ID!) {
  currentUser {
    id
    adminFunds {
      id
      primary
      employer {
        id
        employerProfile {
          id
          alreadyRequestedIntro(allocatorProfileId: $allocatorProfileId)
          introRequestPeriodEnd
          introRequestsLeft
          isAllocatorBlocklisted(allocatorProfileId: $allocatorProfileId)
          status
        }
        name
      }
    }
    isAllocator
    isAllocatorAdmin(allocatorProfileId: $allocatorProfileId)
  }
  allocatorProfile(id: $allocatorProfileId) {
    ...AllocatorProfileBackgroundImage
    ...AllocatorProfileCard
    ...AllocatorProfileExecutiveManagement
    ...AllocatorProfileInvestmentPreferences
    allocatorRecommendation {
      ...AllocatorProfileRecommendation
    }
    investmentCriteria
    recentlyJoined
  }
}
    ${AllocatorProfileBackgroundImageFragmentDoc}
${AllocatorProfileCardFragmentDoc}
${AllocatorProfileExecutiveManagementFragmentDoc}
${AllocatorProfileInvestmentPreferencesFragmentDoc}
${AllocatorProfileRecommendationFragmentDoc}`;

/**
 * __useAllocatorProfileShowPageQuery__
 *
 * To run a query within a React component, call `useAllocatorProfileShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllocatorProfileShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllocatorProfileShowPageQuery({
 *   variables: {
 *      allocatorProfileId: // value for 'allocatorProfileId'
 *   },
 * });
 */
export function useAllocatorProfileShowPageQuery(baseOptions: Apollo.QueryHookOptions<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables> & ({ variables: AllocatorProfileShowPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables>(AllocatorProfileShowPageDocument, options);
      }
export function useAllocatorProfileShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables>(AllocatorProfileShowPageDocument, options);
        }
export function useAllocatorProfileShowPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables>(AllocatorProfileShowPageDocument, options);
        }
export type AllocatorProfileShowPageQueryHookResult = ReturnType<typeof useAllocatorProfileShowPageQuery>;
export type AllocatorProfileShowPageLazyQueryHookResult = ReturnType<typeof useAllocatorProfileShowPageLazyQuery>;
export type AllocatorProfileShowPageSuspenseQueryHookResult = ReturnType<typeof useAllocatorProfileShowPageSuspenseQuery>;
export type AllocatorProfileShowPageQueryResult = Apollo.QueryResult<AllocatorProfileShowPageQuery, AllocatorProfileShowPageQueryVariables>;
export const AnonymousCurrentUserDocument = gql`
    query AnonymousCurrentUser {
  currentUser {
    id
    username
    profileCity
    mostRecentEmployer {
      id
      title
      employer {
        id
        aumRange
        fundType
      }
    }
  }
}
    `;

/**
 * __useAnonymousCurrentUserQuery__
 *
 * To run a query within a React component, call `useAnonymousCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnonymousCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnonymousCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useAnonymousCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>(AnonymousCurrentUserDocument, options);
      }
export function useAnonymousCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>(AnonymousCurrentUserDocument, options);
        }
export function useAnonymousCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>(AnonymousCurrentUserDocument, options);
        }
export type AnonymousCurrentUserQueryHookResult = ReturnType<typeof useAnonymousCurrentUserQuery>;
export type AnonymousCurrentUserLazyQueryHookResult = ReturnType<typeof useAnonymousCurrentUserLazyQuery>;
export type AnonymousCurrentUserSuspenseQueryHookResult = ReturnType<typeof useAnonymousCurrentUserSuspenseQuery>;
export type AnonymousCurrentUserQueryResult = Apollo.QueryResult<AnonymousCurrentUserQuery, AnonymousCurrentUserQueryVariables>;
export const AssetQuoteDocument = gql`
    query AssetQuote($id: ID!, $timeframe: String) {
  asset(id: $id) {
    id
    primarySymbol
    currencyCode
    priceHistory(timeframe: $timeframe) {
      price
      date
    }
    ideasInTimeframe(timeframe: $timeframe) {
      edges {
        node {
          id
          elevatorPitch
          createdAt: openedAt
          totalReturn
          returnTarget
          positions {
            id
            direction
            priceTarget
            asset {
              id
              primarySymbol
            }
          }
          user {
            id
            displayName
            mostRecentEmployer {
              id
              title
            }
            profileImageUrl
          }
        }
      }
    }
    ideaUpdatesInTimeframe(timeframe: $timeframe) {
      edges {
        node {
          id
          createdAt
          closed
          impact
          text
          idea {
            id
            elevatorPitch
            createdAt
            totalReturn
            returnTarget
            positions {
              id
              direction
              priceTarget
              asset {
                id
                primarySymbol
              }
            }
            user {
              id
              displayName
              mostRecentEmployer {
                id
                title
              }
              profileImageUrl
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAssetQuoteQuery__
 *
 * To run a query within a React component, call `useAssetQuoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssetQuoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssetQuoteQuery({
 *   variables: {
 *      id: // value for 'id'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useAssetQuoteQuery(baseOptions: Apollo.QueryHookOptions<AssetQuoteQuery, AssetQuoteQueryVariables> & ({ variables: AssetQuoteQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AssetQuoteQuery, AssetQuoteQueryVariables>(AssetQuoteDocument, options);
      }
export function useAssetQuoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AssetQuoteQuery, AssetQuoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AssetQuoteQuery, AssetQuoteQueryVariables>(AssetQuoteDocument, options);
        }
export function useAssetQuoteSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AssetQuoteQuery, AssetQuoteQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AssetQuoteQuery, AssetQuoteQueryVariables>(AssetQuoteDocument, options);
        }
export type AssetQuoteQueryHookResult = ReturnType<typeof useAssetQuoteQuery>;
export type AssetQuoteLazyQueryHookResult = ReturnType<typeof useAssetQuoteLazyQuery>;
export type AssetQuoteSuspenseQueryHookResult = ReturnType<typeof useAssetQuoteSuspenseQuery>;
export type AssetQuoteQueryResult = Apollo.QueryResult<AssetQuoteQuery, AssetQuoteQueryVariables>;
export const BillingAddressDocument = gql`
    query BillingAddress {
  currentUser {
    id
    billingAddress {
      address {
        city
        lineOne
        lineTwo
        postalCode
        state
        country
      }
      name
      email
    }
    subscriptions {
      status
    }
  }
}
    `;

/**
 * __useBillingAddressQuery__
 *
 * To run a query within a React component, call `useBillingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingAddressQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingAddressQuery(baseOptions?: Apollo.QueryHookOptions<BillingAddressQuery, BillingAddressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingAddressQuery, BillingAddressQueryVariables>(BillingAddressDocument, options);
      }
export function useBillingAddressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingAddressQuery, BillingAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingAddressQuery, BillingAddressQueryVariables>(BillingAddressDocument, options);
        }
export function useBillingAddressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingAddressQuery, BillingAddressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingAddressQuery, BillingAddressQueryVariables>(BillingAddressDocument, options);
        }
export type BillingAddressQueryHookResult = ReturnType<typeof useBillingAddressQuery>;
export type BillingAddressLazyQueryHookResult = ReturnType<typeof useBillingAddressLazyQuery>;
export type BillingAddressSuspenseQueryHookResult = ReturnType<typeof useBillingAddressSuspenseQuery>;
export type BillingAddressQueryResult = Apollo.QueryResult<BillingAddressQuery, BillingAddressQueryVariables>;
export const BillingHistoryDocument = gql`
    query BillingHistory {
  currentUser {
    id
    billingHistory {
      paidDate {
        year
        month
        day
      }
      amount
      description
      status
    }
    stripeCustomerId
  }
}
    `;

/**
 * __useBillingHistoryQuery__
 *
 * To run a query within a React component, call `useBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBillingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBillingHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useBillingHistoryQuery(baseOptions?: Apollo.QueryHookOptions<BillingHistoryQuery, BillingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BillingHistoryQuery, BillingHistoryQueryVariables>(BillingHistoryDocument, options);
      }
export function useBillingHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BillingHistoryQuery, BillingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BillingHistoryQuery, BillingHistoryQueryVariables>(BillingHistoryDocument, options);
        }
export function useBillingHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BillingHistoryQuery, BillingHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BillingHistoryQuery, BillingHistoryQueryVariables>(BillingHistoryDocument, options);
        }
export type BillingHistoryQueryHookResult = ReturnType<typeof useBillingHistoryQuery>;
export type BillingHistoryLazyQueryHookResult = ReturnType<typeof useBillingHistoryLazyQuery>;
export type BillingHistorySuspenseQueryHookResult = ReturnType<typeof useBillingHistorySuspenseQuery>;
export type BillingHistoryQueryResult = Apollo.QueryResult<BillingHistoryQuery, BillingHistoryQueryVariables>;
export const BlogPostsDocument = gql`
    query BlogPosts($number: Int!, $featured: Boolean!) {
  blogPosts(number: $number, featured: $featured) {
    id
    title
    preview
    blogPostImage
  }
}
    `;

/**
 * __useBlogPostsQuery__
 *
 * To run a query within a React component, call `useBlogPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBlogPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBlogPostsQuery({
 *   variables: {
 *      number: // value for 'number'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useBlogPostsQuery(baseOptions: Apollo.QueryHookOptions<BlogPostsQuery, BlogPostsQueryVariables> & ({ variables: BlogPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BlogPostsQuery, BlogPostsQueryVariables>(BlogPostsDocument, options);
      }
export function useBlogPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BlogPostsQuery, BlogPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BlogPostsQuery, BlogPostsQueryVariables>(BlogPostsDocument, options);
        }
export function useBlogPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BlogPostsQuery, BlogPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BlogPostsQuery, BlogPostsQueryVariables>(BlogPostsDocument, options);
        }
export type BlogPostsQueryHookResult = ReturnType<typeof useBlogPostsQuery>;
export type BlogPostsLazyQueryHookResult = ReturnType<typeof useBlogPostsLazyQuery>;
export type BlogPostsSuspenseQueryHookResult = ReturnType<typeof useBlogPostsSuspenseQuery>;
export type BlogPostsQueryResult = Apollo.QueryResult<BlogPostsQuery, BlogPostsQueryVariables>;
export const ChatDocument = gql`
    query Chat($id: ID!, $cursor: String) {
  chat(id: $id) {
    id
    canCurrentUserChatPublicly
    chatMessagesCount
    chatMessages(first: 10, after: $cursor) {
      edges {
        node {
          ...ChatMessage
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    chattableName
    chattableUrl
    unreadMessagesCount
  }
}
    ${ChatMessageFragmentDoc}`;

/**
 * __useChatQuery__
 *
 * To run a query within a React component, call `useChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useChatQuery(baseOptions: Apollo.QueryHookOptions<ChatQuery, ChatQueryVariables> & ({ variables: ChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
      }
export function useChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatQuery, ChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
        }
export function useChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ChatQuery, ChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
        }
export type ChatQueryHookResult = ReturnType<typeof useChatQuery>;
export type ChatLazyQueryHookResult = ReturnType<typeof useChatLazyQuery>;
export type ChatSuspenseQueryHookResult = ReturnType<typeof useChatSuspenseQuery>;
export type ChatQueryResult = Apollo.QueryResult<ChatQuery, ChatQueryVariables>;
export const CitySearchDocument = gql`
    query CitySearch($query: String) {
  citySearch(query: $query)
}
    `;

/**
 * __useCitySearchQuery__
 *
 * To run a query within a React component, call `useCitySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useCitySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCitySearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useCitySearchQuery(baseOptions?: Apollo.QueryHookOptions<CitySearchQuery, CitySearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CitySearchQuery, CitySearchQueryVariables>(CitySearchDocument, options);
      }
export function useCitySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CitySearchQuery, CitySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CitySearchQuery, CitySearchQueryVariables>(CitySearchDocument, options);
        }
export function useCitySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CitySearchQuery, CitySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CitySearchQuery, CitySearchQueryVariables>(CitySearchDocument, options);
        }
export type CitySearchQueryHookResult = ReturnType<typeof useCitySearchQuery>;
export type CitySearchLazyQueryHookResult = ReturnType<typeof useCitySearchLazyQuery>;
export type CitySearchSuspenseQueryHookResult = ReturnType<typeof useCitySearchSuspenseQuery>;
export type CitySearchQueryResult = Apollo.QueryResult<CitySearchQuery, CitySearchQueryVariables>;
export const CommentsDocument = gql`
    query Comments($cursor: String, $feedItemId: ID!) {
  feedItemComments(feedItemId: $feedItemId, first: 10, after: $cursor) {
    edges {
      node {
        ...ActivityFeedComment
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  feedItemShow(feedItemId: $feedItemId) {
    id
    feedItemMentionables {
      id
      display
    }
  }
}
    ${ActivityFeedCommentFragmentDoc}`;

/**
 * __useCommentsQuery__
 *
 * To run a query within a React component, call `useCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      feedItemId: // value for 'feedItemId'
 *   },
 * });
 */
export function useCommentsQuery(baseOptions: Apollo.QueryHookOptions<CommentsQuery, CommentsQueryVariables> & ({ variables: CommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
      }
export function useCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export function useCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommentsQuery, CommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommentsQuery, CommentsQueryVariables>(CommentsDocument, options);
        }
export type CommentsQueryHookResult = ReturnType<typeof useCommentsQuery>;
export type CommentsLazyQueryHookResult = ReturnType<typeof useCommentsLazyQuery>;
export type CommentsSuspenseQueryHookResult = ReturnType<typeof useCommentsSuspenseQuery>;
export type CommentsQueryResult = Apollo.QueryResult<CommentsQuery, CommentsQueryVariables>;
export const CommunitySuggestionsDocument = gql`
    query CommunitySuggestions($pageSize: Int, $afterCursor: String) {
  recommendedUsersToFollow(first: $pageSize, after: $afterCursor) {
    edges {
      node {
        id
        displayName
        currentEmployerName
        profileImageUrl
        publishedIdeasCount
        currentRanksCount
        wroteOnWatchlistedSectors
        featuredRankForCurrentUserWatchlist {
          id
          category
          value
        }
        sectorsWroteOn
        mostRecentEmployer {
          id
          title
          employer {
            id
            aumRange
            fundType
          }
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    `;

/**
 * __useCommunitySuggestionsQuery__
 *
 * To run a query within a React component, call `useCommunitySuggestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCommunitySuggestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCommunitySuggestionsQuery({
 *   variables: {
 *      pageSize: // value for 'pageSize'
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useCommunitySuggestionsQuery(baseOptions?: Apollo.QueryHookOptions<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>(CommunitySuggestionsDocument, options);
      }
export function useCommunitySuggestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>(CommunitySuggestionsDocument, options);
        }
export function useCommunitySuggestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>(CommunitySuggestionsDocument, options);
        }
export type CommunitySuggestionsQueryHookResult = ReturnType<typeof useCommunitySuggestionsQuery>;
export type CommunitySuggestionsLazyQueryHookResult = ReturnType<typeof useCommunitySuggestionsLazyQuery>;
export type CommunitySuggestionsSuspenseQueryHookResult = ReturnType<typeof useCommunitySuggestionsSuspenseQuery>;
export type CommunitySuggestionsQueryResult = Apollo.QueryResult<CommunitySuggestionsQuery, CommunitySuggestionsQueryVariables>;
export const CompensationIndexListDocument = gql`
    query compensationIndexList($searchParams: String, $indexType: String!) {
  compensationIndexList(searchParams: $searchParams) {
    edges {
      node {
        id
        title
        location
        baseSalary
        year
        category
        experience
        fundType
        fundSize
        interestIncentiveFeesValue
        interestMgmtFeesValue
        annualDiscrBonus
        totalCashComp
        postedAt
        interestIncentiveFeesPerc
        vestingIncentiveFees
        interestMgmtFeesPerc
        vestingMgmtFees
        totalDeferredComp
        totalCashDeferredComp
        fundStrategy
        industry
        assetClass
        pieChartData
        investInFund
        buildPersonalTrackRecord
        marketPersonalTrackRecord
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  compensationIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: $indexType
  )
  compensationStatistics(searchParams: $searchParams) {
    maxComp
    mean
    minComp
    median
  }
  currentUser {
    id
    draftCompensations {
      id
    }
    isAdmin
    canCreateCompensations: canAccess(resource: "compensation", permission: "write")
  }
}
    `;

/**
 * __useCompensationIndexListQuery__
 *
 * To run a query within a React component, call `useCompensationIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompensationIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompensationIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useCompensationIndexListQuery(baseOptions: Apollo.QueryHookOptions<CompensationIndexListQuery, CompensationIndexListQueryVariables> & ({ variables: CompensationIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompensationIndexListQuery, CompensationIndexListQueryVariables>(CompensationIndexListDocument, options);
      }
export function useCompensationIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompensationIndexListQuery, CompensationIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompensationIndexListQuery, CompensationIndexListQueryVariables>(CompensationIndexListDocument, options);
        }
export function useCompensationIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompensationIndexListQuery, CompensationIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompensationIndexListQuery, CompensationIndexListQueryVariables>(CompensationIndexListDocument, options);
        }
export type CompensationIndexListQueryHookResult = ReturnType<typeof useCompensationIndexListQuery>;
export type CompensationIndexListLazyQueryHookResult = ReturnType<typeof useCompensationIndexListLazyQuery>;
export type CompensationIndexListSuspenseQueryHookResult = ReturnType<typeof useCompensationIndexListSuspenseQuery>;
export type CompensationIndexListQueryResult = Apollo.QueryResult<CompensationIndexListQuery, CompensationIndexListQueryVariables>;
export const CompensationSubmissionCompensationDocument = gql`
    query compensationSubmissionCompensation($actualId: ID, $estimatedId: ID) {
  actualCompensation: compensation(id: $actualId) {
    ...CompensationFields
  }
  estimatedCompensation: compensation(id: $estimatedId) {
    ...CompensationFields
  }
}
    ${CompensationFieldsFragmentDoc}`;

/**
 * __useCompensationSubmissionCompensationQuery__
 *
 * To run a query within a React component, call `useCompensationSubmissionCompensationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompensationSubmissionCompensationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompensationSubmissionCompensationQuery({
 *   variables: {
 *      actualId: // value for 'actualId'
 *      estimatedId: // value for 'estimatedId'
 *   },
 * });
 */
export function useCompensationSubmissionCompensationQuery(baseOptions?: Apollo.QueryHookOptions<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>(CompensationSubmissionCompensationDocument, options);
      }
export function useCompensationSubmissionCompensationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>(CompensationSubmissionCompensationDocument, options);
        }
export function useCompensationSubmissionCompensationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>(CompensationSubmissionCompensationDocument, options);
        }
export type CompensationSubmissionCompensationQueryHookResult = ReturnType<typeof useCompensationSubmissionCompensationQuery>;
export type CompensationSubmissionCompensationLazyQueryHookResult = ReturnType<typeof useCompensationSubmissionCompensationLazyQuery>;
export type CompensationSubmissionCompensationSuspenseQueryHookResult = ReturnType<typeof useCompensationSubmissionCompensationSuspenseQuery>;
export type CompensationSubmissionCompensationQueryResult = Apollo.QueryResult<CompensationSubmissionCompensationQuery, CompensationSubmissionCompensationQueryVariables>;
export const ContestIndexDocument = gql`
    query contestIndex($afterCursor: String, $pageSize: Int) {
  contestIndex(first: $pageSize, after: $afterCursor) {
    edges {
      node {
        ...ContestIndexCard
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  featuredContests {
    ...ContestIndexCard
  }
}
    ${ContestIndexCardFragmentDoc}`;

/**
 * __useContestIndexQuery__
 *
 * To run a query within a React component, call `useContestIndexQuery` and pass it any options that fit your needs.
 * When your component renders, `useContestIndexQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContestIndexQuery({
 *   variables: {
 *      afterCursor: // value for 'afterCursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useContestIndexQuery(baseOptions?: Apollo.QueryHookOptions<ContestIndexQuery, ContestIndexQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContestIndexQuery, ContestIndexQueryVariables>(ContestIndexDocument, options);
      }
export function useContestIndexLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContestIndexQuery, ContestIndexQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContestIndexQuery, ContestIndexQueryVariables>(ContestIndexDocument, options);
        }
export function useContestIndexSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContestIndexQuery, ContestIndexQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContestIndexQuery, ContestIndexQueryVariables>(ContestIndexDocument, options);
        }
export type ContestIndexQueryHookResult = ReturnType<typeof useContestIndexQuery>;
export type ContestIndexLazyQueryHookResult = ReturnType<typeof useContestIndexLazyQuery>;
export type ContestIndexSuspenseQueryHookResult = ReturnType<typeof useContestIndexSuspenseQuery>;
export type ContestIndexQueryResult = Apollo.QueryResult<ContestIndexQuery, ContestIndexQueryVariables>;
export const ContestShowDocument = gql`
    query ContestShow($contestId: ID!) {
  contest(id: $contestId) {
    id
    active
    awardWinners {
      ...IdeaResearchItem
    }
    name
    summary
    promoSummary
    prizes {
      id
      description
      sponsorImage
      sponsorTrackingLink
    }
    sponsors {
      id
      sponsorImage
      sponsorTrackingLink
    }
    countdownDate
    startDate
    endDate
    judges {
      id
      sanitizedDisplayName
      sanitizedProfilePictureUrl
      sanitizedProfileUrl
      sanitizedEmployerString
      sanitizedEmployerUrl
    }
    isCurrentUserJudge
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useContestShowQuery__
 *
 * To run a query within a React component, call `useContestShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useContestShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContestShowQuery({
 *   variables: {
 *      contestId: // value for 'contestId'
 *   },
 * });
 */
export function useContestShowQuery(baseOptions: Apollo.QueryHookOptions<ContestShowQuery, ContestShowQueryVariables> & ({ variables: ContestShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContestShowQuery, ContestShowQueryVariables>(ContestShowDocument, options);
      }
export function useContestShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContestShowQuery, ContestShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContestShowQuery, ContestShowQueryVariables>(ContestShowDocument, options);
        }
export function useContestShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContestShowQuery, ContestShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContestShowQuery, ContestShowQueryVariables>(ContestShowDocument, options);
        }
export type ContestShowQueryHookResult = ReturnType<typeof useContestShowQuery>;
export type ContestShowLazyQueryHookResult = ReturnType<typeof useContestShowLazyQuery>;
export type ContestShowSuspenseQueryHookResult = ReturnType<typeof useContestShowSuspenseQuery>;
export type ContestShowQueryResult = Apollo.QueryResult<ContestShowQuery, ContestShowQueryVariables>;
export const CryptoStatsDocument = gql`
    query CryptoStats($id: ID!) {
  entity(id: $id) {
    id
    primaryAsset {
      id
      companyData {
        id
        country
        geography
        industry
        sector
      }
      currencyCode
      fiftyTwoWeekRange
      cryptoMarketData {
        ...CryptoQuote
      }
    }
  }
}
    ${CryptoQuoteFragmentDoc}`;

/**
 * __useCryptoStatsQuery__
 *
 * To run a query within a React component, call `useCryptoStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCryptoStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCryptoStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCryptoStatsQuery(baseOptions: Apollo.QueryHookOptions<CryptoStatsQuery, CryptoStatsQueryVariables> & ({ variables: CryptoStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CryptoStatsQuery, CryptoStatsQueryVariables>(CryptoStatsDocument, options);
      }
export function useCryptoStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CryptoStatsQuery, CryptoStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CryptoStatsQuery, CryptoStatsQueryVariables>(CryptoStatsDocument, options);
        }
export function useCryptoStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CryptoStatsQuery, CryptoStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CryptoStatsQuery, CryptoStatsQueryVariables>(CryptoStatsDocument, options);
        }
export type CryptoStatsQueryHookResult = ReturnType<typeof useCryptoStatsQuery>;
export type CryptoStatsLazyQueryHookResult = ReturnType<typeof useCryptoStatsLazyQuery>;
export type CryptoStatsSuspenseQueryHookResult = ReturnType<typeof useCryptoStatsSuspenseQuery>;
export type CryptoStatsQueryResult = Apollo.QueryResult<CryptoStatsQuery, CryptoStatsQueryVariables>;
export const CurrentRankingDocument = gql`
    query currentRanking($category: String!) {
  currentRankingForCategory(category: $category) {
    date
    confidence
  }
}
    `;

/**
 * __useCurrentRankingQuery__
 *
 * To run a query within a React component, call `useCurrentRankingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRankingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRankingQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useCurrentRankingQuery(baseOptions: Apollo.QueryHookOptions<CurrentRankingQuery, CurrentRankingQueryVariables> & ({ variables: CurrentRankingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRankingQuery, CurrentRankingQueryVariables>(CurrentRankingDocument, options);
      }
export function useCurrentRankingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRankingQuery, CurrentRankingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRankingQuery, CurrentRankingQueryVariables>(CurrentRankingDocument, options);
        }
export function useCurrentRankingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentRankingQuery, CurrentRankingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRankingQuery, CurrentRankingQueryVariables>(CurrentRankingDocument, options);
        }
export type CurrentRankingQueryHookResult = ReturnType<typeof useCurrentRankingQuery>;
export type CurrentRankingLazyQueryHookResult = ReturnType<typeof useCurrentRankingLazyQuery>;
export type CurrentRankingSuspenseQueryHookResult = ReturnType<typeof useCurrentRankingSuspenseQuery>;
export type CurrentRankingQueryResult = Apollo.QueryResult<CurrentRankingQuery, CurrentRankingQueryVariables>;
export const CurrentUserDocument = gql`
    query CurrentUser {
  currentUser {
    id
    adminFundProfiles {
      id
      sectionCompletenessPercents
      sectionVisibilities
      ...FundProfileReturns
    }
    acceptedPostTerms
    canComment: canAccess(resource: "idea_comments", permission: "write")
    canCommentAnonymously
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    canWriteWhitePapers: canAccess(resource: "white_papers", permission: "write")
    canPost: isBuyside
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
    hasCompletedOnboarding
    isAdmin
    isAllocator
    isPaladin
    isRetail
    mostRecentEmployer {
      id
      currentEmployer
    }
    profileImageUrl
    sessionId
  }
}
    ${FundProfileReturnsFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export function useCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export type CurrentUserQueryResult = Apollo.QueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export const CurrentUserAccountDocument = gql`
    query CurrentUserAccount {
  currentUser {
    id
    isTokenBased
    stripeCustomerId
  }
}
    `;

/**
 * __useCurrentUserAccountQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>(CurrentUserAccountDocument, options);
      }
export function useCurrentUserAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>(CurrentUserAccountDocument, options);
        }
export function useCurrentUserAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>(CurrentUserAccountDocument, options);
        }
export type CurrentUserAccountQueryHookResult = ReturnType<typeof useCurrentUserAccountQuery>;
export type CurrentUserAccountLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountLazyQuery>;
export type CurrentUserAccountSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountSuspenseQuery>;
export type CurrentUserAccountQueryResult = Apollo.QueryResult<CurrentUserAccountQuery, CurrentUserAccountQueryVariables>;
export const CurrentUserAccountBadgesDocument = gql`
    query CurrentUserAccountBadges {
  currentUser {
    id
    userBadges: badgeCollectionRelationships {
      edges {
        node {
          id
          badge {
            ...Badges
          }
          badgeNumber
          earnedAt
          visible
        }
      }
    }
    unearnedBadges {
      id
      name
      description
    }
  }
}
    ${BadgesFragmentDoc}`;

/**
 * __useCurrentUserAccountBadgesQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountBadgesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountBadgesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountBadgesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountBadgesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>(CurrentUserAccountBadgesDocument, options);
      }
export function useCurrentUserAccountBadgesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>(CurrentUserAccountBadgesDocument, options);
        }
export function useCurrentUserAccountBadgesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>(CurrentUserAccountBadgesDocument, options);
        }
export type CurrentUserAccountBadgesQueryHookResult = ReturnType<typeof useCurrentUserAccountBadgesQuery>;
export type CurrentUserAccountBadgesLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountBadgesLazyQuery>;
export type CurrentUserAccountBadgesSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountBadgesSuspenseQuery>;
export type CurrentUserAccountBadgesQueryResult = Apollo.QueryResult<CurrentUserAccountBadgesQuery, CurrentUserAccountBadgesQueryVariables>;
export const CurrentUserAccountCompensationsDocument = gql`
    query CurrentUserAccountCompensations {
  currentUser {
    id
    draftCompensations {
      id
      title
      location
      year
      category
      updatedAt
    }
    isAdmin
    publishedCompensations {
      id
      title
      location
      baseSalary
      year
      category
      experience
      fundType
      fundSize
      interestIncentiveFeesValue
      interestMgmtFeesValue
      annualDiscrBonus
      totalCashComp
      postedAt
      interestIncentiveFeesPerc
      vestingIncentiveFees
      interestMgmtFeesPerc
      vestingMgmtFees
      totalDeferredComp
      totalCashDeferredComp
      fundStrategy
      industry
      assetClass
      pieChartData
      investInFund
      buildPersonalTrackRecord
      marketPersonalTrackRecord
      comments
    }
  }
}
    `;

/**
 * __useCurrentUserAccountCompensationsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountCompensationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountCompensationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountCompensationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountCompensationsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>(CurrentUserAccountCompensationsDocument, options);
      }
export function useCurrentUserAccountCompensationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>(CurrentUserAccountCompensationsDocument, options);
        }
export function useCurrentUserAccountCompensationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>(CurrentUserAccountCompensationsDocument, options);
        }
export type CurrentUserAccountCompensationsQueryHookResult = ReturnType<typeof useCurrentUserAccountCompensationsQuery>;
export type CurrentUserAccountCompensationsLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountCompensationsLazyQuery>;
export type CurrentUserAccountCompensationsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountCompensationsSuspenseQuery>;
export type CurrentUserAccountCompensationsQueryResult = Apollo.QueryResult<CurrentUserAccountCompensationsQuery, CurrentUserAccountCompensationsQueryVariables>;
export const CurrentUserAccountFollowersDocument = gql`
    query CurrentUserAccountFollowers {
  currentUser {
    id
    activeFollowersCount
  }
}
    `;

/**
 * __useCurrentUserAccountFollowersQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountFollowersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountFollowersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>(CurrentUserAccountFollowersDocument, options);
      }
export function useCurrentUserAccountFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>(CurrentUserAccountFollowersDocument, options);
        }
export function useCurrentUserAccountFollowersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>(CurrentUserAccountFollowersDocument, options);
        }
export type CurrentUserAccountFollowersQueryHookResult = ReturnType<typeof useCurrentUserAccountFollowersQuery>;
export type CurrentUserAccountFollowersLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountFollowersLazyQuery>;
export type CurrentUserAccountFollowersSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountFollowersSuspenseQuery>;
export type CurrentUserAccountFollowersQueryResult = Apollo.QueryResult<CurrentUserAccountFollowersQuery, CurrentUserAccountFollowersQueryVariables>;
export const CurrentUserAccountFollowingDocument = gql`
    query CurrentUserAccountFollowing {
  currentUser {
    id
    activeFollowedUsersCount
  }
}
    `;

/**
 * __useCurrentUserAccountFollowingQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountFollowingQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountFollowingQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>(CurrentUserAccountFollowingDocument, options);
      }
export function useCurrentUserAccountFollowingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>(CurrentUserAccountFollowingDocument, options);
        }
export function useCurrentUserAccountFollowingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>(CurrentUserAccountFollowingDocument, options);
        }
export type CurrentUserAccountFollowingQueryHookResult = ReturnType<typeof useCurrentUserAccountFollowingQuery>;
export type CurrentUserAccountFollowingLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountFollowingLazyQuery>;
export type CurrentUserAccountFollowingSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountFollowingSuspenseQuery>;
export type CurrentUserAccountFollowingQueryResult = Apollo.QueryResult<CurrentUserAccountFollowingQuery, CurrentUserAccountFollowingQueryVariables>;
export const CurrentUserAccountIdeasDocument = gql`
    query CurrentUserAccountIdeas($cursor: String) {
  currentUser {
    id
    draftIdeas {
      id
      entityName
      userUpdatedAt
    }
    isRetail
    publishedIdeasCount(isPublic: false)
    publishedIdeas(first: 20, after: $cursor) {
      edges {
        node {
          ...IdeaResearchItem
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useCurrentUserAccountIdeasQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountIdeasQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCurrentUserAccountIdeasQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>(CurrentUserAccountIdeasDocument, options);
      }
export function useCurrentUserAccountIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>(CurrentUserAccountIdeasDocument, options);
        }
export function useCurrentUserAccountIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>(CurrentUserAccountIdeasDocument, options);
        }
export type CurrentUserAccountIdeasQueryHookResult = ReturnType<typeof useCurrentUserAccountIdeasQuery>;
export type CurrentUserAccountIdeasLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountIdeasLazyQuery>;
export type CurrentUserAccountIdeasSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountIdeasSuspenseQuery>;
export type CurrentUserAccountIdeasQueryResult = Apollo.QueryResult<CurrentUserAccountIdeasQuery, CurrentUserAccountIdeasQueryVariables>;
export const CurrentUserAccountJobApplicationsDocument = gql`
    query CurrentUserAccountJobApplications {
  currentUser {
    id
    jobApplications {
      id
      jobPosting {
        id
        city
        employer {
          id
          aumRange
          fundType
          strategy
        }
        status
        title
      }
      status
      createdAt
    }
  }
}
    `;

/**
 * __useCurrentUserAccountJobApplicationsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountJobApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountJobApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountJobApplicationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountJobApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>(CurrentUserAccountJobApplicationsDocument, options);
      }
export function useCurrentUserAccountJobApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>(CurrentUserAccountJobApplicationsDocument, options);
        }
export function useCurrentUserAccountJobApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>(CurrentUserAccountJobApplicationsDocument, options);
        }
export type CurrentUserAccountJobApplicationsQueryHookResult = ReturnType<typeof useCurrentUserAccountJobApplicationsQuery>;
export type CurrentUserAccountJobApplicationsLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountJobApplicationsLazyQuery>;
export type CurrentUserAccountJobApplicationsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountJobApplicationsSuspenseQuery>;
export type CurrentUserAccountJobApplicationsQueryResult = Apollo.QueryResult<CurrentUserAccountJobApplicationsQuery, CurrentUserAccountJobApplicationsQueryVariables>;
export const CurrentUserAccountJobPostingsDocument = gql`
    query CurrentUserAccountJobPostings {
  currentUser {
    id
    jobPostings {
      id
      status
      title
      applicationCount
      postedAt
      updatedAt
    }
    profile {
      id
    }
  }
}
    `;

/**
 * __useCurrentUserAccountJobPostingsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountJobPostingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountJobPostingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountJobPostingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountJobPostingsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>(CurrentUserAccountJobPostingsDocument, options);
      }
export function useCurrentUserAccountJobPostingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>(CurrentUserAccountJobPostingsDocument, options);
        }
export function useCurrentUserAccountJobPostingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>(CurrentUserAccountJobPostingsDocument, options);
        }
export type CurrentUserAccountJobPostingsQueryHookResult = ReturnType<typeof useCurrentUserAccountJobPostingsQuery>;
export type CurrentUserAccountJobPostingsLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountJobPostingsLazyQuery>;
export type CurrentUserAccountJobPostingsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountJobPostingsSuspenseQuery>;
export type CurrentUserAccountJobPostingsQueryResult = Apollo.QueryResult<CurrentUserAccountJobPostingsQuery, CurrentUserAccountJobPostingsQueryVariables>;
export const CurrentUserAccountLeftSideBarDocument = gql`
    query CurrentUserAccountLeftSideBar {
  currentUser {
    id
    canPostJobs
    canApplyToJobs
    canWriteCompensations: canAccess(resource: "compensations", permission: "write")
    isTopDown
    hasBadges
    hasIdeas
    profile {
      id
    }
    stripeCustomerId
  }
}
    `;

/**
 * __useCurrentUserAccountLeftSideBarQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountLeftSideBarQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountLeftSideBarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountLeftSideBarQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountLeftSideBarQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>(CurrentUserAccountLeftSideBarDocument, options);
      }
export function useCurrentUserAccountLeftSideBarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>(CurrentUserAccountLeftSideBarDocument, options);
        }
export function useCurrentUserAccountLeftSideBarSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>(CurrentUserAccountLeftSideBarDocument, options);
        }
export type CurrentUserAccountLeftSideBarQueryHookResult = ReturnType<typeof useCurrentUserAccountLeftSideBarQuery>;
export type CurrentUserAccountLeftSideBarLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountLeftSideBarLazyQuery>;
export type CurrentUserAccountLeftSideBarSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountLeftSideBarSuspenseQuery>;
export type CurrentUserAccountLeftSideBarQueryResult = Apollo.QueryResult<CurrentUserAccountLeftSideBarQuery, CurrentUserAccountLeftSideBarQueryVariables>;
export const CurrentUserAccountNotificationShowPageDocument = gql`
    query CurrentUserAccountNotificationShowPage {
  currentUser {
    id
    canMessage: canAccess(resource: "messages", permission: "manage")
    canReceiveViewerIntroRequest
    canWriteIdeaComments: canAccess(resource: "idea_comments", permission: "write")
    canWriteWhitePapers: canAccess(resource: "white_papers", permission: "write")
    emailPreferences {
      id
      emailType
      subscribed
    }
    fundProfileSearchAlerts {
      id
      active
      display
      name
      employerProfileSavedSearch {
        id
        criteria
      }
    }
    hasIdeas
    ideaSearchAlerts {
      id
      active
      frequency
      display
      name
      ideaSavedSearch {
        id
        criteria
      }
    }
    isAllocator
    isFundProfileAdmin
    isRetail
  }
}
    `;

/**
 * __useCurrentUserAccountNotificationShowPageQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountNotificationShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountNotificationShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountNotificationShowPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountNotificationShowPageQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>(CurrentUserAccountNotificationShowPageDocument, options);
      }
export function useCurrentUserAccountNotificationShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>(CurrentUserAccountNotificationShowPageDocument, options);
        }
export function useCurrentUserAccountNotificationShowPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>(CurrentUserAccountNotificationShowPageDocument, options);
        }
export type CurrentUserAccountNotificationShowPageQueryHookResult = ReturnType<typeof useCurrentUserAccountNotificationShowPageQuery>;
export type CurrentUserAccountNotificationShowPageLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountNotificationShowPageLazyQuery>;
export type CurrentUserAccountNotificationShowPageSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountNotificationShowPageSuspenseQuery>;
export type CurrentUserAccountNotificationShowPageQueryResult = Apollo.QueryResult<CurrentUserAccountNotificationShowPageQuery, CurrentUserAccountNotificationShowPageQueryVariables>;
export const CurrentUserAccountSavedSearchesDocument = gql`
    query CurrentUserAccountSavedSearches {
  currentUser {
    id
    fundProfileSearchAlerts {
      id
      active
      display
      name
      employerProfileSavedSearch {
        id
        criteria
      }
    }
    ideaSearchAlerts {
      id
      active
      frequency
      display
      name
      ideaSavedSearch {
        id
        criteria
      }
    }
  }
}
    `;

/**
 * __useCurrentUserAccountSavedSearchesQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountSavedSearchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountSavedSearchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountSavedSearchesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountSavedSearchesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>(CurrentUserAccountSavedSearchesDocument, options);
      }
export function useCurrentUserAccountSavedSearchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>(CurrentUserAccountSavedSearchesDocument, options);
        }
export function useCurrentUserAccountSavedSearchesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>(CurrentUserAccountSavedSearchesDocument, options);
        }
export type CurrentUserAccountSavedSearchesQueryHookResult = ReturnType<typeof useCurrentUserAccountSavedSearchesQuery>;
export type CurrentUserAccountSavedSearchesLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountSavedSearchesLazyQuery>;
export type CurrentUserAccountSavedSearchesSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountSavedSearchesSuspenseQuery>;
export type CurrentUserAccountSavedSearchesQueryResult = Apollo.QueryResult<CurrentUserAccountSavedSearchesQuery, CurrentUserAccountSavedSearchesQueryVariables>;
export const CurrentUserAccountShowPageDocument = gql`
    query CurrentUserAccountShowPage {
  currentUser {
    id
    email
  }
}
    `;

/**
 * __useCurrentUserAccountShowPageQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountShowPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountShowPageQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>(CurrentUserAccountShowPageDocument, options);
      }
export function useCurrentUserAccountShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>(CurrentUserAccountShowPageDocument, options);
        }
export function useCurrentUserAccountShowPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>(CurrentUserAccountShowPageDocument, options);
        }
export type CurrentUserAccountShowPageQueryHookResult = ReturnType<typeof useCurrentUserAccountShowPageQuery>;
export type CurrentUserAccountShowPageLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountShowPageLazyQuery>;
export type CurrentUserAccountShowPageSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountShowPageSuspenseQuery>;
export type CurrentUserAccountShowPageQueryResult = Apollo.QueryResult<CurrentUserAccountShowPageQuery, CurrentUserAccountShowPageQueryVariables>;
export const CurrentUserAccountUserReferralsDocument = gql`
    query CurrentUserAccountUserReferrals {
  currentUser {
    id
    allTimeReferralAwards
    userReferrals {
      id
      cumulativeRewardDays
      referee {
        id
        displayName(controlled: false)
        email
        activeAt
      }
      referralProgramMaxRewardDays
    }
    unregisteredReferrals {
      id
      email
      status
      referrerId
    }
  }
}
    `;

/**
 * __useCurrentUserAccountUserReferralsQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccountUserReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccountUserReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccountUserReferralsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccountUserReferralsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>(CurrentUserAccountUserReferralsDocument, options);
      }
export function useCurrentUserAccountUserReferralsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>(CurrentUserAccountUserReferralsDocument, options);
        }
export function useCurrentUserAccountUserReferralsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>(CurrentUserAccountUserReferralsDocument, options);
        }
export type CurrentUserAccountUserReferralsQueryHookResult = ReturnType<typeof useCurrentUserAccountUserReferralsQuery>;
export type CurrentUserAccountUserReferralsLazyQueryHookResult = ReturnType<typeof useCurrentUserAccountUserReferralsLazyQuery>;
export type CurrentUserAccountUserReferralsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccountUserReferralsSuspenseQuery>;
export type CurrentUserAccountUserReferralsQueryResult = Apollo.QueryResult<CurrentUserAccountUserReferralsQuery, CurrentUserAccountUserReferralsQueryVariables>;
export const CurrentUserAccreditedInvestorProfileDocument = gql`
    query CurrentUserAccreditedInvestorProfile {
  currentUser {
    id
    accreditedInvestorProfile {
      userId
      netWorth
      next12MoAllocation
      investmentSize
      yearsInvesting
      bonds
      hedgeFunds
      realEstate
      foreignCurrencies
      futuresOrCommodities
      privateEquityFunds
      publiclyTradedStocks
      privateCompanies
    }
  }
}
    `;

/**
 * __useCurrentUserAccreditedInvestorProfileQuery__
 *
 * To run a query within a React component, call `useCurrentUserAccreditedInvestorProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserAccreditedInvestorProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserAccreditedInvestorProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserAccreditedInvestorProfileQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>(CurrentUserAccreditedInvestorProfileDocument, options);
      }
export function useCurrentUserAccreditedInvestorProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>(CurrentUserAccreditedInvestorProfileDocument, options);
        }
export function useCurrentUserAccreditedInvestorProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>(CurrentUserAccreditedInvestorProfileDocument, options);
        }
export type CurrentUserAccreditedInvestorProfileQueryHookResult = ReturnType<typeof useCurrentUserAccreditedInvestorProfileQuery>;
export type CurrentUserAccreditedInvestorProfileLazyQueryHookResult = ReturnType<typeof useCurrentUserAccreditedInvestorProfileLazyQuery>;
export type CurrentUserAccreditedInvestorProfileSuspenseQueryHookResult = ReturnType<typeof useCurrentUserAccreditedInvestorProfileSuspenseQuery>;
export type CurrentUserAccreditedInvestorProfileQueryResult = Apollo.QueryResult<CurrentUserAccreditedInvestorProfileQuery, CurrentUserAccreditedInvestorProfileQueryVariables>;
export const CurrentUserArchivedReadingListItemsDocument = gql`
    query CurrentUserArchivedReadingListItems($page: Int) {
  currentUser {
    id
    archivedReadingListItemsCount
    archivedReadingListItems(page: $page) {
      edges {
        node {
          id
          idea {
            ...IdeaResearchItem
          }
        }
      }
    }
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    isPaladin
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useCurrentUserArchivedReadingListItemsQuery__
 *
 * To run a query within a React component, call `useCurrentUserArchivedReadingListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserArchivedReadingListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserArchivedReadingListItemsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCurrentUserArchivedReadingListItemsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>(CurrentUserArchivedReadingListItemsDocument, options);
      }
export function useCurrentUserArchivedReadingListItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>(CurrentUserArchivedReadingListItemsDocument, options);
        }
export function useCurrentUserArchivedReadingListItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>(CurrentUserArchivedReadingListItemsDocument, options);
        }
export type CurrentUserArchivedReadingListItemsQueryHookResult = ReturnType<typeof useCurrentUserArchivedReadingListItemsQuery>;
export type CurrentUserArchivedReadingListItemsLazyQueryHookResult = ReturnType<typeof useCurrentUserArchivedReadingListItemsLazyQuery>;
export type CurrentUserArchivedReadingListItemsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserArchivedReadingListItemsSuspenseQuery>;
export type CurrentUserArchivedReadingListItemsQueryResult = Apollo.QueryResult<CurrentUserArchivedReadingListItemsQuery, CurrentUserArchivedReadingListItemsQueryVariables>;
export const CurrentUserDraftAndPendingIdeasDocument = gql`
    query CurrentUserDraftAndPendingIdeas {
  currentUser {
    id
    draftAndPendingIdeas {
      id
      status
      updatedAt
      positions {
        id
        asset {
          id
          entity {
            id
            name
          }
          primarySymbol
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserDraftAndPendingIdeasQuery__
 *
 * To run a query within a React component, call `useCurrentUserDraftAndPendingIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserDraftAndPendingIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserDraftAndPendingIdeasQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserDraftAndPendingIdeasQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>(CurrentUserDraftAndPendingIdeasDocument, options);
      }
export function useCurrentUserDraftAndPendingIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>(CurrentUserDraftAndPendingIdeasDocument, options);
        }
export function useCurrentUserDraftAndPendingIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>(CurrentUserDraftAndPendingIdeasDocument, options);
        }
export type CurrentUserDraftAndPendingIdeasQueryHookResult = ReturnType<typeof useCurrentUserDraftAndPendingIdeasQuery>;
export type CurrentUserDraftAndPendingIdeasLazyQueryHookResult = ReturnType<typeof useCurrentUserDraftAndPendingIdeasLazyQuery>;
export type CurrentUserDraftAndPendingIdeasSuspenseQueryHookResult = ReturnType<typeof useCurrentUserDraftAndPendingIdeasSuspenseQuery>;
export type CurrentUserDraftAndPendingIdeasQueryResult = Apollo.QueryResult<CurrentUserDraftAndPendingIdeasQuery, CurrentUserDraftAndPendingIdeasQueryVariables>;
export const CurrentUserEventRegistrationDocument = gql`
    query CurrentUserEventRegistration {
  currentUser {
    id
    hasRegisteredForEvent
  }
}
    `;

/**
 * __useCurrentUserEventRegistrationQuery__
 *
 * To run a query within a React component, call `useCurrentUserEventRegistrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserEventRegistrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserEventRegistrationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserEventRegistrationQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>(CurrentUserEventRegistrationDocument, options);
      }
export function useCurrentUserEventRegistrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>(CurrentUserEventRegistrationDocument, options);
        }
export function useCurrentUserEventRegistrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>(CurrentUserEventRegistrationDocument, options);
        }
export type CurrentUserEventRegistrationQueryHookResult = ReturnType<typeof useCurrentUserEventRegistrationQuery>;
export type CurrentUserEventRegistrationLazyQueryHookResult = ReturnType<typeof useCurrentUserEventRegistrationLazyQuery>;
export type CurrentUserEventRegistrationSuspenseQueryHookResult = ReturnType<typeof useCurrentUserEventRegistrationSuspenseQuery>;
export type CurrentUserEventRegistrationQueryResult = Apollo.QueryResult<CurrentUserEventRegistrationQuery, CurrentUserEventRegistrationQueryVariables>;
export const CurrentUserFollowersListDocument = gql`
    query CurrentUserFollowersList($page: Int) {
  currentUser {
    id
    activeFollowersCount
    followersList(page: $page) {
      edges {
        node {
          id
          city
          imageProfileUrl
          summary
          user {
            id
            displayName
            mostRecentEmployer {
              id
              currentEmployer
              employer {
                id
                name
                aumRange
                fundType
              }
              title
            }
            publishedIdeasCount
            userBadges: badgeCollectionRelationships {
              edges {
                node {
                  id
                  badgeNumber
                  visible
                  badge {
                    ...Badges
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    ${BadgesFragmentDoc}`;

/**
 * __useCurrentUserFollowersListQuery__
 *
 * To run a query within a React component, call `useCurrentUserFollowersListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserFollowersListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserFollowersListQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCurrentUserFollowersListQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>(CurrentUserFollowersListDocument, options);
      }
export function useCurrentUserFollowersListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>(CurrentUserFollowersListDocument, options);
        }
export function useCurrentUserFollowersListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>(CurrentUserFollowersListDocument, options);
        }
export type CurrentUserFollowersListQueryHookResult = ReturnType<typeof useCurrentUserFollowersListQuery>;
export type CurrentUserFollowersListLazyQueryHookResult = ReturnType<typeof useCurrentUserFollowersListLazyQuery>;
export type CurrentUserFollowersListSuspenseQueryHookResult = ReturnType<typeof useCurrentUserFollowersListSuspenseQuery>;
export type CurrentUserFollowersListQueryResult = Apollo.QueryResult<CurrentUserFollowersListQuery, CurrentUserFollowersListQueryVariables>;
export const CurrentUserFollowingListDocument = gql`
    query CurrentUserFollowingList($page: Int) {
  currentUser {
    id
    followingList(page: $page) {
      edges {
        node {
          id
          city
          imageProfileUrl
          summary
          user {
            id
            displayName
            mostRecentEmployer {
              id
              currentEmployer
              employer {
                id
                name
                aumRange
                fundType
              }
              title
            }
            publishedIdeasCount
            userBadges: badgeCollectionRelationships {
              edges {
                node {
                  id
                  badgeNumber
                  visible
                  badge {
                    ...Badges
                  }
                }
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    activeFollowedUsersCount
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    ${BadgesFragmentDoc}`;

/**
 * __useCurrentUserFollowingListQuery__
 *
 * To run a query within a React component, call `useCurrentUserFollowingListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserFollowingListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserFollowingListQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCurrentUserFollowingListQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>(CurrentUserFollowingListDocument, options);
      }
export function useCurrentUserFollowingListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>(CurrentUserFollowingListDocument, options);
        }
export function useCurrentUserFollowingListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>(CurrentUserFollowingListDocument, options);
        }
export type CurrentUserFollowingListQueryHookResult = ReturnType<typeof useCurrentUserFollowingListQuery>;
export type CurrentUserFollowingListLazyQueryHookResult = ReturnType<typeof useCurrentUserFollowingListLazyQuery>;
export type CurrentUserFollowingListSuspenseQueryHookResult = ReturnType<typeof useCurrentUserFollowingListSuspenseQuery>;
export type CurrentUserFollowingListQueryResult = Apollo.QueryResult<CurrentUserFollowingListQuery, CurrentUserFollowingListQueryVariables>;
export const CurrentUserFundProfileDocument = gql`
    query CurrentUserFundProfile {
  currentUser {
    id
    adminFundProfiles {
      id
      name
    }
  }
}
    `;

/**
 * __useCurrentUserFundProfileQuery__
 *
 * To run a query within a React component, call `useCurrentUserFundProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserFundProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserFundProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserFundProfileQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>(CurrentUserFundProfileDocument, options);
      }
export function useCurrentUserFundProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>(CurrentUserFundProfileDocument, options);
        }
export function useCurrentUserFundProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>(CurrentUserFundProfileDocument, options);
        }
export type CurrentUserFundProfileQueryHookResult = ReturnType<typeof useCurrentUserFundProfileQuery>;
export type CurrentUserFundProfileLazyQueryHookResult = ReturnType<typeof useCurrentUserFundProfileLazyQuery>;
export type CurrentUserFundProfileSuspenseQueryHookResult = ReturnType<typeof useCurrentUserFundProfileSuspenseQuery>;
export type CurrentUserFundProfileQueryResult = Apollo.QueryResult<CurrentUserFundProfileQuery, CurrentUserFundProfileQueryVariables>;
export const CurrentUserIdeaDraftsDocument = gql`
    query CurrentUserIdeaDrafts {
  currentUser {
    id
    draftIdeas {
      id
      updatedAt
      positions {
        id
        asset {
          id
          entity {
            id
            name
          }
          primarySymbol
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserIdeaDraftsQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdeaDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdeaDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdeaDraftsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdeaDraftsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>(CurrentUserIdeaDraftsDocument, options);
      }
export function useCurrentUserIdeaDraftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>(CurrentUserIdeaDraftsDocument, options);
        }
export function useCurrentUserIdeaDraftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>(CurrentUserIdeaDraftsDocument, options);
        }
export type CurrentUserIdeaDraftsQueryHookResult = ReturnType<typeof useCurrentUserIdeaDraftsQuery>;
export type CurrentUserIdeaDraftsLazyQueryHookResult = ReturnType<typeof useCurrentUserIdeaDraftsLazyQuery>;
export type CurrentUserIdeaDraftsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserIdeaDraftsSuspenseQuery>;
export type CurrentUserIdeaDraftsQueryResult = Apollo.QueryResult<CurrentUserIdeaDraftsQuery, CurrentUserIdeaDraftsQueryVariables>;
export const CurrentUserIdeaTokensDocument = gql`
    query CurrentUserIdeaTokens {
  currentUser {
    id
    availableTokenCount
    trialTokenCount
    trialTokenExpiresIn
    usedTokenCount
  }
}
    `;

/**
 * __useCurrentUserIdeaTokensQuery__
 *
 * To run a query within a React component, call `useCurrentUserIdeaTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserIdeaTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserIdeaTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserIdeaTokensQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>(CurrentUserIdeaTokensDocument, options);
      }
export function useCurrentUserIdeaTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>(CurrentUserIdeaTokensDocument, options);
        }
export function useCurrentUserIdeaTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>(CurrentUserIdeaTokensDocument, options);
        }
export type CurrentUserIdeaTokensQueryHookResult = ReturnType<typeof useCurrentUserIdeaTokensQuery>;
export type CurrentUserIdeaTokensLazyQueryHookResult = ReturnType<typeof useCurrentUserIdeaTokensLazyQuery>;
export type CurrentUserIdeaTokensSuspenseQueryHookResult = ReturnType<typeof useCurrentUserIdeaTokensSuspenseQuery>;
export type CurrentUserIdeaTokensQueryResult = Apollo.QueryResult<CurrentUserIdeaTokensQuery, CurrentUserIdeaTokensQueryVariables>;
export const CurrentUserNotificationSettingsDocument = gql`
    query CurrentUserNotificationSettings {
  currentUser {
    id
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    canAccessComments: canAccess(resource: "idea_comments", permission: "access")
    canViewCapIntro: isCapIntroMember
    canAccessJobPostings: canAccess(resource: "job_postings", permission: "access")
    canReceiveViewerIntroRequest
    userNotificationSetting {
      id
      showAll
      showActivelyDiscussed
      showBadges
      showBiggestMovers
      showCapIntro
      showContests
      showComments
      showFolloweeActivity
      showFollowers
      showFundFollower
      showIdeas
      showJobVault
      showViewerIntroRequests
      showNewRecommended
      showRankings
      showTrendingResearch
      showWatchlist
      showWhitePapers
    }
  }
}
    `;

/**
 * __useCurrentUserNotificationSettingsQuery__
 *
 * To run a query within a React component, call `useCurrentUserNotificationSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserNotificationSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserNotificationSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserNotificationSettingsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>(CurrentUserNotificationSettingsDocument, options);
      }
export function useCurrentUserNotificationSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>(CurrentUserNotificationSettingsDocument, options);
        }
export function useCurrentUserNotificationSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>(CurrentUserNotificationSettingsDocument, options);
        }
export type CurrentUserNotificationSettingsQueryHookResult = ReturnType<typeof useCurrentUserNotificationSettingsQuery>;
export type CurrentUserNotificationSettingsLazyQueryHookResult = ReturnType<typeof useCurrentUserNotificationSettingsLazyQuery>;
export type CurrentUserNotificationSettingsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserNotificationSettingsSuspenseQuery>;
export type CurrentUserNotificationSettingsQueryResult = Apollo.QueryResult<CurrentUserNotificationSettingsQuery, CurrentUserNotificationSettingsQueryVariables>;
export const CurrentUserNotificationsDocument = gql`
    query CurrentUserNotifications($cursor: String, $first: Int, $filter: String) {
  currentUser {
    id
    newNotificationsCount
    unreadNotificationsCount
    notifications(desc: true, first: $first, after: $cursor, filter: $filter) {
      edges {
        node {
          ...UserNotification
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${UserNotificationFragmentDoc}`;

/**
 * __useCurrentUserNotificationsQuery__
 *
 * To run a query within a React component, call `useCurrentUserNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserNotificationsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      first: // value for 'first'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCurrentUserNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>(CurrentUserNotificationsDocument, options);
      }
export function useCurrentUserNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>(CurrentUserNotificationsDocument, options);
        }
export function useCurrentUserNotificationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>(CurrentUserNotificationsDocument, options);
        }
export type CurrentUserNotificationsQueryHookResult = ReturnType<typeof useCurrentUserNotificationsQuery>;
export type CurrentUserNotificationsLazyQueryHookResult = ReturnType<typeof useCurrentUserNotificationsLazyQuery>;
export type CurrentUserNotificationsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserNotificationsSuspenseQuery>;
export type CurrentUserNotificationsQueryResult = Apollo.QueryResult<CurrentUserNotificationsQuery, CurrentUserNotificationsQueryVariables>;
export const CurrentUserPublishedPostsDocument = gql`
    query CurrentUserPublishedPosts {
  currentUser {
    id
    acceptedPostTerms
    isAdmin
    posts {
      id
      body
      commentsCount
      currentUserHasLiked
      eventId
      domain
      likeCount
      ogDescription
      ogUrl
      ogPreviewImageUrl
      ogTitle
      postedAt
      tagList
      untaggedBody
      user {
        id
        displayName
        featuredRank {
          id
          rankString
        }
        mostRecentEmployer {
          id
          currentEmployer
          employer {
            id
            aumRange
            fundType
            name
          }
          title
        }
        profile {
          id
          city
        }
        profileImageUrl
      }
      youtubeId
    }
    profileImageUrl
  }
}
    `;

/**
 * __useCurrentUserPublishedPostsQuery__
 *
 * To run a query within a React component, call `useCurrentUserPublishedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPublishedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPublishedPostsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPublishedPostsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>(CurrentUserPublishedPostsDocument, options);
      }
export function useCurrentUserPublishedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>(CurrentUserPublishedPostsDocument, options);
        }
export function useCurrentUserPublishedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>(CurrentUserPublishedPostsDocument, options);
        }
export type CurrentUserPublishedPostsQueryHookResult = ReturnType<typeof useCurrentUserPublishedPostsQuery>;
export type CurrentUserPublishedPostsLazyQueryHookResult = ReturnType<typeof useCurrentUserPublishedPostsLazyQuery>;
export type CurrentUserPublishedPostsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPublishedPostsSuspenseQuery>;
export type CurrentUserPublishedPostsQueryResult = Apollo.QueryResult<CurrentUserPublishedPostsQuery, CurrentUserPublishedPostsQueryVariables>;
export const CurrentUserPublishedWhitePapersDocument = gql`
    query CurrentUserPublishedWhitePapers {
  currentUser {
    id
    canWriteWhitePapers: canAccess(resource: "white_papers", permission: "write")
    whitePapers {
      ...WhitePaperResearchItem
    }
  }
}
    ${WhitePaperResearchItemFragmentDoc}`;

/**
 * __useCurrentUserPublishedWhitePapersQuery__
 *
 * To run a query within a React component, call `useCurrentUserPublishedWhitePapersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPublishedWhitePapersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPublishedWhitePapersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPublishedWhitePapersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>(CurrentUserPublishedWhitePapersDocument, options);
      }
export function useCurrentUserPublishedWhitePapersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>(CurrentUserPublishedWhitePapersDocument, options);
        }
export function useCurrentUserPublishedWhitePapersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>(CurrentUserPublishedWhitePapersDocument, options);
        }
export type CurrentUserPublishedWhitePapersQueryHookResult = ReturnType<typeof useCurrentUserPublishedWhitePapersQuery>;
export type CurrentUserPublishedWhitePapersLazyQueryHookResult = ReturnType<typeof useCurrentUserPublishedWhitePapersLazyQuery>;
export type CurrentUserPublishedWhitePapersSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPublishedWhitePapersSuspenseQuery>;
export type CurrentUserPublishedWhitePapersQueryResult = Apollo.QueryResult<CurrentUserPublishedWhitePapersQuery, CurrentUserPublishedWhitePapersQueryVariables>;
export const CurrentUserQuickPositionsDocument = gql`
    query CurrentUserQuickPositions {
  currentUser {
    id
    quickPositions {
      id
      asset {
        id
        currencyCode
        entityId
        symbol
        latestPrice
      }
      closedAt
      closingPrice
      direction
      openedAt
      openingPrice
      returnToDate
    }
  }
}
    `;

/**
 * __useCurrentUserQuickPositionsQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuickPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuickPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuickPositionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuickPositionsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>(CurrentUserQuickPositionsDocument, options);
      }
export function useCurrentUserQuickPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>(CurrentUserQuickPositionsDocument, options);
        }
export function useCurrentUserQuickPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>(CurrentUserQuickPositionsDocument, options);
        }
export type CurrentUserQuickPositionsQueryHookResult = ReturnType<typeof useCurrentUserQuickPositionsQuery>;
export type CurrentUserQuickPositionsLazyQueryHookResult = ReturnType<typeof useCurrentUserQuickPositionsLazyQuery>;
export type CurrentUserQuickPositionsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserQuickPositionsSuspenseQuery>;
export type CurrentUserQuickPositionsQueryResult = Apollo.QueryResult<CurrentUserQuickPositionsQuery, CurrentUserQuickPositionsQueryVariables>;
export const CurrentUserRankingsDocument = gql`
    query CurrentUserRankings {
  currentUser {
    id
    canViewIdeaFilterDetails: canAccess(
      resource: "idea_filter_details"
      permission: "view"
    )
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    `;

/**
 * __useCurrentUserRankingsQuery__
 *
 * To run a query within a React component, call `useCurrentUserRankingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRankingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRankingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserRankingsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>(CurrentUserRankingsDocument, options);
      }
export function useCurrentUserRankingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>(CurrentUserRankingsDocument, options);
        }
export function useCurrentUserRankingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>(CurrentUserRankingsDocument, options);
        }
export type CurrentUserRankingsQueryHookResult = ReturnType<typeof useCurrentUserRankingsQuery>;
export type CurrentUserRankingsLazyQueryHookResult = ReturnType<typeof useCurrentUserRankingsLazyQuery>;
export type CurrentUserRankingsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserRankingsSuspenseQuery>;
export type CurrentUserRankingsQueryResult = Apollo.QueryResult<CurrentUserRankingsQuery, CurrentUserRankingsQueryVariables>;
export const CurrentUserRatingsDocument = gql`
    query CurrentUserRatings($cursor: String) {
  currentUser {
    id
    ratings(first: 20, after: $cursor) {
      edges {
        node {
          id
          createdAt
          score
          ratingId
          updatedAt
          totalReturn
          idea {
            id
            direction
            totalReturn
            positions {
              id
              asset {
                id
                name
                primarySymbol
              }
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useCurrentUserRatingsQuery__
 *
 * To run a query within a React component, call `useCurrentUserRatingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRatingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRatingsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCurrentUserRatingsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>(CurrentUserRatingsDocument, options);
      }
export function useCurrentUserRatingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>(CurrentUserRatingsDocument, options);
        }
export function useCurrentUserRatingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>(CurrentUserRatingsDocument, options);
        }
export type CurrentUserRatingsQueryHookResult = ReturnType<typeof useCurrentUserRatingsQuery>;
export type CurrentUserRatingsLazyQueryHookResult = ReturnType<typeof useCurrentUserRatingsLazyQuery>;
export type CurrentUserRatingsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserRatingsSuspenseQuery>;
export type CurrentUserRatingsQueryResult = Apollo.QueryResult<CurrentUserRatingsQuery, CurrentUserRatingsQueryVariables>;
export const CurrentUserResearchSubmissionDocument = gql`
    query CurrentUserResearchSubmission {
  currentUser {
    id
    canWriteWhitePapers: canAccess(resource: "white_papers", permission: "write")
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
  }
}
    `;

/**
 * __useCurrentUserResearchSubmissionQuery__
 *
 * To run a query within a React component, call `useCurrentUserResearchSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserResearchSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserResearchSubmissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserResearchSubmissionQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>(CurrentUserResearchSubmissionDocument, options);
      }
export function useCurrentUserResearchSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>(CurrentUserResearchSubmissionDocument, options);
        }
export function useCurrentUserResearchSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>(CurrentUserResearchSubmissionDocument, options);
        }
export type CurrentUserResearchSubmissionQueryHookResult = ReturnType<typeof useCurrentUserResearchSubmissionQuery>;
export type CurrentUserResearchSubmissionLazyQueryHookResult = ReturnType<typeof useCurrentUserResearchSubmissionLazyQuery>;
export type CurrentUserResearchSubmissionSuspenseQueryHookResult = ReturnType<typeof useCurrentUserResearchSubmissionSuspenseQuery>;
export type CurrentUserResearchSubmissionQueryResult = Apollo.QueryResult<CurrentUserResearchSubmissionQuery, CurrentUserResearchSubmissionQueryVariables>;
export const CurrentUserSentIntroRequestsDocument = gql`
    query CurrentUserSentIntroRequests {
  currentUser {
    id
    sentViewerIntroRequests {
      createdAt
      id
      status
      updatedAt
      viewableDisplayTitle
      viewableId
      viewableType
      ideaView {
        id
        viewerCityName
        viewerFundType
        viewerAumRange
        viewerTitle
      }
      viewer {
        id
        displayName
      }
    }
  }
}
    `;

/**
 * __useCurrentUserSentIntroRequestsQuery__
 *
 * To run a query within a React component, call `useCurrentUserSentIntroRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserSentIntroRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserSentIntroRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserSentIntroRequestsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>(CurrentUserSentIntroRequestsDocument, options);
      }
export function useCurrentUserSentIntroRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>(CurrentUserSentIntroRequestsDocument, options);
        }
export function useCurrentUserSentIntroRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>(CurrentUserSentIntroRequestsDocument, options);
        }
export type CurrentUserSentIntroRequestsQueryHookResult = ReturnType<typeof useCurrentUserSentIntroRequestsQuery>;
export type CurrentUserSentIntroRequestsLazyQueryHookResult = ReturnType<typeof useCurrentUserSentIntroRequestsLazyQuery>;
export type CurrentUserSentIntroRequestsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSentIntroRequestsSuspenseQuery>;
export type CurrentUserSentIntroRequestsQueryResult = Apollo.QueryResult<CurrentUserSentIntroRequestsQuery, CurrentUserSentIntroRequestsQueryVariables>;
export const CurrentUserUnreadReadingListItemsDocument = gql`
    query CurrentUserUnreadReadingListItems($page: Int) {
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    isPaladin
    unreadReadingListItemsCount
    unreadReadingListItems(page: $page) {
      edges {
        node {
          id
          idea {
            ...IdeaResearchItem
          }
        }
      }
    }
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useCurrentUserUnreadReadingListItemsQuery__
 *
 * To run a query within a React component, call `useCurrentUserUnreadReadingListItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserUnreadReadingListItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserUnreadReadingListItemsQuery({
 *   variables: {
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCurrentUserUnreadReadingListItemsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>(CurrentUserUnreadReadingListItemsDocument, options);
      }
export function useCurrentUserUnreadReadingListItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>(CurrentUserUnreadReadingListItemsDocument, options);
        }
export function useCurrentUserUnreadReadingListItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>(CurrentUserUnreadReadingListItemsDocument, options);
        }
export type CurrentUserUnreadReadingListItemsQueryHookResult = ReturnType<typeof useCurrentUserUnreadReadingListItemsQuery>;
export type CurrentUserUnreadReadingListItemsLazyQueryHookResult = ReturnType<typeof useCurrentUserUnreadReadingListItemsLazyQuery>;
export type CurrentUserUnreadReadingListItemsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserUnreadReadingListItemsSuspenseQuery>;
export type CurrentUserUnreadReadingListItemsQueryResult = Apollo.QueryResult<CurrentUserUnreadReadingListItemsQuery, CurrentUserUnreadReadingListItemsQueryVariables>;
export const CurrentUserViewerIntroRequestsDocument = gql`
    query CurrentUserViewerIntroRequests($cursor: String) {
  currentUser {
    id
    viewerIntroRequestCount
    viewerIntroRequests(first: 10, after: $cursor) {
      edges {
        node {
          id
          author {
            id
            displayName
          }
          status
          createdAt
          viewableId
          viewableType
          viewableDisplayTitle
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    `;

/**
 * __useCurrentUserViewerIntroRequestsQuery__
 *
 * To run a query within a React component, call `useCurrentUserViewerIntroRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserViewerIntroRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserViewerIntroRequestsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useCurrentUserViewerIntroRequestsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>(CurrentUserViewerIntroRequestsDocument, options);
      }
export function useCurrentUserViewerIntroRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>(CurrentUserViewerIntroRequestsDocument, options);
        }
export function useCurrentUserViewerIntroRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>(CurrentUserViewerIntroRequestsDocument, options);
        }
export type CurrentUserViewerIntroRequestsQueryHookResult = ReturnType<typeof useCurrentUserViewerIntroRequestsQuery>;
export type CurrentUserViewerIntroRequestsLazyQueryHookResult = ReturnType<typeof useCurrentUserViewerIntroRequestsLazyQuery>;
export type CurrentUserViewerIntroRequestsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserViewerIntroRequestsSuspenseQuery>;
export type CurrentUserViewerIntroRequestsQueryResult = Apollo.QueryResult<CurrentUserViewerIntroRequestsQuery, CurrentUserViewerIntroRequestsQueryVariables>;
export const CurrentUserWatchlistDocument = gql`
    query CurrentUserWatchlist {
  currentUser {
    id
    watchlist {
      ...UserWatchlist
    }
    isAllocator
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    ${UserWatchlistFragmentDoc}`;

/**
 * __useCurrentUserWatchlistQuery__
 *
 * To run a query within a React component, call `useCurrentUserWatchlistQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWatchlistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWatchlistQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWatchlistQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>(CurrentUserWatchlistDocument, options);
      }
export function useCurrentUserWatchlistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>(CurrentUserWatchlistDocument, options);
        }
export function useCurrentUserWatchlistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>(CurrentUserWatchlistDocument, options);
        }
export type CurrentUserWatchlistQueryHookResult = ReturnType<typeof useCurrentUserWatchlistQuery>;
export type CurrentUserWatchlistLazyQueryHookResult = ReturnType<typeof useCurrentUserWatchlistLazyQuery>;
export type CurrentUserWatchlistSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWatchlistSuspenseQuery>;
export type CurrentUserWatchlistQueryResult = Apollo.QueryResult<CurrentUserWatchlistQuery, CurrentUserWatchlistQueryVariables>;
export const CurrentUserWatchlistTickersDocument = gql`
    query CurrentUserWatchlistTickers {
  currentUser {
    id
    followedEntityIds
    watchlistTickers {
      id
      createdAt
      entity {
        id
        name
        primaryAsset {
          primarySymbol
        }
      }
    }
  }
}
    `;

/**
 * __useCurrentUserWatchlistTickersQuery__
 *
 * To run a query within a React component, call `useCurrentUserWatchlistTickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWatchlistTickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWatchlistTickersQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWatchlistTickersQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>(CurrentUserWatchlistTickersDocument, options);
      }
export function useCurrentUserWatchlistTickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>(CurrentUserWatchlistTickersDocument, options);
        }
export function useCurrentUserWatchlistTickersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>(CurrentUserWatchlistTickersDocument, options);
        }
export type CurrentUserWatchlistTickersQueryHookResult = ReturnType<typeof useCurrentUserWatchlistTickersQuery>;
export type CurrentUserWatchlistTickersLazyQueryHookResult = ReturnType<typeof useCurrentUserWatchlistTickersLazyQuery>;
export type CurrentUserWatchlistTickersSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWatchlistTickersSuspenseQuery>;
export type CurrentUserWatchlistTickersQueryResult = Apollo.QueryResult<CurrentUserWatchlistTickersQuery, CurrentUserWatchlistTickersQueryVariables>;
export const CurrentUserWhitePaperDraftsDocument = gql`
    query CurrentUserWhitePaperDrafts {
  currentUser {
    id
    draftWhitePapers {
      id
      title
      categories
      updatedAt
    }
  }
}
    `;

/**
 * __useCurrentUserWhitePaperDraftsQuery__
 *
 * To run a query within a React component, call `useCurrentUserWhitePaperDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserWhitePaperDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserWhitePaperDraftsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserWhitePaperDraftsQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>(CurrentUserWhitePaperDraftsDocument, options);
      }
export function useCurrentUserWhitePaperDraftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>(CurrentUserWhitePaperDraftsDocument, options);
        }
export function useCurrentUserWhitePaperDraftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>(CurrentUserWhitePaperDraftsDocument, options);
        }
export type CurrentUserWhitePaperDraftsQueryHookResult = ReturnType<typeof useCurrentUserWhitePaperDraftsQuery>;
export type CurrentUserWhitePaperDraftsLazyQueryHookResult = ReturnType<typeof useCurrentUserWhitePaperDraftsLazyQuery>;
export type CurrentUserWhitePaperDraftsSuspenseQueryHookResult = ReturnType<typeof useCurrentUserWhitePaperDraftsSuspenseQuery>;
export type CurrentUserWhitePaperDraftsQueryResult = Apollo.QueryResult<CurrentUserWhitePaperDraftsQuery, CurrentUserWhitePaperDraftsQueryVariables>;
export const EmailSearchDocument = gql`
    query EmailSearch($email: String, $userOnly: Boolean) {
  emailSearch(email: $email, userOnly: $userOnly)
}
    `;

/**
 * __useEmailSearchQuery__
 *
 * To run a query within a React component, call `useEmailSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailSearchQuery({
 *   variables: {
 *      email: // value for 'email'
 *      userOnly: // value for 'userOnly'
 *   },
 * });
 */
export function useEmailSearchQuery(baseOptions?: Apollo.QueryHookOptions<EmailSearchQuery, EmailSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailSearchQuery, EmailSearchQueryVariables>(EmailSearchDocument, options);
      }
export function useEmailSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailSearchQuery, EmailSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailSearchQuery, EmailSearchQueryVariables>(EmailSearchDocument, options);
        }
export function useEmailSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailSearchQuery, EmailSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailSearchQuery, EmailSearchQueryVariables>(EmailSearchDocument, options);
        }
export type EmailSearchQueryHookResult = ReturnType<typeof useEmailSearchQuery>;
export type EmailSearchLazyQueryHookResult = ReturnType<typeof useEmailSearchLazyQuery>;
export type EmailSearchSuspenseQueryHookResult = ReturnType<typeof useEmailSearchSuspenseQuery>;
export type EmailSearchQueryResult = Apollo.QueryResult<EmailSearchQuery, EmailSearchQueryVariables>;
export const EmployerBlacklistDocument = gql`
    query EmployerBlacklist {
  employerBlacklist
}
    `;

/**
 * __useEmployerBlacklistQuery__
 *
 * To run a query within a React component, call `useEmployerBlacklistQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerBlacklistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerBlacklistQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployerBlacklistQuery(baseOptions?: Apollo.QueryHookOptions<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>(EmployerBlacklistDocument, options);
      }
export function useEmployerBlacklistLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>(EmployerBlacklistDocument, options);
        }
export function useEmployerBlacklistSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>(EmployerBlacklistDocument, options);
        }
export type EmployerBlacklistQueryHookResult = ReturnType<typeof useEmployerBlacklistQuery>;
export type EmployerBlacklistLazyQueryHookResult = ReturnType<typeof useEmployerBlacklistLazyQuery>;
export type EmployerBlacklistSuspenseQueryHookResult = ReturnType<typeof useEmployerBlacklistSuspenseQuery>;
export type EmployerBlacklistQueryResult = Apollo.QueryResult<EmployerBlacklistQuery, EmployerBlacklistQueryVariables>;
export const EmployerSearchDocument = gql`
    query EmployerSearch($query: String) {
  employerSearch(query: $query) {
    name
    aumRange
    fundType
  }
}
    `;

/**
 * __useEmployerSearchQuery__
 *
 * To run a query within a React component, call `useEmployerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEmployerSearchQuery(baseOptions?: Apollo.QueryHookOptions<EmployerSearchQuery, EmployerSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerSearchQuery, EmployerSearchQueryVariables>(EmployerSearchDocument, options);
      }
export function useEmployerSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerSearchQuery, EmployerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerSearchQuery, EmployerSearchQueryVariables>(EmployerSearchDocument, options);
        }
export function useEmployerSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmployerSearchQuery, EmployerSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmployerSearchQuery, EmployerSearchQueryVariables>(EmployerSearchDocument, options);
        }
export type EmployerSearchQueryHookResult = ReturnType<typeof useEmployerSearchQuery>;
export type EmployerSearchLazyQueryHookResult = ReturnType<typeof useEmployerSearchLazyQuery>;
export type EmployerSearchSuspenseQueryHookResult = ReturnType<typeof useEmployerSearchSuspenseQuery>;
export type EmployerSearchQueryResult = Apollo.QueryResult<EmployerSearchQuery, EmployerSearchQueryVariables>;
export const EntitiesByBloombergSymbolDocument = gql`
    query EntitiesByBloombergSymbol($query: String!) {
  entitiesByBloombergSymbol(query: $query) {
    id
    name
    primarySymbol
  }
}
    `;

/**
 * __useEntitiesByBloombergSymbolQuery__
 *
 * To run a query within a React component, call `useEntitiesByBloombergSymbolQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntitiesByBloombergSymbolQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntitiesByBloombergSymbolQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEntitiesByBloombergSymbolQuery(baseOptions: Apollo.QueryHookOptions<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables> & ({ variables: EntitiesByBloombergSymbolQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables>(EntitiesByBloombergSymbolDocument, options);
      }
export function useEntitiesByBloombergSymbolLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables>(EntitiesByBloombergSymbolDocument, options);
        }
export function useEntitiesByBloombergSymbolSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables>(EntitiesByBloombergSymbolDocument, options);
        }
export type EntitiesByBloombergSymbolQueryHookResult = ReturnType<typeof useEntitiesByBloombergSymbolQuery>;
export type EntitiesByBloombergSymbolLazyQueryHookResult = ReturnType<typeof useEntitiesByBloombergSymbolLazyQuery>;
export type EntitiesByBloombergSymbolSuspenseQueryHookResult = ReturnType<typeof useEntitiesByBloombergSymbolSuspenseQuery>;
export type EntitiesByBloombergSymbolQueryResult = Apollo.QueryResult<EntitiesByBloombergSymbolQuery, EntitiesByBloombergSymbolQueryVariables>;
export const EntityFeedCurrentUserDocument = gql`
    query EntityFeedCurrentUser {
  currentUser {
    id
    canCommentAnonymously
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    isAdmin
    isAllocator
    isRetail
    profileImageUrl
    sessionId
  }
}
    `;

/**
 * __useEntityFeedCurrentUserQuery__
 *
 * To run a query within a React component, call `useEntityFeedCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityFeedCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityFeedCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityFeedCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>(EntityFeedCurrentUserDocument, options);
      }
export function useEntityFeedCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>(EntityFeedCurrentUserDocument, options);
        }
export function useEntityFeedCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>(EntityFeedCurrentUserDocument, options);
        }
export type EntityFeedCurrentUserQueryHookResult = ReturnType<typeof useEntityFeedCurrentUserQuery>;
export type EntityFeedCurrentUserLazyQueryHookResult = ReturnType<typeof useEntityFeedCurrentUserLazyQuery>;
export type EntityFeedCurrentUserSuspenseQueryHookResult = ReturnType<typeof useEntityFeedCurrentUserSuspenseQuery>;
export type EntityFeedCurrentUserQueryResult = Apollo.QueryResult<EntityFeedCurrentUserQuery, EntityFeedCurrentUserQueryVariables>;
export const EntityOverviewDocument = gql`
    query EntityOverview($id: ID!) {
  entity(id: $id) {
    id
    name
    primaryAsset {
      id
      latestPrice
      latestQuoteDate
      fundamental {
        id
        sellsideConsensusText
      }
    }
    primarySymbol
  }
}
    `;

/**
 * __useEntityOverviewQuery__
 *
 * To run a query within a React component, call `useEntityOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityOverviewQuery(baseOptions: Apollo.QueryHookOptions<EntityOverviewQuery, EntityOverviewQueryVariables> & ({ variables: EntityOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityOverviewQuery, EntityOverviewQueryVariables>(EntityOverviewDocument, options);
      }
export function useEntityOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityOverviewQuery, EntityOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityOverviewQuery, EntityOverviewQueryVariables>(EntityOverviewDocument, options);
        }
export function useEntityOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityOverviewQuery, EntityOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityOverviewQuery, EntityOverviewQueryVariables>(EntityOverviewDocument, options);
        }
export type EntityOverviewQueryHookResult = ReturnType<typeof useEntityOverviewQuery>;
export type EntityOverviewLazyQueryHookResult = ReturnType<typeof useEntityOverviewLazyQuery>;
export type EntityOverviewSuspenseQueryHookResult = ReturnType<typeof useEntityOverviewSuspenseQuery>;
export type EntityOverviewQueryResult = Apollo.QueryResult<EntityOverviewQuery, EntityOverviewQueryVariables>;
export const EntityOverviewCurrentUserDocument = gql`
    query EntityOverviewCurrentUser {
  currentUser {
    id
    isAdmin
  }
}
    `;

/**
 * __useEntityOverviewCurrentUserQuery__
 *
 * To run a query within a React component, call `useEntityOverviewCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityOverviewCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityOverviewCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useEntityOverviewCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>(EntityOverviewCurrentUserDocument, options);
      }
export function useEntityOverviewCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>(EntityOverviewCurrentUserDocument, options);
        }
export function useEntityOverviewCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>(EntityOverviewCurrentUserDocument, options);
        }
export type EntityOverviewCurrentUserQueryHookResult = ReturnType<typeof useEntityOverviewCurrentUserQuery>;
export type EntityOverviewCurrentUserLazyQueryHookResult = ReturnType<typeof useEntityOverviewCurrentUserLazyQuery>;
export type EntityOverviewCurrentUserSuspenseQueryHookResult = ReturnType<typeof useEntityOverviewCurrentUserSuspenseQuery>;
export type EntityOverviewCurrentUserQueryResult = Apollo.QueryResult<EntityOverviewCurrentUserQuery, EntityOverviewCurrentUserQueryVariables>;
export const EntityPollDocument = gql`
    query EntityPoll($id: ID!) {
  entity(id: $id) {
    id
    currencyCode
    name
    pollQuestionsUnansweredByCurrentUser {
      id
      ...CompanyQuestion
    }
    primaryAssetId
    primarySymbol
  }
  companyQuestions {
    id
    ...CompanyQuestion
    yMin
    yMax
    tickCount
    showTooltip
    tickValues
    pollResponseData(entityId: $id) {
      answeredByCurrentUser
      buysidePollResultStats {
        monthlyAvg {
          label
          value
        }
        twelveMonthsPct {
          label
          value
        }
        currentMonthPct {
          label
          value
        }
      }
      retailPollResultStats {
        monthlyAvg {
          label
          value
        }
        twelveMonthsPct {
          label
          value
        }
        currentMonthPct {
          label
          value
        }
      }
    }
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    ${CompanyQuestionFragmentDoc}`;

/**
 * __useEntityPollQuery__
 *
 * To run a query within a React component, call `useEntityPollQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPollQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPollQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityPollQuery(baseOptions: Apollo.QueryHookOptions<EntityPollQuery, EntityPollQueryVariables> & ({ variables: EntityPollQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPollQuery, EntityPollQueryVariables>(EntityPollDocument, options);
      }
export function useEntityPollLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPollQuery, EntityPollQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPollQuery, EntityPollQueryVariables>(EntityPollDocument, options);
        }
export function useEntityPollSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityPollQuery, EntityPollQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityPollQuery, EntityPollQueryVariables>(EntityPollDocument, options);
        }
export type EntityPollQueryHookResult = ReturnType<typeof useEntityPollQuery>;
export type EntityPollLazyQueryHookResult = ReturnType<typeof useEntityPollLazyQuery>;
export type EntityPollSuspenseQueryHookResult = ReturnType<typeof useEntityPollSuspenseQuery>;
export type EntityPollQueryResult = Apollo.QueryResult<EntityPollQuery, EntityPollQueryVariables>;
export const EntityPostDocument = gql`
    query EntityPost($id: ID!) {
  currentUser {
    id
    acceptedPostTerms
    canPost: isBuyside
    isAdmin
    profileImageUrl
  }
  entity(id: $id) {
    id
    tickerTagString
  }
}
    `;

/**
 * __useEntityPostQuery__
 *
 * To run a query within a React component, call `useEntityPostQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityPostQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityPostQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityPostQuery(baseOptions: Apollo.QueryHookOptions<EntityPostQuery, EntityPostQueryVariables> & ({ variables: EntityPostQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityPostQuery, EntityPostQueryVariables>(EntityPostDocument, options);
      }
export function useEntityPostLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityPostQuery, EntityPostQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityPostQuery, EntityPostQueryVariables>(EntityPostDocument, options);
        }
export function useEntityPostSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityPostQuery, EntityPostQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityPostQuery, EntityPostQueryVariables>(EntityPostDocument, options);
        }
export type EntityPostQueryHookResult = ReturnType<typeof useEntityPostQuery>;
export type EntityPostLazyQueryHookResult = ReturnType<typeof useEntityPostLazyQuery>;
export type EntityPostSuspenseQueryHookResult = ReturnType<typeof useEntityPostSuspenseQuery>;
export type EntityPostQueryResult = Apollo.QueryResult<EntityPostQuery, EntityPostQueryVariables>;
export const EntityRelatedCompaniesDocument = gql`
    query EntityRelatedCompanies($id: ID!) {
  entity(id: $id) {
    id
    relatedCompanies {
      id
      mostRecentIdea {
        id
        canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(
          resource: "idea_filter_details"
          permission: "view"
        )
        elevatorPitch
        positions {
          id
          direction
        }
        postedAt
        totalReturn
        user {
          id
          displayName
          profileImageUrl
        }
      }
      name
      primarySymbol
    }
  }
}
    `;

/**
 * __useEntityRelatedCompaniesQuery__
 *
 * To run a query within a React component, call `useEntityRelatedCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityRelatedCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityRelatedCompaniesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityRelatedCompaniesQuery(baseOptions: Apollo.QueryHookOptions<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables> & ({ variables: EntityRelatedCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables>(EntityRelatedCompaniesDocument, options);
      }
export function useEntityRelatedCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables>(EntityRelatedCompaniesDocument, options);
        }
export function useEntityRelatedCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables>(EntityRelatedCompaniesDocument, options);
        }
export type EntityRelatedCompaniesQueryHookResult = ReturnType<typeof useEntityRelatedCompaniesQuery>;
export type EntityRelatedCompaniesLazyQueryHookResult = ReturnType<typeof useEntityRelatedCompaniesLazyQuery>;
export type EntityRelatedCompaniesSuspenseQueryHookResult = ReturnType<typeof useEntityRelatedCompaniesSuspenseQuery>;
export type EntityRelatedCompaniesQueryResult = Apollo.QueryResult<EntityRelatedCompaniesQuery, EntityRelatedCompaniesQueryVariables>;
export const EntityStatsDocument = gql`
    query EntityStats($id: ID!) {
  entity(id: $id) {
    id
    primaryAsset {
      id
      companyData {
        id
        country
        geography
        industry
        sector
      }
      currencyCode
      fiftyTwoWeekRange
      fundamental {
        ...CompanyPageFundamental
      }
    }
  }
}
    ${CompanyPageFundamentalFragmentDoc}`;

/**
 * __useEntityStatsQuery__
 *
 * To run a query within a React component, call `useEntityStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityStatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEntityStatsQuery(baseOptions: Apollo.QueryHookOptions<EntityStatsQuery, EntityStatsQueryVariables> & ({ variables: EntityStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityStatsQuery, EntityStatsQueryVariables>(EntityStatsDocument, options);
      }
export function useEntityStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityStatsQuery, EntityStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityStatsQuery, EntityStatsQueryVariables>(EntityStatsDocument, options);
        }
export function useEntityStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityStatsQuery, EntityStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityStatsQuery, EntityStatsQueryVariables>(EntityStatsDocument, options);
        }
export type EntityStatsQueryHookResult = ReturnType<typeof useEntityStatsQuery>;
export type EntityStatsLazyQueryHookResult = ReturnType<typeof useEntityStatsLazyQuery>;
export type EntityStatsSuspenseQueryHookResult = ReturnType<typeof useEntityStatsSuspenseQuery>;
export type EntityStatsQueryResult = Apollo.QueryResult<EntityStatsQuery, EntityStatsQueryVariables>;
export const EntityToMentionSearchDocument = gql`
    query entityToMentionSearch($query: String!) {
  assetsByBloombergSymbol(query: $query) {
    entityId
    mentionDisplay
    entity {
      id
      primarySymbol
    }
  }
}
    `;

/**
 * __useEntityToMentionSearchQuery__
 *
 * To run a query within a React component, call `useEntityToMentionSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useEntityToMentionSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEntityToMentionSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEntityToMentionSearchQuery(baseOptions: Apollo.QueryHookOptions<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables> & ({ variables: EntityToMentionSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables>(EntityToMentionSearchDocument, options);
      }
export function useEntityToMentionSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables>(EntityToMentionSearchDocument, options);
        }
export function useEntityToMentionSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables>(EntityToMentionSearchDocument, options);
        }
export type EntityToMentionSearchQueryHookResult = ReturnType<typeof useEntityToMentionSearchQuery>;
export type EntityToMentionSearchLazyQueryHookResult = ReturnType<typeof useEntityToMentionSearchLazyQuery>;
export type EntityToMentionSearchSuspenseQueryHookResult = ReturnType<typeof useEntityToMentionSearchSuspenseQuery>;
export type EntityToMentionSearchQueryResult = Apollo.QueryResult<EntityToMentionSearchQuery, EntityToMentionSearchQueryVariables>;
export const EventRegistrationSponsorsDocument = gql`
    query EventRegistrationSponsors($contestId: ID!) {
  contest(id: $contestId) {
    id
    eventSponsors {
      id
      sponsorImage
      sponsorTrackingLink
    }
  }
}
    `;

/**
 * __useEventRegistrationSponsorsQuery__
 *
 * To run a query within a React component, call `useEventRegistrationSponsorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventRegistrationSponsorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventRegistrationSponsorsQuery({
 *   variables: {
 *      contestId: // value for 'contestId'
 *   },
 * });
 */
export function useEventRegistrationSponsorsQuery(baseOptions: Apollo.QueryHookOptions<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables> & ({ variables: EventRegistrationSponsorsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables>(EventRegistrationSponsorsDocument, options);
      }
export function useEventRegistrationSponsorsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables>(EventRegistrationSponsorsDocument, options);
        }
export function useEventRegistrationSponsorsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables>(EventRegistrationSponsorsDocument, options);
        }
export type EventRegistrationSponsorsQueryHookResult = ReturnType<typeof useEventRegistrationSponsorsQuery>;
export type EventRegistrationSponsorsLazyQueryHookResult = ReturnType<typeof useEventRegistrationSponsorsLazyQuery>;
export type EventRegistrationSponsorsSuspenseQueryHookResult = ReturnType<typeof useEventRegistrationSponsorsSuspenseQuery>;
export type EventRegistrationSponsorsQueryResult = Apollo.QueryResult<EventRegistrationSponsorsQuery, EventRegistrationSponsorsQueryVariables>;
export const FeaturedContestDocument = gql`
    query FeaturedContest {
  featuredContests {
    id
    active
    name
    countdownDate
    disableSiteWideModal
  }
}
    `;

/**
 * __useFeaturedContestQuery__
 *
 * To run a query within a React component, call `useFeaturedContestQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeaturedContestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeaturedContestQuery({
 *   variables: {
 *   },
 * });
 */
export function useFeaturedContestQuery(baseOptions?: Apollo.QueryHookOptions<FeaturedContestQuery, FeaturedContestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeaturedContestQuery, FeaturedContestQueryVariables>(FeaturedContestDocument, options);
      }
export function useFeaturedContestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeaturedContestQuery, FeaturedContestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeaturedContestQuery, FeaturedContestQueryVariables>(FeaturedContestDocument, options);
        }
export function useFeaturedContestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeaturedContestQuery, FeaturedContestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeaturedContestQuery, FeaturedContestQueryVariables>(FeaturedContestDocument, options);
        }
export type FeaturedContestQueryHookResult = ReturnType<typeof useFeaturedContestQuery>;
export type FeaturedContestLazyQueryHookResult = ReturnType<typeof useFeaturedContestLazyQuery>;
export type FeaturedContestSuspenseQueryHookResult = ReturnType<typeof useFeaturedContestSuspenseQuery>;
export type FeaturedContestQueryResult = Apollo.QueryResult<FeaturedContestQuery, FeaturedContestQueryVariables>;
export const FeedDocument = gql`
    query Feed($feedId: ID, $feedType: String, $feedFilter: String, $cursor: String) {
  feedItems(
    feedId: $feedId
    feedType: $feedType
    feedFilter: $feedFilter
    first: 4
    after: $cursor
  ) {
    edges {
      node {
        ...ActivityFeedItem
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ActivityFeedItemFragmentDoc}`;

/**
 * __useFeedQuery__
 *
 * To run a query within a React component, call `useFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedQuery({
 *   variables: {
 *      feedId: // value for 'feedId'
 *      feedType: // value for 'feedType'
 *      feedFilter: // value for 'feedFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFeedQuery(baseOptions?: Apollo.QueryHookOptions<FeedQuery, FeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
      }
export function useFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export function useFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedQuery, FeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedQuery, FeedQueryVariables>(FeedDocument, options);
        }
export type FeedQueryHookResult = ReturnType<typeof useFeedQuery>;
export type FeedLazyQueryHookResult = ReturnType<typeof useFeedLazyQuery>;
export type FeedSuspenseQueryHookResult = ReturnType<typeof useFeedSuspenseQuery>;
export type FeedQueryResult = Apollo.QueryResult<FeedQuery, FeedQueryVariables>;
export const FeedRankDocument = gql`
    query FeedRank($feedItemId: ID!) {
  biggestMoverRank(feedItemId: $feedItemId) {
    ...ActivityFeedRank
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canManageMessages: canAccess(resource: "messages", permission: "manage")
  }
}
    ${ActivityFeedRankFragmentDoc}`;

/**
 * __useFeedRankQuery__
 *
 * To run a query within a React component, call `useFeedRankQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedRankQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedRankQuery({
 *   variables: {
 *      feedItemId: // value for 'feedItemId'
 *   },
 * });
 */
export function useFeedRankQuery(baseOptions: Apollo.QueryHookOptions<FeedRankQuery, FeedRankQueryVariables> & ({ variables: FeedRankQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedRankQuery, FeedRankQueryVariables>(FeedRankDocument, options);
      }
export function useFeedRankLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedRankQuery, FeedRankQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedRankQuery, FeedRankQueryVariables>(FeedRankDocument, options);
        }
export function useFeedRankSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedRankQuery, FeedRankQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedRankQuery, FeedRankQueryVariables>(FeedRankDocument, options);
        }
export type FeedRankQueryHookResult = ReturnType<typeof useFeedRankQuery>;
export type FeedRankLazyQueryHookResult = ReturnType<typeof useFeedRankLazyQuery>;
export type FeedRankSuspenseQueryHookResult = ReturnType<typeof useFeedRankSuspenseQuery>;
export type FeedRankQueryResult = Apollo.QueryResult<FeedRankQuery, FeedRankQueryVariables>;
export const FeedShowDocument = gql`
    query FeedShow($showId: ID!) {
  feedItemShow(feedItemId: $showId) {
    ...ActivityFeedItem
  }
}
    ${ActivityFeedItemFragmentDoc}`;

/**
 * __useFeedShowQuery__
 *
 * To run a query within a React component, call `useFeedShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useFeedShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFeedShowQuery({
 *   variables: {
 *      showId: // value for 'showId'
 *   },
 * });
 */
export function useFeedShowQuery(baseOptions: Apollo.QueryHookOptions<FeedShowQuery, FeedShowQueryVariables> & ({ variables: FeedShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FeedShowQuery, FeedShowQueryVariables>(FeedShowDocument, options);
      }
export function useFeedShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FeedShowQuery, FeedShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FeedShowQuery, FeedShowQueryVariables>(FeedShowDocument, options);
        }
export function useFeedShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FeedShowQuery, FeedShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FeedShowQuery, FeedShowQueryVariables>(FeedShowDocument, options);
        }
export type FeedShowQueryHookResult = ReturnType<typeof useFeedShowQuery>;
export type FeedShowLazyQueryHookResult = ReturnType<typeof useFeedShowLazyQuery>;
export type FeedShowSuspenseQueryHookResult = ReturnType<typeof useFeedShowSuspenseQuery>;
export type FeedShowQueryResult = Apollo.QueryResult<FeedShowQuery, FeedShowQueryVariables>;
export const FundLetterSourcesDocument = gql`
    query FundLetterSources {
  fundLetterSources {
    startingCharacter
    sources
  }
}
    `;

/**
 * __useFundLetterSourcesQuery__
 *
 * To run a query within a React component, call `useFundLetterSourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundLetterSourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundLetterSourcesQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundLetterSourcesQuery(baseOptions?: Apollo.QueryHookOptions<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>(FundLetterSourcesDocument, options);
      }
export function useFundLetterSourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>(FundLetterSourcesDocument, options);
        }
export function useFundLetterSourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>(FundLetterSourcesDocument, options);
        }
export type FundLetterSourcesQueryHookResult = ReturnType<typeof useFundLetterSourcesQuery>;
export type FundLetterSourcesLazyQueryHookResult = ReturnType<typeof useFundLetterSourcesLazyQuery>;
export type FundLetterSourcesSuspenseQueryHookResult = ReturnType<typeof useFundLetterSourcesSuspenseQuery>;
export type FundLetterSourcesQueryResult = Apollo.QueryResult<FundLetterSourcesQuery, FundLetterSourcesQueryVariables>;
export const FundLettersDocument = gql`
    query FundLetters($fundName: String!, $cursor: String) {
  lettersForFund(fundName: $fundName, first: 3, after: $cursor) {
    edges {
      node {
        id
        name
        pdfLink
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    `;

/**
 * __useFundLettersQuery__
 *
 * To run a query within a React component, call `useFundLettersQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundLettersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundLettersQuery({
 *   variables: {
 *      fundName: // value for 'fundName'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useFundLettersQuery(baseOptions: Apollo.QueryHookOptions<FundLettersQuery, FundLettersQueryVariables> & ({ variables: FundLettersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundLettersQuery, FundLettersQueryVariables>(FundLettersDocument, options);
      }
export function useFundLettersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundLettersQuery, FundLettersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundLettersQuery, FundLettersQueryVariables>(FundLettersDocument, options);
        }
export function useFundLettersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundLettersQuery, FundLettersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundLettersQuery, FundLettersQueryVariables>(FundLettersDocument, options);
        }
export type FundLettersQueryHookResult = ReturnType<typeof useFundLettersQuery>;
export type FundLettersLazyQueryHookResult = ReturnType<typeof useFundLettersLazyQuery>;
export type FundLettersSuspenseQueryHookResult = ReturnType<typeof useFundLettersSuspenseQuery>;
export type FundLettersQueryResult = Apollo.QueryResult<FundLettersQuery, FundLettersQueryVariables>;
export const FundProfileCurrentUserDocument = gql`
    query FundProfileCurrentUser {
  currentUser {
    id
    introRequestCount
    isAdmin
    isAllocator
    isCapIntroMember
    profileImageUrl
  }
}
    `;

/**
 * __useFundProfileCurrentUserQuery__
 *
 * To run a query within a React component, call `useFundProfileCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundProfileCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundProfileCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundProfileCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>(FundProfileCurrentUserDocument, options);
      }
export function useFundProfileCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>(FundProfileCurrentUserDocument, options);
        }
export function useFundProfileCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>(FundProfileCurrentUserDocument, options);
        }
export type FundProfileCurrentUserQueryHookResult = ReturnType<typeof useFundProfileCurrentUserQuery>;
export type FundProfileCurrentUserLazyQueryHookResult = ReturnType<typeof useFundProfileCurrentUserLazyQuery>;
export type FundProfileCurrentUserSuspenseQueryHookResult = ReturnType<typeof useFundProfileCurrentUserSuspenseQuery>;
export type FundProfileCurrentUserQueryResult = Apollo.QueryResult<FundProfileCurrentUserQuery, FundProfileCurrentUserQueryVariables>;
export const FundProfileIndexListDocument = gql`
    query FundProfileIndexList($searchParams: String, $indexType: String!) {
  fundProfilesIndexList(searchParams: $searchParams) {
    ...FundProfileIndexItem
  }
  fundProfilesIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: $indexType
  )
}
    ${FundProfileIndexItemFragmentDoc}`;

/**
 * __useFundProfileIndexListQuery__
 *
 * To run a query within a React component, call `useFundProfileIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundProfileIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundProfileIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useFundProfileIndexListQuery(baseOptions: Apollo.QueryHookOptions<FundProfileIndexListQuery, FundProfileIndexListQueryVariables> & ({ variables: FundProfileIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundProfileIndexListQuery, FundProfileIndexListQueryVariables>(FundProfileIndexListDocument, options);
      }
export function useFundProfileIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundProfileIndexListQuery, FundProfileIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundProfileIndexListQuery, FundProfileIndexListQueryVariables>(FundProfileIndexListDocument, options);
        }
export function useFundProfileIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundProfileIndexListQuery, FundProfileIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundProfileIndexListQuery, FundProfileIndexListQueryVariables>(FundProfileIndexListDocument, options);
        }
export type FundProfileIndexListQueryHookResult = ReturnType<typeof useFundProfileIndexListQuery>;
export type FundProfileIndexListLazyQueryHookResult = ReturnType<typeof useFundProfileIndexListLazyQuery>;
export type FundProfileIndexListSuspenseQueryHookResult = ReturnType<typeof useFundProfileIndexListSuspenseQuery>;
export type FundProfileIndexListQueryResult = Apollo.QueryResult<FundProfileIndexListQuery, FundProfileIndexListQueryVariables>;
export const FundProfileIndexSavedSearchDocument = gql`
    query FundProfileIndexSavedSearch {
  fundProfilesSavedSearchList {
    edges {
      node {
        ...FundProfileSavedSearch
      }
    }
  }
}
    ${FundProfileSavedSearchFragmentDoc}`;

/**
 * __useFundProfileIndexSavedSearchQuery__
 *
 * To run a query within a React component, call `useFundProfileIndexSavedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundProfileIndexSavedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundProfileIndexSavedSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundProfileIndexSavedSearchQuery(baseOptions?: Apollo.QueryHookOptions<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>(FundProfileIndexSavedSearchDocument, options);
      }
export function useFundProfileIndexSavedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>(FundProfileIndexSavedSearchDocument, options);
        }
export function useFundProfileIndexSavedSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>(FundProfileIndexSavedSearchDocument, options);
        }
export type FundProfileIndexSavedSearchQueryHookResult = ReturnType<typeof useFundProfileIndexSavedSearchQuery>;
export type FundProfileIndexSavedSearchLazyQueryHookResult = ReturnType<typeof useFundProfileIndexSavedSearchLazyQuery>;
export type FundProfileIndexSavedSearchSuspenseQueryHookResult = ReturnType<typeof useFundProfileIndexSavedSearchSuspenseQuery>;
export type FundProfileIndexSavedSearchQueryResult = Apollo.QueryResult<FundProfileIndexSavedSearchQuery, FundProfileIndexSavedSearchQueryVariables>;
export const FundProfileRecommendationsDocument = gql`
    query FundProfileRecommendations($showAll: Boolean) {
  fundRecommendations(showAll: $showAll) {
    edges {
      node {
        matchesGeographies
        matchesSectors
        matchesAssetClasses
        geographiesMatching
        sectorsMatching
        assetClassesMatching
        hide
        ...FundProfileRecommendation
      }
    }
  }
}
    ${FundProfileRecommendationFragmentDoc}`;

/**
 * __useFundProfileRecommendationsQuery__
 *
 * To run a query within a React component, call `useFundProfileRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundProfileRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundProfileRecommendationsQuery({
 *   variables: {
 *      showAll: // value for 'showAll'
 *   },
 * });
 */
export function useFundProfileRecommendationsQuery(baseOptions?: Apollo.QueryHookOptions<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>(FundProfileRecommendationsDocument, options);
      }
export function useFundProfileRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>(FundProfileRecommendationsDocument, options);
        }
export function useFundProfileRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>(FundProfileRecommendationsDocument, options);
        }
export type FundProfileRecommendationsQueryHookResult = ReturnType<typeof useFundProfileRecommendationsQuery>;
export type FundProfileRecommendationsLazyQueryHookResult = ReturnType<typeof useFundProfileRecommendationsLazyQuery>;
export type FundProfileRecommendationsSuspenseQueryHookResult = ReturnType<typeof useFundProfileRecommendationsSuspenseQuery>;
export type FundProfileRecommendationsQueryResult = Apollo.QueryResult<FundProfileRecommendationsQuery, FundProfileRecommendationsQueryVariables>;
export const FundProfileShowPageDocument = gql`
    query FundProfileShowPage($employerProfileId: ID!) {
  currentUser {
    id
    acceptedFundDisclaimer
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    currentEmployerName
    isAdmin
    isAllocator
    isFundAdmin(employerProfileId: $employerProfileId)
    isPaladin
  }
  fundProfile(id: $employerProfileId) {
    aum
    currentEmployees {
      id
      displayName
    }
    foundingDate
    fundAdminIds
    fundManager
    ...FundProfileBackgroundImage
    fundRecommendation {
      ...FundProfileRecommendation
    }
    pendingIntroRequest {
      id
      status
      messageThread
    }
    ...FundProfileCard
    ...FundProfileAdminDashboard
    sectionCompletenessPercents
    excludedSections
    sectionVisibilities
    ...FundProfileExecutiveManagement
    ...FundProfileFirmReferences
    ...FundProfileExpertise
    ...FundProfileTags
    ...FundProfileReturns
    ...FundProfileFeaturedResearch
    ...FundProfileFeaturedWhitePaperResearch
    ...FundProfileFundHoldings
    ...FundProfileMarketingMaterials
    ...FundProfilePressMedia
    ...FundProfileMetrics
    ...FundProfileFeeStructure
    ...FundProfileDueDiligence
    ...FundProfileNotes
    currentUserOnBlocklist
    currentUserViewCount
    currentUserHasMessagedFund
  }
}
    ${FundProfileBackgroundImageFragmentDoc}
${FundProfileRecommendationFragmentDoc}
${FundProfileCardFragmentDoc}
${FundProfileAdminDashboardFragmentDoc}
${FundProfileExecutiveManagementFragmentDoc}
${FundProfileFirmReferencesFragmentDoc}
${FundProfileExpertiseFragmentDoc}
${FundProfileTagsFragmentDoc}
${FundProfileReturnsFragmentDoc}
${FundProfileFeaturedResearchFragmentDoc}
${FundProfileFeaturedWhitePaperResearchFragmentDoc}
${FundProfileFundHoldingsFragmentDoc}
${FundProfileMarketingMaterialsFragmentDoc}
${FundProfilePressMediaFragmentDoc}
${FundProfileMetricsFragmentDoc}
${FundProfileFeeStructureFragmentDoc}
${FundProfileDueDiligenceFragmentDoc}
${FundProfileNotesFragmentDoc}`;

/**
 * __useFundProfileShowPageQuery__
 *
 * To run a query within a React component, call `useFundProfileShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundProfileShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundProfileShowPageQuery({
 *   variables: {
 *      employerProfileId: // value for 'employerProfileId'
 *   },
 * });
 */
export function useFundProfileShowPageQuery(baseOptions: Apollo.QueryHookOptions<FundProfileShowPageQuery, FundProfileShowPageQueryVariables> & ({ variables: FundProfileShowPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FundProfileShowPageQuery, FundProfileShowPageQueryVariables>(FundProfileShowPageDocument, options);
      }
export function useFundProfileShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FundProfileShowPageQuery, FundProfileShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FundProfileShowPageQuery, FundProfileShowPageQueryVariables>(FundProfileShowPageDocument, options);
        }
export function useFundProfileShowPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FundProfileShowPageQuery, FundProfileShowPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FundProfileShowPageQuery, FundProfileShowPageQueryVariables>(FundProfileShowPageDocument, options);
        }
export type FundProfileShowPageQueryHookResult = ReturnType<typeof useFundProfileShowPageQuery>;
export type FundProfileShowPageLazyQueryHookResult = ReturnType<typeof useFundProfileShowPageLazyQuery>;
export type FundProfileShowPageSuspenseQueryHookResult = ReturnType<typeof useFundProfileShowPageSuspenseQuery>;
export type FundProfileShowPageQueryResult = Apollo.QueryResult<FundProfileShowPageQuery, FundProfileShowPageQueryVariables>;
export const HomePageCommentsDocument = gql`
    query HomePageComments($offset: Int!, $searchParams: String) {
  homeComments(offset: $offset, searchParams: $searchParams) {
    ...ActivityFeedComment
    parsedBody
    commentObject {
      ... on Idea {
        id
        assetSymbol
        entityName
      }
      ... on IdeaUpdate {
        id
        idea {
          id
          assetSymbol
          entityName
        }
      }
    }
  }
  maxOffset: homeCommentsMaxOffset
}
    ${ActivityFeedCommentFragmentDoc}`;

/**
 * __useHomePageCommentsQuery__
 *
 * To run a query within a React component, call `useHomePageCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageCommentsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useHomePageCommentsQuery(baseOptions: Apollo.QueryHookOptions<HomePageCommentsQuery, HomePageCommentsQueryVariables> & ({ variables: HomePageCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageCommentsQuery, HomePageCommentsQueryVariables>(HomePageCommentsDocument, options);
      }
export function useHomePageCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageCommentsQuery, HomePageCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageCommentsQuery, HomePageCommentsQueryVariables>(HomePageCommentsDocument, options);
        }
export function useHomePageCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageCommentsQuery, HomePageCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePageCommentsQuery, HomePageCommentsQueryVariables>(HomePageCommentsDocument, options);
        }
export type HomePageCommentsQueryHookResult = ReturnType<typeof useHomePageCommentsQuery>;
export type HomePageCommentsLazyQueryHookResult = ReturnType<typeof useHomePageCommentsLazyQuery>;
export type HomePageCommentsSuspenseQueryHookResult = ReturnType<typeof useHomePageCommentsSuspenseQuery>;
export type HomePageCommentsQueryResult = Apollo.QueryResult<HomePageCommentsQuery, HomePageCommentsQueryVariables>;
export const HomePageIdeaUpdatesDocument = gql`
    query HomePageIdeaUpdates($offset: Int!, $searchParams: String) {
  homeIdeaUpdates(offset: $offset, searchParams: $searchParams) {
    id
    changesHash
    closed
    idea {
      id
      assetSymbol
      entityName
    }
    impact
    postedAt
    text
    user {
      ...ResearchItemUser
    }
  }
  maxOffset: homeIdeaUpdatesMaxOffset(searchParams: $searchParams)
}
    ${ResearchItemUserFragmentDoc}`;

/**
 * __useHomePageIdeaUpdatesQuery__
 *
 * To run a query within a React component, call `useHomePageIdeaUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageIdeaUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageIdeaUpdatesQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useHomePageIdeaUpdatesQuery(baseOptions: Apollo.QueryHookOptions<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables> & ({ variables: HomePageIdeaUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables>(HomePageIdeaUpdatesDocument, options);
      }
export function useHomePageIdeaUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables>(HomePageIdeaUpdatesDocument, options);
        }
export function useHomePageIdeaUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables>(HomePageIdeaUpdatesDocument, options);
        }
export type HomePageIdeaUpdatesQueryHookResult = ReturnType<typeof useHomePageIdeaUpdatesQuery>;
export type HomePageIdeaUpdatesLazyQueryHookResult = ReturnType<typeof useHomePageIdeaUpdatesLazyQuery>;
export type HomePageIdeaUpdatesSuspenseQueryHookResult = ReturnType<typeof useHomePageIdeaUpdatesSuspenseQuery>;
export type HomePageIdeaUpdatesQueryResult = Apollo.QueryResult<HomePageIdeaUpdatesQuery, HomePageIdeaUpdatesQueryVariables>;
export const HomePageTrendingIdeasDocument = gql`
    query HomePageTrendingIdeas {
  trendingIdeas {
    edges {
      node {
        id
        positions {
          id
          primarySymbol
        }
        totalReturn
      }
    }
  }
}
    `;

/**
 * __useHomePageTrendingIdeasQuery__
 *
 * To run a query within a React component, call `useHomePageTrendingIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useHomePageTrendingIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHomePageTrendingIdeasQuery({
 *   variables: {
 *   },
 * });
 */
export function useHomePageTrendingIdeasQuery(baseOptions?: Apollo.QueryHookOptions<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>(HomePageTrendingIdeasDocument, options);
      }
export function useHomePageTrendingIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>(HomePageTrendingIdeasDocument, options);
        }
export function useHomePageTrendingIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>(HomePageTrendingIdeasDocument, options);
        }
export type HomePageTrendingIdeasQueryHookResult = ReturnType<typeof useHomePageTrendingIdeasQuery>;
export type HomePageTrendingIdeasLazyQueryHookResult = ReturnType<typeof useHomePageTrendingIdeasLazyQuery>;
export type HomePageTrendingIdeasSuspenseQueryHookResult = ReturnType<typeof useHomePageTrendingIdeasSuspenseQuery>;
export type HomePageTrendingIdeasQueryResult = Apollo.QueryResult<HomePageTrendingIdeasQuery, HomePageTrendingIdeasQueryVariables>;
export const IdeaIndexCurrentUserDocument = gql`
    query IdeaIndexCurrentUser {
  currentUser {
    id
    profileImageUrl
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    isPaladin
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
    canViewIdeaFilterDetails: canAccess(
      resource: "idea_filter_details"
      permission: "view"
    )
    isBuyside
  }
}
    `;

/**
 * __useIdeaIndexCurrentUserQuery__
 *
 * To run a query within a React component, call `useIdeaIndexCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaIndexCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaIndexCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdeaIndexCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>(IdeaIndexCurrentUserDocument, options);
      }
export function useIdeaIndexCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>(IdeaIndexCurrentUserDocument, options);
        }
export function useIdeaIndexCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>(IdeaIndexCurrentUserDocument, options);
        }
export type IdeaIndexCurrentUserQueryHookResult = ReturnType<typeof useIdeaIndexCurrentUserQuery>;
export type IdeaIndexCurrentUserLazyQueryHookResult = ReturnType<typeof useIdeaIndexCurrentUserLazyQuery>;
export type IdeaIndexCurrentUserSuspenseQueryHookResult = ReturnType<typeof useIdeaIndexCurrentUserSuspenseQuery>;
export type IdeaIndexCurrentUserQueryResult = Apollo.QueryResult<IdeaIndexCurrentUserQuery, IdeaIndexCurrentUserQueryVariables>;
export const IdeaIndexListDocument = gql`
    query IdeaIndexList($searchParams: String) {
  ideasIndexList(searchParams: $searchParams) {
    edges {
      node {
        ...IdeaResearchItem
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  ideasIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: "IdeasIndex"
  )
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useIdeaIndexListQuery__
 *
 * To run a query within a React component, call `useIdeaIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useIdeaIndexListQuery(baseOptions?: Apollo.QueryHookOptions<IdeaIndexListQuery, IdeaIndexListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaIndexListQuery, IdeaIndexListQueryVariables>(IdeaIndexListDocument, options);
      }
export function useIdeaIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaIndexListQuery, IdeaIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaIndexListQuery, IdeaIndexListQueryVariables>(IdeaIndexListDocument, options);
        }
export function useIdeaIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaIndexListQuery, IdeaIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaIndexListQuery, IdeaIndexListQueryVariables>(IdeaIndexListDocument, options);
        }
export type IdeaIndexListQueryHookResult = ReturnType<typeof useIdeaIndexListQuery>;
export type IdeaIndexListLazyQueryHookResult = ReturnType<typeof useIdeaIndexListLazyQuery>;
export type IdeaIndexListSuspenseQueryHookResult = ReturnType<typeof useIdeaIndexListSuspenseQuery>;
export type IdeaIndexListQueryResult = Apollo.QueryResult<IdeaIndexListQuery, IdeaIndexListQueryVariables>;
export const IdeaIndexSavedSearchDocument = gql`
    query IdeaIndexSavedSearch {
  ideasSavedSearchList {
    edges {
      node {
        ...IdeaSavedSearch
      }
    }
  }
}
    ${IdeaSavedSearchFragmentDoc}`;

/**
 * __useIdeaIndexSavedSearchQuery__
 *
 * To run a query within a React component, call `useIdeaIndexSavedSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaIndexSavedSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaIndexSavedSearchQuery({
 *   variables: {
 *   },
 * });
 */
export function useIdeaIndexSavedSearchQuery(baseOptions?: Apollo.QueryHookOptions<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>(IdeaIndexSavedSearchDocument, options);
      }
export function useIdeaIndexSavedSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>(IdeaIndexSavedSearchDocument, options);
        }
export function useIdeaIndexSavedSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>(IdeaIndexSavedSearchDocument, options);
        }
export type IdeaIndexSavedSearchQueryHookResult = ReturnType<typeof useIdeaIndexSavedSearchQuery>;
export type IdeaIndexSavedSearchLazyQueryHookResult = ReturnType<typeof useIdeaIndexSavedSearchLazyQuery>;
export type IdeaIndexSavedSearchSuspenseQueryHookResult = ReturnType<typeof useIdeaIndexSavedSearchSuspenseQuery>;
export type IdeaIndexSavedSearchQueryResult = Apollo.QueryResult<IdeaIndexSavedSearchQuery, IdeaIndexSavedSearchQueryVariables>;
export const IdeaSubmissionDocument = gql`
    query IdeaSubmission($id: ID!) {
  currentContests {
    id
    name
  }
  currentUser {
    id
    currentEmployers {
      id
      canExtendCapIntroAccess
      hasFundProfile
      name
    }
    isAdmin
  }
  idea(id: $id) {
    ...IdeaSubmissionDraft
  }
  termsOfUse
}
    ${IdeaSubmissionDraftFragmentDoc}`;

/**
 * __useIdeaSubmissionQuery__
 *
 * To run a query within a React component, call `useIdeaSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdeaSubmissionQuery(baseOptions: Apollo.QueryHookOptions<IdeaSubmissionQuery, IdeaSubmissionQueryVariables> & ({ variables: IdeaSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaSubmissionQuery, IdeaSubmissionQueryVariables>(IdeaSubmissionDocument, options);
      }
export function useIdeaSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaSubmissionQuery, IdeaSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaSubmissionQuery, IdeaSubmissionQueryVariables>(IdeaSubmissionDocument, options);
        }
export function useIdeaSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaSubmissionQuery, IdeaSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaSubmissionQuery, IdeaSubmissionQueryVariables>(IdeaSubmissionDocument, options);
        }
export type IdeaSubmissionQueryHookResult = ReturnType<typeof useIdeaSubmissionQuery>;
export type IdeaSubmissionLazyQueryHookResult = ReturnType<typeof useIdeaSubmissionLazyQuery>;
export type IdeaSubmissionSuspenseQueryHookResult = ReturnType<typeof useIdeaSubmissionSuspenseQuery>;
export type IdeaSubmissionQueryResult = Apollo.QueryResult<IdeaSubmissionQuery, IdeaSubmissionQueryVariables>;
export const IdeaSubmissionAssetDocument = gql`
    query IdeaSubmissionAsset($assetId: ID!) {
  asset(id: $assetId) {
    ...IdeaSubmissionAsset
  }
}
    ${IdeaSubmissionAssetFragmentDoc}`;

/**
 * __useIdeaSubmissionAssetQuery__
 *
 * To run a query within a React component, call `useIdeaSubmissionAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaSubmissionAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaSubmissionAssetQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useIdeaSubmissionAssetQuery(baseOptions: Apollo.QueryHookOptions<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables> & ({ variables: IdeaSubmissionAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables>(IdeaSubmissionAssetDocument, options);
      }
export function useIdeaSubmissionAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables>(IdeaSubmissionAssetDocument, options);
        }
export function useIdeaSubmissionAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables>(IdeaSubmissionAssetDocument, options);
        }
export type IdeaSubmissionAssetQueryHookResult = ReturnType<typeof useIdeaSubmissionAssetQuery>;
export type IdeaSubmissionAssetLazyQueryHookResult = ReturnType<typeof useIdeaSubmissionAssetLazyQuery>;
export type IdeaSubmissionAssetSuspenseQueryHookResult = ReturnType<typeof useIdeaSubmissionAssetSuspenseQuery>;
export type IdeaSubmissionAssetQueryResult = Apollo.QueryResult<IdeaSubmissionAssetQuery, IdeaSubmissionAssetQueryVariables>;
export const IdeaSubmissionAssetLookupDocument = gql`
    query IdeaSubmissionAssetLookup($fsymId: ID!) {
  ideaSubmissionAssetLookup(fsymId: $fsymId) {
    id
  }
}
    `;

/**
 * __useIdeaSubmissionAssetLookupQuery__
 *
 * To run a query within a React component, call `useIdeaSubmissionAssetLookupQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaSubmissionAssetLookupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaSubmissionAssetLookupQuery({
 *   variables: {
 *      fsymId: // value for 'fsymId'
 *   },
 * });
 */
export function useIdeaSubmissionAssetLookupQuery(baseOptions: Apollo.QueryHookOptions<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables> & ({ variables: IdeaSubmissionAssetLookupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables>(IdeaSubmissionAssetLookupDocument, options);
      }
export function useIdeaSubmissionAssetLookupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables>(IdeaSubmissionAssetLookupDocument, options);
        }
export function useIdeaSubmissionAssetLookupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables>(IdeaSubmissionAssetLookupDocument, options);
        }
export type IdeaSubmissionAssetLookupQueryHookResult = ReturnType<typeof useIdeaSubmissionAssetLookupQuery>;
export type IdeaSubmissionAssetLookupLazyQueryHookResult = ReturnType<typeof useIdeaSubmissionAssetLookupLazyQuery>;
export type IdeaSubmissionAssetLookupSuspenseQueryHookResult = ReturnType<typeof useIdeaSubmissionAssetLookupSuspenseQuery>;
export type IdeaSubmissionAssetLookupQueryResult = Apollo.QueryResult<IdeaSubmissionAssetLookupQuery, IdeaSubmissionAssetLookupQueryVariables>;
export const IdeaSubmissionAttachmentsDocument = gql`
    query IdeaSubmissionAttachments($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    ideaAttachments {
      ...IdeaAttachments
    }
  }
}
    ${IdeaAttachmentsFragmentDoc}`;

/**
 * __useIdeaSubmissionAttachmentsQuery__
 *
 * To run a query within a React component, call `useIdeaSubmissionAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaSubmissionAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaSubmissionAttachmentsQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaSubmissionAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables> & ({ variables: IdeaSubmissionAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables>(IdeaSubmissionAttachmentsDocument, options);
      }
export function useIdeaSubmissionAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables>(IdeaSubmissionAttachmentsDocument, options);
        }
export function useIdeaSubmissionAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables>(IdeaSubmissionAttachmentsDocument, options);
        }
export type IdeaSubmissionAttachmentsQueryHookResult = ReturnType<typeof useIdeaSubmissionAttachmentsQuery>;
export type IdeaSubmissionAttachmentsLazyQueryHookResult = ReturnType<typeof useIdeaSubmissionAttachmentsLazyQuery>;
export type IdeaSubmissionAttachmentsSuspenseQueryHookResult = ReturnType<typeof useIdeaSubmissionAttachmentsSuspenseQuery>;
export type IdeaSubmissionAttachmentsQueryResult = Apollo.QueryResult<IdeaSubmissionAttachmentsQuery, IdeaSubmissionAttachmentsQueryVariables>;
export const IdeaUpdateCommentsDocument = gql`
    query IdeaUpdateComments($cursor: String, $id: ID!, $controlName: Boolean) {
  ideaUpdate(id: $id) {
    id
    comments(first: 20, after: $cursor) {
      edges {
        node {
          ...IdeaShowPageComment
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    commentMentionables {
      id
      display
    }
  }
  currentUser {
    id
    canCommentAnonymously
    isAllocator
    isRetail
    profileImageUrl
  }
}
    ${IdeaShowPageCommentFragmentDoc}`;

/**
 * __useIdeaUpdateCommentsQuery__
 *
 * To run a query within a React component, call `useIdeaUpdateCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaUpdateCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaUpdateCommentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      id: // value for 'id'
 *      controlName: // value for 'controlName'
 *   },
 * });
 */
export function useIdeaUpdateCommentsQuery(baseOptions: Apollo.QueryHookOptions<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables> & ({ variables: IdeaUpdateCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables>(IdeaUpdateCommentsDocument, options);
      }
export function useIdeaUpdateCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables>(IdeaUpdateCommentsDocument, options);
        }
export function useIdeaUpdateCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables>(IdeaUpdateCommentsDocument, options);
        }
export type IdeaUpdateCommentsQueryHookResult = ReturnType<typeof useIdeaUpdateCommentsQuery>;
export type IdeaUpdateCommentsLazyQueryHookResult = ReturnType<typeof useIdeaUpdateCommentsLazyQuery>;
export type IdeaUpdateCommentsSuspenseQueryHookResult = ReturnType<typeof useIdeaUpdateCommentsSuspenseQuery>;
export type IdeaUpdateCommentsQueryResult = Apollo.QueryResult<IdeaUpdateCommentsQuery, IdeaUpdateCommentsQueryVariables>;
export const IdeaViewsDocument = gql`
    query IdeaViews($id: ID!, $cursor: String) {
  idea(id: $id) {
    id
    anonymous
    openedAt
    lastUpdatedAt
    totalReturn
    closedAt
    expectedPerformanceRating {
      id
      averageRating
      userRatingCount
    }
    newViewsCount
    positions {
      id
      asset {
        id
        primarySymbol
        assetClassName
        entity {
          id
          name
        }
      }
    }
    isCurrentUserAuthor
    ideaViews(first: 10, after: $cursor) {
      edges {
        node {
          ...IdeaView
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${IdeaViewFragmentDoc}`;

/**
 * __useIdeaViewsQuery__
 *
 * To run a query within a React component, call `useIdeaViewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaViewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaViewsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useIdeaViewsQuery(baseOptions: Apollo.QueryHookOptions<IdeaViewsQuery, IdeaViewsQueryVariables> & ({ variables: IdeaViewsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaViewsQuery, IdeaViewsQueryVariables>(IdeaViewsDocument, options);
      }
export function useIdeaViewsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaViewsQuery, IdeaViewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaViewsQuery, IdeaViewsQueryVariables>(IdeaViewsDocument, options);
        }
export function useIdeaViewsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaViewsQuery, IdeaViewsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaViewsQuery, IdeaViewsQueryVariables>(IdeaViewsDocument, options);
        }
export type IdeaViewsQueryHookResult = ReturnType<typeof useIdeaViewsQuery>;
export type IdeaViewsLazyQueryHookResult = ReturnType<typeof useIdeaViewsLazyQuery>;
export type IdeaViewsSuspenseQueryHookResult = ReturnType<typeof useIdeaViewsSuspenseQuery>;
export type IdeaViewsQueryResult = Apollo.QueryResult<IdeaViewsQuery, IdeaViewsQueryVariables>;
export const InsiderTradesDocument = gql`
    query InsiderTrades($query: String, $watchlistedTickers: Boolean, $page: Int!) {
  insiderTrades(
    query: $query
    watchlistedTickers: $watchlistedTickers
    page: $page
  ) {
    trades {
      ...InsiderTrade
    }
    maxPage
    resultCount
  }
}
    ${InsiderTradeFragmentDoc}`;

/**
 * __useInsiderTradesQuery__
 *
 * To run a query within a React component, call `useInsiderTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsiderTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsiderTradesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      watchlistedTickers: // value for 'watchlistedTickers'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useInsiderTradesQuery(baseOptions: Apollo.QueryHookOptions<InsiderTradesQuery, InsiderTradesQueryVariables> & ({ variables: InsiderTradesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsiderTradesQuery, InsiderTradesQueryVariables>(InsiderTradesDocument, options);
      }
export function useInsiderTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsiderTradesQuery, InsiderTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsiderTradesQuery, InsiderTradesQueryVariables>(InsiderTradesDocument, options);
        }
export function useInsiderTradesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InsiderTradesQuery, InsiderTradesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InsiderTradesQuery, InsiderTradesQueryVariables>(InsiderTradesDocument, options);
        }
export type InsiderTradesQueryHookResult = ReturnType<typeof useInsiderTradesQuery>;
export type InsiderTradesLazyQueryHookResult = ReturnType<typeof useInsiderTradesLazyQuery>;
export type InsiderTradesSuspenseQueryHookResult = ReturnType<typeof useInsiderTradesSuspenseQuery>;
export type InsiderTradesQueryResult = Apollo.QueryResult<InsiderTradesQuery, InsiderTradesQueryVariables>;
export const JobApplicationCurrentUserDocument = gql`
    query JobApplicationCurrentUser($jobPostId: ID!) {
  currentUser {
    id
    displayName
    email
    profile {
      id
      mobilePhone
      workPhone
      resume
    }
  }
  jobPost(jobPostId: $jobPostId) {
    id
    coverLetter
  }
}
    `;

/**
 * __useJobApplicationCurrentUserQuery__
 *
 * To run a query within a React component, call `useJobApplicationCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobApplicationCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobApplicationCurrentUserQuery({
 *   variables: {
 *      jobPostId: // value for 'jobPostId'
 *   },
 * });
 */
export function useJobApplicationCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables> & ({ variables: JobApplicationCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables>(JobApplicationCurrentUserDocument, options);
      }
export function useJobApplicationCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables>(JobApplicationCurrentUserDocument, options);
        }
export function useJobApplicationCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables>(JobApplicationCurrentUserDocument, options);
        }
export type JobApplicationCurrentUserQueryHookResult = ReturnType<typeof useJobApplicationCurrentUserQuery>;
export type JobApplicationCurrentUserLazyQueryHookResult = ReturnType<typeof useJobApplicationCurrentUserLazyQuery>;
export type JobApplicationCurrentUserSuspenseQueryHookResult = ReturnType<typeof useJobApplicationCurrentUserSuspenseQuery>;
export type JobApplicationCurrentUserQueryResult = Apollo.QueryResult<JobApplicationCurrentUserQuery, JobApplicationCurrentUserQueryVariables>;
export const JobApplicationIndexListDocument = gql`
    query JobApplicationIndexList($searchParams: String) {
  jobApplicationsIndexList(searchParams: $searchParams) {
    id
    coverNote
    createdAt
    email
    name
    phone
    resumeUrl
    starred
    status
    status
    user {
      id
      displayName
      mostRecentEmployer {
        id
        title
        currentEmployer
        employer {
          id
          name
        }
      }
      profile {
        id
        imageProfileUrl
        city
        summary
      }
      publishedIdeasCount
      userBadges: badgeCollectionRelationships {
        edges {
          node {
            id
            badgeNumber
            visible
            badge {
              ...Badges
            }
          }
        }
      }
    }
  }
  indexListResultCount(
    searchParams: $searchParams
    indexType: "JobApplicationSearch"
  )
}
    ${BadgesFragmentDoc}`;

/**
 * __useJobApplicationIndexListQuery__
 *
 * To run a query within a React component, call `useJobApplicationIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobApplicationIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobApplicationIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function useJobApplicationIndexListQuery(baseOptions?: Apollo.QueryHookOptions<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>(JobApplicationIndexListDocument, options);
      }
export function useJobApplicationIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>(JobApplicationIndexListDocument, options);
        }
export function useJobApplicationIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>(JobApplicationIndexListDocument, options);
        }
export type JobApplicationIndexListQueryHookResult = ReturnType<typeof useJobApplicationIndexListQuery>;
export type JobApplicationIndexListLazyQueryHookResult = ReturnType<typeof useJobApplicationIndexListLazyQuery>;
export type JobApplicationIndexListSuspenseQueryHookResult = ReturnType<typeof useJobApplicationIndexListSuspenseQuery>;
export type JobApplicationIndexListQueryResult = Apollo.QueryResult<JobApplicationIndexListQuery, JobApplicationIndexListQueryVariables>;
export const JobPostingAndApplicationDocument = gql`
    query JobPostingAndApplication($jobApplicationId: ID!) {
  jobApplication(jobApplicationId: $jobApplicationId) {
    id
    coverNote
    name
    phone
    email
    userId
    starred
    status
    resumeUrl
    otherApplications {
      id
      name
    }
    jobPosting {
      id
      title
      applicationCount
    }
  }
}
    `;

/**
 * __useJobPostingAndApplicationQuery__
 *
 * To run a query within a React component, call `useJobPostingAndApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPostingAndApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPostingAndApplicationQuery({
 *   variables: {
 *      jobApplicationId: // value for 'jobApplicationId'
 *   },
 * });
 */
export function useJobPostingAndApplicationQuery(baseOptions: Apollo.QueryHookOptions<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables> & ({ variables: JobPostingAndApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>(JobPostingAndApplicationDocument, options);
      }
export function useJobPostingAndApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>(JobPostingAndApplicationDocument, options);
        }
export function useJobPostingAndApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>(JobPostingAndApplicationDocument, options);
        }
export type JobPostingAndApplicationQueryHookResult = ReturnType<typeof useJobPostingAndApplicationQuery>;
export type JobPostingAndApplicationLazyQueryHookResult = ReturnType<typeof useJobPostingAndApplicationLazyQuery>;
export type JobPostingAndApplicationSuspenseQueryHookResult = ReturnType<typeof useJobPostingAndApplicationSuspenseQuery>;
export type JobPostingAndApplicationQueryResult = Apollo.QueryResult<JobPostingAndApplicationQuery, JobPostingAndApplicationQueryVariables>;
export const JobPostingApplicationsDocument = gql`
    query JobPostingApplications($jobPostingId: ID!) {
  jobPost(jobPostId: $jobPostingId) {
    id
    applications {
      id
      createdAt
      name
      resumeUrl
      starred
      status
      user {
        id
        publishedIdeasCount
      }
    }
  }
}
    `;

/**
 * __useJobPostingApplicationsQuery__
 *
 * To run a query within a React component, call `useJobPostingApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPostingApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPostingApplicationsQuery({
 *   variables: {
 *      jobPostingId: // value for 'jobPostingId'
 *   },
 * });
 */
export function useJobPostingApplicationsQuery(baseOptions: Apollo.QueryHookOptions<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables> & ({ variables: JobPostingApplicationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables>(JobPostingApplicationsDocument, options);
      }
export function useJobPostingApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables>(JobPostingApplicationsDocument, options);
        }
export function useJobPostingApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables>(JobPostingApplicationsDocument, options);
        }
export type JobPostingApplicationsQueryHookResult = ReturnType<typeof useJobPostingApplicationsQuery>;
export type JobPostingApplicationsLazyQueryHookResult = ReturnType<typeof useJobPostingApplicationsLazyQuery>;
export type JobPostingApplicationsSuspenseQueryHookResult = ReturnType<typeof useJobPostingApplicationsSuspenseQuery>;
export type JobPostingApplicationsQueryResult = Apollo.QueryResult<JobPostingApplicationsQuery, JobPostingApplicationsQueryVariables>;
export const JobPostingIndexListDocument = gql`
    query JobPostingIndexList($searchParams: String, $indexType: String!) {
  jobPostingIndexList(searchParams: $searchParams) {
    edges {
      node {
        id
        title
        description
        city
        postedAt(isTimeAgo: true)
        sectors
        employer {
          aumRange
          strategy
          fundType
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  jobPostingIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: $indexType
  )
  currentUser {
    id
    canPostJobs
    missingJobPostReqDescription
    isAdmin
    hasJobApplications
    hasJobPostings
    displayName
    profileImageUrl
    jobPostingIds
    jobPostsAppliedIds
  }
}
    `;

/**
 * __useJobPostingIndexListQuery__
 *
 * To run a query within a React component, call `useJobPostingIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobPostingIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobPostingIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useJobPostingIndexListQuery(baseOptions: Apollo.QueryHookOptions<JobPostingIndexListQuery, JobPostingIndexListQueryVariables> & ({ variables: JobPostingIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobPostingIndexListQuery, JobPostingIndexListQueryVariables>(JobPostingIndexListDocument, options);
      }
export function useJobPostingIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobPostingIndexListQuery, JobPostingIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobPostingIndexListQuery, JobPostingIndexListQueryVariables>(JobPostingIndexListDocument, options);
        }
export function useJobPostingIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobPostingIndexListQuery, JobPostingIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobPostingIndexListQuery, JobPostingIndexListQueryVariables>(JobPostingIndexListDocument, options);
        }
export type JobPostingIndexListQueryHookResult = ReturnType<typeof useJobPostingIndexListQuery>;
export type JobPostingIndexListLazyQueryHookResult = ReturnType<typeof useJobPostingIndexListLazyQuery>;
export type JobPostingIndexListSuspenseQueryHookResult = ReturnType<typeof useJobPostingIndexListSuspenseQuery>;
export type JobPostingIndexListQueryResult = Apollo.QueryResult<JobPostingIndexListQuery, JobPostingIndexListQueryVariables>;
export const JobVaultShowDocument = gql`
    query JobVaultShow($jobPostId: ID!) {
  jobPost(jobPostId: $jobPostId) {
    id
    assets
    actScore
    userId
    city
    degreesAndCertifications
    description
    disqualifiedReasons
    firmExperience
    regions
    minimumGpa
    maximumGpa
    minimumSat
    maximumSat
    postedAt
    sectors
    status
    title
    useCompanyInvestmentMandate
    yearsOfExperience
    employer {
      ...JobVaultEmployer
    }
  }
}
    ${JobVaultEmployerFragmentDoc}`;

/**
 * __useJobVaultShowQuery__
 *
 * To run a query within a React component, call `useJobVaultShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobVaultShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobVaultShowQuery({
 *   variables: {
 *      jobPostId: // value for 'jobPostId'
 *   },
 * });
 */
export function useJobVaultShowQuery(baseOptions: Apollo.QueryHookOptions<JobVaultShowQuery, JobVaultShowQueryVariables> & ({ variables: JobVaultShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobVaultShowQuery, JobVaultShowQueryVariables>(JobVaultShowDocument, options);
      }
export function useJobVaultShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobVaultShowQuery, JobVaultShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobVaultShowQuery, JobVaultShowQueryVariables>(JobVaultShowDocument, options);
        }
export function useJobVaultShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobVaultShowQuery, JobVaultShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobVaultShowQuery, JobVaultShowQueryVariables>(JobVaultShowDocument, options);
        }
export type JobVaultShowQueryHookResult = ReturnType<typeof useJobVaultShowQuery>;
export type JobVaultShowLazyQueryHookResult = ReturnType<typeof useJobVaultShowLazyQuery>;
export type JobVaultShowSuspenseQueryHookResult = ReturnType<typeof useJobVaultShowSuspenseQuery>;
export type JobVaultShowQueryResult = Apollo.QueryResult<JobVaultShowQuery, JobVaultShowQueryVariables>;
export const JobVaultShowCurrentUserDocument = gql`
    query JobVaultShowCurrentUser {
  currentUser {
    id
    isAdmin
    isAllocator
    isHighProfile
    canApplyToJobs
    canCreateIdea: canAccess(resource: "ideas", permission: "write")
    displayName
    hasActiveContract
    hasJobAccess
    jobPostsAppliedIds
    profile {
      id
    }
  }
}
    `;

/**
 * __useJobVaultShowCurrentUserQuery__
 *
 * To run a query within a React component, call `useJobVaultShowCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobVaultShowCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobVaultShowCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobVaultShowCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>(JobVaultShowCurrentUserDocument, options);
      }
export function useJobVaultShowCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>(JobVaultShowCurrentUserDocument, options);
        }
export function useJobVaultShowCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>(JobVaultShowCurrentUserDocument, options);
        }
export type JobVaultShowCurrentUserQueryHookResult = ReturnType<typeof useJobVaultShowCurrentUserQuery>;
export type JobVaultShowCurrentUserLazyQueryHookResult = ReturnType<typeof useJobVaultShowCurrentUserLazyQuery>;
export type JobVaultShowCurrentUserSuspenseQueryHookResult = ReturnType<typeof useJobVaultShowCurrentUserSuspenseQuery>;
export type JobVaultShowCurrentUserQueryResult = Apollo.QueryResult<JobVaultShowCurrentUserQuery, JobVaultShowCurrentUserQueryVariables>;
export const JobVaultSubmissionCurrentUserDocument = gql`
    query JobVaultSubmissionCurrentUser {
  currentUser {
    id
    mostRecentEmployer {
      id
      employer {
        id
        city
        aum
        aumRangePresent
        ...JobVaultEmployer
      }
    }
  }
}
    ${JobVaultEmployerFragmentDoc}`;

/**
 * __useJobVaultSubmissionCurrentUserQuery__
 *
 * To run a query within a React component, call `useJobVaultSubmissionCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobVaultSubmissionCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobVaultSubmissionCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useJobVaultSubmissionCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>(JobVaultSubmissionCurrentUserDocument, options);
      }
export function useJobVaultSubmissionCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>(JobVaultSubmissionCurrentUserDocument, options);
        }
export function useJobVaultSubmissionCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>(JobVaultSubmissionCurrentUserDocument, options);
        }
export type JobVaultSubmissionCurrentUserQueryHookResult = ReturnType<typeof useJobVaultSubmissionCurrentUserQuery>;
export type JobVaultSubmissionCurrentUserLazyQueryHookResult = ReturnType<typeof useJobVaultSubmissionCurrentUserLazyQuery>;
export type JobVaultSubmissionCurrentUserSuspenseQueryHookResult = ReturnType<typeof useJobVaultSubmissionCurrentUserSuspenseQuery>;
export type JobVaultSubmissionCurrentUserQueryResult = Apollo.QueryResult<JobVaultSubmissionCurrentUserQuery, JobVaultSubmissionCurrentUserQueryVariables>;
export const JoinCapIntroCurrentUserDocument = gql`
    query JoinCapIntroCurrentUser {
  currentUser {
    id
    currentEmployers {
      id
      canExtendCapIntroAccess
      name
      employerProfile {
        id
        status
      }
    }
    profile {
      id
    }
  }
}
    `;

/**
 * __useJoinCapIntroCurrentUserQuery__
 *
 * To run a query within a React component, call `useJoinCapIntroCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useJoinCapIntroCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJoinCapIntroCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useJoinCapIntroCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>(JoinCapIntroCurrentUserDocument, options);
      }
export function useJoinCapIntroCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>(JoinCapIntroCurrentUserDocument, options);
        }
export function useJoinCapIntroCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>(JoinCapIntroCurrentUserDocument, options);
        }
export type JoinCapIntroCurrentUserQueryHookResult = ReturnType<typeof useJoinCapIntroCurrentUserQuery>;
export type JoinCapIntroCurrentUserLazyQueryHookResult = ReturnType<typeof useJoinCapIntroCurrentUserLazyQuery>;
export type JoinCapIntroCurrentUserSuspenseQueryHookResult = ReturnType<typeof useJoinCapIntroCurrentUserSuspenseQuery>;
export type JoinCapIntroCurrentUserQueryResult = Apollo.QueryResult<JoinCapIntroCurrentUserQuery, JoinCapIntroCurrentUserQueryVariables>;
export const LargestInsiderTradesDocument = gql`
    query LargestInsiderTrades($timeframe: String!) {
  largestInsiderTrades(timeframe: $timeframe) {
    ...InsiderTrade
  }
}
    ${InsiderTradeFragmentDoc}`;

/**
 * __useLargestInsiderTradesQuery__
 *
 * To run a query within a React component, call `useLargestInsiderTradesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLargestInsiderTradesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLargestInsiderTradesQuery({
 *   variables: {
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useLargestInsiderTradesQuery(baseOptions: Apollo.QueryHookOptions<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables> & ({ variables: LargestInsiderTradesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables>(LargestInsiderTradesDocument, options);
      }
export function useLargestInsiderTradesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables>(LargestInsiderTradesDocument, options);
        }
export function useLargestInsiderTradesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables>(LargestInsiderTradesDocument, options);
        }
export type LargestInsiderTradesQueryHookResult = ReturnType<typeof useLargestInsiderTradesQuery>;
export type LargestInsiderTradesLazyQueryHookResult = ReturnType<typeof useLargestInsiderTradesLazyQuery>;
export type LargestInsiderTradesSuspenseQueryHookResult = ReturnType<typeof useLargestInsiderTradesSuspenseQuery>;
export type LargestInsiderTradesQueryResult = Apollo.QueryResult<LargestInsiderTradesQuery, LargestInsiderTradesQueryVariables>;
export const LastNIdeaViewsCurrentUserDocument = gql`
    query LastNIdeaViewsCurrentUser($n: Int!) {
  currentUser {
    id
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    ideaIsBlocked: isBlocked(feature: "research")
    publishedIdeasCount(isPublic: false)
    lastNViews(n: $n) {
      edges {
        node {
          ...IdeaView
        }
      }
    }
    publishedIdeas {
      edges {
        node {
          id
          positions {
            id
            asset {
              id
              primarySymbol
            }
          }
          createdAt
          newViewsCount
        }
      }
    }
  }
}
    ${IdeaViewFragmentDoc}`;

/**
 * __useLastNIdeaViewsCurrentUserQuery__
 *
 * To run a query within a React component, call `useLastNIdeaViewsCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastNIdeaViewsCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastNIdeaViewsCurrentUserQuery({
 *   variables: {
 *      n: // value for 'n'
 *   },
 * });
 */
export function useLastNIdeaViewsCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables> & ({ variables: LastNIdeaViewsCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables>(LastNIdeaViewsCurrentUserDocument, options);
      }
export function useLastNIdeaViewsCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables>(LastNIdeaViewsCurrentUserDocument, options);
        }
export function useLastNIdeaViewsCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables>(LastNIdeaViewsCurrentUserDocument, options);
        }
export type LastNIdeaViewsCurrentUserQueryHookResult = ReturnType<typeof useLastNIdeaViewsCurrentUserQuery>;
export type LastNIdeaViewsCurrentUserLazyQueryHookResult = ReturnType<typeof useLastNIdeaViewsCurrentUserLazyQuery>;
export type LastNIdeaViewsCurrentUserSuspenseQueryHookResult = ReturnType<typeof useLastNIdeaViewsCurrentUserSuspenseQuery>;
export type LastNIdeaViewsCurrentUserQueryResult = Apollo.QueryResult<LastNIdeaViewsCurrentUserQuery, LastNIdeaViewsCurrentUserQueryVariables>;
export const MainNavigationCurrentUserDocument = gql`
    query MainNavigationCurrentUser {
  currentUser {
    id
    allocatorProfile {
      id
    }
    canEditProfile
    canAccessCompensations: canAccess(
      resource: "compensations"
      permission: "access"
    )
    canAccessJobPostings: canAccess(resource: "job_postings", permission: "access")
    canAccessMessages: canAccess(permission: "access", resource: "messages")
    canManageMessages: canAccess(permission: "manage", resource: "messages")
    canAccessUserDetails: canAccess(resource: "user_details", permission: "access")
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
    currentEmployers {
      id
      name
    }
    displayName
    ...FollowIds
    hasActiveSubscription
    hasCompletedAccreditedInvestorProfile
    hasIdeas
    hasJobApplications
    hasJobPostings
    isAdmin
    isAllocator
    isBuyside
    isFundProfileAdmin
    isRetail
    isTopDown
    isTokenBased
    profile {
      id
      isAccredited
    }
    profileImageUrl
    readingListItems {
      edges {
        node {
          ...ReadingListItem
        }
      }
    }
    unaddressedApplicationsCount
    unseenMessageCount
  }
}
    ${FollowIdsFragmentDoc}
${ReadingListItemFragmentDoc}`;

/**
 * __useMainNavigationCurrentUserQuery__
 *
 * To run a query within a React component, call `useMainNavigationCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainNavigationCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainNavigationCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainNavigationCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>(MainNavigationCurrentUserDocument, options);
      }
export function useMainNavigationCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>(MainNavigationCurrentUserDocument, options);
        }
export function useMainNavigationCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>(MainNavigationCurrentUserDocument, options);
        }
export type MainNavigationCurrentUserQueryHookResult = ReturnType<typeof useMainNavigationCurrentUserQuery>;
export type MainNavigationCurrentUserLazyQueryHookResult = ReturnType<typeof useMainNavigationCurrentUserLazyQuery>;
export type MainNavigationCurrentUserSuspenseQueryHookResult = ReturnType<typeof useMainNavigationCurrentUserSuspenseQuery>;
export type MainNavigationCurrentUserQueryResult = Apollo.QueryResult<MainNavigationCurrentUserQuery, MainNavigationCurrentUserQueryVariables>;
export const MainSiteNavigationMessagesDocument = gql`
    query MainSiteNavigationMessages {
  currentUser {
    id
    incomingMessageThreads(limit: 5) {
      id
      receiverStatus
      sender {
        id
        displayName
        profileImageUrl
      }
      threadCount
      body
      createdAt
    }
    unreadMessageCount
  }
}
    `;

/**
 * __useMainSiteNavigationMessagesQuery__
 *
 * To run a query within a React component, call `useMainSiteNavigationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMainSiteNavigationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMainSiteNavigationMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMainSiteNavigationMessagesQuery(baseOptions?: Apollo.QueryHookOptions<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>(MainSiteNavigationMessagesDocument, options);
      }
export function useMainSiteNavigationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>(MainSiteNavigationMessagesDocument, options);
        }
export function useMainSiteNavigationMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>(MainSiteNavigationMessagesDocument, options);
        }
export type MainSiteNavigationMessagesQueryHookResult = ReturnType<typeof useMainSiteNavigationMessagesQuery>;
export type MainSiteNavigationMessagesLazyQueryHookResult = ReturnType<typeof useMainSiteNavigationMessagesLazyQuery>;
export type MainSiteNavigationMessagesSuspenseQueryHookResult = ReturnType<typeof useMainSiteNavigationMessagesSuspenseQuery>;
export type MainSiteNavigationMessagesQueryResult = Apollo.QueryResult<MainSiteNavigationMessagesQuery, MainSiteNavigationMessagesQueryVariables>;
export const MassTickerSearchDocument = gql`
    query MassTickerSearch($tickers: [String!]) {
  massTickerSearch(tickers: $tickers) {
    foundEntities {
      id
      name
      primarySymbol
    }
    unfoundSymbols
  }
}
    `;

/**
 * __useMassTickerSearchQuery__
 *
 * To run a query within a React component, call `useMassTickerSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMassTickerSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMassTickerSearchQuery({
 *   variables: {
 *      tickers: // value for 'tickers'
 *   },
 * });
 */
export function useMassTickerSearchQuery(baseOptions?: Apollo.QueryHookOptions<MassTickerSearchQuery, MassTickerSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MassTickerSearchQuery, MassTickerSearchQueryVariables>(MassTickerSearchDocument, options);
      }
export function useMassTickerSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MassTickerSearchQuery, MassTickerSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MassTickerSearchQuery, MassTickerSearchQueryVariables>(MassTickerSearchDocument, options);
        }
export function useMassTickerSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MassTickerSearchQuery, MassTickerSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MassTickerSearchQuery, MassTickerSearchQueryVariables>(MassTickerSearchDocument, options);
        }
export type MassTickerSearchQueryHookResult = ReturnType<typeof useMassTickerSearchQuery>;
export type MassTickerSearchLazyQueryHookResult = ReturnType<typeof useMassTickerSearchLazyQuery>;
export type MassTickerSearchSuspenseQueryHookResult = ReturnType<typeof useMassTickerSearchSuspenseQuery>;
export type MassTickerSearchQueryResult = Apollo.QueryResult<MassTickerSearchQuery, MassTickerSearchQueryVariables>;
export const MediaIndexListDocument = gql`
    query MediaIndexList($cursor: String, $searchParams: String, $indexType: String!, $type: String!) {
  mediaIndexList(
    indexType: $indexType
    searchParams: $searchParams
    first: 20
    after: $cursor
  ) {
    edges {
      node {
        ...PodcastEpisodeMediaIndex
        ...VideoMediaIndex
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  indexListResultCount(searchParams: $searchParams, indexType: $indexType)
  mostPopularMediaHashtags(type: $type)
}
    ${PodcastEpisodeMediaIndexFragmentDoc}
${VideoMediaIndexFragmentDoc}`;

/**
 * __useMediaIndexListQuery__
 *
 * To run a query within a React component, call `useMediaIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaIndexListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMediaIndexListQuery(baseOptions: Apollo.QueryHookOptions<MediaIndexListQuery, MediaIndexListQueryVariables> & ({ variables: MediaIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaIndexListQuery, MediaIndexListQueryVariables>(MediaIndexListDocument, options);
      }
export function useMediaIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaIndexListQuery, MediaIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaIndexListQuery, MediaIndexListQueryVariables>(MediaIndexListDocument, options);
        }
export function useMediaIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaIndexListQuery, MediaIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaIndexListQuery, MediaIndexListQueryVariables>(MediaIndexListDocument, options);
        }
export type MediaIndexListQueryHookResult = ReturnType<typeof useMediaIndexListQuery>;
export type MediaIndexListLazyQueryHookResult = ReturnType<typeof useMediaIndexListLazyQuery>;
export type MediaIndexListSuspenseQueryHookResult = ReturnType<typeof useMediaIndexListSuspenseQuery>;
export type MediaIndexListQueryResult = Apollo.QueryResult<MediaIndexListQuery, MediaIndexListQueryVariables>;
export const MediaShowDocument = gql`
    query MediaShow($id: ID!, $type: String!) {
  media(id: $id, type: $type) {
    ...PodcastEpisodeMedia
    ...VideoMedia
  }
}
    ${PodcastEpisodeMediaFragmentDoc}
${VideoMediaFragmentDoc}`;

/**
 * __useMediaShowQuery__
 *
 * To run a query within a React component, call `useMediaShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useMediaShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMediaShowQuery({
 *   variables: {
 *      id: // value for 'id'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useMediaShowQuery(baseOptions: Apollo.QueryHookOptions<MediaShowQuery, MediaShowQueryVariables> & ({ variables: MediaShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MediaShowQuery, MediaShowQueryVariables>(MediaShowDocument, options);
      }
export function useMediaShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MediaShowQuery, MediaShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MediaShowQuery, MediaShowQueryVariables>(MediaShowDocument, options);
        }
export function useMediaShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MediaShowQuery, MediaShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MediaShowQuery, MediaShowQueryVariables>(MediaShowDocument, options);
        }
export type MediaShowQueryHookResult = ReturnType<typeof useMediaShowQuery>;
export type MediaShowLazyQueryHookResult = ReturnType<typeof useMediaShowLazyQuery>;
export type MediaShowSuspenseQueryHookResult = ReturnType<typeof useMediaShowSuspenseQuery>;
export type MediaShowQueryResult = Apollo.QueryResult<MediaShowQuery, MediaShowQueryVariables>;
export const MentionableAssetDocument = gql`
    query MentionableAsset($query: String!) {
  assetsByBloombergSymbol(query: $query) {
    mentionDisplay
    mentionId
  }
}
    `;

/**
 * __useMentionableAssetQuery__
 *
 * To run a query within a React component, call `useMentionableAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useMentionableAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMentionableAssetQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useMentionableAssetQuery(baseOptions: Apollo.QueryHookOptions<MentionableAssetQuery, MentionableAssetQueryVariables> & ({ variables: MentionableAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MentionableAssetQuery, MentionableAssetQueryVariables>(MentionableAssetDocument, options);
      }
export function useMentionableAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MentionableAssetQuery, MentionableAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MentionableAssetQuery, MentionableAssetQueryVariables>(MentionableAssetDocument, options);
        }
export function useMentionableAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MentionableAssetQuery, MentionableAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MentionableAssetQuery, MentionableAssetQueryVariables>(MentionableAssetDocument, options);
        }
export type MentionableAssetQueryHookResult = ReturnType<typeof useMentionableAssetQuery>;
export type MentionableAssetLazyQueryHookResult = ReturnType<typeof useMentionableAssetLazyQuery>;
export type MentionableAssetSuspenseQueryHookResult = ReturnType<typeof useMentionableAssetSuspenseQuery>;
export type MentionableAssetQueryResult = Apollo.QueryResult<MentionableAssetQuery, MentionableAssetQueryVariables>;
export const MessageThreadsDocument = gql`
    query messageThreads($afterCursor: String, $pageSize: Int, $status: String) {
  latestMessagePerThread(first: $pageSize, after: $afterCursor, status: $status) {
    edges {
      node {
        ...MessageItem
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${MessageItemFragmentDoc}`;

/**
 * __useMessageThreadsQuery__
 *
 * To run a query within a React component, call `useMessageThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessageThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessageThreadsQuery({
 *   variables: {
 *      afterCursor: // value for 'afterCursor'
 *      pageSize: // value for 'pageSize'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMessageThreadsQuery(baseOptions?: Apollo.QueryHookOptions<MessageThreadsQuery, MessageThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessageThreadsQuery, MessageThreadsQueryVariables>(MessageThreadsDocument, options);
      }
export function useMessageThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessageThreadsQuery, MessageThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessageThreadsQuery, MessageThreadsQueryVariables>(MessageThreadsDocument, options);
        }
export function useMessageThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MessageThreadsQuery, MessageThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MessageThreadsQuery, MessageThreadsQueryVariables>(MessageThreadsDocument, options);
        }
export type MessageThreadsQueryHookResult = ReturnType<typeof useMessageThreadsQuery>;
export type MessageThreadsLazyQueryHookResult = ReturnType<typeof useMessageThreadsLazyQuery>;
export type MessageThreadsSuspenseQueryHookResult = ReturnType<typeof useMessageThreadsSuspenseQuery>;
export type MessageThreadsQueryResult = Apollo.QueryResult<MessageThreadsQuery, MessageThreadsQueryVariables>;
export const ThreadMessagesDocument = gql`
    query threadMessages($threadNum: Int!, $beforeCursor: String) {
  threadMessages(last: 5, before: $beforeCursor, threadNum: $threadNum) {
    edges {
      node {
        ...MessageThreadItem
      }
    }
    pageInfo {
      hasPreviousPage
      startCursor
    }
  }
  currentUser {
    id
  }
}
    ${MessageThreadItemFragmentDoc}`;

/**
 * __useThreadMessagesQuery__
 *
 * To run a query within a React component, call `useThreadMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useThreadMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useThreadMessagesQuery({
 *   variables: {
 *      threadNum: // value for 'threadNum'
 *      beforeCursor: // value for 'beforeCursor'
 *   },
 * });
 */
export function useThreadMessagesQuery(baseOptions: Apollo.QueryHookOptions<ThreadMessagesQuery, ThreadMessagesQueryVariables> & ({ variables: ThreadMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ThreadMessagesQuery, ThreadMessagesQueryVariables>(ThreadMessagesDocument, options);
      }
export function useThreadMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ThreadMessagesQuery, ThreadMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ThreadMessagesQuery, ThreadMessagesQueryVariables>(ThreadMessagesDocument, options);
        }
export function useThreadMessagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ThreadMessagesQuery, ThreadMessagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ThreadMessagesQuery, ThreadMessagesQueryVariables>(ThreadMessagesDocument, options);
        }
export type ThreadMessagesQueryHookResult = ReturnType<typeof useThreadMessagesQuery>;
export type ThreadMessagesLazyQueryHookResult = ReturnType<typeof useThreadMessagesLazyQuery>;
export type ThreadMessagesSuspenseQueryHookResult = ReturnType<typeof useThreadMessagesSuspenseQuery>;
export type ThreadMessagesQueryResult = Apollo.QueryResult<ThreadMessagesQuery, ThreadMessagesQueryVariables>;
export const NavigationUserInfoDocument = gql`
    query NavigationUserInfo {
  currentUser {
    id
    activeFollowedUsersCount
    activeFollowersCount
    featuredRank {
      id
      rankString
      category
      current
    }
    isPaladin
    paladin {
      ...PaladinQuota
    }
    primaryContact {
      id
      displayName
      email
    }
    publishedIdeasCount
    ...UserAccess
  }
}
    ${PaladinQuotaFragmentDoc}
${UserAccessFragmentDoc}`;

/**
 * __useNavigationUserInfoQuery__
 *
 * To run a query within a React component, call `useNavigationUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigationUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigationUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useNavigationUserInfoQuery(baseOptions?: Apollo.QueryHookOptions<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>(NavigationUserInfoDocument, options);
      }
export function useNavigationUserInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>(NavigationUserInfoDocument, options);
        }
export function useNavigationUserInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>(NavigationUserInfoDocument, options);
        }
export type NavigationUserInfoQueryHookResult = ReturnType<typeof useNavigationUserInfoQuery>;
export type NavigationUserInfoLazyQueryHookResult = ReturnType<typeof useNavigationUserInfoLazyQuery>;
export type NavigationUserInfoSuspenseQueryHookResult = ReturnType<typeof useNavigationUserInfoSuspenseQuery>;
export type NavigationUserInfoQueryResult = Apollo.QueryResult<NavigationUserInfoQuery, NavigationUserInfoQueryVariables>;
export const OmnisearchDocument = gql`
    query Omnisearch($query: String) {
  omnisearch(query: $query) {
    allocators {
      id
      name
    }
    anonUsers {
      id
      username
    }
    employers {
      id
      name
    }
    entities {
      id
      name
      primarySymbol
    }
    funds {
      id
      name
    }
    ideas {
      id
      assetSymbol
      direction
      elevatorPitch
      entityName
      phraseCount
    }
    podcastEpisodes {
      id
      name
      vanityLink
    }
    users {
      id
      displayName
      profile {
        id
        companyString
      }
    }
    videos {
      id
      title
      vanityLink
    }
  }
}
    `;

/**
 * __useOmnisearchQuery__
 *
 * To run a query within a React component, call `useOmnisearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useOmnisearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOmnisearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useOmnisearchQuery(baseOptions?: Apollo.QueryHookOptions<OmnisearchQuery, OmnisearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OmnisearchQuery, OmnisearchQueryVariables>(OmnisearchDocument, options);
      }
export function useOmnisearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OmnisearchQuery, OmnisearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OmnisearchQuery, OmnisearchQueryVariables>(OmnisearchDocument, options);
        }
export function useOmnisearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OmnisearchQuery, OmnisearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OmnisearchQuery, OmnisearchQueryVariables>(OmnisearchDocument, options);
        }
export type OmnisearchQueryHookResult = ReturnType<typeof useOmnisearchQuery>;
export type OmnisearchLazyQueryHookResult = ReturnType<typeof useOmnisearchLazyQuery>;
export type OmnisearchSuspenseQueryHookResult = ReturnType<typeof useOmnisearchSuspenseQuery>;
export type OmnisearchQueryResult = Apollo.QueryResult<OmnisearchQuery, OmnisearchQueryVariables>;
export const OnboardingFundRecommendationsDocument = gql`
    query OnboardingFundRecommendations($offset: Int!) {
  currentUser {
    id
    onboardingFundRecommendations(offset: $offset) {
      id
      aumRange
      focus
      foundingYear
      fundType
      lastReturn {
        ltm
        sinceInception
        ytd
      }
      logoProfileUrl
      name
      strategy
    }
    onboardingFundRecommendationMaxOffset
  }
}
    `;

/**
 * __useOnboardingFundRecommendationsQuery__
 *
 * To run a query within a React component, call `useOnboardingFundRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnboardingFundRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnboardingFundRecommendationsQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useOnboardingFundRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables> & ({ variables: OnboardingFundRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables>(OnboardingFundRecommendationsDocument, options);
      }
export function useOnboardingFundRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables>(OnboardingFundRecommendationsDocument, options);
        }
export function useOnboardingFundRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables>(OnboardingFundRecommendationsDocument, options);
        }
export type OnboardingFundRecommendationsQueryHookResult = ReturnType<typeof useOnboardingFundRecommendationsQuery>;
export type OnboardingFundRecommendationsLazyQueryHookResult = ReturnType<typeof useOnboardingFundRecommendationsLazyQuery>;
export type OnboardingFundRecommendationsSuspenseQueryHookResult = ReturnType<typeof useOnboardingFundRecommendationsSuspenseQuery>;
export type OnboardingFundRecommendationsQueryResult = Apollo.QueryResult<OnboardingFundRecommendationsQuery, OnboardingFundRecommendationsQueryVariables>;
export const OpenGraphDataDocument = gql`
    query OpenGraphData($ogUrl: String) {
  openGraphData(ogUrl: $ogUrl) {
    ogUrl
    ogTitle
    ogPreviewImageUrl
    ogDescription
    domain
  }
}
    `;

/**
 * __useOpenGraphDataQuery__
 *
 * To run a query within a React component, call `useOpenGraphDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOpenGraphDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOpenGraphDataQuery({
 *   variables: {
 *      ogUrl: // value for 'ogUrl'
 *   },
 * });
 */
export function useOpenGraphDataQuery(baseOptions?: Apollo.QueryHookOptions<OpenGraphDataQuery, OpenGraphDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OpenGraphDataQuery, OpenGraphDataQueryVariables>(OpenGraphDataDocument, options);
      }
export function useOpenGraphDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OpenGraphDataQuery, OpenGraphDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OpenGraphDataQuery, OpenGraphDataQueryVariables>(OpenGraphDataDocument, options);
        }
export function useOpenGraphDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OpenGraphDataQuery, OpenGraphDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OpenGraphDataQuery, OpenGraphDataQueryVariables>(OpenGraphDataDocument, options);
        }
export type OpenGraphDataQueryHookResult = ReturnType<typeof useOpenGraphDataQuery>;
export type OpenGraphDataLazyQueryHookResult = ReturnType<typeof useOpenGraphDataLazyQuery>;
export type OpenGraphDataSuspenseQueryHookResult = ReturnType<typeof useOpenGraphDataSuspenseQuery>;
export type OpenGraphDataQueryResult = Apollo.QueryResult<OpenGraphDataQuery, OpenGraphDataQueryVariables>;
export const PaymentMethodDocument = gql`
    query PaymentMethod {
  currentUser {
    id
    cardDetails {
      expiryYear
      expiryMonth
      lastFour
      brand
    }
    stripeCustomerId
    subscriptions {
      status
    }
  }
}
    `;

/**
 * __usePaymentMethodQuery__
 *
 * To run a query within a React component, call `usePaymentMethodQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentMethodQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentMethodQuery({
 *   variables: {
 *   },
 * });
 */
export function usePaymentMethodQuery(baseOptions?: Apollo.QueryHookOptions<PaymentMethodQuery, PaymentMethodQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PaymentMethodQuery, PaymentMethodQueryVariables>(PaymentMethodDocument, options);
      }
export function usePaymentMethodLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PaymentMethodQuery, PaymentMethodQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PaymentMethodQuery, PaymentMethodQueryVariables>(PaymentMethodDocument, options);
        }
export function usePaymentMethodSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PaymentMethodQuery, PaymentMethodQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PaymentMethodQuery, PaymentMethodQueryVariables>(PaymentMethodDocument, options);
        }
export type PaymentMethodQueryHookResult = ReturnType<typeof usePaymentMethodQuery>;
export type PaymentMethodLazyQueryHookResult = ReturnType<typeof usePaymentMethodLazyQuery>;
export type PaymentMethodSuspenseQueryHookResult = ReturnType<typeof usePaymentMethodSuspenseQuery>;
export type PaymentMethodQueryResult = Apollo.QueryResult<PaymentMethodQuery, PaymentMethodQueryVariables>;
export const PodcastEpisodesIndexListDocument = gql`
    query PodcastEpisodesIndexList($cursor: String, $searchParams: String) {
  podcastEpisodesIndexList(searchParams: $searchParams, first: 20, after: $cursor) {
    edges {
      node {
        id
        description
        episodeId
        mentionedEntities {
          id
          name
          primarySymbol
        }
        name
        releasedAt
        tagList
        vanityLink
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  indexListResultCount(
    searchParams: $searchParams
    indexType: "PodcastEpisodesIndex"
  )
}
    `;

/**
 * __usePodcastEpisodesIndexListQuery__
 *
 * To run a query within a React component, call `usePodcastEpisodesIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePodcastEpisodesIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePodcastEpisodesIndexListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function usePodcastEpisodesIndexListQuery(baseOptions?: Apollo.QueryHookOptions<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>(PodcastEpisodesIndexListDocument, options);
      }
export function usePodcastEpisodesIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>(PodcastEpisodesIndexListDocument, options);
        }
export function usePodcastEpisodesIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>(PodcastEpisodesIndexListDocument, options);
        }
export type PodcastEpisodesIndexListQueryHookResult = ReturnType<typeof usePodcastEpisodesIndexListQuery>;
export type PodcastEpisodesIndexListLazyQueryHookResult = ReturnType<typeof usePodcastEpisodesIndexListLazyQuery>;
export type PodcastEpisodesIndexListSuspenseQueryHookResult = ReturnType<typeof usePodcastEpisodesIndexListSuspenseQuery>;
export type PodcastEpisodesIndexListQueryResult = Apollo.QueryResult<PodcastEpisodesIndexListQuery, PodcastEpisodesIndexListQueryVariables>;
export const PopularAssetSearchDocument = gql`
    query PopularAssetSearch($categoryName: String!, $categoryType: String!) {
  popularAssetSearch(categoryName: $categoryName, categoryType: $categoryType) {
    id
    name
    primarySymbol
    entityId
  }
}
    `;

/**
 * __usePopularAssetSearchQuery__
 *
 * To run a query within a React component, call `usePopularAssetSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularAssetSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularAssetSearchQuery({
 *   variables: {
 *      categoryName: // value for 'categoryName'
 *      categoryType: // value for 'categoryType'
 *   },
 * });
 */
export function usePopularAssetSearchQuery(baseOptions: Apollo.QueryHookOptions<PopularAssetSearchQuery, PopularAssetSearchQueryVariables> & ({ variables: PopularAssetSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularAssetSearchQuery, PopularAssetSearchQueryVariables>(PopularAssetSearchDocument, options);
      }
export function usePopularAssetSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularAssetSearchQuery, PopularAssetSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularAssetSearchQuery, PopularAssetSearchQueryVariables>(PopularAssetSearchDocument, options);
        }
export function usePopularAssetSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PopularAssetSearchQuery, PopularAssetSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PopularAssetSearchQuery, PopularAssetSearchQueryVariables>(PopularAssetSearchDocument, options);
        }
export type PopularAssetSearchQueryHookResult = ReturnType<typeof usePopularAssetSearchQuery>;
export type PopularAssetSearchLazyQueryHookResult = ReturnType<typeof usePopularAssetSearchLazyQuery>;
export type PopularAssetSearchSuspenseQueryHookResult = ReturnType<typeof usePopularAssetSearchSuspenseQuery>;
export type PopularAssetSearchQueryResult = Apollo.QueryResult<PopularAssetSearchQuery, PopularAssetSearchQueryVariables>;
export const PostCommentsDocument = gql`
    query PostComments($cursor: String, $postId: ID!) {
  post(postId: $postId) {
    id
    comments(first: 20, after: $cursor) {
      edges {
        node {
          id
          anonUser {
            id
            aumRange
            fundType
            title
          }
          anonymous
          body
          byAllocator
          createdAt
          commentableType
          commentCreationTime
          currentUserHasLiked
          likeCount
          parentId
          user {
            id
            displayName
            mostRecentEmployer {
              id
              currentEmployer
              employer {
                id
                name
                aumRange
                fundType
              }
              title
            }
            profileImageUrl
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
    commentsCount
    commentMentionables {
      id
      display
    }
  }
  currentUser {
    id
    canCommentAnonymously
    isAllocator
    isRetail
    profileImageUrl
  }
}
    `;

/**
 * __usePostCommentsQuery__
 *
 * To run a query within a React component, call `usePostCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostCommentsQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostCommentsQuery(baseOptions: Apollo.QueryHookOptions<PostCommentsQuery, PostCommentsQueryVariables> & ({ variables: PostCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostCommentsQuery, PostCommentsQueryVariables>(PostCommentsDocument, options);
      }
export function usePostCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostCommentsQuery, PostCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostCommentsQuery, PostCommentsQueryVariables>(PostCommentsDocument, options);
        }
export function usePostCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostCommentsQuery, PostCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostCommentsQuery, PostCommentsQueryVariables>(PostCommentsDocument, options);
        }
export type PostCommentsQueryHookResult = ReturnType<typeof usePostCommentsQuery>;
export type PostCommentsLazyQueryHookResult = ReturnType<typeof usePostCommentsLazyQuery>;
export type PostCommentsSuspenseQueryHookResult = ReturnType<typeof usePostCommentsSuspenseQuery>;
export type PostCommentsQueryResult = Apollo.QueryResult<PostCommentsQuery, PostCommentsQueryVariables>;
export const PostIndexCardDocument = gql`
    query PostIndexCard($id: ID!) {
  post(postId: $id) {
    id
    currentUserHasLiked
    postedAt
    youtubeId
  }
}
    `;

/**
 * __usePostIndexCardQuery__
 *
 * To run a query within a React component, call `usePostIndexCardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostIndexCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostIndexCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePostIndexCardQuery(baseOptions: Apollo.QueryHookOptions<PostIndexCardQuery, PostIndexCardQueryVariables> & ({ variables: PostIndexCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostIndexCardQuery, PostIndexCardQueryVariables>(PostIndexCardDocument, options);
      }
export function usePostIndexCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostIndexCardQuery, PostIndexCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostIndexCardQuery, PostIndexCardQueryVariables>(PostIndexCardDocument, options);
        }
export function usePostIndexCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostIndexCardQuery, PostIndexCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostIndexCardQuery, PostIndexCardQueryVariables>(PostIndexCardDocument, options);
        }
export type PostIndexCardQueryHookResult = ReturnType<typeof usePostIndexCardQuery>;
export type PostIndexCardLazyQueryHookResult = ReturnType<typeof usePostIndexCardLazyQuery>;
export type PostIndexCardSuspenseQueryHookResult = ReturnType<typeof usePostIndexCardSuspenseQuery>;
export type PostIndexCardQueryResult = Apollo.QueryResult<PostIndexCardQuery, PostIndexCardQueryVariables>;
export const PostRelatedResearchDocument = gql`
    query PostRelatedResearch($postId: ID!) {
  post(postId: $postId) {
    id
    relatedIdeas {
      edges {
        node {
          ...IdeaResearchItem
        }
      }
    }
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __usePostRelatedResearchQuery__
 *
 * To run a query within a React component, call `usePostRelatedResearchQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostRelatedResearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostRelatedResearchQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostRelatedResearchQuery(baseOptions: Apollo.QueryHookOptions<PostRelatedResearchQuery, PostRelatedResearchQueryVariables> & ({ variables: PostRelatedResearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostRelatedResearchQuery, PostRelatedResearchQueryVariables>(PostRelatedResearchDocument, options);
      }
export function usePostRelatedResearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostRelatedResearchQuery, PostRelatedResearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostRelatedResearchQuery, PostRelatedResearchQueryVariables>(PostRelatedResearchDocument, options);
        }
export function usePostRelatedResearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostRelatedResearchQuery, PostRelatedResearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostRelatedResearchQuery, PostRelatedResearchQueryVariables>(PostRelatedResearchDocument, options);
        }
export type PostRelatedResearchQueryHookResult = ReturnType<typeof usePostRelatedResearchQuery>;
export type PostRelatedResearchLazyQueryHookResult = ReturnType<typeof usePostRelatedResearchLazyQuery>;
export type PostRelatedResearchSuspenseQueryHookResult = ReturnType<typeof usePostRelatedResearchSuspenseQuery>;
export type PostRelatedResearchQueryResult = Apollo.QueryResult<PostRelatedResearchQuery, PostRelatedResearchQueryVariables>;
export const PostShowDocument = gql`
    query PostShow($postId: ID!) {
  post(postId: $postId) {
    id
    body
    commentsCount
    createdAt
    currentUserHasLiked
    domain
    eventId
    likeCount
    ogUrl
    ogTitle
    ogDescription
    ogPreviewImageUrl
    tagList
    untaggedBody
    user {
      id
      displayName
      featuredRank {
        id
        rankString
      }
      profileImageUrl
      mostRecentEmployer {
        id
        currentEmployer
        title
        employer {
          id
          name
          aumRange
          fundType
        }
      }
      profile {
        id
        city
      }
      firstName
      activeFollowersCount
    }
    youtubeId
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    profileImageUrl
  }
}
    `;

/**
 * __usePostShowQuery__
 *
 * To run a query within a React component, call `usePostShowQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostShowQuery({
 *   variables: {
 *      postId: // value for 'postId'
 *   },
 * });
 */
export function usePostShowQuery(baseOptions: Apollo.QueryHookOptions<PostShowQuery, PostShowQueryVariables> & ({ variables: PostShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostShowQuery, PostShowQueryVariables>(PostShowDocument, options);
      }
export function usePostShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostShowQuery, PostShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostShowQuery, PostShowQueryVariables>(PostShowDocument, options);
        }
export function usePostShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostShowQuery, PostShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostShowQuery, PostShowQueryVariables>(PostShowDocument, options);
        }
export type PostShowQueryHookResult = ReturnType<typeof usePostShowQuery>;
export type PostShowLazyQueryHookResult = ReturnType<typeof usePostShowLazyQuery>;
export type PostShowSuspenseQueryHookResult = ReturnType<typeof usePostShowSuspenseQuery>;
export type PostShowQueryResult = Apollo.QueryResult<PostShowQuery, PostShowQueryVariables>;
export const PostsIndexListDocument = gql`
    query PostsIndexList($cursor: String, $searchParams: String) {
  postsIndexList(searchParams: $searchParams, first: 20, after: $cursor) {
    edges {
      node {
        id
        body
        commentsCount
        domain
        eventId
        likeCount
        ogDescription
        ogUrl
        ogPreviewImageUrl
        ogTitle
        tagList
        untaggedBody
        user {
          id
          displayName
          featuredRank {
            id
            rankString
          }
          mostRecentEmployer {
            id
            currentEmployer
            employer {
              id
              aumRange
              fundType
              name
            }
            title
          }
          profile {
            id
            city
          }
          profileImageUrl
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  postsIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: "PostsIndex"
  )
  currentUser {
    id
    acceptedPostTerms
    canPost: isBuyside
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    isAdmin
    profileImageUrl
  }
}
    `;

/**
 * __usePostsIndexListQuery__
 *
 * To run a query within a React component, call `usePostsIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePostsIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePostsIndexListQuery({
 *   variables: {
 *      cursor: // value for 'cursor'
 *      searchParams: // value for 'searchParams'
 *   },
 * });
 */
export function usePostsIndexListQuery(baseOptions?: Apollo.QueryHookOptions<PostsIndexListQuery, PostsIndexListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PostsIndexListQuery, PostsIndexListQueryVariables>(PostsIndexListDocument, options);
      }
export function usePostsIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PostsIndexListQuery, PostsIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PostsIndexListQuery, PostsIndexListQueryVariables>(PostsIndexListDocument, options);
        }
export function usePostsIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PostsIndexListQuery, PostsIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PostsIndexListQuery, PostsIndexListQueryVariables>(PostsIndexListDocument, options);
        }
export type PostsIndexListQueryHookResult = ReturnType<typeof usePostsIndexListQuery>;
export type PostsIndexListLazyQueryHookResult = ReturnType<typeof usePostsIndexListLazyQuery>;
export type PostsIndexListSuspenseQueryHookResult = ReturnType<typeof usePostsIndexListSuspenseQuery>;
export type PostsIndexListQueryResult = Apollo.QueryResult<PostsIndexListQuery, PostsIndexListQueryVariables>;
export const PublicUserDocument = gql`
    query PublicUser($anonymous: Boolean, $userId: ID!) {
  userLookUp(userId: $userId) {
    id
    activeFollowedUsersCount
    activeFollowersCount
    displayName(suppress: $anonymous)
    firstName(suppress: $anonymous)
    profile {
      id
      ideaTotalReturnAverage(anonymous: $anonymous)
      ideaReturnVsBenchmarkAverage(anonymous: $anonymous)
      ideaAnnualizedReturnMedian(anonymous: $anonymous)
    }
    profileImageUrl(suppress: $anonymous)
    publishedIdeasCount(anonymous: $anonymous)
    username
  }
}
    `;

/**
 * __usePublicUserQuery__
 *
 * To run a query within a React component, call `usePublicUserQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserQuery({
 *   variables: {
 *      anonymous: // value for 'anonymous'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function usePublicUserQuery(baseOptions: Apollo.QueryHookOptions<PublicUserQuery, PublicUserQueryVariables> & ({ variables: PublicUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserQuery, PublicUserQueryVariables>(PublicUserDocument, options);
      }
export function usePublicUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserQuery, PublicUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserQuery, PublicUserQueryVariables>(PublicUserDocument, options);
        }
export function usePublicUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicUserQuery, PublicUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicUserQuery, PublicUserQueryVariables>(PublicUserDocument, options);
        }
export type PublicUserQueryHookResult = ReturnType<typeof usePublicUserQuery>;
export type PublicUserLazyQueryHookResult = ReturnType<typeof usePublicUserLazyQuery>;
export type PublicUserSuspenseQueryHookResult = ReturnType<typeof usePublicUserSuspenseQuery>;
export type PublicUserQueryResult = Apollo.QueryResult<PublicUserQuery, PublicUserQueryVariables>;
export const PublicUserFollowersDocument = gql`
    query PublicUserFollowers($userId: ID!, $page: Int) {
  userLookUp(userId: $userId) {
    id
    followersList(page: $page) {
      edges {
        node {
          ...MembersIndexCard
        }
      }
    }
  }
}
    ${MembersIndexCardFragmentDoc}`;

/**
 * __usePublicUserFollowersQuery__
 *
 * To run a query within a React component, call `usePublicUserFollowersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserFollowersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserFollowersQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublicUserFollowersQuery(baseOptions: Apollo.QueryHookOptions<PublicUserFollowersQuery, PublicUserFollowersQueryVariables> & ({ variables: PublicUserFollowersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>(PublicUserFollowersDocument, options);
      }
export function usePublicUserFollowersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>(PublicUserFollowersDocument, options);
        }
export function usePublicUserFollowersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>(PublicUserFollowersDocument, options);
        }
export type PublicUserFollowersQueryHookResult = ReturnType<typeof usePublicUserFollowersQuery>;
export type PublicUserFollowersLazyQueryHookResult = ReturnType<typeof usePublicUserFollowersLazyQuery>;
export type PublicUserFollowersSuspenseQueryHookResult = ReturnType<typeof usePublicUserFollowersSuspenseQuery>;
export type PublicUserFollowersQueryResult = Apollo.QueryResult<PublicUserFollowersQuery, PublicUserFollowersQueryVariables>;
export const PublicUserFollowingDocument = gql`
    query PublicUserFollowing($userId: ID!, $page: Int) {
  userLookUp(userId: $userId) {
    id
    followingList(page: $page) {
      edges {
        node {
          ...MembersIndexCard
        }
      }
    }
  }
}
    ${MembersIndexCardFragmentDoc}`;

/**
 * __usePublicUserFollowingQuery__
 *
 * To run a query within a React component, call `usePublicUserFollowingQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserFollowingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserFollowingQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePublicUserFollowingQuery(baseOptions: Apollo.QueryHookOptions<PublicUserFollowingQuery, PublicUserFollowingQueryVariables> & ({ variables: PublicUserFollowingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>(PublicUserFollowingDocument, options);
      }
export function usePublicUserFollowingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>(PublicUserFollowingDocument, options);
        }
export function usePublicUserFollowingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>(PublicUserFollowingDocument, options);
        }
export type PublicUserFollowingQueryHookResult = ReturnType<typeof usePublicUserFollowingQuery>;
export type PublicUserFollowingLazyQueryHookResult = ReturnType<typeof usePublicUserFollowingLazyQuery>;
export type PublicUserFollowingSuspenseQueryHookResult = ReturnType<typeof usePublicUserFollowingSuspenseQuery>;
export type PublicUserFollowingQueryResult = Apollo.QueryResult<PublicUserFollowingQuery, PublicUserFollowingQueryVariables>;
export const PublicUserIdeasDocument = gql`
    query PublicUserIdeas($anonymous: Boolean, $userId: ID!, $cursor: String) {
  userLookUp(userId: $userId) {
    id
    publishedIdeas(anonymous: $anonymous, first: 20, after: $cursor, isPublic: true) {
      edges {
        node {
          ...IdeaResearchItem
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __usePublicUserIdeasQuery__
 *
 * To run a query within a React component, call `usePublicUserIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicUserIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicUserIdeasQuery({
 *   variables: {
 *      anonymous: // value for 'anonymous'
 *      userId: // value for 'userId'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function usePublicUserIdeasQuery(baseOptions: Apollo.QueryHookOptions<PublicUserIdeasQuery, PublicUserIdeasQueryVariables> & ({ variables: PublicUserIdeasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicUserIdeasQuery, PublicUserIdeasQueryVariables>(PublicUserIdeasDocument, options);
      }
export function usePublicUserIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicUserIdeasQuery, PublicUserIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicUserIdeasQuery, PublicUserIdeasQueryVariables>(PublicUserIdeasDocument, options);
        }
export function usePublicUserIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PublicUserIdeasQuery, PublicUserIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicUserIdeasQuery, PublicUserIdeasQueryVariables>(PublicUserIdeasDocument, options);
        }
export type PublicUserIdeasQueryHookResult = ReturnType<typeof usePublicUserIdeasQuery>;
export type PublicUserIdeasLazyQueryHookResult = ReturnType<typeof usePublicUserIdeasLazyQuery>;
export type PublicUserIdeasSuspenseQueryHookResult = ReturnType<typeof usePublicUserIdeasSuspenseQuery>;
export type PublicUserIdeasQueryResult = Apollo.QueryResult<PublicUserIdeasQuery, PublicUserIdeasQueryVariables>;
export const QuickPositionAssetDocument = gql`
    query QuickPositionAsset($assetId: ID!) {
  currentUser {
    id
    isHidden
  }
  asset(id: $assetId) {
    id
    currencyCode
    currentUserQuickPosition {
      id
      chat {
        id
      }
      direction
      openedAt
      openingPrice
      returnToDate
    }
    latestPrice
    longQuickPositionRatio
    shortQuickPositionRatio
    symbol
  }
}
    `;

/**
 * __useQuickPositionAssetQuery__
 *
 * To run a query within a React component, call `useQuickPositionAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPositionAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPositionAssetQuery({
 *   variables: {
 *      assetId: // value for 'assetId'
 *   },
 * });
 */
export function useQuickPositionAssetQuery(baseOptions: Apollo.QueryHookOptions<QuickPositionAssetQuery, QuickPositionAssetQueryVariables> & ({ variables: QuickPositionAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickPositionAssetQuery, QuickPositionAssetQueryVariables>(QuickPositionAssetDocument, options);
      }
export function useQuickPositionAssetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickPositionAssetQuery, QuickPositionAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickPositionAssetQuery, QuickPositionAssetQueryVariables>(QuickPositionAssetDocument, options);
        }
export function useQuickPositionAssetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickPositionAssetQuery, QuickPositionAssetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickPositionAssetQuery, QuickPositionAssetQueryVariables>(QuickPositionAssetDocument, options);
        }
export type QuickPositionAssetQueryHookResult = ReturnType<typeof useQuickPositionAssetQuery>;
export type QuickPositionAssetLazyQueryHookResult = ReturnType<typeof useQuickPositionAssetLazyQuery>;
export type QuickPositionAssetSuspenseQueryHookResult = ReturnType<typeof useQuickPositionAssetSuspenseQuery>;
export type QuickPositionAssetQueryResult = Apollo.QueryResult<QuickPositionAssetQuery, QuickPositionAssetQueryVariables>;
export const QuickPositionChatsNavigationDocument = gql`
    query QuickPositionChatsNavigation {
  currentUser {
    id
    openQuickPositions {
      id
      chat {
        id
        unreadMessagesCount
      }
      direction
      asset {
        id
        symbol
        entity {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useQuickPositionChatsNavigationQuery__
 *
 * To run a query within a React component, call `useQuickPositionChatsNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuickPositionChatsNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuickPositionChatsNavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useQuickPositionChatsNavigationQuery(baseOptions?: Apollo.QueryHookOptions<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>(QuickPositionChatsNavigationDocument, options);
      }
export function useQuickPositionChatsNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>(QuickPositionChatsNavigationDocument, options);
        }
export function useQuickPositionChatsNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>(QuickPositionChatsNavigationDocument, options);
        }
export type QuickPositionChatsNavigationQueryHookResult = ReturnType<typeof useQuickPositionChatsNavigationQuery>;
export type QuickPositionChatsNavigationLazyQueryHookResult = ReturnType<typeof useQuickPositionChatsNavigationLazyQuery>;
export type QuickPositionChatsNavigationSuspenseQueryHookResult = ReturnType<typeof useQuickPositionChatsNavigationSuspenseQuery>;
export type QuickPositionChatsNavigationQueryResult = Apollo.QueryResult<QuickPositionChatsNavigationQuery, QuickPositionChatsNavigationQueryVariables>;
export const RankingsWidgetDocument = gql`
    query RankingsWidget($category: String!, $first: Int!) {
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
  currentRanksForCategory(category: $category, first: $first) {
    edges {
      node {
        ...RankingsWidgetRank
      }
    }
  }
}
    ${RankingsWidgetRankFragmentDoc}`;

/**
 * __useRankingsWidgetQuery__
 *
 * To run a query within a React component, call `useRankingsWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useRankingsWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRankingsWidgetQuery({
 *   variables: {
 *      category: // value for 'category'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useRankingsWidgetQuery(baseOptions: Apollo.QueryHookOptions<RankingsWidgetQuery, RankingsWidgetQueryVariables> & ({ variables: RankingsWidgetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RankingsWidgetQuery, RankingsWidgetQueryVariables>(RankingsWidgetDocument, options);
      }
export function useRankingsWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RankingsWidgetQuery, RankingsWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RankingsWidgetQuery, RankingsWidgetQueryVariables>(RankingsWidgetDocument, options);
        }
export function useRankingsWidgetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RankingsWidgetQuery, RankingsWidgetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RankingsWidgetQuery, RankingsWidgetQueryVariables>(RankingsWidgetDocument, options);
        }
export type RankingsWidgetQueryHookResult = ReturnType<typeof useRankingsWidgetQuery>;
export type RankingsWidgetLazyQueryHookResult = ReturnType<typeof useRankingsWidgetLazyQuery>;
export type RankingsWidgetSuspenseQueryHookResult = ReturnType<typeof useRankingsWidgetSuspenseQuery>;
export type RankingsWidgetQueryResult = Apollo.QueryResult<RankingsWidgetQuery, RankingsWidgetQueryVariables>;
export const CurrentRanksDocument = gql`
    query currentRanks($category: String!, $afterCursor: String, $pageSize: Int) {
  currentRanksForCategory(
    category: $category
    first: $pageSize
    after: $afterCursor
  ) {
    edges {
      node {
        ...RankCard
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
    }
  }
}
    ${RankCardFragmentDoc}`;

/**
 * __useCurrentRanksQuery__
 *
 * To run a query within a React component, call `useCurrentRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentRanksQuery({
 *   variables: {
 *      category: // value for 'category'
 *      afterCursor: // value for 'afterCursor'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useCurrentRanksQuery(baseOptions: Apollo.QueryHookOptions<CurrentRanksQuery, CurrentRanksQueryVariables> & ({ variables: CurrentRanksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentRanksQuery, CurrentRanksQueryVariables>(CurrentRanksDocument, options);
      }
export function useCurrentRanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentRanksQuery, CurrentRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentRanksQuery, CurrentRanksQueryVariables>(CurrentRanksDocument, options);
        }
export function useCurrentRanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentRanksQuery, CurrentRanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentRanksQuery, CurrentRanksQueryVariables>(CurrentRanksDocument, options);
        }
export type CurrentRanksQueryHookResult = ReturnType<typeof useCurrentRanksQuery>;
export type CurrentRanksLazyQueryHookResult = ReturnType<typeof useCurrentRanksLazyQuery>;
export type CurrentRanksSuspenseQueryHookResult = ReturnType<typeof useCurrentRanksSuspenseQuery>;
export type CurrentRanksQueryResult = Apollo.QueryResult<CurrentRanksQuery, CurrentRanksQueryVariables>;
export const RecommendedIdeaDocument = gql`
    query RecommendedIdea($userId: ID!, $lastSeenIds: [ID!]) {
  recommendedIdea(userId: $userId, lastSeenIds: $lastSeenIds) {
    id
    userId
    idea {
      ...IdeaResearchItem
    }
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useRecommendedIdeaQuery__
 *
 * To run a query within a React component, call `useRecommendedIdeaQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedIdeaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedIdeaQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      lastSeenIds: // value for 'lastSeenIds'
 *   },
 * });
 */
export function useRecommendedIdeaQuery(baseOptions: Apollo.QueryHookOptions<RecommendedIdeaQuery, RecommendedIdeaQueryVariables> & ({ variables: RecommendedIdeaQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedIdeaQuery, RecommendedIdeaQueryVariables>(RecommendedIdeaDocument, options);
      }
export function useRecommendedIdeaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedIdeaQuery, RecommendedIdeaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedIdeaQuery, RecommendedIdeaQueryVariables>(RecommendedIdeaDocument, options);
        }
export function useRecommendedIdeaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedIdeaQuery, RecommendedIdeaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedIdeaQuery, RecommendedIdeaQueryVariables>(RecommendedIdeaDocument, options);
        }
export type RecommendedIdeaQueryHookResult = ReturnType<typeof useRecommendedIdeaQuery>;
export type RecommendedIdeaLazyQueryHookResult = ReturnType<typeof useRecommendedIdeaLazyQuery>;
export type RecommendedIdeaSuspenseQueryHookResult = ReturnType<typeof useRecommendedIdeaSuspenseQuery>;
export type RecommendedIdeaQueryResult = Apollo.QueryResult<RecommendedIdeaQuery, RecommendedIdeaQueryVariables>;
export const RecommendedUsersToFollowDocument = gql`
    query recommendedUsersToFollow($afterCursor: String) {
  recommendedUsersToFollow(first: 20, after: $afterCursor) {
    edges {
      node {
        ...MembersIndexCardUser
        isFollowedByCurrentUser
        profile {
          id
          city
          imageProfileUrl
          summary
        }
        currentRanksCount
        watchlistIdeasCount
        wroteOnSameEntitiesCount
        wroteOnWatchlistedSectors
        userInWatchlistedGeography
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  recommendedUsersToFollowCount
}
    ${MembersIndexCardUserFragmentDoc}`;

/**
 * __useRecommendedUsersToFollowQuery__
 *
 * To run a query within a React component, call `useRecommendedUsersToFollowQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedUsersToFollowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedUsersToFollowQuery({
 *   variables: {
 *      afterCursor: // value for 'afterCursor'
 *   },
 * });
 */
export function useRecommendedUsersToFollowQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>(RecommendedUsersToFollowDocument, options);
      }
export function useRecommendedUsersToFollowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>(RecommendedUsersToFollowDocument, options);
        }
export function useRecommendedUsersToFollowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>(RecommendedUsersToFollowDocument, options);
        }
export type RecommendedUsersToFollowQueryHookResult = ReturnType<typeof useRecommendedUsersToFollowQuery>;
export type RecommendedUsersToFollowLazyQueryHookResult = ReturnType<typeof useRecommendedUsersToFollowLazyQuery>;
export type RecommendedUsersToFollowSuspenseQueryHookResult = ReturnType<typeof useRecommendedUsersToFollowSuspenseQuery>;
export type RecommendedUsersToFollowQueryResult = Apollo.QueryResult<RecommendedUsersToFollowQuery, RecommendedUsersToFollowQueryVariables>;
export const RegistrantSearchDocument = gql`
    query RegistrantSearch($email: String!) {
  registrantSearch(email: $email)
}
    `;

/**
 * __useRegistrantSearchQuery__
 *
 * To run a query within a React component, call `useRegistrantSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistrantSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistrantSearchQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRegistrantSearchQuery(baseOptions: Apollo.QueryHookOptions<RegistrantSearchQuery, RegistrantSearchQueryVariables> & ({ variables: RegistrantSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RegistrantSearchQuery, RegistrantSearchQueryVariables>(RegistrantSearchDocument, options);
      }
export function useRegistrantSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RegistrantSearchQuery, RegistrantSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RegistrantSearchQuery, RegistrantSearchQueryVariables>(RegistrantSearchDocument, options);
        }
export function useRegistrantSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RegistrantSearchQuery, RegistrantSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RegistrantSearchQuery, RegistrantSearchQueryVariables>(RegistrantSearchDocument, options);
        }
export type RegistrantSearchQueryHookResult = ReturnType<typeof useRegistrantSearchQuery>;
export type RegistrantSearchLazyQueryHookResult = ReturnType<typeof useRegistrantSearchLazyQuery>;
export type RegistrantSearchSuspenseQueryHookResult = ReturnType<typeof useRegistrantSearchSuspenseQuery>;
export type RegistrantSearchQueryResult = Apollo.QueryResult<RegistrantSearchQuery, RegistrantSearchQueryVariables>;
export const SampleFeedDocument = gql`
    query SampleFeed {
  sampleFeedItems {
    edges {
      node {
        ...ActivityFeedItem
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    ${ActivityFeedItemFragmentDoc}`;

/**
 * __useSampleFeedQuery__
 *
 * To run a query within a React component, call `useSampleFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSampleFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSampleFeedQuery({
 *   variables: {
 *   },
 * });
 */
export function useSampleFeedQuery(baseOptions?: Apollo.QueryHookOptions<SampleFeedQuery, SampleFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SampleFeedQuery, SampleFeedQueryVariables>(SampleFeedDocument, options);
      }
export function useSampleFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SampleFeedQuery, SampleFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SampleFeedQuery, SampleFeedQueryVariables>(SampleFeedDocument, options);
        }
export function useSampleFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SampleFeedQuery, SampleFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SampleFeedQuery, SampleFeedQueryVariables>(SampleFeedDocument, options);
        }
export type SampleFeedQueryHookResult = ReturnType<typeof useSampleFeedQuery>;
export type SampleFeedLazyQueryHookResult = ReturnType<typeof useSampleFeedLazyQuery>;
export type SampleFeedSuspenseQueryHookResult = ReturnType<typeof useSampleFeedSuspenseQuery>;
export type SampleFeedQueryResult = Apollo.QueryResult<SampleFeedQuery, SampleFeedQueryVariables>;
export const SchoolNameSearchDocument = gql`
    query SchoolNameSearch($query: String) {
  schoolNameSearch(query: $query)
}
    `;

/**
 * __useSchoolNameSearchQuery__
 *
 * To run a query within a React component, call `useSchoolNameSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSchoolNameSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSchoolNameSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSchoolNameSearchQuery(baseOptions?: Apollo.QueryHookOptions<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>(SchoolNameSearchDocument, options);
      }
export function useSchoolNameSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>(SchoolNameSearchDocument, options);
        }
export function useSchoolNameSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>(SchoolNameSearchDocument, options);
        }
export type SchoolNameSearchQueryHookResult = ReturnType<typeof useSchoolNameSearchQuery>;
export type SchoolNameSearchLazyQueryHookResult = ReturnType<typeof useSchoolNameSearchLazyQuery>;
export type SchoolNameSearchSuspenseQueryHookResult = ReturnType<typeof useSchoolNameSearchSuspenseQuery>;
export type SchoolNameSearchQueryResult = Apollo.QueryResult<SchoolNameSearchQuery, SchoolNameSearchQueryVariables>;
export const SectorChatsNavigationDocument = gql`
    query SectorChatsNavigation {
  sectorChats {
    id
    sector {
      id
      name
    }
    unreadMessagesCount
  }
}
    `;

/**
 * __useSectorChatsNavigationQuery__
 *
 * To run a query within a React component, call `useSectorChatsNavigationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSectorChatsNavigationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSectorChatsNavigationQuery({
 *   variables: {
 *   },
 * });
 */
export function useSectorChatsNavigationQuery(baseOptions?: Apollo.QueryHookOptions<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>(SectorChatsNavigationDocument, options);
      }
export function useSectorChatsNavigationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>(SectorChatsNavigationDocument, options);
        }
export function useSectorChatsNavigationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>(SectorChatsNavigationDocument, options);
        }
export type SectorChatsNavigationQueryHookResult = ReturnType<typeof useSectorChatsNavigationQuery>;
export type SectorChatsNavigationLazyQueryHookResult = ReturnType<typeof useSectorChatsNavigationLazyQuery>;
export type SectorChatsNavigationSuspenseQueryHookResult = ReturnType<typeof useSectorChatsNavigationSuspenseQuery>;
export type SectorChatsNavigationQueryResult = Apollo.QueryResult<SectorChatsNavigationQuery, SectorChatsNavigationQueryVariables>;
export const SecuritiesDocument = gql`
    query Securities($symbol: String!) {
  securities(symbol: $symbol) {
    edges {
      node {
        id
        display
      }
    }
  }
}
    `;

/**
 * __useSecuritiesQuery__
 *
 * To run a query within a React component, call `useSecuritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecuritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecuritiesQuery({
 *   variables: {
 *      symbol: // value for 'symbol'
 *   },
 * });
 */
export function useSecuritiesQuery(baseOptions: Apollo.QueryHookOptions<SecuritiesQuery, SecuritiesQueryVariables> & ({ variables: SecuritiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecuritiesQuery, SecuritiesQueryVariables>(SecuritiesDocument, options);
      }
export function useSecuritiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecuritiesQuery, SecuritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecuritiesQuery, SecuritiesQueryVariables>(SecuritiesDocument, options);
        }
export function useSecuritiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SecuritiesQuery, SecuritiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SecuritiesQuery, SecuritiesQueryVariables>(SecuritiesDocument, options);
        }
export type SecuritiesQueryHookResult = ReturnType<typeof useSecuritiesQuery>;
export type SecuritiesLazyQueryHookResult = ReturnType<typeof useSecuritiesLazyQuery>;
export type SecuritiesSuspenseQueryHookResult = ReturnType<typeof useSecuritiesSuspenseQuery>;
export type SecuritiesQueryResult = Apollo.QueryResult<SecuritiesQuery, SecuritiesQueryVariables>;
export const SecuritySearchDocument = gql`
    query SecuritySearch($query: String, $assetClass: String, $includeLocalAsset: Boolean, $skip: Boolean!) {
  securitySearch(
    query: $query
    assetClass: $assetClass
    includeLocalAsset: $includeLocalAsset
  ) @skip(if: $skip)
}
    `;

/**
 * __useSecuritySearchQuery__
 *
 * To run a query within a React component, call `useSecuritySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSecuritySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSecuritySearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      assetClass: // value for 'assetClass'
 *      includeLocalAsset: // value for 'includeLocalAsset'
 *      skip: // value for 'skip'
 *   },
 * });
 */
export function useSecuritySearchQuery(baseOptions: Apollo.QueryHookOptions<SecuritySearchQuery, SecuritySearchQueryVariables> & ({ variables: SecuritySearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SecuritySearchQuery, SecuritySearchQueryVariables>(SecuritySearchDocument, options);
      }
export function useSecuritySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SecuritySearchQuery, SecuritySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SecuritySearchQuery, SecuritySearchQueryVariables>(SecuritySearchDocument, options);
        }
export function useSecuritySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SecuritySearchQuery, SecuritySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SecuritySearchQuery, SecuritySearchQueryVariables>(SecuritySearchDocument, options);
        }
export type SecuritySearchQueryHookResult = ReturnType<typeof useSecuritySearchQuery>;
export type SecuritySearchLazyQueryHookResult = ReturnType<typeof useSecuritySearchLazyQuery>;
export type SecuritySearchSuspenseQueryHookResult = ReturnType<typeof useSecuritySearchSuspenseQuery>;
export type SecuritySearchQueryResult = Apollo.QueryResult<SecuritySearchQuery, SecuritySearchQueryVariables>;
export const SiteMessageDocument = gql`
    query SiteMessage {
  latestSiteMessage {
    id
    body
    linkUrl
    linkText
    isContest
  }
}
    `;

/**
 * __useSiteMessageQuery__
 *
 * To run a query within a React component, call `useSiteMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteMessageQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteMessageQuery(baseOptions?: Apollo.QueryHookOptions<SiteMessageQuery, SiteMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteMessageQuery, SiteMessageQueryVariables>(SiteMessageDocument, options);
      }
export function useSiteMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteMessageQuery, SiteMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteMessageQuery, SiteMessageQueryVariables>(SiteMessageDocument, options);
        }
export function useSiteMessageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteMessageQuery, SiteMessageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteMessageQuery, SiteMessageQueryVariables>(SiteMessageDocument, options);
        }
export type SiteMessageQueryHookResult = ReturnType<typeof useSiteMessageQuery>;
export type SiteMessageLazyQueryHookResult = ReturnType<typeof useSiteMessageLazyQuery>;
export type SiteMessageSuspenseQueryHookResult = ReturnType<typeof useSiteMessageSuspenseQuery>;
export type SiteMessageQueryResult = Apollo.QueryResult<SiteMessageQuery, SiteMessageQueryVariables>;
export const SiteWideModalContestDocument = gql`
    query SiteWideModalContest {
  promotedContest {
    id
    active
    name
    promoSummary
    judgesDisplayNames
    prizes {
      id
      description
      sponsorImage
      sponsorTrackingLink
    }
    countdownDate
    disableSiteWideModal
  }
}
    `;

/**
 * __useSiteWideModalContestQuery__
 *
 * To run a query within a React component, call `useSiteWideModalContestQuery` and pass it any options that fit your needs.
 * When your component renders, `useSiteWideModalContestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSiteWideModalContestQuery({
 *   variables: {
 *   },
 * });
 */
export function useSiteWideModalContestQuery(baseOptions?: Apollo.QueryHookOptions<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>(SiteWideModalContestDocument, options);
      }
export function useSiteWideModalContestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>(SiteWideModalContestDocument, options);
        }
export function useSiteWideModalContestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>(SiteWideModalContestDocument, options);
        }
export type SiteWideModalContestQueryHookResult = ReturnType<typeof useSiteWideModalContestQuery>;
export type SiteWideModalContestLazyQueryHookResult = ReturnType<typeof useSiteWideModalContestLazyQuery>;
export type SiteWideModalContestSuspenseQueryHookResult = ReturnType<typeof useSiteWideModalContestSuspenseQuery>;
export type SiteWideModalContestQueryResult = Apollo.QueryResult<SiteWideModalContestQuery, SiteWideModalContestQueryVariables>;
export const StripeSubscriptionDocument = gql`
    query StripeSubscription {
  currentUser {
    id
    subscriptions {
      id
      currentPeriodEnd
      description
      isAutoRenewing
    }
  }
}
    `;

/**
 * __useStripeSubscriptionQuery__
 *
 * To run a query within a React component, call `useStripeSubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeSubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeSubscriptionQuery({
 *   variables: {
 *   },
 * });
 */
export function useStripeSubscriptionQuery(baseOptions?: Apollo.QueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
      }
export function useStripeSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
        }
export function useStripeSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>(StripeSubscriptionDocument, options);
        }
export type StripeSubscriptionQueryHookResult = ReturnType<typeof useStripeSubscriptionQuery>;
export type StripeSubscriptionLazyQueryHookResult = ReturnType<typeof useStripeSubscriptionLazyQuery>;
export type StripeSubscriptionSuspenseQueryHookResult = ReturnType<typeof useStripeSubscriptionSuspenseQuery>;
export type StripeSubscriptionQueryResult = Apollo.QueryResult<StripeSubscriptionQuery, StripeSubscriptionQueryVariables>;
export const TopStockWinnersDocument = gql`
    query TopStockWinners {
  topStockWinners {
    id
    entityName
    user {
      id
      displayName(controlled: false)
      profileImageUrl
      mostRecentEmployer {
        id
        employer {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useTopStockWinnersQuery__
 *
 * To run a query within a React component, call `useTopStockWinnersQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopStockWinnersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopStockWinnersQuery({
 *   variables: {
 *   },
 * });
 */
export function useTopStockWinnersQuery(baseOptions?: Apollo.QueryHookOptions<TopStockWinnersQuery, TopStockWinnersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopStockWinnersQuery, TopStockWinnersQueryVariables>(TopStockWinnersDocument, options);
      }
export function useTopStockWinnersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopStockWinnersQuery, TopStockWinnersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopStockWinnersQuery, TopStockWinnersQueryVariables>(TopStockWinnersDocument, options);
        }
export function useTopStockWinnersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TopStockWinnersQuery, TopStockWinnersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopStockWinnersQuery, TopStockWinnersQueryVariables>(TopStockWinnersDocument, options);
        }
export type TopStockWinnersQueryHookResult = ReturnType<typeof useTopStockWinnersQuery>;
export type TopStockWinnersLazyQueryHookResult = ReturnType<typeof useTopStockWinnersLazyQuery>;
export type TopStockWinnersSuspenseQueryHookResult = ReturnType<typeof useTopStockWinnersSuspenseQuery>;
export type TopStockWinnersQueryResult = Apollo.QueryResult<TopStockWinnersQuery, TopStockWinnersQueryVariables>;
export const TrendingResearchItemsDocument = gql`
    query TrendingResearchItems {
  trendingIdeas {
    edges {
      node {
        ...ResearchItem
      }
    }
  }
  activeConversationIdeas {
    edges {
      node {
        ...ResearchItem
      }
    }
  }
  biggestMoverIdeas {
    edges {
      node {
        ...ResearchItem
        thirtyDayReturnChange
      }
    }
  }
}
    ${ResearchItemFragmentDoc}`;

/**
 * __useTrendingResearchItemsQuery__
 *
 * To run a query within a React component, call `useTrendingResearchItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTrendingResearchItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTrendingResearchItemsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTrendingResearchItemsQuery(baseOptions?: Apollo.QueryHookOptions<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>(TrendingResearchItemsDocument, options);
      }
export function useTrendingResearchItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>(TrendingResearchItemsDocument, options);
        }
export function useTrendingResearchItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>(TrendingResearchItemsDocument, options);
        }
export type TrendingResearchItemsQueryHookResult = ReturnType<typeof useTrendingResearchItemsQuery>;
export type TrendingResearchItemsLazyQueryHookResult = ReturnType<typeof useTrendingResearchItemsLazyQuery>;
export type TrendingResearchItemsSuspenseQueryHookResult = ReturnType<typeof useTrendingResearchItemsSuspenseQuery>;
export type TrendingResearchItemsQueryResult = Apollo.QueryResult<TrendingResearchItemsQuery, TrendingResearchItemsQueryVariables>;
export const TwitterCurrentUserDocument = gql`
    query TwitterCurrentUser {
  currentUser {
    id
    hasTwitterToken
    profileImageUrl
  }
}
    `;

/**
 * __useTwitterCurrentUserQuery__
 *
 * To run a query within a React component, call `useTwitterCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useTwitterCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwitterCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useTwitterCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>(TwitterCurrentUserDocument, options);
      }
export function useTwitterCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>(TwitterCurrentUserDocument, options);
        }
export function useTwitterCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>(TwitterCurrentUserDocument, options);
        }
export type TwitterCurrentUserQueryHookResult = ReturnType<typeof useTwitterCurrentUserQuery>;
export type TwitterCurrentUserLazyQueryHookResult = ReturnType<typeof useTwitterCurrentUserLazyQuery>;
export type TwitterCurrentUserSuspenseQueryHookResult = ReturnType<typeof useTwitterCurrentUserSuspenseQuery>;
export type TwitterCurrentUserQueryResult = Apollo.QueryResult<TwitterCurrentUserQuery, TwitterCurrentUserQueryVariables>;
export const UserApplicationDocument = gql`
    query UserApplication($id: ID!) {
  userApplication(id: $id) {
    firstName
    lastName
    email
    linkedinUrl
    city
    phone
    employmentStatus
    isAccredited
    title
    employerName
    basicEmployerName
    basicInvestorType: investorType
    employerFundType
    employerAumRange
    schoolName
    degree
    fieldOfStudy
    yearStart
    expectedGraduation
    applicantType
  }
}
    `;

/**
 * __useUserApplicationQuery__
 *
 * To run a query within a React component, call `useUserApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserApplicationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserApplicationQuery(baseOptions: Apollo.QueryHookOptions<UserApplicationQuery, UserApplicationQueryVariables> & ({ variables: UserApplicationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserApplicationQuery, UserApplicationQueryVariables>(UserApplicationDocument, options);
      }
export function useUserApplicationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserApplicationQuery, UserApplicationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserApplicationQuery, UserApplicationQueryVariables>(UserApplicationDocument, options);
        }
export function useUserApplicationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserApplicationQuery, UserApplicationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserApplicationQuery, UserApplicationQueryVariables>(UserApplicationDocument, options);
        }
export type UserApplicationQueryHookResult = ReturnType<typeof useUserApplicationQuery>;
export type UserApplicationLazyQueryHookResult = ReturnType<typeof useUserApplicationLazyQuery>;
export type UserApplicationSuspenseQueryHookResult = ReturnType<typeof useUserApplicationSuspenseQuery>;
export type UserApplicationQueryResult = Apollo.QueryResult<UserApplicationQuery, UserApplicationQueryVariables>;
export const UserFeedbackSubmittedDocument = gql`
    query UserFeedbackSubmitted($prompt: String!) {
  currentUser {
    id
    userFeedbackSubmitted(prompt: $prompt)
  }
}
    `;

/**
 * __useUserFeedbackSubmittedQuery__
 *
 * To run a query within a React component, call `useUserFeedbackSubmittedQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserFeedbackSubmittedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserFeedbackSubmittedQuery({
 *   variables: {
 *      prompt: // value for 'prompt'
 *   },
 * });
 */
export function useUserFeedbackSubmittedQuery(baseOptions: Apollo.QueryHookOptions<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables> & ({ variables: UserFeedbackSubmittedQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables>(UserFeedbackSubmittedDocument, options);
      }
export function useUserFeedbackSubmittedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables>(UserFeedbackSubmittedDocument, options);
        }
export function useUserFeedbackSubmittedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables>(UserFeedbackSubmittedDocument, options);
        }
export type UserFeedbackSubmittedQueryHookResult = ReturnType<typeof useUserFeedbackSubmittedQuery>;
export type UserFeedbackSubmittedLazyQueryHookResult = ReturnType<typeof useUserFeedbackSubmittedLazyQuery>;
export type UserFeedbackSubmittedSuspenseQueryHookResult = ReturnType<typeof useUserFeedbackSubmittedSuspenseQuery>;
export type UserFeedbackSubmittedQueryResult = Apollo.QueryResult<UserFeedbackSubmittedQuery, UserFeedbackSubmittedQueryVariables>;
export const UserProfileIndexListDocument = gql`
    query UserProfileIndexList($searchParams: String, $indexType: String!) {
  userProfileIndexList(searchParams: $searchParams) {
    edges {
      node {
        ...MembersIndexCard
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
  userProfileIndexListResultCount: indexListResultCount(
    searchParams: $searchParams
    indexType: $indexType
  )
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    isCapIntroMember
  }
}
    ${MembersIndexCardFragmentDoc}`;

/**
 * __useUserProfileIndexListQuery__
 *
 * To run a query within a React component, call `useUserProfileIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useUserProfileIndexListQuery(baseOptions: Apollo.QueryHookOptions<UserProfileIndexListQuery, UserProfileIndexListQueryVariables> & ({ variables: UserProfileIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileIndexListQuery, UserProfileIndexListQueryVariables>(UserProfileIndexListDocument, options);
      }
export function useUserProfileIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileIndexListQuery, UserProfileIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileIndexListQuery, UserProfileIndexListQueryVariables>(UserProfileIndexListDocument, options);
        }
export function useUserProfileIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileIndexListQuery, UserProfileIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileIndexListQuery, UserProfileIndexListQueryVariables>(UserProfileIndexListDocument, options);
        }
export type UserProfileIndexListQueryHookResult = ReturnType<typeof useUserProfileIndexListQuery>;
export type UserProfileIndexListLazyQueryHookResult = ReturnType<typeof useUserProfileIndexListLazyQuery>;
export type UserProfileIndexListSuspenseQueryHookResult = ReturnType<typeof useUserProfileIndexListSuspenseQuery>;
export type UserProfileIndexListQueryResult = Apollo.QueryResult<UserProfileIndexListQuery, UserProfileIndexListQueryVariables>;
export const UserProfileRankingChartDocument = gql`
    query UserProfileRankingChart($profileId: ID!, $timeframe: String!) {
  userProfile(id: $profileId) {
    id
    user {
      id
      publicRankings(timeframe: $timeframe) {
        id
        value
        createdAt
        category
      }
    }
  }
}
    `;

/**
 * __useUserProfileRankingChartQuery__
 *
 * To run a query within a React component, call `useUserProfileRankingChartQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileRankingChartQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileRankingChartQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      timeframe: // value for 'timeframe'
 *   },
 * });
 */
export function useUserProfileRankingChartQuery(baseOptions: Apollo.QueryHookOptions<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables> & ({ variables: UserProfileRankingChartQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables>(UserProfileRankingChartDocument, options);
      }
export function useUserProfileRankingChartLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables>(UserProfileRankingChartDocument, options);
        }
export function useUserProfileRankingChartSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables>(UserProfileRankingChartDocument, options);
        }
export type UserProfileRankingChartQueryHookResult = ReturnType<typeof useUserProfileRankingChartQuery>;
export type UserProfileRankingChartLazyQueryHookResult = ReturnType<typeof useUserProfileRankingChartLazyQuery>;
export type UserProfileRankingChartSuspenseQueryHookResult = ReturnType<typeof useUserProfileRankingChartSuspenseQuery>;
export type UserProfileRankingChartQueryResult = Apollo.QueryResult<UserProfileRankingChartQuery, UserProfileRankingChartQueryVariables>;
export const UserProfileShowPageDocument = gql`
    query UserProfileShowPage($profileId: ID!, $controlIdeaAccess: Boolean = true) {
  currentUser {
    id
    isAdmin
    isUserProfileAdmin(profileId: $profileId)
    isHiringManager(profileId: $profileId)
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canManageMessages: canAccess(permission: "manage", resource: "messages")
  }
  userProfile(id: $profileId) {
    id
    isAccredited
    ...UserProfileBackgroundImage
    ...UserProfileCard
    ...UserProfileAdminDashboard
    ...UserProfileContact
    ...UserProfileResearchPerformance
    ...UserProfileAwards
    ...UserProfileWorkExperience
    ...UserProfileExpertise
    ...UserProfileEducation
    ...UserProfilePersonalDetails
    ...UserProfileResumePhone
    ...UserProfileAcademicPerformance
    ...UserProfileResearch
    ...UserProfileQAndA
    user {
      id
      isRetail
      accreditedInvestorProfile {
        ...AccreditedInvestorProfile
      }
    }
  }
}
    ${UserProfileBackgroundImageFragmentDoc}
${UserProfileCardFragmentDoc}
${UserProfileAdminDashboardFragmentDoc}
${UserProfileContactFragmentDoc}
${UserProfileResearchPerformanceFragmentDoc}
${UserProfileAwardsFragmentDoc}
${UserProfileWorkExperienceFragmentDoc}
${UserProfileExpertiseFragmentDoc}
${UserProfileEducationFragmentDoc}
${UserProfilePersonalDetailsFragmentDoc}
${UserProfileResumePhoneFragmentDoc}
${UserProfileAcademicPerformanceFragmentDoc}
${UserProfileResearchFragmentDoc}
${UserProfileQAndAFragmentDoc}
${AccreditedInvestorProfileFragmentDoc}`;

/**
 * __useUserProfileShowPageQuery__
 *
 * To run a query within a React component, call `useUserProfileShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserProfileShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserProfileShowPageQuery({
 *   variables: {
 *      profileId: // value for 'profileId'
 *      controlIdeaAccess: // value for 'controlIdeaAccess'
 *   },
 * });
 */
export function useUserProfileShowPageQuery(baseOptions: Apollo.QueryHookOptions<UserProfileShowPageQuery, UserProfileShowPageQueryVariables> & ({ variables: UserProfileShowPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserProfileShowPageQuery, UserProfileShowPageQueryVariables>(UserProfileShowPageDocument, options);
      }
export function useUserProfileShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserProfileShowPageQuery, UserProfileShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserProfileShowPageQuery, UserProfileShowPageQueryVariables>(UserProfileShowPageDocument, options);
        }
export function useUserProfileShowPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserProfileShowPageQuery, UserProfileShowPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserProfileShowPageQuery, UserProfileShowPageQueryVariables>(UserProfileShowPageDocument, options);
        }
export type UserProfileShowPageQueryHookResult = ReturnType<typeof useUserProfileShowPageQuery>;
export type UserProfileShowPageLazyQueryHookResult = ReturnType<typeof useUserProfileShowPageLazyQuery>;
export type UserProfileShowPageSuspenseQueryHookResult = ReturnType<typeof useUserProfileShowPageSuspenseQuery>;
export type UserProfileShowPageQueryResult = Apollo.QueryResult<UserProfileShowPageQuery, UserProfileShowPageQueryVariables>;
export const UserSearchDocument = gql`
    query userSearch($user: String) {
  userSearch(query: $user) {
    id
    displayName
    currentEmployerName
  }
}
    `;

/**
 * __useUserSearchQuery__
 *
 * To run a query within a React component, call `useUserSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSearchQuery({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserSearchQuery(baseOptions?: Apollo.QueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
      }
export function useUserSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
        }
export function useUserSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserSearchQuery, UserSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserSearchQuery, UserSearchQueryVariables>(UserSearchDocument, options);
        }
export type UserSearchQueryHookResult = ReturnType<typeof useUserSearchQuery>;
export type UserSearchLazyQueryHookResult = ReturnType<typeof useUserSearchLazyQuery>;
export type UserSearchSuspenseQueryHookResult = ReturnType<typeof useUserSearchSuspenseQuery>;
export type UserSearchQueryResult = Apollo.QueryResult<UserSearchQuery, UserSearchQueryVariables>;
export const WatchlistTickerAssetDataDocument = gql`
    query watchlistTickerAssetData($id: ID) {
  watchlistTickerAssetData(id: $id) {
    id
    entity {
      name
    }
    entityId
    name
  }
}
    `;

/**
 * __useWatchlistTickerAssetDataQuery__
 *
 * To run a query within a React component, call `useWatchlistTickerAssetDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useWatchlistTickerAssetDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchlistTickerAssetDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWatchlistTickerAssetDataQuery(baseOptions?: Apollo.QueryHookOptions<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>(WatchlistTickerAssetDataDocument, options);
      }
export function useWatchlistTickerAssetDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>(WatchlistTickerAssetDataDocument, options);
        }
export function useWatchlistTickerAssetDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>(WatchlistTickerAssetDataDocument, options);
        }
export type WatchlistTickerAssetDataQueryHookResult = ReturnType<typeof useWatchlistTickerAssetDataQuery>;
export type WatchlistTickerAssetDataLazyQueryHookResult = ReturnType<typeof useWatchlistTickerAssetDataLazyQuery>;
export type WatchlistTickerAssetDataSuspenseQueryHookResult = ReturnType<typeof useWatchlistTickerAssetDataSuspenseQuery>;
export type WatchlistTickerAssetDataQueryResult = Apollo.QueryResult<WatchlistTickerAssetDataQuery, WatchlistTickerAssetDataQueryVariables>;
export const WhitePaperCommentMentionablesDocument = gql`
    query WhitePaperCommentMentionables($id: ID!) {
  whitePaper(id: $id) {
    id
    commentsMentionableList {
      id
      display
    }
  }
}
    `;

/**
 * __useWhitePaperCommentMentionablesQuery__
 *
 * To run a query within a React component, call `useWhitePaperCommentMentionablesQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitePaperCommentMentionablesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitePaperCommentMentionablesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWhitePaperCommentMentionablesQuery(baseOptions: Apollo.QueryHookOptions<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables> & ({ variables: WhitePaperCommentMentionablesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables>(WhitePaperCommentMentionablesDocument, options);
      }
export function useWhitePaperCommentMentionablesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables>(WhitePaperCommentMentionablesDocument, options);
        }
export function useWhitePaperCommentMentionablesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables>(WhitePaperCommentMentionablesDocument, options);
        }
export type WhitePaperCommentMentionablesQueryHookResult = ReturnType<typeof useWhitePaperCommentMentionablesQuery>;
export type WhitePaperCommentMentionablesLazyQueryHookResult = ReturnType<typeof useWhitePaperCommentMentionablesLazyQuery>;
export type WhitePaperCommentMentionablesSuspenseQueryHookResult = ReturnType<typeof useWhitePaperCommentMentionablesSuspenseQuery>;
export type WhitePaperCommentMentionablesQueryResult = Apollo.QueryResult<WhitePaperCommentMentionablesQuery, WhitePaperCommentMentionablesQueryVariables>;
export const WhitePaperCommentsDocument = gql`
    query WhitePaperComments($id: ID!) {
  whitePaper(id: $id) {
    id
    comments {
      edges {
        node {
          id
          body
          createdAt
          responseRequested
          currentUserHasLiked
          parentId
          likeCount
          anonUser {
            id
            anonymousUserId
            aumRange
            isAllocator
            fundType
            title
            username
          }
          user {
            id
            anonymousUserId
            displayName
            mostRecentEmployer {
              id
              title
              employer {
                id
                name
                aumRange
                fundType
              }
              currentEmployer
            }
            profileImageUrl
          }
        }
      }
    }
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
  }
}
    `;

/**
 * __useWhitePaperCommentsQuery__
 *
 * To run a query within a React component, call `useWhitePaperCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitePaperCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitePaperCommentsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWhitePaperCommentsQuery(baseOptions: Apollo.QueryHookOptions<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables> & ({ variables: WhitePaperCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables>(WhitePaperCommentsDocument, options);
      }
export function useWhitePaperCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables>(WhitePaperCommentsDocument, options);
        }
export function useWhitePaperCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables>(WhitePaperCommentsDocument, options);
        }
export type WhitePaperCommentsQueryHookResult = ReturnType<typeof useWhitePaperCommentsQuery>;
export type WhitePaperCommentsLazyQueryHookResult = ReturnType<typeof useWhitePaperCommentsLazyQuery>;
export type WhitePaperCommentsSuspenseQueryHookResult = ReturnType<typeof useWhitePaperCommentsSuspenseQuery>;
export type WhitePaperCommentsQueryResult = Apollo.QueryResult<WhitePaperCommentsQuery, WhitePaperCommentsQueryVariables>;
export const WhitePapersIndexListDocument = gql`
    query WhitePapersIndexList($searchParams: String, $indexType: String!) {
  whitePapersIndexList(searchParams: $searchParams) {
    ...WhitePaperResearchItem
  }
  currentUser {
    id
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canWriteWhitePapers: canAccess(resource: "white_papers", permission: "write")
  }
  indexListResultCount(searchParams: $searchParams, indexType: $indexType)
}
    ${WhitePaperResearchItemFragmentDoc}`;

/**
 * __useWhitePapersIndexListQuery__
 *
 * To run a query within a React component, call `useWhitePapersIndexListQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitePapersIndexListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitePapersIndexListQuery({
 *   variables: {
 *      searchParams: // value for 'searchParams'
 *      indexType: // value for 'indexType'
 *   },
 * });
 */
export function useWhitePapersIndexListQuery(baseOptions: Apollo.QueryHookOptions<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables> & ({ variables: WhitePapersIndexListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables>(WhitePapersIndexListDocument, options);
      }
export function useWhitePapersIndexListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables>(WhitePapersIndexListDocument, options);
        }
export function useWhitePapersIndexListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables>(WhitePapersIndexListDocument, options);
        }
export type WhitePapersIndexListQueryHookResult = ReturnType<typeof useWhitePapersIndexListQuery>;
export type WhitePapersIndexListLazyQueryHookResult = ReturnType<typeof useWhitePapersIndexListLazyQuery>;
export type WhitePapersIndexListSuspenseQueryHookResult = ReturnType<typeof useWhitePapersIndexListSuspenseQuery>;
export type WhitePapersIndexListQueryResult = Apollo.QueryResult<WhitePapersIndexListQuery, WhitePapersIndexListQueryVariables>;
export const WhitePaperShowPageDocument = gql`
    query WhitePaperShowPage($id: ID!) {
  whitePaper(id: $id) {
    id
    elevatorPitch
    associatedEmployer {
      ...UserEmployer
    }
    mentionedEntities {
      id
      primarySymbol
    }
    pdfThesisUrl
    positionDisclaimerFund
    positionDisclaimerIndividual
    status
    thesis
    tagList
    thesisText
    submittedAt
    updatedAt
    isAuthor
    title
    whitePaperUpdates {
      id
    }
    whitePaperAttachments {
      id
      filename
      researchType
      attachmentType
      createdAt
      fileType
    }
    user {
      id
      displayName
      profileImageUrl
      profileCity
      mostRecentEmployer {
        id
        currentEmployer
        title
        employer {
          ...UserEmployer
        }
      }
      featuredRank {
        ...FeaturedRanking
      }
      userBadges: badgeCollectionRelationships {
        edges {
          node {
            id
            badgeNumber
            visible
            badge {
              ...Badges
            }
          }
        }
      }
      activeFollowersCount
      followersCount
      profile {
        id
        summary
        ideaTotalReturnAverage
        ideaReturnVsBenchmarkAverage
        ideaAnnualizedReturnMedian
      }
    }
    youtubeIds
    esgs {
      id
      name
    }
    geographies {
      id
      name
    }
    globalMacros {
      id
      name
    }
    sectors {
      id
      name
    }
  }
  currentUser {
    id
    canWriteWhitePaperComments: canAccess(
      resource: "white_paper_comments"
      permission: "write"
    )
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canCommentAnonymously
    isAdmin
  }
}
    ${UserEmployerFragmentDoc}
${FeaturedRankingFragmentDoc}
${BadgesFragmentDoc}`;

/**
 * __useWhitePaperShowPageQuery__
 *
 * To run a query within a React component, call `useWhitePaperShowPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitePaperShowPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitePaperShowPageQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWhitePaperShowPageQuery(baseOptions: Apollo.QueryHookOptions<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables> & ({ variables: WhitePaperShowPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables>(WhitePaperShowPageDocument, options);
      }
export function useWhitePaperShowPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables>(WhitePaperShowPageDocument, options);
        }
export function useWhitePaperShowPageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables>(WhitePaperShowPageDocument, options);
        }
export type WhitePaperShowPageQueryHookResult = ReturnType<typeof useWhitePaperShowPageQuery>;
export type WhitePaperShowPageLazyQueryHookResult = ReturnType<typeof useWhitePaperShowPageLazyQuery>;
export type WhitePaperShowPageSuspenseQueryHookResult = ReturnType<typeof useWhitePaperShowPageSuspenseQuery>;
export type WhitePaperShowPageQueryResult = Apollo.QueryResult<WhitePaperShowPageQuery, WhitePaperShowPageQueryVariables>;
export const WhitePaperShowPageRelatedIdeasDocument = gql`
    query WhitePaperShowPageRelatedIdeas($id: ID!) {
  whitePaper(id: $id) {
    id
    relatedIdeas {
      ...IdeaResearchItem
    }
  }
  currentUser {
    id
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    isBuyside
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useWhitePaperShowPageRelatedIdeasQuery__
 *
 * To run a query within a React component, call `useWhitePaperShowPageRelatedIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitePaperShowPageRelatedIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitePaperShowPageRelatedIdeasQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWhitePaperShowPageRelatedIdeasQuery(baseOptions: Apollo.QueryHookOptions<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables> & ({ variables: WhitePaperShowPageRelatedIdeasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables>(WhitePaperShowPageRelatedIdeasDocument, options);
      }
export function useWhitePaperShowPageRelatedIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables>(WhitePaperShowPageRelatedIdeasDocument, options);
        }
export function useWhitePaperShowPageRelatedIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables>(WhitePaperShowPageRelatedIdeasDocument, options);
        }
export type WhitePaperShowPageRelatedIdeasQueryHookResult = ReturnType<typeof useWhitePaperShowPageRelatedIdeasQuery>;
export type WhitePaperShowPageRelatedIdeasLazyQueryHookResult = ReturnType<typeof useWhitePaperShowPageRelatedIdeasLazyQuery>;
export type WhitePaperShowPageRelatedIdeasSuspenseQueryHookResult = ReturnType<typeof useWhitePaperShowPageRelatedIdeasSuspenseQuery>;
export type WhitePaperShowPageRelatedIdeasQueryResult = Apollo.QueryResult<WhitePaperShowPageRelatedIdeasQuery, WhitePaperShowPageRelatedIdeasQueryVariables>;
export const WhitePaperSubmissionDocument = gql`
    query WhitePaperSubmission($id: ID!) {
  currentUser {
    id
    currentEmployers {
      id
      canExtendCapIntroAccess
      hasFundProfile
      name
    }
    isAdmin
  }
  whitePaper(id: $id) {
    ...WhitePaperSubmissionDraft
  }
}
    ${WhitePaperSubmissionDraftFragmentDoc}`;

/**
 * __useWhitePaperSubmissionQuery__
 *
 * To run a query within a React component, call `useWhitePaperSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhitePaperSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhitePaperSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWhitePaperSubmissionQuery(baseOptions: Apollo.QueryHookOptions<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables> & ({ variables: WhitePaperSubmissionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables>(WhitePaperSubmissionDocument, options);
      }
export function useWhitePaperSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables>(WhitePaperSubmissionDocument, options);
        }
export function useWhitePaperSubmissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables>(WhitePaperSubmissionDocument, options);
        }
export type WhitePaperSubmissionQueryHookResult = ReturnType<typeof useWhitePaperSubmissionQuery>;
export type WhitePaperSubmissionLazyQueryHookResult = ReturnType<typeof useWhitePaperSubmissionLazyQuery>;
export type WhitePaperSubmissionSuspenseQueryHookResult = ReturnType<typeof useWhitePaperSubmissionSuspenseQuery>;
export type WhitePaperSubmissionQueryResult = Apollo.QueryResult<WhitePaperSubmissionQuery, WhitePaperSubmissionQueryVariables>;
export const CurrentUserRankHistoryDocument = gql`
    query currentUserRankHistory {
  currentUser {
    id
    ranks {
      rankString
      createdAt
    }
  }
}
    `;

/**
 * __useCurrentUserRankHistoryQuery__
 *
 * To run a query within a React component, call `useCurrentUserRankHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRankHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRankHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserRankHistoryQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>(CurrentUserRankHistoryDocument, options);
      }
export function useCurrentUserRankHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>(CurrentUserRankHistoryDocument, options);
        }
export function useCurrentUserRankHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>(CurrentUserRankHistoryDocument, options);
        }
export type CurrentUserRankHistoryQueryHookResult = ReturnType<typeof useCurrentUserRankHistoryQuery>;
export type CurrentUserRankHistoryLazyQueryHookResult = ReturnType<typeof useCurrentUserRankHistoryLazyQuery>;
export type CurrentUserRankHistorySuspenseQueryHookResult = ReturnType<typeof useCurrentUserRankHistorySuspenseQuery>;
export type CurrentUserRankHistoryQueryResult = Apollo.QueryResult<CurrentUserRankHistoryQuery, CurrentUserRankHistoryQueryVariables>;
export const CurrentUserRanksDocument = gql`
    query currentUserRanks {
  currentUser {
    id
    currentRanks {
      category
      createdAt
      ...RankCard
    }
  }
}
    ${RankCardFragmentDoc}`;

/**
 * __useCurrentUserRanksQuery__
 *
 * To run a query within a React component, call `useCurrentUserRanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserRanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserRanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserRanksQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>(CurrentUserRanksDocument, options);
      }
export function useCurrentUserRanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>(CurrentUserRanksDocument, options);
        }
export function useCurrentUserRanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>(CurrentUserRanksDocument, options);
        }
export type CurrentUserRanksQueryHookResult = ReturnType<typeof useCurrentUserRanksQuery>;
export type CurrentUserRanksLazyQueryHookResult = ReturnType<typeof useCurrentUserRanksLazyQuery>;
export type CurrentUserRanksSuspenseQueryHookResult = ReturnType<typeof useCurrentUserRanksSuspenseQuery>;
export type CurrentUserRanksQueryResult = Apollo.QueryResult<CurrentUserRanksQuery, CurrentUserRanksQueryVariables>;
export const IdeaAttachmentsDocument = gql`
    query IdeaAttachments($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    ideaAttachments {
      id
      attachmentType
      createdAt
      filename
      fileType
      researchType
    }
  }
}
    `;

/**
 * __useIdeaAttachmentsQuery__
 *
 * To run a query within a React component, call `useIdeaAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaAttachmentsQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables> & ({ variables: IdeaAttachmentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables>(IdeaAttachmentsDocument, options);
      }
export function useIdeaAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables>(IdeaAttachmentsDocument, options);
        }
export function useIdeaAttachmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables>(IdeaAttachmentsDocument, options);
        }
export type IdeaAttachmentsQueryHookResult = ReturnType<typeof useIdeaAttachmentsQuery>;
export type IdeaAttachmentsLazyQueryHookResult = ReturnType<typeof useIdeaAttachmentsLazyQuery>;
export type IdeaAttachmentsSuspenseQueryHookResult = ReturnType<typeof useIdeaAttachmentsSuspenseQuery>;
export type IdeaAttachmentsQueryResult = Apollo.QueryResult<IdeaAttachmentsQuery, IdeaAttachmentsQueryVariables>;
export const IdeaAuthorDocument = gql`
    query IdeaAuthor($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    associatedEmployer {
      ...UserEmployer
    }
    authorName
    isNonBuyside
    user {
      id
      activeFollowersCount
      displayName(ideaId: $ideaId)
      featuredRank {
        id
        category
        rankString
      }
      mostRecentEmployer {
        id
        currentEmployer
        title
        employer {
          ...UserEmployer
        }
      }
      profile {
        id
        ideaTotalReturnAverage
        ideaReturnVsBenchmarkAverage
        ideaAnnualizedReturnMedian
      }
      profileCity
      profileImageUrl
      username
    }
  }
}
    ${UserEmployerFragmentDoc}`;

/**
 * __useIdeaAuthorQuery__
 *
 * To run a query within a React component, call `useIdeaAuthorQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaAuthorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaAuthorQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaAuthorQuery(baseOptions: Apollo.QueryHookOptions<IdeaAuthorQuery, IdeaAuthorQueryVariables> & ({ variables: IdeaAuthorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaAuthorQuery, IdeaAuthorQueryVariables>(IdeaAuthorDocument, options);
      }
export function useIdeaAuthorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaAuthorQuery, IdeaAuthorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaAuthorQuery, IdeaAuthorQueryVariables>(IdeaAuthorDocument, options);
        }
export function useIdeaAuthorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaAuthorQuery, IdeaAuthorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaAuthorQuery, IdeaAuthorQueryVariables>(IdeaAuthorDocument, options);
        }
export type IdeaAuthorQueryHookResult = ReturnType<typeof useIdeaAuthorQuery>;
export type IdeaAuthorLazyQueryHookResult = ReturnType<typeof useIdeaAuthorLazyQuery>;
export type IdeaAuthorSuspenseQueryHookResult = ReturnType<typeof useIdeaAuthorSuspenseQuery>;
export type IdeaAuthorQueryResult = Apollo.QueryResult<IdeaAuthorQuery, IdeaAuthorQueryVariables>;
export const IdeaCommentsDocument = gql`
    query IdeaComments($ideaId: ID!, $controlName: Boolean) {
  idea(id: $ideaId) {
    id
    commentsCount
    comments {
      edges {
        node {
          ...IdeaShowPageComment
        }
      }
    }
    commentsMentionableList {
      id
      display
    }
  }
}
    ${IdeaShowPageCommentFragmentDoc}`;

/**
 * __useIdeaCommentsQuery__
 *
 * To run a query within a React component, call `useIdeaCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaCommentsQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *      controlName: // value for 'controlName'
 *   },
 * });
 */
export function useIdeaCommentsQuery(baseOptions: Apollo.QueryHookOptions<IdeaCommentsQuery, IdeaCommentsQueryVariables> & ({ variables: IdeaCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaCommentsQuery, IdeaCommentsQueryVariables>(IdeaCommentsDocument, options);
      }
export function useIdeaCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaCommentsQuery, IdeaCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaCommentsQuery, IdeaCommentsQueryVariables>(IdeaCommentsDocument, options);
        }
export function useIdeaCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaCommentsQuery, IdeaCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaCommentsQuery, IdeaCommentsQueryVariables>(IdeaCommentsDocument, options);
        }
export type IdeaCommentsQueryHookResult = ReturnType<typeof useIdeaCommentsQuery>;
export type IdeaCommentsLazyQueryHookResult = ReturnType<typeof useIdeaCommentsLazyQuery>;
export type IdeaCommentsSuspenseQueryHookResult = ReturnType<typeof useIdeaCommentsSuspenseQuery>;
export type IdeaCommentsQueryResult = Apollo.QueryResult<IdeaCommentsQuery, IdeaCommentsQueryVariables>;
export const IdeaCoreDocument = gql`
    query IdeaCore($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    anonymous
    annualizedReturn
    approved
    autoclosed
    awardWinningContestIdeas {
      id
      award
      contestId
    }
    benchmarkNames
    catalystNames
    canCurrentUserAccessIdeaComments: canCurrentUserAccess(
      resource: "idea_comments"
      permission: "access"
    )
    canCurrentUserViewIdeaAttachments: canCurrentUserAccess(
      resource: "idea_attachments"
      permission: "view"
    )
    canCurrentUserViewIdeaFilterDetails: canCurrentUserAccess(
      resource: "idea_filter_details"
      permission: "view"
    )
    closedAt
    closeToTimeframe
    createdAt
    dateToClose
    direction
    elevatorPitch
    expectedReturn
    featuredOnAFundProfile
    pdfThesisUrl
    hasPendingEdit
    ideaPdfLink
    ideaUpdatesCount
    isOpenAccess
    isPairTrade
    lastUpdatedAt
    legacyPositionDisclaimer
    mentionedEntities {
      id
      primarySymbol
    }
    openedAt
    pairRatio
    paladinReviews {
      id
      description
      status
      paladin {
        id
        displayName
        userId
      }
    }
    pendingContestIdeas {
      id
      contestId
      contestName
    }
    pendingIntroRequest {
      id
      employerName
      messageThread
      status
    }
    positionDisclaimerFund
    positionDisclaimerIndividual
    returnTarget
    returnVsBenchmark
    situation(showPage: true)
    situationUnformatted: situation(raw: true)
    status
    tagList
    targetAllocation
    thesis
    timeframe
    totalReturn
    weeklyTopIdea
    youtubeIds
  }
}
    `;

/**
 * __useIdeaCoreQuery__
 *
 * To run a query within a React component, call `useIdeaCoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaCoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaCoreQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaCoreQuery(baseOptions: Apollo.QueryHookOptions<IdeaCoreQuery, IdeaCoreQueryVariables> & ({ variables: IdeaCoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaCoreQuery, IdeaCoreQueryVariables>(IdeaCoreDocument, options);
      }
export function useIdeaCoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaCoreQuery, IdeaCoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaCoreQuery, IdeaCoreQueryVariables>(IdeaCoreDocument, options);
        }
export function useIdeaCoreSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaCoreQuery, IdeaCoreQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaCoreQuery, IdeaCoreQueryVariables>(IdeaCoreDocument, options);
        }
export type IdeaCoreQueryHookResult = ReturnType<typeof useIdeaCoreQuery>;
export type IdeaCoreLazyQueryHookResult = ReturnType<typeof useIdeaCoreLazyQuery>;
export type IdeaCoreSuspenseQueryHookResult = ReturnType<typeof useIdeaCoreSuspenseQuery>;
export type IdeaCoreQueryResult = Apollo.QueryResult<IdeaCoreQuery, IdeaCoreQueryVariables>;
export const IdeaCurrentUserDocument = gql`
    query IdeaCurrentUser($ideaId: ID!) {
  currentUser {
    id
    availableTokenCount
    canComment: canAccess(resource: "idea_comments", permission: "write")
    canCommentAnonymously
    canDownloadIdeaPdf: canAccess(resource: "idea_pdf_download", permission: "view")
    canManageMessages: canAccess(resource: "messages", permission: "manage")
    canRateIdeas: canAccess(resource: "ratings", permission: "write")
    canViewIdeas: canAccess(resource: "ideas", permission: "view")
    canViewUserDetails: canAccess(resource: "user_details", permission: "view")
    canWriteIdeas: canAccess(resource: "ideas", permission: "write")
    ideaRating(ideaId: $ideaId) {
      id
      score
    }
    isAdmin
    isAllocator
    isPaladin
    isRetail
    mostRecentEmployer {
      id
      currentEmployer
    }
    profileImageUrl
  }
}
    `;

/**
 * __useIdeaCurrentUserQuery__
 *
 * To run a query within a React component, call `useIdeaCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaCurrentUserQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables> & ({ variables: IdeaCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables>(IdeaCurrentUserDocument, options);
      }
export function useIdeaCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables>(IdeaCurrentUserDocument, options);
        }
export function useIdeaCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables>(IdeaCurrentUserDocument, options);
        }
export type IdeaCurrentUserQueryHookResult = ReturnType<typeof useIdeaCurrentUserQuery>;
export type IdeaCurrentUserLazyQueryHookResult = ReturnType<typeof useIdeaCurrentUserLazyQuery>;
export type IdeaCurrentUserSuspenseQueryHookResult = ReturnType<typeof useIdeaCurrentUserSuspenseQuery>;
export type IdeaCurrentUserQueryResult = Apollo.QueryResult<IdeaCurrentUserQuery, IdeaCurrentUserQueryVariables>;
export const IdeaPositionsDocument = gql`
    query IdeaPositions($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    hasEntitiesHaveOtherIdeas
    positions {
      id
      asset {
        id
        assetClassName
        companyData {
          id
          country
          geography
          industry
          sector
        }
        currencyCode
        currencyName
        entity {
          id
          name
        }
        fundamentalCurrencyCode
        fundamentalCurrencyName
        isCredit
        name
        symbol
      }
      closingPrice
      direction
      isCurrencySubunit
      priceTarget
      totalReturn
      userCompanyData {
        id
        currencyName
        currencyCode
      }
      userCreditData {
        id
        amountOutstanding
        convertible
        couponFrequency
        couponRate
        couponType
        fitchCreditRating
        guaranteed
        issueSize
        lien
        maturityDate
        moodyCreditRating
        securedBy
        securityClass
        seniority
        standardCreditRating
      }
    }
  }
}
    `;

/**
 * __useIdeaPositionsQuery__
 *
 * To run a query within a React component, call `useIdeaPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaPositionsQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaPositionsQuery(baseOptions: Apollo.QueryHookOptions<IdeaPositionsQuery, IdeaPositionsQueryVariables> & ({ variables: IdeaPositionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaPositionsQuery, IdeaPositionsQueryVariables>(IdeaPositionsDocument, options);
      }
export function useIdeaPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaPositionsQuery, IdeaPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaPositionsQuery, IdeaPositionsQueryVariables>(IdeaPositionsDocument, options);
        }
export function useIdeaPositionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaPositionsQuery, IdeaPositionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaPositionsQuery, IdeaPositionsQueryVariables>(IdeaPositionsDocument, options);
        }
export type IdeaPositionsQueryHookResult = ReturnType<typeof useIdeaPositionsQuery>;
export type IdeaPositionsLazyQueryHookResult = ReturnType<typeof useIdeaPositionsLazyQuery>;
export type IdeaPositionsSuspenseQueryHookResult = ReturnType<typeof useIdeaPositionsSuspenseQuery>;
export type IdeaPositionsQueryResult = Apollo.QueryResult<IdeaPositionsQuery, IdeaPositionsQueryVariables>;
export const IdeaPositionsPricingDocument = gql`
    query IdeaPositionsPricing($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    closeToTarget
    positions {
      id
      adjOpeningPrice: openingPrice
      asset {
        id
        fiftyTwoWeekRangeHigh
        fiftyTwoWeekRangeLow
        fundamental {
          id
          bookValue
          currentPe
          debtBook
          divYield
          ev
          evEbitda
          evFcf
          evSales
          fcfYield
          forwardPe
          marketCap
          priceBook
          sellsideConsensus
          threeMonthAdv
          totalCash
          totalDebt
        }
      }
      latestPrice
      latestPriceDate
      openingPrice
    }
  }
}
    `;

/**
 * __useIdeaPositionsPricingQuery__
 *
 * To run a query within a React component, call `useIdeaPositionsPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaPositionsPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaPositionsPricingQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaPositionsPricingQuery(baseOptions: Apollo.QueryHookOptions<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables> & ({ variables: IdeaPositionsPricingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables>(IdeaPositionsPricingDocument, options);
      }
export function useIdeaPositionsPricingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables>(IdeaPositionsPricingDocument, options);
        }
export function useIdeaPositionsPricingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables>(IdeaPositionsPricingDocument, options);
        }
export type IdeaPositionsPricingQueryHookResult = ReturnType<typeof useIdeaPositionsPricingQuery>;
export type IdeaPositionsPricingLazyQueryHookResult = ReturnType<typeof useIdeaPositionsPricingLazyQuery>;
export type IdeaPositionsPricingSuspenseQueryHookResult = ReturnType<typeof useIdeaPositionsPricingSuspenseQuery>;
export type IdeaPositionsPricingQueryResult = Apollo.QueryResult<IdeaPositionsPricingQuery, IdeaPositionsPricingQueryVariables>;
export const IdeaRatingDocument = gql`
    query IdeaRating($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    expectedPerformanceRating {
      id
      averageRating
      userRatingCount
    }
  }
}
    `;

/**
 * __useIdeaRatingQuery__
 *
 * To run a query within a React component, call `useIdeaRatingQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaRatingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaRatingQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useIdeaRatingQuery(baseOptions: Apollo.QueryHookOptions<IdeaRatingQuery, IdeaRatingQueryVariables> & ({ variables: IdeaRatingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaRatingQuery, IdeaRatingQueryVariables>(IdeaRatingDocument, options);
      }
export function useIdeaRatingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaRatingQuery, IdeaRatingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaRatingQuery, IdeaRatingQueryVariables>(IdeaRatingDocument, options);
        }
export function useIdeaRatingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaRatingQuery, IdeaRatingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaRatingQuery, IdeaRatingQueryVariables>(IdeaRatingDocument, options);
        }
export type IdeaRatingQueryHookResult = ReturnType<typeof useIdeaRatingQuery>;
export type IdeaRatingLazyQueryHookResult = ReturnType<typeof useIdeaRatingLazyQuery>;
export type IdeaRatingSuspenseQueryHookResult = ReturnType<typeof useIdeaRatingSuspenseQuery>;
export type IdeaRatingQueryResult = Apollo.QueryResult<IdeaRatingQuery, IdeaRatingQueryVariables>;
export const IdeaUpdatesDocument = gql`
    query IdeaUpdates($id: ID!) {
  idea(id: $id) {
    id
    benchmarkUpdate {
      id
      createdAt
      priceTarget
    }
    ideaUpdates {
      ...IdeaUpdates
    }
  }
}
    ${IdeaUpdatesFragmentDoc}`;

/**
 * __useIdeaUpdatesQuery__
 *
 * To run a query within a React component, call `useIdeaUpdatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdeaUpdatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdeaUpdatesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useIdeaUpdatesQuery(baseOptions: Apollo.QueryHookOptions<IdeaUpdatesQuery, IdeaUpdatesQueryVariables> & ({ variables: IdeaUpdatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdeaUpdatesQuery, IdeaUpdatesQueryVariables>(IdeaUpdatesDocument, options);
      }
export function useIdeaUpdatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdeaUpdatesQuery, IdeaUpdatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdeaUpdatesQuery, IdeaUpdatesQueryVariables>(IdeaUpdatesDocument, options);
        }
export function useIdeaUpdatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IdeaUpdatesQuery, IdeaUpdatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IdeaUpdatesQuery, IdeaUpdatesQueryVariables>(IdeaUpdatesDocument, options);
        }
export type IdeaUpdatesQueryHookResult = ReturnType<typeof useIdeaUpdatesQuery>;
export type IdeaUpdatesLazyQueryHookResult = ReturnType<typeof useIdeaUpdatesLazyQuery>;
export type IdeaUpdatesSuspenseQueryHookResult = ReturnType<typeof useIdeaUpdatesSuspenseQuery>;
export type IdeaUpdatesQueryResult = Apollo.QueryResult<IdeaUpdatesQuery, IdeaUpdatesQueryVariables>;
export const RelatedIdeasDocument = gql`
    query RelatedIdeas($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    relatedIdeas {
      ...IdeaResearchItem
    }
  }
}
    ${IdeaResearchItemFragmentDoc}`;

/**
 * __useRelatedIdeasQuery__
 *
 * To run a query within a React component, call `useRelatedIdeasQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedIdeasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedIdeasQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useRelatedIdeasQuery(baseOptions: Apollo.QueryHookOptions<RelatedIdeasQuery, RelatedIdeasQueryVariables> & ({ variables: RelatedIdeasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedIdeasQuery, RelatedIdeasQueryVariables>(RelatedIdeasDocument, options);
      }
export function useRelatedIdeasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedIdeasQuery, RelatedIdeasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedIdeasQuery, RelatedIdeasQueryVariables>(RelatedIdeasDocument, options);
        }
export function useRelatedIdeasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedIdeasQuery, RelatedIdeasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedIdeasQuery, RelatedIdeasQueryVariables>(RelatedIdeasDocument, options);
        }
export type RelatedIdeasQueryHookResult = ReturnType<typeof useRelatedIdeasQuery>;
export type RelatedIdeasLazyQueryHookResult = ReturnType<typeof useRelatedIdeasLazyQuery>;
export type RelatedIdeasSuspenseQueryHookResult = ReturnType<typeof useRelatedIdeasSuspenseQuery>;
export type RelatedIdeasQueryResult = Apollo.QueryResult<RelatedIdeasQuery, RelatedIdeasQueryVariables>;
export const RelatedPostsDocument = gql`
    query RelatedPosts($ideaId: ID!) {
  idea(id: $ideaId) {
    id
    relatedPosts {
      id
      commentsCount
      currentUserHasLiked
      eventId
      likeCount
      untaggedBody
    }
  }
}
    `;

/**
 * __useRelatedPostsQuery__
 *
 * To run a query within a React component, call `useRelatedPostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRelatedPostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRelatedPostsQuery({
 *   variables: {
 *      ideaId: // value for 'ideaId'
 *   },
 * });
 */
export function useRelatedPostsQuery(baseOptions: Apollo.QueryHookOptions<RelatedPostsQuery, RelatedPostsQueryVariables> & ({ variables: RelatedPostsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RelatedPostsQuery, RelatedPostsQueryVariables>(RelatedPostsDocument, options);
      }
export function useRelatedPostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RelatedPostsQuery, RelatedPostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RelatedPostsQuery, RelatedPostsQueryVariables>(RelatedPostsDocument, options);
        }
export function useRelatedPostsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RelatedPostsQuery, RelatedPostsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RelatedPostsQuery, RelatedPostsQueryVariables>(RelatedPostsDocument, options);
        }
export type RelatedPostsQueryHookResult = ReturnType<typeof useRelatedPostsQuery>;
export type RelatedPostsLazyQueryHookResult = ReturnType<typeof useRelatedPostsLazyQuery>;
export type RelatedPostsSuspenseQueryHookResult = ReturnType<typeof useRelatedPostsSuspenseQuery>;
export type RelatedPostsQueryResult = Apollo.QueryResult<RelatedPostsQuery, RelatedPostsQueryVariables>;
export const TestFeedDocument = gql`
    query TestFeed($feedId: ID, $feedType: String, $feedFilter: String, $cursor: String) {
  feedItems(
    feedId: $feedId
    feedType: $feedType
    feedFilter: $feedFilter
    first: 4
    after: $cursor
  ) {
    edges {
      node {
        id
        createdAt
        forMentionedEntity
        event {
          id
          currentUserHasLiked
          eventObject {
            ...ActivityFeedCorporateAction
            ...ActivityFeedIdea
            ...ActivityFeedIdeaUpdate
            ... on Comment {
              id
              anonUser {
                id
                title
                username
              }
              body
              byAllocator
              commentCreationTime
              commentObject {
                ...ActivityFeedIdea
                ...ActivityFeedIdeaUpdate
              }
              user {
                ...ActivityFeedUser
              }
            }
          }
          likeCount
          verb
        }
      }
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
    ${ActivityFeedCorporateActionFragmentDoc}
${ActivityFeedIdeaFragmentDoc}
${ActivityFeedIdeaUpdateFragmentDoc}
${ActivityFeedUserFragmentDoc}`;

/**
 * __useTestFeedQuery__
 *
 * To run a query within a React component, call `useTestFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useTestFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTestFeedQuery({
 *   variables: {
 *      feedId: // value for 'feedId'
 *      feedType: // value for 'feedType'
 *      feedFilter: // value for 'feedFilter'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useTestFeedQuery(baseOptions?: Apollo.QueryHookOptions<TestFeedQuery, TestFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TestFeedQuery, TestFeedQueryVariables>(TestFeedDocument, options);
      }
export function useTestFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TestFeedQuery, TestFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TestFeedQuery, TestFeedQueryVariables>(TestFeedDocument, options);
        }
export function useTestFeedSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TestFeedQuery, TestFeedQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TestFeedQuery, TestFeedQueryVariables>(TestFeedDocument, options);
        }
export type TestFeedQueryHookResult = ReturnType<typeof useTestFeedQuery>;
export type TestFeedLazyQueryHookResult = ReturnType<typeof useTestFeedLazyQuery>;
export type TestFeedSuspenseQueryHookResult = ReturnType<typeof useTestFeedSuspenseQuery>;
export type TestFeedQueryResult = Apollo.QueryResult<TestFeedQuery, TestFeedQueryVariables>;
export const OnChatMessageCreatedDocument = gql`
    subscription OnChatMessageCreated {
  chatMessageCreated {
    chatMessage {
      ...ChatMessage
    }
    chatId
  }
}
    ${ChatMessageFragmentDoc}`;

/**
 * __useOnChatMessageCreatedSubscription__
 *
 * To run a query within a React component, call `useOnChatMessageCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnChatMessageCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnChatMessageCreatedSubscription({
 *   variables: {
 *   },
 * });
 */
export function useOnChatMessageCreatedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<OnChatMessageCreatedSubscription, OnChatMessageCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<OnChatMessageCreatedSubscription, OnChatMessageCreatedSubscriptionVariables>(OnChatMessageCreatedDocument, options);
      }
export type OnChatMessageCreatedSubscriptionHookResult = ReturnType<typeof useOnChatMessageCreatedSubscription>;
export type OnChatMessageCreatedSubscriptionResult = Apollo.SubscriptionResult<OnChatMessageCreatedSubscription>;